const himachalpradesh  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/himachal-pardesh-tour-package"
const shimla ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/shimla-tour-package"
const manali  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/manali-tour-package"
const solangvalley ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/solang_valley-tour-package"
const dharmshala  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/dharmshala-tour-package"
const kasol ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kasol-tour-package"
const khajjar ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/khajjar-tour-package"
const uttrakhand ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/uttrakhand-tour-package"
const nainital  ="https://res.cloudinary.com/dul7aqbfs/image/upload/c_fill,w_400,h_500,g_auto/f_auto/q_auto:eco/nanital-tour-package"
const mussorie ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/mussorie-tour-package"
const bhimtal ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/bhimtal-tour-package"
const dhanaulti ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/dhanaulti-tour-package"
const rishikesh ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/rishikesh-tour-package"
const haridwar ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/haridwar-tour-package"
const ranikhet ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/ranikhet-tour-package"
const jimcorbett ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/jim_corbett-tour-package"
const kausani ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kausani-tour-package"
const almora ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/almora-tour-package"
const northgoa ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/north-goa-tour-package"
const southgoa ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/southgoa-tour-package"
const dudhsagar ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/dudhsagar-tour-package"
const rajasthan ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/rajasthan-tour-package"
const jaipur ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/jaipur-tour-package"
const udaipur ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/udaipur-tour-package"
const pushkar ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/pushkar-tour-package"
const mountabu ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/mount_abu-tour-package"
const jodhpur ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/jodhpur-tour-package"
const jaislmer ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/jaisalmer-tour-package"
const tamilnadu  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/tamil_nadu-tour-package"
const ooty  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/ooty-tour-package"
const kodaikanal ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kodaikanal-tour-package"
const cooner ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/coonoor-tour-package"
const madurai ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/madurai-tour-package"
const chennai ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/chennai-tour-package"
const mahabalipuram ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/mahabalipuram-tour-package"
const pondicherry ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/pondicherry-tour-package"
const rameshwaram ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/rameshwaram-tour-package"
const kanyakumari ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kanyakumari-tour-package"
const odisha ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/odisha-tour-package"
const puri ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/puri-tour-package"
const konark ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/konark-tour-package"
const bhubaneswar ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/bhubaneswar-tour-package"
const chilikalake ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/chilika_lake-tour-package"
const gopalpur ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/gopalpur-tour-package"
const sikkim   ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/sikkim-tour-package"
const gangtok ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/gangtok-tour-package"
const pelling ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/pelling-tour-package"
const lachung ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/lachung-tour-package"
const lachen ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/lachen-tour-package"
const namchi ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/namchi-tour-package"
const ladakh ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/ladakh-tour-package"
const leh ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/leh-tour-package"
const monasteriestour ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/monasteries-tour-package"
const nubarvalley ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/nubar-valley-tour-package"
const pangong ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/pangong-tour-package"
const tsoMoriri ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/tso_Moriri-tour-package"
const kargil ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kargil-tour-package"
const sonamarg ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/sonamarg-tour-package"
const karnatka ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/karnatka-tour-package"
const coorg ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/coorg-tour-package"
const chikmagalur ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/chikmagalur-tour-package"
const banglore ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/banglore-tour-package"
const mysore ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/mysore-tour-package"
const hampi ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/hampi-tour-package"
const badami ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/badami-tour-package"
const pattadakal ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/pattadakal-tour-package"
const andamanandnicobar ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/andaman-and-nicobar-tour-package"
const portBlair ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/port_blair-tour-package"
const havelock ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/havelock-tour-package"
const neilIsland ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/neil-island-tour-package"
const rossIsland ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/ross_island-tour-package"
const baratang ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/baratang-tour-package"
const dubai ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/dubai-tour-package"
const abudhabi ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/abu-dhabi-tour-package"
const thailand ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/thailand-tour-package"
const pattaya ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/pattaya-tour-package"
const bangkok ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/bangkok-tour-package"
const phuket ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/phuket-tour-package"
const krabi ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/krabi-tour-package"
const kohSamai ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/koh-samai-tour-package"
const bali ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/bali-tour-package"
const kuta ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kuta-tour-package"
const ubud ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/ubud-tour-package"
const seminyak ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/seminyak-tour-package"
const nusaDua ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/nusa-dua-tour-package"
const nusaPenida ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/nusa-penida-tour-package"
const beachvilla ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/beach-villa-maldives-tour-package"
const watervilla ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/water-villa-maldives-tour-package"
const maldives ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/maldives-tour-package"
const singapore ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/singapore-tour-package"
const sentosa ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/sentosa-tour-package"
const kualaLumpur ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kuala-lumpur-tour-package"
const malaysia ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/malaysia-tour-package"
const langkawi ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/langkawi-tour-package"
const penang ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/penang-tour-package"
const genting ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/genting-tour-package"
const vietnam ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/vietnam-tour-package"
const hanoi ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/hanoi-tour-package"
const halongBay ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/halong_bay-tour-package"
const daNang ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/da_nang-tour-package"
const hoiAn ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/hoi-an-tour-package"
const phuQuoc ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/phu-quoc-tour-package"
const hochiminhcity ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/ho-chi-minh-city-tour-package"
const mauritius ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/mauritius-tour-package"
const beachresort ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/mauritius-beach_resort-tour-package"
const bhutan ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/bhutan-tour-package"
const thimpu ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/thimpu-tour-package"
const paro ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/paro-tour-package"
const punakha ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/punakha-tour-package"
const phuntsholing ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/phuntsholing-tour-package"
const japan ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/japan-tour-package"
const tokyo ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/tokyo-tour-package"
const osaka ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/osaka-tour-package"
const kyoto ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kyoto-tour-package"
const hakone ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/hakone-tour-package"
const hokkaido ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/hokkaido-tour-package"
const kanazawa  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kanazawa-tour-package"
const gotemba ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/gotemba-tour-package"
const nagano  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/nagano-tour-package"
const toyama ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/toyama-tour-package"
const hiroshima ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/hiroshima-tour-package"
const europe ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/europe-tour-package"
const paris ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/paris-tour-package"
const amsterdam ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/amsterdam-tour-package"
const switzerland ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/switzerland-tour-package"
const italy ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/italy-tour-package"
const venice ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/venice-tour-package"
const rome ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/rome-tour-package"
const germany ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/germany-tour-package"
const porto ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/porto-tour-package"
const coimbra ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/coimbra-tour-package"
const lisbon ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/lisbon-tour-package"
const marrakech ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/marrakech-tour-package"
const casablanca ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/casablanca-tour-package"
const rabat ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/rabat-tour-package"
const fez ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/fez-tour-package"
const tangier ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/tangier-tour-package"
const gibraltar ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/gibraltar-tour-package"
const seville  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/seville-tour-package"
const merida  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/merida-tour-package"
const madrid  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/madrid-tour-package"
const vienna  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/vienna-tour-package"
const budapest ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/budapest-tour-package"
const liptovsky ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/liptovsky-tour-package"
const mikulas  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/mikulas-tour-package"
const olomouc  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/olomouc-tour-package"
const krakow ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/krakow-tour-package"
const warsaw  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/warsaw-tour-package"
const gdansk  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/gdansk-tour-package"
const prague  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/prague-tour-package"
const london  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/london-tour-package"
const copenhagen  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/copenhagen-tour-package"
const kiel  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kiel-tour-package"
const berlin  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/berlin-tour-package"
const frankfurt  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/frankfurt-tour-package"
const dusseldorf  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/dusseldorf-tour-package"
const hamburg   ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/hamburg-tour-package"
const leipzing  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/leipzing-tour-package"
const dresden  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/dresden-tour-package"
const bergen  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/bergen-tour-package"
const oslo  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/oslo-tour-package"
const stockholm  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/stockholm-tour-package"
const helsinki  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/helsinki-tour-package"
const riga  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/riga-tour-package"
const vilnius   ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/vilnius-tour-package"
const lyon  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/lyon-tour-package"
const lausanne  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/lausanne-tour-package"
const bern  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/bern-tour-package"
const stgallen ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/st_gallen-tour-package"
const mulhouse  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/mulhouse-tour-package"
const strasbourg  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/strasbourg-tour-package"
const stuttgart  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/stuttgart-tour-package"
const innsburck  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/innsburck-tour-package"
const padova  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/padova-tour-package"
const arezzo  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/arezzo-tour-package"
const ferrara  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/ferrara-tour-package"
const turkey ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/turkey-tour-package"
const istanbul ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/istanbul-tour-package"
const cappadocia ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/cappadocia-tour-package"
const antalya ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/antalya-tour-package"
const pamukkale ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/pamukkale-tour-package"
const zurich ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/zurich-tour-package"
const lucerne ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/lucerne-tour-package"
const interlaken ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/interlaken-tour-package"
const geneva ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/geneva-tour-package"
const australia ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/australia-tour-package"
const sydney ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/sydney-tour-package"
const melbourne ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/melbourne-tour-package"
const goldCoast ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/gold_coast-tour-package"
const cairns ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/cairns-tour-package"
const newzealand ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/new-zealand-tour-package"
const auckland ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/auckland-tour-package"
const queenstown ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/queenstown-tour-package"
const rotorua ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/rotorua-tour-package"
const christchurch ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/christchurch-tour-package"
const southkorea ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/south_korea-tour-package"
const seoul  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/seoul-tour-package"
const busan ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/busan-tour-package"
const jejuisland ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/jeju_island-tour-package"
const azerbaijan ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/azerbaijan-tour-package"
const baku ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/baku-tour-package"
const gabala ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/gabala-tour-package"
const georgia ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/georgia-tour-package"
const tbilisi ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/tbilisi-tour-package"
const batumi ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/batumi-tour-package"
const kazbegi ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kazbegi-tour-package"
const nepal  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/nepal-tour-package"
const kathmandu ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kathmandu-tour-package"
const pokhara ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/pokhara-tour-package"
const northeast  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/northeast-tour-package"
const assam  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/assam-tour-package"
const meghalaya ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/meghalaya-tour-package"
const guwahati ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/guwahati-tour-package"
const kaziranga ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kaziranga-tour-package"
const shillong ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/shillong-tour-package"
const kashmir ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kashmir-tour-package"
const gulmarg ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/gulmarg-tour-package"
const srinagar ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/srinagar-tour-package"
const pahalgam ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/pahalgham-tour-package"
const greece  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/greece-tour-package"
const athens ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/athens-tour-package"
const nafplio ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/nafplio-tour-package"
const monemvasia ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/monemvasia-tour-package"
const areopoli ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/areopoli-tour-package"
const methoni ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/methoni-tour-package"
const olympia ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/olympia-tour-package"
const nafpaktos ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/nafpaktos-tour-package"
const arachova ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/arachova-tour-package"
const paros  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/paros-tour-package"
const naxos  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/naxos-tour-package"
const santorini  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/santorini-tour-package"
const heraklion ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/heraklion-tour-package"
const chania  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/chania-tour-package"
const plakias  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/plakias-tour-package"
const ierapetra ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/ierapetra-tour-package"
const agiosnikolaos  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/agios-nikolaos-tour-package"
const preveza  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/preveza-tour-package"
const corfu  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/corfu-tour-package"
const kalambaka  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kalambaka-tour-package"
const thessaloniki  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/thessaloniki-tour-package"
const milosisland  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/milos-island-tour-package"
const rhodes ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/rhodes-tour-package"
const kos  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kos-tour-package"
const kalymos  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kalymos-tour-package"
const patmos  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/patmos-tour-package"
const samos  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/samos-tour-package"
const patras ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/patras-tour-package"
const galaxidi  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/galaxidi-tour-package"
const volos  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/volos-tour-package"
const xanthi ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/xanthi-tour-package"
const dehradun  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/dehradun-tour-package"
const kedarnath  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/kedarnath-tour-package"
const badrinath  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/badrinath-tour-package"
const yamunotri  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/yamunotri-tour-package"
const gangotri  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/gangotri-tour-package"
const manchester  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/manchester-tour-package"
const glasgow  ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/glasgow-tour-package"
const birmingham   ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/birmingham-tour-package"
const shahdag   ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/shahdag-tour-package"
const africa   ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/africa-tour-package"
const portugal   ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/portugal-tour-package"
const morocco   ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/morocco-tour-package"
const spain   ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/spain-tour-package"
const liechtenstein   ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/liechtenstein-tour-package"
const austria   ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/austria-tour-package"
const monaco   ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/monaco-tour-package"
const netherlands   ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/netherlands-tour-package"
const scotland   ="https://res.cloudinary.com/dul7aqbfs/image/upload/q_auto/f_auto/c_scale,w_800/scotland-tour-package"
const herohead   ="https://res.cloudinary.com/dul7aqbfs/image/upload/himachal-pardesh-tour-package"

export const images = [herohead]
export const destinations = [
  {
    slug: "himachalpradesh",
    name: "Himachal Pradesh",
    price: 6999,
    categories: ["domestic", "trending", "popular"],
    image: himachalpradesh,
    link: "/packages/himachalpradesh",
  },
  {
    slug: "uttrakhand",
    name: "Uttrakhand",
    price: 32999,
    categories: ["domestic", "honeymoon", "popular", "trending"],
    image: uttrakhand,
    link: "/packages/uttrakhand",

  },
  {
    slug: "goa",
    name: "Goa",
    price: 29999,
    categories: ["domestic", "honeymoon", "trending"],
    image: northgoa,
    link: "/packages/goa"
  },
  {
    slug: "rajasthan",
    name: "Rajasthan",
    price: 54999,
    categories: ["domestic", "honeymoon", "popular"],
    image: rajasthan,
    link: "/packages/rajasthan"
  },
  {
    slug: "tamilnadu",
    name: "Tamil Nadu",
    price: 38999,
    categories: ["domestic"],
    image: tamilnadu,
    link: "/packages/tamilnadu"
  },
  {
    slug: "odisha",
    name: "Odisha",
    price: 15999,
    categories: ["domestic", "popular", "honeymoon"],
    image: odisha,
    link: "/packages/odisha"
  },
  {
    slug: "sikkim",
    name: "Sikkim",
    price: 8999,
    categories: ["domestic", "trending"],
    image: sikkim,
    link: "/packages/sikkim"
  },
  {
    slug: "ladakh",
    name: "Ladakh",
    price: 24999,
    categories: ["domestic", "popular"],
    image: ladakh,
    link: "/packages/ladakh"
  },
  {
    slug: "karnataka",
    name: "Karnataka",
    price: 19999,
    categories: ["domestic", "group-tour", "trending"],
    image: karnatka,
    link: "/packages/karnataka"
  },
  {
    slug: "andaman",
    name: "Andaman & Nicobar",
    price: 19999,
    categories: ["domestic", "group-tour", "trending"],
    image: andamanandnicobar,
    link: "/packages/andaman"
  },
  {
  slug: "dubai",
  name: "Dubai",
  price: 45999,
  categories: ["international", "family-tour", "trending"],
  image: dubai,
  link: "/packages/dubai"
},
{
  slug: "thailand",
  name: "Thailand",
  price: 34999,
  categories: ["international", "honeymoon", "group-tour"],
  image: thailand,
  link: "/packages/thailand"
},
{
  slug: "bali",
  name: "Bali",
  price: 52999,
  categories: ["international", "honeymoon", "trending"],
  image: bali,
  link: "/packages/bali"
},
{
  slug: "maldives",
  name: "Maldives",
  price: 79999,
  categories: ["international", "luxury", "honeymoon"],
  image: maldives,
  link: "/packages/maldives"
},
{
  slug: "singapore",
  name: "Singapore",
  price: 61999,
  categories: ["international", "family-tour", "group-tour"],
  image: singapore,
  link: "/packages/singapore"
},
{
  slug: "malaysia",
  name: "Malaysia",
  price: 49999,
  categories: ["international", "family-tour", "budget-friendly"],
  image: malaysia,
  link: "/packages/malaysia"
},
{
  slug: "vietnam",
  name: "Vietnam",
  price: 42999,
  categories: ["international", "budget-friendly", "trending"],
  image: vietnam,
  link: "/packages/vietnam"
},
{
  slug: "mauritius",
  name: "Mauritius",
  price: 94999,
  categories: ["international", "honeymoon", "luxury"],
  image: mauritius,
  link: "/packages/mauritius"
},
{
  slug: "bhutan",
  name: "Bhutan",
  price: 38999,
  categories: ["international", "nature", "group-tour"],
  image: bhutan,
  link: "/packages/bhutan"
},
{
  slug: "japan",
  name: "Japan",
  price: 149999,
  categories: ["international", "luxury", "trending"],
  image: japan,
  link: "/packages/japan"
},
{
  slug: "europe",
  name: "Europe",
  price: 189999,
  categories: ["international", "luxury", "group-tour"],
  image: europe,
  link: "/packages/europe"
},
{
  slug: "turkey",
  name: "Turkey",
  price: 89999,
  categories: ["international", "group-tour", "trending"],
  image: turkey,
  link: "/packages/turkey"
},
{
  slug: "switzerland",
  name: "Switzerland",
  price: 169999,
  categories: ["international", "luxury", "honeymoon"],
  image: switzerland,
  link: "/packages/switzerland"
},
{
  slug: "australia",
  name: "Australia",
  price: 179999,
  categories: ["international", "family-tour", "luxury"],
  image: australia,
  link: "/packages/australia"
},
{
  slug: "newzealand",
  name: "New Zealand",
  price: 199999,
  categories: ["international", "nature", "luxury"],
  image: newzealand,
  link: "/packages/newzealand"
},
{
  slug: "southkorea",
  name: "South Korea",
  price: 129999,
  categories: ["international", "trending", "group-tour"],
  image: southkorea,
  link: "/packages/southkorea"
},
// {
//   slug: "seychelles",
//   name: "Seychelles",
//   price: 139999,
//   categories: ["international", "honeymoon", "luxury"],
//   image: swizerland1,
//   link: "/packages/seychelles"
// },
// {
//   slug: "egypt",
//   name: "Egypt",
//   price: 99999,
//   categories: ["international", "history", "group-tour"],
//   image: swizerland1,
//   link: "/packages/egypt"
// },
{
  slug: "azerbaijan",
  name: "Azerbaijan",
  price: 59999,
  categories: ["international", "budget-friendly", "trending"],
  image: azerbaijan,
  link: "/packages/azerbaijan"
},
{
  slug: "georgia",
  name: "Georgia",
  price: 64999,
  categories: ["international", "budget-friendly", "nature"],
  image: georgia,
  link: "/packages/georgia"
},
];
export const Packages = [
  // ================= Himachal pradesh =================
{
  id: "himachalpradesh-001",
  slug: "shimla-short-trip",
  path: "/packages/himachalpradesh/shimla-short-trip",
  title: "Himalayan Escape",
  duration: "2 Nights 3 Days",
  route: "2N Shimla",
  price: 6999,
  stars: 3,
  image: shimla,
  categories: ["domestic", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "himachalpradesh-002",
  slug: "manali-short-trip",
  path: "/packages/himachalpradesh/manali-short-trip",
  title: "Snow & Serenity Getaway",
  duration: "2 Nights 3 Days",
  route: "2N Manali",
  price: 7499,
  stars: 3,
  image: manali,
  categories: ["domestic", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "himachalpradesh-003",
  slug: "shimla-kufri-retreat",
  path: "/packages/himachalpradesh/shimla-kufri-retreat",
  title: "Scenic Himachal Retreat",
  duration: "3 Nights 4 Days",
  route: "2N Shimla | 1N Kufri",
  price: 9999,
  stars: 3,
  image: himachalpradesh,
  categories: ["domestic", "family", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "himachalpradesh-004",
  slug: "manali-solang-trip",
  path: "/packages/himachalpradesh/manali-solang-trip",
  title: "Snow Trails of Himachal",
  duration: "3 Nights 4 Days",
  route: "2N Manali | Solang Valley",
  price: 12999,
  stars: 3,
  image: solangvalley,
  categories: ["domestic", "adventure", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "himachalpradesh-005",
  slug: "shimla-manali-delight",
  path: "/packages/himachalpradesh/shimla-manali-delight",
  title: "Enchanting Shimla Manali",
  duration: "4 Nights 5 Days",
  route: "2N Shimla | 2N Manali",
  price: 13999,
  stars: 3,
  image: shimla,
  categories: ["domestic", "honeymoon", "bestSeller"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "himachalpradesh-006",
  slug: "shimla-manali-experience",
  path: "/packages/himachalpradesh/shimla-manali-experience",
  title: "Best of Himachal",
  duration: "5 Nights 6 Days",
  route: "2N Shimla | 3N Manali",
  price: 15999,
  stars: 3,
  image: manali,
  categories: ["domestic", "popular", "family"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "himachalpradesh-007",
  slug: "dharamshala-dalhousie-trip",
  path: "/packages/himachalpradesh/dharamshala-dalhousie-trip",
  title: "Valleys of Himachal",
  duration: "5 Nights 6 Days",
  route: "2N Dharamshala | 3N Dalhousie",
  price: 14999,
  stars: 3,
  image: dharmshala,
  categories: ["domestic", "nature", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "himachalpradesh-008",
  slug: "shimla-manali-kasol-tour",
  path: "/packages/himachalpradesh/shimla-manali-kasol-tour",
  title: "Ultimate Himachal Escape",
  duration: "6 Nights 7 Days",
  route: "2N Shimla | 3N Manali | 1N Kasol",
  price: 18999,
  stars: 3,
  image: kasol,
  categories: ["domestic", "adventure", "bestSeller"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "himachalpradesh-009",
  slug: "dharamshala-dalhousie-khajjiar-tour",
  path: "/packages/himachalpradesh/dharamshala-dalhousie-khajjiar-tour",
  title: "Heavenly Himachal Tour",
  duration: "6 Nights 7 Days",
  route: "2N Dharamshala | 2N Dalhousie | 2N Khajjiar",
  price: 19999,
  stars: 3,
  image: khajjar,
  categories: ["domestic", "nature", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Uttrakhand =================
{
  id: "uttrakhand-001",
  slug: "nainital-short-trip",
  path: "/packages/uttrakhand/nainital-short-trip",
  title: "Lake City Escape",
  duration: "2 Nights 3 Days",
  route: "2N Nainital",
  price: 6999,
  stars: 3,
   image: nainital,
  categories: ["domestic", "popular", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "uttrakhand-002",
  slug: "mussoorie-short-trip",
  path: "/packages/uttrakhand/mussoorie-short-trip",
  title: "Queen of Hills Retreat",
  duration: "2 Nights 3 Days",
  route: "2N Mussoorie",
  price: 7499,
  stars: 3,
   image: mussorie,
  categories: ["domestic", "family", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "uttrakhand-003",
  slug: "nainital-bhimtal-tour",
  path: "/packages/uttrakhand/nainital-bhimtal-tour",
  title: "Lakes & Valleys Tour",
  duration: "3 Nights 4 Days",
  route: "2N Nainital | 1N Bhimtal",
  price: 9999,
  stars: 3,
   image: bhimtal,
  categories: ["domestic", "nature", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "uttrakhand-004",
  slug: "mussoorie-dhanaulti-trip",
  path: "/packages/uttrakhand/mussoorie-dhanaulti-trip",
  title: "Scenic Hills Escape",
  duration: "3 Nights 4 Days",
  route: "2N Mussoorie | 1N Dhanaulti",
  price: 10499,
  stars: 3,
   image: dhanaulti,
  categories: ["domestic", "nature", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "uttrakhand-005",
  slug: "mussoorie-rishikesh-haridwar-tour",
  path: "/packages/uttrakhand/mussoorie-rishikesh-haridwar-tour",
  title: "Spiritual & Hills Journey",
  duration: "4 Nights 5 Days",
  route: "2N Mussoorie | 1N Rishikesh | 1N Haridwar",
  price: 12999,
  stars: 3,
  image: haridwar,
  categories: ["domestic", "spiritual", "family"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "uttrakhand-006",
  slug: "nainital-ranikhet-jimcorbett-tour",
  path: "/packages/uttrakhand/nainital-ranikhet-jimcorbett-tour",
  title: "Wildlife & Hills Retreat",
  duration: "5 Nights 6 Days",
  route: "2N Nainital | 1N Ranikhet | 2N Jim Corbett",
  price: 15999,
  stars: 3,
  image: jimcorbett,
  categories: ["domestic", "wildlife", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "uttrakhand-007",
  slug: "mussoorie-rishikesh-corbett-tour",
  path: "/packages/uttrakhand/mussoorie-rishikesh-corbett-tour",
  title: "Adventure Uttarakhand Tour",
  duration: "6 Nights 7 Days",
  route: "2N Mussoorie | 2N Rishikesh | 2N Jim Corbett",
  price: 18999,
  stars: 3,
  image: rishikesh,
  categories: ["domestic", "adventure", "bestSeller"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "uttrakhand-008",
  slug: "nainital-kausani-almora-tour",
  path: "/packages/uttrakhand/nainital-kausani-almora-tour",
  title: "Kumaon Hills Escape",
  duration: "6 Nights 7 Days",
  route: "2N Nainital | 2N Kausani | 2N Almora",
  price: 19499,
  stars: 3,
   image: almora,
  categories: ["domestic", "nature", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Goa =================
{
  id: "goa-001",
  slug: "north-goa-short-trip",
  path: "/packages/goa/north-goa-short-trip",
  title: "North Goa Beach Escape",
  duration: "2 Nights 3 Days",
  route: "2N North Goa",
  price: 6999,
  stars: 3,
   image: northgoa,
  categories: ["domestic", "beach", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "goa-002",
  slug: "south-goa-short-trip",
  path: "/packages/goa/south-goa-short-trip",
  title: "South Goa Serenity",
  duration: "2 Nights 3 Days",
  route: "2N South Goa",
  price: 7499,
  stars: 3,
   image: southgoa,
  categories: ["domestic", "relax", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "goa-003",
  slug: "north-south-goa-tour",
  path: "/packages/goa/north-south-goa-tour",
  title: "Classic Goa Getaway",
  duration: "3 Nights 4 Days",
  route: "2N North Goa | 1N South Goa",
  price: 10999,
  stars: 3,
  image: southgoa,
  categories: ["domestic", "popular", "family"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "goa-004",
  slug: "full-goa-experience",
  path: "/packages/goa/full-goa-experience",
  title: "Ultimate Goa Experience",
  duration: "4 Nights 5 Days",
  route: "2N North Goa | 2N South Goa",
  price: 14999,
  stars: 3,
   image: northgoa,
  categories: ["domestic", "bestSeller", "beach"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "goa-005",
  slug: "goa-dudhsagar-cruise-tour",
  path: "/packages/goa/goa-dudhsagar-cruise-tour",
  title: "Goa Adventure & Cruise",
  duration: "5 Nights 6 Days",
  route: "2N North Goa | 2N South Goa | Dudhsagar Trip",
  price: 17999,
  stars: 3,
   image: dudhsagar,
  categories: ["domestic", "adventure", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Rajasthan =================
{
  id: "rajasthan-001",
  slug: "jaipur-short-trip",
  path: "/packages/rajasthan/jaipur-short-trip",
  title: "Pink City Escape",
  duration: "2 Nights 3 Days",
  route: "2N Jaipur",
  price: 6999,
  stars: 3,
   image: jaipur,
  categories: ["domestic", "heritage", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "rajasthan-002",
  slug: "udaipur-short-trip",
  path: "/packages/rajasthan/udaipur-short-trip",
  title: "City of Lakes Retreat",
  duration: "2 Nights 3 Days",
  route: "2N Udaipur",
  price: 7499,
  stars: 3,
  image: udaipur,
  categories: ["domestic", "honeymoon", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "rajasthan-003",
  slug: "jaipur-pushkar-tour",
  path: "/packages/rajasthan/jaipur-pushkar-tour",
  title: "Royal Rajasthan Journey",
  duration: "3 Nights 4 Days",
  route: "2N Jaipur | 1N Pushkar",
  price: 10999,
  stars: 3,
   image: pushkar,
  categories: ["domestic", "heritage", "family"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "rajasthan-004",
  slug: "udaipur-mountabu-tour",
  path: "/packages/rajasthan/udaipur-mountabu-tour",
  title: "Lakes & Hills Escape",
  duration: "3 Nights 4 Days",
  route: "2N Udaipur | 1N Mount Abu",
  price: 11499,
  stars: 3,
  image: mountabu,
  categories: ["domestic", "nature", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "rajasthan-005",
  slug: "jaipur-udaipur-tour",
  path: "/packages/rajasthan/jaipur-udaipur-tour",
  title: "Royal Rajasthan Delight",
  duration: "4 Nights 5 Days",
  route: "2N Jaipur | 2N Udaipur",
  price: 14999,
  stars: 3,
   image: udaipur,
  categories: ["domestic", "bestSeller", "heritage"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "rajasthan-006",
  slug: "jodhpur-jaisalmer-tour",
  path: "/packages/rajasthan/jodhpur-jaisalmer-tour",
  title: "Desert Kingdom Tour",
  duration: "4 Nights 5 Days",
  route: "2N Jodhpur | 2N Jaisalmer",
  price: 15999,
  stars: 3,
   image: jaislmer,
  categories: ["domestic", "desert", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "rajasthan-007",
  slug: "jaipur-udaipur-mountabu-tour",
  path: "/packages/rajasthan/jaipur-udaipur-mountabu-tour",
  title: "Complete Rajasthan Escape",
  duration: "5 Nights 6 Days",
  route: "2N Jaipur | 2N Udaipur | 1N Mount Abu",
  price: 18999,
  stars: 3,
  image: jaipur,
  categories: ["domestic", "luxury", "family"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "rajasthan-008",
  slug: "golden-triangle-rajasthan-tour",
  path: "/packages/rajasthan/golden-triangle-rajasthan-tour",
  title: "Golden Triangle Rajasthan",
  duration: "6 Nights 7 Days",
  route: "2N Jaipur | 2N Jodhpur | 2N Udaipur",
  price: 22999,
  stars: 3,
   image: jodhpur,
  categories: ["domestic", "premium", "bestSeller"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "rajasthan-009",
  slug: "udaipur-jodhpur-mountabu-tour",
  path: "/packages/rajasthan/udaipur-jodhpur-mountabu-tour",
  title: "Majestic Rajasthan Journey",
  duration: "6 Nights 7 Days",
  route: "2N Udaipur | 2N Jodhpur | 2N Mount Abu",
  price: 21999,
  stars: 3,
  image: mountabu,
  categories: ["domestic", "heritage", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Tamil Nadu =================
{
  id: "tamilnadu-001",
  slug: "ooty-short-trip",
  path: "/packages/tamilnadu/ooty-short-trip",
  title: "Ooty Hill Escape",
  duration: "2 Nights 3 Days",
  route: "2N Ooty",
  price: 7499,
  stars: 3,
   image: ooty,
  categories: ["domestic", "nature", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "tamilnadu-002",
  slug: "kodaikanal-short-trip",
  path: "/packages/tamilnadu/kodaikanal-short-trip",
  title: "Princess of Hills Retreat",
  duration: "2 Nights 3 Days",
  route: "2N Kodaikanal",
  price: 7999,
  stars: 3,
   image: kodaikanal,
  categories: ["domestic", "honeymoon", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "tamilnadu-003",
  slug: "ooty-coonoor-tour",
  path: "/packages/tamilnadu/ooty-coonoor-tour",
  title: "Nilgiri Hills Escape",
  duration: "3 Nights 4 Days",
  route: "2N Ooty | 1N Coonoor",
  price: 10999,
  stars: 3,
   image: cooner,
  categories: ["domestic", "nature", "family"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "tamilnadu-004",
  slug: "kodaikanal-madurai-tour",
  path: "/packages/tamilnadu/kodaikanal-madurai-tour",
  title: "Hills & Heritage Journey",
  duration: "3 Nights 4 Days",
  route: "2N Kodaikanal | 1N Madurai",
  price: 11499,
  stars: 3,
   image: madurai,
  categories: ["domestic", "heritage", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "tamilnadu-005",
  slug: "chennai-mahabalipuram-pondicherry-tour",
  path: "/packages/tamilnadu/chennai-mahabalipuram-pondicherry-tour",
  title: "Coastal Tamil Nadu Escape",
  duration: "4 Nights 5 Days",
  route: "2N Chennai | 1N Mahabalipuram | 1N Pondicherry",
  price: 14999,
  stars: 3,
   image: chennai,
  categories: ["domestic", "beach", "bestSeller"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "tamilnadu-006",
  slug: "madurai-rameshwaram-kanyakumari-tour",
  path: "/packages/tamilnadu/madurai-rameshwaram-kanyakumari-tour",
  title: "Temple & Coastal Journey",
  duration: "5 Nights 6 Days",
  route: "2N Madurai | 2N Rameshwaram | 1N Kanyakumari",
  price: 17999,
  stars: 3,
   image: rameshwaram,
  categories: ["domestic", "spiritual", "family"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "tamilnadu-007",
  slug: "ooty-kodaikanal-madurai-tour",
  path: "/packages/tamilnadu/ooty-kodaikanal-madurai-tour",
  title: "Complete Tamil Nadu Hills Tour",
  duration: "6 Nights 7 Days",
  route: "2N Ooty | 2N Kodaikanal | 2N Madurai",
  price: 21999,
  stars: 3,
  image: ooty,
  categories: ["domestic", "nature", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "tamilnadu-008",
  slug: "chennai-rameshwaram-kanyakumari-tour",
  path: "/packages/tamilnadu/chennai-rameshwaram-kanyakumari-tour",
  title: "South India Spiritual Escape",
  duration: "6 Nights 7 Days",
  route: "2N Chennai | 2N Rameshwaram | 2N Kanyakumari",
  price: 22999,
  stars: 3,
  image: kanyakumari,
  categories: ["domestic", "spiritual", "premium"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Odisha =================
{
  id: "odisha-001",
  slug: "puri-konark-tour",
  path: "/packages/odisha/puri-konark-tour",
  title: "Sacred Odisha Escape",
  duration: "2 Nights 3 Days",
  route: "2N Puri | Konark",
  price: 6999,
  stars: 3,
   image: puri,
  categories: ["domestic", "spiritual", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "odisha-002",
  slug: "puri-konark-bhubaneswar-tour",
  path: "/packages/odisha/puri-konark-bhubaneswar-tour",
  title: "Temple Trail of Odisha",
  duration: "3 Nights 4 Days",
  route: "2N Puri | 1N Bhubaneswar",
  price: 10999,
  stars: 3,
   image: bhubaneswar,
  categories: ["domestic", "heritage", "family"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "odisha-003",
  slug: "puri-bhubaneswar-chilika-tour",
  path: "/packages/odisha/puri-bhubaneswar-chilika-tour",
  title: "Lakes & Temples Journey",
  duration: "4 Nights 5 Days",
  route: "2N Puri | 1N Bhubaneswar | Chilika Lake",
  price: 13999,
  stars: 3,
   image: chilikalake,
  categories: ["domestic", "nature", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "odisha-004",
  slug: "puri-bhubaneswar-gopalpur-chilika-tour",
  path: "/packages/odisha/puri-bhubaneswar-gopalpur-chilika-tour",
  title: "Complete Odisha Coastal Escape",
  duration: "5 Nights 6 Days",
  route: "2N Puri | 1N Bhubaneswar | 1N Gopalpur | Chilika Lake",
  price: 16999,
  stars: 3,
  image: gopalpur,
  categories: ["domestic", "beach", "bestSeller"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Sikkim  =================
{
  id: "sikkim-001",
  slug: "gangtok-short-trip",
  path: "/packages/sikkim/gangtok-short-trip",
  title: "Gangtok Himalayan Escape",
  duration: "3 Nights 4 Days",
  route: "3N Gangtok",
  price: 9999,
  stars: 3,
  image: gangtok,
  categories: ["domestic", "nature", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "sikkim-002",
  slug: "gangtok-pelling-tour",
  path: "/packages/sikkim/gangtok-pelling-tour",
  title: "Mystic Sikkim Journey",
  duration: "4 Nights 5 Days",
  route: "2N Gangtok | 2N Pelling",
  price: 14999,
  stars: 3,
  image: pelling,
  categories: ["domestic", "mountains", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "sikkim-003",
  slug: "gangtok-lachung-tour",
  path: "/packages/sikkim/gangtok-lachung-tour",
  title: "Snow Valley Retreat",
  duration: "4 Nights 5 Days",
  route: "2N Gangtok | 2N Lachung",
  price: 15999,
  stars: 3,
  image: lachung,
  categories: ["domestic", "adventure", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "sikkim-004",
  slug: "gangtok-lachung-pelling-tour",
  path: "/packages/sikkim/gangtok-lachung-pelling-tour",
  title: "Complete Sikkim Escape",
  duration: "5 Nights 6 Days",
  route: "2N Gangtok | 1N Lachung | 2N Pelling",
  price: 19999,
  stars: 3,
  image: gangtok,
  categories: ["domestic", "bestSeller", "nature"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "sikkim-005",
  slug: "gangtok-lachen-lachung-pelling-tour",
  path: "/packages/sikkim/gangtok-lachen-lachung-pelling-tour",
  title: "Grand Sikkim Expedition",
  duration: "6 Nights 7 Days",
  route: "2N Gangtok | 1N Lachen | 1N Lachung | 2N Pelling",
  price: 23999,
  stars: 3,
  image: lachen,
  categories: ["domestic", "luxury", "mountains"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "sikkim-006",
  slug: "gangtok-lachen-lachung-pelling-namchi-tour",
  path: "/packages/sikkim/gangtok-lachen-lachung-pelling-namchi-tour",
  title: "Ultimate Sikkim Discovery",
  duration: "7 Nights 8 Days",
  route: "2N Gangtok | 1N Lachen | 1N Lachung | 2N Pelling | 1N Namchi",
  price: 27999,
  stars: 3,
  image: pelling,
  categories: ["domestic", "premium", "adventure"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Ladakh  =================
{
  id: "ladakh-001",
  slug: "leh-local-monastery-tour",
  path: "/packages/ladakh/leh-local-monastery-tour",
  title: "Leh Monastery Escape",
  duration: "3 Nights 4 Days",
  route: "3N Leh | Monasteries Tour",
  price: 14999,
  stars: 3,
   image: leh,
  categories: ["domestic", "adventure", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "ladakh-002",
  slug: "leh-nubra-tour",
  path: "/packages/ladakh/leh-nubra-tour",
  title: "Himalayan Desert Journey",
  duration: "4 Nights 5 Days",
  route: "2N Leh | 2N Nubra Valley",
  price: 19999,
  stars: 3,
   image: nubarvalley,
  categories: ["domestic", "mountains", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "ladakh-003",
  slug: "leh-pangong-tour",
  path: "/packages/ladakh/leh-pangong-tour",
  title: "Pangong Lake Retreat",
  duration: "4 Nights 5 Days",
  route: "2N Leh | 2N Pangong",
  price: 20999,
  stars: 3,
   image: pangong,
  categories: ["domestic", "nature", "bestSeller"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "ladakh-004",
  slug: "leh-nubra-pangong-tour",
  path: "/packages/ladakh/leh-nubra-pangong-tour",
  title: "Complete Ladakh Adventure",
  duration: "5 Nights 6 Days",
  route: "2N Leh | 1N Nubra Valley | 2N Pangong",
  price: 25999,
  stars: 3,
  image: nubarvalley,
  categories: ["domestic", "adventure", "premium"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "ladakh-005",
  slug: "leh-nubra-pangong-tsomoriri-tour",
  path: "/packages/ladakh/leh-nubra-pangong-tsomoriri-tour",
  title: "Ultimate Ladakh Expedition",
  duration: "6 Nights 7 Days",
  route: "2N Leh | 1N Nubra Valley | 1N Pangong | 2N Tso Moriri",
  price: 31999,
  stars: 3,
   image: tsoMoriri,
  categories: ["domestic", "luxury", "adventure"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Karnatka  =================
{
  id: "karnataka-001",
  slug: "coorg-short-trip",
  path: "/packages/karnataka/coorg-short-trip",
  title: "Coorg Nature Escape",
  duration: "2 Nights 3 Days",
  route: "2N Coorg",
  price: 7999,
  stars: 3,
  image: coorg,
  categories: ["domestic", "nature", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "karnataka-002",
  slug: "chikmagalur-short-trip",
  path: "/packages/karnataka/chikmagalur-short-trip",
  title: "Coffee Hills Retreat",
  duration: "2 Nights 3 Days",
  route: "2N Chikmagalur",
  price: 8499,
  stars: 3,
  image: chikmagalur,
  categories: ["domestic", "mountains", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "karnataka-003",
  slug: "bangalore-mysore-tour",
  path: "/packages/karnataka/bangalore-mysore-tour",
  title: "Royal Karnataka Journey",
  duration: "3 Nights 4 Days",
  route: "2N Bangalore | 1N Mysore",
  price: 11999,
  stars: 3,
  image: mysore,
  categories: ["domestic", "heritage", "family"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "karnataka-004",
  slug: "bangalore-coorg-mysore-tour",
  path: "/packages/karnataka/bangalore-coorg-mysore-tour",
  title: "Best of Karnataka Escape",
  duration: "4 Nights 5 Days",
  route: "2N Bangalore | 1N Coorg | 1N Mysore",
  price: 15999,
  stars: 3,
  image: banglore,
  categories: ["domestic", "bestSeller", "nature"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "karnataka-005",
  slug: "hampi-badami-pattadakal-tour",
  path: "/packages/karnataka/hampi-badami-pattadakal-tour",
  title: "Heritage Karnataka Trail",
  duration: "5 Nights 6 Days",
  route: "2N Hampi | 2N Badami | Pattadakal",
  price: 18999,
  stars: 3,
  image: hampi,
  categories: ["domestic", "heritage", "premium"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "karnataka-006",
  slug: "bangalore-mysore-coorg-ooty-tour",
  path: "/packages/karnataka/bangalore-mysore-coorg-ooty-tour",
  title: "South India Hills Escape",
  duration: "6 Nights 7 Days",
  route: "2N Bangalore | 1N Mysore | 2N Coorg | 1N Ooty",
  price: 23999,
  stars: 3,
  image: ooty,
  categories: ["domestic", "luxury", "family"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Andaman & Nicobar  =================
{
  id: "andaman-001",
  slug: "portblair-havelock-tour",
  path: "/packages/andaman/portblair-havelock-tour",
  title: "Island Paradise Escape",
  duration: "3 Nights 4 Days",
  route: "2N Port Blair | 1N Havelock",
  price: 14999,
  stars: 3,
  image: portBlair,
  categories: ["domestic", "beach", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "andaman-002",
  slug: "portblair-havelock-neil-tour",
  path: "/packages/andaman/portblair-havelock-neil-tour",
  title: "Andaman Island Retreat",
  duration: "4 Nights 5 Days",
  route: "2N Port Blair | 1N Havelock | 1N Neil Island",
  price: 18999,
  stars: 3,
  image: havelock,
  categories: ["domestic", "honeymoon", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "andaman-003",
  slug: "classic-andaman-tour",
  path: "/packages/andaman/classic-andaman-tour",
  title: "Classic Andaman Escape",
  duration: "5 Nights 6 Days",
  route: "2N Port Blair | 2N Havelock | 1N Neil Island",
  price: 22999,
  stars: 3,
  image: neilIsland,
  categories: ["domestic", "bestSeller", "beach"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "andaman-004",
  slug: "grand-andaman-exploration",
  path: "/packages/andaman/grand-andaman-exploration",
  title: "Grand Andaman Exploration",
  duration: "6 Nights 7 Days",
  route: "2N Port Blair | 2N Havelock | 1N Neil Island | Ross Island | Baratang",
  price: 28999,
  stars: 3,
  image: baratang,
  categories: ["domestic", "luxury", "adventure"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Dubai =================
{
  id: "dubai-budget-001",
  slug: "dubai-budget-trip",
  path: "/packages/dubai/dubai-budget-trip",
  title: "Affordable Dubai Escape",
  duration: "3 Nights 4 Days",
  route: "3N Dubai",
  price: 32999,
  stars: 2,
  image: dubai,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "sightseeing", "transfers"]
},
{
  id: "dubai-budget-002",
  slug: "dubai-economy-tour",
  path: "/packages/dubai/dubai-economy-tour",
  title: "Dubai Saver Journey",
  duration: "4 Nights 5 Days",
  route: "4N Dubai",
  price: 39999,
  stars: 3,
  image: dubai,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "dubai-001",
  slug: "dubai-short-trip",
  path: "/packages/dubai/dubai-short-trip",
  title: "Desert City Escape",
  duration: "3 Nights 4 Days",
  route: "3N Dubai",
  price: 45999,
  stars: 4,
  image: dubai,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "dubai-002",
  slug: "dubai-family-tour",
  path: "/packages/dubai/dubai-family-tour",
  title: "Dubai Family Fun",
  duration: "4 Nights 5 Days",
  route: "4N Dubai",
  price: 59999,
  stars: 4,
  image: dubai,
  categories: ["international", "family-tour", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "dubai-003",
  slug: "dubai-abu-dhabi-tour",
  path: "/packages/dubai/dubai-abu-dhabi-tour",
  title: "Luxury Emirates Journey",
  duration: "5 Nights 6 Days",
  route: "4N Dubai | 1N Abu Dhabi",
  price: 74999,
  stars: 5,
  image: abudhabi,
  categories: ["international", "luxury", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "dubai-004",
  slug: "dubai-honeymoon-package",
  path: "/packages/dubai/dubai-honeymoon-package",
  title: "Romantic Dubai Escape",
  duration: "5 Nights 6 Days",
  route: "5N Dubai",
  price: 82999,
  stars: 5,
  image: dubai,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "dubai-005",
  slug: "grand-dubai-explorer",
  path: "/packages/dubai/grand-dubai-explorer",
  title: "Ultimate Dubai Adventure",
  duration: "6 Nights 7 Days",
  route: "5N Dubai | 1N Abu Dhabi",
  price: 99999,
  stars: 5,
  image: abudhabi,
  categories: ["international", "luxury", "group-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Thailand =================
{
  id: "thailand-budget-001",
  slug: "thailand-budget-trip",
  path: "/packages/thailand/thailand-budget-trip",
  title: "Budget Thailand Escape",
  duration: "4 Nights 5 Days",
  route: "2N Pattaya | 2N Bangkok",
  price: 24999,
  stars: 2,
  image: pattaya,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "sightseeing", "transfers"]
},
{
  id: "thailand-budget-002",
  slug: "thailand-economy-tour",
  path: "/packages/thailand/thailand-economy-tour",
  title: "Thailand Saver Journey",
  duration: "5 Nights 6 Days",
  route: "3N Phuket | 2N Krabi",
  price: 34999,
  stars: 3,
  image: phuket,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "thailand-001",
  slug: "bangkok-pattaya-trip",
  path: "/packages/thailand/bangkok-pattaya-trip",
  title: "Thailand Fun Retreat",
  duration: "4 Nights 5 Days",
  route: "2N Pattaya | 2N Bangkok",
  price: 34999,
  stars: 3,
  image: bangkok,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "thailand-002",
  slug: "phuket-krabi-tour",
  path: "/packages/thailand/phuket-krabi-tour",
  title: "Island Adventure Thailand",
  duration: "5 Nights 6 Days",
  route: "3N Phuket | 2N Krabi",
  price: 55999,
  stars: 4,
  image: krabi,
  categories: ["international", "honeymoon", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "thailand-003",
  slug: "bangkok-phuket-tour",
  path: "/packages/thailand/bangkok-phuket-tour",
  title: "City & Beach Escape",
  duration: "6 Nights 7 Days",
  route: "3N Bangkok | 3N Phuket",
  price: 64999,
  stars: 4,
  image: bangkok,
  categories: ["international", "family-tour", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "thailand-004",
  slug: "thailand-honeymoon-package",
  path: "/packages/thailand/thailand-honeymoon-package",
  title: "Romantic Thailand Bliss",
  duration: "6 Nights 7 Days",
  route: "3N Krabi | 3N Phuket",
  price: 72999,
  stars: 5,
  image: phuket,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "thailand-005",
  slug: "grand-thailand-tour",
  path: "/packages/thailand/grand-thailand-tour",
  title: "Ultimate Thailand Explorer",
  duration: "8 Nights 9 Days",
  route: "2N Pattaya | 2N Bangkok | 2N Phuket | 2N Krabi",
  price: 99999,
  stars: 5,
  image: pattaya,
  categories: ["international", "luxury", "group-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Bali =================
{
  id: "bali-budget-001",
  slug: "bali-budget-trip",
  path: "/packages/bali/bali-budget-trip",
  title: "Affordable Bali Escape",
  duration: "4 Nights 5 Days",
  route: "4N Bali",
  price: 39999,
  stars: 2,
  image: bali,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "sightseeing", "transfers"]
},
{
  id: "bali-budget-002",
  slug: "bali-economy-tour",
  path: "/packages/bali/bali-economy-tour",
  title: "Bali Saver Retreat",
  duration: "5 Nights 6 Days",
  route: "3N Kuta | 2N Ubud",
  price: 49999,
  stars: 3,
  image: kuta,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "bali-001",
  slug: "bali-short-trip",
  path: "/packages/bali/bali-short-trip",
  title: "Tropical Bali Escape",
  duration: "4 Nights 5 Days",
  route: "4N Bali",
  price: 52999,
  stars: 4,
  image: bali,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "bali-002",
  slug: "bali-kuta-ubud-tour",
  path: "/packages/bali/bali-kuta-ubud-tour",
  title: "Bali Nature & Beaches",
  duration: "5 Nights 6 Days",
  route: "3N Kuta | 2N Ubud",
  price: 64999,
  stars: 4,
  image: ubud,
  categories: ["international", "honeymoon", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "bali-003",
  slug: "bali-family-package",
  path: "/packages/bali/bali-family-package",
  title: "Bali Family Adventure",
  duration: "6 Nights 7 Days",
  route: "3N Kuta | 3N Ubud",
  price: 74999,
  stars: 4,
  image: kuta,
  categories: ["international", "family-tour", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "bali-004",
  slug: "bali-honeymoon-package",
  path: "/packages/bali/bali-honeymoon-package",
  title: "Romantic Bali Bliss",
  duration: "6 Nights 7 Days",
  route: "2N Seminyak | 2N Ubud | 2N Nusa Dua",
  price: 89999,
  stars: 5,
  image: seminyak,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "bali-005",
  slug: "grand-bali-explorer",
  path: "/packages/bali/grand-bali-explorer",
  title: "Ultimate Bali Journey",
  duration: "7 Nights 8 Days",
  route: "3N Kuta | 2N Ubud | 2N Nusa Penida",
  price: 109999,
  stars: 5,
  image: nusaPenida,
  categories: ["international", "luxury", "group-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Maldives =================
{
  id: "maldives-budget-001",
  slug: "maldives-budget-trip",
  path: "/packages/maldives/maldives-budget-trip",
  title: "Affordable Maldives Escape",
  duration: "3 Nights 4 Days",
  route: "3N Maldives",
  price: 59999,
  stars: 2,
  image: maldives,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "transfers"]
},
{
  id: "maldives-budget-002",
  slug: "maldives-economy-tour",
  path: "/packages/maldives/maldives-economy-tour",
  title: "Maldives Saver Retreat",
  duration: "4 Nights 5 Days",
  route: "4N Maldives",
  price: 74999,
  stars: 3,
  image: maldives,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "transfers", "meals"]
},
{
  id: "maldives-001",
  slug: "maldives-short-escape",
  path: "/packages/maldives/maldives-short-escape",
  title: "Ocean Paradise Retreat",
  duration: "3 Nights 4 Days",
  route: "3N Maldives",
  price: 79999,
  stars: 4,
  image: maldives,
  categories: ["international", "honeymoon", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "maldives-002",
  slug: "maldives-water-villa-tour",
  path: "/packages/maldives/maldives-water-villa-tour",
  title: "Luxury Water Villa Escape",
  duration: "4 Nights 5 Days",
  route: "4N Maldives",
  price: 109999,
  stars: 5,
  image: maldives,
  categories: ["international", "luxury", "honeymoon"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "maldives-003",
  slug: "maldives-family-package",
  path: "/packages/maldives/maldives-family-package",
  title: "Maldives Family Getaway",
  duration: "5 Nights 6 Days",
  route: "5N Maldives",
  price: 129999,
  stars: 5,
  image: maldives,
  categories: ["international", "family-tour", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "maldives-004",
  slug: "maldives-honeymoon-package",
  path: "/packages/maldives/maldives-honeymoon-package",
  title: "Romantic Island Bliss",
  duration: "5 Nights 6 Days",
  route: "2N Beach Villa | 3N Water Villa",
  price: 149999,
  stars: 5,
  image: watervilla,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "maldives-005",
  slug: "grand-maldives-luxury-tour",
  path: "/packages/maldives/grand-maldives-luxury-tour",
  title: "Ultimate Maldives Experience",
  duration: "6 Nights 7 Days",
  route: "3N Beach Villa | 3N Water Villa",
  price: 189999,
  stars: 5,
  image: beachvilla,
  categories: ["international", "luxury", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Singapore =================
{
  id: "singapore-budget-001",
  slug: "singapore-budget-trip",
  path: "/packages/singapore/singapore-budget-trip",
  title: "Affordable Singapore Escape",
  duration: "3 Nights 4 Days",
  route: "3N Singapore",
  price: 44999,
  stars: 2,
  image: singapore,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "sightseeing", "transfers"]
},
{
  id: "singapore-budget-002",
  slug: "singapore-economy-tour",
  path: "/packages/singapore/singapore-economy-tour",
  title: "Singapore Saver Journey",
  duration: "4 Nights 5 Days",
  route: "4N Singapore",
  price: 55999,
  stars: 3,
  image: singapore,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "singapore-001",
  slug: "singapore-short-trip",
  path: "/packages/singapore/singapore-short-trip",
  title: "Singapore City Escape",
  duration: "3 Nights 4 Days",
  route: "3N Singapore",
  price: 61999,
  stars: 4,
  image: singapore,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "singapore-002",
  slug: "singapore-family-tour",
  path: "/packages/singapore/singapore-family-tour",
  title: "Singapore Family Adventure",
  duration: "4 Nights 5 Days",
  route: "4N Singapore",
  price: 74999,
  stars: 4,
  image: singapore,
  categories: ["international", "family-tour", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "singapore-003",
  slug: "singapore-sentosa-package",
  path: "/packages/singapore/singapore-sentosa-package",
  title: "Sentosa Island Getaway",
  duration: "5 Nights 6 Days",
  route: "3N Singapore | 2N Sentosa",
  price: 89999,
  stars: 5,
  image: sentosa,
  categories: ["international", "luxury", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "singapore-004",
  slug: "singapore-malaysia-tour",
  path: "/packages/singapore/singapore-malaysia-tour",
  title: "Twin Nation Explorer",
  duration: "6 Nights 7 Days",
  route: "3N Singapore | 3N Kuala Lumpur",
  price: 99999,
  stars: 5,
  image: kualaLumpur,
  categories: ["international", "group-tour", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "singapore-005",
  slug: "grand-singapore-luxury-tour",
  path: "/packages/singapore/grand-singapore-luxury-tour",
  title: "Ultimate Singapore Experience",
  duration: "7 Nights 8 Days",
  route: "4N Singapore | 3N Sentosa",
  price: 129999,
  stars: 5,
  image: sentosa,
  categories: ["international", "luxury", "family-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Malaysia =================
{
  id: "malaysia-budget-001",
  slug: "malaysia-budget-trip",
  path: "/packages/malaysia/malaysia-budget-trip",
  title: "Affordable Malaysia Escape",
  duration: "3 Nights 4 Days",
  route: "3N Kuala Lumpur",
  price: 34999,
  stars: 2,
  image: kualaLumpur,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "sightseeing", "transfers"]
},
{
  id: "malaysia-budget-002",
  slug: "malaysia-economy-tour",
  path: "/packages/malaysia/malaysia-economy-tour",
  title: "Malaysia Saver Journey",
  duration: "5 Nights 6 Days",
  route: "3N Kuala Lumpur | 2N Langkawi",
  price: 49999,
  stars: 3,
  image: langkawi,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "malaysia-001",
  slug: "kuala-lumpur-short-trip",
  path: "/packages/malaysia/kuala-lumpur-short-trip",
  title: "Malaysia City Escape",
  duration: "3 Nights 4 Days",
  route: "3N Kuala Lumpur",
  price: 49999,
  stars: 4,
  image: kualaLumpur,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "malaysia-002",
  slug: "kuala-lumpur-langkawi-tour",
  path: "/packages/malaysia/kuala-lumpur-langkawi-tour",
  title: "Malaysia Beach & City Tour",
  duration: "5 Nights 6 Days",
  route: "3N Kuala Lumpur | 2N Langkawi",
  price: 64999,
  stars: 4,
  image: langkawi,
  categories: ["international", "family-tour", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "malaysia-003",
  slug: "langkawi-penang-package",
  path: "/packages/malaysia/langkawi-penang-package",
  title: "Island & Heritage Escape",
  duration: "6 Nights 7 Days",
  route: "3N Langkawi | 3N Penang",
  price: 75999,
  stars: 4,
  image: penang,
  categories: ["international", "trending", "group-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "malaysia-004",
  slug: "malaysia-honeymoon-package",
  path: "/packages/malaysia/malaysia-honeymoon-package",
  title: "Romantic Malaysia Retreat",
  duration: "6 Nights 7 Days",
  route: "3N Kuala Lumpur | 3N Langkawi",
  price: 89999,
  stars: 5,
  image: kualaLumpur,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "malaysia-005",
  slug: "grand-malaysia-tour",
  path: "/packages/malaysia/grand-malaysia-tour",
  title: "Ultimate Malaysia Explorer",
  duration: "8 Nights 9 Days",
  route: "3N Kuala Lumpur | 2N Langkawi | 3N Penang",
  price: 119999,
  stars: 5,
  image: penang,
  categories: ["international", "luxury", "family-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Vietnam =================
{
  id: "vietnam-budget-001",
  slug: "vietnam-budget-trip",
  path: "/packages/vietnam/vietnam-budget-trip",
  title: "Affordable Vietnam Escape",
  duration: "4 Nights 5 Days",
  route: "3N Hanoi | 1N Halong Bay",
  price: 32999,
  stars: 2,
  image: halongBay,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "sightseeing", "transfers"]
},
{
  id: "vietnam-budget-002",
  slug: "vietnam-economy-tour",
  path: "/packages/vietnam/vietnam-economy-tour",
  title: "Vietnam Saver Journey",
  duration: "5 Nights 6 Days",
  route: "3N Hanoi | 2N Da Nang",
  price: 44999,
  stars: 3,
  image: daNang,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "vietnam-001",
  slug: "hanoi-short-trip",
  path: "/packages/vietnam/hanoi-short-trip",
  title: "Vietnam Cultural Escape",
  duration: "3 Nights 4 Days",
  route: "3N Hanoi",
  price: 42999,
  stars: 4,
  image: hanoi,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "vietnam-002",
  slug: "hanoi-halong-tour",
  path: "/packages/vietnam/hanoi-halong-tour",
  title: "Halong Bay Discovery",
  duration: "5 Nights 6 Days",
  route: "3N Hanoi | 2N Halong Bay",
  price: 58999,
  stars: 4,
  image: hanoi,
  categories: ["international", "family-tour", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "vietnam-003",
  slug: "danang-hoi-an-package",
  path: "/packages/vietnam/danang-hoi-an-package",
  title: "Vietnam Coastal Journey",
  duration: "6 Nights 7 Days",
  route: "3N Da Nang | 3N Hoi An",
  price: 72999,
  stars: 4,
  image: hoiAn,
  categories: ["international", "trending", "group-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "vietnam-004",
  slug: "vietnam-honeymoon-package",
  path: "/packages/vietnam/vietnam-honeymoon-package",
  title: "Romantic Vietnam Escape",
  duration: "6 Nights 7 Days",
  route: "3N Da Nang | 3N Phu Quoc",
  price: 89999,
  stars: 5,
  image: phuQuoc,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "vietnam-005",
  slug: "grand-vietnam-tour",
  path: "/packages/vietnam/grand-vietnam-tour",
  title: "Ultimate Vietnam Explorer",
  duration: "8 Nights 9 Days",
  route: "3N Hanoi | 2N Halong Bay | 3N Ho Chi Minh City",
  price: 119999,
  stars: 5,
  image: hochiminhcity,
  categories: ["international", "luxury", "family-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Mauritius =================
{
  id: "mauritius-budget-001",
  slug: "mauritius-budget-trip",
  path: "/packages/mauritius/mauritius-budget-trip",
  title: "Affordable Mauritius Escape",
  duration: "4 Nights 5 Days",
  route: "4N Mauritius",
  price: 69999,
  stars: 2,
  image: mauritius,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "transfers"]
},
{
  id: "mauritius-budget-002",
  slug: "mauritius-economy-tour",
  path: "/packages/mauritius/mauritius-economy-tour",
  title: "Mauritius Saver Retreat",
  duration: "5 Nights 6 Days",
  route: "5N Mauritius",
  price: 89999,
  stars: 3,
  image: mauritius,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "mauritius-001",
  slug: "mauritius-short-escape",
  path: "/packages/mauritius/mauritius-short-escape",
  title: "Tropical Island Retreat",
  duration: "4 Nights 5 Days",
  route: "4N Mauritius",
  price: 94999,
  stars: 4,
  image: mauritius,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "mauritius-002",
  slug: "mauritius-family-tour",
  path: "/packages/mauritius/mauritius-family-tour",
  title: "Mauritius Beach Adventure",
  duration: "5 Nights 6 Days",
  route: "5N Mauritius",
  price: 119999,
  stars: 5,
  image: mauritius,
  categories: ["international", "family-tour", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "mauritius-003",
  slug: "mauritius-honeymoon-package",
  path: "/packages/mauritius/mauritius-honeymoon-package",
  title: "Romantic Island Bliss",
  duration: "6 Nights 7 Days",
  route: "6N Mauritius",
  price: 139999,
  stars: 5,
  image: mauritius,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "mauritius-004",
  slug: "mauritius-luxury-retreat",
  path: "/packages/mauritius/mauritius-luxury-retreat",
  title: "Luxury Ocean Escape",
  duration: "7 Nights 8 Days",
  route: "7N Mauritius",
  price: 169999,
  stars: 5,
  image: mauritius,
  categories: ["international", "luxury", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "mauritius-005",
  slug: "grand-mauritius-tour",
  path: "/packages/mauritius/grand-mauritius-tour",
  title: "Ultimate Mauritius Experience",
  duration: "8 Nights 9 Days",
  route: "5N Mauritius | 3N Beach Resort",
  price: 199999,
  stars: 5,
  image: beachresort,
  categories: ["international", "luxury", "family-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Bhutan =================
{
  id: "bhutan-budget-001",
  slug: "bhutan-budget-trip",
  path: "/packages/bhutan/bhutan-budget-trip",
  title: "Affordable Bhutan Escape",
  duration: "4 Nights 5 Days",
  route: "2N Thimphu | 2N Paro",
  price: 24999,
  stars: 2,
  image: thimpu,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "sightseeing", "transfers"]
},
{
  id: "bhutan-budget-002",
  slug: "bhutan-economy-tour",
  path: "/packages/bhutan/bhutan-economy-tour",
  title: "Bhutan Saver Journey",
  duration: "5 Nights 6 Days",
  route: "3N Thimphu | 2N Paro",
  price: 34999,
  stars: 3,
  image: paro,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "bhutan-001",
  slug: "bhutan-short-trip",
  path: "/packages/bhutan/bhutan-short-trip",
  title: "Land of Happiness Escape",
  duration: "4 Nights 5 Days",
  route: "2N Thimphu | 2N Paro",
  price: 38999,
  stars: 3,
  image: paro,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "bhutan-002",
  slug: "thimphu-paro-tour",
  path: "/packages/bhutan/thimphu-paro-tour",
  title: "Bhutan Cultural Journey",
  duration: "5 Nights 6 Days",
  route: "3N Thimphu | 2N Paro",
  price: 49999,
  stars: 4,
  image: thimpu,
  categories: ["international", "family-tour", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "bhutan-003",
  slug: "bhutan-nature-package",
  path: "/packages/bhutan/bhutan-nature-package",
  title: "Mystic Himalayan Retreat",
  duration: "6 Nights 7 Days",
  route: "2N Thimphu | 2N Punakha | 2N Paro",
  price: 64999,
  stars: 4,
  image: punakha,
  categories: ["international", "nature", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "bhutan-004",
  slug: "bhutan-honeymoon-package",
  path: "/packages/bhutan/bhutan-honeymoon-package",
  title: "Romantic Bhutan Escape",
  duration: "6 Nights 7 Days",
  route: "3N Paro | 3N Punakha",
  price: 79999,
  stars: 5,
  image: paro,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "bhutan-005",
  slug: "grand-bhutan-tour",
  path: "/packages/bhutan/grand-bhutan-tour",
  title: "Ultimate Bhutan Explorer",
  duration: "8 Nights 9 Days",
  route: "3N Thimphu | 2N Punakha | 3N Paro",
  price: 99999,
  stars: 5,
  image: punakha,
  categories: ["international", "luxury", "group-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Japan =================
{
  id: "japan-budget-001",
  slug: "japan-budget-trip",
  path: "/packages/japan/japan-budget-trip",
  title: "Affordable Japan Escape",
  duration: "5 Nights 6 Days",
  route: "3N Tokyo | 2N Osaka",
  price: 99999,
  stars: 2,
  image: osaka,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "transfers"]
},
{
  id: "japan-budget-002",
  slug: "japan-economy-tour",
  path: "/packages/japan/japan-economy-tour",
  title: "Japan Saver Journey",
  duration: "6 Nights 7 Days",
  route: "3N Tokyo | 3N Kyoto",
  price: 129999,
  stars: 3,
  image: kyoto,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "japan-001",
  slug: "tokyo-short-trip",
  path: "/packages/japan/tokyo-short-trip",
  title: "Tokyo City Escape",
  duration: "4 Nights 5 Days",
  route: "4N Tokyo",
  price: 129999,
  stars: 4,
  image: tokyo,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "japan-002",
  slug: "tokyo-osaka-tour",
  path: "/packages/japan/tokyo-osaka-tour",
  title: "Japan Cultural Journey",
  duration: "6 Nights 7 Days",
  route: "3N Tokyo | 3N Osaka",
  price: 149999,
  stars: 4,
  image: osaka,
  categories: ["international", "family-tour", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "japan-003",
  slug: "tokyo-kyoto-osaka-package",
  path: "/packages/japan/tokyo-kyoto-osaka-package",
  title: "Cherry Blossom Explorer",
  duration: "7 Nights 8 Days",
  route: "3N Tokyo | 2N Kyoto | 2N Osaka",
  price: 179999,
  stars: 5,
  image: kyoto,
  categories: ["international", "trending", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "japan-004",
  slug: "japan-honeymoon-package",
  path: "/packages/japan/japan-honeymoon-package",
  title: "Romantic Japan Escape",
  duration: "8 Nights 9 Days",
  route: "3N Tokyo | 2N Hakone | 3N Kyoto",
  price: 219999,
  stars: 5,
  image: hakone,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "japan-005",
  slug: "grand-japan-tour",
  path: "/packages/japan/grand-japan-tour",
  title: "Ultimate Japan Experience",
  duration: "10 Nights 11 Days",
  route: "3N Tokyo | 2N Kyoto | 2N Osaka | 3N Hokkaido",
  price: 289999,
  stars: 5,
  image: hokkaido,
  categories: ["international", "luxury", "group-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Europe =================
{
  id: "europe-budget-001",
  slug: "europe-budget-trip",
  path: "/packages/europe/europe-budget-trip",
  title: "Affordable Europe Escape",
  duration: "6 Nights 7 Days",
  route: "3N Paris | 3N Amsterdam",
  price: 149999,
  stars: 2,
  image: paris,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "transfers"]
},
{
  id: "europe-budget-002",
  slug: "europe-economy-tour",
  path: "/packages/europe/europe-economy-tour",
  title: "Europe Saver Journey",
  duration: "8 Nights 9 Days",
  route: "3N Paris | 3N Switzerland | 2N Italy",
  price: 199999,
  stars: 3,
  image: switzerland,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "europe-001",
  slug: "switzerland-paris-tour",
  path: "/packages/europe/switzerland-paris-tour",
  title: "European Dream Escape",
  duration: "6 Nights 7 Days",
  route: "3N Switzerland | 3N Paris",
  price: 189999,
  stars: 4,
  image: paris,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "europe-002",
  slug: "paris-amsterdam-tour",
  path: "/packages/europe/paris-amsterdam-tour",
  title: "Classic Europe Journey",
  duration: "7 Nights 8 Days",
  route: "4N Paris | 3N Amsterdam",
  price: 209999,
  stars: 4,
  image: amsterdam,
  categories: ["international", "family-tour", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "europe-003",
  slug: "switzerland-italy-france-package",
  path: "/packages/europe/switzerland-italy-france-package",
  title: "Scenic Europe Explorer",
  duration: "9 Nights 10 Days",
  route: "3N Switzerland | 3N Italy | 3N Paris",
  price: 249999,
  stars: 5,
  image: italy,
  categories: ["international", "luxury", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "europe-004",
  slug: "europe-honeymoon-package",
  path: "/packages/europe/europe-honeymoon-package",
  title: "Romantic Europe Escape",
  duration: "10 Nights 11 Days",
  route: "3N Paris | 3N Switzerland | 2N Venice | 2N Rome",
  price: 299999,
  stars: 5,
  image: rome,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "europe-005",
  slug: "grand-europe-tour",
  path: "/packages/europe/grand-europe-tour",
  title: "Ultimate Europe Expedition",
  duration: "14 Nights 15 Days",
  route: "Paris | Switzerland | Italy | Amsterdam | Germany",
  price: 399999,
  stars: 5,
  image: germany,
  categories: ["international", "luxury", "group-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Turkey =================
{
  id: "turkey-budget-001",
  slug: "turkey-budget-trip",
  path: "/packages/turkey/turkey-budget-trip",
  title: "Affordable Turkey Escape",
  duration: "4 Nights 5 Days",
  route: "4N Istanbul",
  price: 59999,
  stars: 2,
  image: istanbul,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "sightseeing", "transfers"]
},
{
  id: "turkey-budget-002",
  slug: "turkey-economy-tour",
  path: "/packages/turkey/turkey-economy-tour",
  title: "Turkey Saver Journey",
  duration: "6 Nights 7 Days",
  route: "3N Istanbul | 3N Cappadocia",
  price: 79999,
  stars: 3,
  image: cappadocia,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "turkey-001",
  slug: "istanbul-short-trip",
  path: "/packages/turkey/istanbul-short-trip",
  title: "Istanbul City Escape",
  duration: "4 Nights 5 Days",
  route: "4N Istanbul",
  price: 79999,
  stars: 4,
  image: istanbul,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "turkey-002",
  slug: "istanbul-cappadocia-tour",
  path: "/packages/turkey/istanbul-cappadocia-tour",
  title: "Turkey Heritage Journey",
  duration: "6 Nights 7 Days",
  route: "3N Istanbul | 3N Cappadocia",
  price: 99999,
  stars: 4,
  image: cappadocia,
  categories: ["international", "family-tour", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "turkey-003",
  slug: "turkey-coastal-package",
  path: "/packages/turkey/turkey-coastal-package",
  title: "Mediterranean Turkey Escape",
  duration: "7 Nights 8 Days",
  route: "3N Antalya | 2N Cappadocia | 2N Istanbul",
  price: 129999,
  stars: 5,
  image: antalya,
  categories: ["international", "luxury", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "turkey-004",
  slug: "turkey-honeymoon-package",
  path: "/packages/turkey/turkey-honeymoon-package",
  title: "Romantic Turkey Bliss",
  duration: "8 Nights 9 Days",
  route: "3N Istanbul | 3N Cappadocia | 2N Antalya",
  price: 149999,
  stars: 5,
  image: istanbul,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "turkey-005",
  slug: "grand-turkey-tour",
  path: "/packages/turkey/grand-turkey-tour",
  title: "Ultimate Turkey Explorer",
  duration: "10 Nights 11 Days",
  route: "3N Istanbul | 2N Cappadocia | 2N Antalya | 3N Pamukkale",
  price: 189999,
  stars: 5,
  image: pamukkale,
  categories: ["international", "luxury", "group-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Switzerland =================
{
  id: "switzerland-budget-001",
  slug: "switzerland-budget-trip",
  path: "/packages/switzerland/switzerland-budget-trip",
  title: "Affordable Swiss Escape",
  duration: "5 Nights 6 Days",
  route: "3N Zurich | 2N Lucerne",
  price: 129999,
  stars: 2,
  image: zurich,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "transfers"]
},
{
  id: "switzerland-budget-002",
  slug: "switzerland-economy-tour",
  path: "/packages/switzerland/switzerland-economy-tour",
  title: "Swiss Saver Journey",
  duration: "7 Nights 8 Days",
  route: "3N Zurich | 2N Interlaken | 2N Lucerne",
  price: 169999,
  stars: 3,
  image: interlaken,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "switzerland-001",
  slug: "switzerland-short-trip",
  path: "/packages/switzerland/switzerland-short-trip",
  title: "Swiss Alps Escape",
  duration: "5 Nights 6 Days",
  route: "3N Zurich | 2N Lucerne",
  price: 169999,
  stars: 4,
  image: lucerne,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "switzerland-002",
  slug: "zurich-interlaken-tour",
  path: "/packages/switzerland/zurich-interlaken-tour",
  title: "Scenic Switzerland Journey",
  duration: "7 Nights 8 Days",
  route: "3N Zurich | 2N Interlaken | 2N Lucerne",
  price: 219999,
  stars: 4,
  image: zurich,
  categories: ["international", "family-tour", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "switzerland-003",
  slug: "switzerland-paris-package",
  path: "/packages/switzerland/switzerland-paris-package",
  title: "Swiss & Paris Explorer",
  duration: "8 Nights 9 Days",
  route: "5N Switzerland | 3N Paris",
  price: 259999,
  stars: 5,
  image: paris,
  categories: ["international", "luxury", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "switzerland-004",
  slug: "switzerland-honeymoon-package",
  path: "/packages/switzerland/switzerland-honeymoon-package",
  title: "Romantic Swiss Escape",
  duration: "9 Nights 10 Days",
  route: "3N Zurich | 3N Interlaken | 3N Lucerne",
  price: 299999,
  stars: 5,
  image: lucerne,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "switzerland-005",
  slug: "grand-switzerland-tour",
  path: "/packages/switzerland/grand-switzerland-tour",
  title: "Ultimate Switzerland Experience",
  duration: "11 Nights 12 Days",
  route: "3N Zurich | 3N Interlaken | 2N Geneva | 3N Lucerne",
  price: 379999,
  stars: 5,
  image: geneva,
  categories: ["international", "luxury", "group-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Australia =================
{
  id: "australia-budget-001",
  slug: "australia-budget-trip",
  path: "/packages/australia/australia-budget-trip",
  title: "Affordable Australia Escape",
  duration: "5 Nights 6 Days",
  route: "5N Sydney",
  price: 149999,
  stars: 2,
  image: sydney,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "transfers"]
},
{
  id: "australia-budget-002",
  slug: "australia-economy-tour",
  path: "/packages/australia/australia-economy-tour",
  title: "Australia Saver Journey",
  duration: "7 Nights 8 Days",
  route: "4N Sydney | 3N Melbourne",
  price: 189999,
  stars: 3,
  image: melbourne,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "australia-001",
  slug: "sydney-short-trip",
  path: "/packages/australia/sydney-short-trip",
  title: "Sydney City Escape",
  duration: "5 Nights 6 Days",
  route: "5N Sydney",
  price: 179999,
  stars: 4,
  image: sydney,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "australia-002",
  slug: "sydney-melbourne-tour",
  path: "/packages/australia/sydney-melbourne-tour",
  title: "Australia Urban Journey",
  duration: "7 Nights 8 Days",
  route: "4N Sydney | 3N Melbourne",
  price: 229999,
  stars: 4,
  image: melbourne,
  categories: ["international", "family-tour", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "australia-003",
  slug: "gold-coast-cairns-package",
  path: "/packages/australia/gold-coast-cairns-package",
  title: "Coastal Australia Adventure",
  duration: "8 Nights 9 Days",
  route: "4N Gold Coast | 4N Cairns",
  price: 269999,
  stars: 5,
  image: cairns,
  categories: ["international", "luxury", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "australia-004",
  slug: "australia-honeymoon-package",
  path: "/packages/australia/australia-honeymoon-package",
  title: "Romantic Australia Escape",
  duration: "9 Nights 10 Days",
  route: "4N Sydney | 3N Gold Coast | 2N Melbourne",
  price: 319999,
  stars: 5,
  image: goldCoast,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "australia-005",
  slug: "grand-australia-tour",
  path: "/packages/australia/grand-australia-tour",
  title: "Ultimate Australia Explorer",
  duration: "12 Nights 13 Days",
  route: "4N Sydney | 3N Melbourne | 3N Gold Coast | 2N Cairns",
  price: 429999,
  stars: 5,
  image: cairns,
  categories: ["international", "luxury", "group-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= New Zealand =================
{
  id: "newzealand-budget-001",
  slug: "newzealand-budget-trip",
  path: "/packages/new zealand/newzealand-budget-trip",
  title: "Affordable New Zealand Escape",
  duration: "5 Nights 6 Days",
  route: "5N Auckland",
  price: 169999,
  stars: 2,
  image: auckland,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "transfers"]
},
{
  id: "newzealand-budget-002",
  slug: "newzealand-economy-tour",
  path: "/packages/new zealand/newzealand-economy-tour",
  title: "New Zealand Saver Journey",
  duration: "7 Nights 8 Days",
  route: "4N Auckland | 3N Queenstown",
  price: 219999,
  stars: 3,
  image: queenstown,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "newzealand-001",
  slug: "auckland-short-trip",
  path: "/packages/new zealand/auckland-short-trip",
  title: "New Zealand City Escape",
  duration: "5 Nights 6 Days",
  route: "5N Auckland",
  price: 199999,
  stars: 4,
  image: auckland,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "newzealand-002",
  slug: "auckland-queenstown-tour",
  path: "/packages/new zealand/auckland-queenstown-tour",
  title: "Scenic New Zealand Journey",
  duration: "7 Nights 8 Days",
  route: "4N Auckland | 3N Queenstown",
  price: 249999,
  stars: 4,
  image: queenstown,
  categories: ["international", "family-tour", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "newzealand-003",
  slug: "queenstown-rotorua-package",
  path: "/packages/new zealand/queenstown-rotorua-package",
  title: "Adventure & Nature Escape",
  duration: "8 Nights 9 Days",
  route: "4N Queenstown | 4N Rotorua",
  price: 289999,
  stars: 5,
  image: rotorua,
  categories: ["international", "luxury", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "newzealand-004",
  slug: "newzealand-honeymoon-package",
  path: "/packages/new zealand/newzealand-honeymoon-package",
  title: "Romantic Kiwi Escape",
  duration: "9 Nights 10 Days",
  route: "4N Auckland | 3N Queenstown | 2N Rotorua",
  price: 349999,
  stars: 5,
  image: auckland,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "newzealand-005",
  slug: "grand-newzealand-tour",
  path: "/packages/new zealand/grand-newzealand-tour",
  title: "Ultimate New Zealand Explorer",
  duration: "12 Nights 13 Days",
  route: "4N Auckland | 3N Queenstown | 2N Rotorua | 3N Christchurch",
  price: 449999,
  stars: 5,
  image: christchurch,
  categories: ["international", "luxury", "group-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= South Korea =================
{
  id: "southkorea-budget-001",
  slug: "southkorea-budget-trip",
  path: "/packages/south korea/southkorea-budget-trip",
  title: "Affordable Korea Escape",
  duration: "4 Nights 5 Days",
  route: "4N Seoul",
  price: 89999,
  stars: 2,
  image: seoul,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "transfers"]
},
{
  id: "southkorea-budget-002",
  slug: "southkorea-economy-tour",
  path: "/packages/south korea/southkorea-economy-tour",
  title: "Korea Saver Journey",
  duration: "6 Nights 7 Days",
  route: "3N Seoul | 3N Busan",
  price: 119999,
  stars: 3,
  image: busan,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "southkorea-001",
  slug: "seoul-short-trip",
  path: "/packages/south korea/seoul-short-trip",
  title: "Seoul City Escape",
  duration: "4 Nights 5 Days",
  route: "4N Seoul",
  price: 119999,
  stars: 4,
  image: seoul,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "southkorea-002",
  slug: "seoul-busan-tour",
  path: "/packages/south korea/seoul-busan-tour",
  title: "Korea Cultural Journey",
  duration: "6 Nights 7 Days",
  route: "3N Seoul | 3N Busan",
  price: 149999,
  stars: 4,
  image: busan,
  categories: ["international", "family-tour", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "southkorea-003",
  slug: "seoul-jeju-package",
  path: "/packages/south korea/seoul-jeju-package",
  title: "Korea Nature & Island Escape",
  duration: "7 Nights 8 Days",
  route: "4N Seoul | 3N Jeju Island",
  price: 179999,
  stars: 5,
  image: jejuisland,
  categories: ["international", "luxury", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "southkorea-004",
  slug: "southkorea-honeymoon-package",
  path: "/packages/south korea/southkorea-honeymoon-package",
  title: "Romantic Korea Escape",
  duration: "8 Nights 9 Days",
  route: "3N Seoul | 3N Jeju Island | 2N Busan",
  price: 219999,
  stars: 5,
  image: seoul,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "southkorea-005",
  slug: "grand-southkorea-tour",
  path: "/packages/south korea/grand-southkorea-tour",
  title: "Ultimate South Korea Experience",
  duration: "10 Nights 11 Days",
  route: "4N Seoul | 3N Busan | 3N Jeju Island",
  price: 289999,
  stars: 5,
  image: busan,
  categories: ["international", "luxury", "group-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Azerbaijan =================
{
  id: "azerbaijan-budget-001",
  slug: "azerbaijan-budget-trip",
  path: "/packages/azerbaijan/azerbaijan-budget-trip",
  title: "Affordable Azerbaijan Escape",
  duration: "4 Nights 5 Days",
  route: "4N Baku",
  price: 44999,
  stars: 2,
  image: baku,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "sightseeing", "transfers"]
},
{
  id: "azerbaijan-budget-002",
  slug: "azerbaijan-economy-tour",
  path: "/packages/azerbaijan/azerbaijan-economy-tour",
  title: "Azerbaijan Saver Journey",
  duration: "5 Nights 6 Days",
  route: "3N Baku | 2N Gabala",
  price: 59999,
  stars: 3,
  image: gabala,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "azerbaijan-001",
  slug: "baku-short-trip",
  path: "/packages/azerbaijan/baku-short-trip",
  title: "Baku City Escape",
  duration: "4 Nights 5 Days",
  route: "4N Baku",
  price: 59999,
  stars: 4,
  image: baku,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "azerbaijan-002",
  slug: "baku-gabala-tour",
  path: "/packages/azerbaijan/baku-gabala-tour",
  title: "Caspian Adventure Journey",
  duration: "5 Nights 6 Days",
  route: "3N Baku | 2N Gabala",
  price: 74999,
  stars: 4,
  image: gabala,
  categories: ["international", "family-tour", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "azerbaijan-003",
  slug: "azerbaijan-nature-package",
  path: "/packages/azerbaijan/azerbaijan-nature-package",
  title: "Mountains & Modernity Escape",
  duration: "6 Nights 7 Days",
  route: "3N Baku | 3N Gabala",
  price: 89999,
  stars: 5,
  image: gabala,
  categories: ["international", "luxury", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "azerbaijan-004",
  slug: "azerbaijan-honeymoon-package",
  path: "/packages/azerbaijan/azerbaijan-honeymoon-package",
  title: "Romantic Baku Retreat",
  duration: "7 Nights 8 Days",
  route: "4N Baku | 3N Gabala",
  price: 109999,
  stars: 5,
  image: baku,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "azerbaijan-005",
  slug: "grand-azerbaijan-tour",
  path: "/packages/azerbaijan/grand-azerbaijan-tour",
  title: "Ultimate Azerbaijan Explorer",
  duration: "8 Nights 9 Days",
  route: "4N Baku | 2N Gabala | 2N Shahdag",
  price: 139999,
  stars: 5,
  image: shahdag,
  categories: ["international", "luxury", "group-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
// ================= Georgia =================
{
  id: "georgia-budget-001",
  slug: "georgia-budget-trip",
  path: "/packages/georgia/georgia-budget-trip",
  title: "Affordable Georgia Escape",
  duration: "4 Nights 5 Days",
  route: "4N Tbilisi",
  price: 49999,
  stars: 2,
  image: tbilisi,
  categories: ["international", "budget-friendly", "popular"],
  includes: ["hotels", "sightseeing", "transfers"]
},
{
  id: "georgia-budget-002",
  slug: "georgia-economy-tour",
  path: "/packages/georgia/georgia-economy-tour",
  title: "Georgia Saver Journey",
  duration: "6 Nights 7 Days",
  route: "3N Tbilisi | 3N Batumi",
  price: 69999,
 stars: 3,
  image: batumi,
  categories: ["international", "budget-friendly", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "georgia-001",
  slug: "tbilisi-short-trip",
  path: "/packages/georgia/tbilisi-short-trip",
  title: "Tbilisi City Escape",
  duration: "4 Nights 5 Days",
  route: "4N Tbilisi",
  price: 64999,
  stars: 4,
 image: tbilisi,
  categories: ["international", "trending", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "georgia-002",
  slug: "tbilisi-kazbegi-tour",
  path: "/packages/georgia/tbilisi-kazbegi-tour",
  title: "Caucasus Mountain Journey",
  duration: "5 Nights 6 Days",
  route: "3N Tbilisi | 2N Kazbegi",
  price: 79999,
  stars: 4,
  image: kazbegi,
  categories: ["international", "family-tour", "popular"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "georgia-003",
  slug: "georgia-nature-package",
  path: "/packages/georgia/georgia-nature-package",
  title: "Nature & Heritage Escape",
  duration: "6 Nights 7 Days",
  route: "3N Tbilisi | 3N Batumi",
  price: 94999,
  stars: 5,
  image: batumi,
  categories: ["international", "luxury", "trending"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "georgia-004",
  slug: "georgia-honeymoon-package",
  path: "/packages/georgia/georgia-honeymoon-package",
  title: "Romantic Georgia Retreat",
  duration: "7 Nights 8 Days",
  route: "4N Tbilisi | 3N Batumi",
  price: 119999,
  stars: 5,
  image: tbilisi,
  categories: ["international", "honeymoon", "luxury"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
{
  id: "georgia-005",
  slug: "grand-georgia-tour",
  path: "/packages/georgia/grand-georgia-tour",
  title: "Ultimate Georgia Explorer",
  duration: "8 Nights 9 Days",
  route: "3N Tbilisi | 2N Kazbegi | 3N Batumi",
  price: 149999,
  stars: 5,
  image: kazbegi,
  categories: ["international", "luxury", "group-tour"],
  includes: ["hotels", "sightseeing", "transfers", "meals"]
},
];

export const packageDetails = [
  // ================= Himachal pradesh =================
{
  id: "himachalpradesh-001",
  slug: "shimla-short-trip",
  destination: "Himachalpradesh",
  title: "Himalayan Escape",
  duration: "2 Nights 3 Days",
  route: "2N Shimla",
  price: 6999,
  stars: 3,
  tags: ["🔥 Trending Himachal", "🏔️ Hill Station Escape"],
  rating: 4.7,

  images: [
    himachalpradesh,
    shimla,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Shimla",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Shimla Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "2 Nights Accommodation in Shimla",
    "Daily Breakfast",
    "Mall Road & Kufri Sightseeing",
    "All Transfers on Private Basis",
    "Driver Allowance & Toll Taxes"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "Personal Expenses",
    "Adventure Activities",
    "Anything not mentioned in inclusions"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Shimla",
      detail:
        "Arrival and transfer to hotel. Evening free for Mall Road exploration and leisure."
    },
    {
      day: 2,
      title: "Kufri Sightseeing",
      detail:
        "After breakfast proceed for Kufri sightseeing and local attractions."
    },
    {
      day: 3,
      title: "Departure",
      detail:
        "After breakfast check-out from hotel and proceed for return journey."
    }
  ],

  overview:
    "Enjoy a refreshing escape to Shimla with scenic mountain views, pleasant weather and famous attractions like Kufri and Mall Road."
},
{
  id: "himachalpradesh-002",
  slug: "manali-short-trip",
  destination: "himachalpradesh",
  title: "Snow & Serenity Getaway",
  duration: "2 Nights 3 Days",
  route: "2N Manali",
  price: 7499,
  stars: 3,
  tags: ["❄️ Snow Escape", "🏔️ Himachal Tours"],
  rating: 4.8,

  images: [
    manali,
   himachalpradesh
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Manali",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

   sightseeing: [
    {
      title: "Manali Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "2 Nights Accommodation in Manali",
    "Daily Breakfast & Dinner",
    "Solang Valley Excursion",
    "Local Sightseeing",
    "All Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "Rohtang Pass Charges",
    "Personal Expenses",
    "Anything not mentioned in inclusions"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Manali",
      detail:
        "Check-in at hotel and enjoy evening at leisure in Manali."
    },
    {
      day: 2,
      title: "Solang Valley Tour",
      detail:
        "Full-day excursion to Solang Valley for sightseeing and adventure activities."
    },
    {
      day: 3,
      title: "Departure",
      detail:
        "After breakfast proceed for return journey."
    }
  ],

  overview:
    "Experience the beauty of Manali with snow-capped mountains, adventure spots and scenic valleys."
},
{
  id: "himachalpradesh-003",
  slug: "shimla-kufri-retreat",
  destination: "himachalpradesh",
  title: "Scenic Himachal Retreat",
  duration: "3 Nights 4 Days",
  route: "2N Shimla | 1N Kufri",
  price: 9999,
  stars: 3,
  tags: ["🌲 Nature Escape", "🏔️ Family Tour"],
  rating: 4.7,

  images: [
    shimla,himachalpradesh
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Shimla",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Kufri",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Shimla Sightseeing"
    },
    {
      title: "Kufri Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast & Dinner",
    "Shimla & Kufri Sightseeing",
    "Private Transfers"
  ],

  exclusions: [
    "Airfare / Train Fare",
    "Personal Expenses",
    "Adventure Activities"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Shimla",
      detail:
        "Transfer to Shimla and check-in at hotel."
    },
    {
      day: 2,
      title: "Shimla Sightseeing",
      detail:
        "Visit Mall Road, Ridge and local attractions."
    },
    {
      day: 3,
      title: "Kufri Excursion",
      detail:
        "Proceed to Kufri and enjoy scenic beauty."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and return journey."
    }
  ],

  overview:
    "Perfect Himachal retreat covering Shimla and Kufri with beautiful mountain landscapes and sightseeing."
},
{
  id: "himachalpradesh-004",
  slug: "manali-solang-trip",
  destination: "himachalpradesh",
  title: "Snow Trails of Himachal",
  duration: "3 Nights 4 Days",
  route: "2N Manali | Solang Valley",
  price: 10999,
  stars: 3,
  tags: ["❄️ Adventure Escape", "🏔️ Snow Valley Tour"],
  rating: 4.8,

  images: [
    manali,
    solangvalley,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Manali",
      nights: "3 Nights",
      type: "3 Star Hotel"
    }
  ],

   sightseeing: [
    {
      title: "Shimla Sightseeing"
    },
    {
      title: "Solang Valley Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "3 Nights Accommodation in Manali",
    "Daily Breakfast & Dinner",
    "Solang Valley Excursion",
    "Local Sightseeing",
    "All Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Fare",
    "Rohtang Pass Charges",
    "Adventure Activities",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Manali",
      detail:
        "Arrival and transfer to hotel. Evening free for leisure."
    },
    {
      day: 2,
      title: "Solang Valley Excursion",
      detail:
        "Enjoy full-day Solang Valley sightseeing and adventure activities."
    },
    {
      day: 3,
      title: "Local Manali Tour",
      detail:
        "Visit Hadimba Temple, Mall Road and nearby attractions."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Explore snowy mountains and scenic valleys of Manali with exciting sightseeing and adventure experiences."
},
{
  id: "himachalpradesh-005",
  slug: "shimla-manali-delight",
  destination: "himachalpradesh",
  title: "Enchanting Shimla Manali",
  duration: "4 Nights 5 Days",
  route: "2N Shimla | 2N Manali",
  price: 13999,
  stars: 3,
  tags: ["💕 Honeymoon Escape", "🏔️ Best Seller"],
  rating: 4.9,

  images: [
    shimla,
    manali,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Shimla",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Manali",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

   sightseeing: [
    {
      title: "Shimla Sightseeing"
    },
    {
      title: "Manali Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast & Dinner",
    "Shimla & Manali Sightseeing",
    "Private Transfers",
    "Driver Allowance & Toll Taxes"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "Rohtang Pass Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Shimla",
      detail:
        "Arrival and transfer to hotel in Shimla."
    },
    {
      day: 2,
      title: "Shimla Sightseeing",
      detail:
        "Visit Kufri, Mall Road and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Manali",
      detail:
        "Scenic drive from Shimla to Manali."
    },
    {
      day: 4,
      title: "Manali Excursion",
      detail:
        "Explore Solang Valley and local sightseeing."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "A perfect Himachal package covering Shimla and Manali with mountain views, adventure and romantic vibes."
},
{
  id: "himachalpradesh-006",
  slug: "shimla-manali-experience",
  destination: "himachalpradesh",
  title: "Best of Himachal",
  duration: "5 Nights 6 Days",
  route: "2N Shimla | 3N Manali",
  price: 15999,
  stars: 3,
  tags: ["🌄 Family Tour", "🏔️ Popular Himachal"],
  rating: 4.8,

  images: [
    shimla,
    manali,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Shimla",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Manali",
      nights: "3 Nights",
      type: "3 Star Hotel"
    }
  ],

   sightseeing: [
    {
      title: "Shimla Sightseeing"
    },
    {
      title: "Manali Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast & Dinner",
    "Shimla & Manali Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "Adventure Activities",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Shimla",
      detail:
        "Transfer and hotel check-in."
    },
    {
      day: 2,
      title: "Shimla Kufri Tour",
      detail:
        "Full-day sightseeing in Shimla & Kufri."
    },
    {
      day: 3,
      title: "Transfer to Manali",
      detail:
        "Drive to Manali with scenic mountain views."
    },
    {
      day: 4,
      title: "Solang Valley Excursion",
      detail:
        "Enjoy snow and adventure activities."
    },
    {
      day: 5,
      title: "Local Manali Sightseeing",
      detail:
        "Visit temples and Mall Road."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Proceed for return journey."
    }
  ],

  overview:
    "Experience the best attractions of Shimla and Manali with scenic beauty, adventure and comfortable stays."
},
{
  id: "himachalpradesh-007",
  slug: "dharamshala-dalhousie-trip",
  destination: "himachalpradesh",
  title: "Valleys of Himachal",
  duration: "5 Nights 6 Days",
  route: "2N Dharamshala | 3N Dalhousie",
  price: 14999,
  stars: 3,
  tags: ["🌲 Nature Escape", "🏔️ Hill Retreat"],
  rating: 4.7,

  images: [
    dharmshala,
    himachalpradesh,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Dharamshala",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Dalhousie",
      nights: "3 Nights",
      type: "3 Star Hotel"
    }
  ],

   sightseeing: [
    {
      title: "Dharamshala Sightseeing"
    },
    {
      title: "Dalhousie Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast & Dinner",
    "Dharamshala & Dalhousie Sightseeing",
    "Khajjiar Excursion",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Fare",
    "Adventure Activities",
    "Personal Expenses",
    "Anything not mentioned in inclusions"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Dharamshala",
      detail:
        "Arrival and transfer to hotel. Evening at leisure."
    },
    {
      day: 2,
      title: "McLeodganj Tour",
      detail:
        "Visit Dalai Lama Temple, Bhagsu Waterfall and local markets."
    },
    {
      day: 3,
      title: "Transfer to Dalhousie",
      detail:
        "Scenic drive to Dalhousie and hotel check-in."
    },
    {
      day: 4,
      title: "Khajjiar Excursion",
      detail:
        "Full-day excursion to Khajjiar known as Mini Switzerland."
    },
    {
      day: 5,
      title: "Dalhousie Sightseeing",
      detail:
        "Explore local attractions and markets."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Explore peaceful valleys, Tibetan culture and scenic mountain landscapes with this Dharamshala and Dalhousie package."
},
{
  id: "himachalpradesh-008",
  slug: "shimla-manali-kasol-tour",
  destination: "himachalpradesh",
  title: "Ultimate Himachal Escape",
  duration: "6 Nights 7 Days",
  route: "2N Shimla | 3N Manali | 1N Kasol",
  price: 18999,
  stars: 3,
  tags: ["🏕️ Adventure Tour", "❄️ Best Seller"],
  rating: 4.9,

  images: [
    shimla,
    manali,
    kasol,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Shimla",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Manali",
      nights: "3 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Kasol",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

   sightseeing: [
    {
      title: "Manali Sightseeing"
    },
    {
      title: "Kasol Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast & Dinner",
    "Shimla, Manali & Kasol Sightseeing",
    "Private Transfers Included",
    "Driver Allowance & Toll Taxes"
  ],

  exclusions: [
    "Airfare / Train Fare",
    "Adventure Activities",
    "Rohtang Pass Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Shimla",
      detail:
        "Transfer to Shimla hotel and leisure time."
    },
    {
      day: 2,
      title: "Shimla & Kufri Tour",
      detail:
        "Visit Kufri, Ridge and Mall Road."
    },
    {
      day: 3,
      title: "Transfer to Manali",
      detail:
        "Scenic drive from Shimla to Manali."
    },
    {
      day: 4,
      title: "Solang Valley Excursion",
      detail:
        "Adventure activities and sightseeing."
    },
    {
      day: 5,
      title: "Local Manali Tour",
      detail:
        "Explore temples and local attractions."
    },
    {
      day: 6,
      title: "Transfer to Kasol",
      detail:
        "Enjoy scenic Parvati Valley and Kasol vibes."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Return journey after breakfast."
    }
  ],

  overview:
    "An adventurous Himachal tour covering Shimla, Manali and Kasol with mountain scenery, snow activities and peaceful valleys."
},
{
  id: "himachalpradesh-009",
  slug: "dharamshala-dalhousie-khajjiar-tour",
  destination: "himachalpradesh",
  title: "Heavenly Himachal Tour",
  duration: "6 Nights 7 Days",
  route: "2N Dharamshala | 2N Dalhousie | 2N Khajjiar",
  price: 19999,
  stars: 3,
  tags: ["🌄 Luxury Escape", "🏔️ Scenic Himachal"],
  rating: 4.8,

  images: [
    dharmshala,
    himachalpradesh,
    khajjar,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Dharamshala",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Dalhousie",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Khajjiar",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

   sightseeing: [
    {
      title: "Dharamshala Sightseeing"
    },
    {
      title: "Dalhousie Sightseeing"
    },
    {
      title: "Khajjiar Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast & Dinner",
    "Dharamshala, Dalhousie & Khajjiar Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "Personal Expenses",
    "Adventure Activities"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Dharamshala",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "McLeodganj Sightseeing",
      detail:
        "Explore temples, waterfalls and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Dalhousie",
      detail:
        "Drive through scenic mountain roads."
    },
    {
      day: 4,
      title: "Dalhousie Tour",
      detail:
        "Visit churches and local attractions."
    },
    {
      day: 5,
      title: "Khajjiar Excursion",
      detail:
        "Enjoy meadows and scenic landscapes."
    },
    {
      day: 6,
      title: "Leisure Day",
      detail:
        "Relax and explore local surroundings."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Discover the scenic beauty of Dharamshala, Dalhousie and Khajjiar with peaceful valleys and breathtaking mountain landscapes."
},
// ================= Uttrakhand =================
{
  id: "uttrakhand-001",
  slug: "nainital-short-trip",
  destination: "uttrakhand",
  title: "Lake City Escape",
  duration: "2 Nights 3 Days",
  route: "2N Nainital",
  price: 6999,
  stars: 3,
  tags: ["🏞️ Lake Escape", "🌲 Nature Retreat"],
  rating: 4.7,

  images: [
    nainital,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Nainital",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Nainital Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "2 Nights Accommodation",
    "Daily Breakfast Included",
    "Nainital Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "Boating Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Nainital",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Nainital Sightseeing",
      detail:
        "Visit lakes, viewpoints and local attractions."
    },
    {
      day: 3,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Enjoy a peaceful getaway to Nainital with lakes, mountain views and pleasant weather."
},
{
  id: "uttrakhand-002",
  slug: "mussoorie-short-trip",
  destination: "uttrakhand",
  title: "Queen of Hills Retreat",
  duration: "2 Nights 3 Days",
  route: "2N Mussoorie",
  price: 7499,
  stars: 3,
  tags: ["🏔️ Hill Escape", "🌲 Weekend Retreat"],
  rating: 4.8,

  images: [
    mussorie,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Mussoorie",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Mussoorie Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "2 Nights Accommodation",
    "Daily Breakfast Included",
    "Mussoorie Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "Adventure Activities",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Mussoorie",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Mussoorie Sightseeing",
      detail:
        "Visit waterfalls, viewpoints and Mall Road."
    },
    {
      day: 3,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Relax in the Queen of Hills with scenic mountain views and peaceful surroundings."
},
{
  id: "uttrakhand-003",
  slug: "nainital-bhimtal-tour",
  destination: "uttrakhand",
  title: "Lakes & Valleys Tour",
  duration: "3 Nights 4 Days",
  route: "2N Nainital | 1N Bhimtal",
  price: 9999,
  stars: 3,
  tags: ["🏞️ Lake Tour", "🌄 Nature Escape"],
  rating: 4.8,

  images: [
    nainital,
    bhimtal,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Nainital",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Bhimtal",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Nainital Sightseeing"
    },
    {
      title: "Bhimtal Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Nainital & Bhimtal Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Boating Charges",
    "Personal Expenses",
    "Anything not mentioned in inclusions"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Nainital",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Nainital Sightseeing",
      detail:
        "Explore lakes and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Bhimtal",
      detail:
        "Enjoy scenic drive and sightseeing."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Discover beautiful lakes and peaceful valleys with this relaxing Uttarakhand getaway."
},
{
  id: "uttrakhand-004",
  slug: "mussoorie-dhanaulti-trip",
  destination: "uttrakhand",
  title: "Scenic Hills Escape",
  duration: "3 Nights 4 Days",
  route: "2N Mussoorie | 1N Dhanaulti",
  price: 10499,
  stars: 3,
  tags: ["🌲 Nature Escape", "🏔️ Hills Retreat"],
  rating: 4.7,

  images: [
    mussorie,
    dhanaulti,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Mussoorie",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Dhanaulti",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Mussoorie Sightseeing"
    },
    {
      title: "Dhanaulti Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Mussoorie & Dhanaulti Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Adventure Activities",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Mussoorie",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Mussoorie Sightseeing",
      detail:
        "Visit waterfalls, viewpoints and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Dhanaulti",
      detail:
        "Scenic drive and nature sightseeing."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience peaceful hill stations and scenic mountain beauty with Mussoorie and Dhanaulti."
},
{
  id: "uttrakhand-005",
  slug: "mussoorie-rishikesh-haridwar-tour",
  destination: "uttrakhand",
  title: "Spiritual & Hills Journey",
  duration: "4 Nights 5 Days",
  route: "2N Mussoorie | 1N Rishikesh | 1N Haridwar",
  price: 12999,
  stars: 3,
  tags: ["🛕 Spiritual Escape", "🏔️ Hills & Ganga Tour"],
  rating: 4.8,

  images: [
    mussorie,
    rishikesh,
    haridwar,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Mussoorie",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Rishikesh",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Haridwar",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Mussoorie Sightseeing"
    },
    {
      title: "Rishikesh Sightseeing"
    },
    {
      title: "Haridwar Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Mussoorie, Rishikesh & Haridwar Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Adventure Activities",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Mussoorie",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Mussoorie Sightseeing",
      detail:
        "Visit local attractions and scenic viewpoints."
    },
    {
      day: 3,
      title: "Transfer to Rishikesh",
      detail:
        "Enjoy Ganga Aarti and local sightseeing."
    },
    {
      day: 4,
      title: "Transfer to Haridwar",
      detail:
        "Temple visits and spiritual exploration."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "A perfect mix of spiritual experiences and scenic hill station beauty across Uttarakhand."
},
{
  id: "uttrakhand-006",
  slug: "nainital-ranikhet-jimcorbett-tour",
  destination: "uttrakhand",
  title: "Wildlife & Hills Retreat",
  duration: "5 Nights 6 Days",
  route: "2N Nainital | 1N Ranikhet | 2N Jim Corbett",
  price: 15999,
  stars: 3,
  tags: ["🌲 Nature Escape", "🦁 Wildlife Adventure"],
  rating: 4.8,

  images: [
    nainital,
    ranikhet,
    jimcorbett,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Nainital",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Ranikhet",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Jim Corbett",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Nainital Sightseeing"
    },
    {
      title: "Ranikhet Sightseeing"
    },
    {
      title: "Jim Corbett Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Nainital, Ranikhet & Jim Corbett Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "Safari Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Nainital",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Nainital Sightseeing",
      detail:
        "Visit lakes, viewpoints and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Ranikhet",
      detail:
        "Scenic drive through Kumaon hills."
    },
    {
      day: 4,
      title: "Transfer to Jim Corbett",
      detail:
        "Arrival and leisure at wildlife resort."
    },
    {
      day: 5,
      title: "Jim Corbett Safari",
      detail:
        "Enjoy jungle safari and nature exploration."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience lakes, hills and wildlife together with this Uttarakhand getaway covering Nainital, Ranikhet and Jim Corbett."
},
{
  id: "uttrakhand-007",
  slug: "mussoorie-rishikesh-corbett-tour",
  destination: "uttrakhand",
  title: "Adventure Uttarakhand Tour",
  duration: "6 Nights 7 Days",
  route: "2N Mussoorie | 2N Rishikesh | 2N Jim Corbett",
  price: 18999,
  stars: 3,
  tags: ["🏕️ Adventure Escape", "🌊 River & Wildlife"],
  rating: 4.9,

  images: [
    mussorie,
    rishikesh,
    jimcorbett,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Mussoorie",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Rishikesh",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Jim Corbett",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Mussoorie Sightseeing"
    },
    {
      title: "Rishikesh Sightseeing"
    },
    {
      title: "Jim Corbett Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Mussoorie, Rishikesh & Jim Corbett Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "River Rafting Charges",
    "Safari Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Mussoorie",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Mussoorie Sightseeing",
      detail:
        "Visit waterfalls, viewpoints and Mall Road."
    },
    {
      day: 3,
      title: "Transfer to Rishikesh",
      detail:
        "Drive to Rishikesh and enjoy Ganga Aarti."
    },
    {
      day: 4,
      title: "Adventure Activities",
      detail:
        "Enjoy rafting and local sightseeing."
    },
    {
      day: 5,
      title: "Transfer to Jim Corbett",
      detail:
        "Arrival at wildlife resort."
    },
    {
      day: 6,
      title: "Corbett Safari",
      detail:
        "Explore jungle safari and wildlife."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Perfect adventure getaway covering Mussoorie hills, Rishikesh river activities and Jim Corbett wildlife experience."
},
{
  id: "uttrakhand-008",
  slug: "nainital-kausani-almora-tour",
  destination: "uttrakhand",
  title: "Kumaon Hills Escape",
  duration: "6 Nights 7 Days",
  route: "2N Nainital | 2N Kausani | 2N Almora",
  price: 19499,
  stars: 3,
  tags: ["🏔️ Hill Escape", "🌲 Nature Retreat"],
  rating: 4.8,

  images: [
    nainital,
    kausani,
    almora,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Nainital",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Kausani",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Almora",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Nainital Sightseeing"
    },
    {
      title: "Kausani Sightseeing"
    },
    {
      title: "Almora Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Nainital, Kausani & Almora Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "Personal Expenses",
    "Adventure Activities"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Nainital",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Nainital Sightseeing",
      detail:
        "Visit lakes and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Kausani",
      detail:
        "Scenic drive through Kumaon hills."
    },
    {
      day: 4,
      title: "Kausani Tour",
      detail:
        "Enjoy Himalayan sunrise and tea gardens."
    },
    {
      day: 5,
      title: "Transfer to Almora",
      detail:
        "Arrival and local sightseeing."
    },
    {
      day: 6,
      title: "Almora Exploration",
      detail:
        "Visit temples and scenic viewpoints."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Discover the beauty of Kumaon hills with peaceful landscapes, lakes and Himalayan mountain views."
},
// ================= Goa =================
{
  id: "goa-001",
  slug: "north-goa-short-trip",
  destination: "goa",
  title: "North Goa Beach Escape",
  duration: "2 Nights 3 Days",
  route: "2N North Goa",
  price: 6999,
  stars: 3,
  tags: ["🏖️ Beach Escape", "🌴 Goa Vibes"],
  rating: 4.7,

  images: [
    northgoa
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "North Goa",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "North Goa Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "2 Nights Accommodation",
    "Daily Breakfast Included",
    "North Goa Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "Water Sports Activities",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Goa",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "North Goa Sightseeing",
      detail:
        "Visit beaches, forts and popular attractions."
    },
    {
      day: 3,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Enjoy vibrant beaches, nightlife and scenic coastal vibes with this North Goa getaway."
},
{
  id: "goa-002",
  slug: "south-goa-short-trip",
  destination: "goa",
  title: "South Goa Serenity",
  duration: "2 Nights 3 Days",
  route: "2N South Goa",
  price: 7499,
  stars: 3,
  tags: ["🌊 Relaxing Escape", "🏖️ Beach Retreat"],
  rating: 4.8,
images: [
    southgoa
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "South Goa",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "South Goa Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "2 Nights Accommodation",
    "Daily Breakfast Included",
    "South Goa Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "Personal Expenses",
    "Water Sports Activities"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in South Goa",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "South Goa Sightseeing",
      detail:
        "Explore beaches, churches and peaceful attractions."
    },
    {
      day: 3,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Relax and unwind with peaceful beaches and scenic coastal beauty in South Goa."
},
{
  id: "goa-003",
  slug: "north-south-goa-tour",
  destination: "goa",
  title: "Classic Goa Getaway",
  duration: "3 Nights 4 Days",
  route: "2N North Goa | 1N South Goa",
  price: 10999,
  stars: 3,
  tags: ["🌴 Goa Escape", "🏖️ Family Tour"],
  rating: 4.8,

  images: [
    northgoa,
    southgoa,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "North Goa",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "South Goa",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "North Goa Sightseeing"
    },
    {
      title: "South Goa Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "North & South Goa Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "Water Sports Activities",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Goa",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "North Goa Tour",
      detail:
        "Visit beaches and popular attractions."
    },
    {
      day: 3,
      title: "South Goa Tour",
      detail:
        "Explore churches and scenic coastal areas."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Discover the perfect mix of lively beaches and peaceful coastal beauty with this Goa package."
},
{
  id: "goa-004",
  slug: "full-goa-experience",
  destination: "goa",
  title: "Ultimate Goa Experience",
  duration: "4 Nights 5 Days",
  route: "2N North Goa | 2N South Goa",
  price: 14999,
  stars: 3,
  tags: ["🏖️ Best Seller", "🌴 Beach Escape"],
  rating: 4.9,

   images: [
    northgoa,
    southgoa,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "North Goa",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "South Goa",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "North Goa Sightseeing"
    },
    {
      title: "South Goa Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "North & South Goa Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "Adventure Activities",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Goa",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "North Goa Tour",
      detail:
        "Explore beaches, forts and nightlife spots."
    },
    {
      day: 3,
      title: "Transfer to South Goa",
      detail:
        "Enjoy scenic coastal drive and leisure."
    },
    {
      day: 4,
      title: "South Goa Sightseeing",
      detail:
        "Visit churches, beaches and local attractions."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience the best beaches, nightlife and coastal charm with this complete Goa vacation."
},
{
  id: "goa-005",
  slug: "goa-dudhsagar-cruise-tour",
  destination: "goa",
  title: "Goa Adventure & Cruise",
  duration: "5 Nights 6 Days",
  route: "2N North Goa | 2N South Goa | Dudhsagar Trip",
  price: 17999,
  stars: 3,
  tags: ["🚤 Adventure Tour", "🌊 Cruise Experience"],
  rating: 4.9,

 images: [
    northgoa,
    southgoa,
    dudhsagar
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "North Goa",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "South Goa",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Dudhsagar",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "North Goa Sightseeing"
    },
    {
      title: "South Goa Sightseeing"
    },
    {
      title: "Dudhsagar Waterfall Tour"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "North & South Goa Sightseeing",
    "Dudhsagar Waterfall Excursion",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "Cruise Charges",
    "Adventure Activities",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Goa",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "North Goa Tour",
      detail:
        "Visit beaches and popular attractions."
    },
    {
      day: 3,
      title: "South Goa Tour",
      detail:
        "Explore churches and peaceful beaches."
    },
    {
      day: 4,
      title: "Dudhsagar Excursion",
      detail:
        "Enjoy waterfall sightseeing and nature views."
    },
    {
      day: 5,
      title: "Cruise Experience",
      detail:
        "Enjoy evening cruise and leisure activities."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Enjoy beaches, waterfalls and cruise experiences with this adventurous Goa holiday package."
},
// ================= Rajasthan =================
{
  id: "rajasthan-001",
  slug: "jaipur-short-trip",
  destination: "rajasthan",
  title: "Pink City Escape",
  duration: "2 Nights 3 Days",
  route: "2N Jaipur",
  price: 6999,
  stars: 3,
  tags: ["🏰 Heritage Escape", "🌸 Pink City Tour"],
  rating: 4.7,

  images: [
    jaipur
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Jaipur",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Jaipur Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "2 Nights Accommodation",
    "Daily Breakfast Included",
    "Jaipur Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare / Train Tickets",
    "Monument Entry Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Jaipur",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Jaipur Sightseeing",
      detail:
        "Visit forts, palaces and local attractions."
    },
    {
      day: 3,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Explore the royal charm of Jaipur with forts, palaces and colorful markets."
},
{
  id: "rajasthan-002",
  slug: "udaipur-short-trip",
  destination: "rajasthan",
  title: "City of Lakes Retreat",
  duration: "2 Nights 3 Days",
  route: "2N Udaipur",
  price: 7499,
  stars: 3,
  tags: ["🏞️ Lake City Escape", "💕 Romantic Retreat"],
  rating: 4.8,

  images: [
    udaipur
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Udaipur",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Udaipur Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "2 Nights Accommodation",
    "Daily Breakfast Included",
    "Udaipur Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Boat Ride Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Udaipur",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Udaipur Sightseeing",
      detail:
        "Visit lakes, palaces and local attractions."
    },
    {
      day: 3,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience the romantic charm and beautiful lakes of Udaipur with this relaxing getaway."
},
{
  id: "rajasthan-003",
  slug: "jaipur-pushkar-tour",
  destination: "rajasthan",
  title: "Royal Rajasthan Journey",
  duration: "3 Nights 4 Days",
  route: "2N Jaipur | 1N Pushkar",
  price: 10999,
  stars: 3,
  tags: ["🏰 Royal Escape", "🛕 Heritage Tour"],
  rating: 4.8,

  images: [
    jaipur,
    pushkar
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Jaipur",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Pushkar",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Jaipur Sightseeing"
    },
    {
      title: "Pushkar Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Jaipur & Pushkar Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Camel Ride Charges",
    "Monument Entry Fees",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Jaipur",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Jaipur Tour",
      detail:
        "Visit forts, palaces and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Pushkar",
      detail:
        "Visit Pushkar Lake and Brahma Temple."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Explore royal palaces and spiritual heritage with this Jaipur and Pushkar package."
},
{
  id: "rajasthan-004",
  slug: "udaipur-mountabu-tour",
  destination: "rajasthan",
  title: "Lakes & Hills Escape",
  duration: "3 Nights 4 Days",
  route: "2N Udaipur | 1N Mount Abu",
  price: 11499,
  stars: 3,
  tags: ["🏞️ Lake Escape", "🏔️ Hill Retreat"],
  rating: 4.8,

  images: [
    udaipur,
    mountabu
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Udaipur",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Mount Abu",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Udaipur Sightseeing"
    },
    {
      title: "Mount Abu Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Udaipur & Mount Abu Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Boat Ride Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Udaipur",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Udaipur Sightseeing",
      detail:
        "Visit lakes, palaces and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Mount Abu",
      detail:
        "Scenic drive and local sightseeing."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Enjoy the beauty of lakes and hills with this relaxing Rajasthan getaway."
},
{
  id: "rajasthan-005",
  slug: "jaipur-udaipur-tour",
  destination: "rajasthan",
  title: "Royal Rajasthan Delight",
  duration: "4 Nights 5 Days",
  route: "2N Jaipur | 2N Udaipur",
  price: 14999,
  stars: 3,
  tags: ["🏰 Heritage Tour", "✨ Best Seller"],
  rating: 4.9,

  images: [
    jaipur,
    udaipur
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Jaipur",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Udaipur",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Jaipur Sightseeing"
    },
    {
      title: "Udaipur Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Jaipur & Udaipur Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Monument Entry Charges",
    "Boat Ride Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Jaipur",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Jaipur Tour",
      detail:
        "Visit forts, palaces and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Udaipur",
      detail:
        "Scenic drive and leisure time."
    },
    {
      day: 4,
      title: "Udaipur Tour",
      detail:
        "Explore lakes and city attractions."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Discover royal forts, colorful culture and scenic lakes with this Rajasthan tour."
},
{
  id: "rajasthan-006",
  slug: "jodhpur-jaisalmer-tour",
  destination: "rajasthan",
  title: "Desert Kingdom Tour",
  duration: "4 Nights 5 Days",
  route: "2N Jodhpur | 2N Jaisalmer",
  price: 15999,
  stars: 3,
  tags: ["🏜️ Desert Escape", "🐪 Royal Rajasthan"],
  rating: 4.8,

  images: [
    jodhpur,
    jaislmer
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Jodhpur",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Jaisalmer",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Jodhpur Sightseeing"
    },
    {
      title: "Jaisalmer Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Jodhpur & Jaisalmer Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Camel Safari Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Jodhpur",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Jodhpur Sightseeing",
      detail:
        "Visit forts, palaces and markets."
    },
    {
      day: 3,
      title: "Transfer to Jaisalmer",
      detail:
        "Drive through desert landscapes."
    },
    {
      day: 4,
      title: "Jaisalmer Tour",
      detail:
        "Explore desert attractions and local culture."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience royal forts, golden deserts and vibrant culture with this Rajasthan tour."
},
{
  id: "rajasthan-007",
  slug: "jaipur-udaipur-mountabu-tour",
  destination: "rajasthan",
  title: "Complete Rajasthan Escape",
  duration: "5 Nights 6 Days",
  route: "2N Jaipur | 2N Udaipur | 1N Mount Abu",
  price: 18999,
  stars: 3,
  tags: ["🏰 Royal Escape", "🌄 Hills & Lakes"],
  rating: 4.9,

  images: [
    jaipur,
    udaipur,
    mountabu
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Jaipur",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Udaipur",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Mount Abu",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Jaipur Sightseeing"
    },
    {
      title: "Udaipur Sightseeing"
    },
    {
      title: "Mount Abu Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Jaipur, Udaipur & Mount Abu Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Boat Ride Charges",
    "Monument Entry Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Jaipur",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Jaipur Sightseeing",
      detail:
        "Visit forts, palaces and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Udaipur",
      detail:
        "Scenic drive and leisure time."
    },
    {
      day: 4,
      title: "Udaipur Sightseeing",
      detail:
        "Explore lakes and city attractions."
    },
    {
      day: 5,
      title: "Transfer to Mount Abu",
      detail:
        "Enjoy scenic hill station views."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Discover royal heritage, scenic lakes and peaceful hills with this complete Rajasthan package."
},
{
  id: "rajasthan-008",
  slug: "golden-triangle-rajasthan-tour",
  destination: "rajasthan",
  title: "Golden Triangle Rajasthan",
  duration: "6 Nights 7 Days",
  route: "2N Jaipur | 2N Jodhpur | 2N Udaipur",
  price: 22999,
  stars: 3,
  tags: ["✨ Premium Rajasthan", "🏰 Royal Heritage"],
  rating: 4.9,

  images: [
    jaipur,
    jodhpur,
    udaipur
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Jaipur",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Jodhpur",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Udaipur",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Jaipur Sightseeing"
    },
    {
      title: "Jodhpur Sightseeing"
    },
    {
      title: "Udaipur Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Jaipur, Jodhpur & Udaipur Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Monument Entry Charges",
    "Boat Ride Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Jaipur",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Jaipur Tour",
      detail:
        "Explore forts and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Jodhpur",
      detail:
        "Scenic drive through Rajasthan landscapes."
    },
    {
      day: 4,
      title: "Jodhpur Sightseeing",
      detail:
        "Visit forts, palaces and local markets."
    },
    {
      day: 5,
      title: "Transfer to Udaipur",
      detail:
        "Drive to the city of lakes."
    },
    {
      day: 6,
      title: "Udaipur Tour",
      detail:
        "Explore lakes and heritage attractions."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Explore the royal heritage, forts and scenic lakes of Rajasthan with this premium tour package."
},
{
  id: "rajasthan-009",
  slug: "udaipur-jodhpur-mountabu-tour",
  destination: "rajasthan",
  title: "Majestic Rajasthan Journey",
  duration: "6 Nights 7 Days",
  route: "2N Udaipur | 2N Jodhpur | 2N Mount Abu",
  price: 21999,
  stars: 3,
  tags: ["🏜️ Heritage Escape", "🏔️ Scenic Rajasthan"],
  rating: 4.8,

  images: [
    udaipur,
    jodhpur,
    mountabu
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Udaipur",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Jodhpur",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Mount Abu",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Udaipur Sightseeing"
    },
    {
      title: "Jodhpur Sightseeing"
    },
    {
      title: "Mount Abu Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Udaipur, Jodhpur & Mount Abu Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Boat Ride Charges",
    "Monument Entry Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Udaipur",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Udaipur Tour",
      detail:
        "Visit lakes and heritage attractions."
    },
    {
      day: 3,
      title: "Transfer to Jodhpur",
      detail:
        "Drive through scenic Rajasthan roads."
    },
    {
      day: 4,
      title: "Jodhpur Sightseeing",
      detail:
        "Explore forts and local markets."
    },
    {
      day: 5,
      title: "Transfer to Mount Abu",
      detail:
        "Enjoy scenic hill station journey."
    },
    {
      day: 6,
      title: "Mount Abu Tour",
      detail:
        "Visit temples, lakes and viewpoints."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience royal heritage, scenic lakes and peaceful hills with this Rajasthan journey."
},
// ================= Tamil Nadu =================
{
  id: "tamilnadu-001",
  slug: "ooty-short-trip",
  destination: "tamilnadu",
  title: "Ooty Hill Escape",
  duration: "2 Nights 3 Days",
  route: "2N Ooty",
  price: 7499,
  stars: 3,
  tags: ["🏔️ Hill Retreat", "🌿 Nature Escape"],
  rating: 4.7,

  images: [
    ooty
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Ooty",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Ooty Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "2 Nights Accommodation",
    "Daily Breakfast Included",
    "Ooty Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Toy Train Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Ooty",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Ooty Sightseeing",
      detail:
        "Visit lakes, gardens and viewpoints."
    },
    {
      day: 3,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Enjoy the peaceful beauty and cool climate of Ooty with scenic hill views and nature attractions."
},
{
  id: "tamilnadu-002",
  slug: "kodaikanal-short-trip",
  destination: "tamilnadu",
  title: "Princess of Hills Retreat",
  duration: "2 Nights 3 Days",
  route: "2N Kodaikanal",
  price: 7999,
  stars: 3,
  tags: ["🌄 Hill Escape", "💕 Romantic Retreat"],
  rating: 4.8,

  images: [
    kodaikanal
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Kodaikanal",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Kodaikanal Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "2 Nights Accommodation",
    "Daily Breakfast Included",
    "Kodaikanal Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Boating Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Kodaikanal",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Kodaikanal Tour",
      detail:
        "Visit lakes, waterfalls and viewpoints."
    },
    {
      day: 3,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Relax amidst misty hills, lakes and beautiful landscapes with this Kodaikanal getaway."
},
{
  id: "tamilnadu-003",
  slug: "ooty-coonoor-tour",
  destination: "tamilnadu",
  title: "Nilgiri Hills Escape",
  duration: "3 Nights 4 Days",
  route: "2N Ooty | 1N Coonoor",
  price: 10999,
  stars: 3,
  tags: ["🌿 Nature Tour", "🚂 Nilgiri Experience"],
  rating: 4.8,

  images: [
    ooty,
    cooner
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Ooty",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Coonoor",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Ooty Sightseeing"
    },
    {
      title: "Coonoor Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Ooty & Coonoor Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Toy Train Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Ooty",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Ooty Tour",
      detail:
        "Explore lakes, gardens and viewpoints."
    },
    {
      day: 3,
      title: "Transfer to Coonoor",
      detail:
        "Enjoy scenic Nilgiri mountain views."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Explore the scenic beauty of Ooty and Coonoor with hills, tea gardens and peaceful surroundings."
},
{
  id: "tamilnadu-004",
  slug: "kodaikanal-madurai-tour",
  destination: "tamilnadu",
  title: "Hills & Heritage Journey",
  duration: "3 Nights 4 Days",
  route: "2N Kodaikanal | 1N Madurai",
  price: 11499,
  stars: 3,
  tags: ["🏔️ Hills Escape", "🛕 Heritage Tour"],
  rating: 4.8,

  images: [
    kodaikanal,
    madurai
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Kodaikanal",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Madurai",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Kodaikanal Sightseeing"
    },
    {
      title: "Madurai Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Kodaikanal & Madurai Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Temple Entry Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Kodaikanal",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Kodaikanal Tour",
      detail:
        "Visit lakes, waterfalls and viewpoints."
    },
    {
      day: 3,
      title: "Transfer to Madurai",
      detail:
        "Explore heritage temples and local attractions."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Enjoy misty hills and cultural heritage with this Kodaikanal and Madurai package."
},
{
  id: "tamilnadu-005",
  slug: "chennai-mahabalipuram-pondicherry-tour",
  destination: "tamilnadu",
  title: "Coastal Tamil Nadu Escape",
  duration: "4 Nights 5 Days",
  route: "2N Chennai | 1N Mahabalipuram | 1N Pondicherry",
  price: 14999,
  stars: 3,
  tags: ["🌊 Coastal Escape", "🏖️ Beach Retreat"],
  rating: 4.9,

  images: [
   chennai,
   mahabalipuram,
   pondicherry
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Chennai",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Mahabalipuram",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Pondicherry",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Chennai Sightseeing"
    },
    {
      title: "Mahabalipuram Sightseeing"
    },
    {
      title: "Pondicherry Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Chennai, Mahabalipuram & Pondicherry Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Beach Activities",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Chennai",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Chennai Tour",
      detail:
        "Visit temples, beaches and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Mahabalipuram",
      detail:
        "Explore heritage monuments and beaches."
    },
    {
      day: 4,
      title: "Transfer to Pondicherry",
      detail:
        "Enjoy French colonial streets and beachside vibes."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Discover beaches, heritage monuments and coastal beauty with this Tamil Nadu getaway."
},
{
  id: "tamilnadu-006",
  slug: "madurai-rameshwaram-kanyakumari-tour",
  destination: "tamilnadu",
  title: "Temple & Coastal Journey",
  duration: "5 Nights 6 Days",
  route: "2N Madurai | 2N Rameshwaram | 1N Kanyakumari",
  price: 17999,
  stars: 3,
  tags: ["🛕 Spiritual Escape", "🌊 Coastal Journey"],
  rating: 4.8,

  images: [
    madurai,
    rameshwaram,
    kanyakumari
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Madurai",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Rameshwaram",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Kanyakumari",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Madurai Sightseeing"
    },
    {
      title: "Rameshwaram Sightseeing"
    },
    {
      title: "Kanyakumari Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Madurai, Rameshwaram & Kanyakumari Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Temple Entry Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Madurai",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Madurai Tour",
      detail:
        "Visit temples and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Rameshwaram",
      detail:
        "Explore spiritual temples and beaches."
    },
    {
      day: 4,
      title: "Rameshwaram Sightseeing",
      detail:
        "Visit temples and coastal attractions."
    },
    {
      day: 5,
      title: "Transfer to Kanyakumari",
      detail:
        "Enjoy sunset views and sightseeing."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience temples, spirituality and coastal beauty with this South India journey."
},
{
  id: "tamilnadu-007",
  slug: "ooty-kodaikanal-madurai-tour",
  destination: "tamilnadu",
  title: "Complete Tamil Nadu Hills Tour",
  duration: "6 Nights 7 Days",
  route: "2N Ooty | 2N Kodaikanal | 2N Madurai",
  price: 21999,
  stars: 3,
  tags: ["🏔️ Hills Escape", "🌿 Nature & Heritage"],
  rating: 4.9,

  images: [
    ooty,
    kodaikanal,
    madurai
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Ooty",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Kodaikanal",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Madurai",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Ooty Sightseeing"
    },
    {
      title: "Kodaikanal Sightseeing"
    },
    {
      title: "Madurai Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Ooty, Kodaikanal & Madurai Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Temple Entry Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Ooty",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Ooty Sightseeing",
      detail:
        "Visit gardens, lakes and viewpoints."
    },
    {
      day: 3,
      title: "Transfer to Kodaikanal",
      detail:
        "Scenic hill drive and leisure time."
    },
    {
      day: 4,
      title: "Kodaikanal Tour",
      detail:
        "Explore waterfalls, lakes and local attractions."
    },
    {
      day: 5,
      title: "Transfer to Madurai",
      detail:
        "Visit temples and heritage sites."
    },
    {
      day: 6,
      title: "Madurai Sightseeing",
      detail:
        "Explore temples and cultural attractions."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience scenic hill stations and cultural heritage with this complete Tamil Nadu package."
},
{
  id: "tamilnadu-008",
  slug: "chennai-rameshwaram-kanyakumari-tour",
  destination: "tamilnadu",
  title: "South India Spiritual Escape",
  duration: "6 Nights 7 Days",
  route: "2N Chennai | 2N Rameshwaram | 2N Kanyakumari",
  price: 22999,
  stars: 3,
  tags: ["🛕 Spiritual Journey", "🌊 Coastal Escape"],
  rating: 4.9,

  images: [
    chennai,
    rameshwaram,
    kanyakumari
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Chennai",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Rameshwaram",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Kanyakumari",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Chennai Sightseeing"
    },
    {
      title: "Rameshwaram Sightseeing"
    },
    {
      title: "Kanyakumari Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Chennai, Rameshwaram & Kanyakumari Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Temple Entry Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Chennai",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Chennai Sightseeing",
      detail:
        "Visit beaches, temples and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Rameshwaram",
      detail:
        "Explore spiritual temples and coastal beauty."
    },
    {
      day: 4,
      title: "Rameshwaram Tour",
      detail:
        "Visit temples and scenic attractions."
    },
    {
      day: 5,
      title: "Transfer to Kanyakumari",
      detail:
        "Enjoy scenic coastal drive and sightseeing."
    },
    {
      day: 6,
      title: "Kanyakumari Sightseeing",
      detail:
        "Visit Vivekananda Rock and sunset points."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Discover spirituality, temples and coastal beauty with this South India travel experience."
},
// ================= Odisha =================
{
  id: "odisha-001",
  slug: "puri-konark-tour",
  destination: "odisha",
  title: "Sacred Odisha Escape",
  duration: "2 Nights 3 Days",
  route: "2N Puri | Konark",
  price: 6999,
  stars: 3,
  tags: ["🛕 Spiritual Journey", "🌊 Coastal Escape"],
  rating: 4.7,

  images: [
    puri,
    konark
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Puri",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Puri Sightseeing"
    },
    {
      title: "Konark Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "2 Nights Accommodation",
    "Daily Breakfast Included",
    "Puri & Konark Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Temple Entry Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Puri",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Puri & Konark Tour",
      detail:
        "Visit Jagannath Temple and Konark Sun Temple."
    },
    {
      day: 3,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Explore spiritual temples and coastal beauty with this peaceful Odisha getaway."
},
{
  id: "odisha-002",
  slug: "puri-konark-bhubaneswar-tour",
  destination: "odisha",
  title: "Temple Trail of Odisha",
  duration: "3 Nights 4 Days",
  route: "2N Puri | 1N Bhubaneswar",
  price: 10999,
  stars: 3,
  tags: ["🏛️ Heritage Tour", "🛕 Temple Journey"],
  rating: 4.8,

  images: [
    puri,
    bhubaneswar
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Puri",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Bhubaneswar",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Puri Sightseeing"
    },
    {
      title: "Konark Sightseeing"
    },
    {
      title: "Bhubaneswar Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Puri, Konark & Bhubaneswar Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Temple Entry Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Puri",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Konark Excursion",
      detail:
        "Visit Konark Sun Temple and nearby attractions."
    },
    {
      day: 3,
      title: "Transfer to Bhubaneswar",
      detail:
        "Explore heritage temples and local sites."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Discover Odisha’s famous temples, heritage monuments and spiritual attractions with this package."
},
{
  id: "odisha-003",
  slug: "puri-bhubaneswar-chilika-tour",
  destination: "odisha",
  title: "Lakes & Temples Journey",
  duration: "4 Nights 5 Days",
  route: "2N Puri | 1N Bhubaneswar | Chilika Lake",
  price: 13999,
  stars: 3,
  tags: ["🌊 Nature Escape", "🛕 Spiritual Tour"],
  rating: 4.8,

  images: [
   puri,
   bhubaneswar,
   chilikalake
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Puri",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Bhubaneswar",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Chilika",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Puri Sightseeing"
    },
    {
      title: "Bhubaneswar Sightseeing"
    },
    {
      title: "Chilika Lake Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Puri, Bhubaneswar & Chilika Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Boat Ride Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Puri",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Puri Sightseeing",
      detail:
        "Visit temples and coastal attractions."
    },
    {
      day: 3,
      title: "Transfer to Bhubaneswar",
      detail:
        "Explore heritage temples and city attractions."
    },
    {
      day: 4,
      title: "Chilika Lake Tour",
      detail:
        "Enjoy scenic lake views and boating."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience lakes, temples and scenic coastal beauty with this Odisha tour package."
},
{
  id: "odisha-004",
  slug: "puri-bhubaneswar-gopalpur-chilika-tour",
  destination: "odisha",
  title: "Complete Odisha Coastal Escape",
  duration: "5 Nights 6 Days",
  route: "2N Puri | 1N Bhubaneswar | 1N Gopalpur | Chilika Lake",
  price: 16999,
  stars: 3,
  tags: ["🏖️ Coastal Escape", "🌊 Best Seller"],
  rating: 4.9,

  images: [
    puri,
    bhubaneswar,
    gopalpur,
    chilikalake
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Puri",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Bhubaneswar",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Gopalpur",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Chilika",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Puri Sightseeing"
    },
    {
      title: "Bhubaneswar Sightseeing"
    },
    {
      title: "Gopalpur Sightseeing"
    },
    {
      title: "Chilika Lake Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Puri, Bhubaneswar, Gopalpur & Chilika Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Boat Ride Charges",
    "Temple Entry Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Puri",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Puri & Konark Tour",
      detail:
        "Visit temples and coastal attractions."
    },
    {
      day: 3,
      title: "Transfer to Bhubaneswar",
      detail:
        "Explore heritage sites and temples."
    },
    {
      day: 4,
      title: "Transfer to Gopalpur",
      detail:
        "Enjoy beachside relaxation and sightseeing."
    },
    {
      day: 5,
      title: "Chilika Lake Tour",
      detail:
        "Explore scenic lake views and boating."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Discover Odisha’s temples, beaches and scenic lakes with this complete coastal getaway."
},
// ================= Sikkim  =================
{
  id: "sikkim-001",
  slug: "gangtok-short-trip",
  destination: "sikkim",
  title: "Gangtok Himalayan Escape",
  duration: "3 Nights 4 Days",
  route: "3N Gangtok",
  price: 9999,
  stars: 3,
  tags: ["🏔️ Himalayan Escape", "🌿 Nature Retreat"],
  rating: 4.8,

  images: [
    gangtok
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Gangtok",
      nights: "3 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Gangtok Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Gangtok Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Permit Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Gangtok",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Gangtok Sightseeing",
      detail:
        "Visit monasteries, viewpoints and local attractions."
    },
    {
      day: 3,
      title: "Excursion Tour",
      detail:
        "Enjoy scenic mountain views and sightseeing."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Enjoy the scenic beauty of Gangtok with Himalayan views, monasteries and peaceful surroundings."
},
{
  id: "sikkim-002",
  slug: "gangtok-pelling-tour",
  destination: "sikkim",
  title: "Mystic Sikkim Journey",
  duration: "4 Nights 5 Days",
  route: "2N Gangtok | 2N Pelling",
  price: 14999,
  stars: 3,
  tags: ["🏔️ Mountain Escape", "🌄 Scenic Journey"],
  rating: 4.8,

  images: [
   gangtok,
   pelling
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Gangtok",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Pelling",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Gangtok Sightseeing"
    },
    {
      title: "Pelling Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Gangtok & Pelling Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Permit Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Gangtok",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Gangtok Tour",
      detail:
        "Explore monasteries and mountain viewpoints."
    },
    {
      day: 3,
      title: "Transfer to Pelling",
      detail:
        "Scenic drive through Himalayan roads."
    },
    {
      day: 4,
      title: "Pelling Sightseeing",
      detail:
        "Visit waterfalls and scenic attractions."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Explore the natural beauty and mountain charm of Gangtok and Pelling with this Sikkim package."
},
{
  id: "sikkim-003",
  slug: "gangtok-lachung-tour",
  destination: "sikkim",
  title: "Snow Valley Retreat",
  duration: "4 Nights 5 Days",
  route: "2N Gangtok | 2N Lachung",
  price: 15999,
  stars: 3,
  tags: ["❄️ Snow Adventure", "🏔️ Himalayan Escape"],
  rating: 4.9,

  images: [
    gangtok,
    lachung
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Gangtok",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Lachung",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Gangtok Sightseeing"
    },
    {
      title: "Lachung Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Gangtok & Lachung Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Permit Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Gangtok",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Gangtok Sightseeing",
      detail:
        "Visit viewpoints and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Lachung",
      detail:
        "Scenic drive through mountain valleys."
    },
    {
      day: 4,
      title: "Lachung Excursion",
      detail:
        "Enjoy snow-covered landscapes and sightseeing."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience snow valleys, mountain landscapes and Himalayan beauty with this Sikkim adventure."
},
{
  id: "sikkim-004",
  slug: "gangtok-lachung-pelling-tour",
  destination: "sikkim",
  title: "Complete Sikkim Escape",
  duration: "5 Nights 6 Days",
  route: "2N Gangtok | 1N Lachung | 2N Pelling",
  price: 19999,
  stars: 3,
  tags: ["🏔️ Best Seller", "🌿 Scenic Escape"],
  rating: 4.9,

  images: [
    gangtok,
    lachung,
    pelling
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Gangtok",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Lachung",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Pelling",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Gangtok Sightseeing"
    },
    {
      title: "Lachung Sightseeing"
    },
    {
      title: "Pelling Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Gangtok, Lachung & Pelling Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Permit Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Gangtok",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Gangtok Sightseeing",
      detail:
        "Visit monasteries and scenic viewpoints."
    },
    {
      day: 3,
      title: "Transfer to Lachung",
      detail:
        "Scenic drive through Himalayan valleys."
    },
    {
      day: 4,
      title: "Transfer to Pelling",
      detail:
        "Explore mountain landscapes and waterfalls."
    },
    {
      day: 5,
      title: "Pelling Sightseeing",
      detail:
        "Visit monasteries and local attractions."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Discover mountains, waterfalls and scenic valleys with this complete Sikkim holiday package."
},
{
  id: "sikkim-005",
  slug: "gangtok-lachen-lachung-pelling-tour",
  destination: "sikkim",
  title: "Grand Sikkim Expedition",
  duration: "6 Nights 7 Days",
  route: "2N Gangtok | 1N Lachen | 1N Lachung | 2N Pelling",
  price: 23999,
  stars: 3,
  tags: ["🏔️ Luxury Escape", "❄️ Mountain Adventure"],
  rating: 4.9,

  images: [
    gangtok,
    lachen,
    lachung,
    pelling
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Gangtok",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Lachen",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Lachung",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Pelling",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Gangtok Sightseeing"
    },
    {
      title: "Lachen Sightseeing"
    },
    {
      title: "Lachung Sightseeing"
    },
    {
      title: "Pelling Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Gangtok, Lachen, Lachung & Pelling Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Permit Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Gangtok",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Gangtok Tour",
      detail:
        "Explore local attractions and viewpoints."
    },
    {
      day: 3,
      title: "Transfer to Lachen",
      detail:
        "Scenic mountain drive and sightseeing."
    },
    {
      day: 4,
      title: "Transfer to Lachung",
      detail:
        "Visit valleys and waterfalls."
    },
    {
      day: 5,
      title: "Transfer to Pelling",
      detail:
        "Enjoy Himalayan landscapes and monasteries."
    },
    {
      day: 6,
      title: "Pelling Sightseeing",
      detail:
        "Visit scenic attractions and local spots."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience the beauty of mountains, snow valleys and monasteries with this grand Sikkim expedition."
},
{
  id: "sikkim-006",
  slug: "gangtok-lachen-lachung-pelling-namchi-tour",
  destination: "sikkim",
  title: "Ultimate Sikkim Discovery",
  duration: "7 Nights 8 Days",
  route: "2N Gangtok | 1N Lachen | 1N Lachung | 2N Pelling | 1N Namchi",
  price: 27999,
  stars: 3,
  tags: ["🏔️ Premium Escape", "🌄 Adventure Journey"],
  rating: 5.0,

  images: [
    gangtok,lachen,lachung,pelling,namchi
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Gangtok",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Lachen",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Lachung",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Pelling",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Namchi",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Gangtok Sightseeing"
    },
    {
      title: "Lachen Sightseeing"
    },
    {
      title: "Lachung Sightseeing"
    },
    {
      title: "Pelling Sightseeing"
    },
    {
      title: "Namchi Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "7 Nights Accommodation",
    "Daily Breakfast Included",
    "Gangtok, Lachen, Lachung, Pelling & Namchi Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Permit Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Gangtok",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Gangtok Sightseeing",
      detail:
        "Explore monasteries and viewpoints."
    },
    {
      day: 3,
      title: "Transfer to Lachen",
      detail:
        "Enjoy scenic Himalayan drives."
    },
    {
      day: 4,
      title: "Transfer to Lachung",
      detail:
        "Visit waterfalls and mountain valleys."
    },
    {
      day: 5,
      title: "Transfer to Pelling",
      detail:
        "Explore scenic mountain attractions."
    },
    {
      day: 6,
      title: "Pelling Sightseeing",
      detail:
        "Visit monasteries and viewpoints."
    },
    {
      day: 7,
      title: "Transfer to Namchi",
      detail:
        "Enjoy peaceful landscapes and sightseeing."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Discover the complete beauty of Sikkim with mountains, monasteries, valleys and scenic Himalayan landscapes."
},
// ================= Ladakh  =================
{
  id: "ladakh-001",
  slug: "leh-local-monastery-tour",
  destination: "ladakh",
  title: "Leh Monastery Escape",
  duration: "3 Nights 4 Days",
  route: "3N Leh | Monasteries Tour",
  price: 14999,
  stars: 3,
  tags: ["🏔️ Himalayan Escape", "🛕 Monastery Tour"],
  rating: 4.8,

  images: [
    leh,
    monasteriestour
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Leh",
      nights: "3 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Leh Sightseeing"
    },
    {
      title: "Monastery Tour"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Leh & Monastery Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Permit Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Leh",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Leh Local Sightseeing",
      detail:
        "Visit monasteries and local attractions."
    },
    {
      day: 3,
      title: "Monastery Tour",
      detail:
        "Explore famous monasteries and scenic mountain views."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience peaceful monasteries and stunning Himalayan landscapes with this Ladakh getaway."
},
{
  id: "ladakh-002",
  slug: "leh-nubra-tour",
  destination: "ladakh",
  title: "Himalayan Desert Journey",
  duration: "4 Nights 5 Days",
  route: "2N Leh | 2N Nubra Valley",
  price: 19999,
  stars: 3,
  tags: ["🏜️ Desert Adventure", "🏔️ Mountain Escape"],
  rating: 4.9,

  images: [
   leh,
   nubarvalley
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Leh",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Nubra Valley",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Leh Sightseeing"
    },
    {
      title: "Nubra Valley Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Leh & Nubra Valley Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Camel Ride Charges",
    "Permit Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Leh",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Leh Sightseeing",
      detail:
        "Visit monasteries and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Nubra Valley",
      detail:
        "Drive through Khardung La Pass."
    },
    {
      day: 4,
      title: "Nubra Valley Tour",
      detail:
        "Explore sand dunes and scenic valleys."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Discover mountain passes, monasteries and desert valleys with this Ladakh adventure package."
},
{
  id: "ladakh-003",
  slug: "leh-pangong-tour",
  destination: "ladakh",
  title: "Pangong Lake Retreat",
  duration: "4 Nights 5 Days",
  route: "2N Leh | 2N Pangong",
  price: 20999,
  stars: 3,
  tags: ["🌊 Pangong Escape", "🏔️ Nature Retreat"],
  rating: 4.9,

  images: [
   leh,
   pangong
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Leh",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Pangong",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Leh Sightseeing"
    },
    {
      title: "Pangong Lake Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Leh & Pangong Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Permit Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Leh",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Leh Local Tour",
      detail:
        "Visit monasteries and viewpoints."
    },
    {
      day: 3,
      title: "Transfer to Pangong",
      detail:
        "Drive through scenic mountain passes."
    },
    {
      day: 4,
      title: "Pangong Lake Tour",
      detail:
        "Enjoy breathtaking lake views and nature."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience the beauty of Pangong Lake and Himalayan landscapes with this Ladakh package."
},
{
  id: "ladakh-004",
  slug: "leh-nubra-pangong-tour",
  destination: "ladakh",
  title: "Complete Ladakh Adventure",
  duration: "5 Nights 6 Days",
  route: "2N Leh | 1N Nubra Valley | 2N Pangong",
  price: 25999,
  stars: 3,
  tags: ["🏔️ Adventure Escape", "🌊 Premium Journey"],
  rating: 5.0,

  images: [
    leh,
    nubarvalley,
    pangong
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Leh",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Nubra Valley",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Pangong",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Leh Sightseeing"
    },
    {
      title: "Nubra Valley Sightseeing"
    },
    {
      title: "Pangong Lake Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Leh, Nubra & Pangong Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Camel Ride Charges",
    "Permit Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Leh",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Leh Sightseeing",
      detail:
        "Visit monasteries and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Nubra Valley",
      detail:
        "Drive through Khardung La Pass."
    },
    {
      day: 4,
      title: "Transfer to Pangong",
      detail:
        "Enjoy scenic mountain landscapes."
    },
    {
      day: 5,
      title: "Pangong Exploration",
      detail:
        "Relax by the lake and enjoy sightseeing."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Explore mountain passes, desert valleys and Pangong Lake with this complete Ladakh adventure."
},
{
  id: "ladakh-005",
  slug: "leh-nubra-pangong-tsomoriri-tour",
  destination: "ladakh",
  title: "Ultimate Ladakh Expedition",
  duration: "6 Nights 7 Days",
  route: "2N Leh | 1N Nubra Valley | 1N Pangong | 2N Tso Moriri",
  price: 31999,
  stars: 3,
  tags: ["🏔️ Luxury Adventure", "🌊 Himalayan Expedition"],
  rating: 5.0,

  images: [
    leh,
    nubarvalley,
    pangong,
    tsoMoriri
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Leh",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Nubra Valley",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Pangong",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Tso Moriri",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Leh Sightseeing"
    },
    {
      title: "Nubra Valley Sightseeing"
    },
    {
      title: "Pangong Lake Sightseeing"
    },
    {
      title: "Tso Moriri Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Leh, Nubra, Pangong & Tso Moriri Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Permit Charges",
    "Camel Ride Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Leh",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Leh Local Tour",
      detail:
        "Visit monasteries and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Nubra Valley",
      detail:
        "Drive through Khardung La Pass."
    },
    {
      day: 4,
      title: "Transfer to Pangong",
      detail:
        "Explore scenic Himalayan routes."
    },
    {
      day: 5,
      title: "Transfer to Tso Moriri",
      detail:
        "Enjoy breathtaking lake landscapes."
    },
    {
      day: 6,
      title: "Tso Moriri Exploration",
      detail:
        "Relax and explore high-altitude lake surroundings."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience the ultimate Ladakh road trip with mountains, lakes and scenic Himalayan adventures."
},
// ================= Karnatka  =================
{
  id: "karnataka-001",
  slug: "coorg-short-trip",
  destination: "karnataka",
  title: "Coorg Nature Escape",
  duration: "2 Nights 3 Days",
  route: "2N Coorg",
  price: 7999,
  stars: 3,
  tags: ["🌿 Nature Retreat", "🏔️ Hill Escape"],
  rating: 4.8,

  images: [
   coorg
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Coorg",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Coorg Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "2 Nights Accommodation",
    "Daily Breakfast Included",
    "Coorg Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Adventure Activities",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Coorg",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Coorg Sightseeing",
      detail:
        "Visit waterfalls, coffee plantations and viewpoints."
    },
    {
      day: 3,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Relax amidst coffee plantations, waterfalls and scenic landscapes with this Coorg getaway."
},
{
  id: "karnataka-002",
  slug: "chikmagalur-short-trip",
  destination: "karnataka",
  title: "Coffee Hills Retreat",
  duration: "2 Nights 3 Days",
  route: "2N Chikmagalur",
  price: 8499,
  stars: 3,
  tags: ["☕ Coffee Escape", "🏔️ Mountain Retreat"],
  rating: 4.8,

  images: [
   chikmagalur
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Chikmagalur",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Chikmagalur Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "2 Nights Accommodation",
    "Daily Breakfast Included",
    "Chikmagalur Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Trekking Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Chikmagalur",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Chikmagalur Tour",
      detail:
        "Visit coffee estates, waterfalls and viewpoints."
    },
    {
      day: 3,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Enjoy scenic coffee plantations and mountain landscapes with this Chikmagalur package."
},
{
  id: "karnataka-003",
  slug: "bangalore-mysore-tour",
  destination: "karnataka",
  title: "Royal Karnataka Journey",
  duration: "3 Nights 4 Days",
  route: "2N Bangalore | 1N Mysore",
  price: 11999,
  stars: 3,
  tags: ["🏰 Heritage Tour", "🌆 City Escape"],
  rating: 4.8,

  images: [
    banglore,
    mysore
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Bangalore",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Mysore",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Bangalore Sightseeing"
    },
    {
      title: "Mysore Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Bangalore & Mysore Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Monument Entry Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Bangalore",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Bangalore Sightseeing",
      detail:
        "Visit gardens, palaces and city attractions."
    },
    {
      day: 3,
      title: "Transfer to Mysore",
      detail:
        "Explore Mysore Palace and local attractions."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Explore heritage palaces, gardens and cultural attractions with this Karnataka tour."
},
{
  id: "karnataka-004",
  slug: "bangalore-coorg-mysore-tour",
  destination: "karnataka",
  title: "Best of Karnataka Escape",
  duration: "4 Nights 5 Days",
  route: "2N Bangalore | 1N Coorg | 1N Mysore",
  price: 15999,
  stars: 3,
  tags: ["🌿 Nature Escape", "✨ Best Seller"],
  rating: 4.9,

  images: [
    banglore,
    coorg,
    mysore
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Bangalore",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Coorg",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Mysore",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Bangalore Sightseeing"
    },
    {
      title: "Coorg Sightseeing"
    },
    {
      title: "Mysore Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Bangalore, Coorg & Mysore Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Adventure Activities",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Bangalore",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Bangalore Tour",
      detail:
        "Explore gardens and city attractions."
    },
    {
      day: 3,
      title: "Transfer to Coorg",
      detail:
        "Visit coffee plantations and waterfalls."
    },
    {
      day: 4,
      title: "Transfer to Mysore",
      detail:
        "Explore palaces and cultural attractions."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience the perfect mix of cities, hills and heritage with this Karnataka getaway."
},
{
  id: "karnataka-005",
  slug: "hampi-badami-pattadakal-tour",
  destination: "karnataka",
  title: "Heritage Karnataka Trail",
  duration: "5 Nights 6 Days",
  route: "2N Hampi | 2N Badami | Pattadakal",
  price: 18999,
  stars: 3,
  tags: ["🏛️ Heritage Escape", "🌄 Premium Journey"],
  rating: 4.9,

  images: [
    hampi,
    badami,
    pattadakal
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Hampi",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Badami",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Pattadakal",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Hampi Sightseeing"
    },
    {
      title: "Badami Sightseeing"
    },
    {
      title: "Pattadakal Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Hampi, Badami & Pattadakal Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Monument Entry Charges",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Hampi",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Hampi Tour",
      detail:
        "Explore ancient ruins and temples."
    },
    {
      day: 3,
      title: "Transfer to Badami",
      detail:
        "Visit caves and heritage attractions."
    },
    {
      day: 4,
      title: "Badami Sightseeing",
      detail:
        "Explore temples and historical sites."
    },
    {
      day: 5,
      title: "Pattadakal Tour",
      detail:
        "Visit UNESCO heritage monuments."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Discover Karnataka’s ancient heritage and architectural wonders with this historical tour."
},
{
  id: "karnataka-006",
  slug: "bangalore-mysore-coorg-ooty-tour",
  destination: "karnataka",
  title: "South India Hills Escape",
  duration: "6 Nights 7 Days",
  route: "2N Bangalore | 1N Mysore | 2N Coorg | 1N Ooty",
  price: 23999,
  stars: 3,
  tags: ["🏔️ Luxury Escape", "🌿 Family Retreat"],
  rating: 5.0,

  images: [
    banglore,
    mysore,
    coorg,
    ooty
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Bangalore",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Mysore",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Coorg",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Ooty",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Bangalore Sightseeing"
    },
    {
      title: "Mysore Sightseeing"
    },
    {
      title: "Coorg Sightseeing"
    },
    {
      title: "Ooty Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Bangalore, Mysore, Coorg & Ooty Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Adventure Activities",
    "Personal Expenses",
    "Airfare / Train Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Bangalore",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Bangalore Tour",
      detail:
        "Explore city attractions and gardens."
    },
    {
      day: 3,
      title: "Transfer to Mysore",
      detail:
        "Visit Mysore Palace and local attractions."
    },
    {
      day: 4,
      title: "Transfer to Coorg",
      detail:
        "Enjoy waterfalls and coffee plantations."
    },
    {
      day: 5,
      title: "Coorg Sightseeing",
      detail:
        "Visit scenic viewpoints and nature attractions."
    },
    {
      day: 6,
      title: "Transfer to Ooty",
      detail:
        "Explore hill station beauty and gardens."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience cities, heritage and scenic hill stations with this South India escape."
},
// ================= Andaman & Nicobar  =================
{
  id: "andaman-001",
  slug: "portblair-havelock-tour",
  destination: "andaman",
  title: "Island Paradise Escape",
  duration: "3 Nights 4 Days",
  route: "2N Port Blair | 1N Havelock",
  price: 14999,
  stars: 3,
  tags: ["🏝️ Beach Escape", "🌊 Island Retreat"],
  rating: 4.8,

  images: [
    portBlair,
    havelock
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Port Blair",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Havelock",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Port Blair Sightseeing"
    },
    {
      title: "Havelock Island Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Port Blair & Havelock Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Water Sports Charges",
    "Personal Expenses",
    "Airfare / Ferry Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Port Blair",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Port Blair Sightseeing",
      detail:
        "Visit Cellular Jail and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Havelock",
      detail:
        "Enjoy beaches and island sightseeing."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience tropical beaches, crystal-clear waters and island beauty with this Andaman getaway."
},
{
  id: "andaman-002",
  slug: "portblair-havelock-neil-tour",
  destination: "andaman",
  title: "Andaman Island Retreat",
  duration: "4 Nights 5 Days",
  route: "2N Port Blair | 1N Havelock | 1N Neil Island",
  price: 18999,
  stars: 3,
  tags: ["💕 Honeymoon Escape", "🏝️ Island Tour"],
  rating: 4.9,

  images: [
   portBlair,
   havelock,
   neilIsland
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Port Blair",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Havelock",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Neil Island",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Port Blair Sightseeing"
    },
    {
      title: "Havelock Island Sightseeing"
    },
    {
      title: "Neil Island Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Port Blair, Havelock & Neil Island Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Water Sports Charges",
    "Personal Expenses",
    "Airfare / Ferry Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Port Blair",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Port Blair Tour",
      detail:
        "Visit Cellular Jail and nearby attractions."
    },
    {
      day: 3,
      title: "Transfer to Havelock",
      detail:
        "Enjoy beach activities and island views."
    },
    {
      day: 4,
      title: "Transfer to Neil Island",
      detail:
        "Explore beaches and natural attractions."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Enjoy romantic beaches, turquoise waters and scenic island beauty with this Andaman package."
},
{
  id: "andaman-003",
  slug: "classic-andaman-tour",
  destination: "andaman",
  title: "Classic Andaman Escape",
  duration: "5 Nights 6 Days",
  route: "2N Port Blair | 2N Havelock | 1N Neil Island",
  price: 22999,
  stars: 3,
  tags: ["🏖️ Best Seller", "🌊 Island Escape"],
  rating: 4.9,

 images: [
   portBlair,
   havelock,
   neilIsland
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Port Blair",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Havelock",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Neil Island",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Port Blair Sightseeing"
    },
    {
      title: "Havelock Island Sightseeing"
    },
    {
      title: "Neil Island Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Port Blair, Havelock & Neil Island Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Scuba Diving Charges",
    "Personal Expenses",
    "Airfare / Ferry Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Port Blair",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Port Blair Sightseeing",
      detail:
        "Visit Cellular Jail and local attractions."
    },
    {
      day: 3,
      title: "Transfer to Havelock",
      detail:
        "Relax at beaches and enjoy sightseeing."
    },
    {
      day: 4,
      title: "Havelock Exploration",
      detail:
        "Enjoy beach activities and scenic views."
    },
    {
      day: 5,
      title: "Transfer to Neil Island",
      detail:
        "Explore natural bridges and beaches."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Discover beautiful beaches, island adventures and tropical landscapes with this classic Andaman tour."
},
{
  id: "andaman-004",
  slug: "grand-andaman-exploration",
  destination: "andaman",
  title: "Grand Andaman Exploration",
  duration: "6 Nights 7 Days",
  route: "2N Port Blair | 2N Havelock | 1N Neil Island | Ross Island | Baratang",
  price: 28999,
  stars: 3,
  tags: ["🏝️ Luxury Escape", "🌊 Adventure Journey"],
  rating: 5.0,

  images: [
   portBlair,
   havelock,
   neilIsland,
   rossIsland,
   baratang
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Port Blair",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Havelock",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Neil Island",
      nights: "1 Night",
      type: "3 Star Hotel"
    },
    {
      location: "Baratang",
      nights: "1 Night",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Port Blair Sightseeing"
    },
    {
      title: "Havelock Island Sightseeing"
    },
    {
      title: "Neil Island Sightseeing"
    },
    {
      title: "Ross Island Sightseeing"
    },
    {
      title: "Baratang Sightseeing"
    },
  ],

  transfers: [
  {
    from: "Airport / Railway Station",
    to: "Hotel",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Sightseeing Points",
    type: "Private Transfer"
  },
  {
    from: "Hotel",
    to: "Airport / Railway Station",
    type: "Private Transfer"
  },
],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Port Blair, Havelock, Neil Island & Baratang Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Scuba Diving Charges",
    "Personal Expenses",
    "Airfare / Ferry Tickets"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Port Blair",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Port Blair & Ross Island Tour",
      detail:
        "Explore historical attractions and island beauty."
    },
    {
      day: 3,
      title: "Transfer to Havelock",
      detail:
        "Enjoy beaches and scenic landscapes."
    },
    {
      day: 4,
      title: "Havelock Exploration",
      detail:
        "Relax and enjoy water activities."
    },
    {
      day: 5,
      title: "Transfer to Neil Island",
      detail:
        "Explore beaches and natural attractions."
    },
    {
      day: 6,
      title: "Baratang Excursion",
      detail:
        "Visit limestone caves and mangrove forests."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Check-out and proceed for return journey."
    }
  ],

  overview:
    "Experience beaches, islands and tropical adventures with this grand Andaman holiday package."
},
// ================= Dubai =================
{
  id: "dubai-budget-001",
  slug: "dubai-budget-trip",
  destination: "dubai",
  title: "Affordable Dubai Escape",
  duration: "3 Nights 4 Days",
  route: "3N Dubai",
  price: 32999,
  stars: 2,
  tags: ["🏙️ Budget Friendly", "🛍️ City Explorer"],
  rating: 4.3,

  images: [
    dubai
  ],

  includes: ["hotels", "sightseeing", "transfers"],

  hotels: [
    {
      location: "Dubai",
      nights: "3 Nights",
      type: "2 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Dubai City Tour"
    },
    {
      title: "Burj Khalifa Visit"
    },
    {
      title: "Desert Safari"
    },
    {
      title: "Dubai Marina Exploration"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "3 Nights Accommodation",
    "Dubai City Sightseeing",
    "Airport Transfers",
    "Desert Safari Experience"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Dubai",
      detail:
        "Arrival at Dubai Airport and hotel check-in."
    },
    {
      day: 2,
      title: "Dubai City Tour",
      detail:
        "Explore iconic attractions and shopping areas."
    },
    {
      day: 3,
      title: "Desert Safari Experience",
      detail:
        "Enjoy dune bashing and cultural performances."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and transfer to airport."
    }
  ],

  overview:
    "Discover the charm of Dubai with this affordable city escape package."
},
{
  id: "dubai-budget-002",
  slug: "dubai-economy-tour",
  destination: "dubai",
  title: "Dubai Saver Journey",
  duration: "4 Nights 5 Days",
  route: "4N Dubai",
  price: 39999,
  stars: 3,
  tags: ["🏙️ Budget Escape", "🌆 Modern Dubai"],
  rating: 4.5,

   images: [
    dubai
  ],


  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Dubai",
      nights: "4 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Dubai City Tour"
    },
    {
      title: "Burj Khalifa Observation Deck"
    },
    {
      title: "Desert Safari"
    },
    {
      title: "Dubai Mall & Fountain Show"
    },
    {
      title: "Dubai Marina Cruise"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Dubai Sightseeing",
    "Airport Transfers"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Dubai",
      detail:
        "Arrival and transfer to hotel."
    },
    {
      day: 2,
      title: "Dubai City Exploration",
      detail:
        "Visit major attractions and landmarks."
    },
    {
      day: 3,
      title: "Desert Safari",
      detail:
        "Experience thrilling desert adventure."
    },
    {
      day: 4,
      title: "Marina & Shopping Tour",
      detail:
        "Explore Dubai Marina and shopping destinations."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Hotel check-out and airport transfer."
    }
  ],

  overview:
    "Enjoy Dubai’s modern attractions and desert adventures with this budget-friendly tour."
},
{
  id: "dubai-001",
  slug: "dubai-short-trip",
  destination: "dubai",
  title: "Desert City Escape",
  duration: "3 Nights 4 Days",
  route: "3N Dubai",
  price: 45999,
  stars: 4,
  tags: ["🏙️ City Adventure", "🌆 Luxury Escape"],
  rating: 4.7,

  images: [
    dubai
  ],


  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Dubai",
      nights: "3 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Dubai City Tour"
    },
    {
      title: "Burj Khalifa Visit"
    },
    {
      title: "Desert Safari"
    },
    {
      title: "Dubai Marina Cruise"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Dubai Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Dubai",
      detail:
        "Arrival and transfer to hotel."
    },
    {
      day: 2,
      title: "Dubai City Tour",
      detail:
        "Visit iconic attractions and landmarks."
    },
    {
      day: 3,
      title: "Desert Safari Adventure",
      detail:
        "Enjoy dune bashing and evening entertainment."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Check-out and airport transfer."
    }
  ],

  overview:
    "Experience the modern wonders and luxury lifestyle of Dubai with this exciting holiday package."
},
{
  id: "dubai-002",
  slug: "dubai-family-tour",
  destination: "dubai",
  title: "Dubai Family Fun",
  duration: "4 Nights 5 Days",
  route: "4N Dubai",
  price: 59999,
  stars: 4,
  tags: ["👨‍👩‍👧 Family Tour", "🏖️ Fun Activities"],
  rating: 4.8,

   images: [
    dubai
  ],


  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Dubai",
      nights: "4 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Dubai City Tour"
    },
    {
      title: "Dubai Aquarium"
    },
    {
      title: "Desert Safari"
    },
    {
      title: "Miracle Garden Visit"
    },
    {
      title: "Dubai Marina Cruise"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Family-Friendly Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Dubai",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Dubai City Sightseeing",
      detail:
        "Explore top attractions and shopping malls."
    },
    {
      day: 3,
      title: "Desert Safari",
      detail:
        "Adventure activities and cultural performances."
    },
    {
      day: 4,
      title: "Aquarium & Marina Tour",
      detail:
        "Visit Dubai Aquarium and enjoy Marina cruise."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Enjoy an unforgettable family vacation with exciting attractions and luxury experiences in Dubai."
},
{
  id: "dubai-003",
  slug: "dubai-abu-dhabi-tour",
  destination: "dubai",
  title: "Luxury Emirates Journey",
  duration: "5 Nights 6 Days",
  route: "4N Dubai | 1N Abu Dhabi",
  price: 74999,
  stars: 5,
  tags: ["✨ Luxury Escape", "🏙️ Twin City Tour"],
  rating: 4.9,

   images: [
    dubai,abudhabi
  ],


  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Dubai",
      nights: "4 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Abu Dhabi",
      nights: "1 Night",
      type: "5 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Dubai City Tour"
    },
    {
      title: "Burj Khalifa Experience"
    },
    {
      title: "Desert Safari"
    },
    {
      title: "Abu Dhabi City Tour"
    },
    {
      title: "Sheikh Zayed Grand Mosque"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Premium Dinner Included"
    }
  ],

  inclusions: [
    "5 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Dubai & Abu Dhabi Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Dubai",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Dubai City Tour",
      detail:
        "Visit iconic landmarks and attractions."
    },
    {
      day: 3,
      title: "Desert Safari",
      detail:
        "Adventure activities and cultural entertainment."
    },
    {
      day: 4,
      title: "Burj Khalifa & Marina",
      detail:
        "Explore Downtown Dubai and Marina district."
    },
    {
      day: 5,
      title: "Transfer to Abu Dhabi",
      detail:
        "Visit Sheikh Zayed Mosque and city attractions."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Explore the luxury and modern beauty of Dubai and Abu Dhabi with this premium Emirates holiday package."
},
{
  id: "dubai-004",
  slug: "dubai-honeymoon-package",
  destination: "dubai",
  title: "Romantic Dubai Escape",
  duration: "5 Nights 6 Days",
  route: "5N Dubai",
  price: 82999,
  stars: 5,
  tags: ["💖 Honeymoon Special", "🌆 Luxury Romance"],
  rating: 5.0,

   images: [
    dubai
  ],


  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Dubai",
      nights: "5 Nights",
      type: "5 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Dubai City Tour"
    },
    {
      title: "Burj Khalifa Experience"
    },
    {
      title: "Luxury Marina Cruise"
    },
    {
      title: "Desert Safari with Dinner"
    },
    {
      title: "Palm Jumeirah Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "5 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic Cruise Experience",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Dubai",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Dubai City Exploration",
      detail:
        "Visit major attractions and shopping areas."
    },
    {
      day: 3,
      title: "Romantic Marina Cruise",
      detail:
        "Enjoy dinner cruise with skyline views."
    },
    {
      day: 4,
      title: "Desert Safari",
      detail:
        "Adventure and entertainment in the desert."
    },
    {
      day: 5,
      title: "Palm Jumeirah & Leisure Day",
      detail:
        "Relax and explore luxury attractions."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer to airport for return flight."
    }
  ],

  overview:
    "Celebrate romance and luxury with this unforgettable Dubai honeymoon experience."
},
{
  id: "dubai-005",
  slug: "grand-dubai-explorer",
  destination: "dubai",
  title: "Ultimate Dubai Adventure",
  duration: "6 Nights 7 Days",
  route: "5N Dubai | 1N Abu Dhabi",
  price: 99999,
  stars: 5,
  tags: ["🌟 Ultimate Luxury", "🏙️ Premium Experience"],
  rating: 5.0,

  images: [
    dubai,
    abudhabi
  ],


  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Dubai",
      nights: "5 Nights",
      type: "5 Star Luxury Hotel"
    },
    {
      location: "Abu Dhabi",
      nights: "1 Night",
      type: "5 Star Luxury Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Dubai City Tour"
    },
    {
      title: "Burj Khalifa At The Top"
    },
    {
      title: "Luxury Desert Safari"
    },
    {
      title: "Dubai Marina Yacht Cruise"
    },
    {
      title: "Atlantis & Palm Jumeirah Tour"
    },
    {
      title: "Abu Dhabi City Exploration"
    },
    {
      title: "Ferrari World Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Dinners Included"
    }
  ],

  inclusions: [
    "6 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Dubai & Abu Dhabi Premium Sightseeing",
    "Luxury Yacht Cruise Experience",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Travel Insurance",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Dubai",
      detail:
        "Airport pickup and luxury hotel check-in."
    },
    {
      day: 2,
      title: "Dubai City Tour",
      detail:
        "Explore iconic landmarks and luxury attractions."
    },
    {
      day: 3,
      title: "Burj Khalifa & Dubai Mall",
      detail:
        "Enjoy panoramic city views and shopping experience."
    },
    {
      day: 4,
      title: "Luxury Desert Safari",
      detail:
        "Experience adventure activities and premium dinner."
    },
    {
      day: 5,
      title: "Yacht Cruise & Palm Jumeirah",
      detail:
        "Relax with luxury cruise and island exploration."
    },
    {
      day: 6,
      title: "Abu Dhabi Excursion",
      detail:
        "Visit Sheikh Zayed Mosque and Ferrari World."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Check-out and airport transfer."
    }
  ],

  overview:
    "Discover the finest luxury experiences, iconic attractions and thrilling adventures with this ultimate Dubai holiday package."
},
// ================= Thailand =================
{
  id: "thailand-budget-001",
  slug: "thailand-budget-trip",
  destination: "thailand",
  title: "Budget Thailand Escape",
  duration: "4 Nights 5 Days",
  route: "2N Pattaya | 2N Bangkok",
  price: 24999,
  stars: 2,
  tags: ["🏝️ Budget Escape", "🛍️ City & Beach"],
  rating: 4.2,

  images: [
    pattaya,
    bangkok
  ],

  includes: ["hotels", "sightseeing", "transfers"],

  hotels: [
    {
      location: "Pattaya",
      nights: "2 Nights",
      type: "2 Star Hotel"
    },
    {
      location: "Bangkok",
      nights: "2 Nights",
      type: "2 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Pattaya Coral Island Tour"
    },
    {
      title: "Bangkok City Tour"
    },
    {
      title: "Floating Market Visit"
    },
    {
      title: "Pattaya Beach Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "4 Nights Accommodation",
    "Pattaya & Bangkok Sightseeing",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Pattaya",
      detail:
        "Arrival and hotel check-in."
    },
    {
      day: 2,
      title: "Coral Island Tour",
      detail:
        "Enjoy beach activities and island sightseeing."
    },
    {
      day: 3,
      title: "Transfer to Bangkok",
      detail:
        "Travel to Bangkok and leisure time."
    },
    {
      day: 4,
      title: "Bangkok City Tour",
      detail:
        "Visit temples, markets and city attractions."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Enjoy beaches, shopping and vibrant nightlife with this affordable Thailand holiday package."
},
{
  id: "thailand-budget-002",
  slug: "thailand-economy-tour",
  destination: "thailand",
  title: "Thailand Saver Journey",
  duration: "5 Nights 6 Days",
  route: "3N Phuket | 2N Krabi",
  price: 34999,
  stars: 3,
  tags: ["🌴 Tropical Escape", "🏖️ Budget Adventure"],
  rating: 4.4,

  images: [
    phuket,
    krabi
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Phuket",
      nights: "3 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Krabi",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Phi Phi Island Tour"
    },
    {
      title: "Krabi Four Island Tour"
    },
    {
      title: "Phuket City Tour"
    },
    {
      title: "Patong Beach Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Island Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Phuket",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Phi Phi Island Tour",
      detail:
        "Explore beaches and crystal-clear waters."
    },
    {
      day: 3,
      title: "Phuket City Tour",
      detail:
        "Visit popular attractions and markets."
    },
    {
      day: 4,
      title: "Transfer to Krabi",
      detail:
        "Scenic transfer and leisure time."
    },
    {
      day: 5,
      title: "Krabi Island Tour",
      detail:
        "Explore islands and beach activities."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Discover tropical beaches and island adventures with this value-for-money Thailand package."
},
{
  id: "thailand-001",
  slug: "bangkok-pattaya-trip",
  destination: "thailand",
  title: "Thailand Fun Retreat",
  duration: "4 Nights 5 Days",
  route: "2N Pattaya | 2N Bangkok",
  price: 34999,
  stars: 3,
  tags: ["🏖️ Beach Escape", "🌆 City Adventure"],
  rating: 4.5,

  images: [
    pattaya,
    bangkok
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Pattaya",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Bangkok",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Coral Island Tour"
    },
    {
      title: "Bangkok Temple Tour"
    },
    {
      title: "Pattaya Beach Experience"
    },
    {
      title: "Floating Market Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Bangkok & Pattaya Sightseeing",
    "Airport Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Pattaya",
      detail:
        "Airport pickup and transfer to hotel."
    },
    {
      day: 2,
      title: "Coral Island Tour",
      detail:
        "Enjoy water sports and beach activities."
    },
    {
      day: 3,
      title: "Transfer to Bangkok",
      detail:
        "Travel to Bangkok and evening leisure."
    },
    {
      day: 4,
      title: "Bangkok City Tour",
      detail:
        "Explore temples, markets and attractions."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer to airport for return flight."
    }
  ],

  overview:
    "Enjoy the perfect combination of beaches, nightlife and city attractions with this Thailand getaway."
},
{
  id: "thailand-002",
  slug: "phuket-krabi-tour",
  destination: "thailand",
  title: "Island Adventure Thailand",
  duration: "5 Nights 6 Days",
  route: "3N Phuket | 2N Krabi",
  price: 55999,
  stars: 4,
  tags: ["🏝️ Island Adventure", "🌊 Tropical Escape"],
  rating: 4.7,

  images: [
    phuket,
    krabi
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Phuket",
      nights: "3 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Krabi",
      nights: "2 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Phi Phi Island Tour"
    },
    {
      title: "Krabi Four Island Tour"
    },
    {
      title: "Phuket City Tour"
    },
    {
      title: "Patong Beach Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Island Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

 itinerary: [
    {
      day: 1,
      title: "Arrival in Phuket",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Phi Phi Island Tour",
      detail:
        "Explore famous islands and beaches."
    },
    {
      day: 3,
      title: "Phuket City Tour",
      detail:
        "Visit attractions, temples and markets."
    },
    {
      day: 4,
      title: "Transfer to Krabi",
      detail:
        "Travel to Krabi and leisure time."
    },
    {
      day: 5,
      title: "Krabi Four Island Tour",
      detail:
        "Experience island hopping and water activities."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

 overview:
    "Experience Thailand’s beautiful beaches and island adventures with this tropical holiday package."
},
{
  id: "thailand-003",
  slug: "bangkok-phuket-tour",
  destination: "thailand",
  title: "City & Beach Escape",
  duration: "6 Nights 7 Days",
  route: "3N Bangkok | 3N Phuket",
  price: 64999,
  stars: 4,
  tags: ["🌆 City Life", "🏖️ Beach Holiday"],
  rating: 4.8,

  images: [
    bangkok,
    phuket
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Bangkok",
      nights: "3 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Phuket",
      nights: "3 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Bangkok Temple Tour"
    },
    {
      title: "Floating Market Visit"
    },
    {
      title: "Phi Phi Island Tour"
    },
    {
      title: "Phuket City Tour"
    },
    {
      title: "Patong Beach Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Bangkok & Phuket Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Bangkok",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Bangkok City Tour",
      detail:
        "Visit temples, shopping markets and attractions."
    },
    {
      day: 3,
      title: "Floating Market Tour",
      detail:
        "Explore Thailand’s famous floating market."
    },
    {
      day: 4,
      title: "Transfer to Phuket",
      detail:
        "Travel to Phuket and leisure time."
    },
    {
      day: 5,
      title: "Phi Phi Island Tour",
      detail:
        "Enjoy beaches and island activities."
    },
    {
      day: 6,
      title: "Phuket Exploration",
      detail:
        "Visit Patong Beach and local attractions."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Experience Thailand’s vibrant city life and tropical beaches with this exciting holiday package."
},
{
  id: "thailand-004",
  slug: "thailand-honeymoon-package",
  destination: "thailand",
  title: "Romantic Thailand Bliss",
  duration: "6 Nights 7 Days",
  route: "3N Krabi | 3N Phuket",
  price: 72999,
  stars: 5,
  tags: ["💖 Honeymoon Special", "🌴 Romantic Beaches"],
  rating: 4.9,

  images: [
    krabi,
    pattaya
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Krabi",
      nights: "3 Nights",
      type: "5 Star Resort"
    },
    {
      location: "Phuket",
      nights: "3 Nights",
      type: "5 Star Resort"
    }
  ],

  sightseeing: [
    {
      title: "Krabi Island Tour"
    },
    {
      title: "Phi Phi Island Excursion"
    },
    {
      title: "Romantic Beach Dinner"
    },
    {
      title: "Phuket City Tour"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "6 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Island Tours Included",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Krabi",
      detail:
        "Airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Krabi Island Tour",
      detail:
        "Enjoy island hopping and water activities."
    },
    {
      day: 3,
      title: "Leisure Day",
      detail:
        "Relax at beach resort and enjoy romantic experiences."
    },
    {
      day: 4,
      title: "Transfer to Phuket",
      detail:
        "Travel to Phuket and leisure evening."
    },
    {
      day: 5,
      title: "Phi Phi Island Tour",
      detail:
        "Explore tropical islands and beaches."
    },
    {
      day: 6,
      title: "Romantic Dinner Experience",
      detail:
        "Enjoy special dinner by the beach."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Celebrate romance and luxury with this unforgettable Thailand honeymoon package."
},
{
  id: "thailand-005",
  slug: "grand-thailand-tour",
  destination: "thailand",
  title: "Ultimate Thailand Explorer",
  duration: "8 Nights 9 Days",
  route: "2N Pattaya | 2N Bangkok | 2N Phuket | 2N Krabi",
  price: 99999,
  stars: 5,
  tags: ["🌟 Grand Thailand Tour", "🏝️ Ultimate Adventure"],
  rating: 5.0,

  images: [
    pattaya,
    bangkok,
    phuket,
    krabi
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Pattaya",
      nights: "2 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Bangkok",
      nights: "2 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Phuket",
      nights: "2 Nights",
      type: "5 Star Resort"
    },
    {
      location: "Krabi",
      nights: "2 Nights",
      type: "5 Star Resort"
    }
  ],

  sightseeing: [
    {
      title: "Coral Island Tour"
    },
    {
      title: "Bangkok City Tour"
    },
    {
      title: "Phi Phi Island Tour"
    },
    {
      title: "Krabi Four Island Tour"
    },
    {
      title: "Floating Market Visit"
    },
    {
      title: "Patong Beach Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Dinners Included"
    }
  ],

  inclusions: [
    "8 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Thailand Sightseeing Tours",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Pattaya",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Coral Island Adventure",
      detail:
        "Enjoy water sports and beach activities."
    },
    {
      day: 3,
      title: "Transfer to Bangkok",
      detail:
        "Travel to Bangkok and evening leisure."
    },
    {
      day: 4,
      title: "Bangkok Sightseeing",
      detail:
        "Visit famous temples and shopping areas."
    },
    {
      day: 5,
      title: "Transfer to Phuket",
      detail:
        "Arrival and resort check-in."
    },
    {
      day: 6,
      title: "Phi Phi Island Tour",
      detail:
        "Island hopping and beach exploration."
    },
    {
      day: 7,
      title: "Transfer to Krabi",
      detail:
        "Travel to Krabi and enjoy leisure time."
    },
    {
      day: 8,
      title: "Krabi Four Island Tour",
      detail:
        "Explore beaches and scenic islands."
    },
    {
      day: 9,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Discover Thailand’s best beaches, islands and cities with this ultimate luxury holiday package."
},
// ================= Bali =================
{
  id: "bali-budget-001",
  slug: "bali-budget-trip",
  destination: "bali",
  title: "Affordable Bali Escape",
  duration: "4 Nights 5 Days",
  route: "4N Bali",
  price: 39999,
  stars: 2,
  tags: ["🌴 Budget Escape", "🏖️ Tropical Holiday"],
  rating: 4.2,

  images: [
    bali
  ],

  includes: ["hotels", "sightseeing", "transfers"],

  hotels: [
    {
      location: "Bali",
      nights: "4 Nights",
      type: "2 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Kuta Beach Visit"
    },
    {
      title: "Tanah Lot Temple Tour"
    },
    {
      title: "Ubud Market Exploration"
    },
    {
      title: "Bali Sunset Tour"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "4 Nights Accommodation",
    "Bali Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Bali",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Kuta Beach Tour",
      detail:
        "Enjoy beach activities and sunset views."
    },
    {
      day: 3,
      title: "Temple & Market Tour",
      detail:
        "Visit famous temples and local markets."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Relax and explore nearby attractions."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Enjoy Bali’s beaches, temples and tropical beauty with this affordable holiday package."
},
{
  id: "bali-budget-002",
  slug: "bali-economy-tour",
  destination: "bali",
  title: "Bali Saver Retreat",
  duration: "5 Nights 6 Days",
  route: "3N Kuta | 2N Ubud",
  price: 49999,
  stars: 3,
  tags: ["🌴 Nature Escape", "🏝️ Budget Retreat"],
  rating: 4.4,

  images: [
    kuta,
    ubud
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Kuta",
      nights: "3 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Ubud",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Kuta Beach Experience"
    },
    {
      title: "Ubud Rice Terrace Tour"
    },
    {
      title: "Tanah Lot Temple Visit"
    },
    {
      title: "Bali Swing Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Bali Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Kuta",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Kuta Beach Tour",
      detail:
        "Enjoy beach and water activities."
    },
    {
      day: 3,
      title: "Temple & Sunset Tour",
      detail:
        "Visit Bali temples and scenic viewpoints."
    },
    {
      day: 4,
      title: "Transfer to Ubud",
      detail:
        "Travel to Ubud and explore local culture."
    },
    {
      day: 5,
      title: "Rice Terrace & Swing Tour",
      detail:
        "Visit rice fields and famous Bali swings."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Discover Bali’s natural beauty and cultural attractions with this budget-friendly island getaway."
},
{
  id: "bali-001",
  slug: "bali-short-trip",
  destination: "bali",
  title: "Tropical Bali Escape",
  duration: "4 Nights 5 Days",
  route: "4N Bali",
  price: 52999,
  stars: 4,
  tags: ["🏝️ Tropical Escape", "🌅 Beach Holiday"],
  rating: 4.6,

  images: [
    bali
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Bali",
      nights: "4 Nights",
      type: "4 Star Resort"
    }
  ],

  sightseeing: [
    {
      title: "Kuta Beach Tour"
    },
    {
      title: "Tanah Lot Temple Visit"
    },
    {
      title: "Bali Sunset Experience"
    },
    {
      title: "Uluwatu Temple Tour"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Bali Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Bali",
      detail:
        "Airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Kuta & Sunset Tour",
      detail:
        "Enjoy beaches and sunset viewpoints."
    },
    {
      day: 3,
      title: "Temple Exploration",
      detail:
        "Visit Bali’s famous temples and attractions."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Relax and enjoy resort activities."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Experience Bali’s tropical beaches, temples and island charm with this relaxing getaway package."
},
{
  id: "bali-002",
  slug: "bali-kuta-ubud-tour",
  destination: "bali",
  title: "Bali Nature & Beaches",
  duration: "5 Nights 6 Days",
  route: "3N Kuta | 2N Ubud",
  price: 64999,
  stars: 4,
  tags: ["🌴 Nature Retreat", "🏖️ Beach Escape"],
  rating: 4.7,

  images: [
    kuta,
    ubud
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Kuta",
      nights: "3 Nights",
      type: "4 Star Resort"
    },
    {
      location: "Ubud",
      nights: "2 Nights",
      type: "4 Star Resort"
    }
  ],

  sightseeing: [
    {
      title: "Kuta Beach Experience"
    },
    {
      title: "Ubud Rice Terrace Tour"
    },
    {
      title: "Tanah Lot Temple Visit"
    },
    {
      title: "Bali Swing Experience"
    },
    {
      title: "Uluwatu Temple Tour"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Bali Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Kuta",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Kuta Beach Tour",
      detail:
        "Enjoy beaches and shopping markets."
    },
    {
      day: 3,
      title: "Temple & Sunset Tour",
      detail:
        "Visit temples and scenic attractions."
    },
    {
      day: 4,
      title: "Transfer to Ubud",
      detail:
        "Travel to Ubud and enjoy natural landscapes."
    },
    {
      day: 5,
      title: "Rice Terrace & Swing Tour",
      detail:
        "Explore Bali’s greenery and adventure spots."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Enjoy the perfect blend of Bali’s beaches, temples and lush natural beauty with this island holiday package."
},
{
  id: "bali-003",
  slug: "bali-family-package",
  destination: "bali",
  title: "Bali Family Adventure",
  duration: "6 Nights 7 Days",
  route: "3N Kuta | 3N Ubud",
  price: 74999,
  stars: 4,
  tags: ["👨‍👩‍👧 Family Holiday", "🌴 Tropical Adventure"],
  rating: 4.8,

  images: [
    kuta,
    ubud
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Kuta",
      nights: "3 Nights",
      type: "4 Star Resort"
    },
    {
      location: "Ubud",
      nights: "3 Nights",
      type: "4 Star Resort"
    }
  ],

  sightseeing: [
    {
      title: "Kuta Beach Tour"
    },
    {
      title: "Waterbom Bali Visit"
    },
    {
      title: "Ubud Rice Terrace Tour"
    },
    {
      title: "Bali Safari Experience"
    },
    {
      title: "Tanah Lot Temple Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Family-Friendly Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Kuta",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Kuta Beach & Water Activities",
      detail:
        "Enjoy beach activities and family fun."
    },
    {
      day: 3,
      title: "Waterbom Bali Visit",
      detail:
        "Experience thrilling water rides and attractions."
    },
    {
      day: 4,
      title: "Transfer to Ubud",
      detail:
        "Travel to Ubud and explore local culture."
    },
    {
      day: 5,
      title: "Rice Terrace & Temple Tour",
      detail:
        "Visit scenic rice terraces and temples."
    },
    {
      day: 6,
      title: "Bali Safari Adventure",
      detail:
        "Enjoy wildlife experiences and leisure activities."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Create unforgettable family memories with beaches, adventures and cultural experiences in Bali."
},
{
  id: "bali-004",
  slug: "bali-honeymoon-package",
  destination: "bali",
  title: "Romantic Bali Bliss",
  duration: "6 Nights 7 Days",
  route: "2N Seminyak | 2N Ubud | 2N Nusa Dua",
  price: 89999,
  stars: 5,
  tags: ["💖 Honeymoon Escape", "🌅 Romantic Retreat"],
  rating: 4.9,

  images: [
    seminyak,
    ubud,
    nusaDua
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Seminyak",
      nights: "2 Nights",
      type: "5 Star Resort"
    },
    {
      location: "Ubud",
      nights: "2 Nights",
      type: "5 Star Villa Resort"
    },
    {
      location: "Nusa Dua",
      nights: "2 Nights",
      type: "5 Star Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "Romantic Sunset Dinner"
    },
    {
      title: "Ubud Rice Terrace Tour"
    },
    {
      title: "Bali Swing Experience"
    },
    {
      title: "Nusa Dua Beach Experience"
    },
    {
      title: "Tanah Lot Temple Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Candle Light Dinner"
    }
  ],

  inclusions: [
    "6 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic Dinner Experience",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Seminyak",
      detail:
        "Airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Beach & Sunset Experience",
      detail:
        "Relax at beaches and enjoy romantic dinner."
    },
    {
      day: 3,
      title: "Transfer to Ubud",
      detail:
        "Explore nature and cultural attractions."
    },
    {
      day: 4,
      title: "Rice Terrace & Swing Tour",
      detail:
        "Visit scenic rice fields and adventure spots."
    },
    {
      day: 5,
      title: "Transfer to Nusa Dua",
      detail:
        "Enjoy luxury beachside experiences."
    },
    {
      day: 6,
      title: "Leisure & Romantic Day",
      detail:
        "Relax and enjoy resort amenities."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Celebrate love with luxury resorts, tropical beaches and romantic experiences in Bali."
},
{
  id: "bali-005",
  slug: "grand-bali-explorer",
  destination: "bali",
  title: "Ultimate Bali Journey",
  duration: "7 Nights 8 Days",
  route: "3N Kuta | 2N Ubud | 2N Nusa Penida",
  price: 109999,
  stars: 5,
  tags: ["🌟 Grand Bali Tour", "🏝️ Ultimate Island Adventure"],
  rating: 5.0,

  images: [
    kuta,
    ubud,
    nusaPenida
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Kuta",
      nights: "3 Nights",
      type: "5 Star Resort"
    },
    {
      location: "Ubud",
      nights: "2 Nights",
      type: "5 Star Villa Resort"
    },
    {
      location: "Nusa Penida",
      nights: "2 Nights",
      type: "5 Star Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "Kuta Beach Tour"
    },
    {
      title: "Nusa Penida Island Tour"
    },
    {
      title: "Ubud Rice Terrace Visit"
    },
    {
      title: "Bali Swing Experience"
    },
    {
      title: "Tanah Lot Temple Tour"
    },
    {
      title: "Snorkeling Adventure"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Dinners Included"
    }
  ],

  inclusions: [
    "7 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Island Tours & Adventure Activities",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Kuta",
      detail:
        "Airport pickup and luxury resort check-in."
    },
    {
      day: 2,
      title: "Kuta Beach Exploration",
      detail:
        "Enjoy beach leisure and nightlife."
    },
    {
      day: 3,
      title: "Temple & Sunset Tour",
      detail:
        "Visit Bali temples and scenic viewpoints."
    },
    {
      day: 4,
      title: "Transfer to Ubud",
      detail:
        "Experience Bali’s nature and culture."
    },
    {
      day: 5,
      title: "Rice Terrace & Swing Adventure",
      detail:
        "Explore iconic landscapes and activities."
    },
    {
      day: 6,
      title: "Transfer to Nusa Penida",
      detail:
        "Relax and enjoy island beauty."
    },
    {
      day: 7,
      title: "Island Adventure & Snorkeling",
      detail:
        "Enjoy water sports and sightseeing."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Discover the best of Bali with luxury resorts, island adventures and unforgettable tropical experiences."
},
// ================= Maldives =================
{
  id: "maldives-budget-001",
  slug: "maldives-budget-trip",
  destination: "maldives",
  title: "Affordable Maldives Escape",
  duration: "3 Nights 4 Days",
  route: "3N Maldives",
  price: 59999,
  stars: 2,
  tags: ["🏝️ Budget Island Escape", "🌊 Tropical Relaxation"],
  rating: 4.3,

  images: [
    maldives
  ],

  includes: ["hotels", "transfers"],

  hotels: [
    {
      location: "Maldives",
      nights: "3 Nights",
      type: "2 Star Beach Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Beach Leisure Experience"
    },
    {
      title: "Island Exploration"
    },
    {
      title: "Sunset Viewing"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Speedboat Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Speedboat Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "3 Nights Accommodation",
    "Airport Transfers Included",
    "Beach Resort Stay"
  ],

  exclusions: [
    "Airfare",
    "Water Sports Activities",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Maldives",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Beach Leisure Day",
      detail:
        "Relax and enjoy island surroundings."
    },
    {
      day: 3,
      title: "Island Exploration",
      detail:
        "Explore local island attractions and beaches."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Enjoy the beauty of Maldives beaches and crystal-clear waters with this affordable island getaway."
},
{
  id: "maldives-budget-002",
  slug: "maldives-economy-tour",
  destination: "maldives",
  title: "Maldives Saver Retreat",
  duration: "4 Nights 5 Days",
  route: "4N Maldives",
  price: 74999,
  stars: 3,
  tags: ["🌊 Island Retreat", "🏖️ Budget Luxury"],
  rating: 4.5,

  images: [
    maldives
  ],

  includes: ["hotels", "transfers", "meals"],

  hotels: [
    {
      location: "Maldives",
      nights: "4 Nights",
      type: "3 Star Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "Island Leisure Experience"
    },
    {
      title: "Sunset Cruise"
    },
    {
      title: "Beach Activities"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Speedboat Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Speedboat Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Airport Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Water Sports Activities",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Maldives",
      detail:
        "Airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Beach Leisure Day",
      detail:
        "Relax and enjoy beachside activities."
    },
    {
      day: 3,
      title: "Sunset Cruise Experience",
      detail:
        "Enjoy scenic sunset views over the ocean."
    },
    {
      day: 4,
      title: "Island Exploration",
      detail:
        "Explore nearby beaches and attractions."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Experience Maldives island beauty and peaceful beaches with this budget-friendly resort package."
},
{
  id: "maldives-001",
  slug: "maldives-short-escape",
  destination: "maldives",
  title: "Ocean Paradise Retreat",
  duration: "3 Nights 4 Days",
  route: "3N Maldives",
  price: 79999,
  stars: 4,
  tags: ["🏝️ Tropical Escape", "🌊 Ocean Paradise"],
  rating: 4.7,

   images: [
    maldives
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Maldives",
      nights: "3 Nights",
      type: "4 Star Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "Beach Leisure Experience"
    },
    {
      title: "Sunset Cruise"
    },
    {
      title: "Island Exploration"
    },
    {
      title: "Snorkeling Adventure"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Resort",
      type: "Private Speedboat Transfer"
    },
    {
      from: "Resort",
      to: "Airport",
      type: "Private Speedboat Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Snorkeling Experience",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Water Sports Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Maldives",
      detail:
        "Airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Island Leisure Day",
      detail:
        "Relax and enjoy resort amenities."
    },
    {
      day: 3,
      title: "Snorkeling & Sunset Cruise",
      detail:
        "Enjoy water activities and scenic views."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Relax in paradise with crystal-clear waters, beaches and luxury island experiences in Maldives."
},
{
  id: "maldives-002",
  slug: "maldives-water-villa-tour",
  destination: "maldives",
  title: "Luxury Water Villa Escape",
  duration: "4 Nights 5 Days",
  route: "4N Maldives",
  price: 109999,
  stars: 5,
  tags: ["💎 Luxury Escape", "🏡 Water Villa Stay"],
  rating: 4.9,

   images: [
    maldives
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Maldives",
      nights: "4 Nights",
      type: "5 Star Water Villa Resort"
    }
  ],

  sightseeing: [
    {
      title: "Luxury Water Villa Experience"
    },
    {
      title: "Sunset Cruise"
    },
    {
      title: "Snorkeling Adventure"
    },
    {
      title: "Private Beach Access"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Resort",
      type: "Private Seaplane Transfer"
    },
    {
      from: "Resort",
      to: "Airport",
      type: "Private Seaplane Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "4 Nights Luxury Water Villa Stay",
    "Daily Breakfast Included",
    "Snorkeling & Cruise Experience",
    "Private Seaplane Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Premium Water Sports Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Maldives",
      detail:
        "Seaplane transfer and villa check-in."
    },
    {
      day: 2,
      title: "Beach & Water Activities",
      detail:
        "Enjoy snorkeling and water adventures."
    },
    {
      day: 3,
      title: "Sunset Cruise Experience",
      detail:
        "Relax with scenic sunset views."
    },
    {
      day: 4,
      title: "Luxury Leisure Day",
      detail:
        "Enjoy resort spa and private beach."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Experience ultimate luxury and romance with a stunning Maldives water villa getaway."
},
{
  id: "maldives-003",
  slug: "maldives-family-package",
  destination: "maldives",
  title: "Maldives Family Getaway",
  duration: "5 Nights 6 Days",
  route: "5N Maldives",
  price: 129999,
  stars: 5,
  tags: ["👨‍👩‍👧 Family Luxury", "🏖️ Island Adventure"],
  rating: 4.8,

   images: [
    maldives
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Maldives",
      nights: "5 Nights",
      type: "5 Star Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "Island Exploration"
    },
    {
      title: "Sunset Cruise"
    },
    {
      title: "Family Beach Activities"
    },
    {
      title: "Snorkeling Experience"
    },
    {
      title: "Resort Leisure Activities"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Resort",
      type: "Private Speedboat Transfer"
    },
    {
      from: "Resort",
      to: "Airport",
      type: "Private Speedboat Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Family Dinner Included"
    }
  ],

  inclusions: [
    "5 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Family-Friendly Activities",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Premium Water Sports Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Maldives",
      detail:
        "Airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Beach & Family Activities",
      detail:
        "Enjoy leisure and beachside fun."
    },
    {
      day: 3,
      title: "Island Exploration",
      detail:
        "Visit nearby islands and scenic spots."
    },
    {
      day: 4,
      title: "Snorkeling Adventure",
      detail:
        "Experience marine life and water activities."
    },
    {
      day: 5,
      title: "Resort Leisure Day",
      detail:
        "Relax and enjoy resort amenities."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Enjoy luxury beaches, family adventures and unforgettable island experiences in Maldives."
},
{
  id: "maldives-004",
  slug: "maldives-honeymoon-package",
  destination: "maldives",
  title: "Romantic Island Bliss",
  duration: "5 Nights 6 Days",
  route: "2N Beach Villa | 3N Water Villa",
  price: 149999,
  stars: 5,
  tags: ["💖 Honeymoon Special", "🌅 Romantic Luxury"],
  rating: 5.0,

  images: [
    beachvilla,
    watervilla
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Maldives",
      nights: "2 Nights",
      type: "5 Star Beach Villa"
    },
    {
      location: "Maldives",
      nights: "3 Nights",
      type: "5 Star Water Villa"
    }
  ],

  sightseeing: [
    {
      title: "Romantic Sunset Cruise"
    },
    {
      title: "Private Beach Dinner"
    },
    {
      title: "Snorkeling Experience"
    },
    {
      title: "Couple Spa Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Resort",
      type: "Private Seaplane Transfer"
    },
    {
      from: "Resort",
      to: "Airport",
      type: "Private Seaplane Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Candle Light Dinner Included"
    }
  ],

  inclusions: [
    "5 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic Dinner Experience",
    "Private Seaplane Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Premium Water Sports Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Maldives",
      detail:
        "Airport pickup and beach villa check-in."
    },
    {
      day: 2,
      title: "Beach Leisure Day",
      detail:
        "Relax and enjoy private beach experiences."
    },
    {
      day: 3,
      title: "Transfer to Water Villa",
      detail:
        "Experience luxury overwater accommodation."
    },
    {
      day: 4,
      title: "Snorkeling & Cruise",
      detail:
        "Enjoy marine adventures and scenic sunset views."
    },
    {
      day: 5,
      title: "Romantic Leisure Day",
      detail:
        "Spa experiences and candle light dinner."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Celebrate romance with luxury villas, ocean views and unforgettable experiences in Maldives."
},
{
  id: "maldives-005",
  slug: "grand-maldives-luxury-tour",
  destination: "maldives",
  title: "Ultimate Maldives Experience",
  duration: "6 Nights 7 Days",
  route: "3N Beach Villa | 3N Water Villa",
  price: 189999,
  stars: 5,
  tags: ["🌟 Ultimate Luxury", "🏝️ Premium Island Escape"],
  rating: 5.0,

  images: [
    beachvilla,
    watervilla
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Maldives",
      nights: "3 Nights",
      type: "5 Star Beach Villa"
    },
    {
      location: "Maldives",
      nights: "3 Nights",
      type: "5 Star Water Villa"
    }
  ],

  sightseeing: [
    {
      title: "Luxury Island Experience"
    },
    {
      title: "Private Sunset Cruise"
    },
    {
      title: "Snorkeling & Diving Adventure"
    },
    {
      title: "Private Beach Dinner"
    },
    {
      title: "Spa & Wellness Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Resort",
      type: "Private Seaplane Transfer"
    },
    {
      from: "Resort",
      to: "Airport",
      type: "Private Seaplane Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Dinners Included"
    }
  ],

  inclusions: [
    "6 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Luxury Experiences & Activities",
    "Private Seaplane Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Scuba Diving Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Maldives",
      detail:
        "Luxury seaplane transfer and resort check-in."
    },
    {
      day: 2,
      title: "Beach Villa Leisure",
      detail:
        "Relax and enjoy tropical surroundings."
    },
    {
      day: 3,
      title: "Snorkeling & Water Activities",
      detail:
        "Experience marine adventures and island beauty."
    },
    {
      day: 4,
      title: "Transfer to Water Villa",
      detail:
        "Enjoy luxury overwater accommodation."
    },
    {
      day: 5,
      title: "Private Cruise Experience",
      detail:
        "Relax with premium sunset cruise and dinner."
    },
    {
      day: 6,
      title: "Spa & Wellness Day",
      detail:
        "Enjoy spa therapies and resort luxury."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Discover the ultimate luxury island experience with water villas, ocean adventures and world-class hospitality in Maldives."
},
// ================= Singapore =================
{
  id: "singapore-budget-001",
  slug: "singapore-budget-trip",
  destination: "singapore",
  title: "Affordable Singapore Escape",
  duration: "3 Nights 4 Days",
  route: "3N Singapore",
  price: 44999,
  stars: 2,
  tags: ["🏙️ Budget Escape", "🛍️ City Explorer"],
  rating: 4.2,

  images: [
    singapore
  ],

  includes: ["hotels", "sightseeing", "transfers"],

  hotels: [
    {
      location: "Singapore",
      nights: "3 Nights",
      type: "2 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Singapore City Tour"
    },
    {
      title: "Marina Bay Sands Visit"
    },
    {
      title: "Merlion Park Tour"
    },
    {
      title: "Gardens By The Bay"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "3 Nights Accommodation",
    "Singapore City Sightseeing",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Singapore",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Singapore City Tour",
      detail:
        "Explore famous landmarks and attractions."
    },
    {
      day: 3,
      title: "Gardens By The Bay Visit",
      detail:
        "Enjoy futuristic gardens and city views."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Discover Singapore’s modern attractions and vibrant city life with this affordable holiday package."
},
{
  id: "singapore-budget-002",
  slug: "singapore-economy-tour",
  destination: "singapore",
  title: "Singapore Saver Journey",
  duration: "4 Nights 5 Days",
  route: "4N Singapore",
  price: 55999,
  stars: 3,
  tags: ["🌆 Modern Escape", "🏙️ Budget Holiday"],
  rating: 4.4,

  images: [
    singapore
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Singapore",
      nights: "4 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Singapore City Tour"
    },
    {
      title: "Sentosa Island Tour"
    },
    {
      title: "Universal Studios Visit"
    },
    {
      title: "Gardens By The Bay"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Singapore Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Singapore",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Singapore City Tour",
      detail:
        "Visit famous city attractions and landmarks."
    },
    {
      day: 3,
      title: "Sentosa Island Experience",
      detail:
        "Enjoy beaches and entertainment attractions."
    },
    {
      day: 4,
      title: "Universal Studios Visit",
      detail:
        "Experience rides and themed attractions."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Enjoy Singapore’s iconic attractions and entertainment experiences with this budget-friendly city package."
},
{
  id: "singapore-001",
  slug: "singapore-short-trip",
  destination: "singapore",
  title: "Singapore City Escape",
  duration: "3 Nights 4 Days",
  route: "3N Singapore",
  price: 61999,
  stars: 4,
  tags: ["🏙️ Luxury City Escape", "🌃 Modern Attractions"],
  rating: 4.6,

  images: [
    singapore
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Singapore",
      nights: "3 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Singapore City Tour"
    },
    {
      title: "Marina Bay Sands SkyPark"
    },
    {
      title: "Gardens By The Bay"
    },
    {
      title: "Clarke Quay Night Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Singapore Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Singapore",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "City Sightseeing Tour",
      detail:
        "Explore iconic landmarks and attractions."
    },
    {
      day: 3,
      title: "Gardens & Nightlife Experience",
      detail:
        "Enjoy futuristic gardens and nightlife attractions."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Experience Singapore’s luxury attractions, skyline views and vibrant nightlife with this exciting getaway."
},
{
  id: "singapore-002",
  slug: "singapore-family-tour",
  destination: "singapore",
  title: "Singapore Family Adventure",
  duration: "4 Nights 5 Days",
  route: "4N Singapore",
  price: 74999,
  stars: 4,
  tags: ["👨‍👩‍👧 Family Fun", "🎢 Entertainment Escape"],
  rating: 4.7,

  images: [
    singapore
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Singapore",
      nights: "4 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Universal Studios Singapore"
    },
    {
      title: "Sentosa Island Tour"
    },
    {
      title: "SEA Aquarium Visit"
    },
    {
      title: "Singapore Zoo Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Family Entertainment Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Singapore",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Universal Studios Visit",
      detail:
        "Enjoy thrilling rides and attractions."
    },
    {
      day: 3,
      title: "Sentosa Island Experience",
      detail:
        "Explore beaches and entertainment zones."
    },
    {
      day: 4,
      title: "Zoo & Aquarium Tour",
      detail:
        "Visit wildlife and marine attractions."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Enjoy exciting attractions, family entertainment and unforgettable experiences in Singapore."
},
{
  id: "singapore-003",
  slug: "singapore-sentosa-package",
  destination: "singapore",
  title: "Sentosa Island Getaway",
  duration: "5 Nights 6 Days",
  route: "3N Singapore | 2N Sentosa",
  price: 89999,
  stars: 5,
  tags: ["🏝️ Island Luxury", "🌆 Premium Escape"],
  rating: 4.8,

  images: [
    singapore,
    sentosa
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Singapore",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Sentosa",
      nights: "2 Nights",
      type: "5 Star Resort"
    }
  ],

  sightseeing: [
    {
      title: "Singapore City Tour"
    },
    {
      title: "Sentosa Island Experience"
    },
    {
      title: "Universal Studios Visit"
    },
    {
      title: "Marina Bay Sands"
    },
    {
      title: "Gardens By The Bay"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Singapore & Sentosa Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Singapore",
      detail:
        "Airport pickup and luxury hotel check-in."
    },
    {
      day: 2,
      title: "Singapore City Exploration",
      detail:
        "Visit major attractions and shopping areas."
    },
    {
      day: 3,
      title: "Transfer to Sentosa",
      detail:
        "Enjoy island entertainment and beaches."
    },
    {
      day: 4,
      title: "Universal Studios Experience",
      detail:
        "Enjoy rides and themed attractions."
    },
    {
      day: 5,
      title: "Leisure Day",
      detail:
        "Relax and enjoy resort facilities."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Discover luxury, entertainment and island beauty with this Singapore and Sentosa holiday package."
},
{
  id: "singapore-004",
  slug: "singapore-malaysia-tour",
  destination: "singapore",
  title: "Twin Nation Explorer",
  duration: "6 Nights 7 Days",
  route: "3N Singapore | 3N Kuala Lumpur",
  price: 99999,
  stars: 5,
  tags: ["🌏 Twin Country Tour", "🏙️ Asian Explorer"],
  rating: 4.9,

  images: [
    singapore,
    kualaLumpur
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Singapore",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Kuala Lumpur",
      nights: "3 Nights",
      type: "5 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Singapore City Tour"
    },
    {
      title: "Sentosa Island Tour"
    },
    {
      title: "Petronas Twin Towers Visit"
    },
    {
      title: "Kuala Lumpur City Tour"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "6 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Singapore & Malaysia Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Singapore",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Singapore Sightseeing",
      detail:
        "Explore major city attractions."
    },
    {
      day: 3,
      title: "Sentosa Island Tour",
      detail:
        "Enjoy beaches and entertainment activities."
    },
    {
      day: 4,
      title: "Transfer to Kuala Lumpur",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 5,
      title: "Kuala Lumpur City Tour",
      detail:
        "Visit famous landmarks and shopping areas."
    },
    {
      day: 6,
      title: "Petronas Towers Experience",
      detail:
        "Explore iconic city attractions."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Explore the best attractions of Singapore and Malaysia with this exciting twin-country holiday package."
},
{
  id: "singapore-005",
  slug: "grand-singapore-luxury-tour",
  destination: "singapore",
  title: "Ultimate Singapore Experience",
  duration: "7 Nights 8 Days",
  route: "4N Singapore | 3N Sentosa",
  price: 129999,
  stars: 5,
  tags: ["🌟 Ultimate Luxury", "🏝️ Premium Family Escape"],
  rating: 5.0,

  images: [
    singapore,
    sentosa
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Singapore",
      nights: "4 Nights",
      type: "5 Star Luxury Hotel"
    },
    {
      location: "Sentosa",
      nights: "3 Nights",
      type: "5 Star Luxury Resort"
    }
  ],

  sightseeing: [
    {
      title: "Singapore City Tour"
    },
    {
      title: "Universal Studios Singapore"
    },
    {
      title: "Sentosa Island Experience"
    },
    {
      title: "Gardens By The Bay"
    },
    {
      title: "Marina Bay Sands SkyPark"
    },
    {
      title: "SEA Aquarium Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Dinners Included"
    }
  ],

  inclusions: [
    "7 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Singapore Attractions",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Singapore",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Singapore City Exploration",
      detail:
        "Visit iconic attractions and shopping districts."
    },
    {
      day: 3,
      title: "Gardens & Marina Experience",
      detail:
        "Explore futuristic attractions and skyline views."
    },
    {
      day: 4,
      title: "Transfer to Sentosa",
      detail:
        "Relax at luxury beach resort."
    },
    {
      day: 5,
      title: "Universal Studios Adventure",
      detail:
        "Enjoy entertainment and themed attractions."
    },
    {
      day: 6,
      title: "SEA Aquarium & Leisure",
      detail:
        "Explore marine life and island attractions."
    },
    {
      day: 7,
      title: "Luxury Leisure Day",
      detail:
        "Enjoy premium resort experiences."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Experience the ultimate luxury holiday with Singapore’s iconic attractions, entertainment and premium island resorts."
},
// ================= Malaysia =================
{
  id: "malaysia-budget-001",
  slug: "malaysia-budget-trip",
  destination: "malaysia",
  title: "Affordable Malaysia Escape",
  duration: "3 Nights 4 Days",
  route: "3N Kuala Lumpur",
  price: 34999,
  stars: 2,
  tags: ["🏙️ Budget Escape", "🛍️ City Explorer"],
  rating: 4.2,

  images: [
    kualaLumpur
  ],

  includes: ["hotels", "sightseeing", "transfers"],

  hotels: [
    {
      location: "Kuala Lumpur",
      nights: "3 Nights",
      type: "2 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Kuala Lumpur City Tour"
    },
    {
      title: "Petronas Twin Towers Visit"
    },
    {
      title: "Batu Caves Tour"
    },
    {
      title: "Local Market Exploration"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "3 Nights Accommodation",
    "Kuala Lumpur Sightseeing",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Kuala Lumpur",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "City Sightseeing Tour",
      detail:
        "Visit iconic attractions and shopping areas."
    },
    {
      day: 3,
      title: "Batu Caves & Market Visit",
      detail:
        "Explore cultural attractions and local markets."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Discover Malaysia’s vibrant city attractions and culture with this affordable Kuala Lumpur getaway."
},
{
  id: "malaysia-budget-002",
  slug: "malaysia-economy-tour",
  destination: "malaysia",
  title: "Malaysia Saver Journey",
  duration: "5 Nights 6 Days",
  route: "3N Kuala Lumpur | 2N Langkawi",
  price: 49999,
  stars: 3,
  tags: ["🏝️ Island Escape", "🌆 Budget Adventure"],
  rating: 4.4,

  images: [
    kualaLumpur,
    langkawi
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Kuala Lumpur",
      nights: "3 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Langkawi",
      nights: "2 Nights",
      type: "3 Star Resort"
    }
  ],

  sightseeing: [
    {
      title: "Kuala Lumpur City Tour"
    },
    {
      title: "Petronas Twin Towers"
    },
    {
      title: "Langkawi Island Tour"
    },
    {
      title: "Langkawi Cable Car Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Malaysia Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Kuala Lumpur",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Kuala Lumpur Sightseeing",
      detail:
        "Visit major attractions and landmarks."
    },
    {
      day: 3,
      title: "Transfer to Langkawi",
      detail:
        "Travel to Langkawi and leisure evening."
    },
    {
      day: 4,
      title: "Langkawi Island Tour",
      detail:
        "Explore beaches and island attractions."
    },
    {
      day: 5,
      title: "Cable Car Experience",
      detail:
        "Enjoy scenic mountain and island views."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Enjoy the perfect mix of city attractions and tropical beaches with this Malaysia holiday package."
},
{
  id: "malaysia-001",
  slug: "kuala-lumpur-short-trip",
  destination: "malaysia",
  title: "Malaysia City Escape",
  duration: "3 Nights 4 Days",
  route: "3N Kuala Lumpur",
  price: 49999,
  stars: 4,
  tags: ["🌆 City Luxury", "🏙️ Modern Escape"],
  rating: 4.6,

  images: [
    kualaLumpur
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Kuala Lumpur",
      nights: "3 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Kuala Lumpur City Tour"
    },
    {
      title: "Petronas Twin Towers Visit"
    },
    {
      title: "Batu Caves Tour"
    },
    {
      title: "KL Tower Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Kuala Lumpur Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Kuala Lumpur",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "City Exploration",
      detail:
        "Visit iconic attractions and shopping areas."
    },
    {
      day: 3,
      title: "KL Tower & Batu Caves",
      detail:
        "Explore cultural and modern landmarks."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Experience Malaysia’s modern skyline, attractions and shopping with this exciting city holiday package."
},
{
  id: "malaysia-002",
  slug: "kuala-lumpur-langkawi-tour",
  destination: "malaysia",
  title: "Malaysia Beach & City Tour",
  duration: "5 Nights 6 Days",
  route: "3N Kuala Lumpur | 2N Langkawi",
  price: 64999,
  stars: 4,
  tags: ["🏖️ Beach Escape", "🌆 City Adventure"],
  rating: 4.7,

 images: [
    kualaLumpur,
    langkawi
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Kuala Lumpur",
      nights: "3 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Langkawi",
      nights: "2 Nights",
      type: "4 Star Resort"
    }
  ],

  sightseeing: [
    {
      title: "Kuala Lumpur City Tour"
    },
    {
      title: "Petronas Twin Towers"
    },
    {
      title: "Langkawi Island Tour"
    },
    {
      title: "Cable Car & Sky Bridge Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Malaysia Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Kuala Lumpur",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "City Sightseeing Tour",
      detail:
        "Explore famous landmarks and shopping districts."
    },
    {
      day: 3,
      title: "Transfer to Langkawi",
      detail:
        "Travel to island resort and leisure evening."
    },
    {
      day: 4,
      title: "Langkawi Island Exploration",
      detail:
        "Enjoy beaches and island attractions."
    },
    {
      day: 5,
      title: "Cable Car & Sky Bridge",
      detail:
        "Experience panoramic island views."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Enjoy Malaysia’s vibrant cities and tropical island beauty with this unforgettable holiday package."
},
{
  id: "malaysia-003",
  slug: "langkawi-penang-package",
  destination: "malaysia",
  title: "Island & Heritage Escape",
  duration: "6 Nights 7 Days",
  route: "3N Langkawi | 3N Penang",
  price: 75999,
  stars: 4,
  tags: ["🏝️ Island Escape", "🏛️ Heritage Journey"],
  rating: 4.8,

  images: [
    langkawi,
    penang
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Langkawi",
      nights: "3 Nights",
      type: "4 Star Resort"
    },
    {
      location: "Penang",
      nights: "3 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Langkawi Island Tour"
    },
    {
      title: "Cable Car Experience"
    },
    {
      title: "Penang Heritage Tour"
    },
    {
      title: "Georgetown Exploration"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Island & Heritage Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Langkawi",
      detail:
        "Airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Island Tour",
      detail:
        "Explore beaches and island attractions."
    },
    {
      day: 3,
      title: "Cable Car Adventure",
      detail:
        "Enjoy scenic mountain and island views."
    },
    {
      day: 4,
      title: "Transfer to Penang",
      detail:
        "Travel and explore local surroundings."
    },
    {
      day: 5,
      title: "Penang Heritage Tour",
      detail:
        "Visit Georgetown and cultural attractions."
    },
    {
      day: 6,
      title: "Local Exploration",
      detail:
        "Enjoy food streets and sightseeing."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Discover Malaysia’s tropical islands and rich cultural heritage with this exciting holiday package."
},
{
  id: "malaysia-004",
  slug: "malaysia-honeymoon-package",
  destination: "malaysia",
  title: "Romantic Malaysia Retreat",
  duration: "6 Nights 7 Days",
  route: "3N Kuala Lumpur | 3N Langkawi",
  price: 89999,
  stars: 5,
  tags: ["💖 Honeymoon Escape", "🌴 Luxury Retreat"],
  rating: 4.9,

  images: [
    kualaLumpur,
    langkawi
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Kuala Lumpur",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Langkawi",
      nights: "3 Nights",
      type: "5 Star Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "Kuala Lumpur City Tour"
    },
    {
      title: "Petronas Twin Towers"
    },
    {
      title: "Langkawi Sunset Cruise"
    },
    {
      title: "Beach Leisure Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "6 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic Cruise Experience",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Kuala Lumpur",
      detail:
        "Airport pickup and luxury hotel check-in."
    },
    {
      day: 2,
      title: "City Exploration",
      detail:
        "Visit major attractions and shopping areas."
    },
    {
      day: 3,
      title: "Transfer to Langkawi",
      detail:
        "Relax at luxury beach resort."
    },
    {
      day: 4,
      title: "Beach & Sunset Cruise",
      detail:
        "Enjoy romantic beach experiences."
    },
    {
      day: 5,
      title: "Leisure Day",
      detail:
        "Relax and enjoy resort facilities."
    },
    {
      day: 6,
      title: "Island Exploration",
      detail:
        "Visit scenic attractions and beaches."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Celebrate romance with luxury stays, tropical beaches and unforgettable experiences in Malaysia."
},
{
  id: "malaysia-005",
  slug: "grand-malaysia-tour",
  destination: "malaysia",
  title: "Ultimate Malaysia Explorer",
  duration: "8 Nights 9 Days",
  route: "3N Kuala Lumpur | 2N Langkawi | 3N Penang",
  price: 119999,
  stars: 5,
  tags: ["🌟 Grand Malaysia Tour", "🏝️ Luxury Adventure"],
  rating: 5.0,

  images: [
    kualaLumpur,
    langkawi,
    penang
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Kuala Lumpur",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Langkawi",
      nights: "2 Nights",
      type: "5 Star Resort"
    },
    {
      location: "Penang",
      nights: "3 Nights",
      type: "5 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Kuala Lumpur City Tour"
    },
    {
      title: "Petronas Twin Towers"
    },
    {
      title: "Langkawi Cable Car Experience"
    },
    {
      title: "Penang Heritage Tour"
    },
    {
      title: "Georgetown Exploration"
    },
    {
      title: "Island Beach Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Dinners Included"
    }
  ],

  inclusions: [
    "8 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Malaysia Premium Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Kuala Lumpur",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "City Sightseeing",
      detail:
        "Explore landmarks and shopping districts."
    },
    {
      day: 3,
      title: "Leisure & Exploration",
      detail:
        "Enjoy local attractions and nightlife."
    },
    {
      day: 4,
      title: "Transfer to Langkawi",
      detail:
        "Relax at luxury island resort."
    },
    {
      day: 5,
      title: "Island Adventure",
      detail:
        "Enjoy beaches and cable car attractions."
    },
    {
      day: 6,
      title: "Transfer to Penang",
      detail:
        "Explore cultural and heritage attractions."
    },
    {
      day: 7,
      title: "Penang Heritage Tour",
      detail:
        "Visit Georgetown and famous landmarks."
    },
    {
      day: 8,
      title: "Leisure Day",
      detail:
        "Relax and explore local experiences."
    },
    {
      day: 9,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Discover Malaysia’s cities, beaches and cultural heritage with this ultimate luxury holiday package."
},
// ================= Vietnam =================
{
  id: "vietnam-budget-001",
  slug: "vietnam-budget-trip",
  destination: "vietnam",
  title: "Affordable Vietnam Escape",
  duration: "4 Nights 5 Days",
  route: "3N Hanoi | 1N Halong Bay",
  price: 32999,
  stars: 2,
  tags: ["🏮 Budget Escape", "🌊 Bay Experience"],
  rating: 4.2,

  images: [
   hanoi,
   halongBay
  ],

  includes: ["hotels", "sightseeing", "transfers"],

  hotels: [
    {
      location: "Hanoi",
      nights: "3 Nights",
      type: "2 Star Hotel"
    },
    {
      location: "Halong Bay",
      nights: "1 Night",
      type: "2 Star Cruise Stay"
    }
  ],

  sightseeing: [
    {
      title: "Hanoi City Tour"
    },
    {
      title: "Halong Bay Cruise Experience"
    },
    {
      title: "Old Quarter Exploration"
    },
    {
      title: "Temple Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "4 Nights Accommodation",
    "Vietnam Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Hanoi",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Hanoi City Tour",
      detail:
        "Explore cultural landmarks and attractions."
    },
    {
      day: 3,
      title: "Transfer to Halong Bay",
      detail:
        "Enjoy scenic cruise and island views."
    },
    {
      day: 4,
      title: "Return to Hanoi",
      detail:
        "Leisure time and market exploration."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Experience Vietnam’s cultural beauty and scenic Halong Bay with this affordable getaway package."
},
{
  id: "vietnam-budget-002",
  slug: "vietnam-economy-tour",
  destination: "vietnam",
  title: "Vietnam Saver Journey",
  duration: "5 Nights 6 Days",
  route: "3N Hanoi | 2N Da Nang",
  price: 44999,
  stars: 3,
  tags: ["🏖️ Coastal Escape", "🏮 Cultural Journey"],
  rating: 4.4,

  images: [
   hanoi,
   daNang
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Hanoi",
      nights: "3 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Da Nang",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Hanoi City Tour"
    },
    {
      title: "Halong Bay Excursion"
    },
    {
      title: "Da Nang Beach Experience"
    },
    {
      title: "Dragon Bridge Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Vietnam Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Hanoi",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Hanoi Exploration",
      detail:
        "Visit cultural and historical attractions."
    },
    {
      day: 3,
      title: "Halong Bay Excursion",
      detail:
        "Enjoy cruise experience and scenic views."
    },
    {
      day: 4,
      title: "Transfer to Da Nang",
      detail:
        "Travel and beach leisure time."
    },
    {
      day: 5,
      title: "Da Nang City Tour",
      detail:
        "Explore beaches and city attractions."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Discover Vietnam’s culture, beaches and scenic landscapes with this budget-friendly holiday package."
},
{
  id: "vietnam-001",
  slug: "hanoi-short-trip",
  destination: "vietnam",
  title: "Vietnam Cultural Escape",
  duration: "3 Nights 4 Days",
  route: "3N Hanoi",
  price: 42999,
  stars: 4,
  tags: ["🏮 Cultural Journey", "🌆 City Escape"],
  rating: 4.6,

  images: [
   hanoi,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Hanoi",
      nights: "3 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Hanoi City Tour"
    },
    {
      title: "Old Quarter Exploration"
    },
    {
      title: "Temple of Literature Visit"
    },
    {
      title: "Local Market Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "3 Nights Accommodation",
    "Daily Breakfast Included",
    "Hanoi Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Hanoi",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Cultural City Tour",
      detail:
        "Visit temples, markets and local attractions."
    },
    {
      day: 3,
      title: "Old Quarter Experience",
      detail:
        "Explore local culture and street food areas."
    },
    {
      day: 4,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Experience Vietnam’s rich culture, history and local charm with this Hanoi city holiday package."
},
{
  id: "vietnam-002",
  slug: "hanoi-halong-tour",
  destination: "vietnam",
  title: "Halong Bay Discovery",
  duration: "5 Nights 6 Days",
  route: "3N Hanoi | 2N Halong Bay",
  price: 58999,
  stars: 4,
  tags: ["🌊 Bay Adventure", "🏮 Cultural Escape"],
  rating: 4.7,

  images: [
    hanoi,
    halongBay
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Hanoi",
      nights: "3 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Halong Bay",
      nights: "2 Nights",
      type: "4 Star Cruise Stay"
    }
  ],

  sightseeing: [
    {
      title: "Hanoi City Tour"
    },
    {
      title: "Halong Bay Cruise"
    },
    {
      title: "Cave Exploration"
    },
    {
      title: "Sunset Deck Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Halong Bay Cruise Experience",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Hanoi",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Hanoi Sightseeing",
      detail:
        "Explore cultural attractions and markets."
    },
    {
      day: 3,
      title: "Transfer to Halong Bay",
      detail:
        "Board cruise and enjoy scenic views."
    },
    {
      day: 4,
      title: "Cruise & Cave Exploration",
      detail:
        "Enjoy water activities and sightseeing."
    },
    {
      day: 5,
      title: "Return to Hanoi",
      detail:
        "Leisure and local exploration."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Explore Vietnam’s cultural beauty and breathtaking Halong Bay with this exciting holiday package."
},
{
  id: "vietnam-003",
  slug: "danang-hoi-an-package",
  destination: "vietnam",
  title: "Vietnam Coastal Journey",
  duration: "6 Nights 7 Days",
  route: "3N Da Nang | 3N Hoi An",
  price: 72999,
  stars: 4,
  tags: ["🏖️ Coastal Escape", "🏮 Heritage Experience"],
  rating: 4.8,

  images: [
    daNang,
    hoiAn
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Da Nang",
      nights: "3 Nights",
      type: "4 Star Beach Resort"
    },
    {
      location: "Hoi An",
      nights: "3 Nights",
      type: "4 Star Heritage Resort"
    }
  ],

  sightseeing: [
    {
      title: "Da Nang Beach Tour"
    },
    {
      title: "Golden Bridge Visit"
    },
    {
      title: "Hoi An Ancient Town"
    },
    {
      title: "Lantern Market Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Vietnam Coastal Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Da Nang",
      detail:
        "Airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Golden Bridge Tour",
      detail:
        "Visit iconic bridge and mountain attractions."
    },
    {
      day: 3,
      title: "Beach Leisure Day",
      detail:
        "Relax and enjoy beachside experiences."
    },
    {
      day: 4,
      title: "Transfer to Hoi An",
      detail:
        "Explore ancient town and local markets."
    },
    {
      day: 5,
      title: "Hoi An Exploration",
      detail:
        "Experience heritage attractions and lantern streets."
    },
    {
      day: 6,
      title: "Local Leisure Day",
      detail:
        "Relax and explore nearby attractions."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Discover Vietnam’s coastal beauty, beaches and cultural heritage with this unforgettable holiday package."
},
{
  id: "vietnam-004",
  slug: "vietnam-honeymoon-package",
  destination: "vietnam",
  title: "Romantic Vietnam Escape",
  duration: "6 Nights 7 Days",
  route: "3N Da Nang | 3N Phu Quoc",
  price: 89999,
  stars: 5,
  tags: ["💖 Honeymoon Escape", "🏝️ Luxury Beaches"],
  rating: 4.9,

  images: [
    daNang,
    phuQuoc
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Da Nang",
      nights: "3 Nights",
      type: "5 Star Beach Resort"
    },
    {
      location: "Phu Quoc",
      nights: "3 Nights",
      type: "5 Star Luxury Resort"
    }
  ],

  sightseeing: [
    {
      title: "Da Nang Beach Tour"
    },
    {
      title: "Golden Bridge Visit"
    },
    {
      title: "Phu Quoc Island Experience"
    },
    {
      title: "Romantic Sunset Dinner"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "6 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic Experiences Included",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Da Nang",
      detail:
        "Airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Golden Bridge Experience",
      detail:
        "Visit iconic attractions and scenic views."
    },
    {
      day: 3,
      title: "Beach Leisure Day",
      detail:
        "Relax and enjoy luxury beach resort."
    },
    {
      day: 4,
      title: "Transfer to Phu Quoc",
      detail:
        "Travel to tropical island resort."
    },
    {
      day: 5,
      title: "Island Exploration",
      detail:
        "Enjoy beaches and island attractions."
    },
    {
      day: 6,
      title: "Romantic Dinner Experience",
      detail:
        "Celebrate with candle light dinner."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Celebrate romance with luxury beaches, island resorts and unforgettable experiences in Vietnam."
},
{
  id: "vietnam-005",
  slug: "grand-vietnam-tour",
  destination: "vietnam",
  title: "Ultimate Vietnam Explorer",
  duration: "8 Nights 9 Days",
  route: "3N Hanoi | 2N Halong Bay | 3N Ho Chi Minh City",
  price: 119999,
  stars: 5,
  tags: ["🌟 Grand Vietnam Tour", "🏮 Luxury Explorer"],
  rating: 5.0,

  images: [
    hanoi,
    halongBay,
    hochiminhcity
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Hanoi",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Halong Bay",
      nights: "2 Nights",
      type: "5 Star Luxury Cruise"
    },
    {
      location: "Ho Chi Minh City",
      nights: "3 Nights",
      type: "5 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Hanoi City Tour"
    },
    {
      title: "Halong Bay Luxury Cruise"
    },
    {
      title: "Ho Chi Minh City Tour"
    },
    {
      title: "Cu Chi Tunnel Experience"
    },
    {
      title: "Local Market Exploration"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Dinners Included"
    }
  ],

  inclusions: [
    "8 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Vietnam Premium Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Hanoi",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Hanoi Cultural Tour",
      detail:
        "Explore temples, markets and city attractions."
    },
    {
      day: 3,
      title: "Transfer to Halong Bay",
      detail:
        "Board luxury cruise and enjoy scenic landscapes."
    },
    {
      day: 4,
      title: "Cruise & Cave Exploration",
      detail:
        "Enjoy luxury cruise activities and sightseeing."
    },
    {
      day: 5,
      title: "Transfer to Ho Chi Minh City",
      detail:
        "Arrival and evening leisure."
    },
    {
      day: 6,
      title: "City Exploration",
      detail:
        "Visit museums, markets and famous landmarks."
    },
    {
      day: 7,
      title: "Cu Chi Tunnel Experience",
      detail:
        "Explore historical attractions and local culture."
    },
    {
      day: 8,
      title: "Leisure Day",
      detail:
        "Relax and enjoy premium city experiences."
    },
    {
      day: 9,
      title: "Departure",
      detail:
        "Airport transfer for return journey."
    }
  ],

  overview:
    "Discover Vietnam’s culture, luxury cruises and vibrant cities with this ultimate premium holiday package."
},
// ================= Mauritius =================
{
  id: "mauritius-budget-001",
  slug: "mauritius-budget-trip",
  destination: "mauritius",
  title: "Affordable Mauritius Escape",
  duration: "4 Nights 5 Days",
  route: "4N Mauritius",
  price: 69999,
  stars: 2,
  tags: ["🏝️ Budget Island Escape", "🌊 Beach Relaxation"],
  rating: 4.2,

  images: [
    mauritius
  ],

  includes: ["hotels", "transfers"],

  hotels: [
    {
      location: "Mauritius",
      nights: "4 Nights",
      type: "2 Star Beach Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Beach Leisure Experience"
    },
    {
      title: "Local Island Exploration"
    },
    {
      title: "Sunset Beach Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "4 Nights Accommodation",
    "Airport Transfers Included",
    "Beach Resort Stay"
  ],

  exclusions: [
    "Airfare",
    "Water Sports Activities",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Mauritius",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Beach Leisure Day",
      detail:
        "Relax and enjoy island surroundings."
    },
    {
      day: 3,
      title: "Island Exploration",
      detail:
        "Explore nearby attractions and beaches."
    },
    {
      day: 4,
      title: "Leisure & Relaxation",
      detail:
        "Enjoy resort amenities and scenic views."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Enjoy tropical beaches and island beauty with this affordable Mauritius holiday package."
},
{
  id: "mauritius-budget-002",
  slug: "mauritius-economy-tour",
  destination: "mauritius",
  title: "Mauritius Saver Retreat",
  duration: "5 Nights 6 Days",
  route: "5N Mauritius",
  price: 89999,
  stars: 3,
  tags: ["🌴 Island Retreat", "🏖️ Budget Luxury"],
  rating: 4.4,

  images: [
    mauritius
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Mauritius",
      nights: "5 Nights",
      type: "3 Star Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "North Island Tour"
    },
    {
      title: "South Island Tour"
    },
    {
      title: "Beach Leisure Experience"
    },
    {
      title: "Local Market Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Mauritius Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Water Sports Activities",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Mauritius",
      detail:
        "Airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "North Island Tour",
      detail:
        "Explore beaches and local attractions."
    },
    {
      day: 3,
      title: "Beach Leisure Day",
      detail:
        "Relax and enjoy island beauty."
    },
    {
      day: 4,
      title: "South Island Tour",
      detail:
        "Visit scenic viewpoints and attractions."
    },
    {
      day: 5,
      title: "Local Exploration",
      detail:
        "Explore markets and nearby attractions."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Experience Mauritius beaches, island attractions and tropical relaxation with this budget-friendly package."
},
{
  id: "mauritius-001",
  slug: "mauritius-short-escape",
  destination: "mauritius",
  title: "Tropical Island Retreat",
  duration: "4 Nights 5 Days",
  route: "4N Mauritius",
  price: 94999,
  stars: 4,
  tags: ["🏝️ Tropical Escape", "🌊 Island Adventure"],
  rating: 4.6,

   images: [
    mauritius
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Mauritius",
      nights: "4 Nights",
      type: "4 Star Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "North Island Tour"
    },
    {
      title: "Beach Activities"
    },
    {
      title: "Local Market Experience"
    },
    {
      title: "Sunset Beach Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Resort",
      type: "Private Transfer"
    },
    {
      from: "Resort",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Resort",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Mauritius Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Water Sports Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Mauritius",
      detail:
        "Airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Island Exploration",
      detail:
        "Visit scenic attractions and beaches."
    },
    {
      day: 3,
      title: "Beach Leisure Day",
      detail:
        "Enjoy resort amenities and water activities."
    },
    {
      day: 4,
      title: "Local Experience",
      detail:
        "Explore markets and island culture."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Relax on tropical beaches and enjoy island adventures with this Mauritius holiday package."
},
{
  id: "mauritius-002",
  slug: "mauritius-family-tour",
  destination: "mauritius",
  title: "Mauritius Beach Adventure",
  duration: "5 Nights 6 Days",
  route: "5N Mauritius",
  price: 119999,
  stars: 5,
  tags: ["👨‍👩‍👧 Family Luxury", "🏖️ Beach Adventure"],
  rating: 4.8,

   images: [
    mauritius
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Mauritius",
      nights: "5 Nights",
      type: "5 Star Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "Island Sightseeing Tour"
    },
    {
      title: "Family Beach Activities"
    },
    {
      title: "Casela Nature Park Visit"
    },
    {
      title: "Sunset Cruise Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Resort",
      type: "Private Luxury Transfer"
    },
    {
      from: "Resort",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Resort",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Family Dinner Included"
    }
  ],

  inclusions: [
    "5 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Family Activities Included",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Adventure Sports Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Mauritius",
      detail:
        "Airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Beach & Resort Leisure",
      detail:
        "Enjoy family-friendly resort experiences."
    },
    {
      day: 3,
      title: "Nature Park Adventure",
      detail:
        "Explore wildlife and outdoor activities."
    },
    {
      day: 4,
      title: "Island Sightseeing",
      detail:
        "Visit scenic attractions and beaches."
    },
    {
      day: 5,
      title: "Sunset Cruise Experience",
      detail:
        "Enjoy scenic ocean views and relaxation."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Create unforgettable family memories with luxury beaches, island adventures and premium experiences in Mauritius."
},
{
  id: "mauritius-003",
  slug: "mauritius-honeymoon-package",
  destination: "mauritius",
  title: "Romantic Island Bliss",
  duration: "6 Nights 7 Days",
  route: "6N Mauritius",
  price: 139999,
  stars: 5,
  tags: ["💖 Honeymoon Escape", "🌅 Romantic Luxury"],
  rating: 4.9,

   images: [
    mauritius
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Mauritius",
      nights: "6 Nights",
      type: "5 Star Luxury Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "Romantic Beach Experience"
    },
    {
      title: "Sunset Cruise"
    },
    {
      title: "Private Candle Light Dinner"
    },
    {
      title: "Island Exploration"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Resort",
      type: "Private Luxury Transfer"
    },
    {
      from: "Resort",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Resort",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "6 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic Experiences Included",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Adventure Sports Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Mauritius",
      detail:
        "Luxury airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Beach Leisure Day",
      detail:
        "Relax and enjoy luxury beach experiences."
    },
    {
      day: 3,
      title: "Island Exploration",
      detail:
        "Visit scenic attractions and beaches."
    },
    {
      day: 4,
      title: "Sunset Cruise Experience",
      detail:
        "Enjoy romantic ocean views and dinner."
    },
    {
      day: 5,
      title: "Resort Leisure Day",
      detail:
        "Relax with spa and premium amenities."
    },
    {
      day: 6,
      title: "Private Romantic Experience",
      detail:
        "Celebrate with candle light dinner."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Celebrate romance with luxury resorts, tropical beaches and unforgettable experiences in Mauritius."
},
{
  id: "mauritius-004",
  slug: "mauritius-luxury-retreat",
  destination: "mauritius",
  title: "Luxury Ocean Escape",
  duration: "7 Nights 8 Days",
  route: "7N Mauritius",
  price: 169999,
  stars: 5,
  tags: ["🌊 Ocean Luxury", "🏝️ Premium Retreat"],
  rating: 5.0,

   images: [
    mauritius
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Mauritius",
      nights: "7 Nights",
      type: "5 Star Luxury Ocean Resort"
    }
  ],

  sightseeing: [
    {
      title: "Island Exploration"
    },
    {
      title: "Luxury Catamaran Cruise"
    },
    {
      title: "Private Beach Experience"
    },
    {
      title: "Spa & Wellness Session"
    },
    {
      title: "Adventure Water Activities"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Resort",
      type: "Private Luxury Transfer"
    },
    {
      from: "Resort",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Resort",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Dinners Included"
    }
  ],

  inclusions: [
    "7 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Luxury Experiences Included",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Scuba Diving Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Mauritius",
      detail:
        "Luxury airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Beach Leisure Day",
      detail:
        "Relax and enjoy oceanfront experiences."
    },
    {
      day: 3,
      title: "Catamaran Cruise",
      detail:
        "Enjoy luxury cruise and island exploration."
    },
    {
      day: 4,
      title: "Adventure Activities",
      detail:
        "Experience water sports and beach fun."
    },
    {
      day: 5,
      title: "Spa & Wellness Day",
      detail:
        "Relax with premium spa therapies."
    },
    {
      day: 6,
      title: "Island Sightseeing",
      detail:
        "Explore scenic attractions and local culture."
    },
    {
      day: 7,
      title: "Luxury Leisure Day",
      detail:
        "Enjoy premium resort amenities."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Experience ultimate luxury, tropical beaches and premium island experiences with this Mauritius retreat."
},
{
  id: "mauritius-005",
  slug: "grand-mauritius-tour",
  destination: "mauritius",
  title: "Ultimate Mauritius Experience",
  duration: "8 Nights 9 Days",
  route: "5N Mauritius | 3N Beach Resort",
  price: 199999,
  stars: 5,
  tags: ["🌟 Ultimate Luxury", "🏝️ Premium Island Escape"],
  rating: 5.0,

   images: [
    mauritius,
    beachresort
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Mauritius",
      nights: "5 Nights",
      type: "5 Star Luxury Resort"
    },
    {
      location: "Beach Resort",
      nights: "3 Nights",
      type: "5 Star Premium Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "Luxury Island Exploration"
    },
    {
      title: "Catamaran Cruise Experience"
    },
    {
      title: "Private Beach Leisure"
    },
    {
      title: "Spa & Wellness Experience"
    },
    {
      title: "Adventure Water Sports"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Resort",
      type: "Private Luxury Transfer"
    },
    {
      from: "Resort",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Resort",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Dinners Included"
    }
  ],

  inclusions: [
    "8 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Island Experiences",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Scuba Diving Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Mauritius",
      detail:
        "Luxury airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Island Exploration",
      detail:
        "Visit scenic beaches and attractions."
    },
    {
      day: 3,
      title: "Luxury Cruise Experience",
      detail:
        "Enjoy premium ocean cruise and activities."
    },
    {
      day: 4,
      title: "Adventure Water Activities",
      detail:
        "Experience snorkeling and water sports."
    },
    {
      day: 5,
      title: "Spa & Wellness Day",
      detail:
        "Relax with luxury spa therapies."
    },
    {
      day: 6,
      title: "Transfer to Beach Resort",
      detail:
        "Enjoy premium beachside luxury stay."
    },
    {
      day: 7,
      title: "Private Beach Leisure",
      detail:
        "Relax and enjoy tropical surroundings."
    },
    {
      day: 8,
      title: "Luxury Leisure Day",
      detail:
        "Enjoy premium resort amenities and dining."
    },
    {
      day: 9,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Discover the ultimate luxury island experience with tropical beaches, premium resorts and unforgettable adventures in Mauritius."
},
// ================= Bhutan =================
{
  id: "bhutan-budget-001",
  slug: "bhutan-budget-trip",
  destination: "bhutan",
  title: "Affordable Bhutan Escape",
  duration: "4 Nights 5 Days",
  route: "2N Thimphu | 2N Paro",
  price: 24999,
  stars: 2,
  tags: ["🏔️ Budget Himalayan Escape", "🙏 Cultural Journey"],
  rating: 4.2,

   images: [
    thimpu,
    paro
  ],

  includes: ["hotels", "sightseeing", "transfers"],

  hotels: [
    {
      location: "Thimphu",
      nights: "2 Nights",
      type: "2 Star Hotel"
    },
    {
      location: "Paro",
      nights: "2 Nights",
      type: "2 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Thimphu City Tour"
    },
    {
      title: "Buddha Dordenma Visit"
    },
    {
      title: "Paro Valley Exploration"
    },
    {
      title: "Local Market Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "4 Nights Accommodation",
    "Bhutan Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Sustainable Development Fee",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Thimphu",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Thimphu Exploration",
      detail:
        "Visit monasteries and cultural attractions."
    },
    {
      day: 3,
      title: "Transfer to Paro",
      detail:
        "Enjoy scenic Himalayan landscapes."
    },
    {
      day: 4,
      title: "Paro Sightseeing",
      detail:
        "Explore valleys and local markets."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Bhutan’s peaceful monasteries, valleys and Himalayan beauty with this affordable holiday package."
},
{
  id: "bhutan-budget-002",
  slug: "bhutan-economy-tour",
  destination: "bhutan",
  title: "Bhutan Saver Journey",
  duration: "5 Nights 6 Days",
  route: "3N Thimphu | 2N Paro",
  price: 34999,
  stars: 3,
  tags: ["🏔️ Himalayan Journey", "🌿 Budget Nature Escape"],
  rating: 4.4,

  images: [
    thimpu,
    paro
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Thimphu",
      nights: "3 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Paro",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Thimphu City Tour"
    },
    {
      title: "Buddha Dordenma Visit"
    },
    {
      title: "Memorial Chorten Tour"
    },
    {
      title: "Paro Valley Exploration"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Bhutan Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Sustainable Development Fee",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Thimphu",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Thimphu Sightseeing",
      detail:
        "Explore monasteries and local attractions."
    },
    {
      day: 3,
      title: "Cultural Exploration",
      detail:
        "Visit museums and local markets."
    },
    {
      day: 4,
      title: "Transfer to Paro",
      detail:
        "Enjoy scenic mountain landscapes."
    },
    {
      day: 5,
      title: "Paro Valley Tour",
      detail:
        "Visit famous monasteries and viewpoints."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Bhutan’s culture, monasteries and scenic Himalayan landscapes with this budget-friendly package."
},
{
  id: "bhutan-001",
  slug: "bhutan-short-trip",
  destination: "bhutan",
  title: "Land of Happiness Escape",
  duration: "4 Nights 5 Days",
  route: "2N Thimphu | 2N Paro",
  price: 38999,
  stars: 3,
  tags: ["🙏 Spiritual Escape", "🏔️ Himalayan Beauty"],
  rating: 4.5,

  images: [
    thimpu,
    paro
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Thimphu",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Paro",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Thimphu City Tour"
    },
    {
      title: "Buddha Point Visit"
    },
    {
      title: "Paro Valley Exploration"
    },
    {
      title: "Tiger’s Nest Monastery Viewpoint"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Bhutan Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Sustainable Development Fee",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Thimphu",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Thimphu Exploration",
      detail:
        "Visit monasteries and city attractions."
    },
    {
      day: 3,
      title: "Transfer to Paro",
      detail:
        "Enjoy scenic Himalayan landscapes."
    },
    {
      day: 4,
      title: "Paro Sightseeing",
      detail:
        "Explore valleys and monastery viewpoints."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Explore Bhutan’s peaceful valleys, monasteries and spiritual charm with this scenic holiday package."
},
{
  id: "bhutan-002",
  slug: "thimphu-paro-tour",
  destination: "bhutan",
  title: "Bhutan Cultural Journey",
  duration: "5 Nights 6 Days",
  route: "3N Thimphu | 2N Paro",
  price: 49999,
  stars: 4,
  tags: ["🏯 Cultural Heritage", "🏔️ Scenic Escape"],
  rating: 4.7,

  images: [
    thimpu,
    paro
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Thimphu",
      nights: "3 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Paro",
      nights: "2 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Thimphu Cultural Tour"
    },
    {
      title: "Memorial Chorten Visit"
    },
    {
      title: "Paro Dzong Exploration"
    },
    {
      title: "Tiger’s Nest Monastery Trek"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Bhutan Cultural Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Sustainable Development Fee",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Thimphu",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Cultural Sightseeing",
      detail:
        "Visit monasteries and local attractions."
    },
    {
      day: 3,
      title: "Local Exploration",
      detail:
        "Explore markets and Bhutanese culture."
    },
    {
      day: 4,
      title: "Transfer to Paro",
      detail:
        "Enjoy scenic mountain routes."
    },
    {
      day: 5,
      title: "Tiger’s Nest Experience",
      detail:
        "Visit Bhutan’s iconic monastery."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Bhutan’s rich culture, monasteries and Himalayan beauty with this unforgettable journey."
},
{
  id: "bhutan-003",
  slug: "bhutan-nature-package",
  destination: "bhutan",
  title: "Mystic Himalayan Retreat",
  duration: "6 Nights 7 Days",
  route: "2N Thimphu | 2N Punakha | 2N Paro",
  price: 64999,
  stars: 4,
  tags: ["🌿 Nature Escape", "🏔️ Himalayan Adventure"],
  rating: 4.8,

  images: [
    thimpu,
    punakha,
    paro
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Thimphu",
      nights: "2 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Punakha",
      nights: "2 Nights",
      type: "4 Star Resort"
    },
    {
      location: "Paro",
      nights: "2 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Thimphu City Tour"
    },
    {
      title: "Punakha Dzong Visit"
    },
    {
      title: "Dochula Pass Experience"
    },
    {
      title: "Paro Valley Exploration"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Bhutan Nature & Cultural Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Sustainable Development Fee",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Thimphu",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Thimphu Exploration",
      detail:
        "Visit monasteries and scenic attractions."
    },
    {
      day: 3,
      title: "Transfer to Punakha",
      detail:
        "Enjoy mountain landscapes and valleys."
    },
    {
      day: 4,
      title: "Punakha Sightseeing",
      detail:
        "Explore dzongs and local culture."
    },
    {
      day: 5,
      title: "Transfer to Paro",
      detail:
        "Travel through scenic Himalayan routes."
    },
    {
      day: 6,
      title: "Paro Exploration",
      detail:
        "Visit valleys and monastery viewpoints."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Bhutan’s peaceful valleys, Himalayan landscapes and cultural heritage with this nature retreat."
},
{
  id: "bhutan-004",
  slug: "bhutan-honeymoon-package",
  destination: "bhutan",
  title: "Romantic Bhutan Escape",
  duration: "6 Nights 7 Days",
  route: "3N Paro | 3N Punakha",
  price: 79999,
  stars: 5,
  tags: ["💖 Romantic Escape", "🏔️ Luxury Himalayan Retreat"],
  rating: 4.9,

  images: [
    paro,
    punakha
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Paro",
      nights: "3 Nights",
      type: "5 Star Luxury Resort"
    },
    {
      location: "Punakha",
      nights: "3 Nights",
      type: "5 Star Luxury Resort"
    }
  ],

  sightseeing: [
    {
      title: "Paro Valley Exploration"
    },
    {
      title: "Tiger’s Nest Monastery Visit"
    },
    {
      title: "Punakha Dzong Tour"
    },
    {
      title: "Romantic Riverside Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Resort",
      type: "Private Luxury Transfer"
    },
    {
      from: "Resort",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Resort",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "6 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic Experiences Included",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Sustainable Development Fee",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Paro",
      detail:
        "Luxury airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Paro Exploration",
      detail:
        "Visit valleys and scenic monasteries."
    },
    {
      day: 3,
      title: "Tiger’s Nest Experience",
      detail:
        "Explore Bhutan’s iconic monastery."
    },
    {
      day: 4,
      title: "Transfer to Punakha",
      detail:
        "Enjoy scenic Himalayan landscapes."
    },
    {
      day: 5,
      title: "Punakha Sightseeing",
      detail:
        "Visit dzongs and riverside attractions."
    },
    {
      day: 6,
      title: "Romantic Leisure Day",
      detail:
        "Relax and enjoy luxury resort experiences."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Celebrate romance with peaceful valleys, luxury stays and unforgettable Himalayan experiences in Bhutan."
},
{
  id: "bhutan-005",
  slug: "grand-bhutan-tour",
  destination: "bhutan",
  title: "Ultimate Bhutan Explorer",
  duration: "8 Nights 9 Days",
  route: "3N Thimphu | 2N Punakha | 3N Paro",
  price: 99999,
  stars: 5,
  tags: ["🌟 Grand Bhutan Tour", "🏔️ Luxury Himalayan Journey"],
  rating: 5.0,

  images: [
    thimpu,
    punakha,
    paro
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Thimphu",
      nights: "3 Nights",
      type: "5 Star Luxury Hotel"
    },
    {
      location: "Punakha",
      nights: "2 Nights",
      type: "5 Star Luxury Resort"
    },
    {
      location: "Paro",
      nights: "3 Nights",
      type: "5 Star Luxury Resort"
    }
  ],

  sightseeing: [
    {
      title: "Thimphu Cultural Tour"
    },
    {
      title: "Dochula Pass Experience"
    },
    {
      title: "Punakha Dzong Visit"
    },
    {
      title: "Tiger’s Nest Monastery Trek"
    },
    {
      title: "Paro Valley Exploration"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Dinners Included"
    }
  ],

  inclusions: [
    "8 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Bhutan Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Sustainable Development Fee",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Thimphu",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Cultural Exploration",
      detail:
        "Visit monasteries and local attractions."
    },
    {
      day: 3,
      title: "Local Leisure Day",
      detail:
        "Explore markets and scenic viewpoints."
    },
    {
      day: 4,
      title: "Transfer to Punakha",
      detail:
        "Travel through Himalayan mountain passes."
    },
    {
      day: 5,
      title: "Punakha Exploration",
      detail:
        "Visit dzongs and riverside attractions."
    },
    {
      day: 6,
      title: "Transfer to Paro",
      detail:
        "Enjoy scenic valleys and landscapes."
    },
    {
      day: 7,
      title: "Tiger’s Nest Trek",
      detail:
        "Experience Bhutan’s iconic monastery."
    },
    {
      day: 8,
      title: "Paro Leisure Day",
      detail:
        "Relax and explore local attractions."
    },
    {
      day: 9,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Bhutan’s monasteries, valleys and Himalayan luxury with this ultimate premium holiday package."
},
// ================= Japan =================
{
  id: "japan-budget-001",
  slug: "japan-budget-trip",
  destination: "japan",
  title: "Affordable Japan Escape",
  duration: "5 Nights 6 Days",
  route: "3N Tokyo | 2N Osaka",
  price: 99999,
  stars: 2,
  tags: ["🏯 Budget Japan Tour", "🌆 City Explorer"],
  rating: 4.2,

  images: [
    tokyo,
    osaka
  ],

  includes: ["hotels", "transfers"],

  hotels: [
    {
      location: "Tokyo",
      nights: "3 Nights",
      type: "2 Star Hotel"
    },
    {
      location: "Osaka",
      nights: "2 Nights",
      type: "2 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Tokyo City Exploration"
    },
    {
      title: "Shibuya Crossing Visit"
    },
    {
      title: "Osaka Local Tour"
    },
    {
      title: "Dotonbori Street Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "City Attractions",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "5 Nights Accommodation",
    "Airport Transfers Included",
    "Japan City Exploration"
  ],

  exclusions: [
    "Airfare",
    "Japan Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Tokyo",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Tokyo Exploration",
      detail:
        "Visit city attractions and shopping districts."
    },
    {
      day: 3,
      title: "Leisure Day",
      detail:
        "Explore Tokyo streets and local culture."
    },
    {
      day: 4,
      title: "Transfer to Osaka",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 5,
      title: "Osaka City Tour",
      detail:
        "Explore local attractions and food streets."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Discover Japan’s modern cities, local culture and iconic attractions with this affordable holiday package."
},
{
  id: "japan-budget-002",
  slug: "japan-economy-tour",
  destination: "japan",
  title: "Japan Saver Journey",
  duration: "6 Nights 7 Days",
  route: "3N Tokyo | 3N Kyoto",
  price: 129999,
  stars: 3,
  tags: ["🏯 Cultural Escape", "🌸 Scenic Japan"],
  rating: 4.4,

  images: [
    tokyo,
    kyoto
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Tokyo",
      nights: "3 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Kyoto",
      nights: "3 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Tokyo City Tour"
    },
    {
      title: "Mount Fuji Viewpoint"
    },
    {
      title: "Kyoto Temple Exploration"
    },
    {
      title: "Fushimi Inari Shrine Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Japan Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Japan Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Tokyo",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Tokyo Sightseeing",
      detail:
        "Explore iconic attractions and shopping areas."
    },
    {
      day: 3,
      title: "Mount Fuji Excursion",
      detail:
        "Enjoy scenic mountain landscapes."
    },
    {
      day: 4,
      title: "Transfer to Kyoto",
      detail:
        "Travel by train and leisure evening."
    },
    {
      day: 5,
      title: "Kyoto Temple Tour",
      detail:
        "Visit shrines and cultural attractions."
    },
    {
      day: 6,
      title: "Cultural Exploration",
      detail:
        "Experience local traditions and markets."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Japan’s rich culture, temples and modern cities with this budget-friendly holiday package."
},
{
  id: "japan-001",
  slug: "tokyo-short-trip",
  destination: "japan",
  title: "Tokyo City Escape",
  duration: "4 Nights 5 Days",
  route: "4N Tokyo",
  price: 129999,
  stars: 4,
  tags: ["🌆 Modern Japan", "🗼 Tokyo Adventure"],
  rating: 4.6,

  images: [
    tokyo,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Tokyo",
      nights: "4 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Tokyo City Tour"
    },
    {
      title: "Tokyo Skytree Visit"
    },
    {
      title: "Shibuya & Shinjuku Exploration"
    },
    {
      title: "Disneyland Optional Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Tokyo Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Japan Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Tokyo",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Tokyo City Exploration",
      detail:
        "Visit modern attractions and shopping streets."
    },
    {
      day: 3,
      title: "Tokyo Skytree Experience",
      detail:
        "Enjoy panoramic city views and local culture."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Explore local cafés and entertainment districts."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Explore Tokyo’s futuristic attractions, culture and entertainment with this exciting Japan holiday package."
},
{
  id: "japan-002",
  slug: "tokyo-osaka-tour",
  destination: "japan",
  title: "Japan Cultural Journey",
  duration: "6 Nights 7 Days",
  route: "3N Tokyo | 3N Osaka",
  price: 149999,
  stars: 4,
  tags: ["🏯 Cultural Japan", "🚄 City Adventure"],
  rating: 4.7,

  images: [
    tokyo,
    osaka
  ],


  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Tokyo",
      nights: "3 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Osaka",
      nights: "3 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Tokyo City Tour"
    },
    {
      title: "Mount Fuji Excursion"
    },
    {
      title: "Osaka Castle Visit"
    },
    {
      title: "Dotonbori Street Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Japan Cultural Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Japan Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Tokyo",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Tokyo Exploration",
      detail:
        "Visit iconic city attractions."
    },
    {
      day: 3,
      title: "Mount Fuji Excursion",
      detail:
        "Enjoy scenic landscapes and viewpoints."
    },
    {
      day: 4,
      title: "Transfer to Osaka",
      detail:
        "Travel by bullet train and leisure evening."
    },
    {
      day: 5,
      title: "Osaka City Tour",
      detail:
        "Explore castles, markets and food streets."
    },
    {
      day: 6,
      title: "Leisure Day",
      detail:
        "Enjoy shopping and entertainment."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Japan’s cultural heritage, modern cities and scenic beauty with this unforgettable journey."
},
{
  id: "japan-003",
  slug: "tokyo-kyoto-osaka-package",
  destination: "japan",
  title: "Cherry Blossom Explorer",
  duration: "7 Nights 8 Days",
  route: "3N Tokyo | 2N Kyoto | 2N Osaka",
  price: 179999,
  stars: 5,
  tags: ["🌸 Cherry Blossom Tour", "🏯 Luxury Japan Escape"],
  rating: 4.8,

 images: [
    tokyo,
    kyoto,
    osaka
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Tokyo",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Kyoto",
      nights: "2 Nights",
      type: "5 Star Heritage Hotel"
    },
    {
      location: "Osaka",
      nights: "2 Nights",
      type: "5 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Tokyo City Tour"
    },
    {
      title: "Mount Fuji Excursion"
    },
    {
      title: "Kyoto Temple Tour"
    },
    {
      title: "Cherry Blossom Experience"
    },
    {
      title: "Osaka Castle Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Traditional Japanese Dinner Included"
    }
  ],

  inclusions: [
    "7 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Japan Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Japan Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Tokyo",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Tokyo Exploration",
      detail:
        "Visit modern attractions and shopping districts."
    },
    {
      day: 3,
      title: "Mount Fuji Tour",
      detail:
        "Enjoy scenic landscapes and viewpoints."
    },
    {
      day: 4,
      title: "Transfer to Kyoto",
      detail:
        "Travel by bullet train and leisure evening."
    },
    {
      day: 5,
      title: "Kyoto Cultural Tour",
      detail:
        "Visit shrines, temples and heritage sites."
    },
    {
      day: 6,
      title: "Transfer to Osaka",
      detail:
        "Explore modern city attractions."
    },
    {
      day: 7,
      title: "Osaka Exploration",
      detail:
        "Enjoy shopping and local food streets."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience cherry blossoms, Japanese culture and luxury city stays with this premium Japan holiday package."
},
{
  id: "japan-004",
  slug: "japan-honeymoon-package",
  destination: "japan",
  title: "Romantic Japan Escape",
  duration: "8 Nights 9 Days",
  route: "3N Tokyo | 2N Hakone | 3N Kyoto",
  price: 219999,
  stars: 5,
  tags: ["💖 Romantic Japan", "♨️ Luxury Honeymoon"],
  rating: 4.9,

   images: [
    tokyo,
    hakone,
    kyoto
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Tokyo",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Hakone",
      nights: "2 Nights",
      type: "Luxury Ryokan"
    },
    {
      location: "Kyoto",
      nights: "3 Nights",
      type: "5 Star Heritage Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Tokyo City Tour"
    },
    {
      title: "Hakone Hot Spring Experience"
    },
    {
      title: "Mount Fuji Scenic Tour"
    },
    {
      title: "Kyoto Temple Exploration"
    },
    {
      title: "Romantic Dinner Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "8 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic Experiences Included",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Japan Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Tokyo",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Tokyo Exploration",
      detail:
        "Visit iconic city attractions and shopping districts."
    },
    {
      day: 3,
      title: "Leisure Day",
      detail:
        "Enjoy Tokyo nightlife and cafés."
    },
    {
      day: 4,
      title: "Transfer to Hakone",
      detail:
        "Relax in luxury hot spring resort."
    },
    {
      day: 5,
      title: "Mount Fuji Experience",
      detail:
        "Enjoy scenic landscapes and romantic views."
    },
    {
      day: 6,
      title: "Transfer to Kyoto",
      detail:
        "Travel by bullet train and leisure evening."
    },
    {
      day: 7,
      title: "Kyoto Cultural Tour",
      detail:
        "Visit shrines and traditional attractions."
    },
    {
      day: 8,
      title: "Romantic Leisure Day",
      detail:
        "Enjoy luxury experiences and fine dining."
    },
    {
      day: 9,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Celebrate romance with luxury stays, scenic landscapes and unforgettable Japanese cultural experiences."
},
{
  id: "japan-005",
  slug: "grand-japan-tour",
  destination: "japan",
  title: "Ultimate Japan Experience",
  duration: "10 Nights 11 Days",
  route: "3N Tokyo | 2N Kyoto | 2N Osaka | 3N Hokkaido",
  price: 289999,
  stars: 5,
  tags: ["🌟 Grand Japan Tour", "🏔️ Ultimate Luxury Escape"],
  rating: 5.0,

 images: [
    tokyo,
    kyoto,
    osaka,
    hokkaido,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Tokyo",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Kyoto",
      nights: "2 Nights",
      type: "5 Star Heritage Hotel"
    },
    {
      location: "Osaka",
      nights: "2 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Hokkaido",
      nights: "3 Nights",
      type: "5 Star Luxury Resort"
    }
  ],

  sightseeing: [
    {
      title: "Tokyo City Tour"
    },
    {
      title: "Mount Fuji Excursion"
    },
    {
      title: "Kyoto Cultural Exploration"
    },
    {
      title: "Osaka Castle Visit"
    },
    {
      title: "Hokkaido Nature Experience"
    },
    {
      title: "Hot Spring Resort Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Japanese Dinners Included"
    }
  ],

  inclusions: [
    "10 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Japan Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Japan Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Tokyo",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Tokyo Exploration",
      detail:
        "Visit iconic attractions and shopping districts."
    },
    {
      day: 3,
      title: "Mount Fuji Tour",
      detail:
        "Enjoy scenic landscapes and viewpoints."
    },
    {
      day: 4,
      title: "Transfer to Kyoto",
      detail:
        "Travel by bullet train and leisure evening."
    },
    {
      day: 5,
      title: "Kyoto Cultural Experience",
      detail:
        "Explore shrines, temples and heritage streets."
    },
    {
      day: 6,
      title: "Transfer to Osaka",
      detail:
        "Visit castles and modern attractions."
    },
    {
      day: 7,
      title: "Osaka Exploration",
      detail:
        "Enjoy local cuisine and shopping districts."
    },
    {
      day: 8,
      title: "Transfer to Hokkaido",
      detail:
        "Experience scenic nature and mountain views."
    },
    {
      day: 9,
      title: "Hokkaido Nature Tour",
      detail:
        "Explore lakes, landscapes and hot springs."
    },
    {
      day: 10,
      title: "Luxury Leisure Day",
      detail:
        "Relax at premium resort and spa."
    },
    {
      day: 11,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Japan’s cities, culture, mountains and luxury experiences with this ultimate premium holiday package."
},
// ================= Europe =================
{
  id: "europe-budget-001",
  slug: "europe-budget-trip",
  destination: "europe",
  title: "Affordable Europe Escape",
  duration: "6 Nights 7 Days",
  route: "3N Paris | 3N Amsterdam",
  price: 149999,
  stars: 2,
  tags: ["🗼 Budget Europe Tour", "🌍 City Explorer"],
  rating: 4.2,

  images: [
    paris,
    amsterdam
  ],

  includes: ["hotels", "transfers"],

  hotels: [
    {
      location: "Paris",
      nights: "3 Nights",
      type: "2 Star Hotel"
    },
    {
      location: "Amsterdam",
      nights: "3 Nights",
      type: "2 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Paris City Tour"
    },
    {
      title: "Eiffel Tower Visit"
    },
    {
      title: "Amsterdam Canal Experience"
    },
    {
      title: "Local Market Exploration"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "City Attractions",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "6 Nights Accommodation",
    "Airport Transfers Included",
    "Europe City Exploration"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Paris",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Paris Exploration",
      detail:
        "Visit famous attractions and shopping streets."
    },
    {
      day: 3,
      title: "Leisure Day",
      detail:
        "Explore cafés and local markets."
    },
    {
      day: 4,
      title: "Transfer to Amsterdam",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 5,
      title: "Amsterdam City Tour",
      detail:
        "Enjoy canal views and local attractions."
    },
    {
      day: 6,
      title: "Leisure & Shopping",
      detail:
        "Explore local markets and city culture."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Discover Europe’s iconic cities, canals and cultural attractions with this affordable holiday package."
},
{
  id: "europe-budget-002",
  slug: "europe-economy-tour",
  destination: "europe",
  title: "Europe Saver Journey",
  duration: "8 Nights 9 Days",
  route: "3N Paris | 3N Switzerland | 2N Italy",
  price: 199999,
  stars: 3,
  tags: ["🏔️ Scenic Europe", "🌍 Budget Multi-Country Tour"],
  rating: 4.4,

  images: [
    paris,
    switzerland,
    italy
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Paris",
      nights: "3 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Switzerland",
      nights: "3 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Italy",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Paris City Tour"
    },
    {
      title: "Eiffel Tower Visit"
    },
    {
      title: "Swiss Alps Excursion"
    },
    {
      title: "Italy Cultural Exploration"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "8 Nights Accommodation",
    "Daily Breakfast Included",
    "Europe Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Paris",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Paris Exploration",
      detail:
        "Visit iconic attractions and shopping streets."
    },
    {
      day: 3,
      title: "Leisure Day",
      detail:
        "Enjoy cafés and local experiences."
    },
    {
      day: 4,
      title: "Transfer to Switzerland",
      detail:
        "Enjoy scenic mountain landscapes."
    },
    {
      day: 5,
      title: "Swiss Alps Tour",
      detail:
        "Explore mountains and scenic attractions."
    },
    {
      day: 6,
      title: "Leisure Day",
      detail:
        "Relax and enjoy Swiss surroundings."
    },
    {
      day: 7,
      title: "Transfer to Italy",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 8,
      title: "Italy Exploration",
      detail:
        "Visit cultural landmarks and attractions."
    },
    {
      day: 9,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Europe’s famous cities, Swiss mountains and cultural attractions with this budget-friendly package."
},
{
  id: "europe-001",
  slug: "switzerland-paris-tour",
  destination: "europe",
  title: "European Dream Escape",
  duration: "6 Nights 7 Days",
  route: "3N Switzerland | 3N Paris",
  price: 189999,
  stars: 4,
  tags: ["🏔️ Swiss Beauty", "🗼 Paris Escape"],
  rating: 4.6,

  images: [
    switzerland,
    paris
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Switzerland",
      nights: "3 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Paris",
      nights: "3 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Swiss Alps Excursion"
    },
    {
      title: "Jungfraujoch Experience"
    },
    {
      title: "Paris City Tour"
    },
    {
      title: "Eiffel Tower Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Europe Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Switzerland",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Swiss Alps Exploration",
      detail:
        "Enjoy scenic mountain experiences."
    },
    {
      day: 3,
      title: "Jungfraujoch Excursion",
      detail:
        "Visit Europe’s famous mountain attraction."
    },
    {
      day: 4,
      title: "Transfer to Paris",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 5,
      title: "Paris City Tour",
      detail:
        "Visit famous attractions and shopping districts."
    },
    {
      day: 6,
      title: "Leisure Day",
      detail:
        "Enjoy cafés and local experiences."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Explore Swiss mountains and Parisian charm with this unforgettable Europe holiday package."
},
{
  id: "europe-002",
  slug: "paris-amsterdam-tour",
  destination: "europe",
  title: "Classic Europe Journey",
  duration: "7 Nights 8 Days",
  route: "4N Paris | 3N Amsterdam",
  price: 209999,
  stars: 4,
  tags: ["🗼 Paris Adventure", "🚤 Amsterdam Canals"],
  rating: 4.7,

  images: [
    paris,
    amsterdam
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Paris",
      nights: "4 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Amsterdam",
      nights: "3 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Paris City Tour"
    },
    {
      title: "Seine River Cruise"
    },
    {
      title: "Amsterdam Canal Cruise"
    },
    {
      title: "Windmill Village Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "7 Nights Accommodation",
    "Daily Breakfast Included",
    "Europe Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Paris",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Paris Exploration",
      detail:
        "Visit iconic attractions and shopping streets."
    },
    {
      day: 3,
      title: "Seine River Cruise",
      detail:
        "Enjoy scenic river and city views."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Explore cafés and entertainment areas."
    },
    {
      day: 5,
      title: "Transfer to Amsterdam",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 6,
      title: "Amsterdam Canal Tour",
      detail:
        "Experience canals and local culture."
    },
    {
      day: 7,
      title: "Windmill Village Visit",
      detail:
        "Explore Dutch countryside attractions."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Europe’s iconic cities, river cruises and cultural charm with this classic holiday package."
},
{
  id: "europe-003",
  slug: "switzerland-italy-france-package",
  destination: "europe",
  title: "Scenic Europe Explorer",
  duration: "9 Nights 10 Days",
  route: "3N Switzerland | 3N Italy | 3N Paris",
  price: 249999,
  stars: 5,
  tags: ["🏔️ Scenic Europe", "🌍 Luxury Explorer"],
  rating: 4.8,

  images: [
    switzerland,
    italy,
    paris
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Switzerland",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Italy",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Paris",
      nights: "3 Nights",
      type: "5 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Swiss Alps Tour"
    },
    {
      title: "Venice Canal Experience"
    },
    {
      title: "Rome City Exploration"
    },
    {
      title: "Paris Eiffel Tower Visit"
    },
    {
      title: "Luxury River Cruise"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Premium European Dinner Included"
    }
  ],

  inclusions: [
    "9 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Europe Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Switzerland",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Swiss Alps Experience",
      detail:
        "Enjoy scenic mountain excursions."
    },
    {
      day: 3,
      title: "Leisure Day",
      detail:
        "Relax and explore Swiss towns."
    },
    {
      day: 4,
      title: "Transfer to Italy",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 5,
      title: "Venice Exploration",
      detail:
        "Experience canals and cultural landmarks."
    },
    {
      day: 6,
      title: "Rome City Tour",
      detail:
        "Visit historical attractions and markets."
    },
    {
      day: 7,
      title: "Transfer to Paris",
      detail:
        "Travel and leisure evening."
    },
    {
      day: 8,
      title: "Paris Sightseeing",
      detail:
        "Visit iconic attractions and cafés."
    },
    {
      day: 9,
      title: "Luxury Cruise Experience",
      detail:
        "Enjoy scenic river and city views."
    },
    {
      day: 10,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Europe’s scenic mountains, cultural cities and luxury experiences with this premium holiday package."
},
{
  id: "europe-004",
  slug: "europe-honeymoon-package",
  destination: "europe",
  title: "Romantic Europe Escape",
  duration: "10 Nights 11 Days",
  route: "3N Paris | 3N Switzerland | 2N Venice | 2N Rome",
  price: 299999,
  stars: 5,
  tags: ["💖 Romantic Europe", "🏔️ Luxury Honeymoon"],
  rating: 4.9,

  images: [
    paris,
    switzerland,
    venice,
    rome
  ],
  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Paris",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Switzerland",
      nights: "3 Nights",
      type: "5 Star Resort"
    },
    {
      location: "Venice",
      nights: "2 Nights",
      type: "5 Star Canal Hotel"
    },
    {
      location: "Rome",
      nights: "2 Nights",
      type: "5 Star Luxury Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Paris City Tour"
    },
    {
      title: "Swiss Alps Experience"
    },
    {
      title: "Venice Gondola Ride"
    },
    {
      title: "Rome Historical Tour"
    },
    {
      title: "Romantic Dinner Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "10 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic Europe Experiences",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Paris",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Paris Exploration",
      detail:
        "Visit iconic attractions and cafés."
    },
    {
      day: 3,
      title: "Leisure Day",
      detail:
        "Enjoy shopping and romantic experiences."
    },
    {
      day: 4,
      title: "Transfer to Switzerland",
      detail:
        "Travel through scenic mountain landscapes."
    },
    {
      day: 5,
      title: "Swiss Alps Tour",
      detail:
        "Experience scenic mountain excursions."
    },
    {
      day: 6,
      title: "Luxury Leisure Day",
      detail:
        "Relax at premium Swiss resort."
    },
    {
      day: 7,
      title: "Transfer to Venice",
      detail:
        "Enjoy canal city exploration."
    },
    {
      day: 8,
      title: "Venice Gondola Experience",
      detail:
        "Explore canals and romantic surroundings."
    },
    {
      day: 9,
      title: "Transfer to Rome",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 10,
      title: "Rome Historical Tour",
      detail:
        "Visit famous monuments and attractions."
    },
    {
      day: 11,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Celebrate romance across Europe with luxury stays, scenic landscapes and unforgettable experiences."
},
{
  id: "europe-005",
  slug: "grand-europe-tour",
  destination: "europe",
  title: "Ultimate Europe Expedition",
  duration: "14 Nights 15 Days",
  route: "Paris | Switzerland | Italy | Amsterdam | Germany",
  price: 399999,
  stars: 5,
  tags: ["🌟 Grand Europe Tour", "🌍 Ultimate Luxury Journey"],
  rating: 5.0,

  images: [
    paris,
    switzerland,
    italy,
    amsterdam,
    germany
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Paris",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Switzerland",
      nights: "3 Nights",
      type: "5 Star Resort"
    },
    {
      location: "Italy",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Amsterdam",
      nights: "2 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Germany",
      nights: "3 Nights",
      type: "5 Star Luxury Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Paris City Tour"
    },
    {
      title: "Swiss Alps Excursion"
    },
    {
      title: "Venice Canal Experience"
    },
    {
      title: "Rome Historical Tour"
    },
    {
      title: "Amsterdam Canal Cruise"
    },
    {
      title: "Germany Castle Exploration"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium European Dinners Included"
    }
  ],

  inclusions: [
    "14 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Europe Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Paris",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Paris Exploration",
      detail:
        "Visit iconic attractions and shopping districts."
    },
    {
      day: 3,
      title: "Leisure Day",
      detail:
        "Enjoy cafés and local experiences."
    },
    {
      day: 4,
      title: "Transfer to Switzerland",
      detail:
        "Travel through scenic mountain routes."
    },
    {
      day: 5,
      title: "Swiss Alps Experience",
      detail:
        "Explore mountains and scenic attractions."
    },
    {
      day: 6,
      title: "Luxury Leisure Day",
      detail:
        "Relax at premium resort."
    },
    {
      day: 7,
      title: "Transfer to Italy",
      detail:
        "Travel and evening exploration."
    },
    {
      day: 8,
      title: "Italy Cultural Tour",
      detail:
        "Visit historical monuments and attractions."
    },
    {
      day: 9,
      title: "Venice Canal Experience",
      detail:
        "Enjoy scenic gondola rides and canals."
    },
    {
      day: 10,
      title: "Transfer to Amsterdam",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 11,
      title: "Amsterdam Exploration",
      detail:
        "Experience canals and Dutch culture."
    },
    {
      day: 12,
      title: "Transfer to Germany",
      detail:
        "Travel through scenic European landscapes."
    },
    {
      day: 13,
      title: "Germany Castle Tour",
      detail:
        "Explore famous castles and attractions."
    },
    {
      day: 14,
      title: "Leisure & Shopping",
      detail:
        "Enjoy luxury shopping and entertainment."
    },
    {
      day: 15,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Europe’s iconic cities, mountains, canals and luxury experiences with this ultimate grand tour."
},
// ================= Turkey =================
{
  id: "turkey-budget-001",
  slug: "turkey-budget-trip",
  destination: "turkey",
  title: "Affordable Turkey Escape",
  duration: "4 Nights 5 Days",
  route: "4N Istanbul",
  price: 59999,
  stars: 2,
  tags: ["🕌 Budget Turkey Tour", "🌆 Istanbul Escape"],
  rating: 4.2,

  images: [
    istanbul
  ],

  includes: ["hotels", "sightseeing", "transfers"],

  hotels: [
    {
      location: "Istanbul",
      nights: "4 Nights",
      type: "2 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Istanbul City Tour"
    },
    {
      title: "Blue Mosque Visit"
    },
    {
      title: "Grand Bazaar Exploration"
    },
    {
      title: "Bosphorus View Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "4 Nights Accommodation",
    "Turkey Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Turkey Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Istanbul",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Istanbul Exploration",
      detail:
        "Visit mosques and famous attractions."
    },
    {
      day: 3,
      title: "Grand Bazaar Experience",
      detail:
        "Explore shopping streets and local culture."
    },
    {
      day: 4,
      title: "Bosphorus Leisure",
      detail:
        "Enjoy scenic city and waterfront views."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer to airport for return journey."
    }
  ],

  overview:
    "Discover Istanbul’s culture, markets and historic attractions with this affordable Turkey holiday package."
},
{
  id: "turkey-budget-002",
  slug: "turkey-economy-tour",
  destination: "turkey",
  title: "Turkey Saver Journey",
  duration: "6 Nights 7 Days",
  route: "3N Istanbul | 3N Cappadocia",
  price: 79999,
  stars: 3,
  tags: ["🎈 Cappadocia Escape", "🕌 Cultural Journey"],
  rating: 4.4,

  images: [
    istanbul,
    cappadocia
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Istanbul",
      nights: "3 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Cappadocia",
      nights: "3 Nights",
      type: "3 Star Cave Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Istanbul City Tour"
    },
    {
      title: "Blue Mosque Visit"
    },
    {
      title: "Cappadocia Valley Tour"
    },
    {
      title: "Hot Air Balloon View Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Turkey Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Turkey Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Istanbul",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Istanbul Sightseeing",
      detail:
        "Explore historical attractions and markets."
    },
    {
      day: 3,
      title: "Bosphorus Experience",
      detail:
        "Enjoy scenic waterfront views."
    },
    {
      day: 4,
      title: "Transfer to Cappadocia",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 5,
      title: "Cappadocia Exploration",
      detail:
        "Visit valleys and cave attractions."
    },
    {
      day: 6,
      title: "Balloon View Experience",
      detail:
        "Enjoy sunrise landscapes and local culture."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Turkey’s historical charm and Cappadocia landscapes with this budget-friendly holiday package."
},
{
  id: "turkey-001",
  slug: "istanbul-short-trip",
  destination: "turkey",
  title: "Istanbul City Escape",
  duration: "4 Nights 5 Days",
  route: "4N Istanbul",
  price: 79999,
  stars: 4,
  tags: ["🕌 Historic Istanbul", "🌆 Luxury City Escape"],
  rating: 4.6,

  images: [
    istanbul
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Istanbul",
      nights: "4 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Istanbul City Tour"
    },
    {
      title: "Hagia Sophia Visit"
    },
    {
      title: "Blue Mosque Tour"
    },
    {
      title: "Bosphorus Cruise Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Istanbul Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Turkey Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Istanbul",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Historical Exploration",
      detail:
        "Visit iconic mosques and monuments."
    },
    {
      day: 3,
      title: "Bosphorus Cruise",
      detail:
        "Enjoy scenic city and waterfront views."
    },
    {
      day: 4,
      title: "Shopping & Leisure",
      detail:
        "Explore bazaars and local markets."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Istanbul’s iconic architecture, culture and waterfront beauty with this premium holiday package."
},
{
  id: "turkey-002",
  slug: "istanbul-cappadocia-tour",
  destination: "turkey",
  title: "Turkey Heritage Journey",
  duration: "6 Nights 7 Days",
  route: "3N Istanbul | 3N Cappadocia",
  price: 99999,
  stars: 4,
  tags: ["🏛️ Heritage Tour", "🎈 Cappadocia Adventure"],
  rating: 4.7,

  images: [
    istanbul,
    cappadocia
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Istanbul",
      nights: "3 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Cappadocia",
      nights: "3 Nights",
      type: "4 Star Cave Resort"
    }
  ],

  sightseeing: [
    {
      title: "Istanbul Historical Tour"
    },
    {
      title: "Grand Bazaar Experience"
    },
    {
      title: "Cappadocia Valley Tour"
    },
    {
      title: "Hot Air Balloon Ride"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Turkey Heritage Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Turkey Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Istanbul",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Historical Istanbul Tour",
      detail:
        "Explore famous monuments and markets."
    },
    {
      day: 3,
      title: "Bosphorus Leisure Day",
      detail:
        "Enjoy scenic cruise and city attractions."
    },
    {
      day: 4,
      title: "Transfer to Cappadocia",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 5,
      title: "Cappadocia Valley Exploration",
      detail:
        "Visit valleys, caves and viewpoints."
    },
    {
      day: 6,
      title: "Hot Air Balloon Experience",
      detail:
        "Enjoy sunrise balloon ride and landscapes."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Turkey’s cultural heritage, scenic valleys and iconic Cappadocia adventures with this premium package."
},
{
  id: "turkey-003",
  slug: "turkey-coastal-package",
  destination: "turkey",
  title: "Mediterranean Turkey Escape",
  duration: "7 Nights 8 Days",
  route: "3N Antalya | 2N Cappadocia | 2N Istanbul",
  price: 129999,
  stars: 5,
  tags: ["🌊 Mediterranean Escape", "🎈 Luxury Turkey Tour"],
  rating: 4.8,

  images: [
    antalya,
    cappadocia,
    istanbul
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Antalya",
      nights: "3 Nights",
      type: "5 Star Beach Resort"
    },
    {
      location: "Cappadocia",
      nights: "2 Nights",
      type: "5 Star Cave Resort"
    },
    {
      location: "Istanbul",
      nights: "2 Nights",
      type: "5 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Antalya Coastal Tour"
    },
    {
      title: "Mediterranean Beach Experience"
    },
    {
      title: "Cappadocia Balloon Experience"
    },
    {
      title: "Istanbul Bosphorus Cruise"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Premium Turkish Dinner Included"
    }
  ],

  inclusions: [
    "7 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Turkey Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Turkey Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Antalya",
      detail:
        "Luxury airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Coastal Exploration",
      detail:
        "Enjoy beaches and Mediterranean attractions."
    },
    {
      day: 3,
      title: "Leisure Day",
      detail:
        "Relax at luxury beach resort."
    },
    {
      day: 4,
      title: "Transfer to Cappadocia",
      detail:
        "Travel and evening cave stay experience."
    },
    {
      day: 5,
      title: "Balloon & Valley Tour",
      detail:
        "Explore Cappadocia landscapes and attractions."
    },
    {
      day: 6,
      title: "Transfer to Istanbul",
      detail:
        "Travel and leisure evening."
    },
    {
      day: 7,
      title: "Istanbul Exploration",
      detail:
        "Visit famous monuments and markets."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Turkey’s Mediterranean coast, Cappadocia landscapes and luxury city experiences with this premium package."
},
{
  id: "turkey-004",
  slug: "turkey-honeymoon-package",
  destination: "turkey",
  title: "Romantic Turkey Bliss",
  duration: "8 Nights 9 Days",
  route: "3N Istanbul | 3N Cappadocia | 2N Antalya",
  price: 149999,
  stars: 5,
  tags: ["💖 Romantic Turkey", "🎈 Luxury Honeymoon"],
  rating: 4.9,

  images: [
    istanbul,
    cappadocia,
    antalya
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Istanbul",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Cappadocia",
      nights: "3 Nights",
      type: "5 Star Cave Resort"
    },
    {
      location: "Antalya",
      nights: "2 Nights",
      type: "5 Star Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "Istanbul City Tour"
    },
    {
      title: "Bosphorus Cruise Experience"
    },
    {
      title: "Cappadocia Balloon Ride"
    },
    {
      title: "Antalya Beach Leisure"
    },
    {
      title: "Romantic Dinner Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "8 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic Turkey Experiences",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Turkey Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Istanbul",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Istanbul Exploration",
      detail:
        "Visit iconic attractions and local cafés."
    },
    {
      day: 3,
      title: "Bosphorus Cruise",
      detail:
        "Enjoy romantic waterfront experiences."
    },
    {
      day: 4,
      title: "Transfer to Cappadocia",
      detail:
        "Travel and luxury cave stay."
    },
    {
      day: 5,
      title: "Balloon Ride Experience",
      detail:
        "Enjoy sunrise views and valley landscapes."
    },
    {
      day: 6,
      title: "Cappadocia Leisure",
      detail:
        "Explore local culture and scenic attractions."
    },
    {
      day: 7,
      title: "Transfer to Antalya",
      detail:
        "Relax at Mediterranean beach resort."
    },
    {
      day: 8,
      title: "Beach Leisure Day",
      detail:
        "Enjoy romantic beachside experiences."
    },
    {
      day: 9,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Celebrate romance with luxury cave stays, balloon rides and Mediterranean beaches in this Turkey honeymoon package."
},
{
  id: "turkey-005",
  slug: "grand-turkey-tour",
  destination: "turkey",
  title: "Ultimate Turkey Explorer",
  duration: "10 Nights 11 Days",
  route: "3N Istanbul | 2N Cappadocia | 2N Antalya | 3N Pamukkale",
  price: 189999,
  stars: 5,
  tags: ["🌟 Grand Turkey Tour", "🏛️ Luxury Heritage Journey"],
  rating: 5.0,

  images: [
    istanbul,
    cappadocia,
    antalya,
    pamukkale
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Istanbul",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Cappadocia",
      nights: "2 Nights",
      type: "5 Star Cave Resort"
    },
    {
      location: "Antalya",
      nights: "2 Nights",
      type: "5 Star Beach Resort"
    },
    {
      location: "Pamukkale",
      nights: "3 Nights",
      type: "5 Star Thermal Resort"
    }
  ],

  sightseeing: [
    {
      title: "Istanbul Historical Tour"
    },
    {
      title: "Cappadocia Balloon Experience"
    },
    {
      title: "Antalya Coastal Tour"
    },
    {
      title: "Pamukkale Thermal Pools"
    },
    {
      title: "Turkish Cultural Exploration"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Turkish Dinners Included"
    }
  ],

  inclusions: [
    "10 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Turkey Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Turkey Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Istanbul",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Historical Istanbul Tour",
      detail:
        "Visit iconic mosques and monuments."
    },
    {
      day: 3,
      title: "Bosphorus Leisure Day",
      detail:
        "Enjoy waterfront and shopping experiences."
    },
    {
      day: 4,
      title: "Transfer to Cappadocia",
      detail:
        "Travel and cave hotel stay."
    },
    {
      day: 5,
      title: "Balloon Ride Experience",
      detail:
        "Enjoy scenic sunrise valley views."
    },
    {
      day: 6,
      title: "Transfer to Antalya",
      detail:
        "Relax at luxury beach resort."
    },
    {
      day: 7,
      title: "Antalya Coastal Exploration",
      detail:
        "Visit beaches and local attractions."
    },
    {
      day: 8,
      title: "Transfer to Pamukkale",
      detail:
        "Travel and thermal resort experience."
    },
    {
      day: 9,
      title: "Pamukkale Thermal Pools",
      detail:
        "Explore natural thermal attractions."
    },
    {
      day: 10,
      title: "Leisure & Wellness Day",
      detail:
        "Relax with spa and resort experiences."
    },
    {
      day: 11,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Turkey’s history, landscapes, thermal resorts and luxury adventures with this ultimate grand tour package."
},
// ================= Switzerland =================
{
  id: "switzerland-budget-001",
  slug: "switzerland-budget-trip",
  destination: "switzerland",
  title: "Affordable Swiss Escape",
  duration: "5 Nights 6 Days",
  route: "3N Zurich | 2N Lucerne",
  price: 129999,
  stars: 2,
  tags: ["🏔️ Budget Swiss Tour", "🚞 Scenic Escape"],
  rating: 4.2,

  images: [
    zurich,
    lucerne
  ],

  includes: ["hotels", "transfers"],

  hotels: [
    {
      location: "Zurich",
      nights: "3 Nights",
      type: "2 Star Hotel"
    },
    {
      location: "Lucerne",
      nights: "2 Nights",
      type: "2 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Zurich City Tour"
    },
    {
      title: "Lake Zurich Experience"
    },
    {
      title: "Lucerne Old Town Visit"
    },
    {
      title: "Swiss Scenic Train Journey"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "City Attractions",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "5 Nights Accommodation",
    "Airport Transfers Included",
    "Swiss Scenic Exploration"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Zurich",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Zurich Exploration",
      detail:
        "Visit city attractions and shopping streets."
    },
    {
      day: 3,
      title: "Lake Zurich Experience",
      detail:
        "Enjoy scenic lake and leisure experiences."
    },
    {
      day: 4,
      title: "Transfer to Lucerne",
      detail:
        "Travel through scenic Swiss landscapes."
    },
    {
      day: 5,
      title: "Lucerne Sightseeing",
      detail:
        "Explore old town and lakeside attractions."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Switzerland’s lakes, mountains and charming cities with this affordable holiday package."
},
{
  id: "switzerland-budget-002",
  slug: "switzerland-economy-tour",
  destination: "switzerland",
  title: "Swiss Saver Journey",
  duration: "7 Nights 8 Days",
  route: "3N Zurich | 2N Interlaken | 2N Lucerne",
  price: 169999,
  stars: 3,
  tags: ["🏔️ Swiss Alps Journey", "🚞 Scenic Train Escape"],
  rating: 4.4,

  images: [
    zurich,
    interlaken,
    lucerne
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Zurich",
      nights: "3 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Interlaken",
      nights: "2 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Lucerne",
      nights: "2 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Zurich City Tour"
    },
    {
      title: "Interlaken Scenic Tour"
    },
    {
      title: "Swiss Alps Excursion"
    },
    {
      title: "Lucerne Lake Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "7 Nights Accommodation",
    "Daily Breakfast Included",
    "Swiss Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Zurich",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Zurich Exploration",
      detail:
        "Visit famous city attractions."
    },
    {
      day: 3,
      title: "Lake & Leisure Day",
      detail:
        "Enjoy shopping and lakeside experiences."
    },
    {
      day: 4,
      title: "Transfer to Interlaken",
      detail:
        "Travel through scenic mountain routes."
    },
    {
      day: 5,
      title: "Swiss Alps Tour",
      detail:
        "Explore mountains and panoramic viewpoints."
    },
    {
      day: 6,
      title: "Transfer to Lucerne",
      detail:
        "Enjoy scenic Swiss train journey."
    },
    {
      day: 7,
      title: "Lucerne Exploration",
      detail:
        "Visit lakeside attractions and local cafés."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Switzerland’s scenic train journeys, lakes and mountain landscapes with this budget-friendly package."
},
{
  id: "switzerland-001",
  slug: "switzerland-short-trip",
  destination: "switzerland",
  title: "Swiss Alps Escape",
  duration: "5 Nights 6 Days",
  route: "3N Zurich | 2N Lucerne",
  price: 169999,
  stars: 4,
  tags: ["🏔️ Swiss Alps", "🚞 Luxury Scenic Escape"],
  rating: 4.6,

  images: [
    zurich,
    lucerne
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Zurich",
      nights: "3 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Lucerne",
      nights: "2 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Zurich City Tour"
    },
    {
      title: "Mount Titlis Excursion"
    },
    {
      title: "Lucerne Lake Tour"
    },
    {
      title: "Swiss Scenic Train Ride"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Swiss Alps Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Zurich",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Zurich Exploration",
      detail:
        "Visit famous attractions and shopping streets."
    },
    {
      day: 3,
      title: "Mount Titlis Excursion",
      detail:
        "Enjoy snow mountains and cable car experiences."
    },
    {
      day: 4,
      title: "Transfer to Lucerne",
      detail:
        "Travel through scenic Swiss landscapes."
    },
    {
      day: 5,
      title: "Lucerne Sightseeing",
      detail:
        "Explore lakeside attractions and old town."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Swiss Alps, scenic lakes and charming cities with this unforgettable Switzerland holiday package."
},
{
  id: "switzerland-002",
  slug: "zurich-interlaken-tour",
  destination: "switzerland",
  title: "Scenic Switzerland Journey",
  duration: "7 Nights 8 Days",
  route: "3N Zurich | 2N Interlaken | 2N Lucerne",
  price: 219999,
  stars: 4,
  tags: ["🏔️ Scenic Swiss Tour", "🚠 Mountain Adventure"],
  rating: 4.7,

  images: [
    zurich,
    interlaken,
    lucerne
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Zurich",
      nights: "3 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Interlaken",
      nights: "2 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Lucerne",
      nights: "2 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Zurich City Tour"
    },
    {
      title: "Jungfraujoch Excursion"
    },
    {
      title: "Interlaken Valley Experience"
    },
    {
      title: "Lucerne Lake Tour"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "7 Nights Accommodation",
    "Daily Breakfast Included",
    "Swiss Scenic Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Zurich",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Zurich Exploration",
      detail:
        "Visit city attractions and shopping streets."
    },
    {
      day: 3,
      title: "Leisure Day",
      detail:
        "Enjoy lakeside cafés and local culture."
    },
    {
      day: 4,
      title: "Transfer to Interlaken",
      detail:
        "Travel through scenic mountain routes."
    },
    {
      day: 5,
      title: "Jungfraujoch Excursion",
      detail:
        "Experience snow peaks and mountain railways."
    },
    {
      day: 6,
      title: "Transfer to Lucerne",
      detail:
        "Enjoy scenic Swiss train experiences."
    },
    {
      day: 7,
      title: "Lucerne Exploration",
      detail:
        "Visit lake attractions and old town."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Switzerland’s snow mountains, scenic railways and alpine beauty with this premium holiday package."
},
{
  id: "switzerland-003",
  slug: "switzerland-paris-package",
  destination: "switzerland",
  title: "Swiss & Paris Explorer",
  duration: "8 Nights 9 Days",
  route: "5N Switzerland | 3N Paris",
  price: 259999,
  stars: 5,
  tags: ["🏔️ Swiss Luxury", "🗼 Paris Explorer"],
  rating: 4.8,

  images: [
    switzerland,
    paris
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Switzerland",
      nights: "5 Nights",
      type: "5 Star Luxury Resort"
    },
    {
      location: "Paris",
      nights: "3 Nights",
      type: "5 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Swiss Alps Experience"
    },
    {
      title: "Jungfraujoch Excursion"
    },
    {
      title: "Paris Eiffel Tower Tour"
    },
    {
      title: "Seine River Cruise"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Premium European Dinner Included"
    }
  ],

  inclusions: [
    "8 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Switzerland & Paris Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Switzerland",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Swiss Alps Exploration",
      detail:
        "Enjoy scenic mountain experiences."
    },
    {
      day: 3,
      title: "Jungfraujoch Excursion",
      detail:
        "Visit Europe’s famous snow attraction."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Relax and explore Swiss towns."
    },
    {
      day: 5,
      title: "Scenic Train Journey",
      detail:
        "Enjoy breathtaking mountain routes."
    },
    {
      day: 6,
      title: "Transfer to Paris",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 7,
      title: "Paris City Tour",
      detail:
        "Visit famous landmarks and cafés."
    },
    {
      day: 8,
      title: "Seine River Cruise",
      detail:
        "Enjoy romantic city views and luxury experiences."
    },
    {
      day: 9,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Swiss mountains and Parisian elegance with this luxury Europe holiday package."
},
{
  id: "switzerland-004",
  slug: "switzerland-honeymoon-package",
  destination: "switzerland",
  title: "Romantic Swiss Escape",
  duration: "9 Nights 10 Days",
  route: "3N Zurich | 3N Interlaken | 3N Lucerne",
  price: 299999,
  stars: 5,
  tags: ["💖 Romantic Switzerland", "🏔️ Luxury Honeymoon"],
  rating: 4.9,

  images: [
    zurich,
    interlaken,
    lucerne
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Zurich",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Interlaken",
      nights: "3 Nights",
      type: "5 Star Mountain Resort"
    },
    {
      location: "Lucerne",
      nights: "3 Nights",
      type: "5 Star Lakeside Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Zurich City Tour"
    },
    {
      title: "Jungfraujoch Excursion"
    },
    {
      title: "Interlaken Valley Experience"
    },
    {
      title: "Lucerne Lake Cruise"
    },
    {
      title: "Romantic Mountain Dinner"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "9 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic Swiss Experiences",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Zurich",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Zurich Exploration",
      detail:
        "Visit luxury shopping streets and attractions."
    },
    {
      day: 3,
      title: "Leisure Day",
      detail:
        "Enjoy cafés and lakeside experiences."
    },
    {
      day: 4,
      title: "Transfer to Interlaken",
      detail:
        "Travel through scenic alpine routes."
    },
    {
      day: 5,
      title: "Jungfraujoch Excursion",
      detail:
        "Enjoy snow peaks and scenic railways."
    },
    {
      day: 6,
      title: "Romantic Leisure Day",
      detail:
        "Relax at luxury mountain resort."
    },
    {
      day: 7,
      title: "Transfer to Lucerne",
      detail:
        "Travel through scenic Swiss landscapes."
    },
    {
      day: 8,
      title: "Lucerne Lake Cruise",
      detail:
        "Experience romantic lakeside views."
    },
    {
      day: 9,
      title: "Luxury Leisure Experience",
      detail:
        "Enjoy shopping and premium dining."
    },
    {
      day: 10,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Celebrate romance with scenic mountains, luxury resorts and unforgettable Swiss experiences."
},
{
  id: "switzerland-005",
  slug: "grand-switzerland-tour",
  destination: "switzerland",
  title: "Ultimate Switzerland Experience",
  duration: "11 Nights 12 Days",
  route: "3N Zurich | 3N Interlaken | 2N Geneva | 3N Lucerne",
  price: 379999,
  stars: 5,
  tags: ["🌟 Grand Switzerland Tour", "🏔️ Ultimate Alpine Luxury"],
  rating: 5.0,

  images: [
    zurich,
    interlaken,
    geneva,
    lucerne
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Zurich",
      nights: "3 Nights",
      type: "5 Star Luxury Hotel"
    },
    {
      location: "Interlaken",
      nights: "3 Nights",
      type: "5 Star Mountain Resort"
    },
    {
      location: "Geneva",
      nights: "2 Nights",
      type: "5 Star Luxury Hotel"
    },
    {
      location: "Lucerne",
      nights: "3 Nights",
      type: "5 Star Lakeside Resort"
    }
  ],

  sightseeing: [
    {
      title: "Zurich City Tour"
    },
    {
      title: "Jungfraujoch Excursion"
    },
    {
      title: "Interlaken Scenic Tour"
    },
    {
      title: "Geneva Lake Experience"
    },
    {
      title: "Lucerne Lake Cruise"
    },
    {
      title: "Swiss Scenic Rail Journey"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Swiss Dinners Included"
    }
  ],

  inclusions: [
    "11 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Switzerland Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Zurich",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Zurich Exploration",
      detail:
        "Visit luxury attractions and shopping streets."
    },
    {
      day: 3,
      title: "Leisure Day",
      detail:
        "Enjoy local cafés and city experiences."
    },
    {
      day: 4,
      title: "Transfer to Interlaken",
      detail:
        "Travel through scenic alpine routes."
    },
    {
      day: 5,
      title: "Jungfraujoch Excursion",
      detail:
        "Experience snow mountains and railways."
    },
    {
      day: 6,
      title: "Interlaken Leisure",
      detail:
        "Enjoy adventure and valley experiences."
    },
    {
      day: 7,
      title: "Transfer to Geneva",
      detail:
        "Travel and evening lakeside leisure."
    },
    {
      day: 8,
      title: "Geneva Exploration",
      detail:
        "Visit lakes and famous attractions."
    },
    {
      day: 9,
      title: "Transfer to Lucerne",
      detail:
        "Enjoy scenic train journey."
    },
    {
      day: 10,
      title: "Lucerne Lake Cruise",
      detail:
        "Experience alpine lakes and local culture."
    },
    {
      day: 11,
      title: "Luxury Leisure Day",
      detail:
        "Relax at premium lakeside resort."
    },
    {
      day: 12,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Switzerland’s alpine beauty, scenic railways and luxury experiences with this ultimate grand tour package."
},
// ================= Australia =================
{
  id: "australia-budget-001",
  slug: "australia-budget-trip",
  destination: "australia",
  title: "Affordable Australia Escape",
  duration: "5 Nights 6 Days",
  route: "5N Sydney",
  price: 149999,
  stars: 2,
  tags: ["🌆 Budget Australia Tour", "🌊 Sydney Escape"],
  rating: 4.2,

  images: [
    sydney,
  ],

  includes: ["hotels", "transfers"],

  hotels: [
    {
      location: "Sydney",
      nights: "5 Nights",
      type: "2 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Sydney City Tour"
    },
    {
      title: "Sydney Opera House Visit"
    },
    {
      title: "Darling Harbour Experience"
    },
    {
      title: "Bondi Beach Exploration"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "City Attractions",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "5 Nights Accommodation",
    "Airport Transfers Included",
    "Sydney City Exploration"
  ],

  exclusions: [
    "Airfare",
    "Australia Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Sydney",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Sydney Exploration",
      detail:
        "Visit famous attractions and waterfronts."
    },
    {
      day: 3,
      title: "Opera House Experience",
      detail:
        "Enjoy iconic Sydney landmarks."
    },
    {
      day: 4,
      title: "Bondi Beach Leisure",
      detail:
        "Relax and explore beach attractions."
    },
    {
      day: 5,
      title: "Shopping & Leisure",
      detail:
        "Explore local cafés and shopping streets."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Sydney’s beaches, landmarks and vibrant city life with this affordable Australia holiday package."
},
{
  id: "australia-budget-002",
  slug: "australia-economy-tour",
  destination: "australia",
  title: "Australia Saver Journey",
  duration: "7 Nights 8 Days",
  route: "4N Sydney | 3N Melbourne",
  price: 189999,
  stars: 3,
  tags: ["🌆 Australian Cities", "🚋 Scenic Urban Journey"],
  rating: 4.4,

  images: [
    sydney,
    melbourne
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Sydney",
      nights: "4 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Melbourne",
      nights: "3 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Sydney City Tour"
    },
    {
      title: "Sydney Opera House Visit"
    },
    {
      title: "Melbourne City Exploration"
    },
    {
      title: "Great Ocean Road Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "7 Nights Accommodation",
    "Daily Breakfast Included",
    "Australia Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Australia Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Sydney",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Sydney Sightseeing",
      detail:
        "Explore famous city attractions."
    },
    {
      day: 3,
      title: "Bondi Beach Experience",
      detail:
        "Enjoy scenic beaches and cafés."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Explore shopping and entertainment areas."
    },
    {
      day: 5,
      title: "Transfer to Melbourne",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 6,
      title: "Melbourne Exploration",
      detail:
        "Visit famous streets and local attractions."
    },
    {
      day: 7,
      title: "Great Ocean Road Tour",
      detail:
        "Experience scenic coastal landscapes."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Australia’s vibrant cities and scenic coastlines with this budget-friendly holiday package."
},
{
  id: "australia-001",
  slug: "sydney-short-trip",
  destination: "australia",
  title: "Sydney City Escape",
  duration: "5 Nights 6 Days",
  route: "5N Sydney",
  price: 179999,
  stars: 4,
  tags: ["🌆 Sydney Luxury Escape", "🌊 Harbour Experience"],
  rating: 4.6,

  images: [
    sydney,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Sydney",
      nights: "5 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Sydney City Tour"
    },
    {
      title: "Opera House Experience"
    },
    {
      title: "Sydney Harbour Cruise"
    },
    {
      title: "Bondi Beach Tour"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Sydney Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Australia Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Sydney",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Sydney Exploration",
      detail:
        "Visit iconic landmarks and waterfronts."
    },
    {
      day: 3,
      title: "Harbour Cruise Experience",
      detail:
        "Enjoy scenic harbour and skyline views."
    },
    {
      day: 4,
      title: "Bondi Beach Leisure",
      detail:
        "Relax and explore beach attractions."
    },
    {
      day: 5,
      title: "Shopping & Entertainment",
      detail:
        "Enjoy cafés and city nightlife."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Explore Sydney’s iconic harbour, beaches and city attractions with this premium Australia package."
},
{
  id: "australia-002",
  slug: "sydney-melbourne-tour",
  destination: "australia",
  title: "Australia Urban Journey",
  duration: "7 Nights 8 Days",
  route: "4N Sydney | 3N Melbourne",
  price: 229999,
  stars: 4,
  tags: ["🌆 Australian City Tour", "🚋 Coastal Explorer"],
  rating: 4.7,

  images: [
    sydney,
    melbourne
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Sydney",
      nights: "4 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Melbourne",
      nights: "3 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Sydney Harbour Cruise"
    },
    {
      title: "Opera House Tour"
    },
    {
      title: "Melbourne City Exploration"
    },
    {
      title: "Great Ocean Road Excursion"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "7 Nights Accommodation",
    "Daily Breakfast Included",
    "Australia Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Australia Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Sydney",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Sydney City Tour",
      detail:
        "Explore famous attractions and beaches."
    },
    {
      day: 3,
      title: "Harbour Cruise Experience",
      detail:
        "Enjoy scenic skyline and harbour views."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Explore shopping and entertainment districts."
    },
    {
      day: 5,
      title: "Transfer to Melbourne",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 6,
      title: "Melbourne Exploration",
      detail:
        "Visit cultural attractions and cafés."
    },
    {
      day: 7,
      title: "Great Ocean Road Tour",
      detail:
        "Enjoy scenic coastal landscapes."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Australia’s modern cities, beaches and scenic coastal routes with this premium holiday package."
},
{
  id: "australia-003",
  slug: "gold-coast-cairns-package",
  destination: "australia",
  title: "Coastal Australia Adventure",
  duration: "8 Nights 9 Days",
  route: "4N Gold Coast | 4N Cairns",
  price: 269999,
  stars: 5,
  tags: ["🌊 Coastal Luxury", "🐠 Great Barrier Adventure"],
  rating: 4.8,

  images: [
    goldCoast,
    cairns
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Gold Coast",
      nights: "4 Nights",
      type: "5 Star Beach Resort"
    },
    {
      location: "Cairns",
      nights: "4 Nights",
      type: "5 Star Luxury Resort"
    }
  ],

  sightseeing: [
    {
      title: "Gold Coast Beach Experience"
    },
    {
      title: "Theme Park Adventure"
    },
    {
      title: "Great Barrier Reef Excursion"
    },
    {
      title: "Cairns Rainforest Tour"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Premium Seafood Dinner Included"
    }
  ],

  inclusions: [
    "8 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Australia Coastal Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Australia Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Gold Coast",
      detail:
        "Luxury airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Beach Exploration",
      detail:
        "Relax and enjoy coastal attractions."
    },
    {
      day: 3,
      title: "Theme Park Adventure",
      detail:
        "Experience thrilling rides and entertainment."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Enjoy resort facilities and shopping."
    },
    {
      day: 5,
      title: "Transfer to Cairns",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 6,
      title: "Great Barrier Reef Tour",
      detail:
        "Explore marine life and reef experiences."
    },
    {
      day: 7,
      title: "Rainforest Exploration",
      detail:
        "Visit scenic nature attractions."
    },
    {
      day: 8,
      title: "Luxury Leisure Day",
      detail:
        "Relax at beachside resort."
    },
    {
      day: 9,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Australia’s beaches, reefs and luxury coastal adventures with this premium holiday package."
},
{
  id: "australia-004",
  slug: "australia-honeymoon-package",
  destination: "australia",
  title: "Romantic Australia Escape",
  duration: "9 Nights 10 Days",
  route: "4N Sydney | 3N Gold Coast | 2N Melbourne",
  price: 319999,
  stars: 5,
  tags: ["💖 Romantic Australia", "🌊 Luxury Honeymoon"],
  rating: 4.9,

  images: [
    sydney,
    goldCoast,
    melbourne
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Sydney",
      nights: "4 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Gold Coast",
      nights: "3 Nights",
      type: "5 Star Beach Resort"
    },
    {
      location: "Melbourne",
      nights: "2 Nights",
      type: "5 Star Luxury Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Sydney Harbour Cruise"
    },
    {
      title: "Bondi Beach Experience"
    },
    {
      title: "Gold Coast Beach Leisure"
    },
    {
      title: "Melbourne City Exploration"
    },
    {
      title: "Romantic Dinner Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "9 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic Australia Experiences",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Australia Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Sydney",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Sydney Exploration",
      detail:
        "Visit iconic landmarks and beaches."
    },
    {
      day: 3,
      title: "Harbour Cruise Experience",
      detail:
        "Enjoy romantic waterfront experiences."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Relax and explore local attractions."
    },
    {
      day: 5,
      title: "Transfer to Gold Coast",
      detail:
        "Travel and resort leisure."
    },
    {
      day: 6,
      title: "Beach Leisure Experience",
      detail:
        "Enjoy luxury beachside relaxation."
    },
    {
      day: 7,
      title: "Theme Park & Shopping",
      detail:
        "Explore entertainment and shopping districts."
    },
    {
      day: 8,
      title: "Transfer to Melbourne",
      detail:
        "Travel and evening exploration."
    },
    {
      day: 9,
      title: "Melbourne Exploration",
      detail:
        "Visit cafés and cultural attractions."
    },
    {
      day: 10,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Celebrate romance with luxury beaches, scenic cities and unforgettable Australian experiences."
},
{
  id: "australia-005",
  slug: "grand-australia-tour",
  destination: "australia",
  title: "Ultimate Australia Explorer",
  duration: "12 Nights 13 Days",
  route: "4N Sydney | 3N Melbourne | 3N Gold Coast | 2N Cairns",
  price: 429999,
  stars: 5,
  tags: ["🌟 Grand Australia Tour", "🌏 Ultimate Luxury Journey"],
  rating: 5.0,

  images: [
    sydney,
    melbourne,
    goldCoast,
    cairns
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Sydney",
      nights: "4 Nights",
      type: "5 Star Luxury Hotel"
    },
    {
      location: "Melbourne",
      nights: "3 Nights",
      type: "5 Star Luxury Hotel"
    },
    {
      location: "Gold Coast",
      nights: "3 Nights",
      type: "5 Star Beach Resort"
    },
    {
      location: "Cairns",
      nights: "2 Nights",
      type: "5 Star Luxury Resort"
    }
  ],

  sightseeing: [
    {
      title: "Sydney Harbour Cruise"
    },
    {
      title: "Great Ocean Road Tour"
    },
    {
      title: "Gold Coast Beach Experience"
    },
    {
      title: "Great Barrier Reef Excursion"
    },
    {
      title: "Australian Wildlife Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Australian Dinners Included"
    }
  ],

  inclusions: [
    "12 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Australia Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Australia Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Sydney",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Sydney Exploration",
      detail:
        "Visit iconic attractions and beaches."
    },
    {
      day: 3,
      title: "Harbour Cruise Experience",
      detail:
        "Enjoy scenic waterfront experiences."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Relax and explore local attractions."
    },
    {
      day: 5,
      title: "Transfer to Melbourne",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 6,
      title: "Melbourne Exploration",
      detail:
        "Visit cultural attractions and cafés."
    },
    {
      day: 7,
      title: "Great Ocean Road Tour",
      detail:
        "Enjoy scenic coastal landscapes."
    },
    {
      day: 8,
      title: "Transfer to Gold Coast",
      detail:
        "Relax at luxury beach resort."
    },
    {
      day: 9,
      title: "Beach & Theme Park Experience",
      detail:
        "Enjoy entertainment and coastal attractions."
    },
    {
      day: 10,
      title: "Transfer to Cairns",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 11,
      title: "Great Barrier Reef Tour",
      detail:
        "Experience marine adventures and reef beauty."
    },
    {
      day: 12,
      title: "Luxury Leisure Day",
      detail:
        "Relax at premium tropical resort."
    },
    {
      day: 13,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Explore Australia’s iconic cities, beaches, reefs and luxury adventures with this ultimate grand tour package."
},
// ================= New Zealand =================
{
  id: "newzealand-budget-001",
  slug: "newzealand-budget-trip",
  destination: "newzealand",
  title: "Affordable New Zealand Escape",
  duration: "5 Nights 6 Days",
  route: "5N Auckland",
  price: 169999,
  stars: 2,
  tags: ["🌿 Budget Kiwi Tour", "🌆 Auckland Escape"],
  rating: 4.2,

  images: [
    auckland,
  ],

  includes: ["hotels", "transfers"],

  hotels: [
    {
      location: "Auckland",
      nights: "5 Nights",
      type: "2 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Auckland City Tour"
    },
    {
      title: "Sky Tower Experience"
    },
    {
      title: "Harbour Exploration"
    },
    {
      title: "Local Market Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "City Attractions",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "5 Nights Accommodation",
    "Airport Transfers Included",
    "Auckland City Exploration"
  ],

  exclusions: [
    "Airfare",
    "New Zealand Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Auckland",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Auckland Exploration",
      detail:
        "Visit famous attractions and harbour areas."
    },
    {
      day: 3,
      title: "Sky Tower Experience",
      detail:
        "Enjoy panoramic city views."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Explore local cafés and shopping streets."
    },
    {
      day: 5,
      title: "Harbour Leisure",
      detail:
        "Relax and enjoy scenic waterfront experiences."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Explore Auckland’s scenic waterfronts and vibrant city attractions with this affordable New Zealand holiday package."
},
{
  id: "newzealand-budget-002",
  slug: "newzealand-economy-tour",
  destination: "newzealand",
  title: "New Zealand Saver Journey",
  duration: "7 Nights 8 Days",
  route: "4N Auckland | 3N Queenstown",
  price: 219999,
  stars: 3,
  tags: ["🏔️ Scenic New Zealand", "🌿 Nature Journey"],
  rating: 4.4,

  images: [
    auckland,
    queenstown
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Auckland",
      nights: "4 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Queenstown",
      nights: "3 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Auckland City Tour"
    },
    {
      title: "Sky Tower Experience"
    },
    {
      title: "Queenstown Scenic Tour"
    },
    {
      title: "Lake Wakatipu Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "7 Nights Accommodation",
    "Daily Breakfast Included",
    "New Zealand Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "New Zealand Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Auckland",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Auckland Exploration",
      detail:
        "Visit famous city attractions."
    },
    {
      day: 3,
      title: "Sky Tower & Harbour Tour",
      detail:
        "Enjoy city skyline and harbour views."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Explore shopping and local cafés."
    },
    {
      day: 5,
      title: "Transfer to Queenstown",
      detail:
        "Travel and evening leisure."
    },
    {
      day: 6,
      title: "Queenstown Exploration",
      detail:
        "Visit scenic lakes and mountain attractions."
    },
    {
      day: 7,
      title: "Adventure & Nature Experience",
      detail:
        "Enjoy scenic outdoor activities."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience New Zealand’s scenic mountains, lakes and vibrant cities with this budget-friendly holiday package."
},
{
  id: "newzealand-001",
  slug: "auckland-short-trip",
  destination: "newzealand",
  title: "New Zealand City Escape",
  duration: "5 Nights 6 Days",
  route: "5N Auckland",
  price: 199999,
  stars: 4,
  tags: ["🌆 Auckland Luxury", "🌿 Scenic City Escape"],
  rating: 4.6,

 images: [
    auckland,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Auckland",
      nights: "5 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Auckland City Tour"
    },
    {
      title: "Sky Tower Experience"
    },
    {
      title: "Harbour Cruise"
    },
    {
      title: "Waiheke Island Excursion"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Auckland Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "New Zealand Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Auckland",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Auckland Exploration",
      detail:
        "Visit famous attractions and waterfronts."
    },
    {
      day: 3,
      title: "Harbour Cruise Experience",
      detail:
        "Enjoy scenic coastal and skyline views."
    },
    {
      day: 4,
      title: "Waiheke Island Excursion",
      detail:
        "Explore beaches and vineyards."
    },
    {
      day: 5,
      title: "Shopping & Leisure",
      detail:
        "Enjoy cafés and local experiences."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Auckland’s scenic harbours, island beauty and premium city experiences with this New Zealand package."
},
{
  id: "newzealand-002",
  slug: "auckland-queenstown-tour",
  destination: "newzealand",
  title: "Scenic New Zealand Journey",
  duration: "7 Nights 8 Days",
  route: "4N Auckland | 3N Queenstown",
  price: 249999,
  stars: 4,
  tags: ["🏔️ Scenic Kiwi Tour", "🌿 Adventure Escape"],
  rating: 4.7,

  images: [
    auckland,
    queenstown
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Auckland",
      nights: "4 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Queenstown",
      nights: "3 Nights",
      type: "4 Star Resort"
    }
  ],

  sightseeing: [
    {
      title: "Auckland City Tour"
    },
    {
      title: "Harbour Cruise Experience"
    },
    {
      title: "Queenstown Adventure Tour"
    },
    {
      title: "Milford Sound Excursion"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "7 Nights Accommodation",
    "Daily Breakfast Included",
    "New Zealand Scenic Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "New Zealand Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Auckland",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Auckland Exploration",
      detail:
        "Visit city attractions and harbour areas."
    },
    {
      day: 3,
      title: "Harbour & Island Experience",
      detail:
        "Enjoy scenic coastal experiences."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Explore local cafés and shopping streets."
    },
    {
      day: 5,
      title: "Transfer to Queenstown",
      detail:
        "Travel and resort leisure."
    },
    {
      day: 6,
      title: "Queenstown Adventure",
      detail:
        "Enjoy scenic landscapes and adventure activities."
    },
    {
      day: 7,
      title: "Milford Sound Excursion",
      detail:
        "Experience breathtaking fjords and waterfalls."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience New Zealand’s mountains, fjords and scenic adventures with this premium holiday package."
},
{
  id: "newzealand-003",
  slug: "queenstown-rotorua-package",
  destination: "newzealand",
  title: "Adventure & Nature Escape",
  duration: "8 Nights 9 Days",
  route: "4N Queenstown | 4N Rotorua",
  price: 289999,
  stars: 5,
  tags: ["🏔️ Adventure Escape", "🌋 Nature & Luxury"],
  rating: 4.8,

  images: [
    queenstown,
    rotorua
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Queenstown",
      nights: "4 Nights",
      type: "5 Star Luxury Resort"
    },
    {
      location: "Rotorua",
      nights: "4 Nights",
      type: "5 Star Thermal Resort"
    }
  ],

  sightseeing: [
    {
      title: "Queenstown Adventure Tour"
    },
    {
      title: "Milford Sound Cruise"
    },
    {
      title: "Rotorua Geothermal Experience"
    },
    {
      title: "Maori Cultural Village Tour"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Premium Kiwi Dinner Included"
    }
  ],

  inclusions: [
    "8 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium New Zealand Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "New Zealand Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Queenstown",
      detail:
        "Luxury airport pickup and resort check-in."
    },
    {
      day: 2,
      title: "Queenstown Adventure",
      detail:
        "Enjoy scenic landscapes and adventure activities."
    },
    {
      day: 3,
      title: "Milford Sound Cruise",
      detail:
        "Experience fjords, waterfalls and nature beauty."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Relax at luxury resort and lakeside cafés."
    },
    {
      day: 5,
      title: "Transfer to Rotorua",
      detail:
        "Travel and thermal resort check-in."
    },
    {
      day: 6,
      title: "Geothermal Exploration",
      detail:
        "Visit thermal parks and scenic attractions."
    },
    {
      day: 7,
      title: "Maori Cultural Experience",
      detail:
        "Explore traditional performances and villages."
    },
    {
      day: 8,
      title: "Luxury Leisure Day",
      detail:
        "Relax at spa and thermal resort."
    },
    {
      day: 9,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Enjoy luxury adventures, scenic fjords and geothermal wonders with this premium New Zealand holiday package."
},
{
  id: "newzealand-004",
  slug: "newzealand-honeymoon-package",
  destination: "newzealand",
  title: "Romantic Kiwi Escape",
  duration: "9 Nights 10 Days",
  route: "4N Auckland | 3N Queenstown | 2N Rotorua",
  price: 349999,
  stars: 5,
  tags: ["💖 Romantic New Zealand", "🏔️ Luxury Honeymoon"],
  rating: 4.9,

  images: [
    auckland,
    queenstown,
    rotorua
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Auckland",
      nights: "4 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Queenstown",
      nights: "3 Nights",
      type: "5 Star Luxury Resort"
    },
    {
      location: "Rotorua",
      nights: "2 Nights",
      type: "5 Star Thermal Resort"
    }
  ],

  sightseeing: [
    {
      title: "Auckland Harbour Cruise"
    },
    {
      title: "Queenstown Scenic Adventure"
    },
    {
      title: "Milford Sound Cruise"
    },
    {
      title: "Rotorua Thermal Experience"
    },
    {
      title: "Romantic Dinner Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "9 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic New Zealand Experiences",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "New Zealand Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Auckland",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Auckland Exploration",
      detail:
        "Visit scenic attractions and waterfront cafés."
    },
    {
      day: 3,
      title: "Harbour Cruise Experience",
      detail:
        "Enjoy romantic coastal experiences."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Relax and enjoy city attractions."
    },
    {
      day: 5,
      title: "Transfer to Queenstown",
      detail:
        "Travel and luxury resort leisure."
    },
    {
      day: 6,
      title: "Queenstown Adventure",
      detail:
        "Explore scenic mountains and valleys."
    },
    {
      day: 7,
      title: "Milford Sound Cruise",
      detail:
        "Enjoy breathtaking fjord landscapes."
    },
    {
      day: 8,
      title: "Transfer to Rotorua",
      detail:
        "Travel and thermal resort experience."
    },
    {
      day: 9,
      title: "Thermal & Spa Experience",
      detail:
        "Relax with spa and geothermal experiences."
    },
    {
      day: 10,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Celebrate romance with scenic fjords, luxury resorts and unforgettable New Zealand experiences."
},
{
  id: "newzealand-005",
  slug: "grand-newzealand-tour",
  destination: "newzealand",
  title: "Ultimate New Zealand Explorer",
  duration: "12 Nights 13 Days",
  route: "4N Auckland | 3N Queenstown | 2N Rotorua | 3N Christchurch",
  price: 449999,
  stars: 5,
  tags: ["🌟 Grand New Zealand Tour", "🏔️ Ultimate Nature Journey"],
  rating: 5.0,

  images: [
    auckland,
    queenstown,
    rotorua,
    christchurch
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Auckland",
      nights: "4 Nights",
      type: "5 Star Luxury Hotel"
    },
    {
      location: "Queenstown",
      nights: "3 Nights",
      type: "5 Star Luxury Resort"
    },
    {
      location: "Rotorua",
      nights: "2 Nights",
      type: "5 Star Thermal Resort"
    },
    {
      location: "Christchurch",
      nights: "3 Nights",
      type: "5 Star Luxury Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Auckland Harbour Cruise"
    },
    {
      title: "Milford Sound Excursion"
    },
    {
      title: "Rotorua Geothermal Tour"
    },
    {
      title: "Christchurch Garden Experience"
    },
    {
      title: "New Zealand Scenic Rail Journey"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Kiwi Dinners Included"
    }
  ],

  inclusions: [
    "12 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium New Zealand Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "New Zealand Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Auckland",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Auckland Exploration",
      detail:
        "Visit scenic city attractions and harbour areas."
    },
    {
      day: 3,
      title: "Harbour Cruise Experience",
      detail:
        "Enjoy coastal views and luxury experiences."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Explore cafés and local attractions."
    },
    {
      day: 5,
      title: "Transfer to Queenstown",
      detail:
        "Travel and resort leisure."
    },
    {
      day: 6,
      title: "Adventure & Nature Experience",
      detail:
        "Enjoy mountain activities and scenic landscapes."
    },
    {
      day: 7,
      title: "Milford Sound Cruise",
      detail:
        "Experience fjords and waterfalls."
    },
    {
      day: 8,
      title: "Transfer to Rotorua",
      detail:
        "Travel and thermal resort stay."
    },
    {
      day: 9,
      title: "Rotorua Exploration",
      detail:
        "Visit geothermal parks and cultural attractions."
    },
    {
      day: 10,
      title: "Transfer to Christchurch",
      detail:
        "Travel and city leisure."
    },
    {
      day: 11,
      title: "Christchurch Exploration",
      detail:
        "Visit gardens and scenic city attractions."
    },
    {
      day: 12,
      title: "Luxury Leisure Day",
      detail:
        "Relax and enjoy premium experiences."
    },
    {
      day: 13,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Explore New Zealand’s fjords, mountains, geothermal wonders and luxury adventures with this ultimate grand tour package."
},
// ================= South Korea =================
{
  id: "southkorea-budget-001",
  slug: "southkorea-budget-trip",
  destination: "southkorea",
  title: "Affordable Korea Escape",
  duration: "4 Nights 5 Days",
  route: "4N Seoul",
  price: 89999,
  stars: 2,
  tags: ["🌆 Budget Korea Tour", "🎎 Seoul Escape"],
  rating: 4.2,

  images: [
    seoul
  ],

  includes: ["hotels", "transfers"],

  hotels: [
    {
      location: "Seoul",
      nights: "4 Nights",
      type: "2 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Seoul City Tour"
    },
    {
      title: "Gyeongbokgung Palace Visit"
    },
    {
      title: "Myeongdong Shopping Experience"
    },
    {
      title: "Han River Leisure"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "City Attractions",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "4 Nights Accommodation",
    "Airport Transfers Included",
    "Seoul City Exploration"
  ],

  exclusions: [
    "Airfare",
    "South Korea Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Seoul",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Seoul Exploration",
      detail:
        "Visit famous city attractions and markets."
    },
    {
      day: 3,
      title: "Palace & Culture Tour",
      detail:
        "Explore traditional Korean landmarks."
    },
    {
      day: 4,
      title: "Shopping & Leisure",
      detail:
        "Enjoy shopping streets and cafés."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Seoul’s culture, shopping streets and modern attractions with this affordable South Korea holiday package."
},
{
  id: "southkorea-budget-002",
  slug: "southkorea-economy-tour",
  destination: "southkorea",
  title: "Korea Saver Journey",
  duration: "6 Nights 7 Days",
  route: "3N Seoul | 3N Busan",
  price: 119999,
  stars: 3,
  tags: ["🎎 Korea Cultural Tour", "🌊 Seoul to Busan"],
  rating: 4.4,

  images: [
    seoul,
    busan
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Seoul",
      nights: "3 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Busan",
      nights: "3 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Seoul City Tour"
    },
    {
      title: "Gyeongbokgung Palace Visit"
    },
    {
      title: "Busan Beach Experience"
    },
    {
      title: "Gamcheon Culture Village Tour"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "South Korea Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "South Korea Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Seoul",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Seoul Exploration",
      detail:
        "Visit city attractions and shopping districts."
    },
    {
      day: 3,
      title: "Culture & Palace Tour",
      detail:
        "Explore Korean history and landmarks."
    },
    {
      day: 4,
      title: "Transfer to Busan",
      detail:
        "Travel and evening beach leisure."
    },
    {
      day: 5,
      title: "Busan Exploration",
      detail:
        "Visit beaches and scenic attractions."
    },
    {
      day: 6,
      title: "Culture Village Experience",
      detail:
        "Explore local art and colourful streets."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience South Korea’s vibrant cities, beaches and cultural attractions with this budget-friendly package."
},
{
  id: "southkorea-001",
  slug: "seoul-short-trip",
  destination: "southkorea",
  title: "Seoul City Escape",
  duration: "4 Nights 5 Days",
  route: "4N Seoul",
  price: 119999,
  stars: 4,
  tags: ["🌆 Seoul Luxury Escape", "🎎 Korean Culture"],
  rating: 4.6,

  images: [
    seoul
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Seoul",
      nights: "4 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Seoul City Tour"
    },
    {
      title: "N Seoul Tower Experience"
    },
    {
      title: "Han River Cruise"
    },
    {
      title: "Myeongdong Shopping Tour"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Seoul Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "South Korea Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Seoul",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Seoul Exploration",
      detail:
        "Visit iconic attractions and shopping areas."
    },
    {
      day: 3,
      title: "Han River Cruise",
      detail:
        "Enjoy scenic skyline and river views."
    },
    {
      day: 4,
      title: "Culture & Shopping Experience",
      detail:
        "Explore Korean cafés and fashion streets."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Explore Seoul’s modern attractions, cultural landmarks and luxury city experiences with this premium package."
},
{
  id: "southkorea-002",
  slug: "seoul-busan-tour",
  destination: "southkorea",
  title: "Korea Cultural Journey",
  duration: "6 Nights 7 Days",
  route: "3N Seoul | 3N Busan",
  price: 149999,
  stars: 4,
  tags: ["🎎 Korea Discovery", "🌊 City & Beach Escape"],
  rating: 4.7,

  images: [
    seoul,
    busan
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Seoul",
      nights: "3 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Busan",
      nights: "3 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Seoul City Tour"
    },
    {
      title: "N Seoul Tower Experience"
    },
    {
      title: "Busan Beach Tour"
    },
    {
      title: "Gamcheon Culture Village Visit"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "South Korea Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "South Korea Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Seoul",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Seoul Exploration",
      detail:
        "Visit modern attractions and shopping streets."
    },
    {
      day: 3,
      title: "Culture & Food Experience",
      detail:
        "Explore Korean culture and cuisine."
    },
    {
      day: 4,
      title: "Transfer to Busan",
      detail:
        "Travel and beach leisure."
    },
    {
      day: 5,
      title: "Busan Exploration",
      detail:
        "Visit beaches and coastal attractions."
    },
    {
      day: 6,
      title: "Culture Village Tour",
      detail:
        "Experience colourful local art and cafés."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover South Korea’s modern cities, beaches and cultural experiences with this premium holiday package."
},
{
  id: "southkorea-003",
  slug: "seoul-jeju-package",
  destination: "southkorea",
  title: "Korea Nature & Island Escape",
  duration: "7 Nights 8 Days",
  route: "4N Seoul | 3N Jeju Island",
  price: 179999,
  stars: 5,
  tags: ["🌴 Jeju Island Escape", "🎎 Luxury Korea Tour"],
  rating: 4.8,

 images: [
    seoul,
    jejuisland
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Seoul",
      nights: "4 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Jeju Island",
      nights: "3 Nights",
      type: "5 Star Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "Seoul City Tour"
    },
    {
      title: "Han River Cruise"
    },
    {
      title: "Jeju Island Nature Tour"
    },
    {
      title: "Jeju Beach Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Premium Korean Dinner Included"
    }
  ],

  inclusions: [
    "7 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Korea Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "South Korea Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Seoul",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Seoul Exploration",
      detail:
        "Visit iconic attractions and shopping districts."
    },
    {
      day: 3,
      title: "Han River Cruise",
      detail:
        "Enjoy scenic skyline and river views."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Explore cafés and Korean entertainment areas."
    },
    {
      day: 5,
      title: "Transfer to Jeju Island",
      detail:
        "Travel and beach resort leisure."
    },
    {
      day: 6,
      title: "Jeju Nature Exploration",
      detail:
        "Visit waterfalls, beaches and scenic attractions."
    },
    {
      day: 7,
      title: "Island Leisure Day",
      detail:
        "Relax at luxury beach resort."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Seoul’s vibrant culture and Jeju Island’s natural beauty with this luxury South Korea holiday package."
},
{
  id: "southkorea-004",
  slug: "southkorea-honeymoon-package",
  destination: "southkorea",
  title: "Romantic Korea Escape",
  duration: "8 Nights 9 Days",
  route: "3N Seoul | 3N Jeju Island | 2N Busan",
  price: 219999,
  stars: 5,
  tags: ["💖 Romantic Korea", "🌴 Luxury Honeymoon"],
  rating: 4.9,

  images: [
    seoul,
    jejuisland,
    busan
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Seoul",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Jeju Island",
      nights: "3 Nights",
      type: "5 Star Beach Resort"
    },
    {
      location: "Busan",
      nights: "2 Nights",
      type: "5 Star Luxury Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Seoul City Tour"
    },
    {
      title: "Han River Cruise"
    },
    {
      title: "Jeju Island Leisure"
    },
    {
      title: "Busan Beach Experience"
    },
    {
      title: "Romantic Dinner Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "8 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic Korea Experiences",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "South Korea Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Seoul",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Seoul Exploration",
      detail:
        "Visit cultural attractions and cafés."
    },
    {
      day: 3,
      title: "Han River Cruise",
      detail:
        "Enjoy romantic city experiences."
    },
    {
      day: 4,
      title: "Transfer to Jeju Island",
      detail:
        "Travel and beach resort leisure."
    },
    {
      day: 5,
      title: "Jeju Exploration",
      detail:
        "Visit beaches and scenic natural attractions."
    },
    {
      day: 6,
      title: "Island Leisure Day",
      detail:
        "Relax at luxury beach resort."
    },
    {
      day: 7,
      title: "Transfer to Busan",
      detail:
        "Travel and coastal leisure."
    },
    {
      day: 8,
      title: "Busan Beach Experience",
      detail:
        "Enjoy seaside cafés and beach attractions."
    },
    {
      day: 9,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Celebrate romance with Seoul’s city charm, Jeju Island beaches and luxury South Korea experiences."
},
{
  id: "southkorea-005",
  slug: "grand-southkorea-tour",
  destination: "southkorea",
  title: "Ultimate South Korea Experience",
  duration: "10 Nights 11 Days",
  route: "4N Seoul | 3N Busan | 3N Jeju Island",
  price: 289999,
  stars: 5,
  tags: ["🌟 Grand Korea Tour", "🎎 Ultimate Luxury Journey"],
  rating: 5.0,

  images: [
    seoul,
    busan,
    jejuisland
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Seoul",
      nights: "4 Nights",
      type: "5 Star Luxury Hotel"
    },
    {
      location: "Busan",
      nights: "3 Nights",
      type: "5 Star Beach Hotel"
    },
    {
      location: "Jeju Island",
      nights: "3 Nights",
      type: "5 Star Luxury Resort"
    }
  ],

  sightseeing: [
    {
      title: "Seoul City Tour"
    },
    {
      title: "Han River Cruise"
    },
    {
      title: "Busan Beach Tour"
    },
    {
      title: "Jeju Island Nature Exploration"
    },
    {
      title: "Korean Cultural Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Korean Dinners Included"
    }
  ],

  inclusions: [
    "10 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium South Korea Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "South Korea Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Seoul",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Seoul Exploration",
      detail:
        "Visit iconic attractions and shopping areas."
    },
    {
      day: 3,
      title: "Cultural Experience",
      detail:
        "Explore Korean palaces and traditional streets."
    },
    {
      day: 4,
      title: "Han River Cruise",
      detail:
        "Enjoy scenic city views and leisure."
    },
    {
      day: 5,
      title: "Transfer to Busan",
      detail:
        "Travel and beachside leisure."
    },
    {
      day: 6,
      title: "Busan Exploration",
      detail:
        "Visit beaches and cultural attractions."
    },
    {
      day: 7,
      title: "Leisure Day",
      detail:
        "Enjoy cafés and coastal experiences."
    },
    {
      day: 8,
      title: "Transfer to Jeju Island",
      detail:
        "Travel and luxury resort check-in."
    },
    {
      day: 9,
      title: "Jeju Nature Tour",
      detail:
        "Explore waterfalls, beaches and scenic attractions."
    },
    {
      day: 10,
      title: "Island Leisure Day",
      detail:
        "Relax at luxury beach resort."
    },
    {
      day: 11,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Explore South Korea’s vibrant cities, beaches, islands and luxury cultural experiences with this ultimate grand tour package."
},
// ================= Azerbaijan =================
{
  id: "azerbaijan-budget-001",
  slug: "azerbaijan-budget-trip",
  destination: "azerbaijan",
  title: "Affordable Azerbaijan Escape",
  duration: "4 Nights 5 Days",
  route: "4N Baku",
  price: 44999,
  stars: 2,
  tags: ["🌆 Budget Baku Tour", "🏙️ Caspian Escape"],
  rating: 4.2,

 images: [
    baku
  ],

  includes: ["hotels", "sightseeing", "transfers"],

  hotels: [
    {
      location: "Baku",
      nights: "4 Nights",
      type: "2 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Baku City Tour"
    },
    {
      title: "Flame Towers Visit"
    },
    {
      title: "Old City Exploration"
    },
    {
      title: "Caspian Boulevard Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "4 Nights Accommodation",
    "Baku Sightseeing Included",
    "Airport Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Azerbaijan Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Baku",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Baku Exploration",
      detail:
        "Visit modern attractions and city landmarks."
    },
    {
      day: 3,
      title: "Old City Tour",
      detail:
        "Explore cultural and heritage attractions."
    },
    {
      day: 4,
      title: "Leisure & Shopping",
      detail:
        "Enjoy shopping streets and cafés."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Explore Baku’s modern skyline, Caspian waterfront and cultural attractions with this affordable Azerbaijan package."
},
{
  id: "azerbaijan-budget-002",
  slug: "azerbaijan-economy-tour",
  destination: "azerbaijan",
  title: "Azerbaijan Saver Journey",
  duration: "5 Nights 6 Days",
  route: "3N Baku | 2N Gabala",
  price: 59999,
  stars: 3,
  tags: ["🏔️ Azerbaijan Nature Tour", "🌆 City & Mountains"],
  rating: 4.4,

  images: [
    baku,
    gabala
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Baku",
      nights: "3 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Gabala",
      nights: "2 Nights",
      type: "3 Star Resort"
    }
  ],

  sightseeing: [
    {
      title: "Baku City Tour"
    },
    {
      title: "Old City Exploration"
    },
    {
      title: "Gabala Mountain Experience"
    },
    {
      title: "Cable Car Ride"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Azerbaijan Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Azerbaijan Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Baku",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Baku Exploration",
      detail:
        "Visit modern attractions and cultural landmarks."
    },
    {
      day: 3,
      title: "Old City & Boulevard Tour",
      detail:
        "Explore heritage areas and waterfront."
    },
    {
      day: 4,
      title: "Transfer to Gabala",
      detail:
        "Travel and mountain resort leisure."
    },
    {
      day: 5,
      title: "Gabala Exploration",
      detail:
        "Enjoy scenic mountains and cable car rides."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Azerbaijan’s modern cities and scenic mountain landscapes with this budget-friendly holiday package."
},
{
  id: "azerbaijan-001",
  slug: "baku-short-trip",
  destination: "azerbaijan",
  title: "Baku City Escape",
  duration: "4 Nights 5 Days",
  route: "4N Baku",
  price: 59999,
  stars: 4,
  tags: ["🌆 Luxury Baku Tour", "🏙️ Caspian Experience"],
  rating: 4.6,

  images: [
    baku
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Baku",
      nights: "4 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Baku City Tour"
    },
    {
      title: "Flame Towers Experience"
    },
    {
      title: "Caspian Sea Boulevard Tour"
    },
    {
      title: "Old City Heritage Walk"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Baku Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Azerbaijan Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Baku",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Baku Exploration",
      detail:
        "Visit iconic attractions and waterfronts."
    },
    {
      day: 3,
      title: "Old City Experience",
      detail:
        "Explore historical architecture and markets."
    },
    {
      day: 4,
      title: "Shopping & Leisure",
      detail:
        "Enjoy cafés and shopping districts."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Baku’s modern skyline, Caspian beauty and cultural heritage with this premium Azerbaijan package."
},
{
  id: "azerbaijan-002",
  slug: "baku-gabala-tour",
  destination: "azerbaijan",
  title: "Caspian Adventure Journey",
  duration: "5 Nights 6 Days",
  route: "3N Baku | 2N Gabala",
  price: 74999,
  stars: 4,
  tags: ["🏔️ Mountains & City", "🌆 Azerbaijan Explorer"],
  rating: 4.7,

  images: [
    baku,
    gabala
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Baku",
      nights: "3 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Gabala",
      nights: "2 Nights",
      type: "4 Star Resort"
    }
  ],

  sightseeing: [
    {
      title: "Baku City Tour"
    },
    {
      title: "Old City Heritage Walk"
    },
    {
      title: "Gabala Nature Tour"
    },
    {
      title: "Cable Car & Lake Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Azerbaijan Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Azerbaijan Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Baku",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Baku Exploration",
      detail:
        "Visit iconic attractions and shopping areas."
    },
    {
      day: 3,
      title: "Old City Tour",
      detail:
        "Explore historical landmarks and cafés."
    },
    {
      day: 4,
      title: "Transfer to Gabala",
      detail:
        "Travel and mountain resort leisure."
    },
    {
      day: 5,
      title: "Gabala Exploration",
      detail:
        "Enjoy mountain scenery and adventure activities."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Azerbaijan’s modern cities, scenic mountains and cultural attractions with this premium holiday package."
},
{
  id: "azerbaijan-003",
  slug: "azerbaijan-nature-package",
  destination: "azerbaijan",
  title: "Mountains & Modernity Escape",
  duration: "6 Nights 7 Days",
  route: "3N Baku | 3N Gabala",
  price: 89999,
  stars: 5,
  tags: ["🏔️ Luxury Nature Escape", "🌆 Azerbaijan Adventure"],
  rating: 4.8,

  images: [
    baku,
    gabala
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Baku",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Gabala",
      nights: "3 Nights",
      type: "5 Star Mountain Resort"
    }
  ],

  sightseeing: [
    {
      title: "Baku City Tour"
    },
    {
      title: "Caspian Boulevard Experience"
    },
    {
      title: "Gabala Mountain Tour"
    },
    {
      title: "Nature & Waterfall Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Premium Azerbaijani Dinner Included"
    }
  ],

  inclusions: [
    "6 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Azerbaijan Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Azerbaijan Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Baku",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Baku Exploration",
      detail:
        "Visit iconic attractions and shopping districts."
    },
    {
      day: 3,
      title: "Cultural & Waterfront Experience",
      detail:
        "Enjoy heritage and Caspian views."
    },
    {
      day: 4,
      title: "Transfer to Gabala",
      detail:
        "Travel and luxury mountain resort stay."
    },
    {
      day: 5,
      title: "Gabala Nature Exploration",
      detail:
        "Visit scenic waterfalls and mountain attractions."
    },
    {
      day: 6,
      title: "Adventure & Leisure",
      detail:
        "Enjoy cable car rides and nature experiences."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Enjoy Azerbaijan’s modern city charm and scenic mountain luxury with this premium holiday package."
},
{
  id: "azerbaijan-004",
  slug: "azerbaijan-honeymoon-package",
  destination: "azerbaijan",
  title: "Romantic Baku Retreat",
  duration: "7 Nights 8 Days",
  route: "4N Baku | 3N Gabala",
  price: 109999,
  stars: 5,
  tags: ["💖 Romantic Azerbaijan", "🏔️ Luxury Honeymoon"],
  rating: 4.9,

  images: [
    baku,
    gabala
  ],
  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Baku",
      nights: "4 Nights",
      type: "5 Star Luxury Hotel"
    },
    {
      location: "Gabala",
      nights: "3 Nights",
      type: "5 Star Mountain Resort"
    }
  ],

  sightseeing: [
    {
      title: "Baku City Tour"
    },
    {
      title: "Caspian Waterfront Cruise"
    },
    {
      title: "Gabala Nature Experience"
    },
    {
      title: "Mountain Resort Leisure"
    },
    {
      title: "Romantic Dinner Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "7 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic Azerbaijan Experiences",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Azerbaijan Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Baku",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Baku Exploration",
      detail:
        "Visit modern attractions and cafés."
    },
    {
      day: 3,
      title: "Caspian Cruise Experience",
      detail:
        "Enjoy romantic waterfront experiences."
    },
    {
      day: 4,
      title: "Shopping & Leisure",
      detail:
        "Relax and explore luxury shopping areas."
    },
    {
      day: 5,
      title: "Transfer to Gabala",
      detail:
        "Travel and mountain resort check-in."
    },
    {
      day: 6,
      title: "Nature & Leisure Experience",
      detail:
        "Enjoy mountain scenery and resort activities."
    },
    {
      day: 7,
      title: "Luxury Leisure Day",
      detail:
        "Relax at premium mountain resort."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Celebrate romance with Caspian waterfront luxury and scenic mountain experiences in Azerbaijan."
},
{
  id: "azerbaijan-005",
  slug: "grand-azerbaijan-tour",
  destination: "azerbaijan",
  title: "Ultimate Azerbaijan Explorer",
  duration: "8 Nights 9 Days",
  route: "4N Baku | 2N Gabala | 2N Shahdag",
  price: 139999,
  stars: 5,
  tags: ["🌟 Grand Azerbaijan Tour", "🏔️ Ultimate Luxury Escape"],
  rating: 5.0,

  images: [
    baku,
    gabala,
    shahdag
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Baku",
      nights: "4 Nights",
      type: "5 Star Luxury Hotel"
    },
    {
      location: "Gabala",
      nights: "2 Nights",
      type: "5 Star Mountain Resort"
    },
    {
      location: "Shahdag",
      nights: "2 Nights",
      type: "5 Star Luxury Resort"
    }
  ],

  sightseeing: [
    {
      title: "Baku City Tour"
    },
    {
      title: "Old City Heritage Experience"
    },
    {
      title: "Gabala Nature Tour"
    },
    {
      title: "Shahdag Mountain Adventure"
    },
    {
      title: "Caspian Waterfront Leisure"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Azerbaijani Dinners Included"
    }
  ],

  inclusions: [
    "8 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Azerbaijan Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Azerbaijan Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Baku",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Baku Exploration",
      detail:
        "Visit iconic landmarks and shopping districts."
    },
    {
      day: 3,
      title: "Cultural & Waterfront Experience",
      detail:
        "Explore heritage attractions and Caspian views."
    },
    {
      day: 4,
      title: "Leisure Day",
      detail:
        "Relax and enjoy premium city experiences."
    },
    {
      day: 5,
      title: "Transfer to Gabala",
      detail:
        "Travel and resort leisure."
    },
    {
      day: 6,
      title: "Gabala Exploration",
      detail:
        "Visit scenic mountains and waterfalls."
    },
    {
      day: 7,
      title: "Transfer to Shahdag",
      detail:
        "Travel and luxury mountain resort stay."
    },
    {
      day: 8,
      title: "Mountain Adventure Experience",
      detail:
        "Enjoy snow and mountain activities."
    },
    {
      day: 9,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Explore Azerbaijan’s modern cities, mountain resorts and luxury experiences with this ultimate grand tour package."
},
// ================= Georgia =================
{
  id: "georgia-budget-001",
  slug: "georgia-budget-trip",
  destination: "georgia",
  title: "Affordable Georgia Escape",
  duration: "4 Nights 5 Days",
  route: "4N Tbilisi",
  price: 49999,
  stars: 2,
  tags: ["🌆 Budget Georgia Tour", "🏔️ Tbilisi Escape"],
  rating: 4.2,

  images: [
    tbilisi
  ],

  includes: ["hotels", "sightseeing", "transfers"],

  hotels: [
    {
      location: "Tbilisi",
      nights: "4 Nights",
      type: "2 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Tbilisi City Tour"
    },
    {
      title: "Old Town Exploration"
    },
    {
      title: "Narikala Fortress Visit"
    },
    {
      title: "Rustaveli Avenue Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [],

  inclusions: [
    "4 Nights Accommodation",
    "Tbilisi Sightseeing Included",
    "Airport Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Georgia Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Tbilisi",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Tbilisi Exploration",
      detail:
        "Visit city attractions and heritage sites."
    },
    {
      day: 3,
      title: "Old Town Experience",
      detail:
        "Explore local cafés and cultural streets."
    },
    {
      day: 4,
      title: "Leisure & Shopping",
      detail:
        "Enjoy shopping and scenic city views."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Discover Tbilisi’s cultural heritage, scenic streets and modern attractions with this affordable Georgia holiday package."
},
{
  id: "georgia-budget-002",
  slug: "georgia-economy-tour",
  destination: "georgia",
  title: "Georgia Saver Journey",
  duration: "6 Nights 7 Days",
  route: "3N Tbilisi | 3N Batumi",
  price: 69999,
  stars: 3,
  tags: ["🏔️ Georgia Nature Tour", "🌊 City & Coast Escape"],
  rating: 4.4,

  images: [
    tbilisi,
    batumi
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Tbilisi",
      nights: "3 Nights",
      type: "3 Star Hotel"
    },
    {
      location: "Batumi",
      nights: "3 Nights",
      type: "3 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Tbilisi City Tour"
    },
    {
      title: "Old Town Exploration"
    },
    {
      title: "Batumi Boulevard Experience"
    },
    {
      title: "Black Sea Beach Tour"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Shared Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Shared Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "6 Nights Accommodation",
    "Daily Breakfast Included",
    "Georgia Sightseeing Tours",
    "Shared Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Georgia Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Tbilisi",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Tbilisi Exploration",
      detail:
        "Visit cultural attractions and cafés."
    },
    {
      day: 3,
      title: "Heritage & Shopping Tour",
      detail:
        "Explore local markets and old streets."
    },
    {
      day: 4,
      title: "Transfer to Batumi",
      detail:
        "Travel and seaside leisure."
    },
    {
      day: 5,
      title: "Batumi Exploration",
      detail:
        "Visit beaches and coastal attractions."
    },
    {
      day: 6,
      title: "Black Sea Leisure",
      detail:
        "Relax and enjoy seaside cafés."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Georgia’s cultural cities and scenic Black Sea coastline with this budget-friendly holiday package."
},
{
  id: "georgia-001",
  slug: "tbilisi-short-trip",
  destination: "georgia",
  title: "Tbilisi City Escape",
  duration: "4 Nights 5 Days",
  route: "4N Tbilisi",
  price: 64999,
  stars: 4,
  tags: ["🌆 Luxury Tbilisi Tour", "🏔️ Cultural Escape"],
  rating: 4.6,

  images: [
    tbilisi,
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Tbilisi",
      nights: "4 Nights",
      type: "4 Star Hotel"
    }
  ],

  sightseeing: [
    {
      title: "Tbilisi City Tour"
    },
    {
      title: "Narikala Fortress Experience"
    },
    {
      title: "Old Town Heritage Walk"
    },
    {
      title: "Cable Car Ride Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "4 Nights Accommodation",
    "Daily Breakfast Included",
    "Tbilisi Sightseeing Tours",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Georgia Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Tbilisi",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Tbilisi Exploration",
      detail:
        "Visit iconic city attractions and cafés."
    },
    {
      day: 3,
      title: "Heritage & Fortress Tour",
      detail:
        "Explore historical landmarks and viewpoints."
    },
    {
      day: 4,
      title: "Leisure & Shopping",
      detail:
        "Enjoy local markets and city life."
    },
    {
      day: 5,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Explore Tbilisi’s historic charm, scenic viewpoints and premium city experiences with this Georgia package."
},
{
  id: "georgia-002",
  slug: "tbilisi-kazbegi-tour",
  destination: "georgia",
  title: "Caucasus Mountain Journey",
  duration: "5 Nights 6 Days",
  route: "3N Tbilisi | 2N Kazbegi",
  price: 79999,
  stars: 4,
  tags: ["🏔️ Caucasus Adventure", "🌿 Mountain Escape"],
  rating: 4.7,

  images: [
    tbilisi,
    kazbegi
  ],
  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Tbilisi",
      nights: "3 Nights",
      type: "4 Star Hotel"
    },
    {
      location: "Kazbegi",
      nights: "2 Nights",
      type: "4 Star Mountain Resort"
    }
  ],

  sightseeing: [
    {
      title: "Tbilisi City Tour"
    },
    {
      title: "Ananuri Fortress Visit"
    },
    {
      title: "Kazbegi Mountain Experience"
    },
    {
      title: "Gergeti Trinity Church Tour"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    }
  ],

  inclusions: [
    "5 Nights Accommodation",
    "Daily Breakfast Included",
    "Georgia Mountain Sightseeing",
    "Private Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Georgia Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Tbilisi",
      detail:
        "Airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Tbilisi Exploration",
      detail:
        "Visit cultural attractions and cafés."
    },
    {
      day: 3,
      title: "Transfer to Kazbegi",
      detail:
        "Enjoy scenic mountain road journey."
    },
    {
      day: 4,
      title: "Kazbegi Exploration",
      detail:
        "Visit mountain churches and viewpoints."
    },
    {
      day: 5,
      title: "Leisure & Nature Experience",
      detail:
        "Relax and enjoy mountain scenery."
    },
    {
      day: 6,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Experience Georgia’s cultural heritage and breathtaking Caucasus mountain landscapes with this premium package."
},
{
  id: "georgia-003",
  slug: "georgia-nature-package",
  destination: "georgia",
  title: "Nature & Heritage Escape",
  duration: "6 Nights 7 Days",
  route: "3N Tbilisi | 3N Batumi",
  price: 94999,
  stars: 5,
  tags: ["🌿 Luxury Nature Escape", "🌊 Black Sea Experience"],
  rating: 4.8,

  images: [
    tbilisi,
    batumi
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Tbilisi",
      nights: "3 Nights",
      type: "5 Star Hotel"
    },
    {
      location: "Batumi",
      nights: "3 Nights",
      type: "5 Star Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "Tbilisi Heritage Tour"
    },
    {
      title: "Narikala Fortress Experience"
    },
    {
      title: "Batumi Boulevard Tour"
    },
    {
      title: "Black Sea Beach Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Premium Georgian Dinner Included"
    }
  ],

  inclusions: [
    "6 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Georgia Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Georgia Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Tbilisi",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Tbilisi Exploration",
      detail:
        "Visit iconic attractions and cultural landmarks."
    },
    {
      day: 3,
      title: "Heritage & Shopping Experience",
      detail:
        "Explore old streets and local cafés."
    },
    {
      day: 4,
      title: "Transfer to Batumi",
      detail:
        "Travel and luxury beach resort stay."
    },
    {
      day: 5,
      title: "Batumi Exploration",
      detail:
        "Enjoy beaches and coastal attractions."
    },
    {
      day: 6,
      title: "Leisure & Black Sea Experience",
      detail:
        "Relax at luxury seaside resort."
    },
    {
      day: 7,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Enjoy Georgia’s cultural heritage and luxury Black Sea coastal experiences with this premium holiday package."
},
{
  id: "georgia-004",
  slug: "georgia-honeymoon-package",
  destination: "georgia",
  title: "Romantic Georgia Retreat",
  duration: "7 Nights 8 Days",
  route: "4N Tbilisi | 3N Batumi",
  price: 119999,
  stars: 5,
  tags: ["💖 Romantic Georgia", "🌊 Luxury Honeymoon"],
  rating: 4.9,

  images: [
    tbilisi,
    batumi
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Tbilisi",
      nights: "4 Nights",
      type: "5 Star Luxury Hotel"
    },
    {
      location: "Batumi",
      nights: "3 Nights",
      type: "5 Star Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "Tbilisi City Tour"
    },
    {
      title: "Old Town Heritage Walk"
    },
    {
      title: "Batumi Beach Experience"
    },
    {
      title: "Black Sea Sunset Tour"
    },
    {
      title: "Romantic Dinner Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "One Romantic Dinner Included"
    }
  ],

  inclusions: [
    "7 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Romantic Georgia Experiences",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Georgia Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Tbilisi",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Tbilisi Exploration",
      detail:
        "Visit cultural attractions and cafés."
    },
    {
      day: 3,
      title: "Heritage & Leisure Experience",
      detail:
        "Explore old streets and scenic viewpoints."
    },
    {
      day: 4,
      title: "Shopping & Leisure",
      detail:
        "Enjoy local markets and luxury cafés."
    },
    {
      day: 5,
      title: "Transfer to Batumi",
      detail:
        "Travel and beach resort leisure."
    },
    {
      day: 6,
      title: "Batumi Exploration",
      detail:
        "Enjoy beaches and coastal attractions."
    },
    {
      day: 7,
      title: "Romantic Black Sea Experience",
      detail:
        "Relax with seaside dining and sunset views."
    },
    {
      day: 8,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Celebrate romance with Georgia’s scenic cities, Black Sea beaches and luxury honeymoon experiences."
},
{
  id: "georgia-005",
  slug: "grand-georgia-tour",
  destination: "georgia",
  title: "Ultimate Georgia Explorer",
  duration: "8 Nights 9 Days",
  route: "3N Tbilisi | 2N Kazbegi | 3N Batumi",
  price: 149999,
  stars: 5,
  tags: ["🌟 Grand Georgia Tour", "🏔️ Ultimate Caucasus Escape"],
  rating: 5.0,

  images: [
    tbilisi,
    kazbegi,
    batumi
  ],

  includes: ["hotels", "sightseeing", "transfers", "meals"],

  hotels: [
    {
      location: "Tbilisi",
      nights: "3 Nights",
      type: "5 Star Luxury Hotel"
    },
    {
      location: "Kazbegi",
      nights: "2 Nights",
      type: "5 Star Mountain Resort"
    },
    {
      location: "Batumi",
      nights: "3 Nights",
      type: "5 Star Beach Resort"
    }
  ],

  sightseeing: [
    {
      title: "Tbilisi City Tour"
    },
    {
      title: "Kazbegi Mountain Experience"
    },
    {
      title: "Gergeti Trinity Church Tour"
    },
    {
      title: "Batumi Black Sea Tour"
    },
    {
      title: "Georgian Cultural Experience"
    }
  ],

  transfers: [
    {
      from: "Airport",
      to: "Hotel",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Sightseeing Points",
      type: "Private Luxury Transfer"
    },
    {
      from: "Hotel",
      to: "Airport",
      type: "Private Luxury Transfer"
    }
  ],

  meals: [
    {
      title: "Daily Breakfast Included"
    },
    {
      title: "Two Premium Georgian Dinners Included"
    }
  ],

  inclusions: [
    "8 Nights Luxury Accommodation",
    "Daily Breakfast Included",
    "Premium Georgia Sightseeing",
    "Private Luxury Transfers Included"
  ],

  exclusions: [
    "Airfare",
    "Georgia Visa Charges",
    "Personal Expenses"
  ],

  itinerary: [
    {
      day: 1,
      title: "Arrival in Tbilisi",
      detail:
        "Luxury airport pickup and hotel check-in."
    },
    {
      day: 2,
      title: "Tbilisi Exploration",
      detail:
        "Visit iconic attractions and heritage streets."
    },
    {
      day: 3,
      title: "Cultural & Shopping Experience",
      detail:
        "Explore cafés and local markets."
    },
    {
      day: 4,
      title: "Transfer to Kazbegi",
      detail:
        "Enjoy scenic Caucasus mountain journey."
    },
    {
      day: 5,
      title: "Kazbegi Adventure",
      detail:
        "Visit mountain churches and viewpoints."
    },
    {
      day: 6,
      title: "Transfer to Batumi",
      detail:
        "Travel and seaside resort leisure."
    },
    {
      day: 7,
      title: "Batumi Exploration",
      detail:
        "Enjoy beaches and coastal attractions."
    },
    {
      day: 8,
      title: "Black Sea Leisure Experience",
      detail:
        "Relax at luxury seaside resort."
    },
    {
      day: 9,
      title: "Departure",
      detail:
        "Transfer for return journey."
    }
  ],

  overview:
    "Explore Georgia’s cultural cities, Caucasus mountains and Black Sea luxury experiences with this ultimate grand tour package."
},
];

export const GroupTourDestinations = [
  {
    slug: "nepal",
    name: "Nepal",
    price: 28499,
    image: nepal,
    link: "/group-tour/nepal",
  },
  {
    slug: "assam",
    name: "Assam",
    price: 34999,
    image: assam,
    link: "/group-tour/assam",
  },
  {
    slug: "meghalaya",
    name: "Meghalaya",
    price: 34999,
    image: meghalaya,
    link: "/group-tour/meghalaya",
  },
  {
    slug: "northeast",
    name: "Northeast",
    price: 34999,
    image: northeast,
    link: "/group-tour/northeast",
  },
  {
    slug: "bhutan",
    name: "Bhutan",
    price: 39999,
    image: bhutan,
    link: "/group-tour/bhutan"
  },
  {
    slug: "vietnam",
    name: "Vietnam",
    price: 38999,
    image: vietnam,
    link: "/group-tour/vietnam"
  },
  {
    slug: "ladakh",
    name: "Ladakh",
    price: 24999,
    image: ladakh,
    link: "/group-tour/ladakh"
  },
  {
    slug: "thailand",
    name: "Thailand",
    price: 49999,
    image: thailand,
    link: "/group-tour/thailand"
  },
  {
    slug: "kashmir",
    name: "Kashmir",
    price: 59999,
    image: kashmir,
    link: "/group-tour/kashmir"
  },
  {
    slug: "malaysia",
    name: "Malaysia",
    price: 59999,
    image: malaysia,
    link: "/group-tour/malaysia"
  },
  {
    slug: "singapore",
    name: "Singapore",
    price: 129999,
    image: singapore,
    link: "/group-tour/singapore"
  },
  {
    slug: "greece",
    name: "Greece",
    price: 219999,
    image: greece,
    link: "/group-tour/greece"
  },
  {
    slug: "paris",
    name: "Paris",
    price: 151999,
    image: paris,
    link: "/group-tour/paris"
  },
  {
    slug: "europe",
    name: "Europe",
    price: 293999,
    image: europe,
    link: "/group-tour/europe"
  },
  {
    slug: "africa",
    name: "Africa",
    price: 293999,
    image: africa,
    link: "/group-tour/africa"
  },
  {
    slug: "portugal",
    name: "Portugal",
    price: 293999,
    image: portugal,
    link: "/group-tour/portugal"
  },
  {
    slug: "morocco",
    name: "Morocco",
    price: 293999,
    image: morocco,
    link: "/group-tour/morocco"
  },
  {
    slug: "gibraltar",
    name: "Gibraltar",
    price: 293999,
    image: gibraltar,
    link: "/group-tour/gibraltar"
  },
  {
    slug: "spain",
    name: "Spain",
    price: 293999,
    image: spain,
    link: "/group-tour/spain"
  },
  {
    slug: "italy",
    name: "Italy",
    price: 149999,
    image: italy,
    link: "/group-tour/italy"
  },
  {
    slug: "switzerland",
    name: "Switzerland",
    price: 169999,
    image: switzerland,
    link: "/group-tour/switzerland"
  },
  {
    slug: "liechtenstein",
    name: "Liechtenstein",
    price: 169999,
    image: liechtenstein,
    link: "/group-tour/liechtenstein"
  },
  {
    slug: "badrinath",
    name: "Badrinath",
    price: 175999,
    image: badrinath,
    link: "/group-tour/badrinath"
  },
  {
    slug: "yamunotri",
    name: "Yamunotri",
    price: 19999,
    image: yamunotri,
    link: "/group-tour/yamunotri"
  },
  {
    slug: "gangotri",
    name: "Gangotri",
    price: 19999,
    image: gangotri,
    link: "/group-tour/gangotri"
  },
  {
    slug: "kedarnath",
    name: "Kedarnath",
    price: 175999,
    image: kedarnath,
    link: "/group-tour/kedarnath"
  },
  {
    slug: "dehradhun",
    name: "Dehradhun",
    price: 175999,
    image: dehradun,
    link: "/group-tour/dehradhun"
  },
  {
    slug: "germany",
    name: "Germany",
    price: 185999,
    image: germany,
    link: "/group-tour/germany"
  },
  {
    slug: "austria",
    name: "Austria",
    price: 185999,
    image: austria,
    link: "/group-tour/austria"
  },
  {
    slug: "istanbul",
    name: "Istanbul",
    price: 226999,
    image: istanbul,
    link: "/group-tour/istanbul"
  },
  {
    slug: "zurich",
    name: "Zurich",
    price: 195999,
    image: zurich,
    link: "/group-tour/zurich"
  },
  {
    slug: "france",
    name: "France",
    price: 195999,
    image: paris,
    link: "/group-tour/france"
  },
  {
    slug: "monaco",
    name: "Monaco",
    price: 195999,
    image: monaco,
    link: "/group-tour/monaco"
  },
  {
    slug: "newZealand",
    name: "New Zealand",
    price: 208999,
    image: newzealand,
    link: "/group-tour/newZealand"
  },
  {
    slug: "japan",
    name: "Japan",
    price: 249999,
    image: japan,
    link: "/group-tour/japan"
  },
  {
    slug: "netherlands",
    name: "Netherlands",
    price: 219999,
    image: netherlands,
    link: "/group-tour/netherlands"
  },
  {
    slug: "australia",
    name: "Australia",
    price: 429999,
    image: australia,
    link: "/group-tour/australia"
  },
  {
    slug: "scotland",
    name: "Scotland",
    price: 264999,
    image: scotland,
    link: "/group-tour/scotland"
  },
];

export const GroupTourPackages = [
  // ================= Nepal =================
  {
    id: "nepal-001",
    slug: "mystic-nepal-getaway",
    categories: ["nepal"],
    path: "/group-tour/nepal/mystic-nepal-getaway",
    title: "Mystic Nepal Getaway",
    duration: "5 Nights 6 Days",
    route: "2N Kathmandu | 2N Pokhara | 1N Kathmandu",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Ahemdabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", " Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Nov 2026", "Dec 2026"],
    stars: 3,
    price: 28499,
    image: kathmandu,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  // ================= NorthEast - Assam & Meghalaya =================
  {
    id: "northeast-001",
    slug: "northeast-odyssey-assam-meghalaya",
    categories: ["assam", "meghalaya", "northeast"],
    path: "/group-tour/northeast/northeast-odyssey-assam-meghalaya",
    title: "Northeast Odyssey: Assam & Meghalaya",
    duration: "6 Nights 7 Days",
    route: "1N Guwahati | 1N Kaziranga | 3N Shillong | 1N Guwahati ",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026"],
    stars: 3,
    price: 34999,
    image: guwahati,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  // ================= Bhutan =================
  {
    id: "bhutan-001",
    slug: "amazingbhutan",
    categories: ["bhutan"],
    path: "/group-tour/bhutan/amazingbhutan",
    title: "Amazing Bhutan",
    duration: "7 Nights 8 Days",
    route: "1N Phuntsholing  | 2N Thimphu | 1N Punakha | 2N Paro | 1N Phuntsholing",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", " Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Nov 2026", "Dec 2026"],
    stars: 3,
    price: 39999,
    image: phuntsholing,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },

  // ================= Vietnam =================
  {
    id: "vietnam-001",
    slug: "vietnam-adventure-quest",
    categories: ["vietnam"],
    path: "/group-tour/vietnam/vietnam-adventure-quest",
    title: "Vietnam Adventure Quest",
    duration: "6 Nights 7 Days",
    route: "2N Ho Chi Minh City  | 2N Da Nang | 1N Hanoi",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["May 2026"],
    stars: 4,
    price: 44999,
    image: hochiminhcity,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "vietnam-002",
    slug: "vietnam-adventure-quest-with-halong-bay",
    categories: ["vietnam"],
    path: "/group-tour/vietnam/vietnam-adventure-quest-with-halong-bay",
    title: "Vietnam Adventure Quest with Halong Bay",
    duration: "6 Nights 7 Days",
    route: "2N Ho Chi Minh City  | 2N Da Nang | 1N Hanoi | 1N Halong Bay",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["May 2026"],
    stars: 4,
    price: 50999,
    image: daNang,
    includes: ["hotels", "sightseeing", "transfers", "meals", "cruise"]
  },
  {
    id: "vietnam-003",
    slug: "vietnam-dual-paradise",
    categories: ["vietnam"],
    path: "/group-tour/vietnam/vietnam-dual-paradise",
    title: "Vietnam Dual Paradise",
    duration: "6 Nights 7 Days",
    route: "3N Phu Quoc | 3N Da Nang",
    departureCity: ["Mumbai", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026"],
    stars: 4,
    price: 119999,
    image: phuQuoc,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "vietnam-004",
    slug: "vietnam-grand-tour",
    categories: ["vietnam"],
    path: "/group-tour/vietnam/vietnam-grand-tour",
    title: "Vietnam Grand Tour",
    duration: "11 Nights 12 Days",
    route: "3N Hanoi  | 3N Da Nang | 2N Ho Chi Minh City | 3N Phu Quoc",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", "Jul 2026", "Aug 2026"],
    stars: 4,
    price: 109999,
    image: hanoi,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "vietnam-005",
    slug: "unbeatable-vietnam-premium",
    categories: ["vietnam"],
    path: "/group-tour/vietnam/unbeatable-vietnam-premium",
    title: "Unbeatable Vietnam Premium",
    duration: "7 Nights 8 Days",
    route: "2N Hanoi  | 1N Halong Bay | 2N Da Nang | 2N Ho Chi Minh City",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026"],
    stars: 5,
    price: 104499,
    image: halongBay,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },


  // ================= Ladhak =================
  {
    id: "ladakh-001",
    slug: "exclusive-ladakh",
    categories: ["ladakh"],
    path: "/group-tour/ladakh/exclusive-ladakh",
    title: "Exclusive Ladakh",
    duration: "7 Nights 8 Days",
    route: "2N Leh | 2N Nubra Valley | 1N Pangong | 2N Leh",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026"],
    stars: 3,
    price: 44999,
    image: leh,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "ladakh-002",
    slug: "ultimate-ladakh-expedition",
    categories: ["ladakh"],
    path: "/group-tour/ladhak/ultimate-ladakh-expedition",
    title: "Ultimate Ladakh Expedition",
    duration: "9 Nights 10 Days",
    route: "1N Sonamarg | 1N Kargil | 2N Leh | 2N Nubra Valley | 1N Pangong | 2N Leh",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026"],
    stars: 3,
    price: 59999,
    image: nubarvalley,
    includes: ["hotels", "sightseeing", "transfers"]
  },
  {
    id: "ladakh-003",
    slug: "incredible-ladakh-with-nubra-turtuk-and-pangong-deluxe",
    categories: ["ladakh"],
    path: "/group-tour/ladakh/incredible-ladakh-with-nubra-turtuk-and-pangong-deluxe",
    title: "Incredible Ladakh with Nubra, Turtuk and Pangong - Deluxe",
    duration: "6 Nights 7 Days",
    route: "2N Leh | 2N Nubra Valley | 1N Pangong | 1N Leh ",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026"],
    stars: 3,
    price: 42999,
    image: pangong,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "ladakh-004",
    slug: "incredible-ladakh-with-nubra-turtuk-and-pangong-premium",
    categories: ["ladakh"],
    path: "/group-tour/ladakh/incredible-ladakh-with-nubra-turtuk-and-pangong-premium",
    title: "Incredible Ladakh with Nubra, Turtuk and Pangong - Premium",
    duration: "6 Nights 7 Days",
    route: "2N Leh | 2N Nubra Valley | 1N Pangong | 1N Leh ",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026"],
    stars: 4,
    price: 52999,
    image: leh,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "ladakh-005",
    slug: "experience-ladakh-with-nubra-and-pangong-deluxe",
    categories: ["ladakh"],
    path: "/group-tour/ladakh/experience-ladakh-with-nubra-and-pangong-deluxe",
    title: "Experience Ladakh with Nubra and Pangong - Deluxe",
    duration: "5 Nights 6 Days",
    route: "2N Leh | 1N Nubra Valley | 1N Pangong | 1N Leh ",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026"],
    stars: 3,
    price: 32999,
    image: nubarvalley,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "ladakh-006",
    slug: "experience-ladakh-with-nubra-and-pangong-premium",
    categories: ["ladakh"],
    path: "/group-tour/ladakh/experience-ladakh-with-nubra-and-pangong-premium",
    title: "Experience Ladakh with Nubra and Pangong - Premium",
    duration: "5 Nights 6 Days",
    route: "2N Leh | 1N Nubra Valley | 1N Pangong | 1N Leh ",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026"],
    stars: 4,
    price: 42999,
    image: pangong,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },

  // ================= Thailand =================
  {
    id: "thailand-001",
    slug: "thailand-full-moon-party-at-koh-samui",
    categories: ["thailand"],
    path: "/group-tour/thailand/thailand-full-moon-party-at-koh-samui",
    title: "Thailand Full Moon Party at Koh Samui",
    duration: "6 Nights 7 Days",
    route: "2N Krabi | 2N Koh Samai | 2N Phuket",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", " Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 49999,
    image: krabi,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "thailand-002",
    slug: "thailands-calling-the-bachelor-escape",
    categories: ["thailand"],
    path: "/group-tour/thailand/thailands-calling-the-bachelor-escape",
    title: "Thailand’s Calling: The Bachelor Escape",
    duration: "4 Nights 5 Days",
    route: "3N Pattaya | 1N Bangkok",
    departureCity: ["Mumbai", "Bangalore", "Amritsar", "Joining Direct"],
    availableDate: ["May 2026"],
    stars: 4,
    price: 53999,
    image: bangkok,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  // ================= Kashmir =================
  {
    id: "kashmir-001",
    slug: "kashmir-valley-retreat-veg-kitchen-tour",
    categories: ["kashmir"],
    path: "/group-tour/kashmir/kashmir-valley-retreat-veg-kitchen-tour",
    title: "Kashmir Valley Retreat: Veg Kitchen Tour",
    duration: "8 Nights 9 Days",
    route: "2N Sonamarg  | 2N Gulmarg  | 2N Srinagar | 2N Pahalgam",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026"],
    stars: 4,
    price: 59999,
    image: srinagar,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  // ================= Singapore & Malaysia =================
  {
    id: "malaysia-001",
    slug: "unbeatable-malaysia-city-highlands-theme-park",
    categories: ["malaysia"],
    path: "/group-tour/malaysia/unbeatable-malaysia-city-highlands-theme-park",
    title: "Unbeatable Malaysia - City, Highlands & Theme Park",
    duration: "3 Nights 4 Days",
    route: "3N Kuala Lumpur",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Ahmedabad", "Joining Direct"],
    availableDate: ["Jun 2026"],
    stars: 4,
    price: 59999,
    image: kualaLumpur,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "malaysia-002",
    slug: "astonishing-malaysia",
    categories: ["malaysia"],
    path: "/group-tour/malaysia/astonishing-malaysia",
    title: "Astonishing Malaysia",
    duration: "4 Nights 5 Days",
    route: "1N Genting | 3N Kuala Lumpur",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Ahmedabad", "Joining Direct"],
    availableDate: ["Jun 2026"],
    stars: 4,
    price: 68999,
    image: genting,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "malaysia-003",
    slug: "malaysian-extravaganza-city-lights-highlands-island-escape",
    categories: ["malaysia"],
    path: "/group-tour/malaysia/malaysian-extravaganza-city-lights-highlands-island-escape",
    title: "Malaysian Extravaganza - City Lights, Highlands & Island Escape",
    duration: "5 Nights 6 Days",
    route: "3N Kuala Lumpur | 2N Langkwai",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Ahmedabad", "Joining Direct"],
    availableDate: ["Jun 2026"],
    stars: 4,
    price: 87999,
    image: langkawi,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "singapore&malaysia-001",
    slug: "signature-kuala-lumpur-with-singapore",
    categories: ["malaysia", "singapore"],
    path: "/group-tour/malaysia/signature-kuala-lumpur-with-singapore",
    title: "Signature Kuala Lumpur with Singapore",
    duration: "6 Nights 7 Days",
    route: "3N Kuala Lumpur | 2N Singapore",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Ahmedabad", "Joining Direct"],
    availableDate: ["Jun 2026"],
    stars: 4,
    price: 129999,
    image: singapore,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "singapore&malaysia-002",
    slug: "unbelievable-singapore-and-malaysia",
    categories: ["malaysia", "singapore"],
    path: "/group-tour/malaysia/unbelievable-singapore-and-malaysia",
    title: "Unbelievable Singapore and Malaysia",
    duration: "6 Nights 7 Days",
    route: "3N Singapore | 3N Kuala Lumpur",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026"],
    stars: 4,
    price: 144999,
    image: kualaLumpur,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "singapore&malaysia&thailand-001",
    slug: "asian-extravaganza",
    categories: ["malaysia", "singapore", "thailand"],
    path: "/group-tour/malaysia/asian-extravaganza",
    title: "Asian Extravaganza",
    duration: "10 Nights 11 Days",
    route: "3N Singapore | 3N Kuala Lumpur | 2N Pattaya | 2N Bangkok",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026"],
    stars: 4,
    price: 174999,
    image: singapore,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  // ================= Greece & Istanbul =================
  {
    id: "greece-001",
    slug: "greece-of-the-ancient-world",
    categories: ["greece"],
    path: "/group-tour/greece/greece-of-the-ancient-world",
    title: "Greece of The Ancient World",
    duration: "12 Nights 13 Days",
    route: "3N Athens | 1N Nafplio | 1N Monemvasia | 2N Areopoli | 1N Methoni | 1N Olympia | 1N Nafpaktos | 1N Arachova | 1N Athens",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 3,
    price: 219999,
    image: athens,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "greece-002",
    slug: "the-unique-cyclades-and-the-mycenaean-crete",
    categories: ["greece"],
    path: "/group-tour/greece/the-unique-cyclades-and-the-mycenaean-crete",
    title: "The Unique Cyclades and The Mycenaean Crete",
    duration: "12 Nights 13 Days",
    route: "2N Athens | 1N Paros | 2N Naxos | 2N Santorini | 1N Heraklion | 1N Chania | 1N Plakias | 1N Ierapetra | 1N Agios Nikolaos",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Sep 2026", "Oct 2026"],
    stars: 3,
    price: 272999,
    image: paros,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "greece-003",
    slug: "the-must-seen-of-greece",
    categories: ["greece"],
    path: "/group-tour/greece/the-must-seen-of-greece",
    title: "The Must Seen of Greece",
    duration: "10 Nights 11 Days",
    route: "2N Athens | 1N Preveza | 3N Corfu | 1N Kalambaka | 3N Thessaloniki ",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 3,
    price: 201999,
    image: preveza,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "greece-004",
    slug: "the-pearls-of-greek-islands",
    categories: ["greece"],
    path: "/group-tour/greece/the-pearls-of-greek-islands",
    title: "The Pearls of Greek Islands",
    duration: "19 Nights 20 Days",
    route: "3N Athens | 2N Milos Island | 3N Santorini | 3N Rhodes | 2N Kos | 2N Kalymnos | 2N Patmos | 2N Samos",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026"],
    stars: 3,
    price: 394999,
    image: milosisland,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "istanbul-001",
    slug: "classical-greece-and-istanbul",
    categories: ["greece", "istanbul"],
    path: "/group-tour/istanbul/classical-greece-and-istanbul",
    title: "Classical Greece and Istanbul",
    duration: "13 Nights 14 Days",
    route: "3N Athens | 1N Nafplio | 1N Patras | 1N Galaxidi | 1N Volos | 2N Thessaloniki | 1N Xanthi | 3N Istanbul",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jul 2026"],
    stars: 3,
    price: 226999,
    image: nafplio,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  // ================= Paris & Zurich =================
  {
    id: "paris-001",
    slug: "family-paradise-at-paris",
    categories: ["paris"],
    path: "/group-tour/paris/family-paradise-at-paris",
    title: "Family Paradise at Paris",
    duration: "7 Nights 8 Days",
    route: "7N Paris ",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Dec 2026"],
    stars: 4,
    price: 151999,
    image: paris,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "parisandzurich-002",
    slug: "swiss-paris-at-a-glance",
    categories: ["paris", "zurich", "switzerland"],
    path: "/group-tour/zurich/swiss-paris-at-a-glance",
    title: "Swiss Paris at a Glance",
    duration: "6 Nights 7 Days",
    route: "3N Zurich  | 3N Paris",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Dec 2026"],
    stars: 4,
    price: 195999,
    image: zurich,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "paris&swizerland-001",
    slug: "paris-swiss-charm",
    categories: ["paris", "zurich", "switzerland"],
    path: "/group-tour/paris/paris-swiss-charm",
    title: "Paris & Swiss Charm",
    duration: "7 Nights 8 Days",
    route: "3N Paris | 2N Geneva | 2N Zurich",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026"],
    stars: 4,
    price: 232999,
    image: geneva,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  // ================= Europe & Africa =================
  {
    id: "europe&africa-001",
    slug: "two-continents-explorer-portugal-morocco-gibraltar",
    categories: ["europe", "africa", "portugal", "morocco", "gibraltar"],
    path: "/group-tour/europe/two-continents-explorer-portugal-morocco-gibraltar",
    title: "Two Continents Explorer: Portugal, Morocco, Gibraltar",
    duration: "16 Nights 17 Days",
    route: "2N Porto | 1N Coimbra | 3N Lisbon | 3N Marrakech | 2N Casablanca | 1N Rabat | 2N Fez | 1N Tangier | 1N Gibraltar ",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Oct 2026", "Dec 2026"],
    stars: 3,
    price: 293999,
    image: porto,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "europe&africa-002",
    slug: "two-continents-grand-explorer-portugal-morocco-gibraltar-spain",
    categories: ["europe", "africa", "portugal", "morocco", "gibraltar", "spain"],
    path: "/group-tour/europe/two-continents-grand-explorer-portugal-morocco-gibraltar-spain",
    title: "Two Continents Grand Explorer: Portugal, Morocco, Gibraltar, Spain",
    duration: "22 Nights 23 Days",
    route: "2N Porto | 1N Coimbra | 3N Lisbon | 3N Marrakech | 2N Casablanca | 1N Rabat | 2N Fez | 1N Tangier | 1N Gibraltar | 2N Seville | 1N Merida | 3N Madrid",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Oct 2026", "Dec 2026"],
    stars: 3,
    price: 425999,
    image: coimbra,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "europe-002",
    slug: "the-untouched-by-time-diamonds-of-the-old-Europe",
    categories: ["europe", "austria"],
    path: "/group-tour/europe/the-untouched-by-time-diamonds-of-the-old-Europe",
    title: "The Untouched by Time Diamonds of the Old Europe",
    duration: "14 Nights 15 Days",
    route: "2N Vienna | 2N Budapest | 1N Liptovsky Mikulas | 1N Olomouc | 2N Krakow | 2N Warsaw | 1N Gdansk | 3N Prague",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 3,
    price: 225999,
    image: vienna,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "europe-003",
    slug: "european-metropolis",
    categories: ["europe", "austria", "germany", "greece", "italy", "spain"],
    path: "/group-tour/europe/european-metropolis",
    title: "European Metropolis",
    duration: "25 Nights 26 Days",
    route: "3N London | 2N Copenhagen | 1N Kiel | 3N Berlin | 2N Prague | 2N Vienna | 2N Budapest | 4N Athens | 3N Rome | 3N Madrid",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 3,
    price: 445999,
    image: london,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "europe-004",
    slug: "modern-germany-married-with-old-prussia-and-the-doll-prague",
    categories: ["europe", "germany"],
    path: "/group-tour/europe/modern-germany-married-with-old-prussia-and-the-doll-prague",
    title: "Modern Germany Married with Old Prussia and The Doll Prague",
    duration: "11 Nights 12 Days",
    route: "2N Frankfurt | 2N Düsseldorf | 1N Hamburg | 2N Berlin | 1N Leipzig | 1N Dresden | 2N Prague",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Oct 2026"],
    stars: 3,
    price: 231999,
    image: frankfurt,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "europe-005",
    slug: "the-area-of-vikings",
    categories: ["europe"],
    path: "/group-tour/europe/the-area-of-vikings",
    title: "The Area of Vikings",
    duration: "20 Nights 21 Days",
    route: "2N Copenhagen | 2N Bergen | 4N Oslo | 2N Stockholm | 2N Helsinki | 2N Tallinn | 1N Riga | 1N Vilnius | 3N Gdansk | 1N Warsaw",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026"],
    stars: 3,
    price: 446999,
    image: copenhagen,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "europe-006",
    slug: "the-sophisticated-french-speaking-europe",
    categories: ["europe", "france", "germany",
      "zurich", "switzerland"],
    path: "/group-tour/europe/the-sophisticated-french-speaking-europe",
    title: "The Sophisticated French-Speaking Europe",
    duration: "13 Nights 14 Days",
    route: "2N Lyon | 1N Geneva | 1N Lausanne | 1N Bern | 1N Lucerne | 1N St Gallen | 3N Zurich | 1N Mulhouse | 1N Strasbourg | 1N Stuttgart",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 3,
    price: 238999,
    image: lyon,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "europe-007",
    slug: "classic-Europe-amsterdam-paris-switzerland",
    categories: ["europe", "paris", "france", "switzerland", "zurich"],
    path: "/group-tour/europe/classic-Europe-amsterdam-paris-switzerland",
    title: "Classic Europe – Amsterdam, Paris & Switzerland",
    duration: "9 Nights 10 Days",
    route: "2N Amsterdam | 3N Paris | 2N Geneva | 2N Zurich",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026"],
    stars: 4,
    price: 268999,
    image: amsterdam,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "europe-008",
    slug: "grand-europe-highlights-with-euroStar",
    categories: ["europe", "paris", "france", "switzerland", "italy", "zurich"],
    path: "/group-tour/europe/grand-europe-highlights-with-euroStar",
    title: "Grand Europe Highlights with EuroStar",
    duration: "13 Nights 14 Days",
    route: "2N Rome | 1N Ferrara | 1N Milan | 3N Zurich | 3N Paris | 3N London",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 365999,
    image: rome,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "europe-009",
    slug: "grand-tour-of-europe-2026",
    categories: ["europe", "paris", "france", "netherlands", "germany", "switzerland", "austria", "italy", "zurich"],
    path: "/group-tour/europe/grand-tour-of-europe-2026",
    title: "Grand Tour of Europe - 2026",
    duration: "15 Nights 16 Days",
    route: "3N London | 3N Paris | 1N Amsterdam | 1N Frankfurt | 3N Zurich | 1N Innsbruck | 1N Padova | 1N Arezzo | 1N Rome",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 399999,
    image: zurich,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "europe-010",
    slug: "wonders-of-europe-2026",
    categories: ["europe", "paris", "france", "netherlands", "germany", "switzerland", "austria", "italy", "zurich"],
    path: "/group-tour/europe/wonders-of-europe-2026",
    title: "Wonders of Europe 2026",
    duration: "12 Nights 13 Days",
    route: "3N Paris | 1N Amsterdam | 1N Frankfurt | 3N Zurich | 1N Innsbruck | 1N Padova | 1N Arezzo | 1N Rome",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Nov 2026"],
    stars: 4,
    price: 318999,
    image: innsburck,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "europe-011",
    slug: "glimpses-of-europe-2026",
    categories: ["europe", "paris", "france", "netherlands", "germany", "switzerland", "zurich"],
    path: "/group-tour/europe/glimpses-of-europe-2026",
    title: "Glimpses of Europe - 2026",
    duration: "8 Nights 9 Days",
    route: "3N Paris | 1N Amsterdam | 1N Frankfurt | 3N Zurich",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 246999,
    image: amsterdam,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  // ================= France | Monaco | Italy | Switzerland =================
  // {
  //   id: "italy-001",
  //   slug: "italy-of-previous-centuries",
  //   categories: ["italy"],
  //   path: "/group-tour/italy/italy-of-previous-centuries",
  //   title: "Italy of Previous Centuries",
  //   duration: "11 Nights 12 Days",
  //   route: "3N Rome | 2N Naples | 1N Castrovillari | 1N Tropea | 1N Scilla | 1N Crotone | 1N Bari | 1N Campobasso",
  //   departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
  //   stars: 3,
  //   price: 149999,
  //   image: maldives2,
  //   includes: ["hotels", "sightseeing", "transfers", "meals"]
  // },
  // {
  //   id: "italy-002",
  //   slug: "the-alpine-fairytale",
  //   categories: ["italy", "switzerland", "liechtenstein", "europe", "zurich"],
  //   path: "/group-tour/italy/the-alpine-fairytale",
  //   title: "The Alpine Fairytale",
  //   duration: "8 Nights 9 Days",
  //   route: "2N Milan | 1N Lugano | 1N St Moritz | 1N Vaduz | 3N Zurich",
  //   departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Dec 2026"],
  //   stars: 3,
  //   price: 169999,
  //   image: maldives2,
  //   includes: ["hotels", "sightseeing", "transfers", "meals"]
  // },
  // {
  //   id: "france-001",
  //   slug: "the-europe-of-wealth",
  //   categories: ["france", "monaco", "italy", "switzerland"],
  //   path: "/group-tour/france/the-europe-of-wealth",
  //   title: "The Europe of Wealth",
  //   duration: "11 Nights 12 Days",
  //   route: "2N Marseille | 1N Cannes | 2N Nice | 1N Monaco | 1N Genoa | 2N Turin | 1N Lugano | 1N Milan",
  //   departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
  //   stars: 4,
  //   price: 202999,
  //   image: maldives2,
  //   includes: ["hotels", "sightseeing", "transfers", "meals"]
  // },
  // {
  //   id: "france-002",
  //   slug: "france-all-time-classic",
  //   categories: ["france", "paris"],
  //   path: "/group-tour/france/france-all-time-classic",
  //   title: "France All-Time Classic",
  //   duration: "13 Nights 14 Days",
  //   route: "3N Paris | 1N Rouen | 1N Caen | 1N Le Mans | 1N Poitiers | 1N Bordeaux | 1N Toulouse | 1N Nimes | 2N Marseille | 1N Bastia | 1N Ajaccio",
  //   departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026"],
  //   stars: 3,
  //   price: 214999,
  //   image: maldives2,
  //   includes: ["hotels", "sightseeing", "transfers", "meals"]
  // },
  // {
  //   id: "france-003",
  //   slug: "benelux-and-the-sister-france",
  //   categories: ["france", "paris"],
  //   path: "/group-tour/france/benelux-and-the-sister-france",
  //   title: "Benelux and The Sister France",
  //   duration: "14 Nights 15 Days",
  //   route: "3N Amsterdam | 1N Bruges | 1N Ghent | 2N Brussels | 1N Luxembourg | 1N Colmar | 2N Reims | 3N Paris",
  //   departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026"],
  //   stars: 3,
  //   price: 302999,
  //   image: maldives2,
  //   includes: ["hotels", "sightseeing", "transfers", "meals"]
  // },
  // {
  //   id: "italy-003",
  //   slug: "medieval-italy",
  //   categories: ["italy"],
  //   path: "/group-tour/italy/medieval-italy",
  //   title: "Medieval Italy",
  //   duration: "12 Nights 13 Days",
  //   route: "2N Milan | 2N Bologna | 2N Florence | 2N Arezzo | 1N Perugia | 1N Ravenna | 2N Padua",
  //   departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Dec 2026"],
  //   stars: 3,
  //   price: 222999,
  //   image: maldives2,
  //   includes: ["hotels", "sightseeing", "transfers", "meals"]
  // },
  // {
  //   id: "franceswitzerlandgermany-001",
  //   slug: "the-sophisticated-french-speaking-europe",
  //   categories: ["france", "germany", "switzerland", "europe"],
  //   path: "/group-tour/europe/the-sophisticated-french-speaking-europe",
  //   title: "The Sophisticated French-Speaking Europe",
  //   duration: "13 Nights 14 Days",
  //   route: "2N Lyon | 1N Geneva | 1N Lausanne | 1N Bern | 1N Lucerne | 1N St Gallen | 3N Zurich | 1N Mulhouse | 1N Strasbourg | 1N Stuttgart",
  //   departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
  //   stars: 3,
  //   price: 236999,
  //   image: maldives2,
  //   includes: ["hotels", "sightseeing", "transfers", "meals"]
  // },
  {
    id: "franceswitzerlandparis-001",
    slug: "italy-swiss-paris-2026",
    categories: ["france", "paris", "italy", "switzerland", "europe", "zurich"],
    path: "/group-tour/europe/italy-swiss-paris-2026",
    title: "Italy Swiss Paris - 2026",
    duration: "10 Nights 11 Days",
    route: "2N Rome | 1N Ferrara | 1N Milan | 3N Zurich | 3N Paris ",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 268999,
    image: ferrara,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  // {
  //   id: "italy-004",
  //   slug: "the-land-of-the-legendary-etruscans",
  //   categories: ["italy"],
  //   path: "/group-tour/italy/the-land-of-the-legendary-etruscans",
  //   title: "The Land of the Legendary Etruscans ",
  //   duration: "13 Nights 14 Days",
  //   route: "3N Rome | 1N Grosseto | 2N Siena | 2N Florence | 1N Pisa | 1N Novi Ligure | 1N Genoa | 2N Milan",
  //   departureCity: ["Delhi", "Mumbai", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Nov 2026"],
  //   stars: 3,
  //   price: 253999,
  //   image: maldives2,
  //   includes: ["hotels", "sightseeing", "transfers", "meals"]
  // },
  // ================= Chaar Dham Yatra =================
  {
    id: "chardham-001",
    slug: "do-dham-yatra",
    categories: ["dehradhun", "kedarnath", "badrinath"],
    path: "/group-tour/chardham/do-dham-yatra",
    title: "Do Dham Yatra",
    duration: "3 Nights 4 Days",
    route: "1N Dehradun | 1N Phata | 1N Badrinath",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026"],
    stars: 3,
    price: 175999,
    image: badrinath,
    includes: ["helicopter", "hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "chardham-002",
    slug: "char-dham-yatra",
    categories: ["dehradhun", "kedarnath", "badrinath", "yamunotri", "gangotri"],
    path: "/group-tour/chardham/char-dham-yatra",
    title: "Char Dham Yatra",
    duration: "5 Nights 6 Days",
    route: "1N Dehradun | 1N Yamunotri | 1N Gangotri | 1N Phata | 1N Badrinath ",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026"],
    stars: 4,
    price: 252999,
    image: kedarnath,
    includes: ["helicopter", "hotels", "sightseeing", "transfers", "meals"]
  },

  // ================= Germany & Austria =================
  // {
  //   id: "germany-001",
  //   slug: "romanticism-and-wine-roads",
  //   categories: ["germany", "austria"],
  //   path: "/group-tour/germany/romanticism-and-wine-roads",
  //   title: "Romanticism and Wine Roads",
  //   duration: "9 Nights 10 Days",
  //   route: "1N Frankfurt | 1N Nuremberg | 2N Munich | 2N Freiburg | 1N Baden Baden | 1N Heidelberg | 1N Bregenz",
  //   departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Dec 2026"],
  //   stars: 3,
  //   price: 185999,
  //   image: maldives2,
  //   includes: ["hotels", "sightseeing", "transfers", "meals"]
  // },
  // {
  //   id: "germany-002",
  //   slug: "maybe-the-most-beautiful-european-area",
  //   categories: ["germany"],
  //   path: "/group-tour/germany/maybe-the-most-beautiful-european-area",
  //   title: "Maybe the Most Beautiful European Area",
  //   duration: "9 Nights 10 Days",
  //   route: "2N Munich | 1N Innsbruck | 1N Zell am See | 1N Salzburg | 1N Sankt Poelten | 3N Vienna ",
  //   departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Dec 2026"],
  //   stars: 3,
  //   price: 195999,
  //   image: maldives2,
  //   includes: ["hotels", "sightseeing", "transfers", "meals"]
  // },
  // {
  //   id: "germany-003",
  //   slug: "modern-germany-married-with-old-prussia-and-the-doll-prague",
  //   categories: ["germany"],
  //   path: "/group-tour/germany/modern-germany-married-with-old-prussia-and-the-doll-prague",
  //   title: "Modern Germany Married with Old Prussia and The Doll Prague",
  //   duration: "11 Nights 12 Days",
  //   route: "2N Frankfurt | 2N Düsseldorf | 1N Hamburg | 2N Berlin | 1N Leipzig | 1N Dresden | 2N Prague",
  //   departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["May 2026", "Jun 2026", "Oct 2026"],
  //   stars: 3,
  //   price: 229999,
  //   image: maldives2,
  //   includes: ["hotels", "sightseeing", "transfers", "meals"]
  // },
  // {
  //   id: "austria-001",
  //   slug: "the-untouched-by-time-diamonds-of-the-old-europe",
  //   categories: ["austria", "europe"],
  //   path: "/group-tour/austria/the-untouched-by-time-diamonds-of-the-old-europe",
  //   title: "The Untouched by Time Diamonds of the Old Europe",
  //   duration: "14 Nights 15 Days",
  //   route: "2N Vienna | 2N Budapest | 1N Liptovsky Mikulas | 1N Olomouc | 2N Krakow | 2N Warsaw | 1N Gdansk | 3N Prague",
  //   departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
  //   stars: 3,
  //   price: 229999,
  //   image: maldives2,
  //   includes: ["hotels", "sightseeing", "transfers", "meals"]
  // },
  // ================= New Zealand =================
  {
    id: "newZealand-001",
    slug: "explore-new-zealand",
    categories: ["newZealand"],
    path: "/group-tour/newZealand/explore-new-zealand",
    title: "Explore New Zealand",
    duration: "9 Nights 10 Days",
    route: "2N Auckland | 2N Rotorua | 3N Queenstown | 2N Christchurch ",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026"],
    stars: 4,
    price: 208999,
    image: auckland,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  // ================= Spain & Portugal =================
  // {
  //   id: "spain&portugal-001",
  //   slug: "panoram-of-andalusia-and-south-portugal",
  //   categories: ["spain", "portugal"],
  //   path: "/group-tour/spain/panoram-of-andalusia-and-south-portugal",
  //   title: "Panorama of Andalusia and South Portugal",
  //   duration: "12 Nights 13 Days",
  //   route: "3N Madrid | 2N Cordoba | 1N Cadiz | 2N Seville |  4N Lisbon",
  //   departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["Apr 2026", "May 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
  //   stars: 3,
  //   price: 238999,
  //   image: maldives2,
  //   includes: ["hotels", "sightseeing", "transfers", "meals"]
  // },
  // {
  //   id: "spain&portugal-002",
  //   slug: "europe-from-west-to-east-and-from-north-to-south",
  //   categories: ["spain", "portugal", "europe"],
  //   path: "/group-tour/europe/europe-from-west-to-east-and-from-north-to-south",
  //   title: "Europe from West to East and from North to South",
  //   duration: "17 Nights 18 Days",
  //   route: "3N Porto | 3N Barcelona | 3N Dublin | 3N Edinburgh | 2N Malta | 3N Larnaca",
  //   departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Nov 2026"],
  //   stars: 3,
  //   price: 412999,
  //   image: maldives2,
  //   includes: ["hotels", "sightseeing", "transfers", "meals"]
  // },
  // {
  //   id: "spain&portugal-003",
  //   slug: "iberian-peninsula-of-the-north",
  //   categories: ["spain", "portugal"],
  //   path: "/group-tour/spain/iberian-peninsula-of-the-north",
  //   title: "Iberian Peninsula of the North ",
  //   duration: "17 Nights 18 Days",
  //   route: "3N Barcelona | 1N Valencia | 2N Madrid | 1N Oliveira do Douro | 3N Porto | 1N Vigo | 1N Santiago de Compostela | 1N Oviedo | 2N Madrid | 1N Zaragoza | 1N Barcelona",
  //   departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026"],
  //   stars: 3,
  //   price: 321999,
  //   image: maldives2,
  //   includes: ["hotels", "sightseeing", "transfers", "meals"]
  // },
  // ================= Japan =================
  {
    id: "japan-001",
    slug: "japan-for-first-timers-the-classic-route",
    categories: ["japan"],
    path: "/group-tour/japan/japan-for-first-timers-the-classic-route",
    title: "Japan for First Timers - The Classic Route",
    duration: "6 Nights 7 Days",
    route: "3N Tokyo | 1N Kanazawa | 2N Kyoto",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Nov 2026"],
    stars: 4,
    price: 326999,
    image: tokyo,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "japan-002",
    slug: "japan-alpine-route-snow-wall-experience",
    categories: ["japan"],
    path: "/group-tour/japan/japan-alpine-route-snow-wall-experience",
    title: "Japan Alpine Route - Snow Wall Experience",
    duration: "9 Nights 10 Days",
    route: "2N Tokyo | 1N Gotemba | 1N Nagano | 1N Toyama | 1N Nagoya | 3N Osaka",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Joining Direct"],
    availableDate: ["Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 374999,
    image: gotemba,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "japan-003",
    slug: "japan-for-all-mt.Fuji-tokyo-osaka-city-highlights-hiroshimas-past",
    categories: ["japan"],
    path: "/group-tour/japan/japan-for-all-mt.Fuji-tokyo-osaka-city-highlights-hiroshimas-past",
    title: "Japan for all - Mt. Fuji, Tokyo & Osaka City Highlights & Hiroshima’s Past",
    duration: "6 Nights 7 Days",
    route: "3N Tokyo | 1N Hiroshima | 2N Osaka",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Joining Direct"],
    availableDate: ["Jun 2026"],
    stars: 4,
    price: 249999,
    image: hiroshima,
    includes: ["hotels", "sightseeing", "transfers", "meals"]
  },
  // {
  //   id: "japan-004",
  //   slug: "sakura-moments-the-ultimate-cherry-blossom-2026",
  //   categories: ["japan"],
  //   path: "/group-tour/japan/sakura-moments-the-ultimate-cherry-blossom-2026",
  //   title: "Sakura Moments - The Ultimate Cherry Blossom 2026",
  //   duration: "7 Nights 8 Days",
  //   route: "3N Tokyo | 1N Hakone | 1N Hiroshima | 2N Osaka",
  //   departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Joining Direct"],
  //   availableDate: ["May 2026"],
  //   stars: 4,
  //   price: 322999,
  //   image: maldives2,
  //   includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  // },
  {
    id: "japan-005",
    slug: "classic-japan-journey-fuji-kyoto-bullet-train",
    categories: ["japan"],
    path: "/group-tour/japan/classic-japan-journey-fuji-kyoto-bullet-train",
    title: "Classic Japan Journey: Fuji, Kyoto & Bullet Train",
    duration: "8 Nights 9 Days",
    route: "4N Tokyo | 2N Kyoto | 2N Osaka",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Nov 2026"],
    stars: 4,
    price: 378999,
    image: kyoto,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  {
    id: "japan-006",
    slug: "satvik-japan-premium-veg-departure",
    categories: ["japan"],
    path: "/group-tour/japan/satvik-japan-premium-veg-departure",
    title: "Satvik Japan – Premium Veg Departure",
    duration: "9 Nights 10 Days",
    route: "3N Tokyo | 1N Hakone | 2N Kyoto | 3N Osaka",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 394999,
    image: osaka,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },
  // ================= Netherlands =================
  // {
  //   id: "netherlands-001",
  //   slug: "the-netherlands",
  //   categories: ["netherlands"],
  //   path: "/group-tour/netherlands/the-netherlands",
  //   title: "The Netherlands",
  //   duration: "10 Nights 11 Days",
  //   route: "3N Brussels | 2N Bruges | 1N Rotterdam | 1N The Hague | 3N Amsterdam",
  //   departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Ahmedabad", "Joining Direct"],
  //   availableDate: ["May 2026"],
  //   stars: 3,
  //   price: 219999,
  //   image: maldives2,
  //   includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  // },
  // ================= Australia =================
  // {
  //   id: "australia-001",
  //   slug: "grand-australia-package",
  //   categories: ["australia"],
  //   path: "/group-tour/australia/grand-australia-package",
  //   title: "Grand Australia Package",
  //   duration: "12 Nights 13 Days",
  //   route: "3N Melbourne | 3N Gold Coast | 3N Cairns | 3N Sydney",
  //   departureCity: ["Delhi", "Mumbai", "Bangalore", "Joining Direct"],
  //   availableDate: ["Apr 2026"],
  //   stars: 4,
  //   price: 429999,
  //   image: maldives2,
  //   includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  // },
  // ================= UK and Scotland =================
  {
    id: "ukandscotland-001",
    slug: "Wonders of UK and Scotland",
    categories: ["scotland"],
    path: "/group-tour/scotland/Wonders of UK and Scotland",
    title: "Wonders of UK and Scotland",
    duration: "7 Nights 8 Days",
    route: "2N London | 1N Manchester | 2N Glasgow | 1N Birmingham | 1N London",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Ahemdabad", "Kolkata", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 264999,
    image: manchester,
    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"]
  },

];

export const GroupTourPackageDetails = [
  // ================= Nepal =================
  {
    id: "nepal-001",
    slug: "mystic-nepal-getaway",
    destination: "Nepal",
    title: "Mystic Nepal Getaway",
    duration: "5 Nights 6 Days",
    route: "2N Kathmandu | 2N Pokhara | 1N Kathmandu",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Ahemdabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", " Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Nov 2026", "Dec 2026"],
    stars: 3,
    price: 28499,
    tags: ["🔥Best Seller 2026 ", " 🌴 Nepal Mystic"],
    rating: 4.9,

    // ✅ MULTIPLE IMAGES
    images: [
      kathmandu,
      pokhara
    ],

    // 🔥 PACKAGE INCLUDES (TOP RIGHT ICONS)
    includes: ["hotels", "sightseeing", "transfers", "meals"],

    hotels: [
      {
        location: "Kathmandu",
        nights: "2 Nights",
        type: "Temple Suites Kathmandu or similar - 3 Star Hotel"
      },
      {
        location: "Pokhara",
        nights: "2 Nights",
        type: "Hotel Murano or similar - 3 Star Hotel"
      },
      {
        location: "Kathmandu",
        nights: "1 Nights",
        type: "Temple Suites Kathmandu or similar - 3 Star Hotel"
      }
    ],

    sightseeing: [
      {
        title: "Kathmandu Sightseeing"
      },
      {
        title: " Manakamana Temple"
      },
      {
        title: " Pokhara Sightseeing"
      }
    ],

    transfers: [
      {
        from: "Airport",
        to: "Hotel",
        type: "Private"
      },
      {
        from: "Hotel",
        to: "Airport",
        type: "Private"
      },

    ],

    meals: [
      {
        title: "Daily Breakfast Included"
      },
      {
        title: "Daily Dinner Included"
      }
    ],


    // 🔥 INCLUSIONS
    inclusions: [
      "Visit the sacred Pashupatinath Temple, one of the holiest shrines of Lord Shiva",
      "Explore the iconic Boudhanath Stupa, a center of Tibetan Buddhism",
      "Enjoy panoramic valley views from Swayambhunath Stupa",
      "Walk through the artistic heritage of Patan Durbar Square",
      "Scenic drive along rivers and hills between Kathmandu and Pokhara",
      "Optional cable car ride to Manakamana Temple",
      "Discover natural wonders like Devi's Fall and Gupteshwor Cave",
      "Visit fascinating caves: Bat Cave & Mahendra Cave",
      "Witness the dramatic Seti Gorge",
      "Relax by the serene Phewa Lake with optional boating",
      "Perfect mix of spiritual experiences, scenic beauty, and leisure"
    ],

    // 🔥 EXCLUSIONS
    exclusions: [
      "Airfare (unless mentioned or added in the package)",
      "Entry charges to Monuments, Museums and Forts (Directly to be paid by the guest)",
      "Laundry services, phone calls, beverages, meals not indicated in the itinerary, tips any type, personal costs, optional tours and excursions and anything that is not mentioned in ‘Inclusions’."
    ],

    // 🔥 ITINERARY WITH DETAILS
    itinerary: [
      {
        day: 1,
        title: "Arrival in Kathmandu",
        detail:
          "Arrive at Tribhuvan International Airport in Kathmandu. After clearing immigration and customs, you will be greeted and transferred to your hotel. Check in and take some time to relax after your journey. Depending on your arrival time, you can explore nearby streets, markets, or enjoy a short walk around the vibrant Thamel area. Overnight stay in Kathmandu."
      },
      {
        day: 2,
        title: "Kathmandu Sightseeing",
        detail:
          "After breakfast, begin a full-day cultural tour of Kathmandu’s प्रमुख UNESCO World Heritage Sites. Start with Pashupatinath Temple, one of the most sacred Hindu temples dedicated to Lord Shiva, located on the banks of the Bagmati River. Observe traditional rituals and cremation ceremonies from a respectful distance. Next, visit Boudhanath Stupa, one of the largest Buddhist stupas in the world. Walk around the stupa (kora), spin prayer wheels, and soak in the peaceful spiritual ambiance. Continue to Swayambhunath Stupa (also known as the Monkey Temple), situated atop a hill offering panoramic views of Kathmandu Valley. The site is a blend of Hindu and Buddhist symbolism. Later, explore Patan Durbar Square in Lalitpur, famous for its intricate Newari architecture, ancient palaces, temples, and courtyards. Visit the Patan Museum and admire the craftsmanship of traditional artisans. Return to your hotel in the evening. Overnight stay in Kathmandu."
      },
      {
        day: 3,
        title: "Drive to Pokhara",
        detail:
          "After breakfast, begin your scenic drive to Pokhara (approx. 6–8 hours). The journey follows the Trishuli River and offers beautiful views of hills, rivers, and rural landscapes. En route, you may opt to visit Manakamana Temple (at extra cost), a sacred Hindu temple believed to fulfill wishes. Reach the temple via a cable car ride offering stunning views of the surrounding valleys. Continue your drive to Pokhara, a serene lakeside city known for its natural beauty and mountain views. Upon arrival, check in to your hotel. Spend the evening relaxing by Phewa Lake or strolling along Lakeside Market. Overnight stay in Pokhara."
      },
      {
        day: 4,
        title: "Pokhara Sightseeing",
        detail:
          "After breakfast, proceed for a full-day sightseeing tour of Pokhara. Start with Devi’s Fall, a unique waterfall that disappears into an underground tunnel. Just across the road, visit Gupteshwor Mahadev Cave, a sacred cave housing a shrine dedicated to Lord Shiva and offering views of the underground waterfall. Continue to Bat Cave (Chamero Gufa), known for its population of bats, and Mahendra Cave, a limestone cave famous for its stalactites and stalagmites. Visit Seti Gorge, where the Seti River flows through a deep and narrow gorge, creating a fascinating natural sight. Later, enjoy time at Phewa Lake, the second-largest lake in Nepal. You can opt for a boat ride (optional) and visit the Tal Barahi Temple located on an island in the lake. Return to your hotel in the evening. Overnight stay in Pokhara"
      },
      {
        day: 5,
        title: "Drive back to Kathmandu",
        detail:
          "After breakfast, drive back to Kathmandu (approx. 6–8 hours). Upon arrival, check in to your hotel. In the evening, you can explore local markets for shopping or relax at the hotel. Overnight stay in Kathmandu."
      },
      {
        day: 6,
        title: "Departure",
        detail:
          "After breakfast, check out from the hotel and transfer to Tribhuvan International Airport for your onward journey. Tour ends with beautiful memories of Nepal."
      }
    ],

    // 🔥 OVERVIEW
    overview:
      "Discover the perfect blend of spirituality, culture, and natural beauty with this enchanting Nepal journey. From the sacred temples and UNESCO World Heritage Sites of Kathmandu to the tranquil lakes and Himalayan views of Pokhara, this tour offers a refreshing escape into the heart of the Himalayas. Witness timeless traditions, explore heritage landmarks, and unwind amidst breathtaking landscapes. Ideal for first-time travelers, this itinerary balances comfort, exploration, and relaxation.",
  },
  // ================= NorthEast - Assam & Meghalaya =================
  {
    id: "northeast-001",
    slug: "northeast-odyssey-assam-meghalaya",
    destination: "Northeast",
    title: "Northeast Odyssey: Assam & Meghalaya",
    duration: "6 Nights 7 Days",
    route: "1N Guwahati | 1N Kaziranga | 3N Shillong | 1N Guwahati ",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026"],
    stars: 3,
    price: 34999,
    tags: ["💑 Honeymoon Special", "🌴 Northeast Odyssey"],
    rating: 4.7,

    images: [guwahati,kaziranga,shillong],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Delhi", to: "Denpasar", type: "1 Stop" }
    // ],

    hotels: [
      { location: "Guwahati", nights: "1 Nights", type: "IRIS the Boutique HOTEL or similar - 3 Star Hotel" },
      { location: "Kaziranga", nights: "1 Nights", type: "Dhanshree Resort or similar or similar - 3 Star Hotel" },
      { location: "Shillong", nights: "3 Nights", type: "Hotel Alpine Continental or similar - 3 Star Hotel" },
      { location: "Guwahati", nights: "1 Nights", type: "IRIS the Boutique HOTEL or similar - 3 Star Hotel" },
    ],

    sightseeing: [
      { title: "Guwahati & Kamakhya Sightseeing" },
      { title: "Kazirang safari Sightseeing" },
      { title: "Cheerapunjee Sightseeing" },
      { title: "Mawlynnong & Dawki Sightseeing" },
      { title: "Shillong Sightseeing" },
      { title: "Umiam Lake Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Daily Breakfast Included" },
      { title: "Daily Dinner Included" }
    ],


    inclusions: [
      "Accommodation in all places as per the itinerary.",
      "Daily Breakfast & Dinner will be provided.",
      "All Tours and Transfers on a point-to-point basis by private vehicle.",
      "Half-day Guwahati sightseeing including Kamakhya Temple, Umananda Temple & Brahmaputra Ropeway.",
      "Kaziranga Jeep Safari (02 Jeeps) and visit to Kaziranga Orchid Park.",
      "Excursion to Cherrapunjee – Nohkalikai Falls, Mawsmai Cave & Seven Sisters Falls.",
      "Excursion to Mawlynnong & Dawki – Asia’s Cleanest Village & crystal-clear Umngot River.",
      "Shillong Local Sightseeing – Wards Lake, Don Bosco Museum, Lady Hydari Park & Elephant Falls.",
      "Stopover at the picturesque Umiam Lake en route.",
      "All Hotel Taxes, Driver Allowance, and Parking Fees included.",
    ],

    exclusions: [
      "Airfare, train fare, or travel/medical insurance",
      "Any services or facilities not specifically mentioned in the inclusions",
      "Personal expenses such as laundry, telephone calls, tips, porterage, etc.",
      "Alcoholic beverages and snacks",
      "Elephant Safari at Kaziranga National Park – ₹1,650 per person (optional)",
      "Brahmaputra River Cruise – ₹750 per person (optional)",
      "Traditional Bihu Dance Show – ₹550 per person (optional)",
      "Camera / video camera fees at monuments or parks",
      "Special Entry Passes or VIP Darshan at Kamakhya Temple",
      "Any increase in fuel prices, taxes, or entrance fees after booking",
      "Expenses arising from natural calamities, roadblocks, strikes, or political disturbances (to be borne directly by the guest as per actual cost)",
    ],

    itinerary: [
      { day: 1, title: "Arrival at Guwahati – Half-Day Sightseeing (Only possible if Flight is arriving before 10 am)", detail: "Arrive at Guwahati Airport / Railway Station. Meet and greet, then transfer to your hotel for check-in and refreshments. Later, visit the famous Kamakya Temple, take a ride on the Brahmaputra River Ropeway, and visit the serene Umananda Temple located on Peacock Island. Return to your hotel for an overnight stay in Guwahati." },
      { day: 2, title: "Guwahati – Kaziranga", detail: "After breakfast, drive to Kaziranga National Park, home to the one-horned rhinoceros. En route, enjoy the scenic views of Kaziranga Forests and Tea Gardens. Upon arrival, check in to your hotel. In the evening, visit the Kaziranga Orchid Park and enjoy a traditional Bihu Dance Performance, a vibrant showcase of Assamese culture. Overnight stay at Kaziranga." },
      { day: 3, title: "Kaziranga Safari – Shillong", detail: "Early morning, enjoy a thrilling jeep safari in the central range of Kaziranga (optional/additional cost). After breakfast, proceed towards Shillong – known as the “Scotland of the East.” En route, stop at the picturesque Umiam Lake for photo opportunities. Upon arrival, check in to your hotel and relax. Evening free for leisure. Overnight stay at Shillong." },
      { day: 4, title: "Excursion to Cherrapunjee", detail: "After breakfast, take a full-day excursion to Cherrapunjee, one of the wettest places on Earth. Visit major attractions such as Nohkalikai Falls, Seven Sisters Falls, Mawsmai Cave, Arwah Cave, Eco Park, Ram Krishna Mission, and the iconic Living Root Bridge. Return to Shillong for an overnight stay." },
      { day: 5, title: "Excursion to Mawlynnong & Dawki", detail: "After breakfast, drive to Mawlynnong, known as the Cleanest Village in Asia. Explore the village, walk on the Sky Walk, and see the unique Living Root Bridge. Later, drive to Dawki, located on the India–Bangladesh border, and enjoy the crystal-clear waters of the Umngot River. Return to Shillong in the evening. Overnight stay at Shillong" },
      { day: 6, title: "Shillong Halfday sightseeing – Guwahati via Umiam Lake.", detail: "After breakfast, check out from the hotel and drive back to Guwahati. En route, stop again at Umiam Lake for a short break. Upon arrival in Guwahati, proceed for a half-day city tour covering Wards Lake, Don Bosco Museum, Lady Hydari Park, and Elephant Falls. Later, check in to your hotel. Overnight stay in Guwahati." },
      { day: 7, title: "Departure from Guwahati", detail: "After breakfast, check out from the hotel and transfer to Guwahati Airport / Railway Station for your onward journey with pleasant memories." }
    ],

    overview: "Embark on a journey through the magical landscapes of Northeast India — where wilderness meets waterfalls and spirituality blends with serenity. Begin your adventure in Guwahati, home to the revered Kamakhya Temple, before heading to the wild heart of Assam — Kaziranga, the land of the great one-horned rhinoceros. Continue to the misty hills of Shillong and Cherrapunjee, where emerald valleys, cascading falls, and living root bridges await. Experience the charm of clean villages, the clarity of Dawki River, and the cultural warmth of the Northeast on this unforgettable 6-night journey."
  },
  // ================= Bhutan =================
  {
    id: "bhutan-001",
    slug: "amazingbhutan",
    destination: "Bhutan",
    title: "Amazing Bhutan",
    duration: "7 Nights 8 Days",
    route: "1N Phuntsholing  | 2N Thimphu | 1N Punakha | 2N Paro | 1N Phuntsholing",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", " Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Nov 2026", "Dec 2026"],
    stars: 3,
    price: 39999,
    tags: ["💑 Honeymoon Special", "🌴 Amazing Bhutan"],
    rating: 4.7,

    images: [phuntsholing,thimpu,punakha,paro],

    includes: ["hotels", "sightseeing", "transfers", "meals"],


    // flights: [
    //   { from: "Delhi", to: "Denpasar", type: "1 Stop" }
    // ],

    hotels: [
      { location: "Phuntsholing", nights: "1 Nights", type: "Hotel Bhutan Ga Me Ga or similar - 3 Star Hotel" },
      { location: "Thimphu", nights: "2 Nights", type: "Hotel Dralha or similar - 3 Star Hotel" },
      { location: "Punakha", nights: "1 Nights", type: "Punakha Residency or similar - 3 Star Hotel" },
      { location: "Paro", nights: "2 Nights", type: "Udumwara Resort or similar - 3 Star Hotel" },
      { location: "Phuntsholing", nights: "1 Nights", type: "Hotel Bhutan Ga Me Ga or similar - 3 Star Hotel" },
    ],

    sightseeing: [
      { title: "Thimphu Sightseeing" },
      { title: "Punakha Sightseeing" },
      { title: "Paro Sightseeing" },
      { title: "Tiger's Nest Hike " },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Daily Breakfast Included" },
      { title: "Daily Dinner Included" }
    ],


    inclusions: [
      "Accommodation in All Places.",
      "Daily Breakfast & Dinner will be provided.",
      "All Tours and Transfer are on point yo point basis.",
      "Thimphu Local Sightseeing.",
      "Punakha Excursion.",
      "Excursion to Taktshang Monastery.",
      "All Permit Fee and Hotel Taxes (as per the itinerary)",
      "Sdf & Guide Charges",
    ],

    exclusions: [
      "Air Fare / Train fare.",
      "Personal Expenses such as Laundry, telephone calls, tips & gratuity, mineral water, soft & hard drinks.",
      "Additional sightseeing or extra usage of vehicle, other than mentioned in the itinerary.",
      "Entrance Fees.",
      "Any increase in taxes or fuel price, leading to increase in cost on surface transportation & land arrangements, which may come into effect prior to departure.",
      "Room Heater Charges.",
      "Travel Insurance.",
      "Anything which is not included in the inclusion",
      "Any Medical/rescue evacuation due to mishaps.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "NJP Rly Station / IXB Airport – Phuentsholing (Distance: 170 kms. / Driving Time: 5 hrs. / Altitude of Phuentsholing: 293 mts.)",
        detail:
          "Meet & Greet on arrival at NJP Railway Station / IXB Airport and transfer to Phuentsholing - The Gateway of Bhutan by Road from India. It is a thriving commercial center on the northern edge of the Indian Plains. On arrival check in at the hotel. Overnight stay at Phuentsholing"
      },
      {
        day: 2,
        title:
          "Phuentsholing to Thimphu (Distance: 176 kms. / Driving Time: 6 hrs. / Altitude of Thimphu: 2350 mts.)",
        detail:
          "Note: The driver and guide will meet today at around 8:30 AM at the Phuentsholing border for immigration. The process should take a maximum of 1 hour. They will remain there until the journey to Thimphu begins. After breakfast, proceed towards Thimphu. Halt at Chojum to take photographs of the confluence of two rivers of Bhutan, Thumpu Chu, and Paro Chu. Reach Thimpu in the evening. On arrival check in at the hotel. In the evening free for your own activity .Overnight stay at Thimphu."
      },
      {
        day: 3,
        title:
          "Thimphu local sightseeing",
        detail:
          "After breakfast, the day is dedicated to sightseeing in Thimphu. You will see the following tourist sites in Thimphu Kuenselphodrang National Memorial Chorten Folk Heritage Museum Sangaygang view point Takin Reserve Centre. Tashichho Dzong (Fortress of the Glorious Religion) and simply Bhutan .Dinner and Overnight Stay at Thimphu Hotel."
      },
      {
        day: 4,
        title:
          "Thimphu to Punakha Transfer via Dochula pass and sightseeing (4 Hrs)",
        detail:
          "After breakfast, drive to Punakha/Wangdue via the scenic Dochula Pass. Upon arrival, check into your hotel and enjoy lunch. Visit the Punakha Dzong, Chimi Lhakhang, Punakha Suspension Bridge, and Punakha Village. Return to the hotel for Punakha overnight stay."
      },
      {
        day: 5,
        title:
          "Punakha to Paro and Paro sightseeing",
        detail:
          "After breakfast, drive to Paro via Dochu La Pass, passing the Paro Chhu and Wang Chhu river valleys. Visit Simtokha Dzong en route. In Paro, check into your hotel and visit: Ta Dzong Rinpung Dzong Tamchog Lhakhang Return to the hotel for an Overnight stay."
      },
      {
        day: 6,
        title:
          "Day Excursion to Taktshang Monastery",
        detail:
          "After early morning breakfast, you will be starting a Excursion tour to Taktsang Monastery. Taksand Palphug Monastery also known as Tiger's Nest is an amazing Buddhist monastery, temple and sacred site located in the upper Paro town. Built in 1692, Padmasambhava is believed to have meditated at this site for 3 years. Guru Padmasambhava is known to be the founder of Buddhism religion in Bhutan. He is immensely respected and has a huge number of sacred followers in Bhutan. Kyichu Lhakhang is one of the oldest Buddhist Temples in Bhutan (if not the oldest) and it is considered to be a prime example of the ornate Bhutanese architecture. Overnight at the Paro."
      },
      {
        day: 7,
        title:
          "The Chelala Pass (Day Excursion) & Transfer To Phuentsholing",
        detail:
          "Chele-la remains one of the least visited areas in the country and retains the air of an unspoiled, primeval forest. Drive to Chele La Pass (3,988m) from which on a clear day the view sweeps away to Bhutan’s second-highest sacred peak, Mt Jomolhari (7314m). On arrival check in at the hotel. Evening Free for Leisure. Overnight stay at Phuentsholing."
      },
      {
        day: 8,
        title:
          "Phuntsholing To Bagdogra / NJP Drop",
        detail:
          "On the final day of your journey in Bhutan, the day begins with a leisurely breakfast at your hotel in Phuentsholing. After enjoying your meal, it's time to check out and bid farewell to the warm hospitality that has accompanied you throughout your stay. Your driver will be waiting to transfer you to Bagdogra Airport, where you'll catch your departing flight. As you embark on this final leg of your trip, take a moment to reflect on the memories you've made, the sights you've seen, and the experiences you've cherished during your time in the Land of the Thunder Dragon."
      }
    ],

    overview: "Marvel at the beauty of Bhutan with this travel package that takes you through its most enchanting destinations. Begin with a scenic descent into Bagdogra Airport or NJP Railway Station, followed by a transfer to Phuentsholing. Explore the local markets before heading to Thimphu, the capital city, where you'll visit cultural landmarks like the National Memorial Chorten, Buddha Point, and the Takin Preserve. The journey continues to Punakha, home to the stunning Punakha Dzong and the historic Punakha Suspension Bridge. In Paro, the highlight is an excursion to the iconic Taktshang Monastery, perched dramatically on a cliffside. The tour also includes visits to Ta Dzong and Rinpung Dzong, showcasing Bhutan's rich art and architecture. Conclude your adventure with a return to Phuentsholing before departing from Bagdogra or NJP Railway Station. This package offers a perfect blend of natural beauty, cultural immersion, and spiritual experiences."
  },
  // ================= Vietnam =================
  {
    id: "vietnam-001",
    slug: "vietnam-adventure-quest",
    destination: "Vietnam",
    title: "Vietnam Adventure Quest",
    duration: "6 Nights 7 Days",
    route: "2N Ho Chi Minh City  | 2N Da Nang | 1N Hanoi",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["May 2026"],
    stars: 4,
    price: 44999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [hochiminhcity,daNang,hanoi],

    includes: ["hotels", "sightseeing", "transfers", "meals"],


    // flights: [
    //   { from: "Delhi", to: "Denpasar", type: "1 Stop" }
    // ],

    hotels: [
      { location: "Ho Chi Minh City", nights: "2 Nights", type: "Adora Mira Hotel or similar - 4 Star Hotel" },
      { location: "Da Nang", nights: "2 Nights", type: "GRAND CITIVIEW DA NANG HOTEL or similar - 4 Star Hotel" },
      { location: "Hanoi", nights: "1 Nights", type: "Chalcedony Grand Hotel or similar- 4 Star Hotel" },
    ],

    sightseeing: [
      { title: "Ho Chi Minh City Sightseeing" },
      { title: "Da Nang Sightseeing" },
      { title: "Hanoi Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Sharing" },
      { from: "Hotel", to: "Airport", type: "Sharing" },

    ],

    meals: [
      { title: "Daily Breakfast Included" },
    ],


    inclusions: [
      "6 Nights stay in 4* hotels as per the itinerary",
      "Daily Breakfasts, 4 Local Lunches, 1 Dinner at Local Restaurant",
      "Single Entry Vietnam Visa",
      "All sightseeing and transfers as per the itinerary on a shared basis",
      "Halong Bay Day Cruise with Seafood Lunch",
      "Full Day Mekong Delta Tour with Cu Chi Tunnels",
      "Half Day Ho Chi Minh City Tour",
      "Explore Marble Mountain and Hoi An Ancient Town (including Phuc Kien Assembly Hall, Tan Ky Ancient House, and Japanese Covered Bridge)",
      "Lantern Release Ceremony in Hoi An",
      "Full Day Ba Na Hills Tour (including Golden Bridge, Linh Ung Pagoda, Fantasy Park, and Le Jardin)",
      "Full-Day Hanoi City Tour",
      "Full-Day Halong Bay Tour with a Boat Cruise and Scenic Views of Iconic Islets",
    ],

    exclusions: [
      "Tips for Guide (USD 3 per person per day) is mandatory and not included.",
      "Any increase in Airfare, Visa fees, Airport taxes, Govt Taxes, Fuel Surcharges and any applicability of new taxes from Govt.",
      "Any up gradation in Airline class or hotel room category Cost of Air ticket deviation charges.",
      "Any Increase in the rate of exchange leading to an increase in all land arrangements which may come in to effect prior to departure.",
      "Cost of pre or post tour hotel accommodation.",
      "Any extra expense such as route change, Airline change, Date change, Accommodation facilities, etc incurred due to the unforeseen, unavoidable forced majeuere circumstances during the tour.",
      "Porterage, laundry, telephone charges, shopping, wines & alcoholic beverages, items of personal nature and food or drink which is not part of a set group menu.",
      "Any extra cost incurred on behalf of an individual due to illness, accident, hospitalization, or any personal emergency.",
      "Any services or activity charges other than those included in the group tour itinerary.",
      "In case a passenger is opting for direct joining, the cost for airport transfers shall be borne directly by the passenger and will join the group at the hotel.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival at Ho Chi Minh City + Half Day City Tour (Only if flight lands by 11 am)",
        detail:
          "Upon your arrival at Ho Chi Minh City, you will be met by our representative and transferred to your hotel. In the afternoon visit to Cho Lon (Big Market) and Thien Hau Pagoda which is located in China Town. Continue to Bach Dang harbor. After checking in the waterbus tickets, and stabilizing your seat, the boat will start to depart. During the trip, you will have a unique view of the most typical commercial buildings of the city including the Vinhomes Central Park urban area, the magnificent Landmark 81 tower, the Bitexco Financial Tower, the green peaceful District 2. A lot of stunning moments are waiting for you. Try to discover the soul of this land - Saigon River by water bus, maybe you will realize many miracles, a more accurate view of the land once called Paris of Indochina or the Pearl of the Far East. 18:00 PM: Transfer back your hotel or meeting point. Finish the trip."
      },
      {
        day: 2,
        title:
          "Full Day Mekong Delta - Cu Chi Tunnel Tour",
        detail:
          "Pick up at your hotels in Ho Chi Minh City. The trip to Cu Chi will take you an approximately one and a half-hour bus drive. Before exploring the tunnels, you will watch an introductory video about how the tunnels were made and how Vietnamese people survived in the harsh conditions of the wartime. Then, spend your time exploring the remaining areas and tunnel system which include special living areas with kitchens and bedrooms side by side with other martial facilities like weapons factories, field hospitals, and command centers helping whoever lives inside the tunnels meet their basic needs. Besides, there are also many hidden trap doors and dangerous traps within the maze-like tunnels for the security purpose during the war. Afterwards, special tea and cassava (guerrillas’ food during the war) will be served. Break time. Have lunch at the local restaurant. Continue to visit My Tho city. With boat trip on Tien River, you will be excited by the light breeze from the river and the natural beauty of four beautiful islands such as Dragon, Unicorn, Phoenix and Tortoise along the riverside. Cruise through the small canal by sampan, treating yourself to the beauty of the countryside, and taking a short cycling around the village which will certainly be an unforgettable experience when participating in the Mekong Delta tour. Visit the coconut candy workshop, and enjoy seasonal delicious fruits & honey tea. Get a chance to listen to the Southern Vietnamese folk music which is performed by local people. Return to Ho Chi Minh City. Trip ends. Note: Please ensure that the flight from Ho Chi Minh City to Da Nang is in the morning. (Breakfast and Local Lunch)"
      },
      {
        day: 3,
        title:
          "Fly from Ho Chi Minh to Da Nang - Half Day Marble Mountain and Hoi An Ancient Town with Lantern Release - Shared Transfer (Including Dinner)",
        detail:
          "Today morning, check out from your hotel. Later on you will be transferred to the Ho Chi Minh Airport to catch your flight to Da Nang. Upon your arrival at Da Nang airport you will be met by our representative and transferred to your hotel. Check-in and relax for some time. 14:00 – 14:45 pm: Car and tour guide pick up at HOTEL. 16:00 pm: Visit the Non Nuoc carvings-stone village and conquer Marble Mountains, explore the beauty of the mysterious caves, visit the ancient temples hundred years: Linh Ung and Tam Thai. 17:30 pm: After leaving Marble Mountains, shopping Local Specialities. Depart to Hoi An Ancient Town 18:00 pm: Have a dinner at Hoi An restaurant. 19:30 pm: Walking to visit and shopping in Ancient Town, admire Hoi An at night flickering in multi – colored lantern. 21:00 pm: Depart to Da Nang City. Send – off at Hotel (Breakfast and Dinner)"
      },
      {
        day: 4,
        title:
          "Full-Day Tour to Ba Na Hills, French Village, and Golden Hands Bridge; Stay in Da Nang",
        detail:
          "After breakfast, begin your exciting day with a pick-up from your hotel for a journey to the stunning Ba Na Hills. Your adventure starts at the Suoi Mo cable car station, where you’ll embark on a thrilling ride. This ride is known for holding four world records and offering breathtaking views of the lush landscapes below. Upon arriving at Ba Na Hills, step onto the world-famous Golden Bridge, a 150-meter-long architectural marvel supported by giant stone hands, offering mesmerizing views and photo opportunities. Explore the enchanting Le Jardin d’Amour, a picturesque garden with a touch of French colonial charm, and visit the serene Linh Ung Pagoda, home to a majestic 27-meter-high Buddha statue. Take a leisurely stroll through the peaceful Loc Uyen Garden and Quan Am Cac, soaking in the tranquil atmosphere. Those interested can visit the historic Debay Wine Cellar, an optional experience available for direct payment. The wine cellar offers a fascinating glimpse into the French colonial heritage with a collection of fine wines. For a dose of excitement, head to Fantasy Park, where thrilling rides and activities await, including the Love Swing, Skiver Pilot, Fire Racing Track, Bumper Cars, and the spine-chilling Ghost House. Around midday, savor a delightful buffet lunch in the area before heading to the peak of Chua Mountain at an altitude of 1,487 meters. From here, enjoy panoramic views of Da Nang City and Da Nang Bay, and pay a visit to the Ba Chua Thuong Ngan Temple, a revered spiritual site at the summit. After a day filled with unforgettable experiences, return via cable car and head back to Da Nang. Spend some time shopping for local specialties and souvenirs, a perfect way to conclude your day. Finally, return to your hotel for a relaxing evening, cherishing the memories of this extraordinary adventure. Breakfast, Local Lunch"
      },
      {
        day: 5,
        title:
          "Arrival in Hanoi - Half Day City Tour",
        detail:
          "Take your flight from Da Nang to Hanoi. Please reach before 11:am Upon arrival, you will be met by our representative, embark on a half-day city tour to explore the historical gems of Hanoi. KINDLY CHOOSE BETWEEN THE MORNING TOUR OR AFTERNOON TOUR --- MORNING TOUR: Embark on a captivating exploration of Hanoi City as our friendly guide picks you up between 8:00 and 8:30 AM. Your journey begins with a visit to Tran Quoc Pagoda, nestled on the picturesque Golden Fish Island in West Lake. This ancient pagoda, dating back to the 6th century, is a testament to Hanoi's rich history. Next, you'll discover the Ho Chi Minh Complex, where you'll have a remarkable opportunity to view the preserved body of Ho Chi Minh himself. Stroll through the lush garden, which once served as his residence and workplace from 1954 to 1969. Your next stop is the One Pillar Pagoda, an architectural marvel dedicated to the Goddess of Mercy. It stands as one of the world's most unique pagodas. Please remember to dress modestly, covering your shoulders and knees when visiting Ho Chi Minh Mausoleum, temples, and pagodas. Keep in mind that the mausoleum is closed on Mondays and Fridays, if you travel on closing dates of this place, our guide would replace this to another attraction. By 11:15 AM, we would visit the Vietnam Ethnology Museum, where you'll gain valuable insights into the diverse cultures of the country's 54 ethnic groups. On Mondays, when the Ethnology Museum is closed, we'll take you to the Women's Museum for an equally enriching experience. By lunchtime, savor a Vietnamese lunch at local restaurant. Your morning half-day city tour concludes here, leaving you with a deeper understanding of Hanoi's cultural and historical treasures. -- OR -- --- AFTERNOON TOUR: Your adventure begins with our friendly guide extending a warm welcome as they pick you up from your hotel. You're about to embark on an enriching afternoon exploration of Hanoi, one of Vietnam's most culturally vibrant cities. Your culinary and cultural journey kicks off with a visit to a local restaurant, where you'll have the pleasure of indulging in a Vietnamese lunch. The first stop on your itinerary is the esteemed Temple of Literature, known as Van Mieu-Quoc Tu Giam. Founded in the year 1070, this historic complex holds immense significance in Hanoi. Stroll through its picturesque gardens, marvel at the time-honored architecture, and immerse yourself in the rich tapestry of the country's educational heritage. The journey continues with a visit to Hoa Lo Prison, a site that holds historical weight and was famously known as the 'Hanoi Hilton.' Explore its thought-provoking exhibits, each narrating stories from different chapters of the nation's past. (Breakfast and Lunch)"
      },
      {
        day: 6,
        title:
          "Full Day Tour of Halong Bay",
        detail:
          "Start your day with a delicious breakfast at the hotel before departing for Halong Bay, a UNESCO World Heritage site since 1994, famous for its nearly 3,000 rocky islets. The journey takes approximately three to four hours depending on traffic, and you'll travel in a shared, air-conditioned bus through the scenic Red River Delta, one of Vietnam's key agricultural regions. Upon arrival in Halong Bay, embark on a boat cruise to explore the stunning limestone formations. A seafood lunch will be served on board, allowing you to enjoy fresh, traditional dishes while sailing through the bay. You'll pass by several iconic formations, including Surprising Cave (with a chance to disembark and explore), Pelican Grotto, Chopstick Rock, Butterfly Rock, Turtle Rock, the Island of Fishman’s Head, The Fighting Cocks, The Sail, The Urn, and the Sea Dog. You'll have time to explore grottos, swim in the tranquil waters, or simply relax on the sundeck. Some optional activities may include kayaking or additional photo stops (at your own expense). Afterward, return to the Wharf and take the shared bus back to Hanoi. Arrive at your hotel in Hanoi, reflecting on the majestic beauty of Halong Bay. Breakfast, Local Lunch"
      },
      {
        day: 7,
        title:
          "Departure from Hanoi",
        detail:
          "This is where your adventure through Hanoi's rich cultural and historical tapestry comes to an end and after Breakfast, get transferred to the airport. (Breakfast)"
      },
    ],

    overview: "Begin your Vietnamese adventure in the bustling heart of Ho Chi Minh City. Discover Ho Chi Minh's vibrant landmarks, from the Reunification Palace to the iconic Ben Thanh Market. After flying to Da Nang, journey into the lush landscapes of Ba Na Hills, where you’ll walk along the Golden Bridge held by towering stone hands, explore the charming French Village, and revel in the thrills of Fantasy Park. In Hanoi, step back in time at the Temple of Literature, Vietnam's oldest university, and delve into history at Hoa Lo Prison, gaining a deeper understanding of the country’s past. Sail into the UNESCO World Heritage wonder of Halong Bay, a scenic seascape of nearly 3,000 limestone islands, where you’ll savor fresh seafood and explore the enchanting caves and grottos. As your journey concludes, you'll carry home unforgettable memories of Vietnam’s timeless charm, captivating landscapes, and warm hospitality."
  },
  {
    id: "vietnam-002",
    slug: "vietnam-adventure-quest-with-halong-bay",
    destination: "Vietnam",
    title: "Vietnam Adventure Quest with Halong Bay",
    duration: "6 Nights 7 Days",
    route: "2N Ho Chi Minh City  | 2N Da Nang | 1N Hanoi | 1N Halong Bay",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["May 2026"],
    stars: 4,
    price: 50999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [hochiminhcity,daNang,hanoi,halongBay],

    includes: ["hotels", "sightseeing", "transfers", "meals", "cruise"],


    // flights: [
    //   { from: "Delhi", to: "Denpasar", type: "1 Stop" }
    // ],

    hotels: [
      { location: "Ho Chi Minh City", nights: "2 Nights", type: "Adora Mira Hotel or similar - 4 Star Hotel" },
      { location: "Da Nang", nights: "2 Nights", type: "GRAND CITIVIEW DA NANG HOTEL or similar - 4 Star Hotel" },
      { location: "Hanoi", nights: "1 Nights", type: "Chalcedony Grand Hotel or similar - 4 Star Hotel" },
      // { location: "Halong Bay", nights: "1 Nights", type: "Victory Star Cruise or similar - 4 Star" },
    ],
    cruise: [
      { title: "Victory Star Cruise or similar - 4 Star" },
    ],

    sightseeing: [
      { title: "Ho Chi Minh City Sightseeing" },
      { title: "Da Nang Sightseeing" },
      { title: "Hanoi Sightseeing" },
      { title: "Halong Bay Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Sharing" },
      { from: "Hotel", to: "Airport", type: "Sharing" },

    ],

    meals: [
      { title: "6 Breakfast Included" },
      { title: "5 Lunch Included" },
      { title: "2 Dinner Included" },
    ],


    inclusions: [
      "6 nights stay at 4 - star hotels and 1 night in Halong Bay Cruise",
      "6 Breakfasts, 5 Lunches, 2 Dinners",
      "Vietnam Single Entry Visa",
      "All sightseeing and transfers as per the itinerary on an SIC basis",
      "Halong Bay Premium Cruise(Overnight Stay)",
      "Kayaking & Cave Exploration in Halong Bay",
      "Walking tour in Ho Chi Minh City",
      "Mekong Delta Tour",
      "Visit to Ba Na Hills & Golden Hands Bridge",
      "Cable Car Ride",
    ],

    exclusions: [
      "Tips for Guide (USD 3 per person per day) is mandatory and not included.",
      "Any increase in Airfare, Visa fees, Airport taxes, Govt Taxes, Fuel Surcharges and any applicability of new taxes from Govt.",
      "Any up gradation in Airline class or hotel room category Cost of Air ticket deviation charges.",
      "Any Increase in the rate of exchange leading to an increase in all land arrangements which may come in to effect prior to departure.",
      "Cost of pre or post tour hotel accommodation.",
      "Any extra expense such as route change, Airline change, Date change, Accommodation facilities, etc incurred due to the unforeseen, unavoidable forced majeuere circumstances during the tour.",
      "Porterage, laundry, telephone charges, shopping, wines & alcoholic beverages, items of personal nature and food or drink which is not part of a set group menu.",
      "Any extra cost incurred on behalf of an individual due to illness, accident, hospitalization, or any personal emergency.",
      "Any services or activity charges other than those included in the group tour itinerary.",
      "In case a passenger is opting for direct joining, the cost for airport transfers shall be borne directly by the passenger and will join the group at the hotel.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival at Ho Chi Minh City + Half Day City Tour (Only if flight lands by 11 am)",
        detail:
          "Upon your arrival at Ho Chi Minh City, you will be met by our representative and transferred to your hotel. Proceed for a Half-Day City Tour of Ho Chi Minh. Visit Cho Lon (Big Market) and Thien Hau Pagoda in Chinatown. Continue to Bach Dang harbor. The boat will depart after checking in the waterbus tickets and settling into your seat. During the trip, you will have a unique view of the most iconic commercial buildings of the city, including the Vinhomes Central Park, the magnificent Landmark 81 Tower, the Bitexco Financial Tower, and the green, peaceful District 2. A lot of stunning moments await you. Discover the soul of this land — the Saigon River by water bus. As you journey, you may realize many miracles and gain a more accurate view of the land once called the Paris of Indochina or the Pearl of the Far East. Overnight stay in Ho Chi Minh City."
      },
      {
        day: 2,
        title:
          "Full Day Mekong Delta - Cu Chi Tunnel Tour",
        detail:
          "After breakfast at your hotel, your guide will pick you up for the day's adventure. Explore the serene Vinh Trang Pagoda, a cultural gem with a rich history, followed by a boat ride from My Tho to Unicorn Island. Along the way, marvel at natural creeks, fishermen's ports, and charming stilt houses. Visit a local bee farm and enjoy authentic honey tea. Stroll through tranquil villages, experience row boat journeys, and indulge in tropical fruits while listening to local folk music. Savor a local lunch at a restaurant before returning to My Tho, where you'll meet your motorized boat back to the mainland. Return to Ho Chi Minh City in the evening. Overnight stay in Ho Chi Minh City (Breakfast, Local Lunch)"
      },
      {
        day: 3,
        title:
          "Fly from Ho Chi Minh to Da Nang - Half Day Marble Mountain and Hoi An Ancient Town with Lantern Release",
        detail:
          "Please ensure your flight from Ho Chi Minh City to Da Nang is scheduled in the morning. After breakfast at your hotel, check out and transfer to Ho Chi Minh Airport for your flight to Da Nang. Upon arrival at Da Nang Airport, you'll be greeted by our representative and transferred to your hotel for check-in. Relax for some time before your next adventure. In the afternoon, head to Coconut Forest for a unique experience. Try your hand at traditional fishing techniques, paddle a bamboo basket boat, and explore serene waterways surrounded by lush palms. Gain insight into Vietnamese culture through these hands-on activities. Later, embark on a journey to Hoi An Ancient Town, a UNESCO World Heritage Site. Here, you'll visit the Phuc Kien Assembly Hall, marvel at its vibrant colors, intricate roof designs, and dragon statues. Step back in time as you visit Phung Hung or Tan Ky Ancient House, both over 200 years old, and discover the history of the prosperous merchants who once lived and traded here. Experience a captivating performance at the Hoi An Traditional Performing Arts House, then cross the iconic Japanese Covered Bridge. Delve into the symbolism of the carvings and paintings that adorn its interior. Explore hidden alleyways and local neighborhoods, discovering vibrant handicrafts in galleries and shops. Enjoy a delicious dinner featuring Hoi An's culinary specialties, with the exact time flexible based on the day's schedule. Afterward, board a traditional boat for a serene ride along the Hoai River, releasing floating lanterns as you enjoy the magical atmosphere of Lantern Street. Conclude your day with a return to your hotel in Da Nang for an overnight stay. (Optional: The Coconut Forest experience, including traditional fishing techniques and the bamboo basket boat ride, can be skipped or replaced with an alternative activity if preferred.) (Breakfast, Dinner)"
      },
      {
        day: 4,
        title:
          "Full-Day Tour to Ba Na Hills, French Village, and Golden Hands Bridge; Stay in Da Nang",
        detail:
          "After breakfast at your hotel, you'll be picked up for an exciting day at Ba Na Hills. Begin your journey with a scenic cable car ride to Ba Na Hills, where you'll be amazed by breathtaking views and the world-record-setting cable car route. Once at the top, explore the iconic Golden Bridge, a 150-meter-long pedestrian bridge held up by massive hands, an architectural marvel. Visit the enchanting Le Jardin, which reflects the French colonial heritage of the area. You can also visit the historic Debay Wine Cellar as an optional experience, available for direct payment. Then, proceed to Linh Ung Pagoda, home to a towering 27-meter Buddha statue, and explore the peaceful Loc Uyen Garden and Quan Am Cac. For adventure lovers, Fantasy Park awaits, with thrilling rides such as the Love Swing, Skiver Pilot, Fire Racing Track, Bumper Cars, and Ghost House. Enjoy a buffet-style lunch before taking a scenic trek to the Peak of Chua Mountain at 1,487 meters, where you can visit the Ba Chua Thuong Ngan Temple and take in panoramic views of Da Nang City and Da Nang Bay. Afterward, return to Da Nang for some free time to explore local shops and pick up souvenirs, capturing the essence of Vietnam. In the late afternoon, you’ll be dropped off at your hotel in Da Nang to relax and reflect on the incredible day spent at Ba Na Hills. (Breakfast, Local Lunch)"
      },
      {
        day: 5,
        title:
          "Arrival in Hanoi - Half Day City Tour",
        detail:
          "Please ensure your flight from Da Nang to Hanoi is scheduled in the morning. After breakfast at your hotel, check out and transfer to Da Nang Airport for your flight to Hanoi. Upon arrival at Hanoi Airport, you’ll be met by our representative and transferred to your hotel for check-in. Relax for a short time before your afternoon adventure begins. In the afternoon, embark on a Half Day City Tour of Hanoi. Start with a visit to the Temple of Literature, Vietnam’s first university founded in the 11th century. Explore the historical and cultural significance of this iconic site. Next, head to the Hoa Lo Prison Museum, famously known as the 'Hanoi Hilton' during the Vietnam War. Discover the history of political prisoners and U.S. POWs who were held here by the French and North Vietnamese forces. Conclude your day’s exploration and return to your hotel in Hanoi for an overnight stay. (Breakfast, Local Lunch)"
      },
      {
        day: 6,
        title:
          "Hanoi – Halong Bay – Luon Cave – Titop Island",
        detail:
          "After breakfast at your hotel, check out and your driver will pick you up from your hotel in the Old Quarter for a scenic journey to Halong Bay. A short break will be made along the way for refreshments. Upon arrival at Halong International Harbor around 11:30 AM - 11:45 AM, you will embark on the cruise by tender, where you'll be greeted with welcome drinks and a cruise briefing. Set sail and enjoy lunch while cruising through the magnificent Ha Long Bay, taking in the stunning rock formations and emerald-green waters. Around 2:45 PM, you will head to Luon Cave, where you can choose between kayaking or taking a bamboo boat rowed by locals to explore the cave's beauty, a must-do activity in the bay. At 4:00 PM, stop at Titop Island, where you can enjoy a beach day, swim in the clear waters, or climb to the peak for breathtaking views of Halong Bay. Enjoy some free time from 5:00 PM – 6:30 PM on the sundeck as the sun sets over the dramatic limestone peaks. Sip your drinks and watch a cooking demonstration on board. At 7:15 PM, savor a delicious dinner on the cruise. After dinner, you can try your hand at night-time squid fishing before retreating to your cabin for the night. Overnight on the Halong Bay Cruise. (Breakfast, Lunch, Dinner)"
      },
      {
        day: 7,
        title:
          "Halong Bay – Sung Cot Cave – Hanoi",
        detail:
          "Begin your day early with a sunrise experience on the bay and a morning Tai Chi session on the sundeck to start your day with peace and energy. 6:30 AM – Enjoy a light breakfast with coffee, tea, and pastries served in the restaurant as you cruise through the bay. 7:20 AM – Head to Sung Sot Cave, the largest and most impressive cave in Halong Bay, where you will have time to explore its incredible stalactites and stalagmites. 9:15 AM – Return to the cruise for check-out and bill settlement. Start cruising back towards the port. 9:30 AM – A buffet brunch will be served in the restaurant, giving you a chance to enjoy a final meal on the cruise. 10:45 AM – 11:00 AM – Disembark from the cruise and transfer to Tuan Chau Harbor for your return journey. 12:00 PM – 12:30 PM – Leave for Hanoi to catch your return flight. Please make sure your flight from Hanoi to India is after 6:00 PM to ensure ample time for the transfer."
      },
    ],

    overview: "Arrive in Ho Chi Minh City, exploring Cho Lon Market, Thien Hau Pagoda, and stunning cityscapes on a water bus. Venture to the Mekong Delta, where you’ll discover Vinh Trang Pagoda, enjoy tropical fruit on Unicorn Island, and glide through peaceful waterways on traditional rowboats. In Da Nang, immerse yourself in Hoi An’s ancient charm, lantern-lit streets, and the famous Japanese Covered Bridge. Experience the magic of Ba Na Hills with its Golden Bridge, scenic cable car rides, and gardens. In Hanoi, delve into history at the Temple of Literature and Hoa Lo Prison Museum. Cruise through the beauty of Halong Bay, kayak to Luon Cave, relax on Titop Island and enjoy a magical night with dinner and squid fishing. The next morning, witness the sunrise, explore Sung Sot Cave, and return to Hanoi to end your journey."
  },
  {
    id: "vietnam-003",
    slug: "vietnam-dual-paradise",
    destination: "Vietnam",
    title: "Vietnam Dual Paradise",
    duration: "6 Nights 7 Days",
    route: "3N Phu Quoc | 3N Da Nang",
    departureCity: ["Mumbai", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026"],
    stars: 4,
    price: 119999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [phuQuoc,daNang],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],


    flights: [
      { from: "Phu Quoc", to: "Da Nang", type: "Direct or 1 Stop" }
    ],

    hotels: [
      { location: "Phu Quoc", nights: "3 Nights", type: "Vinholidays Fiesta Phu Quoc or similar - 4 Star Hotel" },
      { location: "Da Nang", nights: "3 Nights", type: "Cicilia Hotels & Spa Danang or similar - 4 Star Hotel" },
    ],

    sightseeing: [
      { title: "Phu Quoc Sightseeing" },
      { title: "Da Nang Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "VinWonders Phu Quoc theme park experience",
      "4 Island hopping tour with speedboat & lunch",
      "Grand World evening experience",
      "Ba Na Hills tour with Golden Bridge & cable car",
      "Hoi An Ancient Town with lantern boat ride",
      "Coconut forest basket boat experience",
      "Da Nang city tour with shopping time",
      "All meals included (as per itinerary)",
      "Seamless transfers across destinations",
      "Internal Flights",
      "Onword & Retun Flights(If Selected)",
    ],

    exclusions: [
      "Tips for Guide (USD 3 per person per day) is mandatory and not included.",
      "Any increase in Airfare, Visa fees, Airport taxes, Govt Taxes, Fuel Surcharges and any applicability of new taxes from Govt.",
      "Any up gradation in Airline class or hotel room category Cost of Air ticket deviation charges.",
      "Any Increase in the rate of exchange leading to an increase in all land arrangements which may come in to effect prior to departure.",
      "Cost of pre or post tour hotel accommodation.",
      "Any extra expense such as route change, Airline change, Date change, Accommodation facilities, etc incurred due to the unforeseen, unavoidable forced majeuere circumstances during the tour.",
      "Porterage, laundry, telephone charges, shopping, wines & alcoholic beverages, items of personal nature and food or drink which is not part of a set group menu.",
      "Any extra cost incurred on behalf of an individual due to illness, accident, hospitalization, or any personal emergency.",
      "Any services or activity charges other than those included in the group tour itinerary.",
      "In case a passenger is opting for direct joining, the cost for airport transfers shall be borne directly by the passenger and will join the group at the hotel.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Phu Quoc, VinWonders & Leisure Evening",
        detail:
          "Arrive in Phu Quoc and begin your holiday with a visit to VinWonders, Vietnam’s largest theme park, where thrilling rides and entertainment experiences set the tone for your trip. Enjoy lunch before heading to your hotel for check-in and some relaxation. In the evening, unwind and enjoy a delightful dinner. (Lunch and Dinner)"
      },
      {
        day: 2,
        title:
          "4 Islands Tour by Speedboat & Hon Thom Cable Car Experience",
        detail:
          "After breakfast, set out on an exciting island-hopping adventure by speed boat. Visit multiple islands known for their clear waters and coral reefs, where you can relax, swim, or snorkel. Later, head to Hon Thom Island and enjoy access to the water park before taking the world-famous cable car ride offering breathtaking panoramic views of the sea and surrounding islands. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 3,
        title:
          "Grand World Evening Experience with Water Taxi & Teddy Bear Museum",
        detail:
          "Start your day at leisure after breakfast, giving you time to relax or explore the island at your own pace. Later in the evening, proceed to Grand World — a vibrant entertainment destination known for its colourful European-style architecture and lively atmosphere. Enjoy included access to the Water Taxi ride, offering a scenic and relaxing way to explore the beautifully designed canals. Continue your experience with a visit to the Teddy Bear Museum, where creative displays and themed exhibits add a fun and unique touch to your evening. After soaking in the lively ambience and attractions, return for dinner. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 4,
        title:
          "Departure from Phu Quoc - Fly to Da Nang & Leisure Evening",
        detail:
          "After breakfast, transfer to the airport for your journey to Da Nang. Upon arrival, enjoy a private transfer to your hotel and check in. The rest of the day is at leisure to relax or explore the nearby beach and local surroundings at your own pace. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 5,
        title:
          "Ba Na Hills Tour",
        detail:
          "Leave the bustle of Da Nang for a day and escape to the mountainous serenity of the Ba Na Hills. After visiting the Linh Ung Pagoda, take a cable car to the top of Nui Chua Mountain and grab lunch in a local restaurant. Spend the rest of your afternoon captivated by the attractions at Fantasy Park. Your morning begins with pickup from your hotel. A friendly guide drives you out of the city to Ba Na Hills, a resort founded in the 1920s by French colonists. On the way there, stop at Linh Ung Pagoda to marvel at a 220-foot (67-m) statue of a Bodhisattva. Pass by old French villas and a historic wine cellar, learning about the French occupation of Vietnam from your guide. Once in the mountains, board a cable car and ride to the summit of Nui Chua Mountain. Make the easy trek to Nghinh Phong Peak and enjoy a panoramic view of the surrounding region, and then stop in a restaurant for a tasty lunch of Vietnamese cuisine. Later, venture to Ba Na Hill's Fantasy Park, an indoor entertainment zone with thrilling games for the whole family. Following an afternoon of adventure, make your way back to Da Nang with your guide. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 6,
        title:
          "Hoi An Ancient Town, Basket Boat Experience & Lantern Release",
        detail:
          "In the afternoon, depart from Da Nang for a culturally immersive journey to Hoi An. Begin with a unique basket boat ride through the lush coconut forest, where you’ll witness local fishing techniques and enjoy the serene surroundings. This experience offers a glimpse into the traditional lifestyle of the region. As evening sets in, explore the charming streets of Hoi An Ancient Town, beautifully illuminated with colourful lanterns. Enjoy a delightful dinner before taking a peaceful boat ride along the river, where you can participate in the enchanting lantern release — a truly magical and memorable experience. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 7,
        title:
          "Departure from Da Nang",
        detail:
          "After breakfast, check out from your hotel and transfer to the airport for your return journey, carrying unforgettable memories of Vietnam’s diverse landscapes and experiences. (Breakfast)"
      },
    ],

    overview: "Experience the best of Vietnam with a journey that perfectly blends tropical island fun and cultural exploration. Start your holiday in Phu Quoc, where pristine beaches, thrilling theme parks, and island-hopping adventures create the perfect escape. Continue to Da Nang, a vibrant coastal city offering iconic attractions like Ba Na Hills, the Golden Bridge, and the charming lantern-lit streets of Hoi An. From scenic landscapes to immersive cultural experiences, this itinerary is designed to give you a complete and seamless Vietnam experience. Ideal for families, couples, and groups, this trip combines leisure, adventure, and sightseeing with thoughtfully planned experiences and smooth transitions throughout."
  },
  {
    id: "vietnam-004",
    slug: "vietnam-grand-tour",
    destination: "Vietnam",
    title: "Vietnam Grand Tour",
    duration: "11 Nights 12 Days",
    route: "3N Hanoi  | 3N Da Nang | 2N Ho Chi Minh City | 3N Phu Quoc",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", "Jul 2026", "Aug 2026"],
    stars: 4,
    price: 109999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [hanoi,daNang,hochiminhcity,phuQuoc],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Phu Quoc", to: "Da Nang", type: "Direct or 1 Stop" }
    // ],

    hotels: [
      { location: "Hanoi", nights: "3 Nights", type: "Chalcedony Grand Hotel or similar - 4 Star Hotel" },
      { location: "Da Nang", nights: "3 Nights", type: "Cicilia Hotels & Spa Danang or similar - 4 Star Hotel" },
      { location: "Ho Chi Minh City", nights: "2 Nights", type: "Ramana Saigon Hotel or similar- 4 Star Hotel" },
      { location: "Phu Quoc", nights: "3 Nights", type: "Vinholidays Fiesta Phu Quoc or similar - 4 Star Hotel" },
    ],

    sightseeing: [
      { title: "Hanoi Sightseeing" },
      { title: "Da Nang Sightseeing" },
      { title: "Ho Chi Minh City Sightseeing" },
      { title: "Phu Quoc Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Hanoi city tour with cultural landmarks",
      "Ninh Binh scenic day trip",
      "Halong Bay deluxe cruise experience",
      "Ba Na Hills with Golden Bridge",
      "Hoi An Ancient Town with lantern boat ride",
      "Da Nang city tour & shopping",
      "Ho Chi Minh city exploration",
      "Cu Chi Tunnels & Mekong Delta experience",
      "VinWonders Phu Quoc theme park",
      "4 Island-hopping tour with speedboat",
      "Grand World with Water Taxi & Teddy Bear Museum",
      "All meals included (as per itinerary)",
      "End-to-end Vietnam coverage",
    ],

    exclusions: [
      "Tips for Guide (USD 3 per person per day) is mandatory and not included.",
      "Any increase in Airfare, Visa fees, Airport taxes, Govt Taxes, Fuel Surcharges and any applicability of new taxes from Govt.",
      "Any up gradation in Airline class or hotel room category Cost of Air ticket deviation charges.",
      "Any Increase in the rate of exchange leading to an increase in all land arrangements which may come in to effect prior to departure.",
      "Cost of pre or post tour hotel accommodation.",
      "Any extra expense such as route change, Airline change, Date change, Accommodation facilities, etc incurred due to the unforeseen, unavoidable forced majeuere circumstances during the tour.",
      "Porterage, laundry, telephone charges, shopping, wines & alcoholic beverages, items of personal nature and food or drink which is not part of a set group menu.",
      "Any extra cost incurred on behalf of an individual due to illness, accident, hospitalization, or any personal emergency.",
      "Any services or activity charges other than those included in the group tour itinerary.",
      "In case a passenger is opting for direct joining, the cost for airport transfers shall be borne directly by the passenger and will join the group at the hotel.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival at Hanoi - Transfer to Hotel - Half Day Hanoi City Tour",
        detail:
          "Arrive in Hanoi and begin your journey with a guided city tour, exploring key landmarks and experiencing the cultural essence of Vietnam’s capital. Enjoy lunch before proceeding to your hotel for check-in. In the evening, unwind with dinner."
      },
      {
        day: 2,
        title:
          "Ninh Binh Day Excursion",
        detail:
          "After breakfast, head out for a scenic day trip to Ninh Binh, known for its limestone landscapes and peaceful countryside. Enjoy a relaxing exploration with included lunch before returning to Hanoi for dinner."
      },
      {
        day: 3,
        title:
          "Halong Bay Deluxe Cruise Experience",
        detail:
          "Today, embark on a full-day excursion to Halong Bay. Cruise through stunning limestone karsts aboard a deluxe cruise, enjoy activities onboard, and savour a delicious lunch while soaking in the breathtaking views. Return to Hanoi for dinner."
      },
      {
        day: 4,
        title:
          "Fly to Da Nang & Ba Na Hills Experience",
        detail:
          "After breakfast, check out and proceed for your onward journey to Da Nang. Upon arrival, transfer to your hotel and check in. Later, visit Ba Na Hills and enjoy a scenic cable car ride to the top. Explore the iconic Golden Bridge and surrounding attractions with lunch included. End the day with dinner."
      },
      {
        day: 5,
        title:
          "Hoi An & Coconut Forest Experience",
        detail:
          "After breakfast, head out for a cultural journey to Hoi An. Begin with a basket boat ride through the coconut forest, followed by lunch. In the evening, explore the lantern-lit streets of Hoi An and enjoy a peaceful lantern boat ride experience before dinner."
      },
      {
        day: 6,
        title:
          "Full Day Da Nang City Tour & Shopping Experience",
        detail:
          "After breakfast, set out for a full-day exploration of Da Nang, a vibrant coastal city known for its perfect blend of modern attractions and cultural landmarks. Visit key highlights such as the Marble Mountains, offering scenic views and spiritual significance, and explore iconic city spots that showcase Da Nang’s charm. Continue your day with visits to local markets and shopping areas, where you can browse for souvenirs, handicrafts, and local specialties. Enjoy lunch during the tour and take in the relaxed coastal vibe of the city. After a fulfilling day of sightseeing and shopping, return for dinner."
      },
      {
        day: 7,
        title:
          "Arrival in Ho Chi Minh City & City Tour",
        detail:
          "After breakfast, check out and fly to Ho Chi Minh City. Upon arrival, enjoy lunch and proceed for hotel check-in. Later, explore the city with a guided tour, discovering its vibrant streets and historical landmarks. End the day with dinner."
      },
      {
        day: 8,
        title:
          "Cu Chi Tunnels & Mekong Delta Experience",
        detail:
          "After breakfast, head out for a full-day excursion exploring the Cu Chi Tunnels, followed by a visit to the Mekong Delta. Experience local life, scenic waterways, and cultural insights with lunch included before returning for dinner."
      },
      {
        day: 9,
        title:
          "Fly to Phu Quoc & VinWonders Experience",
        detail:
          "After breakfast, transfer to the airport for your flight to Phu Quoc. Upon arrival, visit VinWonders for a fun-filled experience at Vietnam’s largest theme park. Enjoy lunch before checking into your hotel and relaxing, followed by dinner."
      },
      {
        day: 10,
        title:
          "Phu Quoc 4 Islands Day Tour by Speedboat",
        detail:
          "After breakfast, embark on an exciting 4-island tour by shared speedboat. Explore beautiful beaches, enjoy water activities, and relax amidst stunning island scenery. Lunch is included during the excursion, followed by dinner."
      },
      {
        day: 11,
        title:
          "Grand World Evening Experience",
        detail:
          "After a relaxed morning and lunch, head out in the evening to Grand World. Enjoy a scenic Water Taxi ride through beautifully designed canals and explore the Teddy Bear Museum with its unique themed displays. Return for dinner after a lively evening experience."
      },
      {
        day: 12,
        title:
          "Departure from Phu Quoc",
        detail:
          "After breakfast, check out from the hotel and transfer to the airport for your onward journey, concluding your unforgettable Vietnam experience."
      },
    ],

    overview: "Experience Vietnam like never before with this comprehensive journey covering the country from north to south. Begin in Hanoi, where cultural heritage meets natural beauty, with excursions to Ninh Binh and the breathtaking Halong Bay cruise. Continue to Central Vietnam in Da Nang, home to the iconic Golden Bridge, Ba Na Hills, and the lantern-lit charm of Hoi An. Then head south to Ho Chi Minh City for a dynamic blend of history and local life, including the famous Cu Chi Tunnels and Mekong Delta. End your journey in the tropical paradise of Phu Quoc, where island hopping, theme parks, and vibrant evening experiences create the perfect finale. This itinerary is designed for travellers who want to experience Vietnam in its entirety — seamlessly and comfortably."
  },
  {
    id: "vietnam-005",
    slug: "unbeatable-vietnam-premium",
    destination: "Vietnam",
    title: "Unbeatable Vietnam Premium",
    duration: "7 Nights 8 Days",
    route: "2N Hanoi  | 1N Halong Bay | 2N Da Nang | 2N Ho Chi Minh City",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026"],
    stars: 5,
    price: 104499,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [hanoi,halongBay,daNang,hochiminhcity],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Phu Quoc", to: "Da Nang", type: "Direct or 1 Stop" }
    // ],

    hotels: [
      { location: "Hanoi", nights: "2 Nights", type: "Pullman Hanoi Hotel or similar - 4 Star Hotel" },
      // { location: "Halong Bay", nights: "3 Nights", type: "Vinholidays Fiesta Phu Quoc or similar - 4 Star Hotel" },
      { location: "Da Nang", nights: "2 Nights", type: "Grand Mercure Danang or similar - 4 Star Hotel" },
      { location: "Ho Chi Minh City", nights: "2 Nights", type: "Sofitel Saigon Plaza or similar - 4 Star Hotel" },
    ],
    cruise: [
      { title: "Hera Cruise or similar - 4 Star" }
    ],
    sightseeing: [
      { title: "Hanoi Sightseeing" },
      { title: "Da Nang Sightseeing" },
      { title: "Ho Chi Minh City Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Sharing" },
      { from: "Hotel", to: "Airport", type: "Sharing" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "7 Nights’ Accommodation in premium 4/5 star hotels",
      "Daily Breakfast, Lunches, and Indian Dinners as per itinerary",
      "Domestic Flight Transfers from Hanoi to Da Nang and from Da Nang to Ho Chi Minh City (20 kg luggage allowance)",
      "Single Entry Vietnam E-Visa",
      "All Tours with a Full-Day English Speaking Guide",
      "All Tours and Transfers on a Shared Basis",
      "Half-Day Hanoi City Tour",
      "Full-Day Ninh Binh Tour",
      "Overnight Stay on Halong Bay Cruise with meals (Brunch, Lunch, Dinner) and scenic exploration",
      "Full-Day Ba Na Hills Tour",
      "Half-Day Hoi An Ancient Town Tour",
      "Full-Day Ho Chi Minh City Tour",
      "Morning Free Time for Shopping",
    ],

    exclusions: [
      "Tips for Guide (USD 3 per person per day) is mandatory and not included.",
      "Any increase in Airfare, Visa fees, Airport taxes, Govt Taxes, Fuel Surcharges and any applicability of new taxes from Govt.",
      "Any up gradation in Airline class or hotel room category Cost of Air ticket deviation charges.",
      "Any Increase in the rate of exchange leading to an increase in all land arrangements which may come in to effect prior to departure.",
      "Cost of pre or post tour hotel accommodation.",
      "Any extra expense such as route change, Airline change, Date change, Accommodation facilities, etc incurred due to the unforeseen, unavoidable forced majeuere circumstances during the tour.",
      "Porterage, laundry, telephone charges, shopping, wines & alcoholic beverages, items of personal nature and food or drink which is not part of a set group menu.",
      "Any extra cost incurred on behalf of an individual due to illness, accident, hospitalization, or any personal emergency.",
      "Any services or activity charges other than those included in the group tour itinerary.",
      "In case a passenger is opting for direct joining, the cost for airport transfers shall be borne directly by the passenger and will join the group at the hotel.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival at Hanoi - Half Day Hanoi City Tour",
        detail:
          "On arrival at Noi Bai International Airport, our local representative will wait outside the customs area to welcome you and take you to your hotel. In the afternoon get ready for Hanoi City Tour Half Day. Start by visiting Hoan Kiem Lake, a central landmark in Hanoi. Explore Ngoc Son Temple situated on a small island in thelake, connected by the iconic red Huc Bridge. Head to One Pillar Pagoda, a historic Buddhist temple known for its unique architectural design. Explore the surrounding gardens and learn about the pagoda'scultural significance. -Visit the Ho Chi Minh Mausoleum outside, an important site honoring the founding father of modern Vietnam. While the interior is often closed, you can still appreciate the grandeur of the mausoleum from the outside. Conclude your tour with a visit to Dong Xuan Market, one of the oldest and largest markets in Hanoi. Stroll through the vibrant market and explore the diverse array of goods, including textiles, souvenirs, and local snacks. Have Dinner at an Indian Restaurant in the evening before going to a hotel for an overnight stay. (Indian Lunch, Indian Dinner)"
      },
      {
        day: 2,
        title:
          "Full Day Ninh Binh (Tam Coc - Hoa Lu with Sampan Boat Ride)",
        detail:
          "A 90km drive south of Hanoi will lead you to Ninh Binh, the site of the one capital city of ancient Vietnam before Hanoi took its leading role in 11th century. The area is featured by lots of well-known sceneries, which include Tam Coc Caves and Hoa Lu ancient capital with the old temples dedicated to King Dinh & King Le reigned in 10th century. The visit in Ninh Binh starts by a boat trip in Tam Coc where spectacular limestone karsts jut out from the green paddy fields reminding about Guilin (China) and Halong Bay of Vietnam, which gives this scenery the name “Halong-bay-on-land”. Further discovery in Ninh Binh will be continued in the site that used to be the kings‟ palace in 10th century and now famous for the wooden relieves of the shady Dinh and Le temples. Late afternoon back to Hanoi. (Breakfast, Local Lunch, Indian Dinner)"
      },
      {
        day: 3,
        title:
          "Transfer from Hanoi to Halong Bay – Overnight Stay on Cruise",
        detail:
          "After a delightful breakfast, we embark on an unforgettable adventure to Halong Bay, one of Vietnam's most iconic destinations. This breathtaking natural wonder, part of the Gulf of Tonkin, is renowned for its thousands of islands and islets that rise majestically from the emerald waters, creating a stunning seascape that has earned it a UNESCO World Heritage Site designation. As we travel to this enchanting location, anticipation builds for the scenic beauty that awaits us. Upon arrival, we will board a traditional sailing junk, setting sail on a mesmerizing cruise through the bay. As we glide through calm waters, surrounded by towering limestone cliffs and lush forests, we'll stop at captivating natural grottos and hidden gems, taking in the extraordinary sights. Enjoy a delicious seafood meal prepared by our talented crew, showcasing the region's finest flavors. As the sun sets, casting a warm glow over the bay, take a refreshing swim in the crystal-clear waters before settling in for a peaceful night's sleep on our charming cruise, enveloped by the breathtaking beauty. NOTE: Veg food available on request on cruise (Breakfast, Lunch on Cruise and Dinner on Cruise)"
      },
      {
        day: 4,
        title:
          "Transfer from Halong Bay to Hanoi - Fly to Da Nang",
        detail:
          "After enjoying breakfast on the Halong Cruise, check-out and disembark as you prepare for your transfer to Hanoi. Upon arrival in Hanoi, you'll proceed to the airport for your flight to Da Nang. Once you arrive in Da Nang, check in to your carefully selected hotel. The rest of the day is at your leisure to unwind or explore the city at your own pace. Overnight stay at the hotel in Da Nang. (Brunch and Indian Dinner)"
      },
      {
        day: 5,
        title:
          "Full Day Ba Na Hills Tour with Golden Bridge",
        detail:
          "Start your day with breakfast and check out from your hotel in Da Nang before we pick you up for a half-day sightseeing tour of the serene Ba Na Hills. Leave the city's bustle behind as your friendly guide takes you to this mountain retreat, founded in the 1920s by French colonists. En route, stop at the Linh Ung Pagoda to admire the impressive 220-foot (67-m) statue of Bodhisattva. Continue your journey, passing by old French villas as your guide shares insights into the French occupation of Vietnam. Once in the mountains, take a scenic cable car ride up to the summit of Nui Chua Mountain. Enjoy a short and easy trek to Nghinh Phong Peak, where you'll be rewarded with breathtaking panoramic views of the surrounding landscapes. After taking in the views, savor a delicious Vietnamese lunch at a local restaurant. You can also visit the historic Debay Wine Cellar, an optional activity available for direct payment. This cellar, built in 1923 by French colonialists, offers a glimpse into the region’s past. Spend the rest of your afternoon exploring Fantasy Park, an indoor entertainment zone filled with thrilling games and attractions suitable for all ages. (Breakfast, Lunch, and Dinner)"
      },
      {
        day: 6,
        title:
          "Half Day Hoi An Ancient Town - Transfer from Da Nang to Ho Chi Minh",
        detail:
          "Start your day with a delightful breakfast at your hotel before we pick you up from your hotel in Danang city center or Hoi An for a full-day adventure. Our first stop is the Coconut Forest, where you'll get to try traditional fishing techniques, paddle a unique bamboo basket boat, and explore serene waterways surrounded by lush palms. Engage in hands-on activities that offer a deeper insight into Vietnamese culture and local traditions. We then head to the enchanting Hoi An Old Town, a UNESCO World Heritage Site. Here, you'll uncover the charm of the Phuc Kien Assembly Hall, admiring its vibrant colors, intricate roof designs, and dragon statues. Step back in time at the Phung Hung or Tan Ky Ancient House, appreciating their 200-year-old architecture and learning about the prosperous merchants who once lived here and traded with global communities. You’ll also enjoy a captivating performance at the Hoi An Traditional Performing Arts House and cross the iconic Japanese Covered Bridge, exploring its symbolic carvings and paintings. As you wander through Hoi An’s vibrant handicraft scene, you’ll discover treasures in galleries and shops, exploring hidden alleyways and charming local neighborhoods. Following your adventure, we’ll transfer you back to Da Nang and proceed to the airport for your flight to Ho Chi Minh City. Upon arrival, check in to your hotel. The rest of the day is yours to relax and enjoy at your leisure. Overnight stay at Ho Chi Minh City (Breakfast, Lunch and Indian Dinner)"
      },
      {
        day: 7,
        title:
          "Full Day Ho Chi Minh City Tour with Cu Chi Tunnels",
        detail:
          "Start the tour from the Post Office in colonial-style and the Notre Dame Cathedral. Go on to visit Thien Hau pagoda and a specific section that does not exist in any other city of Vietnam - a bustling China Town, where every board is in two languages: Chinese and Vietnamese, and so is the communication of the inhabitants. In the center of this exciting area is a grandiose market: 'Cho Lon', i.e. The Big Market. A lot of Chinese living in this quarter have obtained great trading success with their know-how, wisdom and dynamic. After lunch in Saigon, head northwest to Cu Chi Tunnels, one of the very few remaining monuments to the Vietnam War. 200km of tunnels, dug by hand and inhabited by the forces of the Vietnamese guerillas during the conflicts, are beneath the ground in Cu Chi. At its peak, prior to the Tet Offensive in 1968, the tunnel complex was a base to almost 10,000 troops. To this day, it remains one of the most impressive examples of how fierce the War was. Return to Saigon in late afternoon. (Breakfast, Local Lunch and Indian Dinner)"
      },
      {
        day: 8,
        title:
          "Morning Free for Shopping - Departure from Ho Chi Minh City",
        detail:
          "Today morning you will have free time to do shopping in Ho Chi Minh City (on your own). You can spend time at Ben Thanh Market or near by malls, after which we will have lunch. Later you will be picked up from the hotel lobby at the time confirmed. Please be available at the lobby 15 minutes before the time given and you will be transferred to the airport for your flight (Breakfast and Indian Lunch)"
      },
    ],

    overview: "Embark on a premium 7-night journey through Vietnam, beginning with a comfortable stay at your hotel in Hanoi. Relish daily continental breakfasts, along with Indian lunches and dinners. Explore Hanoi with a half-day city tour, visiting iconic landmarks such as Hoan Kiem Lake and the Ho Chi Minh Mausoleum. On day two, venture to Ninh Binh to discover the ancient capital of Hoa Lu and experience a serene Sampan boat ride through Tam Coc. Day three highlights a one-night Halong Bay cruise, where you'll marvel at the breathtaking limestone karsts. Continue your journey in Da Nang with a visit to the spectacular Ba Na Hills, including the iconic Golden Bridge, and a trip to the charming Hoi An Ancient Town. Conclude your adventure in Ho Chi Minh City with a city tour and an insightful visit to the historic Cu Chi Tunnels. The package includes domestic flights, seamless transfers, knowledgeable guides, and luxurious accommodations, ensuring an unforgettable travel experience."
  },

  // ================= Ladakh =================
  {
    id: "ladakh-001",
    slug: "exclusive-ladakh",
    destination: "Ladakh",
    title: "Exclusive Ladakh",
    duration: "7 Nights 8 Days",
    route: "2N Leh | 2N Nubra Valley | 1N Pangong | 2N Leh",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026"],
    stars: 3,
    price: 44999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [leh,nubarvalley,pangong],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Phu Quoc", to: "Da Nang", type: "Direct or 1 Stop" }
    // ],

    hotels: [
      { location: "Leh", nights: "2 Nights", type: "Grand k2 Ladakh or similar - 3 Star Hotel" },
      { location: "Nubra Valley", nights: "2 Nights", type: "Classic Cottage nubra or similar - 3 Star Hotel" },
      { location: "Pangong", nights: "1 Nights", type: "Pangong Leisure Resort or similar - 3 Star Hotel" },
      { location: "Leh", nights: "2 Nights", type: "Hotel Shangrila or similar - 3 Star Hotel" },
    ],

    sightseeing: [
      { title: "Leh Sightseeing" },
      { title: "Nubra Valley" },
      { title: "Pangong Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Daily Breakfast Included" },
      { title: "Daily Lunch Included" },
      { title: "Daily Dinner Included" },
    ],


    inclusions: [
      "7 Nights’ accommodation included ensuring rest and relaxation each night",
      "Fresh Satvik / Jain Meals Prepared by Dedicated Maharaj",
      "Visits to iconic monasteries, palaces, and cultural landmarks like Shey Palace and the 3 Idiots School",
      "Scenic drives across Khardungla and Changla Pass with breathtaking views",
      "Nubra Valley charm with Deskit, Hundur, camel safari, and Turtuk Village",
      "Stunning Pangong Lake with its magical shades of blue",
      "Heritage and serenity at Shanti Stupa, Leh Palace, and vibrant local markets",
    ],

    exclusions: [
      "Airfare to and from Leh/Leh",
      "Any personal expenses such as laundry, telephone calls, tips, beverages, and room service",
      "Optional activities such as Camel Safari in Sand Dunes or any snow/adventure activities",
      "Entry tickets to monuments, monasteries, museums, and sightseeing places unless specified",
      "Lunch during the journey unless specifically mentioned in the meal plan",
      "Oxygen cylinders, medical expenses, or any costs arising due to altitude sickness",
      "Travel insurance of any kind",
      "Expenses caused due to road blockage, landslides, weather conditions, flight cancellation, or any natural calamities",
      "Additional sightseeing or usage of vehicle not mentioned in the itinerary",
      "Any services not specifically mentioned under “Package Inclusions”",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Leh and Transfer to the Hotel",
        detail:
          "Upon arrival at Leh Airport, you will be transferred to your hotel where check-in formalities will be completed. The rest of the day is kept free for leisure, giving you time to relax, unwind, and gently acclimatize to the high-altitude environment. In the evening, enjoy a delightful dinner served at the hotel, setting the tone for the days of exploration ahead. (Lunch and Dinner)"
      },
      {
        day: 2,
        title:
          "Full Day Leh Sightseeing with Shey Palace and 3 Idiots School",
        detail:
          "After breakfast at the hotel, you will begin your sightseeing tour with visits to Hemis Monastery, one of the largest and most renowned monasteries in Ladakh, followed by Thikse Monastery, famous for its striking resemblance to the Potala Palace in Lhasa. The tour continues to Shey Palace, once the summer capital of Ladakh, and the popular 3 Idiot School, made famous by the Bollywood film. Lunch will be served at the hotel, giving you time to relax before the afternoon program. In the latter half of the day, your journey takes you to Lamayuru Monastery, often referred to as the “Moonland” for its unique terrain, before continuing with visits to Shanti Stupa, a serene white-domed structure offering panoramic views of Leh, and Leh Fort, which reflects the region’s rich heritage. You will also explore Leh Palace, an impressive nine-storey building showcasing Tibetan-style architecture, and the Hall of Fame, a museum dedicated to the Indian Army’s history and achievements. The day concludes with a visit to Zoravar Fort and some time at the local market to browse traditional handicrafts and souvenirs. Dinner will be served at the hotel, followed by an overnight stay in Leh. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 3,
        title:
          "Transfer from Leh to Nubra Valley with enroute Deskit & Hundur Village Visit",
        detail:
          "After breakfast at the hotel, you will complete the check-out formalities and begin your journey towards Nubra Valley. The drive itself is a scenic adventure, taking you through winding mountain roads and offering breathtaking views of Ladakh’s rugged landscapes. En route, you will cross Khardungla Pass, one of the highest motorable roads in the world, before visiting Deskit and Hundur villages. Here, you can witness the charm of traditional Ladakhi life and, if you wish, enjoy an optional two-hump camel safari across the sand dunes, a unique experience in this high-altitude desert. Upon arrival in Nubra, you will check in at your hotel and have lunch. The rest of the day is kept free for leisure, allowing you to relax and soak in the tranquil surroundings. In the evening, dinner will be served at the hotel, followed by an overnight stay in Nubra. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 4,
        title:
          "Excursion in Nubra Valley with Turtuk Village and Dhang Zero Point",
        detail:
          "After breakfast at the hotel, you will set out for a full-day sightseeing excursion in Nubra Valley. The highlight of the morning is a visit to Turtuk Village, a charming settlement that offers a glimpse into Balti culture and traditions. Its unique location and warm hospitality make it one of the most memorable stops in Nubra. Later, you will continue towards Dhang Zero Point, located near the Pakistan border, where the dramatic landscapes and the unique setting make it a remarkable experience. After spending time exploring the area, you will make your way back to Nubra. Lunch to be served at the hotel. The afternoon is kept free for local sightseeing at your own pace, followed by dinner and an overnight stay. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 5,
        title:
          "Transfer from Nubra Valley to Pangong Lake via Changla Pass",
        detail:
          "After breakfast at the hotel, you will complete the check-out formalities and begin your journey towards Pangong. The drive takes you across the scenic Changla Pass, one of the highest mountain passes in the region, offering spectacular views of the surrounding peaks and valleys along the way. Upon arrival in Pangong, you will check in at the hotel and have time to settle in. Later, you will visit the breathtaking Pangong Lake, the highest saltwater lake in the world, renowned for its ever-changing shades of blue and stunning natural beauty. The rest of the day is kept free for leisure, allowing you to relax and soak in the serene atmosphere. In the evening, dinner will be served at the hotel, followed by an overnight stay in Pangong. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 6,
        title:
          "Transfer from Pangong to Leh",
        detail:
          "After breakfast at the hotel, you will complete the check-out formalities and proceed towards Leh. The drive offers scenic views of Ladakh’s rugged terrain and mountain landscapes. Upon arrival, you will check in at the hotel and enjoy lunch. The rest of the day is kept free for leisure, giving you time to relax and unwind. In the evening, dinner will be served at the hotel, followed by an overnight stay in Leh. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 7,
        title:
          "Leh Sightseeing with Alchi Monastery and Magnetic Hill",
        detail:
          "After breakfast at the hotel, you will set out for an enriching day of exploration. Your journey begins with a visit to Alchi Monastery, one of the oldest monastic complexes in Ladakh, known for its exquisite wall paintings and serene atmosphere. The experience continues at the Pathar Sahib Gurudwara, a revered Sikh shrine that radiates peace and devotion. From there, you’ll head to the fascinating Magnetic Hill, where the natural landscape creates the illusion of vehicles defying gravity. For those seeking adventure, an optional river rafting experience is available at your own cost, adding a thrilling dimension to the day. A picnic lunch will be arranged, allowing you to enjoy the scenery in a relaxed setting. As the day winds down, you will return to the hotel, where dinner will be served. The evening is kept free for leisure, giving you time to reflect on the day’s experiences and unwind in comfort. (Breakfast, Picnic Lunch and Dinner)"
      },
      {
        day: 8,
        title:
          "Departure from Leh",
        detail:
          "After breakfast at the hotel, you will complete the check-out formalities and proceed to Leh Airport to board your onward flight. The drive back offers one last chance to take in the scenic beauty of Ladakh’s landscapes. With your arrival at the airport, the tour comes to an end, leaving you with happy memories of the journey. (Breakfast)"
      },
    ],

    overview: "This journey through Ladakh is a soul-stirring blend of breathtaking landscapes, rich culture, and serene moments of reflection. From the monasteries of Leh to the enchanting Nubra Valley and the shimmering blues of Pangong Lake, every day unfolds with awe and wonder. Crossing high passes, meeting warm locals in Turtuk, and standing at the edge of timeless beauty, you’ll feel both humbled and inspired. Evenings of quiet dinners and mornings of crisp mountain air create a rhythm of peace and adventure. By the time you depart, Ladakh will have etched itself into your heart as a place of unforgettable memories and profound experiences."
  },
  {
    id: "ladakh-002",
    slug: "ultimate-ladakh-expedition",
    destination: "Ladakh",
    title: "Ultimate Ladakh Expedition",
    duration: "9 Nights 10 Days",
    route: "1N Sonamarg | 1N Kargil | 2N Leh | 2N Nubra Valley | 1N Pangong | 2N Leh",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026"],
    stars: 3,
    price: 59999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [sonamarg,kargil,leh,nubarvalley,pangong],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Phu Quoc", to: "Da Nang", type: "Direct or 1 Stop" }
    // ],

    hotels: [
      { location: "Sonamarg", nights: "1 Nights", type: "Hotel Green Kohinoor Resort or similar - 3 Star Hotel" },
      { location: "Kargil", nights: "1 Nights", type: "Hotel Royal Gasho or similar - 3 Star Hotel" },
      { location: "Leh", nights: "2 Nights", type: "Grand k2 Ladakh or similar - 3 Star Hotel" },
      { location: "Nubra Valley", nights: "2 Nights", type: "Classic Cottage nubra or similar - 3 Star Hotel" },
      { location: "Pangong", nights: "1 Nights", type: "Pangong Leisure Resort or similar - 3 Star Hotel" },
      { location: "Leh", nights: "2 Nights", type: "Hotel Shangrila-Ladakh or similar - 3 Star Hotel" },
    ],

    sightseeing: [
      { title: "Sonamarg Sightseeing" },
      { title: "Kargil Sightseeing" },
      { title: "Leh Sightseeing" },
      { title: "Nubra Valley Sightseeing" },
      { title: "Pangong Sightseeing" },
      { title: "Leh Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "9N Accommodation in Premium Hotels & Camps",
      "Fresh Satvik / Jain Meals Prepared by Dedicated Maharaj",
      "Scenic Himalayan Journey from Srinagar to Leh",
      "Visit to the Historic Kargil War Memorial in Drass Valley",
      "Monastery Exploration – Hemis, Thiksey & Lamayuru",
      "Drive through Iconic High Passes – Zoji La, Khardung La & Chang La",
      "Nubra Valley Sand Dunes Experience with Optional Bactrian Camel Ride",
      "Excursion to Turtuk – India’s Last Border Village",
      "Sunrise Experience at the Stunning Pangong Lake",
      "Leh Heritage Tour – Shanti Stupa, Leh Palace & Hall of Fame",
      "Shopping Experience at the Vibrant Leh Local Market",
    ],

    exclusions: [
      "Airfare to and from Leh/Leh",
      "Any personal expenses such as laundry, telephone calls, tips, beverages, and room service",
      "Optional activities such as Camel Safari in Sand Dunes or any snow/adventure activities",
      "Entry tickets to monuments, monasteries, museums, and sightseeing places unless specified",
      "Lunch during the journey unless specifically mentioned in the meal plan",
      "Oxygen cylinders, medical expenses, or any costs arising due to altitude sickness",
      "Travel insurance of any kind",
      "Expenses caused due to road blockage, landslides, weather conditions, flight cancellation, or any natural calamities",
      "Additional sightseeing or usage of vehicle not mentioned in the itinerary",
      "Any services not specifically mentioned under “Package Inclusions”",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Srinagar Arrival - Sonmarg Transfer (Distance: 80 KM | Travel Time: 2.5 – 3 Hours)",
        detail:
          "Your journey begins upon arrival at Srinagar Airport, where our representative will warmly welcome you before commencing a scenic drive towards Sonmarg, also known as the Meadow of Gold. The route winds through the beautiful Kashmir Valley, with lush green landscapes, sparkling rivers, and snow-capped mountains slowly appearing as you ascend higher into the Himalayas. Upon arrival in Sonmarg, check into your hotel and relax amidst the serene mountain surroundings. Important Note: Today there will be 02 pick-up times from Srinagar Airport – 11 AM and 03 PM. Dinner will be served at the hotel. Overnight Stay: Sonmarg"
      },
      {
        day: 2,
        title:
          "Transfer from Sonmarg to Kargil (Distance: 125 KM | Travel Time: 4 – 5 Hours)",
        detail:
          "Through the Legendary Drass Valley, after breakfast prepared by our Maharaj, check out from the hotel and begin your scenic journey towards Kargil. En route, visit Drass Valley, famously known as the second coldest inhabited place in the world. You will also visit the Kargil War Memorial, built in honour of the brave Indian soldiers who sacrificed their lives during the Kargil War. Enjoy breathtaking views of rugged Himalayan landscapes, glaciers, and valleys throughout the drive. Lunch:​ Either pack lunch or have lunch at Kargil Hotel (subject to road closure/weather conditions). Dinner prepared by our Maharaj. Overnight Stay: Kargil"
      },
      {
        day: 3,
        title:
          "Transfer from Kargil to Leh (Distance: 215 KM | Travel Time: 6–7 Hours)",
        detail:
          "Monasteries, Magnetic Hill & Himalayan Wonders After breakfast prepared by our Maharaj, proceed towards Leh, the capital of Ladakh. En route visits include: • Lamayuru Monastery – One of the oldest monasteries in Ladakh​• Moonland Landscape – Unique lunar terrain​• Magnetic Hill – Famous gravity hill phenomenon​• Pathar Sahib Gurudwara Upon arrival in Leh, check into the hotel and relax for acclimatisation. Lunch:​ Either pack lunch or eat at a restaurant en route. Dinner prepared by our Maharaj. Overnight Stay: Leh"
      },
      {
        day: 4,
        title:
          "Leh Monastery Exploration",
        detail:
          "Discover Ladakh’s Spiritual Heritage After breakfast prepared by our Maharaj, explore Ladakh’s famous monasteries. Visit: • Hemis Monastery – Largest monastery in Ladakh​• Thiksey Monastery – 12-storey monastery resembling Potala Palace​• Shey Palace – Former royal palace of Ladakh​• Rancho School (Druk Padma Karpo School) – Featured in the movie 3 Idiots Lunch and dinner prepared by our Maharaj. Overnight Stay: Leh"
      },
      {
        day: 5,
        title:
          "From Leh to Nubra Valley via Khardung La Pass (Distance: 160 KM | Travel Time: 5 – 6 Hours)",
        detail:
          "Cross One of the World's Highest Motorable Roads Drive through the iconic Khardung La Pass (18,380 ft). Upon reaching Nubra Valley: Visit • Diskit Monastery​• Maitreya Buddha Statue Later explore Hunder Sand Dunes where you can enjoy an optional double-hump Bactrian camel safari. Lunch and dinner prepared by our Maharaj. Overnight Stay: Nubra Valley"
      },
      {
        day: 6,
        title:
          "Excursion from Nubra Valley to Turtuk Village (Distance: 170 KM) (Round Trip)",
        detail:
          "Discover India's Last Border Village Excursion to Turtuk Village, located close to the Pakistan border. Highlights: • Unique Balti culture​• Traditional stone houses​• Apricot orchards​• Friendly local communities Visit Dhang Zero Point, one of the closest civilian access points near the Indo–Pakistan border. Lunch and dinner prepared by our Maharaj. Overnight Stay: Nubra Valley"
      },
      {
        day: 7,
        title:
          "Transferring from Nubra to Pangong Lake (Distance: 275 KM | Travel Time: 7 – 8 Hours)",
        detail:
          "The Jewel of Ladakh Drive towards the breathtaking Pangong Lake via Chang La Pass. Pangong Lake stretches across India and Tibet and changes colors throughout the day. Enjoy the peaceful Himalayan evening near the lake. Lunch and dinner are prepared by our Maharaj. Overnight Stay: Pangong Lake"
      },
      {
        day: 8,
        title:
          "From Pangong to Leh (Distance: 225 KM | Travel Time: 6 – 7 Hours)",
        detail:
          "Sunrise & Scenic Return Wake up early to witness the magical sunrise over Pangong Lake. After breakfast, begin the scenic drive back to Leh. Check into the hotel upon arrival. Lunch and dinner prepared by our Maharaj. Overnight Stay: Leh"
      },
      {
        day: 9,
        title:
          "Explore Leh Heritage & Local Market",
        detail:
          "Explore Leh’s cultural landmarks: • Shanti Stupa​• Leh Palace​• Hall of Fame Museum​• Zorawar Fort Later visit Leh Market for shopping Ladakhi handicrafts, souvenirs, and pashmina products. Lunch and dinner prepared by our Maharaj. Overnight Stay: Leh"
      },
      {
        day: 10,
        title:
          "Departure from Leh",
        detail:
          "After breakfast prepared by our Maharaj, check out from the hotel and proceed to Leh Airport for your onward journey."
      },
    ],

    overview: "Embark on an unforgettable group journey through the breathtaking landscapes of Ladakh, starting from Srinagar and passing through Sonmarg, Drass, and Kargil before reaching Leh. Cross iconic Himalayan passes like Khardung La and Chang La Pass, explore monasteries, and experience the stunning beauty of Nubra Valley and Pangong Lake. This carefully designed group expedition combines scenic drives, cultural discoveries, and freshly prepared Satvik meals for a truly memorable Ladakh adventure"
  },
  {
    id: "ladakh-003",
    slug: "incredible-ladakh-with-nubra-turtuk-and-pangong-deluxe",
    destination: "Ladakh",
    title: "Incredible Ladakh with Nubra, Turtuk and Pangong - Deluxe",
    duration: "6 Nights 7 Days",
    route: "2N Leh | 2N Nubra Valley | 1N Pangong | 1N Leh ",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026"],
    stars: 3,
    price: 42999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [leh,nubarvalley,pangong],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Phu Quoc", to: "Da Nang", type: "Direct or 1 Stop" }
    // ],

    hotels: [
      { location: "Leh", nights: "2 Nights", type: "Hotel Yak Tail or similar - 3 Star Hotel" },
      { location: "Nubra Valley", nights: "2 Nights", type: "Naycho Resort - Nubra or similar - 3 Star Hotel" },
      { location: "Pangong", nights: "1 Nights", type: "Pangong Bliss Cottage or similar - 3 Star Hotel" },
      { location: "Leh", nights: "1 Nights", type: "Hotel Yak Tail or similar - 3 Star Hotel" },
    ],

    sightseeing: [
      { title: "Leh Sightseeing" },
      { title: "Nubra Valley Sightseeing" },
      { title: "Pangong Sightseeing" },
      { title: "Leh Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "6 Nights’ comfortable stays in Leh & Nubra with a scenic lakeside stay at Pangong",
      "Enjoy daily breakfast and dinner throughout the journey",
      "Private transfers in a well-maintained vehicle with all transfers and sightseeing included",
      "Feel the mystery of Magnetic Hill and the spiritual calm of Gurdwara Pathar Sahib",
      "Witness the mesmerizing confluence of the Indus and Zanskar rivers",
      "Experience the thrill of crossing Khardung-La Pass, one of the world’s highest motorable roads",
      "Immerse yourself in the surreal beauty of Nubra Valley’s sand dunes",
      "Experience the unique culture and heritage of the remote border village of Turtuk",
      "Experience the spiritual charm of Ladakh with visits to Diskit, Spituk, Shey, and Thiksey Monasteries"
    ],

    exclusions: [
      " Airfares / Train fare.",
      "Lunch or any other meals not specifically mentioned",
      "Oxygen Cylinder at INR 500-1000 per day as per rental basis (Please do let us know if you required the same on prior basis as it is not available in the vehicle)",
      "Any Non-Indian Passport holder permit fees will be at INR 1500 per person (minimum 02 person)",
      "Any monastery entrance fees, Joy ride or rafting, light & sound show.",
      "Medical expenses (apart from first aid) and insurance of any kind.",
      "Tips, laundry, liquors, wines, mineral water, telephone charges, camera fee and items of personal nature.",
      "Transportation is not on disposal basis. It is strictly as per the programme; any extra running will be charges extra.",
      "Any expenses arising out of unforeseen circumstances like flight delay / cancellation / hike in fare, strike, curfew or any other natural calamities (like: road block) or any emergency evacuation expenses. If there are any changes in itinerary due to the above circumstance, guest will have to pay directly over there as per uses.",
      "There is no refund if the tour not complete due to reason of any natural calamities, any crisis or any personal reason.",
      "Any other item not mentioned in the cost includes section."
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Leh",
        detail:
          "On arrival in Leh, you will be met by our driver / company representative, who will assist you with your transfer to the hotel. The rest of the day is free for you to relax and acclimatize to the high altitude of Ladakh. Dinner and overnight stay at the hotel. (Dinner)"
      },
      {
        day: 2,
        title:
          "Excursion to Sham Valley",
        detail:
          "Post breakfast, embark on a full-day excursion around Leh, beginning with a visit to Magnetic Hill, renowned for its intriguing phenomenon where vehicles seem to roll uphill when in neutral gear. Proceed to Gurdwara Shri Pathar Sahib, a sacred shrine dedicated to Guru Nanak Dev Ji, where a revered boulder believed to bear the imprint of the Guru’s back is preserved. Further ahead, witness the stunning confluence of the Zanskar and Indus rivers near Nimu village, where the two rivers meet in contrasting colors, creating a spectacular natural view. On your return journey to Leh, visit the historic Spituk Monastery, perched atop a hill offering panoramic views of the Indus Valley and housing ancient artifacts, thangkas, and a revered image of Mahakaal. Afterwards, proceed to the Ladakh Hall of Fame (closed on Mondays), an Indian Army museum showcasing war memorabilia, heroic accounts of soldiers, and exhibits from the Kargil War. Later, return to the hotel by evening for dinner and an overnight stay. (Breakfast and Dinner) "
      },
      {
        day: 3,
        title:
          "Transfer from Leh to Nubra Valley via Khardung-La Pass",
        detail:
          "Begin early in the morning with a scenic drive to Nubra Valley via Khardung-La Pass (5,602 m), one of the highest motorable roads in the world, situated approximately 39 km from Leh. The journey offers breathtaking views, with two checkpoints along the way before descending into Nubra Valley. Khardung is the first village en route, situated at a higher altitude than Diskit and other nearby villages. On arrival in Nubra Valley, visit the white sand dunes at Hunder, a distinctive cold desert landscape where you can enjoy an optional ride on the double-humped Bactrian camels (at your own cost). If time permits, proceed to Diskit Monastery, a historic 500-year-old gompa founded by Lama Sherab Zangpo, home to around 100 monks and offering panoramic views of the Nubra Valley.Later, check in to your deluxe camp or hotel. Spend the evening at leisure, followed by dinner and an overnight stay. (Breakfast and Dinner)"
      },
      {
        day: 4,
        title:
          "Excursion to Turtuk",
        detail:
          "After breakfast, drive to Turtuk, one of the northernmost villages of India, located along the banks of the Shyok River, approximately 205 km from Leh. This unique border village, once under Pakistan’s control until 1971, offers a fascinating blend of history, culture, and scenic beauty. Predominantly a Muslim village, Turtuk is known for its Balti heritage, with locals speaking Balti, Ladakhi, and Urdu, and serves as one of the gateways to the Siachen Glacier. After exploring the village and its surroundings, drive back to Nubra Valley. On arrival, return to your hotel for dinner and an overnight stay. (Breakfast and Dinner)"
      },
      {
        day: 5,
        title:
          "Transfer from Nubra Valley to Pangong",
        detail:
          "After breakfast, set out on a scenic drive to Pangong Lake, passing through the charming villages of Chemrey and Sakti as you leave the Indus Valley behind. En route, cross the impressive Chang-La Pass (5,475 m), one of the highest motorable passes, accessible for most of the year. Continue the journey through rugged mountain terrain to reach Pangong Lake, located at an altitude of approximately 4,267 meters. On arrival, check in to your camp near the lake. Spend the evening at leisure, unwinding by the lakeside and enjoying the tranquil surroundings. Dinner and overnight stay at the camp. (Breakfast and Dinner)"
      },
      {
        day: 6,
        title:
          "Transfer from Pangong to Leh via Chang-La Pass with Enroute Sightseeing",
        detail:
          "After breakfast, drive back to Leh via the scenic Chang-La Pass (5,391 m), one of the highest motorable passes in the Ladakh range, offering breathtaking views of the surrounding mountains and valleys along the route. En route, visit Shey Monastery, the former royal residence, known for its impressive 7.5-meter-high gold-plated copper statue of Buddha. Continue to Thiksey Monastery, one of the largest and most architecturally striking gompas in Ladakh, housing beautiful temples, stupas, and exquisite wall paintings. Later, stop at the famous Rancho School (Druk Padma Karpo School), known for its unique blend of traditional Ladakhi culture and modern education, and popularized by the movie 3 Idiots. Arrive in Leh by evening and check in to your hotel. The rest of the time is at leisure for relaxation or individual activities. Dinner and overnight stay at the hotel. (Breakfast and Dinner)"
      },
      {
        day: 7,
        title:
          "Departure from Leh",
        detail:
          "Depart on time for Leh Airport to board your flight back home, carrying with you, unforgettable memories of Ladakh’s breathtaking landscapes and serene experiences. Wishing you a safe journey and pleasant onward travels. (Breakfast)"
      },
    ],

    overview: "Embark on an unforgettable journey through Ladakh, beginning with a peaceful acclimatization in Leh before exploring the unique landscapes and cultural gems of Sham Valley. Traverse the iconic Khardung-La Pass into the surreal Nubra Valley, where sand dunes, monasteries, and Himalayan beauty come together. Experience the charm of Turtuk, a remote border village rich in history and Balti culture. Continue to the mesmerizing Pangong Lake, where ever-changing hues create a magical setting amidst rugged mountains. Discover Ladakh’s spiritual essence through its monasteries and local life as you return to Leh. Conclude your journey with lasting memories of breathtaking landscapes, cultural depth, and truly once-in-a-lifetime experiences."
  },
  {
    id: "ladakh-004",
    slug: "incredible-ladakh-with-nubra-turtuk-and-pangong-premium",
    destination: "Ladakh",
    title: "Incredible Ladakh with Nubra, Turtuk and Pangong - Premium",
    duration: "6 Nights 7 Days",
    route: "2N Leh | 2N Nubra Valley | 1N Pangong | 1N Leh ",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026"],
    stars: 4,
    price: 52999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [leh,nubarvalley,pangong],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Phu Quoc", to: "Da Nang", type: "Direct or 1 Stop" }
    // ],

    hotels: [
      { location: "Leh", nights: "2 Nights", type: "Hotel Gyalpo Residency or similar - 4 Star Hotel" },
      { location: "Nubra Valley", nights: "2 Nights", type: "Sand Dunes Retreat or similar - 4 Star Hotel" },
      { location: "Pangong", nights: "1 Nights", type: "Polaris cottage or similar - 4 Star Hotel" },
      { location: "Leh", nights: "1 Nights", type: "Hotel Gyalpo Residency or similar - 4 Star Hotel" },
    ],

    sightseeing: [
      { title: "Leh Sightseeing" },
      { title: "Nubra Valley Sightseeing" },
      { title: "Pangong Sightseeing" },
      { title: "Leh Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "6 Nights’ comfortable stays in Leh & Nubra with a scenic lakeside stay at Pangong",
      "Enjoy daily breakfast and dinner throughout the journey",
      "Private transfers in a well-maintained vehicle with all transfers and sightseeing included",
      "Feel the mystery of Magnetic Hill and the spiritual calm of Gurdwara Pathar Sahib",
      "Witness the mesmerizing confluence of the Indus and Zanskar rivers",
      "Experience the thrill of crossing Khardung-La Pass, one of the world’s highest motorable roads",
      "Immerse yourself in the surreal beauty of Nubra Valley’s sand dunes",
      "Experience the unique culture and heritage of the remote border village of Turtuk",
      "Experience the spiritual charm of Ladakh with visits to Diskit, Spituk, Shey, and Thiksey Monasteries"
    ],

    exclusions: [
      " Airfares / Train fare.",
      "Lunch or any other meals not specifically mentioned",
      "Oxygen Cylinder at INR 500-1000 per day as per rental basis (Please do let us know if you required the same on prior basis as it is not available in the vehicle)",
      "Any Non-Indian Passport holder permit fees will be at INR 1500 per person (minimum 02 person)",
      "Any monastery entrance fees, Joy ride or rafting, light & sound show.",
      "Medical expenses (apart from first aid) and insurance of any kind.",
      "Tips, laundry, liquors, wines, mineral water, telephone charges, camera fee and items of personal nature.",
      "Transportation is not on disposal basis. It is strictly as per the programme; any extra running will be charges extra.",
      "Any expenses arising out of unforeseen circumstances like flight delay / cancellation / hike in fare, strike, curfew or any other natural calamities (like: road block) or any emergency evacuation expenses. If there are any changes in itinerary due to the above circumstance, guest will have to pay directly over there as per uses.",
      "There is no refund if the tour not complete due to reason of any natural calamities, any crisis or any personal reason.",
      "Any other item not mentioned in the cost includes section."
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Leh",
        detail:
          "On arrival in Leh, you will be met by our driver / company representative, who will assist you with your transfer to the hotel. The rest of the day is free for you to relax and acclimatize to the high altitude of Ladakh. Dinner and overnight stay at the hotel. (Dinner)"
      },
      {
        day: 2,
        title:
          "Excursion to Sham Valley",
        detail:
          "Post breakfast, embark on a full-day excursion around Leh, beginning with a visit to Magnetic Hill, renowned for its intriguing phenomenon where vehicles seem to roll uphill when in neutral gear. Proceed to Gurdwara Shri Pathar Sahib, a sacred shrine dedicated to Guru Nanak Dev Ji, where a revered boulder believed to bear the imprint of the Guru’s back is preserved. Further ahead, witness the stunning confluence of the Zanskar and Indus rivers near Nimu village, where the two rivers meet in contrasting colors, creating a spectacular natural view. On your return journey to Leh, visit the historic Spituk Monastery, perched atop a hill offering panoramic views of the Indus Valley and housing ancient artifacts, thangkas, and a revered image of Mahakaal. Afterwards, proceed to the Ladakh Hall of Fame (closed on Mondays), an Indian Army museum showcasing war memorabilia, heroic accounts of soldiers, and exhibits from the Kargil War. Later, return to the hotel by evening for dinner and an overnight stay. (Breakfast and Dinner) "
      },
      {
        day: 3,
        title:
          "Transfer from Leh to Nubra Valley via Khardung-La Pass",
        detail:
          "Begin early in the morning with a scenic drive to Nubra Valley via Khardung-La Pass (5,602 m), one of the highest motorable roads in the world, situated approximately 39 km from Leh. The journey offers breathtaking views, with two checkpoints along the way before descending into Nubra Valley. Khardung is the first village en route, situated at a higher altitude than Diskit and other nearby villages. On arrival in Nubra Valley, visit the white sand dunes at Hunder, a distinctive cold desert landscape where you can enjoy an optional ride on the double-humped Bactrian camels (at your own cost). If time permits, proceed to Diskit Monastery, a historic 500-year-old gompa founded by Lama Sherab Zangpo, home to around 100 monks and offering panoramic views of the Nubra Valley.Later, check in to your deluxe camp or hotel. Spend the evening at leisure, followed by dinner and an overnight stay. (Breakfast and Dinner)"
      },
      {
        day: 4,
        title:
          "Excursion to Turtuk",
        detail:
          "After breakfast, drive to Turtuk, one of the northernmost villages of India, located along the banks of the Shyok River, approximately 205 km from Leh. This unique border village, once under Pakistan’s control until 1971, offers a fascinating blend of history, culture, and scenic beauty. Predominantly a Muslim village, Turtuk is known for its Balti heritage, with locals speaking Balti, Ladakhi, and Urdu, and serves as one of the gateways to the Siachen Glacier. After exploring the village and its surroundings, drive back to Nubra Valley. On arrival, return to your hotel for dinner and an overnight stay. (Breakfast and Dinner)"
      },
      {
        day: 5,
        title:
          "Transfer from Nubra Valley to Pangong",
        detail:
          "After breakfast, set out on a scenic drive to Pangong Lake, passing through the charming villages of Chemrey and Sakti as you leave the Indus Valley behind. En route, cross the impressive Chang-La Pass (5,475 m), one of the highest motorable passes, accessible for most of the year. Continue the journey through rugged mountain terrain to reach Pangong Lake, located at an altitude of approximately 4,267 meters. On arrival, check in to your camp near the lake. Spend the evening at leisure, unwinding by the lakeside and enjoying the tranquil surroundings. Dinner and overnight stay at the camp. (Breakfast and Dinner)"
      },
      {
        day: 6,
        title:
          "Transfer from Pangong to Leh via Chang-La Pass with Enroute Sightseeing",
        detail:
          "After breakfast, drive back to Leh via the scenic Chang-La Pass (5,391 m), one of the highest motorable passes in the Ladakh range, offering breathtaking views of the surrounding mountains and valleys along the route. En route, visit Shey Monastery, the former royal residence, known for its impressive 7.5-meter-high gold-plated copper statue of Buddha. Continue to Thiksey Monastery, one of the largest and most architecturally striking gompas in Ladakh, housing beautiful temples, stupas, and exquisite wall paintings. Later, stop at the famous Rancho School (Druk Padma Karpo School), known for its unique blend of traditional Ladakhi culture and modern education, and popularized by the movie 3 Idiots. Arrive in Leh by evening and check in to your hotel. The rest of the time is at leisure for relaxation or individual activities. Dinner and overnight stay at the hotel. (Breakfast and Dinner)"
      },
      {
        day: 7,
        title:
          "Departure from Leh",
        detail:
          "Depart on time for Leh Airport to board your flight back home, carrying with you, unforgettable memories of Ladakh’s breathtaking landscapes and serene experiences. Wishing you a safe journey and pleasant onward travels. (Breakfast)"
      },
    ],

    overview: "Embark on an unforgettable journey through Ladakh, beginning with a peaceful acclimatization in Leh before exploring the unique landscapes and cultural gems of Sham Valley. Traverse the iconic Khardung-La Pass into the surreal Nubra Valley, where sand dunes, monasteries, and Himalayan beauty come together. Experience the charm of Turtuk, a remote border village rich in history and Balti culture. Continue to the mesmerizing Pangong Lake, where ever-changing hues create a magical setting amidst rugged mountains. Discover Ladakh’s spiritual essence through its monasteries and local life as you return to Leh. Conclude your journey with lasting memories of breathtaking landscapes, cultural depth, and truly once-in-a-lifetime experiences."
  },
  {
    id: "ladakh-005",
    slug: "experience-ladakh-with-nubra-and-pangong-deluxe",
    destination: "Ladakh",
    title: "Experience Ladakh with Nubra and Pangong - Deluxe",
    duration: "5 Nights 6 Days",
    route: "2N Leh | 1N Nubra Valley | 1N Pangong | 1N Leh ",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026"],
    stars: 3,
    price: 32999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [leh,nubarvalley,pangong],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Phu Quoc", to: "Da Nang", type: "Direct or 1 Stop" }
    // ],

    hotels: [
      { location: "Leh", nights: "2 Nights", type: "Hotel City Palace or similar - 3 Star Hotel" },
      { location: "Nubra Valley", nights: "1 Nights", type: "Organic Boutique Hunder or similar - 3 Star Hotel" },
      { location: "Pangong", nights: "1 Nights", type: "Pangong Bliss Cottage or similar - 3 Star Hotel" },
      { location: "Leh", nights: "1 Nights", type: "Hotel City Palace or similar - 3 Star Hotel" },
    ],

    sightseeing: [
      { title: "Leh Sightseeing" },
      { title: "Nubra Valley Sightseeing" },
      { title: "Pangong Sightseeing" },
      { title: "Leh Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "05 nights’ stay in comfortable hotels and deluxe camps, including a scenic lakeside experience at Pangong",
      "Enjoy daily breakfast and dinner throughout the journey",
      "Private transfers in a well-maintained vehicle with all transfers and sightseeing included",
      "Feel the thrill of Magnetic Hill and the serenity of Gurudwara Pathar Sahib",
      "Witness the mesmerizing confluence of the Indus and Zanskar rivers",
      "Discover Ladakh’s rich heritage at Spituk Monastery and the inspiring Hall of Fame",
      "Experience the exhilaration of crossing Khardung-La Pass, surrounded by towering Himalayan peaks",
      "Immerse yourself in the surreal beauty of Nubra Valley’s sand dunes",
      "Unwind by the tranquil waters of Pangong Lake, witnessing its ever-changing hues against rugged mountains",
      "Explore the spiritual and architectural beauty of Shey and Thiksey Monasteries, along with the charm of the iconic Rancho School",
    ],

    exclusions: [
      " Airfares / Train fare.",
      "Lunch or any other meals not specifically mentioned",
      "Oxygen Cylinder at INR 500-1000 per day as per rental basis (Please do let us know if you required the same on prior basis as it is not available in the vehicle)",
      "Any Non-Indian Passport holder permit fees will be at INR 1500 per person (minimum 02 person)",
      "Any monastery entrance fees, Joy ride or rafting, light & sound show.",
      "Medical expenses (apart from first aid) and insurance of any kind.",
      "Tips, laundry, liquors, wines, mineral water, telephone charges, camera fee and items of personal nature.",
      "Transportation is not on disposal basis. It is strictly as per the programme; any extra running will be charges extra.",
      "Any expenses arising out of unforeseen circumstances like flight delay / cancellation / hike in fare, strike, curfew or any other natural calamities (like: road block) or any emergency evacuation expenses. If there are any changes in itinerary due to the above circumstance, guest will have to pay directly over there as per uses.",
      "There is no refund if the tour not complete due to reason of any natural calamities, any crisis or any personal reason.",
      "Any other item not mentioned in the cost includes section."
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Leh",
        detail:
          "On arrival in Leh, you will be met by our driver / company representative, who will assist you with your transfer to the hotel. The rest of the day is free for you to relax and acclimatize to the high altitude of Ladakh. Dinner and overnight stay at the hotel. (Dinner)"
      },
      {
        day: 2,
        title:
          "Excursion to Sham Valley",
        detail:
          "Post breakfast, embark on a full-day excursion around Leh, beginning with a visit to Magnetic Hill, renowned for its intriguing phenomenon where vehicles seem to roll uphill when in neutral gear. Proceed to Gurdwara Shri Pathar Sahib, a sacred shrine dedicated to Guru Nanak Dev Ji, where a revered boulder believed to bear the imprint of the Guru’s back is preserved. Further ahead, witness the stunning confluence of the Zanskar and Indus rivers near Nimu village, where the two rivers meet in contrasting colors, creating a spectacular natural view. On your return journey to Leh, visit the historic Spituk Monastery, perched atop a hill offering panoramic views of the Indus Valley and housing ancient artifacts, thangkas, and a revered image of Mahakaal. Afterwards, proceed to the Ladakh Hall of Fame (closed on Mondays), an Indian Army museum showcasing war memorabilia, heroic accounts of soldiers, and exhibits from the Kargil War. Later, return to the hotel by evening for dinner and an overnight stay. (Breakfast and Dinner) "
      },
      {
        day: 3,
        title:
          "Transfer from Leh to Nubra Valley via Khardung-La Pass",
        detail:
          "Begin early in the morning with a scenic drive to Nubra Valley via Khardung-La Pass (5,602 m), one of the highest motorable roads in the world, situated approximately 39 km from Leh. The journey offers breathtaking views, with two checkpoints along the way before descending into Nubra Valley. Khardung is the first village en route, situated at a higher altitude than Diskit and other nearby villages. On arrival in Nubra Valley, visit the white sand dunes at Hunder, a distinctive cold desert landscape where you can enjoy an optional ride on the double-humped Bactrian camels (at your own cost). If time permits, proceed to Diskit Monastery, a historic 500-year-old gompa founded by Lama Sherab Zangpo, home to around 100 monks and offering panoramic views of the Nubra Valley.Later, check in to your deluxe camp or hotel. Spend the evening at leisure, followed by dinner and an overnight stay. (Breakfast and Dinner)"
      },
      {
        day: 4,
        title:
          "Transfer from Nubra Valley to Pangong",
        detail:
          "After breakfast, proceed for a scenic drive to Pangong Lake via the picturesque villages of Chemrey and Sakti, leaving behind the Indus Valley. En route, cross the mighty Chang-La Pass (5,475 m), one of the highest motorable passes, which remains accessible for most of the year. Continue the journey through rugged mountain terrain to reach Pangong Lake, located at an altitude of approximately 4,267 meters. On arrival, check in to your camp near the lake. Spend the evening relaxing by the lakeside, soaking in the serene beauty of the surroundings. Dinner and overnight stay at the camp. (Breakfast and Dinner)"
      },
      {
        day: 5,
        title:
          "Transfer from Pangong to Leh via Chang-La Pass",
        detail:
          "After breakfast, set out on a scenic drive to Pangong Lake, passing through the charming villages of Chemrey and Sakti as you leave the Indus Valley behind. En route, cross the impressive Chang-La Pass (5,475 m), one of the highest motorable passes, accessible for most of the year. Continue the journey through rugged mountain terrain to reach Pangong Lake, located at an altitude of approximately 4,267 meters. On arrival, check in to your camp near the lake. Spend the evening at leisure, unwinding by the lakeside and enjoying the tranquil surroundings. Dinner and overnight stay at the camp. (Breakfast and Dinner)"
      },
      {
        day: 6,
        title:
          "Transfer from Pangong to Leh via Chang-La Pass with Enroute Sightseeing",
        detail:
          "After breakfast, drive back to Leh via the scenic Chang-La Pass (5,391 m), one of the highest motorable passes in the Ladakh range, offering breathtaking views of the surrounding mountains and valleys along the route. En route, visit Shey Monastery, the former royal residence, known for its impressive 7.5-meter-high gold-plated copper statue of Buddha. Continue to Thiksey Monastery, one of the largest and most architecturally striking gompas in Ladakh, housing beautiful temples, stupas, and exquisite wall paintings. Later, stop at the famous Rancho School (Druk Padma Karpo School), known for its unique blend of traditional Ladakhi culture and modern education, and popularized by the movie 3 Idiots. Arrive in Leh by evening and check in to your hotel. The rest of the time is at leisure for relaxation or individual activities. Dinner and overnight stay at the hotel. (Breakfast and Dinner)"
      },
      {
        day: 7,
        title:
          "Departure from Leh",
        detail:
          "Depart on time for Leh Airport to board your flight back home, carrying with you, unforgettable memories of Ladakh’s breathtaking landscapes and serene experiences. Wishing you a safe journey and pleasant onward travels. (Breakfast)"
      },
    ],

    overview: "Experience the magic of Ladakh as you arrive in Leh and ease into its serene high-altitude charm. Explore the cultural and natural wonders of Sham Valley, from sacred sites to dramatic river confluences. Journey across the iconic Khardung-La Pass into the stunning Nubra Valley, where desert landscapes meet Himalayan beauty. Witness the ever-changing hues of Pangong Lake, a truly mesmerizing highlight of the trip. Discover ancient monasteries and local life as you return to Leh, soaking in the region’s spiritual essence. Leave with unforgettable memories, a sense of peace, and the thrill of having experienced one of India’s most extraordinary destinations."
  },
  {
    id: "ladakh-006",
    slug: "experience-ladakh-with-nubra-and-pangong-premium",
    destination: "Ladakh",
    title: "Experience Ladakh with Nubra and Pangong - Premium",
    duration: "5 Nights 6 Days",
    route: "2N Leh | 1N Nubra Valley | 1N Pangong | 1N Leh ",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026"],
    stars: 4,
    price: 42999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [leh,nubarvalley,pangong],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Phu Quoc", to: "Da Nang", type: "Direct or 1 Stop" }
    // ],

    hotels: [
      { location: "Leh", nights: "2 Nights", type: "The Bodhi Tree or similar - 4 Star Hotel" },
      { location: "Nubra Valley", nights: "1 Nights", type: "The Rustic Cabins or similar - 4 Star Hotel" },
      { location: "Pangong", nights: "1 Nights", type: "Pangong Vista Resort or similar - 4 Star Hotel" },
      { location: "Leh", nights: "1 Nights", type: "The Bodhi Tree or similar - 4 Star Hotel" },
    ],

    sightseeing: [
      { title: "Leh Sightseeing" },
      { title: "Nubra Valley Sightseeing" },
      { title: "Pangong Sightseeing" },
      { title: "Leh Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "05 nights’ stay in comfortable hotels and deluxe camps, including a scenic lakeside experience at Pangong",
      "Enjoy daily breakfast and dinner throughout the journey",
      "Private transfers in a well-maintained vehicle with all transfers and sightseeing included",
      "Feel the thrill of Magnetic Hill and the serenity of Gurudwara Pathar Sahib",
      "Witness the mesmerizing confluence of the Indus and Zanskar rivers",
      "Discover Ladakh’s rich heritage at Spituk Monastery and the inspiring Hall of Fame",
      "Experience the exhilaration of crossing Khardung-La Pass, surrounded by towering Himalayan peaks",
      "Immerse yourself in the surreal beauty of Nubra Valley’s sand dunes",
      "Unwind by the tranquil waters of Pangong Lake, witnessing its ever-changing hues against rugged mountains",
      "Explore the spiritual and architectural beauty of Shey and Thiksey Monasteries, along with the charm of the iconic Rancho School",
    ],

    exclusions: [
      " Airfares / Train fare.",
      "Lunch or any other meals not specifically mentioned",
      "Oxygen Cylinder at INR 500-1000 per day as per rental basis (Please do let us know if you required the same on prior basis as it is not available in the vehicle)",
      "Any Non-Indian Passport holder permit fees will be at INR 1500 per person (minimum 02 person)",
      "Any monastery entrance fees, Joy ride or rafting, light & sound show.",
      "Medical expenses (apart from first aid) and insurance of any kind.",
      "Tips, laundry, liquors, wines, mineral water, telephone charges, camera fee and items of personal nature.",
      "Transportation is not on disposal basis. It is strictly as per the programme; any extra running will be charges extra.",
      "Any expenses arising out of unforeseen circumstances like flight delay / cancellation / hike in fare, strike, curfew or any other natural calamities (like: road block) or any emergency evacuation expenses. If there are any changes in itinerary due to the above circumstance, guest will have to pay directly over there as per uses.",
      "There is no refund if the tour not complete due to reason of any natural calamities, any crisis or any personal reason.",
      "Any other item not mentioned in the cost includes section."
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Leh",
        detail:
          "On arrival in Leh, you will be met by our driver / company representative, who will assist you with your transfer to the hotel. The rest of the day is free for you to relax and acclimatize to the high altitude of Ladakh. Dinner and overnight stay at the hotel. (Dinner)"
      },
      {
        day: 2,
        title:
          "Excursion to Sham Valley",
        detail:
          "Post breakfast, embark on a full-day excursion around Leh, beginning with a visit to Magnetic Hill, renowned for its intriguing phenomenon where vehicles seem to roll uphill when in neutral gear. Proceed to Gurdwara Shri Pathar Sahib, a sacred shrine dedicated to Guru Nanak Dev Ji, where a revered boulder believed to bear the imprint of the Guru’s back is preserved. Further ahead, witness the stunning confluence of the Zanskar and Indus rivers near Nimu village, where the two rivers meet in contrasting colors, creating a spectacular natural view. On your return journey to Leh, visit the historic Spituk Monastery, perched atop a hill offering panoramic views of the Indus Valley and housing ancient artifacts, thangkas, and a revered image of Mahakaal. Afterwards, proceed to the Ladakh Hall of Fame (closed on Mondays), an Indian Army museum showcasing war memorabilia, heroic accounts of soldiers, and exhibits from the Kargil War. Later, return to the hotel by evening for dinner and an overnight stay. (Breakfast and Dinner) "
      },
      {
        day: 3,
        title:
          "Transfer from Leh to Nubra Valley via Khardung-La Pass",
        detail:
          "Begin early in the morning with a scenic drive to Nubra Valley via Khardung-La Pass (5,602 m), one of the highest motorable roads in the world, situated approximately 39 km from Leh. The journey offers breathtaking views, with two checkpoints along the way before descending into Nubra Valley. Khardung is the first village en route, situated at a higher altitude than Diskit and other nearby villages. On arrival in Nubra Valley, visit the white sand dunes at Hunder, a distinctive cold desert landscape where you can enjoy an optional ride on the double-humped Bactrian camels (at your own cost). If time permits, proceed to Diskit Monastery, a historic 500-year-old gompa founded by Lama Sherab Zangpo, home to around 100 monks and offering panoramic views of the Nubra Valley.Later, check in to your deluxe camp or hotel. Spend the evening at leisure, followed by dinner and an overnight stay. (Breakfast and Dinner)"
      },
      {
        day: 4,
        title:
          "Transfer from Nubra Valley to Pangong",
        detail:
          "After breakfast, proceed for a scenic drive to Pangong Lake via the picturesque villages of Chemrey and Sakti, leaving behind the Indus Valley. En route, cross the mighty Chang-La Pass (5,475 m), one of the highest motorable passes, which remains accessible for most of the year. Continue the journey through rugged mountain terrain to reach Pangong Lake, located at an altitude of approximately 4,267 meters. On arrival, check in to your camp near the lake. Spend the evening relaxing by the lakeside, soaking in the serene beauty of the surroundings. Dinner and overnight stay at the camp. (Breakfast and Dinner)"
      },
      {
        day: 5,
        title:
          "Transfer from Pangong to Leh via Chang-La Pass",
        detail:
          "After breakfast, set out on a scenic drive to Pangong Lake, passing through the charming villages of Chemrey and Sakti as you leave the Indus Valley behind. En route, cross the impressive Chang-La Pass (5,475 m), one of the highest motorable passes, accessible for most of the year. Continue the journey through rugged mountain terrain to reach Pangong Lake, located at an altitude of approximately 4,267 meters. On arrival, check in to your camp near the lake. Spend the evening at leisure, unwinding by the lakeside and enjoying the tranquil surroundings. Dinner and overnight stay at the camp. (Breakfast and Dinner)"
      },
      {
        day: 6,
        title:
          "Transfer from Pangong to Leh via Chang-La Pass with Enroute Sightseeing",
        detail:
          "After breakfast, drive back to Leh via the scenic Chang-La Pass (5,391 m), one of the highest motorable passes in the Ladakh range, offering breathtaking views of the surrounding mountains and valleys along the route. En route, visit Shey Monastery, the former royal residence, known for its impressive 7.5-meter-high gold-plated copper statue of Buddha. Continue to Thiksey Monastery, one of the largest and most architecturally striking gompas in Ladakh, housing beautiful temples, stupas, and exquisite wall paintings. Later, stop at the famous Rancho School (Druk Padma Karpo School), known for its unique blend of traditional Ladakhi culture and modern education, and popularized by the movie 3 Idiots. Arrive in Leh by evening and check in to your hotel. The rest of the time is at leisure for relaxation or individual activities. Dinner and overnight stay at the hotel. (Breakfast and Dinner)"
      },
      {
        day: 7,
        title:
          "Departure from Leh",
        detail:
          "Depart on time for Leh Airport to board your flight back home, carrying with you, unforgettable memories of Ladakh’s breathtaking landscapes and serene experiences. Wishing you a safe journey and pleasant onward travels. (Breakfast)"
      },
    ],

    overview: "Experience the magic of Ladakh as you arrive in Leh and ease into its serene high-altitude charm. Explore the cultural and natural wonders of Sham Valley, from sacred sites to dramatic river confluences. Journey across the iconic Khardung-La Pass into the stunning Nubra Valley, where desert landscapes meet Himalayan beauty. Witness the ever-changing hues of Pangong Lake, a truly mesmerizing highlight of the trip. Discover ancient monasteries and local life as you return to Leh, soaking in the region’s spiritual essence. Leave with unforgettable memories, a sense of peace, and the thrill of having experienced one of India’s most extraordinary destinations."
  },
  // ================= Thailand =================
  {
    id: "thailand-001",
    slug: "thailand-full-moon-party-at-koh-samui",
    destination: "Thailand",
    title: "Thailand Full Moon Party at Koh Samui",
    duration: "6 Nights 7 Days",
    route: "2N Krabi | 2N Koh Samai | 2N Phuket",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026", " Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 49999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [krabi,kohSamai,phuket],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Phu Quoc", to: "Da Nang", type: "Direct or 1 Stop" }
    // ],

    hotels: [
      { location: "Krabi", nights: "2 Nights", type: "GLOW Ao Nang Krabi or similar - 4 Star Hotel" },
      { location: "Koh Samai", nights: "2 Nights", type: "Chaweng Noi Pool Villa or similar - 4 Star Hotel" },
      { location: "Phuket", nights: "2 Nights", type: "Andakira Hotel or similar - 4 Star Hotel" },
    ],

    sightseeing: [
      { title: "Krabi Sightseeing" },
      { title: "Koh Samai Sightseeing" },
      { title: "Phuket Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
    ],


    inclusions: [
      "3 Stunning Thai Destinations in One Trip – Krabi, Koh Samui & Phuket",
      "Island Hopping Adventures including the famous Krabi Four Island Tour",
      "Phi Phi Island Speedboat Tour with Lunch – one of Thailand’s must-do experiences",
      "Full Moon Party Experience (Koh Phangan) with speedboat transfers (bucket-list nightlife)",
      "Scenic ferry journeys between islands for a true tropical travel vibe",
      "Comfortable stays in handpicked 4-star hotels with breakfast",
      "Hassle-free private & shared transfers throughout the trip",
      "Perfect mix of romantic escapes + party scenes",
      "Instagram-worthy beaches, limestone cliffs & turquoise waters",
    ],

    exclusions: [
      "Passport fees, immunization costs, city taxes at the hotel and local departure taxes (wherever applicable)",
      "Optional enhancements like room or flight upgrades, or local camera or video fees",
      "Additional sightseeing, activities and experiences outside of the itinerary",
      "Early check-in or late check-out from hotels (unless otherwise specified)",
      "Breakfast, lunches, dinners and drinks (alcoholic and non-alcoholic), unless specified in the itinerary",
      "Any international and/or domestic flights, unless explicitly mentioned as an inclusion",
      "Excess baggage charges, and where applicable, baggage not included in your fare",
      "Tips for services and experiences",
      "Any Visa required, unless mentioned as an inclusion",
      "Read useful information and terms for more on what is included and excluded",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival at Phuket - Transfer to Krabi",
        detail:
          "Upon arrival at Phuket Airport, meet our local tour coordinator who will meet and greet you at the specified area and transfer you to your Krabi hotel. Check in to your hotel (Standard Check in time: 1400 - 1500 hours) and relax. Rest of the day is free at your own leisure. In the evening you can go out and get acquainted to your nearby areas and relish some freshly made cuisines at local seaside restaurants. Later return to hotel and sleep relaxed."
      },
      {
        day: 2,
        title:
          "Full Day Krabi Four Island Tour by Long Tail Boat With Lunch",
        detail:
          "After breakfast, proceed for Krabi Four Island Day Trip. Explore the islands of Koh Tup, Koh Gai, Koh Poda and Phra Nang Cave Beach via boat on this day trip from Krabi. Start your day trip in the morning by first going to the scenic Koh Tup Island, famed for its tidal sandbank. Wonder at the unique formation of shoals and picturesque coastline. Next, head over to Koh Gai Island, also known as Chicken Island for its similar appearance to the head of a chicken. Here dive into the exquisite, azure water for a swim or go snorkelling to closely observe the variety of sea creatures. Break for a delicious picnic lunch at Koh Poda Island and take time to relax on the white sandy beach, snooze in the sun, and observe the stunning scenery. Your last stop is at the breathtaking Phra Nang Cave Beach. Explore the grotto caves, watch as daring climbers ascend the rocks, and swim in the warm waters inside the caves. National Park Fee NOT included in the tour price: 200 THB per adult (to be paid cash on the tour date)"
      },
      {
        day: 3,
        title:
          "Full Moon Party at Koh Phang Nan - Return Transfers from Koh Samui by Speedboat (Subject to availability during Travel) Entry Ticket not included",
        detail:
          "Breakfast at Hotel. Check out hotel and and proceed to Krabi Ferry port to catch your ferry to Koh Samui. On arrival at Koh Samui, transfer to Hotel. Check in to Hotel. Rest of the day is free for leisure & own activity. Overnight stay in Koh Samui. Please note that Full Moon Part Ticket is subject to availability during Travel. Entry Ticket not included"
      },
      {
        day: 4,
        title:
          "Koh Samui - Day at Leisure",
        detail:
          "Today you are free to explore Koh Samui on your own. You can relax at the beaches, indulge in water sports activities like snorkeling or scuba diving or take a tour around the island."
      },
      {
        day: 5,
        title:
          "Transfer from Koh Samui to Phuket by Ferry",
        detail:
          "Today morning check-out from your hotel and get ready for a long 9 hour journey by ferry and land to Phuket. You will be picked up from hotel and transferred to Nathon Pier to catch your ferry to Phuket. You will arrive at Phuket by evening and then transferred to your hotel for check-in."
      },
      {
        day: 6,
        title:
          "Phi Phi Island Tour by Speedboat",
        detail:
          "07:30 Begin your day early with convenient hotel pickup in Phuket. 08:30 You will be transferred to the Phuket Boat Lagoon Marina, where you can enjoy light refreshments such as coffee, tea, and snacks before embarking on your adventure. 09:00 Our first destination is Maya Bay, famously known for its appearance in the movie 'The Beach' starring Leonardo DiCaprio. Take a refreshing swim in the crystal clear waters before we move on to other breathtaking sites including Monkey Beach, Pileh Cove, Viking Cave, and Loh Samah Bay. 12:30 Afterwards, we will make a stop at Phi Phi Don Island for a delicious buffet lunch. Following the meal, we will continue our journey by speedboat to a secluded snorkeling spot where you can explore the vibrant marine life and colorful corals. 15:00 Our final destination is Khai Island, a picturesque location offering pristine white sand beaches. Here, you can engage in various water activities such as swimming, snorkeling, or simply sunbathe. For those interested, there is also the option to try out additional water sports like banana boat rides or jet skiing, at your own expense. 17:00 As the day comes to an end, we will return to the Phuket marina in the late afternoon. From there, you will be transferred back to your hotel via minivan, concluding our tour. Phi Phi Islands Tour, National Park fee @ THB 400 has to be paid directly."
      },
      {
        day: 7,
        title:
          "Departure from Phuket",
        detail:
          "After breakfast, checkout from your hotel. You will be picked up and transfered to the airport to catch your flight back home. Your trip ends with sweet memories."
      },
    ],

    overview: "Experience the best of Thailand’s tropical paradise with this carefully curated 6-night island-hopping journey across Krabi, Koh Samui, and Phuket. Designed for both fun-loving bachelors and couples seeking a mix of relaxation and nightlife, this trip blends scenic beauty, thrilling excursions, and unforgettable party experiences. From the crystal-clear waters of Krabi’s iconic islands to the electrifying Full Moon Party vibes near Koh Samui, and the lively beach culture of Phuket, every day offers a new adventure. Enjoy seamless transfers, comfortable 4-star stays, and handpicked tours that give you the perfect balance of exploration and leisure. Whether you want to unwind on white-sand beaches, cruise across turquoise waters, or dance under the stars—this trip has it all."
  },
  {
    id: "thailand-002",
    slug: "thailands-calling-the-bachelor-escape",
    destination: "Thailand",
    title: "Thailand’s Calling: The Bachelor Escape",
    duration: "4 Nights 5 Days",
    route: "3N Pattaya | 1N Bangkok",
    departureCity: ["Mumbai", "Bangalore", "Amritsar", "Joining Direct"],
    availableDate: ["May 2026"],
    stars: 4,
    price: 53999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [pattaya,bangkok],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Phu Quoc", to: "Da Nang", type: "Direct or 1 Stop" }
    // ],

    hotels: [
      { location: "Pattaya", nights: "3 Nights", type: "Mind Resort Pattaya or similar - 4 Star Hotel" },
      { location: "Bangkok", nights: "1 Nights", type: "Ramada by Wyndham D MA Bangkok or similar - 4 Star Hotel" },
    ],

    sightseeing: [
      { title: "Pattaya Sightseeing" },
      { title: "Bangkok Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
    ],


    inclusions: [
      "Visit Tiger Topia for unique animal encounters & photo moments",
      "Enjoy the dazzling Alcazar Show",
      "Spend a full day at Coral Island (Koh Larn) with beach time & optional activities",
      "Explore Nong Nooch Village, cultural shows & themed gardens",
      "Celebrate with a fun and refreshing Yacht Party",
      "Experience the best of Pattaya & Bangkok nightlife",
      "Comfortable stays + smooth transfers throughout",
    ],

    exclusions: [
      "Passport fees, immunization costs, city taxes at the hotel and local departure taxes (wherever applicable)",
      "Optional enhancements like room or flight upgrades, or local camera or video fees",
      "Additional sightseeing, activities and experiences outside of the itinerary",
      "Early check-in or late check-out from hotels (unless otherwise specified)",
      "Breakfast, lunches, dinners and drinks (alcoholic and non-alcoholic), unless specified in the itinerary",
      "Any international and/or domestic flights, unless explicitly mentioned as an inclusion",
      "Excess baggage charges, and where applicable, baggage not included in your fare",
      "Tips for services and experiences",
      "Any Visa required, unless mentioned as an inclusion",
      "Read useful information and terms for more on what is included and excluded",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Bangkok → Transfer to Pattaya | Tiger Topia | Alcazar Show",
        detail:
          "Morning / Arrival Arrive at Bangkok Airport (BKK/DMK). Meet your tour representative and transfer to Pattaya (approx. 2–2.5 hours by road). Check-in at the hotel and refresh. At Afternoon proceed to Tiger Topia Pattaya, a unique zoo/interactive park. Enjoy the Walkthrough wildlife zones, Tiger feeding & photo opportunities. In the Evening Head to the world-famous Alcazar Show. Witness the Glamorous costumes, International dance & musical performances. After the show, enjoy the nightlife or return to hotel. Overnight: Pattaya"
      },
      {
        day: 2,
        title:
          "Coral Island (Koh Larn) Tour",
        detail:
          "After breakfast, depart for Coral Island (Koh Larn) by speedboat. At Afternoon Relax on the beautiful white-sand beaches. Enjoy lunch at a local restaurant. Free time for swimming, sunbathing & beach activities. At Evening Return to Pattaya. Overnight: Pattaya"
      },
      {
        day: 3,
        title:
          "Nong Nooch Village Tour",
        detail:
          "Morning After breakfast Visit the beautiful Nong Nooch Village. Explore the Elephant show (subject to program availability), Thai cultural show, Stunning themed gardens (Dinosaur Valley, Orchid Garden, French Garden). At Afternoon Enjoy lunch. Explore additional zones including skywalks & photo points. At Evening Return to hotel and relax or explore Pattaya nightlife. Overnight: Pattaya"
      },
      {
        day: 4,
        title:
          "Yacht Party (11 AM) | Transfer to Bangkok",
        detail:
          "Morning after breakfast Get ready and board your private/group yacht around 11:00 AM. Enjoy the Music & onboard party, Swimming, Soft drinks & snacks, Scenic sailing around nearby islands. At Afternoon Return to Pattaya pier. Check-out and depart for Bangkok. At Evening Arrive in Bangkok Check-in at Bangkok hotel. Overnight: Bangkok"
      },
      {
        day: 5,
        title:
          "Shopping & Bangkok Hotel to Airport Transfer",
        detail:
          "After breakfast, enjoy some free time for last-minute shopping at nearby markets or malls, explore Bangkok’s vibrant shopping streets at your own pace, relax at a café, or simply unwind at the hotel. At the scheduled time, meet your driver for a comfortable transfer from your Bangkok hotel to the airport. Depart with great memories of your bachelor trip and a smooth end to your Thailand experience."
      },
    ],

    overview: "Experience the best of Thailand’s tropical paradise with this carefully curated 6-night island-hopping journey across Krabi, Koh Samui, and Phuket. Designed for both fun-loving bachelors and couples seeking a mix of relaxation and nightlife, this trip blends scenic beauty, thrilling excursions, and unforgettable party experiences. From the crystal-clear waters of Krabi’s iconic islands to the electrifying Full Moon Party vibes near Koh Samui, and the lively beach culture of Phuket, every day offers a new adventure. Enjoy seamless transfers, comfortable 4-star stays, and handpicked tours that give you the perfect balance of exploration and leisure. Whether you want to unwind on white-sand beaches, cruise across turquoise waters, or dance under the stars—this trip has it all."
  },
  // ================= KASHMIR =================
  {
    id: "kashmir-001",
    slug: "kashmir-valley-retreat-veg-kitchen-tour",
    destination: "Kashmir",
    title: "Kashmir Valley Retreat: Veg Kitchen Tour",
    duration: "8 Nights 9 Days",
    route: "2N Sonamarg  | 2N Gulmarg  | 2N Srinagar | 2N Pahalgam",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026"],
    stars: 4,
    price: 59999,
    tags: ["❄️ Scenic", "❤️ Popular"],
    rating: 4.8,

    images: [sonamarg,gulmarg,srinagar,pahalgam],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    hotels: [
      { location: "Sonamarg", nights: "2 Nights", type: "Hotel Rosewood Sonamarg or similar - 4 Star Hotel" },
      { location: "Gulmarg", nights: "2 Nights", type: "Rosewood Hotel or similar - 4 Star Hotel" },
      { location: "Srinagar", nights: "2 Nights", type: "Ennco Resorts or similar - 4 Star Hotel" },
      { location: "Pahalgam", nights: "2 Nights", type: "Eden Resorts and spa or similar - 4 Star Hotel" },
    ],

    sightseeing: [
      { title: "Sonamarg Sightseeing" },
      { title: "Gulmarg Sightseeing" },
      { title: "Srinagar Sightseeing" },
      { title: "Pahalgam Sightseeing" }
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" }
    ],

    meals: [
      { title: "Daily Breakfast Included" },
      { title: "Daily Lunch Included" },
      { title: "Daily Dinner Included" },
    ],


    inclusions: [
      "8N Accommodation in 4 Star Hotels.",
      "All meals Prepared by Dedicated Chef.",
      "Completely Pure Veg/ Satvik/Jain Meals.",
      "Snow views at Sonmarg & Thajiwas Glacier",
      "Gulmarg Gondola Ride (Phase 1 Tickets)",
      "Serene Shikara Ride on Dal Lake",
      "Mughal Garden Visit – Shalimar Bagh & Nishat Bagh",
      "Full Day Excursion to Doodhpathri (Hidden Meadow Experience)",
      "ABC Valleys Sightseeing in Pahalgam",
    ],

    exclusions: [
      "Airfare / Train tickets",
      "Pony rides & snow activities",
      "Gondola Phase 2 tickets",
      "Entry tickets to monuments (if any not specified)",
      "Personal expenses (shopping, tips, laundry, phone calls)",
      "Lunch on Day 01 (₹500 per person optional)",
      "Anything not mentioned under inclusions",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Srinagar | Transfer to Sonmarg – The Meadow of Gold",
        detail:
          "Your journey begins with a warm welcome at Srinagar Airport, followed by a scenic drive to the breathtaking landscapes of Sonmarg, fondly known as the “Meadow of Gold.” As you travel alongside the Sindh River with snow-draped peaks in the backdrop, the beauty of Kashmir unfolds gradually. Upon arrival, check into Rosewood Hotel Sonmarg / Similar, your peaceful alpine retreat. After settling in, enjoy leisure time to acclimatize and absorb the serene surroundings at your own pace. Today there will be 02 Pick-Up arranged one at 12 PM and second at 04 PM. In the evening, indulge in a wholesome dinner freshly prepared by our dedicated Maharaj, ensuring authentic flavors, purity, and personalized care in every dish. Overnight at Sonmarg."
      },
      {
        day: 2,
        title:
          "Sonmarg | Snow Adventures & Glacier Views",
        detail:
          "Wake up to crisp mountain air and a nourishing breakfast prepared by our Maharaj. Today, you may opt for an excursion to Zero Point and the magnificent Thajiwas Glacier, where sparkling snowfields and dramatic Himalayan views create unforgettable moments. Enjoy snow activities at your own cost or simply relax amidst the pristine scenery. A freshly prepared lunch and dinner by our Maharaj will be served at the hotel, maintaining consistent taste, hygiene, and comfort throughout your stay. Overnight at Sonmarg. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 3,
        title:
          "Sonmarg to Gulmarg | Into the Valley of Meadows",
        detail:
          "After a hearty breakfast prepared by our Maharaj, complete your check-out formalities and proceed to Gulmarg (approx. 4–5 hours). Known for its expansive meadows and snow-covered landscapes, Gulmarg offers a perfect blend of adventure and tranquillity. Upon arrival, check into Rosewood Hotel Gulmarg or similar. Relish a freshly cooked lunch and dinner, thoughtfully curated by our Maharaj to ensure consistency in quality and dietary preferences. Overnight at Gulmarg."
      },
      {
        day: 4,
        title:
          "Gulmarg | Gondola Experience & Alpine Charm",
        detail:
          "Begin your day with a fulfilling breakfast prepared under the supervision of our Maharaj. Proceed to experience the iconic Gulmarg Gondola Ride (Phase 1 included – Strictly Subject to Availability), offering breathtaking panoramic views of the Himalayas. Post lunch (freshly prepared by our Maharaj), enjoy leisure time for local exploration, scenic walks, the golf course, St Mary’s Church, Maharani Temple, Strawberry Valley or simply unwinding amidst nature. Dinner will once again be served with warmth and authenticity at the hotel. Overnight at Gulmarg."
      },
      {
        day: 5,
        title:
          "Gulmarg to Srinagar | Mughal Grandeur & Shikara Serenity",
        detail:
          "After breakfast prepared by our Maharaj, check out and proceed to Srinagar (approx. 2 hours by drive). Upon arrival and hotel check-in at Ennco Resort Srinagar/similar, enjoy a delicious Maharaj-prepared lunch. Later, explore the famous Mughal Gardens — Nishat Bagh and Shalimar Bagh — followed by a serene Shikara ride on Dal Lake (04 guests per boat), where reflections of the mountains create postcard-perfect memories. Dinner, freshly prepared by our Maharaj, will be served at the resort. Overnight at Srinagar."
      },
      {
        day: 6,
        title:
          "Excursion to Doodhpathri | Valley of Meadows",
        detail:
          "After breakfast prepared by our Maharaj, proceed for a full-day excursion to Doodhpathri, one of Kashmir’s hidden gems known for its lush green meadows and flowing streams. Due to the extended travel time, a packed lunch prepared by our Maharaj will be arranged, with the possibility of a live picnic-style meal amidst nature (subject to feasibility & group size). Return to Srinagar by evening for a comforting Maharaj-prepared dinner. Overnight at Srinagar."
      },
      {
        day: 7,
        title:
          "Srinagar to Pahalgam | Orchards & Riverside Beauty (2 Hrs/91Km)",
        detail:
          "Enjoy breakfast prepared by our Maharaj before checking out and proceeding to Pahalgam. En route, visit saffron fields, apple orchards, and a traditional bat factory — offering cultural insights into the region. Upon arrival, check into Eden Hotel Pahalgam / Similar and enjoy a freshly prepared lunch. Spend the evening relaxing in the serene surroundings before savoring a wholesome dinner prepared by our Maharaj. Overnight at Pahalgam."
      },
      {
        day: 8,
        title:
          "Pahalgam | Scenic Valleys & Leisure",
        detail:
          "Start your day with a nourishing breakfast prepared by our Maharaj. Proceed to explore the stunning A, B, and C Valleys, known for their breathtaking landscapes and cinematic beauty. Pony rides are available at own cost. Return to the hotel for lunch prepared by our Maharaj, followed by leisure time for shopping and exploration. Conclude the day with a carefully curated dinner prepared with purity and consistency. Overnight at Pahalgam."
      },
      {
        day: 9,
        title:
          "Departure | Memories to Cherish",
        detail:
          "After your final breakfast prepared by our Maharaj, complete check-out formalities and proceed to Srinagar Airport for your onwards journey. Today there will be 02 pick-ups arranged, one at 09 AM and the second at 12 PM. You depart with cherished memories of Kashmir’s landscapes — and the comfort of having enjoyed pure, freshly prepared meals throughout your journey, ensuring a seamless and worry-free travel experience."
      },
    ],

    overview: "Experience Kashmir with the comfort of assured pure vegetarian dining throughout your journey. This thoughtfully curated 8-night grand circuit ensures that every meal is freshly prepared with care, maintaining consistency, hygiene, and authentic flavors—allowing you to travel worry-free while enjoying the region’s breathtaking beauty. Your journey unfolds across Kashmir’s most iconic destinations — Sonmarg, Gulmarg, Srinagar, and Pahalgam. From the snow-kissed landscapes of Sonmarg and the alpine charm of Gulmarg to the serene Shikara ride on Dal Lake and the Mughal elegance of Shalimar Bagh and Nishat Bagh, each day reveals a new postcard-perfect experience. Explore the lush meadows of Doodhpathri, take in glacier views, wander through fragrant saffron fields, and breathe in the crisp mountain air of Pahalgam’s scenic valleys — all at a relaxed and well-balanced pace with two nights in each destination. With seamless transfers, handpicked stays, and immersive sightseeing, this journey is designed for families and groups seeking the timeless beauty of Kashmir while enjoying the reassurance of pure vegetarian meals and carefully curated travel experiences. More than a holiday, this is Kashmir experienced with comfort, care, and complete peace of mind."
  },
  // ================= Singapore & Malaysia =================
  {
    id: "malaysia-001",
    slug: "unbeatable-malaysia-city-highlands-theme-park",
    destination: "Malaysia",
    title: "Unbeatable Malaysia - City, Highlands & Theme Park",
    duration: "3 Nights 4 Days",
    route: "3N Kuala Lumpur",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Ahmedabad", "Joining Direct"],
    availableDate: ["Jun 2026"],
    stars: 4,
    price: 59999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [kualaLumpur],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Phu Quoc", to: "Da Nang", type: "Direct or 1 Stop" }
    // ],

    hotels: [
      { location: "Kuala Lumpur", nights: "3 Nights", type: "Regalia Upper View Hotel or similar - 4 Star Hotel" },

    ],

    sightseeing: [
      { title: "Kuala Lumpur Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Sharing" },
      { from: "Hotel", to: "Airport", type: "Sharing" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Kuala Lumpur City Tour + KL Tower Observation Deck",
      "Sunway Lagoon Night Park Experience",
      "Genting Highlands Day Tour + 2-Way Cable Car",
      "Batu Caves Photo Stop (Enroute)",
      "Putrajaya Scenic Drive (Arrival Day)",
      "Immersify Kuala Lumpur Experience",
      "Shopping at Berjaya Times Square",
      "Meals Included (Breakfast + Lunch + Dinner)",
      "SIC Coach Transfers (Private Upgrade Available)",
    ],

    exclusions: [
      "Passport fees, immunization costs, city taxes at the hotel and local departure taxes (wherever applicable)",
      "Optional enhancements like room or flight upgrades, or local camera or video fees",
      "Additional sightseeing, activities and experiences outside of the itinerary",
      "Early check-in or late check-out from hotels (unless otherwise specified)",
      "Breakfast, lunches, dinners and drinks (alcoholic and non-alcoholic), unless specified in the itinerary",
      "Any international and/or domestic flights, unless explicitly mentioned as an inclusion",
      "Excess baggage charges, and where applicable, baggage not included in your fare",
      "Tips for services and experiences",
      "Any Visa required, unless mentioned as an inclusion",
      "Read useful information and terms for more on what is included and excluded",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Kuala Lumpur with Putrajaya Tour Enroute and Sunway Lagoon Night Park",
        detail:
          "Arrive in Kuala Lumpur and begin your journey with a comfortable transfer. Start with breakfast (subject to flight timing), allowing you to relax and refresh after your arrival. Post breakfast, proceed for a scenic drive through Putrajaya, known for its beautiful bridges and modern architecture, offering a calm and visually stunning introduction to Malaysia. Continue towards Kuala Lumpur, enjoy lunch, and complete your hotel check-in. In the evening, head out for a thrilling experience at Sunway Lagoon Night Park, before returning to the hotel after dinner. Smooth arrival with a well-palnned"
      },
      {
        day: 2,
        title:
          "Visit to Genting Highlands with enroute to Batu Caves",
        detail:
          "After breakfast depart for Genting Highlands. Enroute we make a short (as per inclusion) photo stop at Batu Caves - Batu Caves is a limestone hill, which has a series of caves and cave temples, and it is the shrine of Lord Murugah, a Hindu deity. Later, continue drive to Genting Skyway Lower Station to board a cable car to the peak, the journey takes approximately 15 minutes (cable car operation is subject to weather condition). Genting Highlands, located at 2000 meters above sea level, offers a cool respite from Malaysia's capital city combined with all of the excitement, luxury, and entertainment of an international resort destination. After fun filled day we return back to our hotel in Kuala Lumpur."
      },
      {
        day: 3,
        title:
          "Kuala Lumpur City Tour with KL Tower Observaton deck and Immersify Experience",
        detail:
          "Post breakfast, explore Kuala Lumpur’s key landmarks including the Petronas Twin Towers (photo stop), National Mosque, King’s Palace, and Independence Square. The highlight of the day is the KL Tower Observation Deck, offering sweeping views of the city skyline. After lunch, spend time shopping at Berjaya Times Square before concluding the day with dinner and return to the hotel. City, culture, skyline, and shopping in one seamless day."
      },
      {
        day: 4,
        title:
          "Departure from Kuala Lumpur",
        detail:
          "After breakfast, check out from the hotel and spend your morning exploring Kuala Lumpur at your own pace. You can enjoy last-minute shopping at nearby markets or malls, picking up souvenirs and local finds. Later, proceed to the airport for your departure. Relaxed, stress-free ending to the trip."
      },

    ],

    overview: "Discover Kuala Lumpur in a perfectly curated 4-day getaway combining city landmarks, highland escapes, and theme park excitement. From the skyline views at KL Tower to the thrilling Sunway Lagoon and scenic Genting Highlands, this itinerary offers a complete Malaysia experience with meals, guided tours, and seamless travel planning"
  },
  {
    id: "malaysia-002",
    slug: "astonishing-malaysia",
    destination: "Malaysia",
    title: "Astonishing Malaysia",
    duration: "4 Nights 5 Days",
    route: "1N Genting | 3N Kuala Lumpur",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Ahmedabad", "Joining Direct"],
    availableDate: ["Jun 2026"],
    stars: 4,
    price: 68999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [genting,kualaLumpur],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Phu Quoc", to: "Da Nang", type: "Direct or 1 Stop" }
    // ],

    hotels: [
      { location: "Genting", nights: "1 Nights", type: "Resorts World Genting - First World Hotel or similar - 3 Star Hotel" },
      { location: "Kuala Lumpur", nights: "3 Nights", type: "Regalia Upper View Hotel or similar - 4 Star Hotel" },

    ],

    sightseeing: [
      { title: "Genting Sightseeing" },
      { title: "Kuala Lumpur Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "1 Night Stay in Genting Highlands (Inside Resort World)",
      "Batu Caves Visit (Enroute Cultural Experience)",
      "Indian Lunch + Buffet Dinner in Genting",
      "Kuala Lumpur City Tour + KL Tower Observation Deck",
      "Sunway Lagoon – 6 Theme Parks Access",
      "Daily Meals / Meal Coupons Included",
      "Stay in Central Kuala Lumpur (Chinatown Area)",
      "Private Transfers Throughout",
    ],

    exclusions: [
      "Airfare",
      "Visa",
      "Travel Insurance",
      "Personal Expenses",
      "Optional Activities",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival | Putrajaya Drive | Genting Highlands Stay",
        detail:
          "Arrive in Kuala Lumpur and begin your journey with a comfortable private transfer. Enroute to Genting Highlands, enjoy a scenic drive through Putrajaya, Malaysia’s administrative capital known for its stunning architecture, lakes, and iconic bridges. This serves as a relaxing introduction to Malaysia after your flight. Continue your journey towards the cool hills of Genting Highlands. On arrival: Check-in to your hotel; Enjoy the Cable Car ride, have delicious Lunch at Indian Restaurant in Genting; Relax or explore the vibrant Genting complex In the evening: Explore indoor attractions, cafes, and entertainment zones; & End your day with a Buffet Dinner in Genting Highlands Easy arrival + no rush + smooth start to the trip "
      },
      {
        day: 2,
        title:
          "Genting to Kuala Lumpur | Batu Caves Enroute",
        detail:
          "After breakfast, enjoy some free time in Genting before check-out. Proceed towards Kuala Lumpur. Enroute, stop at the iconic Batu Caves: 30–45 minute visit; Explore the famous limestone caves and temple, One of Malaysia’s most photographed cultural landmarks; Continue your journey to Kuala Lumpur. On arrival: Hotel check-in; Relax or explore nearby areas like Chinatown / Bukit Bintang Meals included: Lunch & Dinner at a Local Indian Restaurant Smart routing – no backtracking, smooth cultural add-on"
      },
      {
        day: 3,
        title:
          "Kuala Lumpur City Tour + Skyline Experience",
        detail:
          "After breakfast, proceed for a guided Kuala Lumpur city tour. Explore: Petronas Twin Towers (Photo Stop); Merdeka Square; National Mosque; King’s Palace & National Monument Highlight of the day: KL Tower Observation Deck Experience - Enjoy breathtaking 360° views of Kuala Lumpur skyline Meals included: Lunch & Dinner at a Local Indian Restaurant City, culture, and skyline all in one day"
      },
      {
        day: 4,
        title:
          "Sunway Lagoon Theme Park (Full Day Experience)",
        detail:
          "After breakfast, head out for a full-day adventure at Sunway Lagoon Theme Park. Enjoy access to: Water Park, Amusement Park, Wildlife Park, Extreme Park, & Scream Park Includes: Theme Park Entry with Meal Coupon (30 MYR inside park) & Dinner Coupon at a local Indian Restaurant Return to hotel in the evening. High-energy, family-friendly highlight of the trip"
      },
      {
        day: 5,
        title:
          "Departure | Free Time",
        detail:
          "After breakfast, check out from the hotel. Depending on your flight timing: Enjoy some free time for shopping or exploring Kuala Lumpur Later, transfer to the airport for your departure. Relaxed and well-paced ending Meals included: Lunch at a Local Indian Restaurant"
      },

    ],

    overview: "Discover Malaysia like never before with a unique combination of Genting Highlands and Kuala Lumpur. Experience the cool mountain vibes of Genting with an overnight stay, followed by the vibrant city life of Kuala Lumpur, iconic landmarks, and thrilling theme park adventures. Designed for comfort and ease, this package is perfect for families, couples, and first-time international travellers."
  },
  {
    id: "malaysia-003",
    slug: "malaysian-extravaganza-city-lights-highlands-island-escape",
    destination: "Malaysia",
    title: "Malaysian Extravaganza - City Lights, Highlands & Island Escape",
    duration: "5 Nights 6 Days",
    route: "3N Kuala Lumpur | 2N Langkwai",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Ahmedabad", "Joining Direct"],
    availableDate: ["Jun 2026"],
    stars: 4,
    price: 87999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [kualaLumpur,langkawi],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Kuala Lumpur", to: "Langkwai", type: "Direct or 1 Stop" },
      { from: "Langkwai", to: "Kuala Lumpur", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "Kuala Lumpur", nights: "3 Nights", type: "Regalia Upper View Hotel or similar - 4 Star Hotel" },
      { location: "Langkwai", nights: "2 Nights", type: "Bayview Hotel Langkawi or similar - 4 Star Hotel" },

    ],

    sightseeing: [
      { title: "Kuala Lumpur Sightseeing" },
      { title: "Langkwai Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Kuala Lumpur City Tour with KL Tower Observation Deck",
      "Sunway Lagoon Night Park Experience",
      "Genting Highlands Tour with 2-Way Cable Car",
      "Batu Caves Visit (60-minute cultural experience)",
      "Putrajaya Scenic Drive (Arrival Experience)",
      "Immersify Kuala Lumpur Interactive Experience",
      "Shopping at Berjaya Times Square",
      "Sunset Dinner Cruise in Langkawi",
      "Langkawi Cable Car & SkyBridge Experience",
      "SkyDome, SkyRex & 3D Art Museum",
      "Meals Included (Breakfast + Lunch + Dinner as per itinerary)",
      "Seamless Transfers & Guided Tours",
    ],

    exclusions: [
      "Airfare",
      "Visa",
      "Travel Insurance",
      "Personal Expenses",
      "Optional Activities",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Kuala Lumpur with Putrajaya Tour Enroute and Sunway Lagoon Night Park",
        detail:
          "Arrive in Kuala Lumpur and begin your journey with a comfortable transfer. Start with breakfast (subject to flight timing), allowing you to relax and refresh after your arrival. Post breakfast, proceed for a scenic drive through Putrajaya, known for its beautiful bridges and modern architecture, offering a calm and visually stunning introduction to Malaysia. Continue towards Kuala Lumpur, enjoy lunch, and complete your hotel check-in. In the evening, head out for a thrilling experience at Sunway Lagoon Night Park, before returning to the hotel after dinner. Smooth arrival with a well-paced start to the trip (Breakfast, Lunch and Dinner) "
      },
      {
        day: 2,
        title:
          "Visit to Genting Highlands with enroute to Batu Caves",
        detail:
          "After breakfast, proceed for a full-day excursion to Genting Highlands. Enroute, stop at the iconic Batu Caves for a 60-minute visit. This limestone hill, estimated to be over 400 million years old, is one of Malaysia’s most important Hindu pilgrimage sites and is famous for its towering golden statue of Lord Murugan and the colorful staircase leading up to the cave temple. Continue your journey towards Genting Highlands and experience the scenic two-way cable car ride, offering panoramic views of the lush rainforest below. On arrival, enjoy lunch and spend time exploring Genting’s vibrant entertainment hub, including indoor attractions, cafes, and leisure spaces. By evening, return to Kuala Lumpur for dinner and overnight stay. Culture, nature, and iconic Malaysia experiences in one seamless day. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 3,
        title:
          "Kuala Lumpur City Tour with KL Tower Observaton deck and Immersify Experience",
        detail:
          "Post breakfast, explore Kuala Lumpur’s key landmarks including the Petronas Twin Towers (photo stop), National Mosque, King’s Palace, and Independence Square. The highlight of the day is the KL Tower Observation Deck, offering sweeping views of the city skyline. After lunch, spend time shopping at Berjaya Times Square before concluding the day with dinner and return to the hotel. City, culture, skyline, and shopping in one seamless day. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 4,
        title:
          "Checkout from hotel at Kuala Lumpur and fly to Langkawi with Sunset Dinner Cruise",
        detail:
          "After breakfast, check out from your hotel and proceed to the airport for your flight to Langkawi. Upon arrival, transfer to your hotel and complete check-in. Later in the evening, experience one of the highlights of Langkawi — a Sunset Dinner Cruise. Sail across the Andaman Sea while enjoying beautiful sunset views, light music, and a relaxed dining experience onboard. From city to island – slow down, unwind, and elevate the experience (Breakfast, Lunch and Dinner)"
      },
      {
        day: 5,
        title:
          "Langkawi Island Tour with Cable Car and SkyBridge",
        detail:
          "After breakfast, proceed for a full-day exploration of Langkawi. Discover the island’s scenic beauty and key attractions as you explore its coastal landscapes and cultural highlights. The highlight of the day is the Langkawi Cable Car (SkyCab) experience, taking you up to one of the highest peaks on the island. From here, enjoy breathtaking panoramic views of the surrounding islands and rainforest. Continue to the iconic SkyBridge, a curved suspension bridge offering one of the most stunning viewpoints in Langkawi. Your experience also includes visits to attractions like SkyDome, SkyRex, and the 3D Art Museum, adding a fun and interactive dimension to the day. Enjoy lunch and dinner as per itinerary before returning to your hotel. Nature, views, and one of Malaysia’s most iconic experiences. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 6,
        title:
          "Departure from Langkwai and Fly back Home",
        detail:
          "After breakfast, check out from your hotel and proceed to the airport for your onward journey. Simple, relaxed, and hassle-free departure. (Breakfast)"
      },

    ],

    overview: "Discover Malaysia through a perfectly curated journey that blends vibrant city life, scenic highlands, and tropical island relaxation. This 7-day experience takes you through the best of Kuala Lumpur with its iconic skyline and cultural landmarks, the cool entertainment hub of Genting Highlands, and the breathtaking island landscapes of Langkawi. From thrilling theme parks and cable car rides to immersive city experiences and a sunset cruise across the Andaman Sea, every day is designed to offer a balance of exploration, comfort, and memorable moments. With meals, guided tours, and seamless transfers included, this is a complete and hassle-free international holiday ideal for families, couples, and first-time travellers."
  },
  {
    id: "singapore&malaysia-001",
    slug: "signature-kuala-lumpur-with-singapore",
    destination: "Malaysia",
    title: "Signature Kuala Lumpur with Singapore",
    duration: "6 Nights 7 Days",
    route: "3N Kuala Lumpur | 2N Singapore",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Ahmedabad", "Joining Direct"],
    availableDate: ["Jun 2026"],
    stars: 4,
    price: 129999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [kualaLumpur,singapore],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Singapore", to: "Kuala Lumpur", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "Kuala Lumpur", nights: "3 Nights", type: "Regalia Upper View Hotel or similar - 4 Star Hotel" },
      { location: "Singapore", nights: "2 Nights", type: "ibis Styles Singapore Albert or similar - 4 Star Hotel" },

    ],

    sightseeing: [
      { title: "Kuala Lumpur Sightseeing" },
      { title: "Singapore Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Kuala Lumpur city tour with KL Tower Observation Deck",
      "Full-day Genting Highlands experience with scenic cable car ride",
      "Visit the iconic Batu Caves",
      "Sunway Lagoon Night Park experience",
      "Overland journey from Malaysia to Singapore",
      "Gardens by the Bay (Cloud Forest + Flower Dome) with Jurassic World exhibition",
      "Singapore City Tour With Marina Bay Sands Observation Deck",
      "Sentosa Island with cable car ride & Wings of Time show",
      "Universal Studios Singapore full-day access",
      "Madame Tussauds Singapore (5-in-1 experience)",
    ],

    exclusions: [
      "Airfare",
      "Visa",
      "Travel Insurance",
      "Personal Expenses",
      "Optional Activities",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Kuala Lumpur with Putrajaya Tour Enroute and Sunway Lagoon Night Park",
        detail:
          "Arrive in Kuala Lumpur and begin your journey with a comfortable private transfer to the city. En route, make a scenic 60-minute photo stop at Putrajaya, Malaysia’s administrative capital, known for its stunning architecture, beautiful bridges, and iconic landmarks — perfect for capturing your first memories of the trip. Continue onward to your hotel and check in. In the evening, head out for an exciting visit to Sunway Lagoon Night Park, where vibrant lights, themed zones, and lively entertainment set the tone for your holiday."
      },
      {
        day: 2,
        title:
          "Genting Highlands with Cable Car & Batu Caves (60mins)",
        detail:
          "After breakfast, head out for a full-day excursion to Genting Highlands. En route, stop at the iconic Batu Caves, a significant cultural and religious landmark. Continue your journey to Genting and take a scenic cable car ride up the mountains, where cooler weather and entertainment options await. Enjoy your day exploring before returning to Kuala Lumpur."
      },
      {
        day: 3,
        title:
          "Kuala Lumpur City Highlights",
        detail:
          "Today, explore the best of Kuala Lumpur on a guided city tour. Visit key landmarks and enjoy panoramic views from the KL Tower Observation Deck. Discover the city's blend of modern architecture and cultural heritage as you move through its iconic attractions."
      },
      {
        day: 4,
        title:
          "Journey to Singapore & Gardens by the Bay",
        detail:
          "After breakfast, transfer to the coach terminal and begin your overland journey to Singapore. Upon arrival, transfer to your hotel and later visit the spectacular Gardens by the Bay, including the Cloud Forest and Flower Dome, enhanced by the immersive Jurassic World exhibition."
      },
      {
        day: 5,
        title:
          "Singapore City Tour, Marina Bay Sands SkyPark & Sentosa Island Experience",
        detail:
          "Begin your day with a guided Singapore city tour, exploring the city’s iconic landmarks and vibrant neighborhoods. The highlight of your morning is a visit to the Marina Bay Sands Observation Deck, where you’ll enjoy breathtaking panoramic views of Singapore’s skyline — a perfect introduction to the city’s futuristic charm. In the afternoon, continue to Sentosa Island for an immersive entertainment experience. Enjoy a scenic cable car ride offering stunning aerial views, followed by a visit to Madame Tussauds Singapore with its engaging 5-in-1 attractions, including interactive exhibits and experiences. As the day winds down, witness the spectacular Wings of Time show — a mesmerizing outdoor night show set against the open sea."
      },
      {
        day: 6,
        title:
          "Full Day Universal Studios Tour",
        detail:
          "Spend the day at Universal Studios Singapore, where movie-themed rides, shows, and attractions bring Hollywood magic to life. From thrilling roller coasters to immersive zones, this is a highlight for both families and adventure seekers."
      },
      {
        day: 7,
        title:
          "Departure from Singapore",
        detail:
          "After breakfast, check out and enjoy a comfortable private transfer to the airport for your onward journey, taking back wonderful memories from two incredible destinations. Stop over in Kuala Lumpur"
      },
    ],

    overview: "Step into a perfectly curated Southeast Asia escape that blends the vibrant energy of Kuala Lumpur with the futuristic charm of Singapore. From iconic skyline views and cultural landmarks to thrilling theme parks and world-class attractions, this journey delivers a complete holiday experience. Begin in Kuala Lumpur, where modern cityscapes meet cultural heritage. Explore the buzzing city, visit the majestic Batu Caves, and escape to the cool highlands of Genting. Then continue your journey overland into Singapore — a city that redefines urban experiences with attractions like Gardens by the Bay, Sentosa Island, and Universal Studios. Designed for first-time travellers, couples, and families, this itinerary balances sightseeing, leisure, and entertainment — all with private transfers and seamless logistics for a stress-free premium holiday."
  },
  {
    id: "singapore&malaysia-002",
    slug: "unbelievable-singapore-and-malaysia",
    destination: "Singapore",
    title: "Unbelievable Singapore and Malaysia",
    duration: "6 Nights 7 Days",
    route: "3N Singapore | 3N Kuala Lumpur",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026"],
    stars: 4,
    price: 144999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [singapore,kualaLumpur],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Into Singapore", to: "Out of Kuala Lumpur", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "Singapore", nights: "3 Nights", type: "ibis Styles Singapore Albert or similar - 4 Star Hotel" },
      { location: "Kuala Lumpur", nights: "3 Nights", type: "Regalia Upper View Hotel or similar - 4 Star Hotel" },

    ],

    sightseeing: [
      { title: "Singapore Sightseeing" },
      { title: "Kuala Lumpur Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Return Economy Class Airfare (up to 1 stopover)",
      "06 nights’ accommodation in Singapore and Malaysia",
      "Private Transfer from the Singapore Airport to the Hotel",
      "All sightseeing and transfers are on shared transport.",
      "Daily Continental Breakfast, Indian Veg/Non-Veg Lunch and Dinner",
      "All sightseeing as mentioned in the itinerary and all the entry fees, including:",
      "City Tour in Singapore (Little India, Merlion Statue, Chinatown, Sri Mariamman Temple, Esplanade)",
      "Gardens by the Bay (Cloud Forest, Flower Dome, Light & Sound Show)",
      "River Cruise (Bum Boat Ride along Singapore River)",
      "Marina Bay Sands Sky Park Observation Deck",
      "Sentosa Island Tour (Cable Car, Madame Tussauds 5-in-1, Wings of Time)",
      "Full Day at Universal Studios Singapore (7 themed areas, thrilling rides)",
      "Putrajaya orientation tour with photo-stop (National Mosque, Putra Bridge, Green Spaces, Official Government Buildings)",
      "Kuala Lumpur City Tour (National Mosque, King's Palace, Sultan Abdul Samad Building, Merdeka Square, Menara KL Tower)",
      "Batu Caves and Genting Highlands Tour (Cable Car, Batu Caves photo stop, Skyway Ride)",
      "Services of an English/Hindi Speaking Tour Manager",
      "Travel Insurance for passengers up to 69 years",
      "Inclusive of Singapore Tourist Visa (Single-entry)",
    ],

    exclusions: [
      "Any increase in Airfare, Visa fees, Airport taxes, Govt Taxes, Fuel Surcharges and any applicability of new taxes from Govt.",
      "Any up gradation in Airline class or hotel room category Cost of Air ticket deviation charges.",
      "Any Increase in the rate of exchange leading to an increase in all land arrangements which may come in to effect prior to departure.",
      "Cost of pre or post tour hotel accommodation.",
      "Any extra expense such as route change, Airline change, Date change, Accommodation facilities, etc incurred due to the unforeseen, unavoidable forced majeuere circumstances during the tour.",
      "Porterage, laundry, telephone charges, shopping, wines & alcoholic beverages, items of personal nature and food or drink which is not part of a set group menu.",
      "Any extra cost incurred on behalf of an individual due to illness, accident, hospitalization, or any personal emergency.",
      "Any services or activity charges other than those included in the group tour itinerary.",
      "In case a passenger is opting for direct joining, the cost for airport transfers shall be borne directly by the passenger and will join the group at the hotel.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival In Singapore – City Tour, Marina Bay, Gardens By The Bay",
        detail:
          "Upon arrival at Singapore International Airport, complete the necessary immigration and customs procedures. Afterward, board the coach for your Singapore city tour.(En-route Breakfast at Indian Resturant – Depending on Flight Arrival) The tour will take you through key spots like Little India, the iconic Merlion statue, scenic views of the Singapore River, the vibrant streets of Chinatown, the historic Sri Mariamman Temple, and the architectural marvel of the Esplanade. - The journey continues to the Marina Bay Sands Sky Park Observation Deck, an architectural wonder featuring three interconnected 55-storey towers. From the deck, enjoy panoramic, bird’s-eye views of Singapore’s skyline and the South China Sea, perfect for capturing stunning photographs. - At 2:00 PM, enjoy a delicious buffet lunch at a local Indian restaurant, followed by hotel check-in. - In the evening, visit the renowned Gardens by the Bay, where you'll explore the mesmerizing Cloud Forest and admire the towering Super Trees. The Cloud Forest features a towering indoor waterfall and a misty environment filled with exotic plants, offering a unique, cool atmosphere that mimics tropical mountain climates. The Super Trees are futuristic, towering structures that light up at night, featuring vertical gardens and offering stunning views. These iconic tree-like sculptures also provide a captivating light and sound show after sunset. - Cap off your day with dinner at an Indian restaurant before heading back to your hotel for a relaxing overnight stay. - (Breakfast, Lunch, and Dinner) "
      },
      {
        day: 2,
        title:
          "Afternoon Sentosa Island Tour (Including Cable Car, Madame Tussauds And Wings Of Time)",
        detail:
          "Enjoy a buffet breakfast at the hotel, with the morning free for personal activities. After a buffet lunch, embark on a Sentosa Island tour. Sentosa is a paradise for adventure and leisure, offering world-class attractions from sandy beaches to thrilling rides and cultural experiences. You’ll reach the island via a scenic cable car ride. - During the tour, take a relaxing break to enjoy High Tea & Snacks in Sentosa( Tea/Coffee & Samosa), where you can unwind and savor delightful refreshments before continuing your adventure. - (Breakfast, Lunch, Dinner, and High Tea & Snacks in Sentosa)"
      },
      {
        day: 3,
        title:
          "Full Day Universal Studios, & Singapore River Cruise",
        detail:
          "Start your day with a buffet breakfast at the hotel, then head to Universal Studios Singapore with an SGD20 lunch coupon. Dive into action-packed adventures, where you’ll experience the magic of movies firsthand, from battling villains in Sci-Fi City to meeting beloved characters in Far Far Away. - Explore the seven themed areas inspired by popular films, with thrilling rides like the Mummy’s Curse in Ancient Egypt, the Madagascar Boat Ride, and Shrek’s Adventure. With 24 thrilling rides, Universal Studios Singapore offers a cinematic adventure for everyone. - Following this, indulge in a peaceful River Cruise along the Singapore River. Enjoy a scenic Bum Boat Ride, taking in breathtaking views of iconic landmarks like Marina Bay Sands, Clarke Quay, and the Esplanade. - Cap off your day with dinner at an Indian restaurant before heading back to your hotel for a relaxing overnight stay. - (Breakfast, Lunch, and Dinner) "
      },
      {
        day: 4,
        title:
          "Transfer From Singapore To Kuala Lumpur – En-route Putrajaya Tour",
        detail:
          "After breakfast / packed breakfast, gather in the lobby and transfer at 9:00 am to the Coach Station for Kuala Lumpur. - En route, visit Putrajaya, an expansive complex spanning 11,000 acres within the Multimedia Super Corridor. Named after Malaysia's first Prime Minister, Tunku Abdul Rahman Putra, it lies 25 kilometers from Kuala Lumpur's City Centre. Known as the Garden City, Putrajaya features abundant green spaces and 13 distinct gardens, centered around a large man-made lake. It serves as the official residence of the Malaysian Prime Minister and is a significant tourist destination, showcasing Malaysia's modern infrastructure and facilities. - In the evening, check in at the hotel, followed by dinner at an Indian restaurant. Stay overnight in Kuala Lumpur. - (Breakfast, Lunch, and Dinner) - 'Please note that due to new regulations, traveling from Singapore to Malaysia now requires two separate vehicles. A Singapore-registered vehicle will take passengers from their hotel in Singapore to the border's immigration checkpoint. After clearing immigration, a Malaysia-registered vehicle will continue the journey to the hotel in Malaysia. Under the new rules, only Singapore-registered cars can pick up guests from hotels in Singapore'."
      },
      {
        day: 5,
        title:
          "Full Day Genting Highlands Tour With Batu Caves",
        detail:
          "Start your day with an early breakfast at your hotel in Kuala Lumpur. After breakfast, embark on a journey to Genting Highlands. Along the way to Genting Highlands, make a stop at Batu Caves, a series of limestone caves and cave temples located just outside of Kuala Lumpur. - Continue your journey to Genting Highlands, upon arrival, enjoy the cool mountain air and breathtaking views of the surrounding landscapes. Spend the day exploring the attractions and entertainment options at Genting Highlands. Take a ride on the Genting Skyway cable car, which offers panoramic views of the mountains and forests below (subject to weather conditions and maintenance schedules). - Enjoy a delicious lunch at one of the restaurants or food outlets in Genting Highlands. After a full day of fun and adventure at Genting Highlands, return to Kuala Lumpur in the late afternoon or evening. - Upon returning, indulge in a delicious Indian dinner at a local restaurant. After dinner, return to your hotel in Kuala Lumpur for a restful overnight stay, reflecting on the day's memorable experiences. - (Breakfast, Lunch and Dinner)"
      },
      {
        day: 6,
        title:
          "Kuala Lumpur City Tour With Kl Tower",
        detail:
          "Start your day with a delicious American breakfast at your hotel, fueling up for a day of exploration ahead. After breakfast, embark on an exciting city tour of Kuala Lumpur. You'll be taken to some of the most iconic landmarks and attractions that the city has to offer. Visit the observatory deck at the Menara Kuala Lumpur Tower, enjoy the panoramic views of the Kuala Lumpur skyline from the observation deck, which offers stunning vistas of the city and its surrounding landscape. - Explore the beautiful National Mosque, a symbol of Islamic architecture and an important religious site in Malaysia. Visit, Sultan Abdul Samad Building offers a glimpse into Malaysia's colonial past and architectural heritage. Proceed to one of Kuala Lumpur's most significant landmarks - Merdeka Square, rich in history and surrounded by iconic buildings. Then visit, The National Monument, is a significant landmark in Kuala Lumpur, Malaysia, honoring the country's fallen heroes. Later visit Art Gallery and KL Museum with entry tickets. - Visit, Railway Station, Railway administrations building, Cocoa House and Kings Place before your lunch and your also have some free time to shop on your own. Enjoy a delicious Indian dinner and head back to the hotel for an overnight stay. - (Breakfast, Lunch and Dinner)"
      },
      {
        day: 7,
        title:
          "Departure from Kuala Lumpur",
        detail:
          "Start your day with a buffet breakfast at the hotel. After checking out, we will transfer all luggage onto the coach. Enjoy a buffet lunch, depending on your flight schedule, before being transferred to Kuala Lumpur International Airport for your flight to Bangalore. - (Breakfast and Lunch – Depending on Flight Departure)"
      },
    ],

    overview: "Embark on a captivating 6-night journey through Singapore and Malaysia, where modern marvels meet rich cultural heritage. Start your adventure in Singapore with iconic attractions like the Gardens by the Bay, Universal Studios, and a scenic River Cruise along the Singapore River. Experience the vibrant Sentosa Island with thrilling cable car rides and world-class entertainment. Cross into Malaysia to explore the grandeur of Kuala Lumpur, from the towering KL Tower to the serene Batu Caves, and unwind in the cool highlands of Genting. Enjoy seamless transfers, guided city tours, delicious Indian meals, and comfortable stays, ensuring an unforgettable travel experience filled with excitement, exploration, and relaxation."
  },
  {
    id: "singapore&malaysia&thailand-001",
    slug: "asian-extravaganza",
    destination: "Singapore",
    title: "Asian Extravaganza",
    duration: "10 Nights 11 Days",
    route: "3N Singapore | 3N Kuala Lumpur | 2N Pattaya | 2N Bangkok",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026"],
    stars: 4,
    price: 174999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [singapore,kualaLumpur,pattaya,bangkok],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Into Singapore", to: "Out of Bangkok", type: "Direct or 1 Stop" },
      { from: "Kuala Lumpur", to: "Bangkok", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "Singapore", nights: "3 Nights", type: "ibis Styles Singapore Albert or similar - 4 Star Hotel" },
      { location: "Kuala Lumpur", nights: "3 Nights", type: "Regalia Upper View Hotel or similar - 4 Star Hotel" },
      { location: "Pattaya", nights: "2 Nights", type: "Centara Pattaya Hotel or similar - 4 Star Hotel" },
      { location: "Bangkok", nights: "2 Nights", type: "A-One Bangkok Hotel or similar - 4 Star Hotel" },

    ],

    sightseeing: [
      { title: "Singapore Sightseeing" },
      { title: "Kuala Lumpur Sightseeing" },
      { title: "Pattaya Sightseeing" },
      { title: "Bangkok Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Return Economy Class Airfare (upto 1 stop over)",
      "Internal flight from Kuala Lumpur to Bangkok",
      "10 Night’ Accommodation in All 4 Places",
      "Continental Breakfast and Indian Veg / Non Veg Lunch & Dinner",
      "All Transportation on shared basis",
      "City Tour of Singapore with Gardens by the Bay, Marina Bay sands & Sky park",
      "Sentosa Island (Cable Car + Madame Tussauds 5-in-1 + Wings of Time)",
      "Universal Studio Tour",
      "Kuala Lumpur City Tour",
      "Genting Highlands with Batu Caves",
      "Coral Island Tour",
      "Nong Nooch Village with Bus",
      "Bangkok City Tour with Golden Buddha and Marble Buddha + Mini Reclining Buddha",
      "Chao Phraya Dinner Cruise",
      "Safari World with Marine Park",
      "Services of an English Speaking Tour Manager",
      "Travel Insurance for passengers up to 69 years",
      "Inclusive of Singapore Tourist Visa (Single-entry)",
      "Daily 02 X 500ml Drinking water per head per day",
    ],

    exclusions: [
      "Any services not mentioned in the itinerary.",
      "Cost of USD 10000 granted by RBI under Basic travel Quota scheme.",
      "Porterage, laundry, wines, mineral water, telephone charges, optional tours and all items of personal nature and also food and drinks not forming part of the itinerary.",
      "Anything not specifically mentioned in the “tour price includes” column.",
      "Cost of deviation, in case you want to deviate from the group & Cost of optional tours.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival In Singapore – City Tour, Marina Bay, Gardens By The Bay",
        detail:
          "Upon arrival at Singapore International Airport, complete the necessary immigration and customs procedures. Afterward, board the coach for your Singapore city tour. (En-route Breakfast at Indian Resturant – Depending on Flight Arrival) The tour will take you through key spots like Little India, the iconic Merlion statue, scenic views of the Singapore River, the vibrant streets of Chinatown, the historic Sri Mariamman Temple, and the architectural marvel of the Esplanade. - The journey continues to the Marina Bay Sands Sky Park Observation Deck, an architectural wonder featuring three interconnected 55-storey towers. From the deck, enjoy panoramic, bird’s-eye views of Singapore’s skyline and the South China Sea, perfect for capturing stunning photographs. - At 2:00 PM, enjoy a delicious buffet lunch at a local Indian restaurant, followed by hotel check-in. - In the evening, visit the renowned Gardens by the Bay, where you'll explore the mesmerizing Cloud Forest and admire the towering Super Trees. The Cloud Forest features a towering indoor waterfall and a misty environment filled with exotic plants, offering a unique, cool atmosphere that mimics tropical mountain climates. The Super Trees are futuristic, towering structures that light up at night, featuring vertical gardens and offering stunning views. These iconic tree-like sculptures also provide a captivating light and sound show after sunset. - Cap off your day with dinner at an Indian restaurant before heading back to your hotel for a relaxing overnight stay. - (Breakfast, Lunch, and Dinner)"
      },
      {
        day: 2,
        title:
          "Afternoon Sentosa Island Tour (Including Cable Car, Madame Tussauds And Wings Of Time)",
        detail:
          "Enjoy a buffet breakfast at the hotel, with the morning free for personal activities. After a buffet lunch, embark on a Sentosa Island tour. Sentosa is a paradise for adventure and leisure, offering world-class attractions from sandy beaches to thrilling rides and cultural experiences. You’ll reach the island via a scenic cable car ride. - During the tour, take a relaxing break to enjoy High Tea & Snacks in Sentosa( Tea/Coffee & Samosa), where you can unwind and savor delightful refreshments before continuing your adventure. - (Breakfast, Lunch, Dinner, and High Tea & Snacks in Sentosa)"
      },
      {
        day: 3,
        title:
          "Full Day Universal Studios, & Singapore River Cruise",
        detail:
          "Start your day with a buffet breakfast at the hotel, then head to Universal Studios Singapore with an SGD20 lunch coupon. Dive into action-packed adventures, where you’ll experience the magic of movies firsthand, from battling villains in Sci-Fi City to meeting beloved characters in Far Far Away. - Explore the seven themed areas inspired by popular films, with thrilling rides like the Mummy’s Curse in Ancient Egypt, the Madagascar Boat Ride, and Shrek’s Adventure. With 24 thrilling rides, Universal Studios Singapore offers a cinematic adventure for everyone. - Following this, indulge in a peaceful River Cruise along the Singapore River. Enjoy a scenic Bum Boat Ride, taking in breathtaking views of iconic landmarks like Marina Bay Sands, Clarke Quay, and the Esplanade. - Cap off your day with dinner at an Indian restaurant before heading back to your hotel for a relaxing overnight stay. - (Breakfast, Lunch, and Dinner) "
      },
      {
        day: 4,
        title:
          "Transfer From Singapore To Kuala Lumpur – En-route Putrajaya Tour",
        detail:
          "After breakfast / packed breakfast, gather in the lobby and transfer at 9:00 am to the Coach Station for Kuala Lumpur. - En route, visit Putrajaya, an expansive complex spanning 11,000 acres within the Multimedia Super Corridor. Named after Malaysia's first Prime Minister, Tunku Abdul Rahman Putra, it lies 25 kilometers from Kuala Lumpur's City Centre. Known as the Garden City, Putrajaya features abundant green spaces and 13 distinct gardens, centered around a large man-made lake. It serves as the official residence of the Malaysian Prime Minister and is a significant tourist destination, showcasing Malaysia's modern infrastructure and facilities. - In the evening, check in at the hotel, followed by dinner at an Indian restaurant. Stay overnight in Kuala Lumpur. - (Breakfast, Lunch, and Dinner) - 'Please note that due to new regulations, traveling from Singapore to Malaysia now requires two separate vehicles. A Singapore-registered vehicle will take passengers from their hotel in Singapore to the border's immigration checkpoint. After clearing immigration, a Malaysia-registered vehicle will continue the journey to the hotel in Malaysia. Under the new rules, only Singapore-registered cars can pick up guests from hotels in Singapore'."
      },
      {
        day: 5,
        title:
          "Full Day Genting Highlands Tour With Batu Caves",
        detail:
          "Start your day with an early breakfast at your hotel in Kuala Lumpur. After breakfast, embark on a journey to Genting Highlands. Along the way to Genting Highlands, make a stop at Batu Caves, a series of limestone caves and cave temples located just outside of Kuala Lumpur. - Continue your journey to Genting Highlands, upon arrival, enjoy the cool mountain air and breathtaking views of the surrounding landscapes. Spend the day exploring the attractions and entertainment options at Genting Highlands. Take a ride on the Genting Skyway cable car, which offers panoramic views of the mountains and forests below (subject to weather conditions and maintenance schedules). - Enjoy a delicious lunch at one of the restaurants or food outlets in Genting Highlands. After a full day of fun and adventure at Genting Highlands, return to Kuala Lumpur in the late afternoon or evening. - Upon returning, indulge in a delicious Indian dinner at a local restaurant. After dinner, return to your hotel in Kuala Lumpur for a restful overnight stay, reflecting on the day's memorable experiences. - (Breakfast, Lunch and Dinner)"
      },
      {
        day: 6,
        title:
          "Kuala Lumpur City Tour With Kl Tower",
        detail:
          "Start your day with a delicious American breakfast at your hotel, fueling up for a day of exploration ahead. After breakfast, embark on an exciting city tour of Kuala Lumpur. You'll be taken to some of the most iconic landmarks and attractions that the city has to offer. Visit the observatory deck at the Menara Kuala Lumpur Tower, enjoy the panoramic views of the Kuala Lumpur skyline from the observation deck, which offers stunning vistas of the city and its surrounding landscape. - Explore the beautiful National Mosque, a symbol of Islamic architecture and an important religious site in Malaysia. Visit, Sultan Abdul Samad Building offers a glimpse into Malaysia's colonial past and architectural heritage. Proceed to one of Kuala Lumpur's most significant landmarks - Merdeka Square, rich in history and surrounded by iconic buildings. Then visit, The National Monument, is a significant landmark in Kuala Lumpur, Malaysia, honoring the country's fallen heroes. Later visit Art Gallery and KL Museum with entry tickets. - Visit, Railway Station, Railway administrations building, Cocoa House and Kings Place before your lunch and your also have some free time to shop on your own. Enjoy a delicious Indian dinner and head back to the hotel for an overnight stay. - (Breakfast, Lunch and Dinner)"
      },
      {
        day: 7,
        title:
          "Fly From Kuala Lumpur To Bangkok And Transfer To Pattaya With Alcazar Show",
        detail:
          "Enjoy a leisurely buffet breakfast at your hotel in Kuala Lumpur to start your day off right. Check out from your hotel in Kuala Lumpur and get transferred to the airport to catch your flight to Bangkok. - Arrive at Bangkok Airport (BKK/DMK) and meet your coach for the transfer to Pattaya City. Check into your hotel in Pattaya and freshen up after your journey. - In the evening, head to the Alcazar Show, one of Pattaya's most famous performances, known for its dazzling costumes, extravagant sets, and talented performers. After the show, enjoy a delicious buffet dinner at an Indian restaurant. - Return to your hotel for a comfortable overnight stay, resting up for the adventures awaiting you in Pattaya the next day. - (Breakfast in KL, Lunch in BKK and Dinner in PTY)"
      },
      {
        day: 8,
        title:
          "Excursion To Coral Island With Lunch",
        detail:
          "Begin your day with a hearty buffet breakfast at your Pattaya hotel before setting off on an unforgettable excursion to Coral Island (Koh Larn) by speedboat. Known for its stunning white sandy beaches and crystal-clear turquoise waters, Coral Island offers a perfect escape into nature. - The island is famous for its vibrant coral reefs, making it a paradise for snorkeling and marine life enthusiasts. Whether you’re looking to relax on the sun-kissed beaches, take a dip in the refreshing waters, or explore the underwater world, Coral Island promises an adventure-filled day. After enjoying your time at the island, indulge in a delicious lunch by the beach, making this a perfect day of relaxation and exploration. - In the evening, take time to explore Pattaya's lively nightlife, from strolling along Beach Road and visiting bustling night markets to enjoying world-class cabaret shows, rooftop bars, and vibrant clubs on Walking Street, before unwinding with a relaxing massage. (ON OWN) - (Breakfast, Lunch and Dinner)"
      },
      {
        day: 9,
        title:
          "Nong Nooch Village With Bus Ride And Transfer To Bangkok With Chao Phraya Dinner Cruise",
        detail:
          "Begin your day with a delicious breakfast at the hotel before checking out. The first stop is Nong Nooch Village, a must-visit attraction near Pattaya. Spanning over 500 acres, this stunning botanical garden is home to meticulously maintained landscapes, themed gardens, and vibrant floral displays. - Wander through lush tropical gardens, spot impressive topiary figures, and explore specialized areas such as the French Garden, Cactus Garden, and Orchid Nursery. Nong Nooch also offers cultural performances showcasing Thai traditions, including dance and martial arts. To get an overview of the vast grounds, you can take the Nong Nooch tram before embarking on your personal exploration. - After enjoying the natural beauty of Nong Nooch, you'll be transferred to Bangkok. - Once in the city, prepare for a captivating evening aboard the Chao Phraya River dinner cruise. As you glide along Bangkok's most famous river, you'll take in views of the city’s iconic landmarks, such as the Grand Palace, Wat Arun (Temple of Dawn), and the Rama VIII Bridge, all beautifully illuminated at night. - Onboard, indulge in a lavish buffet featuring both Thai and international dishes, all while live music creates a relaxing ambiance. This enchanting experience offers a unique perspective on Bangkok’s vibrant nightlife. - After the cruise, return to your hotel for a restful overnight stay, reflecting on the day’s rich experiences in both nature and culture. - (Breakfast, Lunch and Dinner)"
      },
      {
        day: 10,
        title:
          "Full-Day Safari World With Marine Park",
        detail:
          "Begin your day with a hearty buffet breakfast at your hotel in Bangkok. After breakfast, get ready for an exciting adventure at Safari World, one of Bangkok's top attractions, known for its captivating wildlife experiences and thrilling shows. - Your first stop is the Safari Park, an open zoo where you can witness a diverse range of animals in their natural habitats. Drive through the park and spot majestic creatures like giraffes, zebras, tigers, lions, and many more. This immersive wildlife experience brings you up close to animals in a way that few other zoos can offer, making it an unforgettable journey for animal lovers of all ages. - After exploring the Safarii Park, continue to the Marine Park section of Safari World. Here, you’ll be entertained by a series of exciting animal shows, including the lively Sea Lion Show, the captivating Dolphin Show, and the action-packed Hollywood Cowboy Stunt Show. These performances feature talented animals and skilled trainers, offering a fun and educational experience for the entire family. - Midday, refuel with a delicious Indian lunch at the Safari World Restaurant, where a range of Indian and international dishes are available to satisfy your appetite. - Spend the afternoon exploring more attractions within Safari World, where you can see other animals, visit themed exhibits, or enjoy more of the entertaining performances. - In the evening, take time to explore Bangkok’s vibrant shopping scene on your own. Whether you’re looking for luxury brands in modern malls, unique finds in local markets, or handcrafted souvenirs, Bangkok has something for everyone. Popular spots like Siam Paragon, MBK Center, and the lively Chatuchak Market offer a wide variety of shopping experiences to suit every taste. - After a fulfilling day of sightseeing and shopping, return to your hotel to relax and reflect on the rich cultural and modern experiences of the day. - (Breakfast, Lunch and Dinner)"
      },
      {
        day: 11,
        title:
          "City And Temple Tour Of Bangkok And Departure",
        detail:
          "Enjoy a leisurely buffet breakfast at your hotel in Bangkok to start your day off right. Check out from your hotel in Bangkok. Proceed with your City And Temple Tour. - Begin your day with a deep dive into Bangkok’s cultural and spiritual heart with a city and temple tour. Your first stop is the renowned Golden Buddha (Wat Traimit), home to the world’s largest solid gold Buddha, weighing 5.5 tons. This stunning statue, hidden beneath plaster for centuries and discovered by accident, is a remarkable piece of history and devotion, providing a peaceful oasis in the bustling city. - Next, visit the magnificent Marble Temple (Wat Benchamabophit), one of the most exquisite temples in Bangkok. Built from pristine white Carrara marble, this temple features a unique blend of traditional Thai architecture and subtle European influences. Stroll through its serene courtyards, admire intricate carvings, and experience the spiritual atmosphere surrounding the golden Buddha statue in the main hall. - Throughout the day, you’ll get a chance to see Bangkok’s iconic landmarks, blending ancient temples and modern cityscapes. The temples offer not only a spiritual journey but also a feast for the eyes with their stunning architecture, intricate sculptures, and historical significance. - After Lunch, take time to explore Bangkok’s vibrant shopping scene on your own. Whether you’re looking for luxury brands in modern malls, unique finds in local markets, or handcrafted souvenirs, Bangkok has something for everyone. Popular spots like Siam Paragon, MBK Center, and the lively Chatuchak Market offer a wide variety of shopping experiences to suit every taste. After a fulfilling day of sightseeing and shopping, return to your hotel to relax and reflect on the rich cultural and modern experiences of the day. Depending on Flight Departure) - Later in the evening, you will be transferred to the airport for your onward journey. - Note: Ensure your flight departs late at night to fully enjoy the day City tour & Shopping, Otherwise, if time is limited, you will proceed directly to the airport after hotel check-out without the Shopping. - (Breakfast and Lunch - Depending on Flight Departure)."
      },

    ],

    overview: "This package encompasses a diverse and exciting journey through Singapore, Kuala Lumpur, and Thailand's Pattaya and Bangkok. Beginning with a comprehensive exploration of Singapore's cultural landmarks and iconic attractions, including Little India, Merlion, and Gardens by the Bay, the trip proceeds to Sentosa Island and Universal Studios for entertainment and adventure. In Kuala Lumpur, highlights include Putrajaya, Genting Highlands, and city tours featuring landmarks like the Genting Highlands and Batu Caves. The journey continues to Pattaya, where you can experience Coral Island and Nong Nooch Village, followed by cultural immersion and temple visits in Bangkok. The itinerary culminates in Safari World, offering wildlife encounters and thrilling shows, before departing from Bangkok Suvarnabhumi Airport. Throughout the journey, you can indulge in delicious Indian cuisine, ensuring a memorable and fulfilling experience."
  },
  // ================= Greece & Istanbul =================
  {
    id: "greece-001",
    slug: "greece-of-the-ancient-world",
    destination: "Greece",
    title: "Greece of The Ancient World",
    duration: "12 Nights 13 Days",
    route: "3N Athens | 1N Nafplio | 1N Monemvasia | 2N Areopoli | 1N Methoni | 1N Olympia | 1N Nafpaktos | 1N Arachova | 1N Athens",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 3,
    price: 219999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [athens,nafplio,monemvasia,areopoli,methoni,olympia,nafpaktos,arachova],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Singapore", to: "Out of Bangkok", type: "Direct or 1 Stop" },
    //   { from: "Kuala Lumpur", to: "Bangkok", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Athens", nights: "3 Nights", type: "Good 3 Star Hotel" },
      { location: "Nafplio", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Monemvasia", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Areopoli", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Methoni", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Olympia", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Nafpaktos", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Arachova", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Athens", nights: "1 Nights", type: "Good 3 Star Hotel" },

    ],

    sightseeing: [
      { title: "Athens Sightseeing" },
      { title: "Nafplio  Sightseeing" },
      { title: "Monemvasia Sightseeing" },
      { title: "Areopoli Sightseeing" },
      { title: "Methoni Sightseeing" },
      { title: "Olympia Sightseeing" },
      { title: "Nafpaktos Sightseeing" },
      { title: "Arachova Sightseeing" },
      { title: "Athens Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      // { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [

      "Acropolis & Archaeological Museum and Temple of Poseidon Visit",
      "Escorted by an experienced English / Hindi-speaking Tour Manager",
      "Daily Dinner at an Indian or Local Restaurant",
      "Visit to Epidaurus & Bourtzi Fortress",
      "Diros Cave Experience and Guided by Expert Local English-Speaking Guide at Mystras",
      "Visit to Mystras and Tour to Hlemoutsi Castle",
      "Guided Tour of Ancient Olympia",
      "Guided Tour of Delphi",
      "This journey explores the rich history and scenic beauty of Greece, beginning in Athens—the birthplace of democracy and home to some of the world’s most iconic ancient landmarks. Travelers will experience authentic Greek culture, traditional cuisine, and the vibrant rhythm of city life before continuing into the historic Peloponnese region.",
      "The journey continues through charming towns such as Nafplio and Monemvasia, explores the dramatic Mani Peninsula near Areopoli, and visits the legendary Olympic site at Olympia before concluding with the historic sanctuary of Delphi.",
    ],

    exclusions: [
      "City tax payable directly at hotel. (€6–€10 per person per night for 3–4 hotels)",
      "Tips for the driver, tour manager, and local tour guide are to be paid separately.",
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently for arrival and departure.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Athens & Welcome Dinner",
        detail:
          "Arrival at Athens International Airport Eleftherios Venizelos. Transfer to the hotel followed by a welcome meeting. Enjoy a common dinner in Athens to experience the famous Greek cuisine."
      },
      {
        day: 2,
        title:
          "Athens City Tour & Ancient Highlights",
        detail:
          "Guided tour of Athens. Visit the Panathenaic Stadium, where the first Olympic Games of the modern era took place in 1896. Continue to the Acropolis of Athens, where we will admire the magnificent 5th-century Temple of Athena, the Propylaea, and panoramic views from the sacred rock. Descend on foot, with a stop for street food—an essential part of Greek daily life. Visit the National Archaeological Museum of Athens, home to remarkable treasures of antiquity. Proceed to Syntagma Square, where the Greek Parliament stands, and observe the ceremonial guards at the Monument of the Unknown Soldier, maintaining their watch 24 hours a day. Breakfast & Dinner Included."
      },
      {
        day: 3,
        title:
          "Sounion Excursion & Lavrio Exploration",
        detail:
          "Enjoy a free morning in Athens, perfect for exploring its bustling shopping streets and vibrant local markets. Don’t miss trying a quick meal of souvlaki, one of Greece’s most beloved street foods. Later, depart for the stunning Temple of Poseidon at Cape Sounion. This iconic 5th-century BC temple, built in Doric style from white marble, stands dramatically 60 meters above the sea, offering breathtaking views over the Aegean Sea—especially magical at sunset. Continue to Lavrio, a fascinating open-air museum reflecting its rich mining heritage. Highlights include the old French loading ladder at the port, the Clock of the Hellenic Metallurgical Company, the former French Company factory (now Lavrio Technological Park), and elegant neoclassical buildings scattered throughout the town. Breakfast & Dinner Included."
      },
      {
        day: 4,
        title:
          "Corinth Canal, Epidaurus & Nafplio",
        detail:
          "Begin the journey into the Peloponnese with a stop at the Corinth Canal. Built between 1881–1893, it stretches 6.3 km in length, 8 meters in depth, and 24.6 meters in width. Continue to the ancient theatre of Epidaurus, preserved almost exactly as it was built and once home to classical performances. Arrival in Nafplio, one of Greece’s most beautiful towns. Walk through its charming squares and enjoy a boat visit to Bourtzi Castle, a former Venetian stronghold. Breakfast & Dinner Included."
      },
      {
        day: 5,
        title:
          "Mycenae, Laconia & Monemvasia",
        detail:
          "Before departing Nafplio, visit Palamidi Fortress, an impressive example of Venetian fortification architecture. Continue to Mycenae, the kingdom of Agamemnon. Travel south through Laconia, crossing the Parnonas, with a stop at Kosmas for coffee. Arrive at Monemvasia, where cobblestone streets transport you to the Middle Ages. Breakfast & Dinner Included."
      },
      {
        day: 6,
        title:
          "Mani Region & Areopoli Stay",
        detail:
          "Journey to the heart of Laconia, the Mani region. Stop at Gythio for coffee, then continue to Areopoli, known as the “stone capital” of Mani. Check in for two nights. Upon arrival, explore the town’s narrow alleys and distinctive architecture. Breakfast & Dinner Included."
      },
      {
        day: 7,
        title:
          "Mani Exploration & Coastal Landscapes",
        detail:
          "Full-day exploration of Mani, including Cape Matapan, Porto Kagio, Vathia, Diros Caves, Oitylo, Kelefa Castle, Limeni, and Gerolimenas. Discover dramatic landscapes, traditional stone villages, and stunning coastal scenery. Breakfast & Dinner Included."
      },
      {
        day: 8,
        title:
          "Methoni to Olympia via Stemnitsa, Dimitsana & Hlemoutsi",
        detail:
          "Proceed to Sparta and continue to Mystras, a historic Byzantine site of exceptional grandeur. After a short stop in Kalamata, continue to Methoni. Explore the impressive Methoni Castle, one of the largest in the Mediterranean. Breakfast & Dinner Included."
      },
      {
        day: 9,
        title:
          "Olympia to Nafpaktos via Rio-Antirio Bridge",
        detail:
          "Visit the Monastery of Timios Prodromos in Stemnitsa. Continue to Dimitsana, a picturesque mountain village rich in culture and history. Proceed to the Olympia region, with a stop at Chlemoutsi Castle to admire the sunset. Breakfast & Dinner Included."
      },
      {
        day: 10,
        title:
          "Nafpaktos to Arachova via Galaxidi & Itea",
        detail:
          "Visit Ancient Olympia, where the Olympic Games were born. Explore the ancient stadium and archaeological museum with a local guide.Continue north across the Rio-Antirrio Bridge to Nafpaktos. Breakfast & Dinner Included."
      },
      {
        day: 11,
        title:
          "Arachova to Delphi Tour and Return to Athens",
        detail:
          "Travel along the coast to Galaxidi, a picturesque maritime town. Continue to Itea and then to Arachova for an overnight stay.Explore its vibrant atmosphere, cobblestone streets, and local landmarks. Breakfast & Dinner Included."
      },
      {
        day: 12,
        title:
          "Delphi Visit & Return to Athens",
        detail:
          "Depart for Delphi, once considered the “navel of the earth.” Discover the temple, sanctuaries, and the ruins of the Oracle on a guided tour. Arrival in Athens and farewell to Greece. Breakfast & Dinner Included."
      },
      {
        day: 13,
        title:
          "Departure",
        detail:
          "After Breakfast, Transfer to the airport for your return flight."
      },

    ],

    overview: "Athens is the city where democracy was born, a timeless symbol of history and civilization. Every city across the Peloponnese and Central Greece holds a story rich enough to fill an entire history book on its own. Each destination in the Peloponnese stands as a complete and autonomous experience, offering visitors a harmonious blend of vibrant cultural life, picturesque villages, and breathtaking landscapes that range from majestic mountains to serene coastlines. Great importance will be placed on Greek cuisine—celebrated for its simplicity, freshness, and authenticity. Rooted in the finest ingredients, it features fresh vegetables, premium olive oil, delicate spices, freshly caught fish, and perfectly grilled meats, all thoughtfully complemented by light, locally produced wines that enhance every dining experience"
  },
  {
    id: "greece-002",
    slug: "the-unique-cyclades-and-the-mycenaean-crete",
    destination: "Greece",
    title: "The Unique Cyclades and The Mycenaean Crete",
    duration: "12 Nights 13 Days",
    route: "2N Athens | 1N Paros | 2N Naxos | 2N Santorini | 1N Heraklion | 1N Chania | 1N Plakias | 1N Ierapetra | 1N Agios Nikolaos",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Sep 2026", "Oct 2026"],
    stars: 3,
    price: 272999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [athens,paros,naxos,santorini,heraklion,chania,plakias,ierapetra,agiosnikolaos],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Singapore", to: "Out of Bangkok", type: "Direct or 1 Stop" },
    //   { from: "Kuala Lumpur", to: "Bangkok", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Athens", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Paros", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Naxos", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Santorini", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Heraklion", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Chania", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Plakias", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Ierapetra", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Agios Nikolaos", nights: "1 Nights", type: "Good 3 Star Hotel" },

    ],

    sightseeing: [
      { title: "Athens Sightseeing" },
      { title: "Paros  Sightseeing" },
      { title: "Naxos Sightseeing" },
      { title: "Santorini Sightseeing" },
      { title: "Heraklion Sightseeing" },
      { title: "Chania Sightseeing" },
      { title: "Plakias Sightseeing" },
      { title: "Ierapetra Sightseeing" },
      { title: "Agios Nikolaos Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      // { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Daily Dinner at an Indian or Local Restaurant",
      "Escorted by an experienced English / Hindi - speaking Tour Manager",
      "Acropolis & Archaeological Museum",
      "City Tour of Paros",
      "City Tour of Naxos",
      "City Tour of Santorini with Crete Island Tour and Visit to Akrotiri Archaeological Site",
      "Knossos Palace Experience",
      "Frangokastelo Fortress Visit",
      "Discover the ancient wonders of Athens, including the iconic Acropolis of Athens and the historic Panathenaic Stadium. Experience the charm of the Cyclades with visits to the beautiful islands of Paros and Naxos, known for their picturesque villages and authentic Greek island life.",
      "Witness the world-famous sunset and dramatic volcanic landscapes of Santorini. Explore the legendary Minoan civilization at Knossos Palace and discover the rich culture of Crete.",
      "Wander through the charming coastal towns of Chania, Rethymno, and Agios Nikolaos while enjoying authentic Cretan cuisine and the stunning beauty of the Mediterranean landscape.",
    ],

    exclusions: [
      "City tax payable directly at hotel. (€6–€10 per person per night for 3–4 hotels)",
      "Tips for the driver, tour manager, and local tour guide are to be paid separately.",
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently for arrival and departure.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Athens & Welcome Dinner",
        detail:
          "Arrival at Athens International Airport Eleftherios Venizelos. Transfer to the hotel followed by a welcome meeting. Enjoy a common dinner in Athens to experience the famous Greek cuisine."
      },
      {
        day: 2,
        title:
          "Athens Highlights & Ancient Heritage",
        detail:
          "Enjoy a guided tour of Athens, beginning with a visit to the historic Panathenaic Stadium, where the first modern Olympic Games were held in 1896. Continue to the iconic Acropolis of Athens to admire the magnificent Parthenon and the Propylaea, while enjoying sweeping panoramic views from the sacred rock. Descend on foot and pause to savor authentic Greek street food—an essential part of local culture. Visit the renowned National Archaeological Museum, home to extraordinary treasures of antiquity. Then proceed to Syntagma Square to see the Greek Parliament and witness the ceremonial guards at the Monument of the Unknown Soldier, standing watch around the clock. Breakfast & Dinner Included."
      },
      {
        day: 3,
        title:
          "Paros Island Discovery & Village Charm",
        detail:
          "Transfer to the harbor of Piraeus or Rafina and ferry to Paros. Accommodation in Paroikia followed by a bus tour of the island. Enjoy your first experience of the island with a Greek coffee in Naousa. Visit Piso Livadi, Alyki, and other picturesque villages. Breakfast & Dinner Included."
      },
      {
        day: 4,
        title:
          "Naxos Transfer & Apollo Temple Visit",
        detail:
          "Transfer to the harbor and ferry to Naxos. Check-in for two nights in the main city. Visit the Temple of Apollo Naxos with a guided tour. Breakfast & Dinner Included."
      },
      {
        day: 5,
        title:
          "Naxos Island Tour & Leisure",
        detail:
          "Explore Naxos island by bus, discovering its landscapes and villages. Breakfast & Dinner Included."
      },
      {
        day: 6,
        title:
          "Santorini Arrival & Iconic Sunset at Oia",
        detail:
          "Transfer to the harbor and ferry to Santorini. Check-in for two nights. Visit Oia to witness its world-famous sunset, with part of the journey on foot and the rest by bus. Breakfast & Dinner Included."
      },
      {
        day: 7,
        title:
          "Santorini Exploration & Ancient Civilisation",
        detail:
          "Tour the island by bus, visiting ruins linked to early civilizations. Enjoy a coffee at Pyrgos, the island’s highest village, followed by free time in Fira. Breakfast & Dinner Included."
      },
      {
        day: 8,
        title:
          "Crete Arrival & Knossos Exploration",
        detail:
          "Transfer to the harbor and journey to Crete—a blessed land with deep roots and strong character. From Kissamos in the west to Vai in the east, Souda and Elounda in the north, Samaria Gorge, Sfakia and Frangokastello in the south, and Anogia and Psiloritis in the center overlooking Ancient Knossos, Phaistos and the Minoan civilization—there is so much to see, experience, and taste. Upon arrival, visit the ancient city of Knossos Palace. Breakfast & Dinner Included."
      },
      {
        day: 9,
        title:
          "Rethymno & Chania Cultural Journey",
        detail:
          "Departure to Rethymno, where the Muslim East and Catholic West coexisted for centuries. Visit landmarks such as the Nerantze Mosque, the Church of Agios Francis, Rimondi Fountain, Makry Stenos, Venetian Port, and Venetian Loggia. Guided city tour.Continue to Chania. After coffee at the picturesque harbor, explore the Mosque of Küçük Hasan Bey, the Great Arsenal, the old Turkish quarter, and the district of Halepa. Breakfast & Dinner Included."
      },
      {
        day: 10,
        title:
          "Sfakia Region & Preveli Natural Wonders",
        detail:
          "Journey into the interior of Crete, a region distinctly different from the coastline, rich in history and resilience. Explore the historic region of Sfakia and visit Frangokastello. Continue to Preveli Beach, known for its palm forest, river lagoon, and crystal-clear waters. Visit the nearby Preveli Monastery. Breakfast & Dinner Included."
      },
      {
        day: 11,
        title:
          "Eastern Crete & Ierapetra Experience",
        detail:
          "Travel east to Myrtos, known for its sunshine. Continue to Ierapetra to explore its lively streets and historic fortress. Breakfast & Dinner Included."
      },
      {
        day: 12,
        title:
          "Lasithi Region & Agios Nikolaos Stay",
        detail:
          "Explore the Lasithi region, a unique meeting point of three seas and diverse landscapes. Visit natural highlights including Vai Palm Grove, Cha Gorge, Lasithi Plateau, and Toplou Monastery. Visit the village of Mochlos. Arrival in Agios Nikolaos, built beside the famous Lake Voulismeni. Stroll through the town, admire the lake, marina, and scenic surroundings. Breakfast & Dinner Included."
      },
      {
        day: 13,
        title:
          "Departure & Return Journey",
        detail:
          "After Breakfast, Transfer to the local airport and onward journey to Athens for your return flight home."
      },

    ],

    overview: "The Cyclades, including the iconic Santorini and its neighboring islands, are a dream destination for many—truly one of the ultimate places to visit. However, a lesser-known yet equally captivating gem is Crete. From nature’s abundant bounty to the warmth of renowned Cretan hospitality, the island offers an experience that is both authentic and enriching. Olive oil and raki delight the soul, while traditional delicacies such as myzithra, ladotyri, wild greens, snails, lamb, gamopilafo, and syglino showcase the region’s rich culinary heritage. For dessert, indulge in xerotigana, kaltsounia, and an array of classic spoon sweets, all thoughtfully prepared for your enjoyment. For a refreshing change, savor freshly caught seafood from the hardworking fishermen of the Cretan and Libyan Seas, bringing the true taste of the island straight to your table."
  },
  {
    id: "greece-003",
    slug: "the-must-seen-of-greece",
    destination: "Greece",
    title: "The Must Seen of Greece",
    duration: "10 Nights 11 Days",
    route: "2N Athens | 1N Preveza | 3N Corfu | 1N Kalambaka | 3N Thessaloniki ",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 3,
    price: 201999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [athens,preveza,corfu,kalambaka,thessaloniki],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Singapore", to: "Out of Bangkok", type: "Direct or 1 Stop" },
    //   { from: "Kuala Lumpur", to: "Bangkok", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Athens", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Preveza", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Corfu", nights: "3 Nights", type: "Good 3 Star Hotel" },
      { location: "Kalambaka", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Thessaloniki ", nights: "3 Nights", type: "Good 3 Star Hotel" },

    ],

    sightseeing: [
      { title: "Athens Sightseeing" },
      { title: "Preveza  Sightseeing" },
      { title: "Corfu Sightseeing" },
      { title: "Kalambaka Sightseeing" },
      { title: "Thessaloniki Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      // { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Daily Dinner at an Indian or Local Restaurant",
      "Escorted by an experienced English / Hindi - speaking Tour Manager",
      "Acropolis & Archaeological Museum",
      "Visit to Salt Museum & Guided Tour of Ioannina",
      "Visit to Achilleion Palace & Boat Ride to Pontikonisi Island",
      "Visit to White Tower of Thessaloniki & Genti Koule",
      "Visit to Archaeological Museum & Aigai Museum",
      "Discover the timeless history and vibrant life of Athens and Thessaloniki, where ancient monuments seamlessly blend with contemporary culture. Experience the charm of the Ionian island of Corfu, celebrated for its turquoise waters, elegant old town, and captivating scenic landscapes.",
      "Journey through picturesque Greek landscapes, from the coastal beauty of Parga to the traditional mountain village of Metsovo. Visit the spectacular monasteries of Meteora, one of the most breathtaking natural and spiritual wonders of Greece.",
      "Enjoy authentic Greek hospitality through traditional cuisine, charming local taverns, and unforgettable cultural experiences.",
    ],

    exclusions: [
      "City tax payable directly at hotel. (€6–€10 per person per night for 3–4 hotels)",
      "Tips for the driver, tour manager, and local tour guide are to be paid separately.",
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently for arrival and departure.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Athens & Welcome Dinner",
        detail:
          "Arrival at Athens International Airport Eleftherios Venizelos. Transfer to the hotel followed by a welcome meeting. Enjoy a common dinner in Athens to experience the famous Greek cuisine."
      },
      {
        day: 2,
        title:
          "Athens City Tour & Ancient Heritage Exploration",
        detail:
          "Guided tour of Athens. Visit the Panathenaic Stadium, where the first Olympic Games of the modern era took place in 1896. Continue to the Acropolis of Athens to admire the magnificent 5th-century Temple of Athena, the Propylaea, and panoramic views from the sacred rock. Descend on foot and pause to enjoy street food, an integral part of Greek culture. Visit the National Archaeological Museum of Athens, home to remarkable treasures of antiquity. Proceed to Syntagma Square, where the Greek Parliament stands, and observe the ceremonial guards at the Monument of the Unknown Soldier, maintaining their watch 24 hours a day. Breakfast & Dinner Included."
      },
      {
        day: 3,
        title:
          "Paros Island Experience & Village Exploration",
        detail:
          "Transfer to the harbor of Port of Piraeus or Rafina Port and board your ferry to Paros. Upon arrival, check in to your accommodation in Parikia, followed by a guided bus tour of the island. Begin your exploration with a relaxing Greek coffee in Naousa, a charming fishing village known for its picturesque harbor. Continue to Piso Livadi and Alyki, along with other quaint settlements, each offering a glimpse into traditional island life. Return to Parikia and enjoy free time to explore the capital at your own pace, soaking in the island’s laid-back charm. Breakfast & Dinner Included."
      },
      {
        day: 4,
        title:
          "Epirus Riviera & Arrival in Corfu",
        detail:
          "Journey north along the breathtaking Epirus Riviera, passing beautiful beaches such as Loutsa Beach, Valtos Beach, and Lychnos Beach, each offering crystal-clear waters and scenic coastal views. Arrive at Parga, a charming seaside town that feels like a living painting with its colorful houses and hillside setting. Enjoy a shared lunch at a local tavern, soaking in the relaxed atmosphere. Continue via Igoumenitsa and cross over to Corfu for a three-night stay. Influenced by Venetian, French, and British rule, Corfu blends Greek traditions with refined European elegance. Explore the UNESCO-listed Old Town, stroll along the Liston Promenade, visit the historic fortresses, and enjoy views from Kanoni. Breakfast & Dinner Included."
      },
      {
        day: 5,
        title:
          "Corfu Island Exploration & Cultural Highlights",
        detail:
          "Begin your exploration of Corfu with a visit to Paleokastritsa, famed for its turquoise waters and dramatic coastal scenery. Visit the historic Paleokastritsa Monastery and the hilltop fortress of Angelokastro, offering breathtaking panoramic views. Continue to the elegant Achilleion Palace, once built for Empress Elisabeth of Austria, and Mon Repos Palace, where history, art, and lush gardens come together beautifully. Enjoy fresh seafood specialties in the charming village of Boukaris before heading back. On your return, visit the iconic Vlacherna Monastery and the nearby Pontikonisi, one of the most photographed spots on the island. Breakfast & Dinner Included."
      },
      {
        day: 6,
        title:
          "Santorini Arrival & Sunset at Oia",
        detail:
          "Transfer to the harbor and board your boat to Santorini, a destination that never fails to exceed expectations with its dramatic landscapes and iconic beauty. Upon arrival, check in to your hotel for a two-night stay and take some time to relax. Later, visit Oia, renowned for its world-famous sunset. The journey will be a mix of walking and bus travel, offering stunning views along the way—an experience truly worth it as the sky transforms into brilliant shades over the caldera. Breakfast & Dinner Included."
      },
      {
        day: 7,
        title:
          "Mainland Return via Ioannina & Metsovo",
        detail:
          "Return to mainland Greece, beginning with a stop at Ioannina for a guided tour. Discover its rich history, lakeside charm, and cultural heritage. Continue your journey to the picturesque mountain village of Metsovo, renowned for its traditional stone architecture, scenic mountain setting, and authentic local atmosphere. Breakfast & Dinner Included."
      },
      {
        day: 8,
        title:
          "Crete Arrival & Knossos Visit",
        detail:
          "Visit the breathtaking Meteora, a UNESCO World Heritage Site where monasteries are perched atop dramatic rock formations. Explore two of these remarkable monasteries and take in the awe-inspiring scenery and spiritual atmosphere. Continue to Aigai, home to the Royal Tombs of Philip II of Macedon, an important archaeological site offering insight into ancient Macedonian history. Breakfast & Dinner Included."
      },
      {
        day: 9,
        title:
          "Rethymno & Chania Cultural Exploration",
        detail:
          "Explore the Upper Town (Ano Poli) of Thessaloniki, where history and panoramic views come together beautifully. Visit the Trigoni Tower and the Heptapyrgion, part of the city’s historic fortifications, along with the serene Vlatadon Monastery. Continue to the iconic Arch of Galerius, a lively central meeting point and a reminder of the city’s Roman past. Breakfast & Dinner Included."
      },
      {
        day: 10,
        title:
          "Museums, Views & Coastal Walk",
        detail:
          "Visit the Archaeological Museum, home to treasures of the Macedonian dynasty. Climb the White Tower of Thessaloniki for panoramic views. Continue with a walk along the coastal boulevard. Breakfast & Dinner Included."
      },
      {
        day: 11,
        title:
          "Departure & Journey Home",
        detail:
          "After Breakfast, Transfer to the airport, flight to Athens, and onward journey back to Delhi."
      },

    ],

    overview: "How can one truly encapsulate the essence of Greece within a single paragraph—where timeless history, world-class museums, breathtaking natural landscapes, and ancient monuments coexist with islands surrounded by endless shades of blue, and vibrant modern cities brought to life by their people? This journey is a thoughtfully curated attempt to do just that—offering a seamless blend of culture, history, scenic beauty, and authentic local experiences. It is not merely about seeing Greece, but about immersing yourself in its soul—discovering a little of everything, and ultimately, experiencing so much more in every moment."
  },
  {
    id: "greece-004",
    slug: "the-pearls-of-greek-islands",
    destination: "Greece",
    title: "The Pearls of Greek Islands",
    duration: "19 Nights 20 Days",
    route: "3N Athens | 2N Milos Island | 3N Santorini | 3N Rhodes | 2N Kos | 2N Kalymnos | 2N Patmos | 2N Samos",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026"],
    stars: 3,
    price: 394999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [athens,milosisland,santorini,rhodes,kos,kalymos,patmos,samos],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Singapore", to: "Out of Bangkok", type: "Direct or 1 Stop" },
    //   { from: "Kuala Lumpur", to: "Bangkok", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Athens", nights: "3 Nights", type: "Good 3 Star Hotel" },
      { location: "Milos Island", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Santorini", nights: "3 Nights", type: "Good 3 Star Hotel" },
      { location: "Rhodes", nights: "3 Nights", type: "Good 3 Star Hotel" },
      { location: "Kos", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Kalymnos", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Patmos", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Samos", nights: "2 Nights", type: "Good 3 Star Hotel" },

    ],

    sightseeing: [
      { title: "Athens Sightseeing" },
      { title: "Milos Island  Sightseeing" },
      { title: "Santorini Sightseeing" },
      { title: "Rhodes Sightseeing" },
      { title: "Kos Sightseeing" },
      { title: "Kalymnos Sightseeing" },
      { title: "Patmos Sightseeing" },
      { title: "Samos Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      // { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Daily Dinner at an Indian or Local Restaurant",
      "Athens Guided City Tour and Acropolis Visit with Archaeological Museum at Athens",
      "Experience of Nafplio with Visit of ancient theatre of Epidavros and Bourtzi Island Trip",
      "Escorted by an Experienced English / Hindi-Speaking Tour Manager",
      "Daily Milos Island Cruise Experience",
      "Oia Bus Tour with Akrotiri Archaeological Site Visit",
      "Rhodes Guided City Tour and Daily Bus Tour",
      "Kos Daily Bus Tour and Archaeological Site Visit",
      "Kalymnos Daily Bus Tour and Sponge Divers Museum Visit",
      "Patmos Guided Tour with Daily Bus Tour",
      "Monastery of Patmos Visit",
      "Discover the legendary city of Athens, exploring the iconic Acropolis, Archaeological Museum, Kalimarmaro Stadium, and Syntagma Square with the ceremonial Changing of the Guards.",
      "Journey to romantic Nafplio, visiting the impressive Palamidi Fortress and strolling through its charming historic Old Town.",
      "Sail into the stunning Aegean Sea, cruising to volcanic Milos with a traditional boat trip to the turquoise caves of Kleftiko and the unique white landscapes of Sarakiniko.",
      "Experience the magic of Santorini, with breathtaking caldera views, the ancient ruins of Akrotiri, and the world-famous sunset in Oia.",
      "Explore the historic Dodecanese islands, discovering medieval Rhodes, the birthplace of Hippocrates in Kos, and the sponge-diving heritage of Kalymnos.",
    ],

    exclusions: [
      "City tax payable directly at hotel. (€6–€10 per person per night for 3–4 hotels)",
      "Tips for the driver, tour manager, and local tour guide are to be paid separately.",
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently for arrival and departure.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Athens",
        detail:
          "Arrive in Athens and transfer to your hotel. Enjoy a welcome dinner and settle in. If time permits, you may explore the city or enjoy some free time for shopping and leisure. Dinner Included."
      },
      {
        day: 2,
        title:
          "Athens City Tour and Highlights",
        detail:
          "Embark on a city tour of Athens, beginning with a visit to the iconic Acropolis, followed by the Archaeological Museum, home to remarkable artifacts from ancient Greece. Continue to the Kalimarmaro Stadium, the site of the first modern Olympic Games. Visit Syntagma Square to see the Greek Parliament and witness the ceremonial changing of the guards. You may also enjoy time for a quick lunch before continuing your exploration. Breakfast & Dinner Included."
      },
      {
        day: 3,
        title:
          "Excursion to Nafplio - Palamidi Fortress and City Exploration",
        detail:
          "Take an excursion by bus to Nafplio, one of Greece’s most charming historic towns, rich in Mycenaean heritage. Visit the impressive Palamidi Fortress, offering panoramic views, and explore Nafplio’s castle and historic center. Enjoy free time to stroll through the town, browse local shops, and soak in its relaxed atmosphere before returning to your hotel in Athens. Breakfast & Dinner Included."
      },
      {
        day: 4,
        title:
          "Transfer from Athens to Milos Island",
        detail:
          "Transfer to Piraeus and board your ship to Milos Island. Upon arrival, enjoy free time to explore the island’s capital at your own pace, taking in its charming atmosphere and coastal beauty. Breakfast & Dinner Included."
      },
      {
        day: 5,
        title:
          "Boat Excursion Around Milos - Beaches and Legends",
        detail:
          "Enjoy an excursion by traditional kaiki boat around Milos Island. Discover the island’s stunning coastline, with its striking blue and turquoise waters of the Aegean Sea. Stop for swimming at the famous Kleftiko and Sarakiniko beaches (weather permitting), known for their unique rock formations and crystal-clear waters. Along the way, hear fascinating stories and legends of the island from your captain, adding a cultural touch to this scenic experience. Breakfast & Dinner Included."
      },
      {
        day: 6,
        title:
          "Transfer from Milos to Santorini",
        detail:
          "After breakfast, proceed to the port for your departure to Santorini. Upon arrival, transfer to your hotel, ideally offering stunning views of the Caldera. Enjoy free time to relax, take in the breathtaking scenery, and explore the island at your own pace. Breakfast & Dinner Included."
      },
      {
        day: 7,
        title:
          "Santorini Leisure and Oia Sunset Visit",
        detail:
          "Enjoy your morning at leisure, taking time to relax or explore Santorini at your own pace. In the afternoon, visit Oia, the island’s most picturesque village, to witness its world-famous sunset—one of Santorini’s most iconic experiences, as the sky transforms into shades of gold and crimson over the caldera. Breakfast & Dinner Included."
      },
      {
        day: 8,
        title:
          "Santorini - Akrotiri Archaeological Site Visit",
        detail:
          "Visit the archaeological site of Akrotiri and enjoy a guided exploration of this ancient city, preserved after a devastating earthquake around 1650 B.C. Discover its remarkably advanced urban layout, well-preserved buildings, and frescoes that offer insight into life in the prehistoric Aegean world. Breakfast & Dinner Included."
      },
      {
        day: 9,
        title:
          "Transfer from Santorini to Rhodes",
        detail:
          "Transfer to the airport for your flight to Rhodes. Upon arrival, transfer to your hotel and enjoy leisure time to relax and unwind. Breakfast & Dinner Included."
      },
      {
        day: 10,
        title:
          "Ancient Rhodes Tour and Local Street Food",
        detail:
          "Tour the ancient city of Rhodes, beginning with a visit to the impressive Castle of the Knights, a remarkable example of medieval architecture. Wander through the narrow cobbled streets of the Old Town, soak in the historic atmosphere, and interact with locals. Along the way, enjoy the chance to sample local street food such as gyros, experiencing the flavors of Greek cuisine. Breakfast & Dinner Included."
      },
      {
        day: 11,
        title:
          "Excursion to Lindos and Southern Rhodes",
        detail:
          "Visit the southern part of Rhodes and explore the charming town of Lindos, known for its whitewashed houses and scenic coastal setting. Wander through its narrow streets and take in the beautiful surroundings. Enjoy free time to relax and swim at one of the area’s stunning beaches before returning. Breakfast & Dinner Included."
      },
      {
        day: 12,
        title:
          "Transfer from Rhodes to Kos",
        detail:
          "Travel to the island of Kos, the birthplace of Hippocrates, the father of modern medicine. Upon arrival, transfer to your hotel and check in. Enjoy free time to explore the city at your own pace, relax, or take in the island’s welcoming atmosphere. Breakfast & Dinner Included."
      },
      {
        day: 13,
        title:
          "Kos Island Tour, Asklepion, Kefalos and Zia Dinner Experience",
        detail:
          "Enjoy a tour of Kos, beginning with a visit to the ancient Asklepion, one of the most important archaeological sites in Greece and a historic center of healing dedicated to Asclepius. Continue exploring the island by bus, reaching Kefalos at the western edge, known for its scenic views and coastal charm. In the evening, head to the mountain village of Zia, where you can enjoy dinner at a traditional local tavern while taking in beautiful sunset views. Return to your hotel afterward. Breakfast & Dinner Included."
      },
      {
        day: 14,
        title:
          "Transfer to Kalymnos via Pserimos – Explore Sponge Diver Heritage",
        detail:
          "Depart by ship for Kalymnos, an island renowned for its long tradition of sponge diving. En route, stop at Pserimos, a tiny island with only a handful of residents, offering a unique glimpse into simple local life. Upon arrival in Kalymnos, visit the Sponge Divers’ Museum to learn about the island’s fascinating history and the lives of its divers. Breakfast & Dinner Included."
      },
      {
        day: 15,
        title:
          "Kalymnos Island Bus Tour - History and Traditions",
        detail:
          "Take a bus tour around the small island of Kalymnos, which stretches just 18 km in length. Along the way, enjoy frequent stops that allow you to explore the island’s scenic landscapes, discover its local history, and experience its unique traditions up close. Breakfast & Dinner Included."
      },
      {
        day: 16,
        title:
          "Transfer to Patmos - Leisure and Architectural Discovery",
        detail:
          "Travel by ship to Patmos Island, one of the most serene and culturally rich islands in the Aegean. Upon arrival, enjoy leisure time to explore at your own pace. Wander through the charming town, admire the traditional Aegean architecture with its whitewashed houses and narrow streets, and soak in the peaceful island atmosphere. Breakfast & Dinner Included."
      },
      {
        day: 17,
        title:
          "Patmos Island Tour and Monastery of Saint John Visit",
        detail:
          "Tour Patmos, beginning with a visit to the Monastery of Saint John, a UNESCO-listed landmark that dominates the island’s skyline and holds great religious significance. Explore the island’s rich history, learning about its spiritual heritage and its connections to medieval knights. Discover the unique character of Patmos as you immerse yourself in its cultural and historical legacy. Breakfast & Dinner Included."
      },
      {
        day: 18,
        title:
          "Transfer to Samos – Leisure in Vathy",
        detail:
          "Take a ship to Samos Island, a destination rich in history and natural beauty. Upon arrival, enjoy free time in the main town of Vathy, where you can stroll along the harbor, explore local streets, and soak in the island’s relaxed atmosphere. Take the opportunity to try local specialties and experience the authentic flavors of Samos. Breakfast & Dinner Included."
      },
      {
        day: 19,
        title:
          "Samos Island Tour: Pythagorio and Efpalio Tunnel",
        detail:
          "Explore Samos by bus, discovering the island’s rich history and scenic landscapes. Visit the charming village of Pythagorio, named after the renowned mathematician Pythagoras, and enjoy its picturesque harbor and historic ambiance. Continue to see the entrance of the Efpalio Tunnel, an ancient engineering marvel and one of the most impressive achievements of classical antiquity. Breakfast & Dinner Included."
      },
      {
        day: 20,
        title:
          "Departure from Samos – Connect via Athens to India",
        detail:
          "After Breakfast, Transfer to the airport for your flight from Samos to Athens, then connect to your flight to India."
      },

    ],

    overview: "When mentioning Greece, many people think of Santorini or ancient Greek civilization the cradle of Democracy. It is not only these. On this trip we will get a small taste of Greece and mainly we will get to know some of the most famous Greek islands. We will get to know their history, we will see how people live around the sea, we will literally dive into the blue waters of the Aegean Sea and we will taste Greek culinary flavors. The beginning will be from the capital city of Athens. We will get a small taste of the Greek countryside with a trip to the first capital of modern Greece, Nafplion and then we are going to visit the pearls, the islands. Not only Santorini but 7 of them, different among each other. At the end try to name which one is the most beautiful. You will have difficulties."
  },
  {
    id: "istanbul-001",
    slug: "classical-greece-and-istanbul",
    destination: "Istanbul",
    title: "Classical Greece and Istanbul",
    duration: "13 Nights 14 Days",
    route: "3N Athens | 1N Nafplio | 1N Patras | 1N Galaxidi | 1N Volos | 2N Thessaloniki | 1N Xanthi | 3N Istanbul",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jul 2026"],
    stars: 3,
    price: 226999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [athens,nafplio,patras,galaxidi,volos,thessaloniki,xanthi,istanbul],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Singapore", to: "Out of Bangkok", type: "Direct or 1 Stop" },
    //   { from: "Kuala Lumpur", to: "Bangkok", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Athens", nights: "3 Nights", type: "Good 3 Star Hotel" },
      { location: "Nafplio", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Patras", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Galaxidi", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Volos", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Thessaloniki", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Xanthi", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Istanbul", nights: "3 Nights", type: "Good 3 Star Hotel" },

    ],

    sightseeing: [
      { title: "Athens Sightseeing" },
      { title: "Nafplio Sightseeing" },
      { title: "Patras Sightseeing" },
      { title: "Galaxidi Sightseeing" },
      { title: "Volos Sightseeing" },
      { title: "Thessaloniki Sightseeing" },
      { title: "Xanthi Sightseeing" },
      { title: "Istanbul Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      // { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Athens City Tour with Archaeological Museum at Athens and Nafplio with Bourtzi Island Trip",
      "Acropolis and Temple of Poseidon at Sounio Experience",
      "Daily Dinner at an Indian or Local Restaurant",
      "Escorted by an Experienced English / Hindi-Speaking Tour Manager",
      "Olympia Archaeological Site and Nafpaktos Castle Visit",
      "Delphi Archaeological Site Visit",
      "Visit to Two Meteora Monasteries",
      "White Tower and Thessaloniki Archaeological Museum Visit",
      "Istanbul Guided Tour and Princes’ Islands Boat Trip",
      "Hagia Sophia Visit",
      "Privately owned, luxury buses, 2025 and 2026 models, with highly experienced drivers.",
      "Discover the ancient wonders of Athens, exploring the iconic Acropolis, Panathenaic Stadium, Syntagma Square, and the lively Monastiraki district.",
      "Enjoy a scenic excursion to Cape Sounion, visiting the dramatic Temple of Poseidon overlooking the sparkling Aegean Sea.",
      "Journey through legendary Greek history, visiting the Corinth Canal, the ancient kingdom of Mycenae, and the romantic seaside town of Nafplio with a boat ride to Bourtzi Fortress.",
      "Explore the spiritual and cultural heart of Greece, including Olympia, the birthplace of the Olympic Games, and the mystical sanctuary of Delphi.",
      "Experience the breathtaking beauty of Meteora and Thessaloniki, from the UNESCO-listed cliff-top monasteries to the vibrant city known for the White Tower and rich Macedonian heritage.",
    ],

    exclusions: [
      "City tax payable directly at hotel. (€6–€10 per person per night for 3–4 hotels)",
      "Tips for the driver, tour manager, and local tour guide are to be paid separately.",
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently for arrival and departure.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Athens",
        detail:
          "Arrive at Athens, transfer to your hotel and dinner. If you arrive early, enjoy some free time at leisure. Dinner Included."
      },
      {
        day: 2,
        title:
          "Athens City Tour: Akropolis & Syntagma",
        detail:
          "Tour Athens with visits to the Acropolis, the Archaeological Museum, and the Panathenaic Stadium (Kalimarmaro), the site of the first modern Olympic Games. Visit Syntagma Square to witness the ritual changing of the guards at the Greek Parliament. Enjoy free time for exploration in Monastiraki, the city’s oldest neighborhood. Breakfast & Dinner Included."
      },
      {
        day: 3,
        title:
          "Excursion to the Temple of Poseidon",
        detail:
          "Visit the Temple of Poseidon at the southern tip of the Attica peninsula. Breakfast & Dinner Included."
      },
      {
        day: 4,
        title:
          "Road to Nafplio: Corinth Canal, Mycenae & City Walk",
        detail:
          "Travel to Nafplio, considered one of the most beautiful and romantic cities in Greece and the former capital of the Greek state. En route, stop at the Corinth Canal, a marvel of engineering, and then visit Mycenae, home of King Agamemnon, including a tour of the royal tomb. Later, explore Nafplio and take a small boat to the island fortress of Bourtzi. Breakfast & Dinner Included."
      },
      {
        day: 5,
        title:
          "Through Peloponnese: Dimitsana & Olympia, Overnight in Patras",
        detail:
          "Cross the Peloponnese from east to west with a stop in Dimitsana, a traditional mountain village. Continue to Olympia, the ancient site where the original Olympic Games began, for a guided tour of the archaeological area and local museum. Breakfast & Dinner Included."
      },
      {
        day: 6,
        title:
          "Road Trip: Rio-Antirio Bridge, Nafpaktos & Galaxidi",
        detail:
          "Begin the journey north, passing over the impressive Rio–Antirio Bridge. Visit Nafpaktos, the site of two crucial naval battles. Explore the local castle and enjoy time for coffee in the town. Continue along the coast with a stop for a swim before arriving in the charming town of Galaxidi for a relaxing evening at the hotel. Breakfast & Dinner Included."
      },
      {
        day: 7,
        title:
          "Delphi Sightseeing & Arrival in Volos",
        detail:
          "Begin with a guided visit to the ancient site of Delphi, the seat of the famous oracle and considered the center of the ancient world. Afterwards, continue to Volos for accommodation. Enjoy time at local tavernas to experience traditional dishes and regional specialties. Breakfast & Dinner Included."
      },
      {
        day: 8,
        title:
          "Meteora Monasteries & Arrival in Thessaloniki",
        detail:
          "Experience the breathtaking Meteora monasteries, perched on the dramatic rock formations of Thessaly. Explore this UNESCO World Heritage Site and learn about the area’s natural and religious significance. Later, continue to Thessaloniki, Greece’s second-largest city, for hotel check-in and free time in the Ladadika area. Breakfast & Dinner Included."
      },
      {
        day: 9,
        title:
          "Thessaloniki City Tour: Landmarks and Museum",
        detail:
          "Enjoy a city tour of Thessaloniki, including stops at the White Tower, Gedi Kule Castle, the scenic sea promenade, and the Archaeological Museum, where the treasure of Philip II is on display. Savor time for coffee and take in the city’s rich history and culture. Breakfast & Dinner Included."
      },
      {
        day: 10,
        title:
          "From Thessaloniki to Xanthi via Kavala",
        detail:
          "Start your journey towards Turkey and Istanbul. Make your first stop in the picturesque city of Kavala to see one of the largest fishing fleets in Greece. Continue to Xanthi—a unique blend of Greek and Ottoman cultures—where you will wander through narrow streets and enjoy time in the town before continuing onward. Breakfast & Dinner Included."
      },
      {
        day: 11,
        title:
          "Arrival in Istanbul: Byzantine & Ottoman Splendor",
        detail:
          "Cross the border into Turkey and arrive in Istanbul, historically known as Constantinople. Experience the city’s unique fusion of Byzantine and Ottoman architecture, explore its neighborhoods, and immerse yourself in its vibrant culture. Arrive at the hotel and enjoy free time for shopping and personal exploration. Breakfast & Dinner Included."
      },
      {
        day: 12,
        title:
          "Istanbul City Tour: Hagia Sophia, Patriarchate & Dolmabahçe Palace",
        detail:
          "Embark on a guided city tour starting from Hagia Sophia, the iconic masterpiece of Byzantine Hellenism. Visit the Ecumenical Patriarchate, stroll through the palace district, and tour Dolmabahçe Palace, the “Versailles of the East.” See the impressive clock tower and mosque at the palace entrance. Breakfast & Dinner Included."
      },
      {
        day: 13,
        title:
          "Day Cruise to the Princes' Islands",
        detail:
          "Take a full-day cruise to the Princes’ Islands (Pringiponisia). This peaceful archipelago, with impressive 19th-century mansions and car-free streets, offers a tranquil escape from Istanbul’s busy life. Explore charming villages and lush green landscapes across the islands. Breakfast & Dinner Included."
      },
      {
        day: 14,
        title:
          "Departure from Istanbul",
        detail:
          "Breakfast Included and Transfer to the airport for your departure flight. End of tour."
      },

    ],

    overview: "At this trip we will attempt a connection between two civilizations, two different cultures that are so different, but also so similar. We will learn the ancient history of Greece, we will visit the cradle of civilization the Acropolis and some of the most characteristic monuments of the ancient world, such as Olympia, the place where the Olympic Games were born, the oracle of Delphi and the sanctuaries in the Nafplio area. We will visit the second largest city Thessaloniki and then with a visit to Xanthi we will connect Greece with Ottoman civilization. Istanbul and the shores of the Bosporus, once Constantinople for the Greeks, is the big city where we will end our trip."
  },
  // ================= Paris & Zurich =================
  {
    id: "paris-001",
    slug: "family-paradise-at-paris",
    destination: "Paris",
    title: "Family Paradise at Paris",
    duration: "7 Nights 8 Days",
    route: "7N Paris ",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Dec 2026"],
    stars: 4,
    price: 151999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [paris],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Singapore", to: "Out of Bangkok", type: "Direct or 1 Stop" },
    //   { from: "Kuala Lumpur", to: "Bangkok", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Paris", nights: "7 Nights", type: "Good 4 or 3 Star Hotel" },
    ],

    sightseeing: [
      { title: "Paris Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      // { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Disneyland Paris Visit",
      "Full day city tour of Eiffel Tower and Seine River Area",
      "Guided tour of Louvre Museum & Notre Dame Cathedral",
      "Full day visit of ZooParc de Beauval",
      "Daily Dinner (07) at Indian or Local Restaurant",
      "Escorted by an Experienced English / Hindi-Speaking Tour Manager",
      "Experience unmatched comfort with our privately owned luxury coaches, 2025 and 2026 models, operated by highly experienced drivers.",
      "Experience the timeless elegance of Paris, from a serene Seine River cruise to strolling through the grand boulevards of Haussmann, the glamorous Belle Époque districts, and the vibrant charm of Pigalle Square.",
      "Discover the heart of the City of Light with a guided tour including entry to the Eiffel Tower, scenic Parisian gardens, and a memorable Seine River Cruise.",
      "Step into the world of legendary art at the Louvre Museum, home to masterpieces like the Mona Lisa, Venus de Milo, and Winged Victory of Samothrace.",
      "Explore historic Paris at the Gothic Notre-Dame Cathedral, wander through Île de la Cité and the charming streets of Île Saint-Louis, and soak in the character of the Latin Quarter.",
      "Enjoy unforgettable family experiences, with a full-day visit to ZooParc de Beauval.",
      "Step into a world of magic with two unforgettable days at Disneyland Paris.",
      "Meals in Indian restaurants, but also in restaurants of other nationalities. A gastronomic paradise.",
      "Unwind with leisure time to explore, shop, and experience the city at your own pace.",
    ],

    exclusions: [
      "City tax payable directly at hotel. (€6–€10 per person per night for 3–4 hotels)",
      "Tips for the driver, tour manager, and local tour guide are to be paid separately.",
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently for arrival and departure.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival at the hotel in Paris",
        detail:
          "Arrival at the hotel, free time for leisure. Dinner Included."
      },
      {
        day: 2,
        title:
          "Paris City Tour - Eiffel Tower, Seine River Cruise",
        detail:
          "Enjoy a guided city tour covering the iconic Eiffel Tower and its nearby gardens, followed by a relaxing Seine River Cruise. Drive through the grand boulevards of Haussmann and explore the elegant Belle Époque areas of Paris. Conclude the tour with a stroll through the lively bars of Pigalle Square. Breakfast & Dinner Included."
      },
      {
        day: 3,
        title:
          "Louvre Museum & Notre Dame Exploration",
        detail:
          "Explore the Louvre Museum, admire masterpieces like Da Vinci's 'Jokonda', Michelangelo's 'Mortal Slave', Rodin's remarks on 'Aphrodite of Milos', and experience the Notre Dame Cathedral, Quartier Latin, Ile de la Cité and Ile Saint-Louis, immersing in Paris’s rich history and culture. Breakfast & Dinner Included."
      },
      {
        day: 4,
        title:
          "Day Trip to Zoo de Beauval",
        detail:
          "Visit ZooParc de Beauval, home to more than 35,000 animals, including the famous panda pair Huan Huan and Yuan Zi. Ranked among the top 5 zoos in the world, it offers one of the largest animal collections in France and Europe. Breakfast & Dinner Included."
      },
      {
        day: 5,
        title:
          "Disneyland Paris Adventure",
        detail:
          "Visit the magical Disneyland Paris. Experience exciting attractions like Pirates of the Caribbean, Indiana Jones Adventure Land, Space Mountain, meet beloved characters like Mickey and Donald, and enjoy spectacular shows. Breakfast & Dinner Included."
      },
      {
        day: 6,
        title:
          "Disneyland Paris - Additional Visit",
        detail:
          "Return to Disneyland Paris to revisit favorites or explore attractions missed on the previous day. Enjoy more magical experiences and entertainment. Breakfast & Dinner Included."
      },
      {
        day: 7,
        title:
          "Free Day for Shopping in Paris",
        detail:
          "Free day for shopping or leisure activities in Paris. Breakfast & Dinner Included."
      },
      {
        day: 8,
        title:
          "Departure from Paris",
        detail:
          "Departure to the airport for your return journey. Breakfast Included."
      },
    ],

    overview: "I am writing this text and as a father I am jealous. How many times in my life have I wished I had a week dedicated to my family so I could make the children happy as much as I can? This trip is the ultimate travel destination for families. Paris is a city associated with elegance, major fashion houses, perfumes and cosmetics, romantic and erotic atmosphere, famous cabarets, opera, museums, boutiques of leading French designers. A city that you can never get enough of, every time is like the first time! Shopping, strolling through the narrow streets of Montmartre and Pigalle Square, filled with chocolates and a melodious music to the ears, the French language! At the Beauval Zoo you will be introduced to the secrets of the animal kingdom and hand in hand with the children you will get to know the habits of the inhabitants of this world. But where everyone will really feel like a child is at Disneyland. That's why we give you two days there so you can have your fill! Advantage of the program is that we are not going to change hotel during all stay. It is an excellent program for families and for the older who want to feel like children again."
  },
  {
    id: "parisandzurich-002",
    slug: "swiss-paris-at-a-glance",
    destination: "Zurich",
    title: "Swiss Paris at a Glance",
    duration: "6 Nights 7 Days",
    route: "3N Zurich  | 3N Paris",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Dec 2026"],
    stars: 4,
    price: 195999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [zurich,paris],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Into Zurich", to: "Out of Paris", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "Zurich", nights: "3 Nights", type: "Radisson Hotel & Suites Zurich -  4 Star Hotel" },
      { location: "Paris", nights: "3 Nights", type: "The Jangle Hotel - Paris - Charles de Gaulle - Airport - 4 Star Hotel" },
    ],

    sightseeing: [
      { title: "Zurich Sightseeing" },
      { title: "Paris Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      // { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Stay in good 4-star hotels in Europe",
      "Ride the world’s first rotating cable car to Mt. Titlis and walk the thrilling Cliff Walk at 3,020m.",
      "Witness the breathtaking Rhine Falls – the largest waterfall in Europe.",
      "Enjoy a scenic orientation tour of Lucerne with its medieval charm and iconic landmarks.",
      "Admire panoramic views of Paris from the Eiffel Tower’s 2nd level and cruise the romantic Seine River.",
      "Experience the magic of Disneyland Paris with access to one enchanting Disney park.",
      "1 Indian Jain/Vegetarian/Non-Vegetarian Lunch.",
      "6 Indian Jain/Vegetarian/Non-Vegetarian Dinners.",
      "Services of an English/Hindi Experienced Tour Manager",
      "All Driver and Tour Manager Tips Included",
    ],

    exclusions: [
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Fare difference arising due to change in travel dates, sector, or airline",
      "Additional costs due to flight rescheduling, cancellation, or no-show",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently.",
      "Guests departing independently from Paris must arrange or pay for their transfers separately.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
      "Any services not explicitly mentioned in the inclusions",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Zurich Calling – The Swiss Chapter Begins",
        detail:
          "Welcome to Zurich, the financial capital of Switzerland and the gateway to the breathtaking Swiss Alps. Upon arrival at Zurich Airport, you’ll be warmly received by our local representative who will assist with the group transfer to your hotel. After check-in, take time to unwind and soak in the serene Swiss atmosphere. Depending on your arrival time, you may wish to explore the surroundings or simply relax after your journey. Zurich offers a unique blend of medieval charm and modern elegance, with its lakeside promenades, mountain views, and pristine streetscapes. In the evening, enjoy a delicious Indian dinner with your fellow travelers as you begin this exciting leg of your European adventure. Get ready for the days ahead filled with snow-covered peaks, scenic train rides, and charming alpine towns—this is Switzerland at its finest. Dinner"
      },
      {
        day: 2,
        title:
          "Paris City Tour - Eiffel Tower, Seine River Cruise",
        detail:
          "After breakfast, get ready for a thrilling alpine experience as we head to the mountain village of Engelberg. From here, enjoy a series of cable car rides leading up to the spectacular Mt. Titlis, culminating in the breathtaking Rotair, the world’s first revolving cable car. At 3,020 meters above sea level, soak in stunning 360-degree views of snow-covered peaks, deep crevasses, and glistening glaciers. Test your nerves with a walk on the Cliff Walk, Europe’s highest suspension bridge, perched along the edge of Mt. Titlis — an unforgettable experience! Later, we descend and travel to the beautiful city of Lucerne. Enjoy an orientation tour of its highlights, including the Chapel Bridge (Kapellbrücke) and the moving Lion Monument. Enjoy some free time to shop for Swiss souvenirs like watches, chocolates, and knives before heading back to Zurich. (Breakfast and Dinner)"
      },
      {
        day: 3,
        title:
          "Magical Alpine Excursion To The Top Of Europe – The Amazing Jungfraujoch And Scenic Interlaken (Extra Cost)",
        detail:
          "After breakfast, get ready for a truly magical Alpine experience. Today, you have the opportunity to join an unforgettable excursion to Jungfraujoch – The Top of Europe (available at an additional cost). We begin by heading to Grindelwald Terminal, where the state-of-the-art Eiger Express gondola swiftly takes you to Eigergletscher Station in just 15 minutes. From there, board the legendary cogwheel train that ascends to the highest railway station in Europe at 11,333 feet. At the summit, immerse yourself in a world of eternal snow and ice. Wander through the Ice Palace, where artists sculpt masterpieces in frozen form, and take in jaw-dropping views of the Aletsch Glacier from the panoramic Sphinx Observatory — a true high point of your European adventure. Those who prefer a more relaxed day can spend time in Interlaken, a scenic town nestled between two lakes and surrounded by the majestic Swiss Alps. Whether shopping for Swiss souvenirs or enjoying a lakeside walk, Interlaken offers a peaceful escape. Later in the day, regroup and return to Zurich for the night. (Breakfast and Dinner)"
      },
      {
        day: 4,
        title:
          "From the Roar of Rhine Falls to the Romance of Paris",
        detail:
          "After breakfast, check out and begin your day with a stop at one of Switzerland’s most captivating natural wonders – the Rhine Falls in Schaffhausen. As Europe’s largest waterfall, the Rhine Falls offers a mesmerizing sight as water thunders down a 150-meter-wide drop. Take in panoramic views from the observation decks, capturing unforgettable moments against a backdrop of mist and power. It’s the perfect way to bid farewell to Switzerland’s natural beauty. From here, relax in the comfort of your luxury coach as you journey across the Swiss-French border toward Paris, the world-renowned City of Lights. The long but scenic drive offers changing vistas – from serene Alpine valleys to charming French countryside – providing a smooth transition from nature’s raw grandeur to urban elegance. Upon arrival in Paris by early evening, complete the hotel check-in and take some time to relax. The evening is yours to explore at leisure—stroll around the vicinity or simply unwind after a scenic travel day. For those interested in an enchanting Parisian night, optional experiences like the Moulin Rouge Cabaret or Paris by Night tour can be arranged (at extra cost). Later, enjoy a comforting Indian dinner with the group, discussing the journey so far and looking ahead to Paris’ iconic attractions awaiting you in the coming days—Eiffel Tower, Seine Cruise, and Disneyland adventures. (Breakfast and Dinner)"
      },
      {
        day: 5,
        title:
          "Paris City Tour – Eiffel Tower 2nd Level & Seine River Cruise",
        detail:
          "After a delightful breakfast, embark on a panoramic guided city tour of Paris, exploring its most iconic and glamorous sights. Drive past the elegant Place Vendôme, Opéra Garnier, Musée d’Orsay, Place de la Concorde, and the world-renowned Champs-Élysées. Marvel at architectural wonders like the Arc de Triomphe, Alexander Bridge, and Les Invalides, each telling a story of the city’s rich history and grandeur. Next, ascend to the 2nd level of the Eiffel Tower, where breathtaking views of Paris await — an unforgettable photo opportunity! Later, set off on a romantic Seine River Cruise, drifting gently past stunning landmarks like Notre-Dame, Louvre Museum, and charming riverside façades. The illuminated bridges and skyline offer a dreamy Parisian evening experience. (Breakfast and Dinner)"
      },
      {
        day: 6,
        title:
          "A Magical Day at Disneyland Paris",
        detail:
          "Get ready for a day packed with fun, fantasy, and unforgettable experiences at Disneyland Paris, one of Europe’s most popular theme parks. Today, you can choose to explore either the enchanting Disneyland Park, where five immersive lands bring classic Disney tales to life, or the Walt Disney Studios Park, where movie magic takes center stage with thrilling shows, behind-the-scenes secrets, and jaw-dropping stunts. Feel the magic as you stroll through Sleeping Beauty’s Castle, join Captain Jack Sparrow on a pirate adventure, or zoom through space with Buzz Lightyear. Don’t miss the colourful street parades and character meet-and-greets that add charm to every corner of the park. At the studios, be amazed by professional stunt performances, discover how animation is created, and explore real-life film sets. Whether you're a thrill-seeker, a Disney fan, or just looking for a memorable day out, Disneyland Paris offers something for everyone — from adrenaline-pumping roller coasters to calm, whimsical rides for kids. Relish a day full of joy and wonder with your loved ones. (Breakfast and Dinner)"
      },
      {
        day: 7,
        title:
          "From Paris with Memories – Fly Back Home",
        detail:
          "After a magical journey across Europe, today marks the end of your unforgettable adventure. Begin your morning with a relaxed breakfast at the hotel, reflecting on the incredible memories you've made—from riding a gondola in Venice and standing beneath the Eiffel Tower, to admiring snow-covered Swiss peaks and strolling through Renaissance Florence. It’s time to bid farewell to Paris, the City of Lights, with its timeless charm and captivating elegance. Our team will assist with your group transfer to the airport as you prepare to fly back home. Ensure your bags are packed and passports ready as you leave with a heart full of memories, cherished moments, and new friendships. Though your holiday ends today, the stories and experiences will remain with you forever. We thank you for traveling with us and look forward to welcoming you again on another exciting journey through the wonders of the world."
      },

    ],

    overview: "Embark on a breathtaking journey that blends the pristine beauty of Switzerland with the timeless romance of France, creating an experience that feels both grand and deeply personal. In Switzerland, crisp alpine air, snow-covered peaks, and serene lakeside settings surround you with a sense of calm and wonder, while soaring high into the mountains offers moments that feel almost surreal — standing above the clouds, embraced by panoramic views and pure natural beauty. As the journey continues into France, the atmosphere shifts to elegance and charm, where stylish boulevards, artistic heritage, and glowing city lights create an unmistakable Parisian magic. Evenings feel romantic, mornings feel inspiring, and every transition brings a new emotion — from awe in the mountains to enchantment in the city. Perfectly balanced between adventure, culture, and playful experiences, this journey leaves you not only with stunning memories but also with a feeling of joy, inspiration, and European sophistication that lingers long after you return home."
  },
  {
    id: "paris&swizerland-001",
    slug: "paris-swiss-charm",
    destination: "Paris",
    title: "Paris & Swiss Charm",
    duration: "7 Nights 8 Days",
    route: "3N Paris | 2N Geneva | 2N Zurich",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026"],
    stars: 4,
    price: 232999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [paris,geneva,zurich],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Into Paris", to: "Out of Zurich", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "Paris", nights: "3 Nights", type: "The Jangle Hotel - Paris - Charles de Gaulle - Airport or similar - 4 Star Hotel" },
      { location: "Geneva", nights: "2 Nights", type: "Novotel Geneve Aeroport or similar -  4 Star Hotel" },
      { location: "Zurich", nights: "2 Nights", type: "Radisson Hotel & Suites Zurich -  4 Star Hotel" },
    ],

    sightseeing: [
      { title: "Paris Sightseeing" },
      { title: "Geneva Sightseeing" },
      { title: "Zurich Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      // { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "7 Nights Stay with 4 - Star Hotel Accommodation",
      "Daily Breakfast & Indian Dinner",
      "Comfortable AC Coach for all Transfers & Sightseeing",
      "Eiffel Tower 2nd Level",
      "Disneyland Paris",
      "Geneva Orientation Tour",
      "Glacier 3000 with Peak Walk by Tissot",
      "Gstaad Visit",
      "Golden Pass Scenic Train",
      "Lake Brienz Cruise",
      "Mt Titlis by Rotating Cable Car",
      "Chapel Bridge",
      "Lion Monument",
      "Zurich Orientation",
      "Airport Pickup from Paris Airport & Drop - off at Zurich Airport",
    ],

    exclusions: [
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Fare difference arising due to change in travel dates, sector, or airline",
      "Additional costs due to flight rescheduling, cancellation, or no-show",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently.",
      "Guests departing independently from Paris must arrange or pay for their transfers separately.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
      "Any services not explicitly mentioned in the inclusions",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Paris – The City of Romance, Lights & Glamour",
        detail:
          "Bienvenue à Paris! Welcome to the city of timeless romance and enchanting lights. Upon arrival and completion of immigration formalities, our friendly tour guide will be waiting to greet you and escort you to your hotel. After check-in, the rest of the day is yours to relax and soak in the Parisian vibe at your own pace. Stroll through the charming streets, sip a coffee at a sidewalk café, or simply unwind at the hotel. (Dinner)"
      },
      {
        day: 2,
        title:
          "Paris City Tour – Eiffel Tower 2nd Level And Romantic River Seine Cruise",
        detail:
          "After breakfast, embark on a guided city tour of Paris, a city synonymous with art, fashion, and history. The tour begins with some of the city’s most celebrated landmarks, including Place Vendôme, known for its elegant architecture and luxury boutiques, and Place de l’Opéra Garnier, home to the world-renowned opera house. Pass by Musée d’Orsay, housing masterpieces of Impressionist art, and Place de la Concorde, one of Paris’ largest and most historic public squares. Continue along the famed Champs Élysées, the city’s most fashionable avenue, and witness the grandeur of the Arc de Triomphe, an iconic monument celebrating France’s military history. Next, visit Eiffel Tower, ascending to the 2nd level for breathtaking panoramic views of Paris’ skyline. Standing beneath its iron lattice structure, you will feel the scale and significance of this architectural marvel. Afterward, enjoy a romantic cruise along the River Seine, a perfect way to admire Paris’ historic bridges and monuments from a unique perspective. Glide past the Notre Dame Cathedral, the Louvre Museum, and Les Invalides, taking in the picturesque scenery and capturing memorable photographs. The Seine cruise offers an intimate glimpse into Paris’ charm, blending history, art, and natural beauty. Return to the hotel in the evening for overnight stay in Paris. (Breakfast and Dinner)"
      },
      {
        day: 3,
        title:
          "Enjoy Your Fun Filled Day At Disneyland Paris",
        detail:
          "After breakfast at the hotel, prepare for a day full of magic and excitement at Disneyland Paris, one of Europe’s most popular amusement destinations. The park offers a perfect blend of entertainment, thrill rides, and family-friendly attractions, ensuring a memorable experience for all ages. You may choose to explore Disney Parks, where the enchanting lands bring fairy tales to life. From adventure-filled rides to vibrant street parades featuring beloved Disney characters, there is something to captivate every visitor. Experience the charm of Fantasyland, the adventure of Adventureland, and the magic of Main Street, U.S.A., all in one immersive experience. Alternatively, you may choose to visit Walt Disney Studios Park, where you can witness the behind-the-scenes magic of movie-making. Enjoy live stunt shows, observe real film sets, and explore interactive attractions that showcase the cinematic world. This unique experience allows visitors to engage with the art and craft of filmmaking, creating memories that go beyond ordinary amusement parks. Throughout the day, you can enjoy themed dining options, shopping, and interactive experiences. Capture photographs with your favorite Disney characters, enjoy thrilling rides, and soak in the immersive environment that Disneyland Paris offers. After a fun-filled day, return to your hotel in Paris for overnight stay. (Breakfast and Dinner)"
      },
      {
        day: 4,
        title:
          "From Paris to the Heart of Geneva",
        detail:
          "After a delightful breakfast in Paris, check out from your hotel and embark on a scenic drive to Geneva, Switzerland’s cosmopolitan gem. Nestled between Lake Geneva and the majestic Alps, the city perfectly blends natural beauty with international sophistication. Upon arrival, enjoy an orientation tour of Geneva, beginning with the iconic Jet d’Eau, one of the world’s tallest fountains, set against the sparkling waters of the lake. Stroll through the English Garden, home to the famous floral clock, a symbol of Swiss precision and artistry. Pass by the Palais des Nations, the European headquarters of the United Nations, and admire the Reformation Wall, commemorating key figures of the Protestant Reformation. Learn about Geneva’s rich history, diplomatic significance, and cultural charm from your guide as you explore the city’s highlights. Spend the evening at leisure, perhaps strolling along the serene lakeside promenade, enjoying the crisp alpine air, or relaxing at your hotel with a view of the lake and surrounding mountains. Geneva is a city that impresses with its elegance and calm energy, offering a perfect introduction to your Swiss adventure. Overnight stay is in the Lake Geneva region, ensuring a restful night before the excitement of the Alps begins. (Breakfast and Dinner)"
      },
      {
        day: 5,
        title:
          "Day trip to Gstaad - Glacier 3000",
        detail:
          "Start your day with breakfast at the hotel before heading to Glacier 3000, near the chic town of Gstaad. The journey itself offers breathtaking views of rolling Swiss landscapes and towering alpine peaks. Upon arrival, take a cable car ride to the glacier, where adventure awaits for all ages. Thrill-seekers can experience the 1-kilometre Alpine Coaster, the world’s highest bobsleigh track, or opt for husky sled rides, skiing, and the snow bus adventure. Don’t miss the Peak Walk by Tissot, Europe’s highest suspension bridge, offering jaw-dropping panoramic vistas of snow-capped mountains and icy crevasses. Enjoy a leisurely lunch at Botta 3000 or Oldegg, where local specialties are served amid stunning alpine views. On the return journey, stop at Gstaad, a charming and sophisticated town favored by celebrities and travelers worldwide. Wander its cobbled streets, explore boutique shops, or enjoy a coffee at a local café while soaking in its luxury ambiance. The day combines adrenaline, scenic beauty, and refined alpine charm, creating memories you’ll cherish forever. Return to your hotel for an overnight stay in the Lake Geneva region (Breakfast, Lunch and Dinner)"
      },
      {
        day: 6,
        title:
          "From Montreux to Zurich via the Golden Pass and Cruise on Lake Brienz",
        detail:
          "After breakfast, drive from Geneva to Montreux (approx. 1.5 hours), a charming resort town nestled on the shores of Lake Geneva and surrounded by snow-capped peaks. The scenic drive offers wonderful lake and vineyard views, setting the tone for a picturesque day ahead. Upon arrival, proceed for a short orientation tour of Montreux, renowned for its mild climate and beautiful lakeside setting. Stroll along the flower-lined promenade, admire the elegant Belle Époque architecture, and capture postcard-perfect photographs of the famous Chillon Castle, one of Switzerland’s most iconic landmarks gracefully standing on the lake’s edge. Later, board the GoldenPass panoramic train from Montreux to Zweisimmen, one of the most beautiful train journeys in the country. Relax in comfortable panoramic coaches as the route unfolds through rolling vineyards, Alpine meadows, charming chalets, and tranquil valleys, offering a glimpse of Switzerland’s natural beauty and rural charm. On arrival at Zweisimmen, continue your journey by road via Interlaken, a picturesque resort town nestled between Lake Thun and Lake Brienz. Here, enjoy a scenic cruise on Lake Brienz, known for its vivid turquoise waters and dramatic mountain backdrop. Glide past traditional Swiss villages and cascading waterfalls, immersing yourself in the serenity of the Bernese Oberland region. After this memorable experience, drive onward to Zurich, Switzerland’s vibrant financial and cultural hub. Upon arrival, check in to your hotel and unwind after a day filled with panoramic views and unforgettable sights. In the evening, you may explore the lively Bahnhofstrasse, one of Europe’s most exclusive shopping avenues, or enjoy a peaceful stroll along the Zurich lakeside promenade, soaking in the charm of Switzerland’s largest city. (Breakfast and Dinner)"
      },
      {
        day: 7,
        title:
          "World’s First Rotating Cable Car Rotair Up Mt. Titlis Peak At 3,020m - Orientation Tour of Lucerne",
        detail:
          "After breakfast, get ready for a thrilling alpine experience as we head to the mountain village of Engelberg. From here, enjoy a series of cable car rides leading up to the spectacular Mt. Titlis, culminating in the breathtaking Rotair, the world’s first revolving cable car. At 3,020 meters above sea level, soak in stunning 360-degree views of snow-covered peaks, deep crevasses, and glistening glaciers. Test your nerves with a walk on the Cliff Walk, Europe’s highest suspension bridge, perched along the edge of Mt. Titlis — an unforgettable experience! Later, we descend and travel to the beautiful city of Lucerne. Enjoy an orientation tour of its highlights, including the Chapel Bridge (Kapellbrücke) and the moving Lion Monument. Enjoy some free time to shop for Swiss souvenirs like watches, chocolates, and knives before heading back to Zurich (Breakfast and Dinner)"
      },
      {
        day: 8,
        title:
          "Departure from Zurich",
        detail:
          "landscapes of Switzerland. As you prepare for your journey home, take a moment to reflect on the unforgettable memories you’ve gathered — from the serene shores of Lake Geneva and the snow-capped peaks of Mt. Titlis to the charming towns of Lucerne and Zurich’s vibrant streets. Each destination has offered a unique experience — the tranquility of the Swiss Alps, the cultural grace of Austria, and the timeless beauty of Central Europe. With your camera full of pictures and your heart full of stories, transfer to Zurich Airport for your flight back home. Carry with you not just souvenirs, but the spirit of Europe — its charm, its culture, and the lasting memories of a journey you’ll cherish forever. (Breakfast)"
      },

    ],

    overview: "Embark on an enchanting 8-day journey where the romance of France meets the serene beauty of Switzerland in one seamless experience. In Paris, you’ll feel the city’s timeless elegance surround you — from relaxed boulevard moments and charming cafés to panoramic city views and magical evenings that glow with character. The atmosphere blends art, culture, and playful excitement, creating days that feel both refined and joyfully immersive. As the journey continues into Switzerland, the scenery transforms into pristine alpine landscapes, crystal-clear air, and storybook towns that radiate calm and sophistication. Snow-covered peaks, scenic mountain experiences, and lakeside charm offer a refreshing contrast to the vibrancy of Paris. Perfectly balanced between elegance and adventure, this journey leaves you with a heart full of romance, tranquillity, and unforgettable European memories."
  },
  // ================= Europe & Africa =================
  {
    id: "europe&africa-001",
    slug: "two-continents-explorer-portugal-morocco-gibraltar",
    destination: "Europe",
    title: "Two Continents Explorer: Portugal, Morocco, Gibraltar",
    duration: "16 Nights 17 Days",
    route: "2N Porto | 1N Coimbra | 3N Lisbon | 3N Marrakech | 2N Casablanca | 1N Rabat | 2N Fez | 1N Tangier | 1N Gibraltar ",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Oct 2026", "Dec 2026"],
    stars: 3,
    price: 293999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [porto,coimbra,lisbon,marrakech,casablanca,rabat,fez,tangier,gibraltar],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Singapore", to: "Out of Bangkok", type: "Direct or 1 Stop" },
    //   { from: "Kuala Lumpur", to: "Bangkok", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Porto", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Coimbra", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Lisbon", nights: "3 Nights", type: "Good 3 Star Hotel" },
      { location: "Marrakech", nights: "3 Nights", type: "Good 3 Star Hotel" },
      { location: "Casablanca", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Rabat", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Fez", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Tangier", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Gibraltar", nights: "1 Nights", type: "Good 3 Star Hotel" },

    ],

    sightseeing: [
      { title: "Porto Sightseeing" },
      { title: "Coimbra Sightseeing" },
      { title: "Lisbon Sightseeing" },
      { title: "Marrakech Sightseeing" },
      { title: "Casablanca Sightseeing" },
      { title: "Rabat Sightseeing" },
      { title: "Fez Sightseeing" },
      { title: "Tangier Sightseeing" },
      { title: "Gibraltar Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      // { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Experience the rare magic of Europe and Africa in a single itinerary, blending the elegance of Portugal with the mystique of Morocco, connected through the iconic Gibraltar.",
      "Explore UNESCO heritage cities, royal palaces, ancient medinas, and historic landmarks with expert-guided tours that bring every destination to life.",
      "From gondola rides in Aveiro and Lisbon’s panoramic viewpoints to Marrakech’s vibrant souks and Gibraltar’s Skywalk—every highlight is thoughtfully included.",
      "Enjoy a well-paced journey with multi-night stays in key cities like Lisbon and Marrakech, ensuring both immersive exploration and relaxed comfort.",
      "From coastal charm and medieval towns to desert gateways and blue-painted villages, every day offers postcard-perfect experiences.",
    ],

    exclusions: [
      "City tax payable directly at hotel. (€6–€10 per person per night for 3–4 hotels)",
      "Tips for the driver, tour manager, and local tour guide are to be paid separately.",
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently for arrival and departure.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Welcome to Porto: Gateway to Portuguese Heritage",
        detail:
          "Arrival at Porto and first meeting with the city. Built on the right bank of the Douro River, the city spreads harmoniously over the hills, still retaining its medieval appearance. The old districts stretch along the river with many traditional shops and the open market located on the quay. Porto represents tradition, human values, hard work and the strength of the soul of the Portuguese Nation. The name of the city means 'PORT', which reveals its true character. A British community developed in this port, which guided the cultivation of the grape varieties from which the famous 'PORT' wine is produced. From this port, wine was traded and shipped to Great Britain and all over the world. Dinner Included."
      },
      {
        day: 2,
        title:
          "Discover Porto: Timeless Architecture & Riverside Charm",
        detail:
          "Tour of the city. The Porto Cathedral is one of the most important sights of the city. Its long history begins with its foundation in the 12th century, its construction was completed in 1737, but since then it has undergone multiple additions and reconstructions. The Cathedral is one of the oldest and most historic buildings in Porto, and is considered the most valuable example of Romanesque architecture. The large square is a historic spot in the center of Porto, which has undergone many transformations since 1718 to acquire its characteristic elongated shape. It is surrounded by a series of historic buildings, and ends at the imposing building of the city's City Hall. In the afternoon, when we start to get hungry, we will visit the Cais da Ribeira area, which is the heart and most characteristic image of the city of Porto. Breakfast & Dinner Included."
      },
      {
        day: 3,
        title:
          "Aveiro & Coimbra: The Cultural Soul of Portugal",
        detail:
          "Departure for Aveiro. The city dates back to the 10th century, while the area was a maritime center and salt production area since Roman times, known by the Latin name Aviarium. It is also known as the 'Venice of Portugal' and is one of the small surprises of the country. There are the canals and the colorful boats (barcos moliceiros) that resemble gondolas. However, we recommend a boat ride. We continue to Coimbra. In the heart of the Beira Atlantico region is founded Coimbra of the 100000 citizens. The Upper Town is a journey back in time. Breakfast & Dinner Included."
      },
      {
        day: 4,
        title:
          "Coastal Beauty to Royal Elegance",
        detail:
          "Continue to trip south with first stop at Nazare. It is Portugal's most famous fishing village, it attracts visitors for its glorious beach and lively village life. You will be fascinated by the traditional costumes that the locals still wear. In Nazare, extreme surfers test their skills in waves that often reach great heights. Second stop at Obidos which is considered like one of Europe's most romantic villages due to its colorful bougainvillea-filled houses, Gothic-cobbled streets and whitewashed churches surrounding the 12th-century castle. Then visit to Sintra. It is 45 minutes from Lisbon and is the city where the wealthy chose to build their palaces. It has 33000 inhabitants and is included in the treasures of the UNESCO World Heritage. The Park and national Palace of Pena and Palacio National de Sintra are the most famous which we will visit. Pena Park is a whole forest of flowers and beautiful plants and a walk there is definitely worth it. Traditional old houses, narrow streets and historical buildings like the Cathedral. Sit in one of the many small cafes and restaurants and experience the relaxed vibe of the neighborhood. Breakfast & Dinner Included."
      },
      {
        day: 5,
        title:
          "Lisbon Highlights: Castles, Explorers & Panoramic Views",
        detail:
          "Tour of the city. Visit of Castelo de Sao Jorhe. This is a castle on the highest hill in the city offering unlimited views of Lisbon and the Tagus River. Beyond that, of course, this castle-fortress has a history that starts from the time of the Visigoths. Belem Tower, especially on a sunny day, takes you back to the time of the knights. It was built in the 16th century and beyond its defensive use, it also had a symbolic meaning as it was considered a monument dedicated to the discoveries of the famous Portuguese explorer Vasco Da Gama. After we will go at elevator de Santa Justa. Today it is used more as a tourist attraction and not so much as a means of transport. The main reason it's worth going up is the panoramic view it offers! On one side you can enjoy Lisbon from above and on the other an unreal medieval church (Carmo Convent) without a roof that survived the 1755 earthquake. Breakfast & Dinner Included."
      },
      {
        day: 6,
        title:
          "Lisbon at Leisure: Culture, Trams & Local Flavours",
        detail:
          "Another excursion to Lisbon, more relaxed today. The bridge Ponte 25 de Abril is characteristic and much photographed, which strongly reminds us of the bridge San Francisco in the USA. Among the most popular things a visitor can do in Lisbon is a ride on the famous yellow trams, which have been moving on the rails of the old, cobblestone streets of the Portuguese capital for decades. This is one of the most picturesque experiences you will have in the city, the most famous being the tram 28, which runs through historic districts such as Alfama and Graça. In one of Lisbon’s most famous squares, Praça do Império, just a few minutes’ walk from the Torre de Belém Tower, you will visit a masterpiece of Portuguese architecture. The truly stunning Catholic Jerónimos Monastery dates back to the 16th century and is now a UNESCO World Heritage Site. We will give you plenty of free time and we are sure you will spend most of it at the wonderful Time Out Market Lisboa, the liveliest food market in the city. Breakfast & Dinner Included."
      },
      {
        day: 7,
        title:
          "Into Africa: Arrival in Magical Marrakech",
        detail:
          "At the crossroads of Europe-Africa and the Mediterranean-Atlantic, Morocco has known many conquerors and settlers during its long history, each of whom left their mark on the culture and habits of its inhabitants. Desert, mountains and oases, colorful markets, kasbahs and medinas, imperial cities, picturesque villages and Bedouins, we have a journey ahead of us on the borders of West and East! Its history dates back to the 11th century. To this day, the city has been influenced by many cultures, including the Arabs and Berbers. Wandering through the ancient Medina, you’ll come across towering piles of spices, donkey-drawn carts and stalls selling aromatic dishes. Breakfast & Dinner Included."
      },
      {
        day: 8,
        title:
          "Marrakech Exploration: Souks, Palaces & Traditions",
        detail:
          "Tour of Marrakesh which is known as the “Red City” or “Daughter of the Desert”. Next to the central square begins the labyrinth of souks, with covered alleys, which are filled with the homonymous small shops that sell everything. In essence, however, the Medina area is full of streets or neighborhoods that specialize in whatever you might be looking for, e.g. metal, leather, fabric, etc. The alleys of the Medina, however, have no names, signs or numbers. That is why you should not go in alone. Either you will get a guide from the hotel (never from the street) or you will decide to do it together with your group, but with great care and making constant signs about where you are turning. A good trick is to constantly enter and exit the alleys in the square, so that you can orient yourself. Drivers, even those from hotels, receive a commission from specific shopkeepers and will try to take you wherever they want. Some of the shopkeepers may also try to make fun of you, while there are also street vendors who will follow you around. It is best to avoid them. The same happens in all cities. Keep these tips in mind. The bazaar is a way of life for Moroccans, so don't even think about skipping it. They will give you a price, you will lower it, you will give another price and after a game between serious and funny, they will sell you something, you will buy something and everyone will be happy. The Bahia Palace is the most important attraction in Marrakech. Fountains, beautiful tiles, arabesques in plaster and wood, make up a magnificent building. For many years it was the seat of the king of Morocco, while, during the years of French rule, it was the residence of the French governor. The second most visited attraction in Marrakech is the art deco house of Yves Saint Laurent, in the Majorelle Gardens. Wonderful gardens, with exotic bamboo and cacti, a space of harmony and tranquility. The ashes of its two creators, the legendary Yves Saint Laurent and his wife, were buried in the space. Breakfast & Dinner Included."
      },
      {
        day: 9,
        title:
          "Desert Gateway: Ouarzazate & Ait Ben Haddou",
        detail:
          "We leave for a daily trip to Quarzazate. The 'Gate of the Desert' was a fortress of the French Legionnaires. About five kilometers west of the city is the infamous film studio 'Atlas', where scenes from many films and television series have been filmed - Gladiator, Alexander the Great, Asterix and Cleopatra, Prison Break, The Mummy, Game of Thrones, etc. It is the largest film studio in the world, as well as a popular tourist destination. In fact, many of the sets of famous films remain intact. On the way back to Marrakech we will stop at the amazing fortified village of Ait Ben Haddou, which is a UNESCO World Heritage Site. Here the caravans carrying gold, salt and other valuable cargo stopped to rest, being safe and protected from robber raids. Due to its location and its picturesqueness, it has often been used as a film set. Breakfast & Dinner Included."
      },
      {
        day: 10,
        title:
          "Atlantic Escape to Casablanca via Essaouira",
        detail:
          "Morning departure for Essaouira, a city on the Atlantic coast, dressed in white and blue, which today is an important center of Moroccan artistic creation. Climb the castle and enjoy the magnificent view, walk along the ocean and listen to the chirping of seagulls... The life of the fishermen around the port is impressive, the smell is certainly somewhat repulsive. Then going to the North, we reach Casablanca which is the financial capital of Morocco. Breakfast & Dinner Included."
      },
      {
        day: 11,
        title:
          "Casablanca: Discover Morocco’s Modern Heart",
        detail:
          "City tour. We learned about Casablanca from the film of the same name with Jeffrey Bogart, but you get to know the real Casablanca by walking through the city's 'labyrinths', the small winding alleys with countless workshops and small shops inside the Medina, the old walled city. It has about 3.7 million inhabitants. Casa, as the locals call it, is also home to the largest religious monument in the Arab world after Mecca. Breakfast & Dinner Included."
      },
      {
        day: 12,
        title:
          "Rabat: The Elegant Capital Experience",
        detail:
          "Depart to the capital of Morocco, Rabat which is just 90 km away. It is small and 'packed' in size, but with labyrinthine alleys, a wonderful Medina and an impressive Kasbah, which in 2012 was declared a World Heritage Site by UNESCO. The Rue des Consuls leads from the south to the heart of the old city, which in the 17th century linked its name to the white slave market of the Berber pirates. Foreign diplomats arrived here to 'buy' their compatriots and essentially grant them their freedom. It is even said that a French diplomat was so good at it that the local rulers expelled him from the country because he... spoiled their work. Later, all foreign diplomats were forced to live on one street instead of scattered throughout the city, and that is how Rue de Consuls got its name, although now the houses mostly belong to powerful merchant families. The Kasbah of Udaya is a city within a city where about 2,000 people live today. It is a fortress built in the 12th century by the Almohad dynasty and is now a residential area. The view of the Atlantic from its highest points is impressive. The biggest “mistake” one can make in Morocco is… to watch their diet. The day starts with harsha, semolina pancakes with butter and honey, or amalou (ground almonds, honey and argan oil), while at lunch he will try freshly fried fish of the day accompanied by shlada (salad with chopped tomato, cucumber, onion, vinegar, olive oil), louvia and khubz (Moroccan bread). Be sure to try tangia (a type of thick soup with meat, vegetables and spices, simmered for hours in a ceramic pot) with plenty of bread, indulge in a portion of fried lamb cheeks, tongue and brains, served with chopped onion, and for dessert try fragrant halva. And of course, before you leave, you will drink several liters of green tea with mint, the refreshing beverage that the locals love. Breakfast & Dinner Included."
      },
      {
        day: 13,
        title:
          "Meknes & Volubilis: Imperial History Uncovered",
        detail:
          "Depart for Meknes. It is one of the four imperial cities of Morocco. One of the most iconic sights of the city is Bab el-Mansour, an impressive gate dating back to 1732. This monumental gate is not only known for its size, but also for its exquisite design. Next stop is the nearby UNESCO World Heritage Site of Volubilis. The ancient Roman ruins, dating back to the third century BC, offer a fascinating glimpse into the history of the region. Walk along the cobblestone streets, admire the well-preserved mosaics and imagine what life was like in this western outpost of the Roman Empire. Then we will arrive in imperial Fez. Fez is one of the most important cities in Morocco and the third largest, with about one million inhabitants. It comes from the union of two smaller cities that were separated by a wall, until the wall was torn down and bridges were built to connect the two parts of the now unified Fez. It is included in the list of cities that prohibit car traffic in their center, which is also on the list of UNESCO Cultural Heritage Sites. The largest ecclesiastical school in the world has been operating continuously in Fez since 859 AD. The presence of Spanish aristocrats is evident throughout the city, having created an excellent mix of Spanish and Arab architecture and culture. It is called the 'Mecca of the West' and the 'Athens of Africa'. Breakfast & Dinner Included."
      },
      {
        day: 14,
        title:
          "Fez: The Cultural & Spiritual Capital",
        detail:
          "Tour of Fez. Madrasah 'Bou Inania' is a historical building of religious importance that functions as a place of Islamic teaching and learning of the Quran. It has been recognized as a UNESCO World Heritage Site. It is considered one of the top examples of Islamic architecture in Morocco. Here future state officials are trained. In the southern part of the historical center of Fez, in the Mellah district, one finds the imposing building of the Royal Palace of Fez. Its foundation dates back to 1275 AD. A symbol of the Moroccan Monarchy with rich architectural beauty. Very close to the Royal Palace of Fez, is the Ibn Danan Synagogue. It was founded in the 17th century by a wealthy merchant, Mimon Boussidan. We will see the lively souks of Fes, where artisans make ceramics, leather goods, metalwork and textiles. We will watch live demonstrations by local artisans. Free time to visit the old city, the center of commerce and entertainment. Breakfast & Dinner Included."
      },
      {
        day: 15,
        title:
          "Chefchaouen & Tangier: From Blue Streets to Mediterranean Charm",
        detail:
          "Departure for Chefchaouen, due to its special color, it is one of the most special Moroccan cities. It is also called the blue city, as the houses of the Medina, the old city, are painted in blue, which, according to theories, repels mosquitoes or according to others symbolizes the color of the sky and spiritual life, while in recent years its preservation is due to the fact that it is the tourist attraction of the city. Here in the souks and alleys of the city you can do your shopping for woolen clothes, textiles and blankets, as well as local handicrafts that you will not find anywhere else in Morocco. The fate of the legendary and highly mysterious Tangier, opposite Gibraltar, was determined by its strategic location, for which many claimed and occupied it. The gateway to the Mediterranean was inhabited by Phoenicians, Romans, Arabs, Portuguese, Spanish, British and French. Those who have seen the film 'Tea in the Sahara' have entered the atmosphere of Tangier at the time when it became a place where almost anything was allowed. The bohemian life with an exotic background attracted all kinds of immigrants, mainly Europeans, who came here to reinvent themselves and create a new identity, literally and figuratively. Sex, prostitution, drugs, homosexuality, everything was allowed. The city evolved into an endless field of debauchery and pleasures for hedonists, tolerant of all those who ended up creating a universe entirely their own there. Burroughs, an iconic figure in American literature, wrote that 'Tangier is one of the few places in the world where, apart from serious crimes or acts of violence, you can do exactly what you want'. We will tour the Medina of Tangier. At the highest point of the Medina is the Kasbah, the fortified citadel that protected the city. In the heart of the Kasbah is the Museum of Mediterranean Civilizations, housed in the former palace of the Sultan, Dar el Makhzen, with collections that concern the history of the region from prehistoric times to the 19th century. Breakfast & Dinner Included."
      },
      {
        day: 16,
        title:
          "Gibraltar: Where Continents Meet",
        detail:
          "Transfer to the port and departure for Gibraltar. It is the 5th most densely populated place in the world. It is also called 'The rock'. Its inhabitants are of Spanish origin. Starting our tour we will head straight to the cable car. The first stop of the tour is at the Upper Rock of Gibraltar Nature Reserve, The Pillars of Hercules the best spot to see Africa on a clear day. Then we arrive at the floating platform known as the Skywalk. It is 340 meters above sea level, made of transparent glass, one of the main attractions of the rock that offers you a 360-degree view of two continents. It is built on the foundations of a World War II structure, and capacity is limited to 50 people. The San Miguel Cave is one of the main tourist attractions of Gibraltar. It is impressive not only because of the scenery full of stalactites and stalagmites and the falling drops, but also because of the light and sound show, called 'Awakening'. During the tour of the cave, which lasts about 15 minutes, the projection of lights on the walls will fascinate you, especially since some of the rocks seem to come to life. The ancient Greeks believed that this cave was the entrance to a mythological underworld, although others believed that it was a temple of Hercules. The Tunnels of Gibraltar are the highest point of the Rock and the view is unbeatable through the numerous windows. Breakfast & Dinner Included."
      },
      {
        day: 17,
        title:
          "A Graceful Farewell To An Extraordinary Experience",
        detail:
          "After Breakfast, Today marks the conclusion of your memorable journey, as guests proceed to the airport for their onward travels, taking with them cherished experiences from across continents."
      },

    ],

    overview: "Step into a journey where continents meet and cultures intertwine, taking you from the charming riverside streets of Porto to the vibrant souks of Marrakech. This thoughtfully crafted itinerary blends Europe’s timeless elegance with Morocco’s exotic allure, offering a seamless travel experience across iconic cities and hidden gems. Wander through historic capitals, admire architectural masterpieces, and indulge in authentic local experiences that capture the soul of each destination. From scenic gondola rides and royal palaces to bustling medinas and breathtaking viewpoints, every moment is designed to inspire. With guided tours, carefully selected stays, and unforgettable highlights included, this is more than a trip—it’s a story you’ll carry for a lifetime."
  },
  {
    id: "europe&africa-002",
    slug: "two-continents-grand-explorer-portugal-morocco-gibraltar-spain",
    destination: "Europe",
    title: "Two Continents Grand Explorer: Portugal, Morocco, Gibraltar, Spain",
    duration: "22 Nights 23 Days",
    route: "2N Porto | 1N Coimbra | 3N Lisbon | 3N Marrakech | 2N Casablanca | 1N Rabat | 2N Fez | 1N Tangier | 1N Gibraltar | 2N Seville | 1N Merida | 3N Madrid",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Oct 2026", "Dec 2026"],
    stars: 3,
    price: 425999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [porto,coimbra,lisbon,marrakech,casablanca,rabat,fez,tangier,gibraltar,seville,merida,madrid],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Singapore", to: "Out of Bangkok", type: "Direct or 1 Stop" },
    //   { from: "Kuala Lumpur", to: "Bangkok", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Porto", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Coimbra", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Lisbon", nights: "3 Nights", type: "Good 3 Star Hotel" },
      { location: "Marrakech", nights: "3 Nights", type: "Good 3 Star Hotel" },
      { location: "Casablanca", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Rabat", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Fez", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Tangier", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Gibraltar", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Seville", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Merida", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Madrid", nights: "3 Nights", type: "Good 3 Star Hotel" },

    ],

    sightseeing: [
      { title: "Porto Sightseeing" },
      { title: "Coimbra Sightseeing" },
      { title: "Lisbon Sightseeing" },
      { title: "Marrakech Sightseeing" },
      { title: "Casablanca Sightseeing" },
      { title: "Rabat Sightseeing" },
      { title: "Fez Sightseeing" },
      { title: "Tangier Sightseeing" },
      { title: "Gibraltar Sightseeing" },
      { title: "Seville Sightseeing" },
      { title: "Merida Sightseeing" },
      { title: "Madrid Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      // { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Daily Dinner at an Indian or Local Restaurant",
      "Escorted by an Experienced English / Hindi-Speaking Tour Manager",
      "Ticket For Palacio Da Bolsa Porto and Tour of Gondola Ride At Aveiro",
      "Guided Tour Of Porto",
      "Guided Tour Of Coimbra",
      "Guided Tour Of Lisbon with Tour To Sintra",
      "Tour To Castelo De Sao Jorge with Tour of Santa Justa Elevator",
      "Guided Tour Of Marrakech and Tour Of Ouarzazate with Tour to Bahia Palace",
      "Guided Tour Of Casablanca",
      "Guided Tour Of Rabat and Tour to Kasbah of Udayas",
      "Guided Tour Of Fez with Tour of Royal Palace Of Fez",
      "Guided Tour of Meknes with Tour to Archaeological Site Of Volubilis",
      "Guided Tour Of Tangier With Tour to Kasbah Of Tangier",
      "Guided Tour Of Chefchaouen",
      "Tour to Skywalk Platform and Tour to St. Michael’s Cave",
      "Guided Tour Of Seville",
      "Tour of Archaeological Site Media",
      "Guided Tour Of Madrid and Guided Tour Of Toledo",
      "Tour to Prado Museum and Royal Palace Of Madrid",
      "Privately owned, luxury buses, 2025 and 2026 models, with highly experienced drivers.",
      "Experience a unique two-continent journey combining the cultural richness of Europe and the exotic charm of Morocco in one seamless itinerary.",
      "Explore Portugal’s iconic destinations, including Porto, Lisbon, Sintra, and scenic coastal towns steeped in history and tradition.",
      "Discover the magic of Morocco, from vibrant souks and imperial cities to UNESCO-listed kasbahs and desert landscapes.",
      "Witness the historic crossroads at Gibraltar, offering breathtaking views where Europe meets Africa.",
      "Continue your journey through Spain’s cultural heart, covering Seville, Mérida, Toledo, and Madrid with their rich heritage, architecture, and local experiences.",
    ],

    exclusions: [
      "City tax payable directly at hotel. (€6–€10 per person per night for 3–4 hotels)",
      "Tips for the driver, tour manager, and local tour guide are to be paid separately.",
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently for arrival and departure.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Welcome to Porto: Gateway to Portuguese Heritage",
        detail:
          "Arrive in Porto and enjoy your first introduction to this charming riverside destination. Built along the right bank of the Douro River, Porto spreads gracefully across rolling hills, preserving its medieval character. Wander through the old districts that stretch along the river, filled with traditional shops and lively open markets on the quay. Porto embodies tradition, resilience, and the spirit of the Portuguese people. Its very name—meaning “port”—reflects its deep-rooted maritime identity. The city also has strong historical ties to a British community that played a key role in cultivating grape varieties used to produce the world-famous Port wine. From here, this iconic wine was exported to Great Britain and across the globe, shaping Porto’s legacy as a center of trade and culture. Dinner Included."
      },
      {
        day: 2,
        title:
          "Discover Porto: Timeless Architecture & Riverside Charm",
        detail:
          "Tour of the city. The Porto Cathedral is one of the most important sights of the city. Its long history begins with its foundation in the 12th century, its construction was completed in 1737, but since then it has undergone multiple additions and reconstructions. The Cathedral is one of the oldest and most historic buildings in Porto, and is considered the most valuable example of Romanesque architecture. The large square is a historic spot in the center of Porto, which has undergone many transformations since 1718 to acquire its characteristic elongated shape. It is surrounded by a series of historic buildings, and ends at the imposing building of the city's City Hall. In the afternoon, when we start to get hungry, we will visit the Cais da Ribeira area, which is the heart and most characteristic image of the city of Porto. Breakfast & Dinner Included."
      },
      {
        day: 3,
        title:
          "Aveiro & Coimbra: The Cultural Soul of Portugal",
        detail:
          "Departure for Aveiro. The city dates back to the 10th century, while the area was a maritime center and salt production area since Roman times, known by the Latin name Aviarium. It is also known as the 'Venice of Portugal' and is one of the small surprises of the country. There are the canals and the colorful boats (barcos moliceiros) that resemble gondolas. However, we recommend a boat ride. We continue to Coimbra. In the heart of the Beira Atlantico region is founded Coimbra of the 100000 citizens. The Upper Town is a journey back in time. Breakfast & Dinner Included."
      },
      {
        day: 4,
        title:
          "Coastal Beauty to Royal Elegance",
        detail:
          "Continue to trip south with first stop at Nazare. It is Portugal's most famous fishing village, it attracts visitors for its glorious beach and lively village life. You will be fascinated by the traditional costumes that the locals still wear. In Nazare, extreme surfers test their skills in waves that often reach great heights. Second stop at Obidos which is considered like one of Europe's most romantic villages due to its colorful bougainvillea-filled houses, Gothic-cobbled streets and whitewashed churches surrounding the 12th-century castle. Then visit to Sintra. It is 45 minutes from Lisbon and is the city where the wealthy chose to build their palaces. It has 33000 inhabitants and is included in the treasures of the UNESCO World Heritage. The Park and national Palace of Pena and Palacio National de Sintra are the most famous which we will visit. Pena Park is a whole forest of flowers and beautiful plants and a walk there is definitely worth it. Traditional old houses, narrow streets and historical buildings like the Cathedral. Sit in one of the many small cafes and restaurants and experience the relaxed vibe of the neighborhood. Breakfast & Dinner Included."
      },
      {
        day: 5,
        title:
          "Lisbon Highlights: Castles, Explorers & Panoramic Views",
        detail:
          "Tour of the city. Visit of Castelo de Sao Jorhe. This is a castle on the highest hill in the city offering unlimited views of Lisbon and the Tagus River. Beyond that, of course, this castle-fortress has a history that starts from the time of the Visigoths. Belem Tower, especially on a sunny day, takes you back to the time of the knights. It was built in the 16th century and beyond its defensive use, it also had a symbolic meaning as it was considered a monument dedicated to the discoveries of the famous Portuguese explorer Vasco Da Gama. After we will go at elevator de Santa Justa. Today it is used more as a tourist attraction and not so much as a means of transport. The main reason it's worth going up is the panoramic view it offers! On one side you can enjoy Lisbon from above and on the other an unreal medieval church (Carmo Convent) without a roof that survived the 1755 earthquake. Breakfast & Dinner Included."
      },
      {
        day: 6,
        title:
          "Lisbon at Leisure: Culture, Trams & Local Flavours",
        detail:
          "Another excursion to Lisbon, more relaxed today. The bridge Ponte 25 de Abril is characteristic and much photographed, which strongly reminds us of the bridge San Francisco in the USA. Among the most popular things a visitor can do in Lisbon is a ride on the famous yellow trams, which have been moving on the rails of the old, cobblestone streets of the Portuguese capital for decades. This is one of the most picturesque experiences you will have in the city, the most famous being the tram 28, which runs through historic districts such as Alfama and Graça. In one of Lisbon’s most famous squares, Praça do Império, just a few minutes’ walk from the Torre de Belém Tower, you will visit a masterpiece of Portuguese architecture. The truly stunning Catholic Jerónimos Monastery dates back to the 16th century and is now a UNESCO World Heritage Site. We will give you plenty of free time and we are sure you will spend most of it at the wonderful Time Out Market Lisboa, the liveliest food market in the city. Breakfast & Dinner Included."
      },
      {
        day: 7,
        title:
          "Into Africa: Arrival in Magical Marrakech",
        detail:
          "At the crossroads of Europe-Africa and the Mediterranean-Atlantic, Morocco has known many conquerors and settlers during its long history, each of whom left their mark on the culture and habits of its inhabitants. Desert, mountains and oases, colorful markets, kasbahs and medinas, imperial cities, picturesque villages and Bedouins, we have a journey ahead of us on the borders of West and East! Its history dates back to the 11th century. To this day, the city has been influenced by many cultures, including the Arabs and Berbers. Wandering through the ancient Medina, you’ll come across towering piles of spices, donkey-drawn carts and stalls selling aromatic dishes. Breakfast & Dinner Included."
      },
      {
        day: 8,
        title:
          "Marrakech Exploration: Souks, Palaces & Traditions",
        detail:
          "Tour of Marrakesh which is known as the “Red City” or “Daughter of the Desert”. Next to the central square begins the labyrinth of souks, with covered alleys, which are filled with the homonymous small shops that sell everything. In essence, however, the Medina area is full of streets or neighborhoods that specialize in whatever you might be looking for, e.g. metal, leather, fabric, etc. The alleys of the Medina, however, have no names, signs or numbers. That is why you should not go in alone. Either you will get a guide from the hotel (never from the street) or you will decide to do it together with your group, but with great care and making constant signs about where you are turning. A good trick is to constantly enter and exit the alleys in the square, so that you can orient yourself. Drivers, even those from hotels, receive a commission from specific shopkeepers and will try to take you wherever they want. Some of the shopkeepers may also try to make fun of you, while there are also street vendors who will follow you around. It is best to avoid them. The same happens in all cities. Keep these tips in mind. The bazaar is a way of life for Moroccans, so don't even think about skipping it. They will give you a price, you will lower it, you will give another price and after a game between serious and funny, they will sell you something, you will buy something and everyone will be happy. The Bahia Palace is the most important attraction in Marrakech. Fountains, beautiful tiles, arabesques in plaster and wood, make up a magnificent building. For many years it was the seat of the king of Morocco, while, during the years of French rule, it was the residence of the French governor. The second most visited attraction in Marrakech is the art deco house of Yves Saint Laurent, in the Majorelle Gardens. Wonderful gardens, with exotic bamboo and cacti, a space of harmony and tranquility. The ashes of its two creators, the legendary Yves Saint Laurent and his wife, were buried in the space. Breakfast & Dinner Included."
      },
      {
        day: 9,
        title:
          "Desert Gateway: Ouarzazate & Ait Ben Haddou",
        detail:
          "We leave for a daily trip to Quarzazate. The 'Gate of the Desert' was a fortress of the French Legionnaires. About five kilometers west of the city is the infamous film studio 'Atlas', where scenes from many films and television series have been filmed - Gladiator, Alexander the Great, Asterix and Cleopatra, Prison Break, The Mummy, Game of Thrones, etc. It is the largest film studio in the world, as well as a popular tourist destination. In fact, many of the sets of famous films remain intact. On the way back to Marrakech we will stop at the amazing fortified village of Ait Ben Haddou, which is a UNESCO World Heritage Site. Here the caravans carrying gold, salt and other valuable cargo stopped to rest, being safe and protected from robber raids. Due to its location and its picturesqueness, it has often been used as a film set. Breakfast & Dinner Included."
      },
      {
        day: 10,
        title:
          "Atlantic Escape to Casablanca via Essaouira",
        detail:
          "Morning departure for Essaouira, a city on the Atlantic coast, dressed in white and blue, which today is an important center of Moroccan artistic creation. Climb the castle and enjoy the magnificent view, walk along the ocean and listen to the chirping of seagulls... The life of the fishermen around the port is impressive, the smell is certainly somewhat repulsive. Then going to the North, we reach Casablanca which is the financial capital of Morocco. Breakfast & Dinner Included."
      },
      {
        day: 11,
        title:
          "Casablanca: Discover Morocco’s Modern Heart",
        detail:
          "City tour. We learned about Casablanca from the film of the same name with Jeffrey Bogart, but you get to know the real Casablanca by walking through the city's 'labyrinths', the small winding alleys with countless workshops and small shops inside the Medina, the old walled city. It has about 3.7 million inhabitants. Casa, as the locals call it, is also home to the largest religious monument in the Arab world after Mecca. Breakfast & Dinner Included."
      },
      {
        day: 12,
        title:
          "Rabat: The Elegant Capital Experience",
        detail:
          "Depart to the capital of Morocco, Rabat which is just 90 km away. It is small and 'packed' in size, but with labyrinthine alleys, a wonderful Medina and an impressive Kasbah, which in 2012 was declared a World Heritage Site by UNESCO. The Rue des Consuls leads from the south to the heart of the old city, which in the 17th century linked its name to the white slave market of the Berber pirates. Foreign diplomats arrived here to 'buy' their compatriots and essentially grant them their freedom. It is even said that a French diplomat was so good at it that the local rulers expelled him from the country because he... spoiled their work. Later, all foreign diplomats were forced to live on one street instead of scattered throughout the city, and that is how Rue de Consuls got its name, although now the houses mostly belong to powerful merchant families. The Kasbah of Udaya is a city within a city where about 2,000 people live today. It is a fortress built in the 12th century by the Almohad dynasty and is now a residential area. The view of the Atlantic from its highest points is impressive. The biggest “mistake” one can make in Morocco is… to watch their diet. The day starts with harsha, semolina pancakes with butter and honey, or amalou (ground almonds, honey and argan oil), while at lunch he will try freshly fried fish of the day accompanied by shlada (salad with chopped tomato, cucumber, onion, vinegar, olive oil), louvia and khubz (Moroccan bread). Be sure to try tangia (a type of thick soup with meat, vegetables and spices, simmered for hours in a ceramic pot) with plenty of bread, indulge in a portion of fried lamb cheeks, tongue and brains, served with chopped onion, and for dessert try fragrant halva. And of course, before you leave, you will drink several liters of green tea with mint, the refreshing beverage that the locals love. Breakfast & Dinner Included."
      },
      {
        day: 13,
        title:
          "Meknes & Volubilis: Imperial History Uncovered",
        detail:
          "Depart for Meknes. It is one of the four imperial cities of Morocco. One of the most iconic sights of the city is Bab el-Mansour, an impressive gate dating back to 1732. This monumental gate is not only known for its size, but also for its exquisite design. Next stop is the nearby UNESCO World Heritage Site of Volubilis. The ancient Roman ruins, dating back to the third century BC, offer a fascinating glimpse into the history of the region. Walk along the cobblestone streets, admire the well-preserved mosaics and imagine what life was like in this western outpost of the Roman Empire. Then we will arrive in imperial Fez. Fez is one of the most important cities in Morocco and the third largest, with about one million inhabitants. It comes from the union of two smaller cities that were separated by a wall, until the wall was torn down and bridges were built to connect the two parts of the now unified Fez. It is included in the list of cities that prohibit car traffic in their center, which is also on the list of UNESCO Cultural Heritage Sites. The largest ecclesiastical school in the world has been operating continuously in Fez since 859 AD. The presence of Spanish aristocrats is evident throughout the city, having created an excellent mix of Spanish and Arab architecture and culture. It is called the 'Mecca of the West' and the 'Athens of Africa'. Breakfast & Dinner Included."
      },
      {
        day: 14,
        title:
          "Fez: The Cultural & Spiritual Capital",
        detail:
          "Tour of Fez. Madrasah 'Bou Inania' is a historical building of religious importance that functions as a place of Islamic teaching and learning of the Quran. It has been recognized as a UNESCO World Heritage Site. It is considered one of the top examples of Islamic architecture in Morocco. Here future state officials are trained. In the southern part of the historical center of Fez, in the Mellah district, one finds the imposing building of the Royal Palace of Fez. Its foundation dates back to 1275 AD. A symbol of the Moroccan Monarchy with rich architectural beauty. Very close to the Royal Palace of Fez, is the Ibn Danan Synagogue. It was founded in the 17th century by a wealthy merchant, Mimon Boussidan. We will see the lively souks of Fes, where artisans make ceramics, leather goods, metalwork and textiles. We will watch live demonstrations by local artisans. Free time to visit the old city, the center of commerce and entertainment. Breakfast & Dinner Included."
      },
      {
        day: 15,
        title:
          "Chefchaouen & Tangier: From Blue Streets to Mediterranean Charm",
        detail:
          "Departure for Chefchaouen, due to its special color, it is one of the most special Moroccan cities. It is also called the blue city, as the houses of the Medina, the old city, are painted in blue, which, according to theories, repels mosquitoes or according to others symbolizes the color of the sky and spiritual life, while in recent years its preservation is due to the fact that it is the tourist attraction of the city. Here in the souks and alleys of the city you can do your shopping for woolen clothes, textiles and blankets, as well as local handicrafts that you will not find anywhere else in Morocco. The fate of the legendary and highly mysterious Tangier, opposite Gibraltar, was determined by its strategic location, for which many claimed and occupied it. The gateway to the Mediterranean was inhabited by Phoenicians, Romans, Arabs, Portuguese, Spanish, British and French. Those who have seen the film 'Tea in the Sahara' have entered the atmosphere of Tangier at the time when it became a place where almost anything was allowed. The bohemian life with an exotic background attracted all kinds of immigrants, mainly Europeans, who came here to reinvent themselves and create a new identity, literally and figuratively. Sex, prostitution, drugs, homosexuality, everything was allowed. The city evolved into an endless field of debauchery and pleasures for hedonists, tolerant of all those who ended up creating a universe entirely their own there. Burroughs, an iconic figure in American literature, wrote that 'Tangier is one of the few places in the world where, apart from serious crimes or acts of violence, you can do exactly what you want'. We will tour the Medina of Tangier. At the highest point of the Medina is the Kasbah, the fortified citadel that protected the city. In the heart of the Kasbah is the Museum of Mediterranean Civilizations, housed in the former palace of the Sultan, Dar el Makhzen, with collections that concern the history of the region from prehistoric times to the 19th century. Breakfast & Dinner Included."
      },
      {
        day: 16,
        title:
          "Gibraltar: Where Continents Meet",
        detail:
          "Transfer to the port and departure for Gibraltar. It is the 5th most densely populated place in the world. It is also called 'The rock'. Its inhabitants are of Spanish origin. Starting our tour we will head straight to the cable car. The first stop of the tour is at the Upper Rock of Gibraltar Nature Reserve, The Pillars of Hercules the best spot to see Africa on a clear day. Then we arrive at the floating platform known as the Skywalk. It is 340 meters above sea level, made of transparent glass, one of the main attractions of the rock that offers you a 360-degree view of two continents. It is built on the foundations of a World War II structure, and capacity is limited to 50 people. The San Miguel Cave is one of the main tourist attractions of Gibraltar. It is impressive not only because of the scenery full of stalactites and stalagmites and the falling drops, but also because of the light and sound show, called 'Awakening'. During the tour of the cave, which lasts about 15 minutes, the projection of lights on the walls will fascinate you, especially since some of the rocks seem to come to life. The ancient Greeks believed that this cave was the entrance to a mythological underworld, although others believed that it was a temple of Hercules. The Tunnels of Gibraltar are the highest point of the Rock and the view is unbeatable through the numerous windows. Breakfast & Dinner Included."
      },
      {
        day: 17,
        title:
          "Transition Day: Continue Your Journey into Spain",
        detail:
          "Today marks a seamless transition in your journey, as the experience evolves from North Africa back into Europe. Get ready to step into the vibrant landscapes and cultural richness of Spain as the next chapter begins. Breakfast & Dinner Included."
      },
      {
        day: 18,
        title:
          "Seville: The Heartbeat of Andalusia",
        detail:
          "Tour of the city. The charm of Seville, capital of the Spanish south and the region of Andalusia, is captivating. Surely this is due to its unique monuments, which reflect its successive possessions by various peoples and coexist harmoniously, shaping its unique character. But it is also due to its unique neighborhoods, the narrow streets that are buzzing with life, the blinding white and vibrant yellow of the buildings that sparkle under the Mediterranean sun, the sounds of the flamenco castanets that join the Spanish guitars, to the smell of jasmine that mingles with the scent of orange trees in enclosed courtyards, to the dozens of flavors of delicious tapas accompanied by a glass of Fino or Manzanilla wine. Breakfast & Dinner Included."
      },
      {
        day: 19,
        title:
          "Mérida: Roman Legacy in Spain",
        detail:
          "The capital of Extremadura is nothing like a Spanish city. An aura of Italy and Rome blows through the narrow streets and cobblestones, between temples and historical buildings that are considered among the most important Roman monuments in the country. It was founded by the Romans in 25 BC. It began as a colony of veterans of the 5th and 10th Legions, flourished and gradually occupied a leading role as the capital of the province. With a population of 50,000 inhabitants, it was the largest Roman city in the Iberian Peninsula, the political and cultural center of the entire peninsula. The center of its life is the arched Plaza de España, decorated by the 13th century church of Santa Maria la Mayor. In front of the Roman Triumphal Arch, with the four rows of columns that formed the northern gate of the Roman city, we can see the Archaeological Museum of Visigothic Art, which is worth a visit to admire objects from the Visigoth era. Next is the Temple of Artemis, dedicated to Caesar Augustus. Next stop south of the square, on the banks of the Guadiana River, which runs through the city. The Alcazaba fortress, a Moorish castle from 855, was built by extending an early Roman and Visigothic building that was later converted into a monastery of the Order of Santiago. The emblem of the city is the Roman theater that we find on José Ramόn Melida Street. The architectural masterpiece, the work of Agrippa, is located on the San Albin hill and is still preserved in excellent condition. It is a miniature of the great theaters of Rome, with a capacity of 6,000 spectators and decorated with statues of gods and emperors. You wouldn't call a Roman city without a hippodrome. Located at the end of Avenida Extremadura, the Circus Maximus could accommodate up to 30,000 spectators, who flocked to enjoy chariot races. Arrival at the hotel and check in. It is dinner time. Many people choose to visit various tapas bars and try a beer or a drink, accompanied by delicious appetizers, instead of large restaurants. Cooked meat and soup remain important components of the local cuisine. Also try cold soup with tomato, peppers, cucumber, garlic (gazpacho), almonds and bread (ajoblanco), hare and partridge, stuffed trout, trout with garlic, smoked goat cheese, pig's ears, wild asparagus. And for dessert dulces abrillantados, that is, glazed sweets. Fruity wines accompany the tasty feast. Breakfast & Dinner Included."
      },
      {
        day: 20,
        title:
          "Toledo to Madrid: A Journey Through Civilizations",
        detail:
          "Breakfast and depart for Toledo. The 'Walled City', as its name implies, was also the center of the Βisigoths kingdom and the Catholic Spanish many centuries later, as well as the religious and cultural center of the country for many years. It is a fortress city, built on a large rocky outcrop, whose three sides are washed by the Tagus River. The former Spanish capital is now a UNESCO World Heritage Site, an amalgam of three different civilizations, a crossroads where diverse cultures coexisted and where it is Moorish, Jewish and Christian history is still perfectly preserved. The Cathedral has been a medieval symbol of the city since 1493, when it was completed. As soon as you pass one of its three main spectacular gates, you will find that the perfection of the Spanish Gothic exterior gives way to the French Gothic interior, which reaches an impressive length of 120 meters. Alcázar is the city's symbol-fortress. Overlooking Toledo from its highest point at 550 meters, the fortress built by the Arab conquerors as the city's main fortress is located on the site where the Roman governor was based centuries ago and is the city's most recognizable landmark. Museo de Santa Cruz is the city's most important museum. It is housed in the former Santa Cruz hospital. Part of the city's rich cultural heritage is due to the fact that the great painter Domenicos Theotokopoulos linked his name with Toledo. Τhe great representative of Mannerism from Crete spent almost 40 years in Toledo, until his death in 1614, creating some of his most outstanding works. In the Casa de El Greco, which consists of two simple houses with a common courtyard, the visitor comes into contact with Theotokopoulos' last artistic period and some of the most important works he created, perfecting his characteristic personal style. Breakfast & Dinner Included."
      },
      {
        day: 21,
        title:
          "Madrid: Royal Grandeur & Artistic Treasures",
        detail:
          "We will begin our wanderings from Plaza Mayor, the central square of Madrid and one of the most popular attractions for both locals and visitors. It is a huge enclosed block of 129 by 94 meters, surrounded by three-story buildings, which have 237 balconies and are part of a uniform architecture overlooking the square. There are three emblematic museums of Madrid - Prado, Thyssen-Bornesmisza and Reina Sofia. We will visit one of them. Here you will admire works by Dali, El Greco, Goya, Picasso and countless other artists. The Royal Palace of Madrid is an 18th century palace, one of the most magnificent and best preserved palaces in Europe. Breakfast & Dinner Included."
      },
      {
        day: 22,
        title:
          "Madrid: Shopping & Local Experiences",
        detail:
          "The Queen of Spain is a modern metropolis with many hidden treasures and a strong pulse in every corner. Point 0 is in the cosmopolitan Puerta Del Sol. Everything is around. The day is free for shopping and relaxing. There are many shopping areas in Madrid, each one different and unique. The exclusive Salamanca, the youthful Argüelles, the trendy Fuencarral, and the ancient Preciados La Salle and Rastro are all popular. Arguelles is a fashion and youth clothing area. All the boutiques in the neighborhood are concentrated on either side of Princesa Street. The trendy shops blend perfectly with the local 19th century architecture. Quatro-Caminos is the shopping district of Spanish brands. Shoes, clothes, jewelry and luxury fabrics. The trendy shops are complemented by a variety of cafes and restaurants, offering the perfect place to relax after a long walk through the corridors. El Rastro is Madrid's most famous open-air market. For those who haven't had enough of museums and archaeological sites, another good idea is to visit the famous Prado Museum. Breakfast & Dinner Included."
      },
      {
        day: 23,
        title:
          "Departure: Farewell to an Unforgettable Journey",
        detail:
          "After Breakfast, Transfer to the airport. Flight back home."
      },

    ],

    overview: "Experience an extraordinary journey across two continents, seamlessly blending the cultural richness of Europe with the exotic charm of Morocco. This thoughtfully designed itinerary takes you through Portugal’s historic cities, Morocco’s vibrant medinas and desert landscapes, and Spain’s iconic cultural destinations. From the scenic beauty of Porto and Lisbon to the timeless allure of Marrakech, Fez, and Chefchaouen, and further into the architectural and cultural heart of Spain, every destination offers a unique and immersive experience. Bridged by the legendary Gibraltar, this grand tour is a perfect mix of history, culture, and diverse landscapes — crafted for travellers seeking a truly enriching and memorable international journey."
  },
  {
    id: "europe-002",
    slug: "the-untouched-by-time-diamonds-of-the-old-Europe",
    destination: "Europe",
    title: "The Untouched by Time Diamonds of the Old Europe",
    duration: "14 Nights 15 Days",
    route: "2N Vienna | 2N Budapest | 1N Liptovsky |  Mikulas | 1N Olomouc | 2N Krakow | 2N Warsaw | 1N Gdansk | 3N Prague",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 3,
    price: 225999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [vienna,budapest,liptovsky,mikulas,olomouc,krakow,warsaw,gdansk,prague],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Singapore", to: "Out of Bangkok", type: "Direct or 1 Stop" },
    //   { from: "Kuala Lumpur", to: "Bangkok", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Vienna", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Budapest", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Liptovsky Mikulas", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Olomouc", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Krakow", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Warsaw", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Gdansk", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Prague", nights: "3 Nights", type: "Good 3 Star Hotel" },

    ],

    sightseeing: [
      { title: "Vienna Sightseeing" },
      { title: "Budapest Sightseeing" },
      { title: "Liptovsky Mikulas Sightseeing" },
      { title: "Olomouc Sightseeing" },
      { title: "Krakow Sightseeing" },
      { title: "Warsaw Sightseeing" },
      { title: "Gdansk Sightseeing" },
      { title: "Prague Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      // { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Daily Dinner at an Indian or Local Restaurant",
      "Vienna and Bratislava City Tour with Visit to Castle",
      "Schönbrunn Palace Experience",
      "Vienna Natural History Museum and Kunsthistorisches Museum Visit",
      "Escorted by an Experienced English / Hindi-Speaking Tour Manager",
      "Budapest Guided City Tour and Royal Castle Visit",
      "Olomouc Guided Tour and Ostrava Mining Area Visit",
      "Auschwitz and Wawel Castle Experience",
      "Kraków Guided City Tour",
      "Wieliczka Salt Mine and Jasna Góra Monastery Visit",
      "Warsaw Guided City Tour and Royal Castle Visit",
      "Privately owned, luxury buses, 2025 and 2026 models, with highly experienced drivers.",
      "Experience the imperial elegance of Vienna, visiting the magnificent Schönbrunn Palace and the world-class Kunsthistorisches Museum.",
      "Discover charming Bratislava and vibrant Budapest, with hilltop castle views, the stunning Fisherman’s Bastion, and an authentic Hungarian dinner experience, including a very beautiful evening at a traditional tavern with gypsy violins and lively dance performances.",
      "Journey through the scenic Tatra Mountains, visiting historical cities, admiring the lush green high mountains and snow-covered landscapes during winter, enjoying festive local celebrations with traditional dances and costumes, and savoring famous regional beers.",
      "Uncover Poland’s rich heritage, with stays in Krakow and Warsaw, plus a visit to the remarkable Wieliczka Salt Mine and the revered Jasna Góra Monastery, along with a separate visit to the coastal city of Gdansk.",
      "Conclude in magical Prague, exploring Prague Castle, the Astronomical Clock, Charles Bridge, and the elegant spa town of Karlovy Vary.",
    ],

    exclusions: [
      "City tax payable directly at hotel. (€6–€10 per person per night for 3–4 hotels)",
      "Tips for the driver, tour manager, and local tour guide are to be paid separately.",
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently for arrival and departure.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Vienna",
        detail:
          "Arrive in Vienna, the imperial capital of Austria, famed for its Baroque architecture, world-class art collections, and rich cultural history. Transfer to the hotel. An optional excursion to the city center includes exploring Kärntnerstrasse with its elegant shops, famous cafés, and the imposing St. Stephen’s Cathedral. Stroll along Vienna’s most popular commercial streets such as Mariahilfer Strasse, Graben, and Kohlmar. Dinner Included."
      },
      {
        day: 2,
        title:
          "Vienna City Tour and Free Afternoon",
        detail:
          "Enjoy a city tour in Vienna. Explore the magnificent Schönbrunn Palace, the former summer residence of the Habsburgs, which attracts millions of visitors annually. Visit the Kunsthistorisches Museum, Austria’s largest and one of the richest fine arts museums in the world, along with the twin Natural History Museum, renowned for its impressive collections and architecture. In the afternoon, enjoy free time to discover Vienna’s romantic ambiance; perhaps take a horse-drawn carriage ride and savor a hot chocolate at a historic café. Breakfast & Dinner Included."
      },
      {
        day: 3,
        title:
          "Transfer: Vienna – Bratislava city tour – Onwards to Budapest",
        detail:
          "Depart Vienna and head east to Slovakia’s capital, Bratislava. Explore its charming central square, Hlavné námestie, the Old Town Hall, Bratislava Castle, the medieval St. Michael’s Gate, and St. Martin’s Cathedral. Visit the Church of the Annunciation (Franciscan Church) and Mirbach Palace, experiencing the architectural splendor and nostalgic atmosphere. Enjoy time in Bratislava’s traditional shops, restaurants, and breweries. Continue onward to Budapest, Hungary, for a two-night stay. Arrive and enjoy leisure time in Budapest. Breakfast & Dinner Included."
      },
      {
        day: 4,
        title:
          "Budapest City Tour and Traditional Dinner",
        detail:
          "Embark on a guided tour of Budapest. Visit Fisherman’s Bastion for panoramic views, Matthias Church, and St. Stephen’s Basilica. Explore the Royal Castle on Castle Hill, with its restored medieval fortifications and impressive museums. Take a funicular ride and admire historical monuments. In the evening, enjoy time at a traditional tavern with gypsy violin music. Breakfast & Dinner Included."
      },
      {
        day: 5,
        title:
          "Transfer: Budapest – Banská Štiavnica – Tatra Mountains – Liptovsky Mikulas",
        detail:
          "Depart from Budapest, heading to the picturesque Slovak town of Banská Štiavnica for a brief visit. Enter the Tatra mountain range, marveling at its high peaks, forests, lakes, and charming towns. Cross the mountains from south to north, enjoying the scenic journey, and arrive at Liptovský Mikuláš for an overnight stay. Breakfast & Dinner Included."
      },
      {
        day: 6,
        title:
          "Transfer: Liptovsky Mikulas – Žilina – Olomouc Exploration",
        detail:
          "Travel toward Žilina for a coffee break. Cross the border into Moravia in the Czech Republic, heading to Olomouc. Discover the city’s many Baroque fountains, the historic Holy Trinity Column (UNESCO), the unique astronomical clock, and St. Wenceslas’ Cathedral. Try the region’s famous tvarůžky cheese with Czech beer. Breakfast & Dinner Included."
      },
      {
        day: 7,
        title:
          "Transfer: Olomouc – Ostrava – Auschwitz – Krakow",
        detail:
          "Depart Olomouc for Poland, stopping en route in Ostrava to visit the city’s historic mines and enjoy coffee in the main square. Cross into Poland, then continue to Auschwitz for a moving visit to the former concentration camp and its museum. Breakfast & Dinner Included."
      },
      {
        day: 8,
        title:
          "Krakow City Tour and Wieliczka Salt Mines",
        detail:
          "Experience the medieval charm of Kraków, built along the Vistula River. Enjoy a guided city tour: see Wawel Castle and Cathedral, Kanonicza Street, the Church of Saints Peter and Paul, and the vibrant Rynek Główny square with its iconic Sukiennice. Then, take an excursion to the UNESCO-listed Wieliczka Salt Mines, touring its fascinating underground chapels and statues. Breakfast & Dinner Included."
      },
      {
        day: 9,
        title:
          "Transfer: Krakow – Częstochowa – Warsaw",
        detail:
          "Depart Kraków and make a pilgrimage stop at Częstochowa to visit the revered Jasna Góra Monastery and the miraculous Black Madonna icon. Continue to Warsaw, the dynamic Polish capital, rebuilt after World War II and now a UNESCO World Heritage Site. Breakfast & Dinner Included."
      },
      {
        day: 10,
        title:
          "Warsaw City Tour",
        detail:
          "Enjoy a city tour in Warsaw. Walk through the Old Town with its beautifully reconstructed Renaissance, Baroque, Gothic, and Neoclassical architecture centered on the main square and its mermaid statue. Visit the Royal Castle and its rich art collections, and take a stroll in the gardens of the impressive Wilanów Palace. Marvel at the grand Palace of Culture and Science and enjoy views from its observation deck. Return to the hotel and enjoy leisure time. Breakfast & Dinner Included."
      },
      {
        day: 11,
        title:
          "Transfer: Warsaw – Gdansk City Exploration",
        detail:
          "Travel to Gdańsk, a scenic Baltic Sea city marked by centuries of commerce and multicultural heritage. Explore Ulica Długa and Długi Targ (Long Street/Long Market), the Neptune Fountain, Golden House, Main Town Hall, and Uphagen House for a glimpse into Gdańsk’s unique architecture and history. Breakfast & Dinner Included."
      },
      {
        day: 12,
        title:
          "Transfer: Gdansk – Prague (Group Dinner)",
        detail:
          "Depart for Prague on a long but rewarding journey. Arrive in the enchanting “City of 100 Towers,” Prague, with its fairy-tale ambiance and medieval architecture. Transfer to the hotel, followed by time at a Czech traditional restaurant. Breakfast & Dinner Included."
      },
      {
        day: 13,
        title:
          "Prague Castle, Old Town, Charles Bridge & Local Experiences",
        detail:
          "Explore the highlights of Prague: tour Prague Castle and Saint Vitus Cathedral, visit Golden Alley, view the world-famous Astronomical Clock in the Old Town Square, and walk along the historic Charles Bridge. Enjoy the lively local beer halls with typical food and beverages. Return to the hotel after an engaging day. Breakfast & Dinner Included."
      },
      {
        day: 14,
        title:
          "Excursion: Karlovy Vary Spa Town & Return to Prague",
        detail:
          "Travel to Karlovy Vary, one of the world’s most famous spa towns, celebrated for its hot springs, Art Nouveau architecture, and lush surroundings. Walk along the renowned colonnades and take in the town’s unique atmosphere. Return to Prague and spend the rest of the day at leisure. Breakfast & Dinner Included."
      },
      {
        day: 15,
        title:
          "Departure from Prague",
        detail:
          "Breakfast at your hotel and transfer to the airport for your flight home. End of services."
      },

    ],

    overview: "A 15-day immersive journey through the heart of Central and Eastern Europe, blending imperial elegance, medieval charm, dramatic history, and breathtaking landscapes. From the grandeur of Vienna and Budapest to the resilient spirit of Warsaw, the Baltic beauty of Gdansk, and the fairytale romance of Prague, this tour offers a rich tapestry of cultures shaped by empires, revolutions, and artistic brilliance. Travelers will cross mountain ranges, walk through UNESCO-listed old towns, reflect at powerful historical memorials, and experience authentic regional traditions. Perfect for culturally curious travelers, history enthusiasts, and those seeking a deeper European exploration beyond the typical Western routes — this is a comprehensive, emotionally enriching, and visually spectacular Central European experience."
  },
  {
    id: "europe-003",
    slug: "european-metropolis",
    destination: "Europe",
    title: "European Metropolis",
    duration: "25 Nights 26 Days",
    route: "3N London | 2N Copenhagen | 1N Kiel | 3N Berlin | 2N Prague | 2N Vienna | 2N Budapest | 4N Athens | 3N Rome | 3N Madrid",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 3,
    price: 445999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [london,copenhagen,kiel,berlin,prague,vienna,budapest,athens,rome,madrid],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Singapore", to: "Out of Bangkok", type: "Direct or 1 Stop" },
    //   { from: "Kuala Lumpur", to: "Bangkok", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "London", nights: "3 Nights", type: "Good 3 Star Hotel" },
      { location: "Copenhagen", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Kiel", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Berlin", nights: "3 Nights", type: "Good 3 Star Hotel" },
      { location: "Prague", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Vienna", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Budapest", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Athens", nights: "4 Nights", type: "Good 3 Star Hotel" },
      { location: "Rome", nights: "3 Nights", type: "Good 3 Star Hotel" },
      { location: "Madrid", nights: "3 Nights", type: "Good 3 Star Hotel" },

    ],

    sightseeing: [
      { title: "London Sightseeing" },
      { title: "Copenhagen Sightseeing" },
      { title: "Kiel Sightseeing" },
      { title: "Berlin Sightseeing" },
      { title: "Prague Sightseeing" },
      { title: "Vienna Sightseeing" },
      { title: "Budapest Sightseeing" },
      { title: "Athens Sightseeing" },
      { title: "Rome Sightseeing" },
      { title: "Madrid Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      // { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Daily Dinner at an Indian or Local Restaurant",
      "Escorted by an Experienced English / Hindi-Speaking Tour Manager",
      "Visit to Windsor with British Museum and London Eye",
      "Visit to Rosenborg Tower with Christiansborg Tower",
      "Tour to Laboe Naval Memorial Kiel",
      "Sanssouci Palace Experience with Tour to Pergamon Museum",
      "Tour to Dresden Castle with Zwinger Palace",
      "Tour to Prague Castle and Castle at Znojmo Czech",
      "Tour to Schönbrunn Palace",
      "Tour to Fisherman’s Bastion with Royal Castle Complex",
      "Acropolis and Archaeological Museum of Athens Experience",
      "Daily Cruise at Saronic Islands and Tour to Delphi",
      "Tour to Roman Forum and St. Peter’s Basilica",
      "Tour to Colosseum with Pantheon",
      "Sintra Visit Experience with Tour to Prado and Royal Palace Madrid",
      "Privately owned, luxury buses, 2025 and 2026 models, with highly experienced drivers.",
      "Embark on an epic 26-day European adventure, traveling across 10 countries from royal London to imperial Vienna and vibrant Madrid.",
      "Stand before Europe’s greatest icons, including the Acropolis of Athens, the legendary Colosseum in Rome, and Berlin’s historic Brandenburg Gate.",
      "Experience the charm of Europe’s most beautiful cities, from fairytale Prague to romantic Budapest and the timeless grandeur of Rome.",
      "Sail through the stunning Greek islands, visiting Hydra and Spetses, where Mediterranean beauty meets rich history.",
      "Enjoy a grand blend of royal heritage, ancient wonders, UNESCO landmarks, and unforgettable cultural experiences across Europe.",
    ],

    exclusions: [
      "City tax payable directly at hotel. (€6–€10 per person per night for 3–4 hotels)",
      "Tips for the driver, tour manager, and local tour guide are to be paid separately.",
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently for arrival and departure.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in London & Tower Bridge",
        detail:
          "Arrive in London, England – one of the world's greatest cities. After arrival, transfer to the hotel and check in for a three-night stay. Begin your first exploration of London with a visit to Tower Bridge, the iconic neo-Gothic movable bridge spanning the Thames. Discover the history, enjoy magnificent views, and soak up the atmosphere of this vibrant metropolis. The evening includes dinner at an Indian restaurant followed by free time to settle in and relax. Dinner"
      },
      {
        day: 2,
        title:
          "Windsor, British Museum & London Eye",
        detail:
          "Proceed on a day excursion to Windsor – the oldest and largest castle in Britain, residence of kings since the 11th century. Continue to the British Museum, renowned for its vast collections that record human civilization through the ages. End the sightseeing with a trip to the London Eye, where guests can marvel at panoramic city views from the world’s tallest observation wheel. Return to the hotel after a day filled with rich history, art, and London’s unique charm. Breakfast & Dinner Included"
      },
      {
        day: 3,
        title:
          "Free Day in London – Optional Excursion to Oxford & Stratford-upon-Avon",
        detail:
          "Enjoy a free day in London for shopping or leisure. Recommended visits include Hyde Park, Kensington Gardens, or renowned shopping streets such as Oxford Street and Regent Street. An optional excursion is available to Oxford University, featuring historic colleges and beautiful gardens, and Stratford-upon-Avon, Shakespeare's birthplace. Another optional excursion is a visit to Warner Bros. Studio for a magical journey through the world of Harry Potter. Return to the hotel for an overnight stay in London. Breakfast & Dinner Included"
      },
      {
        day: 4,
        title:
          "Travel to Copenhagen & Nyhavn Canal Stroll",
        detail:
          "Depart for Copenhagen. The journey heads north along the Jutland Peninsula, crossing the border into Denmark. Enjoy scenic views of land and sea, pass over bridges, and admire the Baltic coastline. Arrive in Copenhagen and check in to the hotel. Enjoy free time, with a recommended stroll along the Nyhavn canal, known for its colorful houses, vibrant atmosphere, and historical significance. Breakfast & Dinner Included."
      },
      {
        day: 5,
        title:
          "Copenhagen City Tour: Landmarks & Canals",
        detail:
          "Explore Copenhagen’s highlights, including Rosenborg Tower, the Church of the Holy Trinity, Christiansborg Tower, Amalienborg Palace, City Hall, and the famous Little Mermaid statue. Optionally, experience a boat trip along the city’s bays and canals. Visit Christiania, an autonomous and creative neighborhood. Enjoy the rest of the day at leisure in the Danish capital. Breakfast & Dinner Included"
      },
      {
        day: 6,
        title:
          "Kiel: Maritime Heritage & City Landmarks",
        detail:
          "After breakfast, depart by bus to Kiel, Germany. Upon arrival, begin a city tour with highlights such as the historic City Hall tower offering views of the fjord and cityscape, and a visit to the Labus Naval Memorial with its panoramic observation deck and World War memorials. Free time to visit the Old Botanical Garden or Holstenstrasse, known for its pedestrian-friendly shopping and lively atmosphere. Breakfast & Dinner Included"
      },
      {
        day: 7,
        title:
          "Arrival in Berlin – Leisure Day",
        detail:
          "Depart for Berlin for a three-night stay. The first day in Berlin is set aside for relaxation, allowing you to settle into the city and unwind after travel. Breakfast & Dinner Included"
      },
      {
        day: 8,
        title:
          "Berlin: Brandenburg Gate, Berlin Wall & Museums",
        detail:
          "Begin your Berlin city tour at the historic Brandenburg Gate, a symbol of German unity. Continue to remnants of the Berlin Wall and visit the Reichstag, the German parliament with its iconic dome. Explore the renowned Pergamon Museum, home to treasures from antiquity and the Islamic world. After a day immersed in Berlin’s history and culture, return to your hotel for the evening. Breakfast & Dinner Included"
      },
      {
        day: 9,
        title:
          "Excursion to Potsdam: Palaces, History & Bridges",
        detail:
          "Enjoy an excursion to Potsdam, known for Sanssouci Palace, Frederick the Great’s summer residence. Discover the Dutch Quarter, Babelsberg Film Studios, and historic sites of the Potsdam Conference and the Cold War. Explore the Glienicke Bridge (the “Bridge of Spies”) and immerse yourself in the city's cinematic and royal history. Return to Berlin for the night. Breakfast & Dinner Included"
      },
      {
        day: 10,
        title:
          "Dresden Sights & Transfer to Prague",
        detail:
          "Depart for Dresden, the “Florence of the Elbe.” Visit Zwinger Palace, Dresden Opera House, Dresden Castle, Sanctissimae Trinitatis Cathedral, and the Fürstenzug (Litany of Princes) mosaic. Later, continue to Prague, the “Golden City of 100 Towers.” Breakfast & Dinner Included"
      },
      {
        day: 11,
        title:
          "Prague: Castles, Clocks & Charles Bridge",
        detail:
          "Explore Prague’s must-see attractions: the majestic Prague Castle complex on Hradčany Hill, St. Vitus Cathedral, the picturesque Golden Lane, the iconic Astronomical Clock in the Old Town Square, and the legendary Charles Bridge over the Vltava River. Savor the atmosphere of Prague’s historic beer halls and sample local cuisine. Return to the hotel for an overnight stay. Breakfast & Dinner Included."
      },
      {
        day: 12,
        title:
          "Znojmo and Arrival in Vienna",
        detail:
          "Travel south to Znojmo, a picturesque Czech town with Gothic towers, a historic castle, and one of the largest underground labyrinths in Central Europe. Enjoy views over the Podyjí National Park. Continue to Vienna, Austria’s imperial capital. After arrival and hotel check-in, explore the city center, including Kärntnerstrasse with its elegant shops, and admire the Gothic St. Stephen’s Cathedral. Enjoy an evening in Vienna’s vibrant city center. Breakfast & Dinner Included"
      },
      {
        day: 13,
        title:
          "Vienna: Palaces, Museums & Café Culture",
        detail:
          "Take a guided tour of Vienna. Visit the historic Schönbrunn Palace, the Kunsthistorisches Museum, and the Natural History Museum. In the afternoon, enjoy leisure time in the romantic city – perhaps a ride in a fiaker (horse-drawn carriage) or a stop in one of Vienna’s legendary cafés for chocolate or coffee. Breakfast & Dinner Included"
      },
      {
        day: 14,
        title:
          "Bratislava Sights & Arrival in Budapest",
        detail:
          "Depart for Bratislava, the charming capital of Slovakia. Explore Hlavné námestie (Central Square), the Old Town Hall, Bratislava Castle, St. Michael’s Gate, St. Martin’s Cathedral, the Church of the Annunciation, and discover quaint shops. Sample local food, beer, or wine at traditional restaurants before continuing to Budapest, Hungary. Arrive and enjoy the evening in the “Pearl of the Danube.” Breakfast & Dinner Included"
      },
      {
        day: 15,
        title:
          "Budapest: Castle Hill, Churches & Local Flavors",
        detail:
          "Embark on a tour of Budapest. Visit Fisherman’s Bastion for panoramic Danube views, Matthias Church, St. Stephen’s Basilica, and the Royal Castle complex. Explore the city’s UNESCO World Heritage sites, cross iconic bridges, and enjoy an evening at a traditional Hungarian tavern with gypsy violin music. Breakfast & Dinner Included"
      },
      {
        day: 16,
        title:
          "Travel to Athens: Syntagma & Monastiraki",
        detail:
          "Transfer to the airport for your flight to Athens, Greece. Upon arrival, take a brief city tour: visit Syntagma Square, watch the Changing of the Guard, and explore Monastiraki and Ermou Street. Sample local Greek street food before checking in to the hotel. Enjoy free time in Athens. Breakfast & Dinner Included."
      },
      {
        day: 17,
        title:
          "Athens: Acropolis, Museums & Temple of Poseidon",
        detail:
          "Begin the day with a visit to the Acropolis, Athens’ greatest monument. Tour the Archaeological Museum and the Panathenaic Stadium (Kalimarmaro), site of the first modern Olympic Games. In the afternoon, travel to Lavrio on the Attica Peninsula to see the Temple of Poseidon. Return to the hotel and relax. Breakfast & Dinner Included."
      },
      {
        day: 18,
        title:
          "Day Excursion to Delphi",
        detail:
          "Enjoy a day trip to Delphi, the seat of the legendary oracle. Explore archaeological wonders and the Omphalos of Delphi, considered the navel of the ancient Greek world. Return to Athens for free time and an overnight stay. Breakfast & Dinner Included."
      },
      {
        day: 19,
        title:
          "Greek Island Hopping: Poros, Hydra & Spetses",
        detail:
          "Transfer to Rafina Port for a boat trip to the Saronic Islands of Poros, Hydra, and Spetses. Enjoy a sample of the Greek islands’ charm and scenery. Return to Athens for the night. Breakfast & Dinner Included."
      },
      {
        day: 20,
        title:
          "Travel to Rome: Pantheon, Trevi Fountain & Arrival",
        detail:
          "Transfer to the airport and fly to Rome, Italy. Upon arrival, begin your introduction to the “Eternal City” with a visit to the Pantheon and the world-famous Trevi Fountain. Enjoy free time for independent exploration, coffee, or people-watching in Rome’s lively squares. Breakfast & Dinner Included."
      },
      {
        day: 21,
        title:
          "Rome: Ancient Sights & Vibrant Streets",
        detail:
          "Begin your exploration of Rome with a visit to the Roman Forum, the Colosseum, Capitoline Hill, Piazza Venezia, and the banks of the Tiber, passing Castel Sant’Angelo en route. Spend the rest of the day enjoying Rome’s vibrant streets and rich history at your own pace. Breakfast & Dinner Included"
      },
      {
        day: 22,
        title:
          "Vatican Museums, St. Peter’s & Rome’s Piazzas",
        detail:
          "Visit the Vatican Museums, including the famous Sistine Chapel and St. Peter’s Basilica. Admire the artworks of Michelangelo and Bernini. Explore the nearby Castel Sant’Angelo and Ponte Sant’Angelo, Piazza Navona, Piazza di Spagna, and Villa Borghese. Enjoy free time for personal exploration or dining in lively Trastevere. Breakfast & Dinner Included"
      },
      {
        day: 23,
        title:
          "Travel to Madrid: Puerta del Sol, Plaza Mayor & Tapas",
        detail:
          "Transfer to the airport and fly to Madrid, Spain. Upon arrival, begin with a city tour around Puerta del Sol and Plaza Mayor, the heart of Madrid. In the evening, explore the city’s culinary scene, try tapas, and enjoy Madrid’s nightlife. Breakfast & Dinner Included"
      },
      {
        day: 24,
        title:
          "Madrid: Museums & Royal Palace",
        detail:
          "Visit Madrid’s central attractions, including Plaza Mayor and one of the city’s three renowned museums – Prado, Thyssen-Bornemisza, or Reina Sofía – home to masterpieces by Europe’s greatest painters. Visit the Royal Palace, the official residence of the Spanish royal family, before enjoying a free evening in the city. Breakfast & Dinner Included"
      },
      {
        day: 25,
        title:
          "Excursion to Toledo: Cathedrals, Alcázar & El Greco",
        detail:
          "Take a day trip to Toledo, a fortress city and UNESCO World Heritage Site. Visit its Gothic cathedral, the imposing Alcázar fortress, Museo de Santa Cruz, and the house of El Greco. Return to Madrid for free time. Breakfast & Dinner Included"
      },
      {
        day: 26,
        title:
          "Departure from Madrid",
        detail:
          "Transfer to the airport for your flight back home, marking the end of your European journey through the region’s great metropolises and historic cities. Breakfast Included."
      },

    ],

    overview: "If you have enough available time, if a visit to Europe is a lifelong dream, this program gives you the opportunity to make it happen. On your way you will find 11 capitals of countries and many other important cities. You will get to know the culture of Europe from end to end, you will hear almost all languages, you will taste different things, you will ... you will ... you will..."
  },
  {
    id: "europe-004",
    slug: "modern-germany-married-with-old-prussia-and-the-doll-prague",
    destination: "Europe",
    title: "Modern Germany Married with Old Prussia and The Doll Prague",
    duration: "11 Nights 12 Days",
    route: "2N Frankfurt | 2N Düsseldorf | 1N Hamburg | 2N Berlin | 1N Leipzig | 1N Dresden | 2N Prague",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Oct 2026"],
    stars: 3,
    price: 231999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [frankfurt,dusseldorf,hamburg,berlin,leipzing,dresden,prague],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Singapore", to: "Out of Bangkok", type: "Direct or 1 Stop" },
    //   { from: "Kuala Lumpur", to: "Bangkok", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Frankfurt", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Düsseldorf", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Hamburg", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Berlin", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Leipzig", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Dresden", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Prague", nights: "2 Nights", type: "Good 3 Star Hotel" },

    ],

    sightseeing: [
      { title: "Frankfurt Sightseeing" },
      { title: "Düsseldorf Sightseeing" },
      { title: "Hamburg Sightseeing" },
      { title: "Berlin Sightseeing" },
      { title: "Leipzig Sightseeing" },
      { title: "Dresden Sightseeing" },
      { title: "Prague Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Daily Dinner at an Indian or Local Restaurant",
      "Frankfurt Guided City Tour and Goethe Museum Visit",
      "Main River Boat Trip Experience",
      "Escorted by an Experienced English / Hindi-Speaking Tour Manager",
      "Lunch at Indian Restaurant",
      "Düsseldorf Guided City Tour and Castle Tower Visit",
      "Hamburg Guided City Tour",
      "Elbphilharmonie and Miniatur Wunderland Experience",
      "Berlin Guided City Tour and Pergamon Museum Visit",
      "Guided Tour of Leipzig",
      "Dresden Guided City Tour and Zwinger Palace Visit",
      "Prague City Tour and Prague Castle Experience with Daily Pass",
      "Privately owned, luxury buses, 2025 and 2026 models, with highly experienced drivers.",
      "Begin in vibrant Frankfurt, where modern skyscrapers rise beside historic squares, offering a perfect introduction to Germany’s dynamic spirit. Discover how major cities like Hamburg, Berlin, Leipzig, and Dresden, once nearly 90% destroyed during World War II, have been remarkably rebuilt to modern standards while preserving their historic character.",
      "Experience authentic German culture through lively pubs, traditional wurst, and local culinary delights.",
      "Journey through Germany’s cultural heart, exploring Saxony’s historic cities such as Leipzig and Dresden, along with vibrant Hamburg, home to the fascinating Miniatur Wunderland, the world’s largest model railway exhibition.",
      "Explore the fascinating capital Berlin, rich with iconic landmarks and powerful history, including the Berlin Wall, Brandenburg Gate, the German Parliament (Reichstag), Pergamon Museum, and nearby Potsdam, reflecting a thriving creative and cultural spirit.",
      "Experience the fairytale charm of Prague in the Czech Republic’s Bohemia region, wandering through its medieval Old Town, grand squares, and stunning riverside views, along with a visit to the elegant spa town of Karlovy Vary, known for its colorful architecture and healing thermal springs.",
      "Relax in the elegance of Central Europe, bringing together historic cities, cultural treasures, and scenic beauty—an ideal combination of history, architecture, and unforgettable experiences.k, Charles Bridge, and the elegant spa town of Karlovy Vary.",
    ],

    exclusions: [
      "City tax payable directly at hotel. (€6–€10 per person per night for 3–4 hotels)",
      "Tips for the driver, tour manager, and local tour guide are to be paid separately.",
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently for arrival and departure.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Frankfurt",
        detail:
          "Arrive at Frankfurt Airport and transfer to the hotel. Relax and settle in after your journey. Spend the rest of the day at leisure to explore the city on your own or simply unwind. Dinner Included."
      },
      {
        day: 2,
        title:
          "Frankfurt - City Discovery & Culinary Experiences",
        detail:
          "Start your day with a coffee at Café Hauptwache in the warm interior of the 18th-century building. Take a boat ride on the River Main and admire the impressive skyline of Frankfurt. Explore the Kleinmarkthalle, bustling since 1954 with over 160 stalls offering delicacies, fresh produce, and local foods. Enjoy schnitzels, cutlets, and sausages at Marktstubb in the market. Visit Goethe’s birthplace and museum to learn about the famous German writer. End the day in the lively Sachsenhausen area, full of taverns and pedestrian streets. Breakfast & Dinner Included."
      },
      {
        day: 3,
        title:
          "Transfer to Düsseldorf & City Sightseeing",
        detail:
          "Travel 228 km northwest to Düsseldorf. Begin your city exploration with a visit to the iconic Rheinturm (Rhine Tower) for panoramic views of the city and river. Stroll through the narrow streets of the Old Town (Altstadt), filled with breweries and traditional pubs, sampling classic German dishes and Altbier. Optionally, catch a show at the Apollo Varieté or enjoy a leisurely evening walk along the Rhine Promenade, soaking in the city lights. Breakfast & Dinner Included."
      },
      {
        day: 4,
        title:
          "Düsseldorf - History, Architecture & Cuisine",
        detail:
          "Explore Düsseldorf’s historic side, including the Castle Tower (Schlossturm) and Burgplatz. Visit the Neanderthal Museum to delve into the region’s prehistoric past. Head to MedienHafen, an architectural hub with striking buildings by renowned architects such as Frank Gehry, and learn about its transformation from an industrial port to a creative center. For the evening, enjoy time at a cozy restaurant serving traditional Rhineland cuisine such as Rheinischer Sauerbraten or Himmel und Erde. Breakfast & Dinner Included."
      },
      {
        day: 5,
        title:
          "Transfer to Hamburg - Architectural & Cultural Highlights",
        detail:
          "Leave Düsseldorf and journey to Hamburg, the capital of northern Germany. Visit the remarkable Elbphilharmonie, one of the world’s largest concert halls, and enjoy city views from its observation deck. Admire the impressive Town Hall in the center of the old town. Explore Miniatur Wunderland, the largest model railway exhibit in the world. The rest of the day offers opportunities to relax in local cafés or pubs and soak in Hamburg’s vibrant atmosphere. Breakfast & Dinner Included."
      },
      {
        day: 6,
        title:
          "Transfer to Berlin - Iconic Monuments",
        detail:
          "Cross the German countryside via the autobahn to Berlin, the country’s iconic capital. Begin with a visit to the historic Brandenburg Gate, a symbol of German unity and peace, then explore the Berlin Wall Memorial, preserving remnants of the once-divided city. Breakfast & Dinner Included."
      },
      {
        day: 7,
        title:
          "Berlin - Reichstag, Museums & Leisure",
        detail:
          "Visit the Reichstag, seat of the German Parliament and a symbol of the nation’s history. Tour its glass dome for panoramic city views. Continue to the Pergamon Museum, exploring ancient artifacts from Egypt, the Middle East, and beyond, including the Ishtar Gate and the Roman Gate of Miletus. Breakfast & Dinner Included."
      },
      {
        day: 8,
        title:
          "Transfer to Leipzig - City Exploration & Culture",
        detail:
          "Depart in the morning for Leipzig, Saxony’s largest city. Explore the contrasts of old and new as you tour the Markt square and Old Town Hall, the Thomaskirche, New Town Hall, and Leipzig University. See monuments to Schiller and preserved sections of the ancient city walls. Stroll through Augustusplatz for a display of architectural eras and enjoy time at local cafés and pubs. Check in at the hotel, with the evening at leisure and an optional opportunity to experience Leipzig’s nightlife. Breakfast & Dinner Included."
      },
      {
        day: 9,
        title:
          "Transfer to Dresden - Baroque Treasures & City Landmarks",
        detail:
          "Continue your journey to Dresden, the rebuilt “Florence of the Elbe.” Tour the Baroque Zwinger Palace and its porcelain collection, the world-renowned Dresden Opera House, and the Renaissance-style Dresden Castle. Admire the Sanctissimae Trinitatis Cathedral and see the Fürstenzug, the world’s largest porcelain artwork. Breakfast & Dinner Included."
      },
      {
        day: 10,
        title:
          "Transfer to Prague via Karlovy Vary - Introduction to Prague",
        detail:
          "Depart early for the Czech Republic with an en route stop at Karlovy Vary, famed for its hot springs and beautiful Art Nouveau architecture. Continue to Prague, the “Golden City of 100 Towers.” Begin with a general city tour: stroll through cobbled alleys, admire the famed Astronomical Clock, the historic Charles Bridge, and the fairy-tale castle. Breakfast & Dinner Included."
      },
      {
        day: 11,
        title:
          "Prague - Castle, Iconic Sights & Local Culture",
        detail:
          "Begin with a visit to Prague Castle, the largest medieval castle in Europe. See the Cathedral of Saint Vitus and the Golden Lane of the alchemists. Visit the Astronomical Clock at the Old Town Hall and enjoy panoramic views from the tower. Walk across the Charles Bridge, connecting the Old Town to the Castle. Experience local beer halls and sample regional cuisine. The rest of the day is at leisure to explore Prague’s historic ambiance. Breakfast & Dinner Included."
      },
      {
        day: 12,
        title:
          "Departure from Prague",
        detail:
          "Check out of the hotel and transfer to the airport for your return journey home. Breakfast Included."
      },

    ],

    overview: "Something is wrong with Germany. Of course, something good. How would it be different for this European beauty? There is nothing that this country does not have. It appeals to all kinds of travelers, because it has to offer them exactly what they are looking for. Big cities are buzzing with life and culture, full of museums and multi-dimensional art spaces. Smaller towns are bathed in the light of the past, full of imposing churches, large squares with old buildings and streets lined with beer halls, bars and award-winning restaurants. The majesty of nature unfolds in every corner of this majestic country: the villages by the river Rhine, the castles tucked into verdant hills, the high mountains and lakes that satisfy nature lovers, the ski resorts and the winter infrastructure that are a model for the rest of the countries. Let’s discover all of them!"
  },
  {
    id: "europe-005",
    slug: "the-area-of-vikings",
    destination: "Europe",
    title: "The Area of Vikings",
    duration: "20 Nights 21 Days",
    route: "2N Copenhagen | 2N Bergen | 4N Oslo | 2N Stockholm | 2N Helsinki | 2N Tallinn | 1N Riga | 1N Vilnius | 3N Gdansk | 1N Warsaw",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026"],
    stars: 3,
    price: 446999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [copenhagen,bergen,oslo,stockholm,helsinki,riga,vilnius,gdansk,warsaw],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Singapore", to: "Out of Bangkok", type: "Direct or 1 Stop" },
    //   { from: "Kuala Lumpur", to: "Bangkok", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Copenhagen", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Bergen", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Oslo", nights: "4 Nights", type: "Good 3 Star Hotel" },
      { location: "Stockholm", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Helsinki", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Tallinn", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Riga", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Vilnius", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Gdansk", nights: "3 Nights", type: "Good 3 Star Hotel" },
      { location: "Warsaw", nights: "1 Nights", type: "Good 3 Star Hotel" },

    ],

    sightseeing: [
      { title: "Copenhagen Sightseeing" },
      { title: "Bergen Sightseeing" },
      { title: "Oslo Sightseeing" },
      { title: "Stockholm Sightseeing" },
      { title: "Helsinki Sightseeing" },
      { title: "Tallinn Sightseeing" },
      { title: "Riga Sightseeing" },
      { title: "Vilnius Sightseeing" },
      { title: "Gdansk Sightseeing" },
      { title: "Warsaw Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      // { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Guided City Tour of Copenhagen",
      "Daily Dinner at an Indian or Local Restaurant",
      "Escorted by an Experienced English / Hindi-Speaking Tour Manager",
      "Fløyen Cable Car & Bergen Fjord Excursion Experience",
      "Oslo Guided City Experience with Bicycle Tour",
      "Oslofjord Boat Excursion Experience",
      "Tour of Upsala and Observatory Entrance",
      "Suomenlinna Fortress Visit",
      "Tour of Tallinn",
      "Maritime Museum and WWII Museum Visit",
      "Toruń Tower Visit and Malbork Castle Sightseeing Experience",
      "Privately owned, luxury buses, 2025 and 2026 models, with highly experienced drivers.",
      "Embark on a grand Nordic and Baltic adventure, exploring Denmark, Norway, Sweden, Finland, Estonia, Latvia, Lithuania, and Poland in one unforgettable cultural journey across Northern Europe.",
      "Discover Scandinavian elegance, from colorful Nyhavn and the Little Mermaid in Copenhagen to the royal heritage, museums, and scenic neighborhoods of vibrant Oslo.",
      "Experience Norway’s breathtaking landscapes, with a visit to UNESCO-listed Bergen, panoramic views from Fløyen, a cruise through the majestic Sognefjord, and a spectacular scenic railway journey to Oslo.",
      "Explore Nordic capitals rich in history and design, including charming Stockholm, the cultural treasures of Helsinki, and the medieval beauty of Tallinn’s UNESCO Old Town.",
      "Journey through the Baltic states to Poland, discovering Riga, Vilnius, the mighty Malbork Castle, historic Gdansk, medieval Torun, and the vibrant capital Warsaw.",
    ],

    exclusions: [
      "City tax payable directly at hotel. (€6–€10 per person per night for 3–4 hotels)",
      "Tips for the driver, tour manager, and local tour guide are to be paid separately.",
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently for arrival and departure.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Copenhagen",
        detail:
          "Arrive at the airport of Copenhagen, 'the port of merchants', which has served as the capital of Denmark since 1417. Transfer to hotel for check-in (2 nights). Enjoy a leisurely walk along the Nyhavn canal, now transformed from its infamous past into one of the city's busiest and most charming areas, lined with colorful houses and lively cafes. Dinner Included."
      },
      {
        day: 2,
        title:
          "Copenhagen City Tour and Exploration",
        detail:
          "Embark on a city tour of Copenhagen. Highlights include Rosenborg Tower, the Church of the Holy Trinity, Christiansborg Tower, Amalienborg Palace, City Hall, and the iconic bronze statue of the Little Mermaid. Visit Christiania, a unique self-governing community. Enjoy free time in the afternoon, with optional boat trips recommended to explore Copenhagen’s bays and canals. Breakfast & Dinner Included."
      },
      {
        day: 3,
        title:
          "Copenhagen to Bergen: Exploring Bergen",
        detail:
          "Transfer to the airport for a flight to Bergen, Norway. Discover Bergen, known as the “Jewel of the North Sea” and the “Gateway to the Fjords.” This UNESCO World Heritage city features attractions such as the medieval Bryggen district, the Bergen Fish Market, and a cable car ride to Fløyen Hill for panoramic city views. Built between two arms of the Byfjord, Bergen offers both rich history and natural beauty. Check in for a two-night stay. Breakfast & Dinner Included."
      },
      {
        day: 4,
        title:
          "Bergen: Sognefjord & Norwegian Fjord Experience",
        detail:
          "Embark on a full-day fjord exploration cruise. Discover Norway’s iconic Sognefjord, the country’s longest and deepest fjord, alive with enchanting fishing villages, glaciers, and idyllic landscapes. Experience the magic of visiting peaceful villages amid the dramatic terrain. Return to the hotel after the tour. Breakfast & Dinner Included."
      },
      {
        day: 5,
        title:
          "Bergen to Oslo: Scenic Train Journey Across Norway",
        detail:
          "Transfer to Oslo by train, crossing Norway from west to east. Enjoy the scenic journey through tunnels, mountains, and towns like Voss, Myrdal, Flåm, Finse, and Geilo. Witness diverse natural landscapes and marvel at feats of railway engineering. Arrive in Oslo, check in for a four-night stay, and rest. Enjoy time at a local tavern. Breakfast & Dinner Included."
      },
      {
        day: 6,
        title:
          "Oslo City Highlights and Museums",
        detail:
          "Begin exploring Oslo. Visit Karl Johans Gate with its historical landmarks: the Royal Palace, National Theater, Parliament, and University. Tour City Hall, Holmenkollen Ski Resort, Frogner Park with Vigeland’s sculptures, and the Bygdøy Peninsula’s Viking Ship Museum, Fram Museum, Museum of Folklore, and Kon-Tiki Museum. Delve into Oslo’s Viking and exploration history. Breakfast & Dinner Included."
      },
      {
        day: 7,
        title:
          "Oslo by Bicycle: Neighborhoods, Culture & Lifestyle",
        detail:
          "Enjoy a relaxed day getting to know Oslo by bicycle. Rent bikes and explore with a local guide, visiting floating saunas along the fjord, bohemian neighborhoods, preserved wooden houses on Damstredet and Telthusbakken, and eclectic shops and cafés. Oslo’s multiculturalism and the Intercultural Museum highlight the city’s diversity. Return the bikes and head back to the hotel. Breakfast & Dinner Included."
      },
      {
        day: 8,
        title:
          "Oslo: Oslofjord Islands and Cultural Attractions",
        detail:
          "Oslo’s culture takes center stage. Rediscover nature with a visit to the Oslofjord and its idyllic islets by ferry, exploring Hovedøya, Langøyene, Gressholmen, Rambergøya, and Heggholmen. Enjoy the contemporary city with its museums, libraries, Opera House, and sculptures in public spaces. Return to hotel after the island exploration. Breakfast & Dinner Included."
      },
      {
        day: 9,
        title:
          "Oslo to Stockholm: Arrival and Gamla Stan",
        detail:
          "Transfer to Oslo Airport for a flight to Stockholm, Sweden. Arrive and explore Gamla Stan, Stockholm’s bustling medieval Old Town set on an island—known for its charming narrow streets, colorful houses, the Nobel Museum, Cathedral, Stock Exchange Building, and the vast Royal Palace. Check in for a two-night stay and spend the rest of the day at leisure in Gamla Stan. Breakfast & Dinner Included."
      },
      {
        day: 10,
        title:
          "Day Trip to Uppsala from Stockholm",
        detail:
          "Depart by bus for a day trip to Uppsala, known for its medieval university, Gustavianum Museum, Uppsala Cathedral, observatory, botanical gardens, castle, and charming city center. Breakfast & Dinner Included."
      },
      {
        day: 11,
        title:
          "Stockholm to Helsinki: Arrival and City Introduction",
        detail:
          "Transfer to the airport for a flight to Helsinki, Finland. Discover the lakes, forests, and rivers that define the Finnish landscape. Arrive in Helsinki—the “White City” and “Daughter of the Baltic”—featuring Art Nouveau architecture, a vibrant harbor, museums, and bridges connecting the city to islands, along with the UNESCO-listed Sveaborg Fortress. Breakfast & Dinner Included."
      },
      {
        day: 12,
        title:
          "Helsinki City Tour: Art, Culture & Design",
        detail:
          "Begin a full-day Helsinki sightseeing tour. Visit Uspenski Cathedral, Temppeliaukio Church, the sea fortress Suomenlinna/Viapori, Helsinki Art Museum, and the Design Museum. Explore the city’s museums and galleries, and stroll through central districts, experiencing both Finnish design heritage and modern urban life. Breakfast & Dinner Included."
      },
      {
        day: 13,
        title:
          "Helsinki to Tallinn: Arrival and Medieval Heritage",
        detail:
          "Transfer to Helsinki Port and take a ferry to Tallinn, Estonia’s capital and one of Europe’s best-preserved medieval cities. Explore the cobbled streets, city walls, towers, and vibrant modern cultural scene. Breakfast & Dinner Included."
      },
      {
        day: 14,
        title:
          "Tallinn Heritage & Culinary Tour",
        detail:
          "Tour Tallinn’s UNESCO-listed Old Town. Explore Toompea Castle and Alexander Nevsky Cathedral in the Upper Town, and the winding cobbled streets, gabled houses, and medieval pharmacies of the Lower Town. Discover the Bastion Tunnels and try local Estonian dishes such as vürtsikilu and kiluvõileib. Sample the city’s foraged food traditions at local cafés and restaurants. Breakfast & Dinner Included."
      },
      {
        day: 15,
        title:
          "Tallinn to Riga: Arrival and Old Town Discovery",
        detail:
          "Depart for Riga, Latvia. Explore Riga’s historic center, filled with merchant and guild houses, churches, Art Nouveau wonders, Soviet-era buildings, and vibrant cultural and nightlife offerings. See landmarks such as the Latvian National Opera, St. James’ Cathedral, and Vērmanes Garden. Enjoy free time to try local dishes in the old town and admire the city’s architectural variety. Breakfast & Dinner Included."
      },
      {
        day: 16,
        title:
          "Riga to Vilnius: Arrival and Exploring Vilnius Old Town",
        detail:
          "Depart for Vilnius, Lithuania. Admire Vilnius’s vast historical center with cobblestone streets, outdoor cafés, unique Renaissance, Baroque, and Gothic architecture, and greenery. Learn about its Jewish history, medieval fortified walls, and vibrant nightlife. Breakfast & Dinner Included."
      },
      {
        day: 17,
        title:
          "Vilnius to Gdansk via Malbork Castle",
        detail:
          "Enjoy breakfast, then depart for Gdańsk, Poland (a long journey with planned stops). En route, visit Malbork Castle, a magnificent Gothic monument with impressive interiors, including the Palace of the Grand Masters. Continue to Gdańsk, a city with a millennium of history, blending architectural influences from across Europe and renowned as the birthplace of the Solidarity movement. Arrive at the hotel for an overnight stay. Breakfast & Dinner Included."
      },
      {
        day: 18,
        title:
          "Gdansk Royal Route and Riverside Walk",
        detail:
          "Take a relaxing walking tour in Gdańsk. Stroll along the Royal Route (Ulica Długa and Długi Targ) between the Golden and Green Gates, admiring architecture such as the Golden House, Main Town Hall, Neptune Fountain, and Uphagen House. Walk along Długie Pobrzeże Street beside the Motława River, see the medieval port crane Żuraw, and explore atmospheric Mariacka Street with amber shops. Enjoy free time to discover Gdańsk’s culinary scene and Solidarity landmarks. Breakfast & Dinner Included."
      },
      {
        day: 19,
        title:
          "Gdansk: Museums and Historical Landmarks",
        detail:
          "Take an organised tour of Gdańsk’s museums and historical sites. Visit the World War II Museum, a must-see with a large collection of war memorials and historical exhibits. Continue to Westerplatte, the site where World War II began, the Maritime Museum with the SS Sołdek, St. Mary’s Church (the world’s largest brick church), and the Gdańsk Historical Museum. Return to the hotel and enjoy some free time to explore the city further. Breakfast & Dinner Included."
      },
      {
        day: 20,
        title:
          "Gdansk to Warsaw via Torun: Gothic Splendors and Copernicus",
        detail:
          "Depart for Warsaw with a stop in Toruń. Tour Toruń’s Gothic Town Hall, climb the clock tower, visit the house of Nicolaus Copernicus, and the city’s famous planetarium. Enjoy free time for coffee and lunch before continuing to Warsaw. Arrive in Warsaw, check in to the hotel, and enjoy free time on your final evening in Poland. Breakfast & Dinner Included."
      },
      {
        day: 21,
        title:
          "Departure from Warsaw",
        detail:
          "Breakfast and transfer to the airport for flight back home. End of services."
      },

    ],

    overview: "We could also call this program 'the countries around the Baltic Sea'. We have Scandinavia, the cradle of the Vikings, which is a sparsely populated region and includes Denmark, the smallest of the four states, Norway with its serene fjords, impressive glaciers, steep mountains and picturesque islands, Sweden with its countless natural beauties, as well as the 'Land of a Thousand Lakes', Finland, despite the fact that its inhabitants constitute a completely separate linguistic and ethnic group. Then we have the Baltic countries and former regions of the Soviet Republics, as well as Poland. We have a magical travel destination, which combines the culture of the cities with the captivating beauty of the landscapes. The trip includes the best direction by train in Europe which is the one between Bergen and Oslo in Norway. Planes, ships, trains, buses, walking - we will try all the modes of transportation bicycles including. You can even volunteer and swim! If you are nature lovers do this trip and not just once in life!"
  },
  {
    id: "europe-006",
    slug: "the-sophisticated-french-speaking-europe",
    destination: "Europe",
    title: "The Sophisticated French-Speaking Europe",
    duration: "13 Nights 14 Days",
    route: "2N Lyon | 1N Geneva | 1N Lausanne | 1N Bern | 1N Lucerne | 1N St Gallen | 3N Zurich | 1N Mulhouse | 1N Strasbourg | 1N Stuttgart",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 3,
    price: 238999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [lyon,geneva,lausanne,bern,lucerne,stgallen,zurich,mulhouse,strasbourg,stuttgart],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Singapore", to: "Out of Bangkok", type: "Direct or 1 Stop" },
    //   { from: "Kuala Lumpur", to: "Bangkok", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Lyon", nights: "2 Nights", type: "Good 3 Star Hotel" },
      { location: "Geneva", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Lausanne", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Bern", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Lucerne", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "St Gallen", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Zurich", nights: "3 Nights", type: "Good 3 Star Hotel" },
      { location: "Mulhouse", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Strasbourg", nights: "1 Nights", type: "Good 3 Star Hotel" },
      { location: "Stuttgart", nights: "1 Nights", type: "Good 3 Star Hotel" },

    ],

    sightseeing: [
      { title: "Lyon Sightseeing" },
      { title: "Geneva Sightseeing" },
      { title: "Lausanne Sightseeing" },
      { title: "Bern Sightseeing" },
      { title: "Lucerne Sightseeing" },
      { title: "St Gallen Sightseeing" },
      { title: "Zurich Sightseeing" },
      { title: "Mulhouse Sightseeing" },
      { title: "Strasbourg Sightseeing" },
      { title: "Stuttgart Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      // { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Museums Experience at the Museum of History and Musée des Confluences",
      "Cogwheel Railway Experience with 2 Rides",
      "Daily Dinner at an Indian or Local Restaurant",
      "Escorted by an Experienced English / Hindi-Speaking Tour Manager",
      "Zurich State Museum Visit",
      "Rhaetian Railway Alpine Train Experience from Chur to St. Moritz and Return",
      "Privately owned, luxury buses, 2025 and 2026 models, with highly experienced drivers.",
      "Begin in the elegant city of Lyon, France’s gastronomic capital, exploring UNESCO-listed Vieux Lyon, the stunning Fourvière Basilica, and enjoying authentic French cuisine in a traditional bouchon.",
      "Discover the beauty of Switzerland, with guided visits to Geneva, lakeside Lausanne, medieval Bern, and picturesque Lucerne with its iconic wooden bridge.",
      "Experience Alpine culture and heritage, visiting Vaduz in Liechtenstein, the UNESCO Abbey Library of St. Gallen, and vibrant Zurich with its famous Bahnhofstrasse.",
      "Witness breathtaking natural scenery, from the powerful Rhine Falls to a spectacular alpine journey on the Rhaetian Railway from Chur to St. Moritz.",
      "Explore Europe’s cultural gems, including artistic Basel, fairytale Colmar, historic Strasbourg, romantic Heidelberg, and innovative Stuttgart, home of Mercedes-Benz and Porsche.",
    ],

    exclusions: [
      "City tax payable directly at hotel. (€6–€10 per person per night for 3–4 hotels)",
      "Tips for the driver, tour manager, and local tour guide are to be paid separately.",
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently for arrival and departure.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Lyon and Exploration of the City",
        detail:
          "Arrive in Lyon, the sophisticated French city nestled between the Rhône and Saône rivers. After transferring to your hotel, begin to soak in the atmosphere of this city of grey stone buildings. Consider visiting the Musée Lumière, which pays tribute to Lyon as the birthplace of cinema. Enjoy Lyon’s celebrated food scene with a common dinner at a traditional bouchon, accompanied by local Beaujolais wines. Explore the vintage boutiques and perhaps stroll through one of France’s largest open-air markets to start your adventure. Dinner Included."
      },
      {
        day: 2,
        title:
          "Lyon City Tour and Cultural Discovery",
        detail:
          "Begin your day with a cultural exploration of Lyon. Start at the Musée d’Histoire de Lyon, housed in a Renaissance mansion, where you will immerse yourself in the city’s fascinating past. Tour Vieux Lyon, the atmospheric old town with its cobblestone streets and architectural gems, and consider learning about chef Paul Bocuse’s culinary legacy. Ride the cogwheel railway up to Fourvière for panoramic city views and visit the iconic Notre-Dame de Fourvière. Do not miss the Musée des Confluences for a unique journey through anthropology, paleontology, and natural history. If you enjoy shopping, spend some time at Les Puces du Canal flea market, a treasure trove of finds. Dine at a local restaurant and savor a glass of regional wine before returning to the hotel for an overnight stay. Breakfast & Dinner Included."
      },
      {
        day: 3,
        title:
          "Arrival in Geneva and Guided City Tour",
        detail:
          "Depart Lyon for Geneva. Upon arrival, begin a guided tour starting with the famous Jet d’Eau fountain. Explore the Old Town to visit the Cathedral of St. Peter and the International Museum of the Reformation. Stroll along the Promenade de la Treille and see the world’s largest wooden bench and the official chestnut tree of Geneva. Wander through the Jardin Anglais to discover the whimsical Flower Clock. Finally, tour the impressive Palais des Nations, home to the United Nations. Breakfast & Dinner Included."
      },
      {
        day: 4,
        title:
          "Day at Lausanne – Attractions and Free Time",
        detail:
          "Depart Geneva for the picturesque city of Lausanne. Set on the edge of Lake Geneva and flanked by views of the Alps, Lausanne exudes a peaceful charm. Visit the majestic Notre-Dame Cathedral and explore the lively Place St. François area filled with shops, as well as the trendy Flon district known for its bars and restaurants. Take note of Lausanne’s status as the headquarters of the International Olympic Committee and the world-renowned Maurice Béjart Ballet. The rest of the day is free to explore at your leisure. Breakfast & Dinner Included."
      },
      {
        day: 5,
        title:
          "Bern – Arrival and Exploration of the Swiss Capital",
        detail:
          "Today, depart for Bern, the capital city of Switzerland. Known for its UNESCO World Heritage medieval old town, Bern is perched on a bend of the Aare River with stunning Alpine backdrops. Discover the city’s beautifully preserved cobblestone streets and admire the iconic Clock Tower with its astronomical clock. Soak in the unique atmosphere that combines provincial charm with the vibrancy of a national capital. Upon arrival, check in at your hotel and enjoy the evening at your own pace. Breakfast & Dinner Included."
      },
      {
        day: 6,
        title:
          "Lucerne – Arrival and Old Town Walk",
        detail:
          "Journey to Lucerne, a picturesque city set beside the beautiful Lake Lucerne. Marvel at the iconic Kapellbrücke, the covered wooden bridge, and its historic Wasserturm. Wander through Lucerne’s medieval old town, characterized by narrow cobblestone streets, colorful houses, charming fountains, and lively squares dotted with cafés and restaurants. Arrive at the hotel and enjoy some free time to further explore or relax by the lakeside. Breakfast & Dinner Included."
      },
      {
        day: 7,
        title:
          "Vaduz and Saint Gallen – Liechtenstein Excursion and Monastic Heritage",
        detail:
          "Depart Lucerne and make a morning visit to Vaduz, the capital of the tiny Principality of Liechtenstein. Take in the sights of this unique city, one of Europe’s smallest capitals, and consider an optional ride on the city train. Following this, continue to St. Gallen, a historic city in northeast Switzerland. Visit the UNESCO-listed Benedictine Monastery, renowned for its library housing priceless manuscripts dating back to the 9th century. Breakfast & Dinner Included."
      },
      {
        day: 8,
        title:
          "Zurich – City Tour and Hotel Check-in",
        detail:
          "Depart for Zurich for a comprehensive city tour. Visit the renowned Bahnhofstrasse for shopping, stroll through the pedestrianized old town, and take in the Fraumünster Church with Chagall’s windows, the Cathedral, Town Hall, Clock Tower, and Lindenhof Hill. View the bridges over the Limmat River and other city sights. Breakfast & Dinner Included."
      },
      {
        day: 9,
        title:
          "Zurich State Museum and Rhine Falls Excursion",
        detail:
          "Begin your day by visiting the Zurich State Museum, home to thousands of exhibits, including items from the Paleolithic era to the Middle Ages, as well as jewelry, paintings, and more. Do not miss the Koch ring collection or the Swiss history displays. In the afternoon, depart by bus to the majestic Rhine Falls in Schaffhausen, Europe’s largest waterfall, for a memorable natural spectacle. Return to Zurich and enjoy free time for shopping or relaxation in the city. Breakfast & Dinner Included."
      },
      {
        day: 10,
        title:
          "Scenic Train to St. Moritz and Return to Zurich",
        detail:
          "Wake up early for a day full of beautiful scenery. Depart Zurich and travel to Chur, where you will board the Rhaetian Railway Alpine train for a breathtaking ride through the Engadin Valley’s alpine landscapes—forests and shimmering lakes—en route to the luxurious resort of St. Moritz. Spend time taking in the glamour and winter charm around Lake St. Moritzsee. Later, return by train to Chur, then board the coach back to Zurich. Breakfast & Dinner Included."
      },
      {
        day: 11,
        title:
          "Basel Exploration and Arrival in Mulhouse",
        detail:
          "Prepare for a day trip to Basel. Start your discovery with a walk through Marktplatz, admire the striking red sandstone Town Hall, and visit the quirky Pocket Museum. Explore the Museum of Cultures and the Museum of Fine Arts to view masterpieces by famed artists. Enjoy a stroll through the picturesque alleys and colorful windows of Basel’s old town. Enjoy free time for lunch with many options available. Later, journey on to the charming city of Mulhouse in France, check in at the hotel, and enjoy free time for independent exploration. Breakfast & Dinner Included."
      },
      {
        day: 12,
        title:
          "Colmar and Strasbourg – Storybook Towns and Alsatian Flavors",
        detail:
          "Visit the enchanting town of Colmar, known for its storybook beauty and connection to the tale of Beauty and the Beast. Admire the traditional half-timbered houses and decorative fountains in the heart of Colmar. Then, journey to Strasbourg, an Alsatian city blending French and German influences. Tour the old town’s maze of canals and narrow streets, marvel at the grand cathedral lauded by Victor Hugo, and discover the charming Petite France district. Enjoy free time for lunch with local Alsatian specialties such as winstubs, tarte flambée, and pretzels. Breakfast & Dinner Included."
      },
      {
        day: 13,
        title:
          "Heidelberg and Stuttgart – Historic Sights and Modern Vibes",
        detail:
          "Embark on an excursion to Heidelberg, home to Germany’s oldest and most famous university. Experience the city’s romantic medieval feel, riverside setting, and spectacular Gothic-Renaissance castle. The program here remains a surprise for extra excitement. Later, continue to Stuttgart, the heart of the German automobile industry. Visit the central Schlossplatz with its Baroque gardens and Concordia Column, the Neues Schloss, and the bustling Königstraße shopping street. Breakfast & Dinner Included."
      },
      {
        day: 14,
        title:
          "Return Home with Cherished Memories",
        detail:
          "Transfer to the airport for your flight back home. Breakfast Included."
      },
    ],

    overview: "The French language is refined. It has something polite about it and for many years it was the international language of diplomacy. It was and is the dream of many people to learn it. On this journey, our ears will get used to the singing sounds. Oh, la la! We will cross a French part of Europe and end up in German-speaking Switzerland. The advantage of the program is that the cities where we will spend the nights are close to each other, so it is an enjoyable and not tiring program."
  },
  {
    id: "europe-007",
    slug: "classic-Europe-amsterdam-paris-switzerland",
    destination: "Europe",
    title: "Classic Europe – Amsterdam, Paris & Switzerland",
    duration: "9 Nights 10 Days",
    route: "2N Amsterdam | 3N Paris | 2N Geneva | 2N Zurich",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026"],
    stars: 4,
    price: 268999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [amsterdam,paris,geneva,zurich],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Into Amsterdam", to: "Out of Zurich", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "Amsterdam", nights: "2 Nights", type: "Park Plaza Amsterdam Airport - 4 Star Hotel" },
      { location: "Paris", nights: "3 Nights", type: "The Jangle Hotel - Paris - Charles de Gaulle - Airport -  4 Star Hotel" },
      { location: "Geneva", nights: "2 Nights", type: "Novotel Geneve Aeroport - 4 Star Hotel" },
      { location: "Zurich", nights: "2 Nights", type: "Radisson Hotel & Suites Zurich - 4 Star Hotel" },

    ],

    sightseeing: [
      { title: "Amsterdam Sightseeing" },
      { title: "Paris Sightseeing" },
      { title: "Geneva Sightseeing" },
      { title: "Zurich Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Stay in handpicked 4-star hotels across Europe for a comfortable and memorable journey.",
      "Discover the charm of Amsterdam with a guided city tour and scenic canal cruise.",
      "Visit the stunning Keukenhof Gardens (seasonal) or Madurodam, the miniature Netherlands.",
      "Explore Brussels, visiting the Grand Place, Manneken Pis, and Atomium.",
      "Enjoy a guided Paris city tour with visits to the Eiffel Tower (2nd level) and River Seine Cruise.",
      "Spend an unforgettable day at Disneyland Paris filled with fun and excitement.",
      "Experience the beauty of Geneva and the alpine adventure at Glacier 3000 with the Peak Walk by Tissot.",
      "Enjoy a Scenic Cruise on Lake Brienz & Experience the Golden Pass Train Experience",
      "Discover Interlaken, Lucerne, and Zurich, with a thrilling Rotating Cable Car ride up Mt. Titlis (3,020m).",
      "Enjoy 2 Lunches at Brussels & Glacier 3000.",
      "Daily Breakfast and Dinner with Indian and Continental options.",
      "Guided by experienced English / Hindi-speaking Tour Managers, with all tips included.",
    ],

    exclusions: [
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fare difference arising due to change in travel dates, sector, or airline",
      "Additional costs due to flight rescheduling, cancellation, or no-show",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently.",
      "Guests departing independently from Zurich must arrange or pay for their transfers separately.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
      "Any services not explicitly mentioned in the inclusions",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Touchdown in Amsterdam",
        detail:
          "Welcome to Amsterdam, the vibrant capital of the Netherlands, known for its picturesque canals, historic architecture, and lively cultural scene. Upon your arrival at Amsterdam Schiphol Airport, you will be warmly received by our representative and transferred to your hotel. Take some time to relax, unwind, and settle into your comfortable accommodations. Depending on your arrival time, you may choose to take a leisurely walk around the neighbourhood, soaking in the charming Dutch ambiance. Amsterdam is famous for its bike-friendly streets, iconic canals, and cosy cafes, providing the perfect introduction to your European journey. In the evening, you may enjoy a quiet stroll or simply relax at the hotel. An overnight stay will be in Amsterdam, offering a comfortable start to your memorable European adve (Dinner)"
      },
      {
        day: 2,
        title:
          "Explore Amsterdam With Canal Cruise – Visit Keukenhof Gardens (Until 12th May) Or The Zaanse Schans (From 13th May)",
        detail:
          "After a hearty breakfast at your hotel, embark on an enriching orientation tour of Amsterdam, guided by our expert local guide. This tour covers some of the city’s most iconic landmarks, giving you a comprehensive overview of its history, architecture, and culture. You will pass through Dam Square, the Royal Palace, and the Anne Frank House from the outside, while learning about the city’s rich heritage and modern lifestyle. Following the city tour, enjoy a serene and scenic canal cruise along Amsterdam’s famous waterways. Glide past beautifully preserved 17th-century canal houses, charming bridges, and lively markets, offering perfect photo opportunities at every turn. From 29th March to 13th May, the tour includes a visit to Keukenhof Gardens, renowned worldwide for its spectacular tulip displays, vibrant flowerbeds, and themed gardens. You can stroll through the beautifully landscaped grounds, capturing the essence of Dutch horticultural excellence. From 13th May onwards, the visit will be to Madurodam, a miniature city showcasing the Netherlands’ iconic landmarks and cultural heritage in intricate detail. Both experiences provide a unique insight into Dutch culture and natural beauty. After the excursions, return to your hotel in Amsterdam. The evening is at leisure for you to explore the city independently, enjoy local delicacies, or relax at a café along the canal. Overnight stay in Amsterdam. (Breakfast and Dinner)"
      },
      {
        day: 3,
        title:
          "Transfer from Amsterdam to Paris via Brussels (visit Grand Place, Manneken Pis Statue And Atomium Photo stop)",
        detail:
          "Following breakfast at your hotel in Amsterdam, check out and begin your journey towards Paris. En route, we will make a stop in Brussels, the capital of Belgium and the administrative heart of the European Union. Upon arrival, begin your guided exploration of the city’s highlights. Start with Grand Place, often hailed as one of Europe’s most beautiful squares, home to the medieval Town Hall and stunning guild houses. Marvel at its ornate architecture while learning about its rich history. Next, visit the iconic Manneken Pis, a symbol of the city’s quirky charm. After sightseeing, enjoy a delightful lunch at a local restaurant in Brussels, where you can savour authentic Belgian cuisine and relax before continuing your journey. Continue with a photo stop at the Atomium, an architectural marvel representing a unit cell of an iron crystal magnified 165 billion times. Drive past St. Michael’s Church and other notable landmarks before proceeding onward to Paris. On arrival in Paris, check into your hotel and take some time to relax after your day of travel and sightseeing. In the evening, you may enjoy a leisurely walk along the charming streets or explore nearby cafés and local spots at your own pace. This day beautifully blends the charm of Dutch and Belgian culture with a smooth transition to the romantic city of Paris, preparing you for the next leg of your European adventure. Overnight stay in Paris. (Breakfast, Indian Lunch and Dinner)"
      },
      {
        day: 4,
        title:
          "Paris City Tour – Eiffel Tower 2nd Level And Romantic River Seine Cruise",
        detail:
          "After breakfast, embark on a guided city tour of Paris, a city synonymous with art, fashion, and history. The tour begins with some of the city’s most celebrated landmarks, including Place Vendôme, known for its elegant architecture and luxury boutiques, and Place de l’Opéra Garnier, home to the world-renowned opera house. Pass by Musée d’Orsay, housing masterpieces of Impressionist art, and Place de la Concorde, one of Paris’ largest and most historic public squares. Continue along the famed Champs Élysées, the city’s most fashionable avenue, and witness the grandeur of the Arc de Triomphe, an iconic monument celebrating France’s military history. Next, visit Eiffel Tower, ascending to the 2nd level for breathtaking panoramic views of Paris’ skyline. Standing beneath its iron lattice structure, you will feel the scale and significance of this architectural marvel. Afterward, enjoy a romantic cruise along the River Seine, a perfect way to admire Paris’ historic bridges and monuments from a unique perspective. Glide past the Notre Dame Cathedral, the Louvre Museum, and Les Invalides, taking in the picturesque scenery and capturing memorable photographs. The Seine cruise offers an intimate glimpse into Paris’ charm, blending history, art, and natural beauty. Return to the hotel in the evening for overnight stay in Paris. (Breakfast and Dinner)"
      },
      {
        day: 5,
        title:
          "Enjoy Your Fun Filled Day At Disneyland Paris",
        detail:
          "After breakfast at the hotel, prepare for a day full of magic and excitement at Disneyland Paris, one of Europe’s most popular amusement destinations. The park offers a perfect blend of entertainment, thrill rides, and family-friendly attractions, ensuring a memorable experience for all ages. You may choose to explore Disney Parks, where the enchanting lands bring fairy tales to life. From adventure-filled rides to vibrant street parades featuring beloved Disney characters, there is something to captivate every visitor. Experience the charm of Fantasyland, the adventure of Adventureland, and the magic of Main Street, U.S.A., all in one immersive experience. Alternatively, you may choose to visit Walt Disney Studios Park, where you can witness the behind-the-scenes magic of movie-making. Enjoy live stunt shows, observe real film sets, and explore interactive attractions that showcase the cinematic world. This unique experience allows visitors to engage with the art and craft of filmmaking, creating memories that go beyond ordinary amusement parks. Throughout the day, you can enjoy themed dining options, shopping, and interactive experiences. Capture photographs with your favorite Disney characters, enjoy thrilling rides, and soak in the immersive environment that Disneyland Paris offers. After a fun-filled day, return to your hotel in Paris for overnight stay. (Breakfast and Dinner)"
      },
      {
        day: 6,
        title:
          "From Paris to the Heart of Geneva",
        detail:
          "After a delightful breakfast in Paris, check out from your hotel and embark on a scenic drive to Geneva, Switzerland’s cosmopolitan gem. Nestled between Lake Geneva and the majestic Alps, the city perfectly blends natural beauty with international sophistication. Upon arrival, enjoy an orientation tour of Geneva, beginning with the iconic Jet d’Eau, one of the world’s tallest fountains, set against the sparkling waters of the lake. Stroll through the English Garden, home to the famous floral clock, a symbol of Swiss precision and artistry. Pass by the Palais des Nations, the European headquarters of the United Nations, and admire the Reformation Wall, commemorating key figures of the Protestant Reformation. Learn about Geneva’s rich history, diplomatic significance, and cultural charm from your guide as you explore the city’s highlights. Spend the evening at leisure, perhaps strolling along the serene lakeside promenade, enjoying the crisp alpine air, or relaxing at your hotel with a view of the lake and surrounding mountains. Geneva is a city that impresses with its elegance and calm energy, offering a perfect introduction to your Swiss adventure. Overnight stay is in the Lake Geneva region, ensuring a restful night before the excitement of the Alps begins. (Breakfast and Dinner)."
      },
      {
        day: 7,
        title:
          "Day trip to Gstaad - Glacier 3000",
        detail:
          "Start your day with breakfast at the hotel before heading to Glacier 3000, near the chic town of Gstaad. The journey itself offers breathtaking views of rolling Swiss landscapes and towering alpine peaks. Upon arrival, take a cable car ride to the glacier, where adventure awaits for all ages. Thrill-seekers can experience the 1-kilometre Alpine Coaster, the world’s highest bobsleigh track, or opt for husky sled rides, skiing, and the snow bus adventure. Don’t miss the Peak Walk by Tissot, Europe’s highest suspension bridge, offering jaw-dropping panoramic vistas of snow-capped mountains and icy crevasses. Enjoy a leisurely lunch at Botta 3000 or Oldegg, where local specialties are served amid stunning alpine views. On the return journey, stop at Gstaad, a charming and sophisticated town favored by celebrities and travelers worldwide. Wander its cobbled streets, explore boutique shops, or enjoy a coffee at a local café while soaking in its luxury ambiance. The day combines adrenaline, scenic beauty, and refined alpine charm, creating memories you’ll cherish forever. Return to your hotel for an overnight stay in the Lake Geneva region (Breakfast, Lunch and Dinner)"
      },
      {
        day: 8,
        title:
          "From Montreux to Zurich via the Golden Pass and Cruise on Lake Brienz",
        detail:
          "After breakfast, drive from Geneva to Montreux (approx. 1.5 hours), a charming resort town nestled on the shores of Lake Geneva and surrounded by snow-capped peaks. The scenic drive offers wonderful lake and vineyard views, setting the tone for a picturesque day ahead. Upon arrival, proceed for a short orientation tour of Montreux, renowned for its mild climate and beautiful lakeside setting. Stroll along the flower-lined promenade, admire the elegant Belle Époque architecture, and capture postcard-perfect photographs of the famous Chillon Castle, one of Switzerland’s most iconic landmarks gracefully standing on the lake’s edge. Later, board the GoldenPass panoramic train from Montreux to Zweisimmen, one of the most beautiful train journeys in the country. Relax in comfortable panoramic coaches as the route unfolds through rolling vineyards, Alpine meadows, charming chalets, and tranquil valleys, offering a glimpse of Switzerland’s natural beauty and rural charm. On arrival at Zweisimmen, continue your journey by road via Interlaken, a picturesque resort town nestled between Lake Thun and Lake Brienz. Here, enjoy a scenic cruise on Lake Brienz, known for its vivid turquoise waters and dramatic mountain backdrop. Glide past traditional Swiss villages and cascading waterfalls, immersing yourself in the serenity of the Bernese Oberland region. After this memorable experience, drive onward to Zurich, Switzerland’s vibrant financial and cultural hub. Upon arrival, check in to your hotel and unwind after a day filled with panoramic views and unforgettable sights. In the evening, you may explore the lively Bahnhofstrasse, one of Europe’s most exclusive shopping avenues, or enjoy a peaceful stroll along the Zurich lakeside promenade, soaking in the charm of Switzerland’s largest city. (Breakfast and Dinner)."
      },
      {
        day: 9,
        title:
          "World’s First Rotating Cable Car Rotair Up Mt. Titlis Peak At 3,020m - Orientation Tour of Lucerne",
        detail:
          "World’s First Rotating Cable Car Rotair Up Mt. Titlis Peak At 3,020m - Orientation Tour of Lucerne Edit After breakfast, get ready for a thrilling alpine experience as we head to the mountain village of Engelberg. From here, enjoy a series of cable car rides leading up to the spectacular Mt. Titlis, culminating in the breathtaking Rotair, the world’s first revolving cable car. At 3,020 meters above sea level, soak in stunning 360-degree views of snow-covered peaks, deep crevasses, and glistening glaciers. Test your nerves with a walk on the Cliff Walk, Europe’s highest suspension bridge, perched along the edge of Mt. Titlis — an unforgettable experience! Later, we descend and travel to the beautiful city of Lucerne. Enjoy an orientation tour of its highlights, including the Chapel Bridge (Kapellbrücke) and the moving Lion Monument. Enjoy some free time to shop for Swiss souvenirs like watches, chocolates, and knives before heading back to Zurich (Breakfast and Dinner)."
      },
      {
        day: 10,
        title:
          "Adieu Europe – A Grand Journey Concludes",
        detail:
          "After breakfast, it’s time to bid farewell to your unforgettable European adventure. Check out from the hotel and transfer to Zurich Airport for your flight back home. As you depart, take with you memories of snow-capped peaks, crystal-clear lakes, charming alpine towns, and the warmth of shared experiences — a journey through Switzerland you’ll cherish forever. (Breakfast)."
      },

    ],

    overview: "Embark on a captivating 10-day European journey designed around immersive moments and authentic experiences rather than sightseeing checklists. Begin in Amsterdam, where life flows gently along canals and cozy cafés invite you to slow down and savor the atmosphere. Travel onward through Brussels and into the romantic elegance of Paris, where stylish boulevards, charming neighborhoods, and magical evenings create memories that linger long after sunset. Enjoy time soaking in the joy and excitement at Disneyland Paris, adding a touch of wonder to your journey. Continue to the serene landscapes of Geneva and the Swiss Alps, where crisp mountain air, scenic drives, and peaceful alpine surroundings offer a refreshing escape. Experience the glamour of Gstaad, the historic charm of Bern, and the vibrant sophistication of Zurich, embracing Switzerland’s perfect balance of tradition and modern elegance. From relaxed strolls and cultural ambiance to breathtaking mountain settings, this thoughtfully curated tour allows you to truly feel Europe’s charm, beauty, and warmth at every step."
  },
  {
    id: "europe-008",
    slug: "grand-europe-highlights-with-euroStar",
    destination: "Europe",
    title: "Grand Europe Highlights with EuroStar",
    duration: "13 Nights 14 Days",
    route: "2N Rome | 1N Ferrara | 1N Milan | 3N Zurich | 3N Paris | 3N London",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 365999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [rome,ferrara,zurich,paris,london],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Into Rome", to: "Out of london", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "Rome", nights: "2 Nights", type: "Hampton By Hilton Rome North Fiano Romano - 4 Star Hotel" },
      { location: "Ferrara", nights: "1 Nights", type: "Radisson Hotel Ferrara - 4 Star Hotel" },
      { location: "Milan", nights: "1 Nights", type: "Zeus Essence Dolce by Wyndham Milan Malpensa - 4 Star Hotel" },
      { location: "Zurich", nights: "3 Nights", type: "Radisson Hotel & Suites Zurich - 4 Star Hotel" },
      { location: "Paris", nights: "3 Nights", type: "The Jangle Hotel - Paris - Charles de Gaulle - Airport - 4 Star Hotel" },
      { location: "London", nights: "3 Nights", type: "Moxy Slough - 4 Star Hotel" },

    ],

    sightseeing: [
      { title: "Rome Sightseeing" },
      { title: "Ferrara Sightseeing" },
      { title: "Milan Sightseeing" },
      { title: "Zurich Sightseeing" },
      { title: "Paris Sightseeing" },
      { title: "London Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Stay in good 4-star hotels across Europe.",
      "Explore ancient Rome and the Vatican City with a guided tour of St. Peter’s Basilica.",
      "Capture the perfect photo at the iconic Leaning Tower of Pisa and admire Florence from Piazzale Michelangelo.",
      "Glide through Venice’s canals with a classic gondola ride and visit the majestic St. Mark’s Square.",
      "Ascend Mt. Titlis in the world’s first rotating cable car and walk the thrilling Cliff Walk.",
      "Visit Interlaken, nestled between Lake Thun and Lake Brienz in the Swiss Alps.",
      "Optional excursion to Jungfraujoch – The Top of Europe by cogwheel train.",
      "Relive childhood dreams at Disneyland Paris and admire the city from the Eiffel Tower’s 2nd level.",
      "Travel from Paris to London via Eurostar – high-speed train through the Channel Tunnel.",
      "Discover London’s iconic sights with visits to Big Ben, Buckingham Palace, Madame Tussauds, and the London Eye.",
      "Dive into cricket heritage at Lords Cricket Stadium and enjoy luxury shopping at Bicester Village.",
      "13 Indian Jain / Vegetarian / Non-Vegetarian Dinners.",
      "5 Indian Lunch included.",
      "Services of an experienced English / Hindi-speaking Tour Manager throughout the tour.",
      "All Driver and Tour Manager Tips Included.",
    ],

    exclusions: [
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fare difference arising due to change in travel dates, sector, or airline",
      "Additional costs due to flight rescheduling, cancellation, or no-show",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently.",
      "Guests departing independently from Zurich must arrange or pay for their transfers separately.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
      "Any services not explicitly mentioned in the inclusions",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Rome Awaits – A Grand Beginning to Your European Journey",
        detail:
          "Welcome to Rome, a city where ancient history, timeless architecture, and vibrant culture come together. Upon your arrival at the airport, our friendly representative will greet you at the arrival hall and assist you with your transfer to the hotel. After check-in, take some time to relax and settle in. The rest of the day is at leisure for you to unwind or explore the surroundings at your own pace. Breathe in the Roman air, admire the classic streets, or simply prepare for the exciting journey that lies ahead. In the evening, join your fellow travelers for a delicious Indian dinner, setting the perfect tone for your European adventure. Get ready to explore historic wonders, cultural icons, and scenic beauty in the days to come. (Dinner)"
      },
      {
        day: 2,
        title:
          "Rome Guided City Tour with Vatican City and St. Peter’s Basilica",
        detail:
          "After a hearty breakfast at the hotel, the day begins with an immersive exploration of one of the world’s most iconic capitals—Rome, steeped in history, art, and imperial grandeur. Accompanied by a professional English-speaking guide, the first stop is Vatican City, the smallest independent state in the world. Here, you'll visit the majestic St. Peter’s Basilica, a masterpiece of Renaissance architecture adorned with incredible works by Michelangelo and Bernini. Marvel at the grandeur of its dome, sculptures, and the awe-inspiring Pietà, as your guide reveals the stories and significance behind each element. Next, return to the heart of Rome for a panoramic city tour. Capture postcard-perfect photos at the Colosseum (exterior), once a grand arena of gladiatorial combat. The drive continues past historical landmarks like Piazza Venezia, home to the grand Victor Emmanuel II Monument, and the legendary Trevi Fountain, where tossing a coin is said to ensure your return to Rome. Your guide will bring history to life, sharing tales of ancient emperors, Renaissance masters, and modern-day marvels. After soaking in the essence of Rome, regroup for a delicious Indian lunch. The rest of the afternoon allows time to explore or relax before returning to the hotel. In the evening, enjoy a traditional Indian dinner with your fellow travelers, recounting the highlights of your Roman adventure. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 3,
        title:
          "Visit Leaning Tower of Pisa – Florence City Tour & Piazzale Michelangelo",
        detail:
          "Start your day with a scenic drive through the Tuscan countryside as you journey from Rome toward the iconic city of Pisa. Upon arrival, you’ll visit the stunning Piazza dei Miracoli, or Square of Miracles—a UNESCO World Heritage Site. Here, marvel at the world-famous Leaning Tower of Pisa, a symbol of architectural wonder and human error turned tourist magnet. Surrounding this area are equally impressive sights like the Baptistery, Monumental Cemetery, and Cathedral of St. Mary of the Assumption, showcasing the Romanesque elegance of medieval Italy. After photo opportunities and time to appreciate Pisa's historical treasures, continue toward Florence, the cradle of the Renaissance. As you approach the city, your first stop is the famous Piazzale Michelangelo, offering a panoramic view over Florence’s red-tiled rooftops, bridges, and monuments—a breathtaking sight perfect for photos. During the orientation tour of Florence, stroll past the city’s key landmarks: the Florence Duomo, crowned by Brunelleschi’s massive dome, the Baptistery with its golden “Gates of Paradise”, Giotto’s Campanile, and the lively Piazza della Signoria, surrounded by Renaissance sculptures and the imposing Palazzo Vecchio. You’ll also see the charming Ponte Vecchio, a medieval stone bridge lined with artisan shops. The tour balances history with leisure, giving you a taste of Florence’s rich cultural heritage and its relaxed Tuscan charm. As the sun sets, proceed to your hotel in Bologna, where a hot Indian dinner awaits—perfect after a day immersed in art, architecture, and Italian legacy. (Breakfast and Dinner)."
      },
      {
        day: 4,
        title:
          "Transfer To Venice – The Floating City Of Italy With Gondola Ride",
        detail:
          "Today’s journey transports you to the magical world of Venice, a city built entirely on water, rich with romantic charm, artistic heritage, and timeless architecture. After breakfast, check out and drive to the Venetian pier, where a private boat awaits to take you across the shimmering waters of the Giudecca Canal. Feel the charm unfold as you arrive at the vibrant St. Mark’s Square, the heart of Venice. Here, admire the magnificent St. Mark’s Basilica, a masterpiece of Byzantine architecture adorned with intricate mosaics and golden domes. Nearby, witness the Clock Tower, the Bell Tower, and the famous Bridge of Sighs, connecting the Doge’s Palace to the historical prison complex. The view, the stories, and the atmosphere transport you to a different era. No trip to Venice is complete without a romantic Gondola ride. Glide through the city's narrow canals, flanked by grand palazzos and picturesque bridges. The peaceful sway of the boat and the reflections of centuries-old buildings in the water create a dreamlike experience unique to Venice. After this unforgettable experience, enjoy a delectable Indian lunch before continuing the journey towards Milan. Upon arrival, you’ll check into your hotel and unwind after a magical day. Venice’s elegance, serenity, and cinematic beauty are sure to remain one of the most cherished highlights of your European journey. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 5,
        title:
          "Discover Milan’s Elegance & Experience the Serenity of Lake Como – Drive to Zurich",
        detail:
          "Begin your morning with a delicious breakfast before checking out from your hotel in Milan. Your first experience today is a brief yet enriching orientation tour of Milan, Italy’s fashion and design capital. Visit the majestic Milan Cathedral (Duomo di Milano), one of the largest and most intricate Gothic cathedrals in the world. Just a few steps away is the historic Galleria Vittorio Emanuele II, a stunning 19th-century shopping arcade with beautiful glass domes, mosaics, and high-end boutiques. This elegant space is also a hotspot for enjoying Italian coffee and capturing some stunning photographs. After exploring Milan, you’ll travel north to the breathtakingly scenic region of Lake Como, a favorite getaway for celebrities and romantics alike. Nestled against the Alpine foothills, this lake is famed for its dramatic landscape, sparkling waters, and elegant lakeside villas. Visit the charming village of Bellagio (subject to road/weather conditions), often referred to as the “Pearl of Lake Como.” Here, you can stroll through narrow cobbled streets, admire pastel-colored buildings, and soak in views of the serene lakefront. Following this picturesque escape, continue your journey across the Swiss border into Zurich, Switzerland’s largest city. Relax in your comfortable coach and enjoy the changing landscapes as the terrain shifts from Italian elegance to Swiss precision and alpine charm. Upon arrival in Zurich by evening, settle into your hotel and enjoy a hearty Indian dinner. Today beautifully blends urban style, natural beauty, and cross-border adventure—offering a taste of Italy’s vibrant cities and the tranquil elegance of Switzerland’s countryside. (Breakfast and Dinner)"
      },
      {
        day: 6,
        title:
          "World’s First Rotating Cable Car Rotair Up Mt. Titlis Peak At 3,020m - Orientation Tour of Lucerne",
        detail:
          "After breakfast, get ready for a thrilling alpine experience as we head to the mountain village of Engelberg. From here, enjoy a series of cable car rides leading up to the spectacular Mt. Titlis, culminating in the breathtaking Rotair, the world’s first revolving cable car. At 3,020 meters above sea level, soak in stunning 360-degree views of snow-covered peaks, deep crevasses, and glistening glaciers. Test your nerves with a walk on the Cliff Walk, Europe’s highest suspension bridge, perched along the edge of Mt. Titlis — an unforgettable experience! Later, we descend and travel to the beautiful city of Lucerne. Enjoy an orientation tour of its highlights, including the Chapel Bridge (Kapellbrücke) and the moving Lion Monument. Enjoy some free time to shop for Swiss souvenirs like watches, chocolates, and knives before heading back to Zurich. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 7,
        title:
          "Magical Alpine Excursion To The Top Of Europe – The Amazing Jungfraujoch And Scenic Interlaken (Extra Cost)",
        detail:
          "After breakfast, get ready for a truly magical Alpine experience. Today, you have the opportunity to join an unforgettable excursion to Jungfraujoch – The Top of Europe (available at an additional cost). We begin by heading to Grindelwald Terminal, where the state-of-the-art Eiger Express gondola swiftly takes you to Eigergletscher Station in just 15 minutes. From there, board the legendary cogwheel train that ascends to the highest railway station in Europe at 11,333 feet. At the summit, immerse yourself in a world of eternal snow and ice. Wander through the Ice Palace, where artists sculpt masterpieces in frozen form, and take in jaw-dropping views of the Aletsch Glacier from the panoramic Sphinx Observatory — a true high point of your European adventure. Those who prefer a more relaxed day can spend time in Interlaken, a scenic town nestled between two lakes and surrounded by the majestic Swiss Alps. Whether shopping for Swiss souvenirs or enjoying a lakeside walk, Interlaken offers a peaceful escape. Later in the day, regroup and return to Zurich for the night. (Breakfast and Dinner)."
      },
      {
        day: 8,
        title:
          "From the Roar of Rhine Falls to the Romance of Paris",
        detail:
          "After breakfast, check out and begin your day in the comfort of your luxury coach as you journey across the Swiss-French border toward Paris, the world-renowned City of Lights. The long but scenic drive offers changing vistas – from serene Alpine valleys to charming French countryside – providing a smooth transition from nature’s raw grandeur to urban elegance. Upon arrival in Paris by early evening, complete the hotel check-in and take some time to relax. The evening is yours to explore at leisure—stroll around the vicinity or simply unwind after a scenic travel day. For those interested in an enchanting Parisian night, optional experiences like the Moulin Rouge Cabaret or Paris by Night tour can be arranged (at extra cost). Later, enjoy a comforting Indian dinner with the group, discussing the journey so far and looking ahead to Paris’ iconic attractions awaiting you in the coming days—Eiffel Tower, Seine Cruise, and Disneyland adventures. (Breakfast and Dinner)."
      },
      {
        day: 9,
        title:
          "Paris City Tour – Eiffel Tower 2nd Level & Seine River Cruise",
        detail:
          "After a delightful breakfast, embark on a panoramic guided city tour of Paris, exploring its most iconic and glamorous sights. Drive past the elegant Place Vendôme, Opéra Garnier, Musée d’Orsay, Place de la Concorde, and the world-renowned Champs-Élysées. Marvel at architectural wonders like the Arc de Triomphe, Alexander Bridge, and Les Invalides, each telling a story of the city’s rich history and grandeur. Next, ascend to the 2nd level of the Eiffel Tower, where breathtaking views of Paris await — an unforgettable photo opportunity! Later, set off on a romantic Seine River Cruise, drifting gently past stunning landmarks like Notre-Dame, Louvre Museum, and charming riverside façades. The illuminated bridges and skyline offer a dreamy Parisian evening experience. (Breakfast and Dinner)."
      },
      {
        day: 10,
        title:
          "A Magical Day at Disneyland Paris",
        detail:
          "Get ready for a day packed with fun, fantasy, and unforgettable experiences at Disneyland Paris, one of Europe’s most popular theme parks. Today, you can choose to explore either the enchanting Disneyland Park, where five immersive lands bring classic Disney tales to life, or the Walt Disney Studios Park, where movie magic takes center stage with thrilling shows, behind-the-scenes secrets, and jaw-dropping stunts. Feel the magic as you stroll through Sleeping Beauty’s Castle, join Captain Jack Sparrow on a pirate adventure, or zoom through space with Buzz Lightyear. Don’t miss the colourful street parades and character meet-and-greets that add charm to every corner of the park. At the studios, be amazed by professional stunt performances, discover how animation is created, and explore real-life film sets. Whether you're a thrill-seeker, a Disney fan, or just looking for a memorable day out, Disneyland Paris offers something for everyone — from adrenaline-pumping roller coasters to calm, whimsical rides for kids. Relish a day full of joy and wonder with your loved ones. (Breakfast and Dinner)."
      },
      {
        day: 11,
        title:
          "Paris to London – Across the Channel with a Taste of Elegance",
        detail:
          "Say goodbye to the magic of Paris and get ready to cross the English Channel for a day full of excitement in London. After breakfast, you'll head to the iconic city of London, where history, culture, and modernity blend seamlessly. Your journey kicks off with a scenic drive, giving you a glimpse of the charming countryside as you make your way to one of the world’s most famous cities. Upon arrival, you’ll be greeted by London’s iconic landmarks, from the majestic Tower of London to the grandeur of Buckingham Palace. Spend your day exploring the best of London, from strolling along the River Thames to shopping at Covent Garden or Oxford Street. Don’t miss the chance to snap a photo in front of Big Ben, or take a ride on the famous London Eye for panoramic views of the city. Whether you’re a history buff, a culture enthusiast, or simply in search of adventure, London offers something for every traveler. From world-class museums to beautiful parks and gardens, your time in London will be nothing short of unforgettable. (Breakfast and Dinner)."
      },
      {
        day: 12,
        title:
          "Iconic London – City Tour, Madame Tussauds & The London Eye",
        detail:
          "After breakfast, step out for a full day of sightseeing in London, a city where tradition meets trend. Your expert local guide will lead you through some of the most celebrated landmarks in the British capital. Drive past Hyde Park, Big Ben, The Houses of Parliament, and the magnificent Westminster Abbey. Stop for photos at Buckingham Palace, and if you're lucky, witness the Changing of the Guard (subject to schedule). Continue through Trafalgar Square, Piccadilly Circus, and the historic Tower Bridge, soaking in London’s majestic skyline. Next, visit the world-famous Madame Tussauds Wax Museum, where lifelike wax figures of celebrities, royalty, and sports legends await your selfies. From here, head to the iconic London Eye—Europe’s tallest cantilevered observation wheel—for breathtaking panoramic views of the Thames, Parliament, and beyond. Enjoy a delicious Indian lunch during the day, followed by free time to shop or relax. The evening offers a chance to walk around the city, admire the twilight-lit buildings, or return to your hotel to unwind. Dinner will be served at an Indian restaurant or hotel. With history, culture, and scenic splendor, Day 2 gives you a true taste of London in its full glory. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 13,
        title:
          "Lords Cricket Ground & Bicester Village Shopping",
        detail:
          "Start your day with a fulfilling breakfast before heading to a sacred ground for cricket lovers—Lords Cricket Stadium. Known as the “Home of Cricket,” this world-famous venue offers a fascinating guided tour, where you’ll explore the players’ dressing rooms, the Long Room, and walk through the iconic corridor leading to the pitch. Feel the legacy of over 200 years of cricketing history as you stand where legends have played. If Lords is unavailable on the day of visit due to events or closures, an alternate visit to the Tower of London will be arranged—a historic fortress that holds centuries of royal secrets and the dazzling Crown Jewels. Later in the day, drive to the stylish Bicester Village Outlet Mall, one of Britain’s top luxury shopping destinations. From global designer brands to high-street favourites, enjoy free time for shopping your heart out at attractive discounted prices. Throughout the day, enjoy Indian meals that include a well-planned lunch and dinner. You’ll also have some leisure time to sip a coffee or explore dining outlets inside the shopping village. Whether you're a shopaholic or just soaking in the charming English countryside ambiance, Bicester offers a laid-back contrast to London’s energy. Return to the hotel by evening with shopping bags full and spirits high. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 14,
        title:
          "Adieu Europe – A Grand Journey Concludes",
        detail:
          "After breakfast, it’s time to bid farewell to your unforgettable journey across Europe. Check out from the hotel and transfer to the airport in London for your flight back home. As you depart, carry with you the memories of iconic cities, breathtaking landscapes, rich cultures, and the warmth of shared experiences — a journey you’ll cherish forever. (Breakfast)."
      },
    ],

    overview: "Embark on an unforgettable 14-day European escape filled with timeless charm, breathtaking scenery, and immersive cultural moments. Experience the romance and history of Rome and Vatican City, soak in Renaissance elegance and scenic piazzas, and glide through the enchanting canals of Venice on a classic gondola ride. Feel the glamour of Italian city life before embracing the serenity of the Swiss Alps, where snowy peaks, rotating cable cars, and panoramic mountain views create pure alpine magic. Witness the roar of majestic waterfalls, stroll through charming lakeside towns, and then step into the romance of Paris with its illuminated skyline, river cruises, and magical theme park thrills. Conclude your journey in vibrant London, where royal landmarks, iconic skyline views, and lively streets blend heritage with modern energy—bringing together history, adventure, elegance, and unforgettable memories in one grand European holiday."
  },
  {
    id: "europe-009",
    slug: "grand-tour-of-europe-2026",
    destination: "Europe",
    title: "Grand Tour of Europe - 2026",
    duration: "15 Nights 16 Days",
    route: "3N London | 3N Paris | 1N Amsterdam | 1N Frankfurt | 3N Zurich | 1N Innsbruck | 1N Padova | 1N Arezzo | 1N Rome",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 399999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [london,paris,amsterdam,frankfurt,zurich,innsburck,padova,arezzo,rome],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Into London", to: "Out of Rome", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "London", nights: "3 Nights", type: "Moxy Slough - 4 Star Hotel" },
      { location: "Paris", nights: "3 Nights", type: "The Jangle Hotel - Paris - Charles de Gaulle - Airport - 4 Star Hotel" },
      { location: "Amsterdam", nights: "1 Nights", type: "NH Amsterdam Schiphol Airport - 4 Star Hotel" },
      { location: "Frankfurt", nights: "1 Nights", type: "Elaya hotel frankfurt oberursel - 4 Star Hotel" },
      { location: "Zurich", nights: "3 Nights", type: "Radisson Hotel & Suites Zurich - 4 Star Hotel" },
      { location: "Innsbruck", nights: "1 Nights", type: "Hotel Alpenkonig Tirol - 4 Star Hotel" },
      { location: "Padova", nights: "1 Nights", type: "Crowne Plaza Padova by IHG - 4 Star Hotel" },
      { location: "Arezzo", nights: "1 Nights", type: "Hotel Park - 4 Star Hotel" },
      { location: "Rome", nights: "1 Nights", type: "Hampton By Hilton Rome North Fiano Romano - 4 Star Hotel" },

    ],

    sightseeing: [
      { title: "London Sightseeing" },
      { title: "Paris Sightseeing" },
      { title: "Amsterdam Sightseeing" },
      { title: "Frankfurt Sightseeing" },
      { title: "Zurich Sightseeing" },
      { title: "Innsbruck Sightseeing" },
      { title: "Padova Sightseeing" },
      { title: "Arezzo Sightseeing" },
      { title: "Rome Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Stay in good 4-star hotels in Europe",
      "Discover London’s iconic sights with visits to Big Ben, Buckingham Palace, Madame Tussauds, and the London Eye.",
      "Dive into cricket heritage at Lords Stadium and enjoy luxury shopping at Bicester Village.",
      "Cross the English Channel by ferry and arrive in Paris for a warm evening welcome in the City of Lights.",
      "Discover Paris with the Eiffel Tower, Seine Cruise, and a magical day at Disneyland.",
      "Explore Brussels' Grand Place and Atomium, and cruise through Amsterdam’s scenic canals.",
      "Visit Venice with a romantic Gondola ride, the Leaning Tower of Pisa, Florence’s Duomo, and Rome’s Colosseum and Trevi Fountain.",
      "Enjoy Swiss delights at Rhine Falls, Mt. Titlis, and optional Jungfraujoch – Top of Europe.",
      "Visit the Swarovski Crystal Museum, experience Vaduz toy train, and shop for Swiss watches and chocolates in Lucerne.",
      "Savour Belgian waffles, relish authentic Italian pizza and pasta, and indulge in creamy gelato.",
      "14 Indian Jain/Vegetarian/Non-Vegetarian Lunches",
      "15 Indian Jain/Vegetarian/Non-Vegetarian Dinners",
      "All Transfers and Tours by Luxury AC Coach",
      "Services of an English/Hindi Experienced Tour Manager",
      "All Driver and Tour Manager Tips Included",
    ],

    exclusions: [
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fare difference arising due to change in travel dates, sector, or airline",
      "Additional costs due to flight rescheduling, cancellation, or no-show",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently.",
      "Guests departing independently from Zurich must arrange or pay for their transfers separately.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
      "Any services not explicitly mentioned in the inclusions",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in London – A Regal Welcome to Britain",
        detail:
          "Welcome to London, the bustling capital of the United Kingdom! Upon your arrival, our representative will greet you at the airport and assist with your transfer to the hotel. After check-in, take some time to relax and recover from your journey. Depending on your flight arrival time, you may have the evening free to explore the surroundings or unwind at the hotel. If you arrive early, you can take a short walk in nearby Windsor or simply rest in preparation for the exciting journey ahead. Dinner will be arranged for you; however, please note that in case of a late flight arrival (after 6:30 PM), a packed dinner may be provided to ensure your comfort. Begin your European adventure in true British style—calm, classic, and comfortable. (Dinner)"
      },
      {
        day: 2,
        title:
          "Iconic London – City Tour, Madame Tussauds & The London Eye",
        detail:
          "After breakfast, step out for a full day of sightseeing in London, a city where tradition meets trend. Your expert local guide will lead you through some of the most celebrated landmarks in the British capital. Drive past Hyde Park, Big Ben, The Houses of Parliament, and the magnificent Westminster Abbey. Stop for photos at Buckingham Palace, and if you're lucky, witness the Changing of the Guard (subject to schedule). Continue through Trafalgar Square, Piccadilly Circus, and the historic Tower Bridge, soaking in London’s majestic skyline. Next, visit the world-famous Madame Tussauds Wax Museum, where lifelike wax figures of celebrities, royalty, and sports legends await your selfies. From here, head to the iconic London Eye—Europe’s tallest cantilevered observation wheel—for breathtaking panoramic views of the Thames, Parliament, and beyond. Enjoy a delicious Indian lunch during the day, followed by free time to shop or relax. The evening offers a chance to walk around the city, admire the twilight-lit buildings, or return to your hotel to unwind. Dinner will be served at an Indian restaurant or hotel. With history, culture, and scenic splendor, Day 2 gives you a true taste of London in its full glory. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 3,
        title:
          "Lords Cricket Ground & Bicester Village Shopping",
        detail:
          "Start your day with a fulfilling breakfast before heading to a sacred ground for cricket lovers—Lords Cricket Stadium. Known as the “Home of Cricket,” this world-famous venue offers a fascinating guided tour, where you’ll explore the players’ dressing rooms, the Long Room, and walk through the iconic corridor leading to the pitch. Feel the legacy of over 200 years of cricketing history as you stand where legends have played. If Lords is unavailable on the day of visit due to events or closures, an alternate visit to the Tower of London will be arranged—a historic fortress that holds centuries of royal secrets and the dazzling Crown Jewels. Later in the day, drive to the stylish Bicester Village Outlet Mall, one of Britain’s top luxury shopping destinations. From global designer brands to high-street favourites, enjoy free time for shopping your heart out at attractive discounted prices. Throughout the day, enjoy Indian meals that include a well-planned lunch and dinner. You’ll also have some leisure time to sip a coffee or explore dining outlets inside the shopping village. Whether you're a shopaholic or just soaking in the charming English countryside ambiance, Bicester offers a laid-back contrast to London’s energy. Return to the hotel by evening with shopping bags full and spirits high. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 4,
        title:
          "London to Paris – Across the Channel with a Taste of Elegance",
        detail:
          "After breakfast, check out and prepare for a memorable journey as you bid farewell to the United Kingdom. You'll drive to the historic Dover port, where your group will board a scenic ferry to Calais, crossing the iconic English Channel—a classic European experience in itself. On arrival in Calais, continue your coach journey through the picturesque French countryside toward Paris. The drive will take approximately 4–5 hours, offering the perfect time to relax, enjoy the views, or catch a nap en route. To ensure your comfort during the drive, a packed lunch will be thoughtfully arranged, so you can dine conveniently while on the move. By early evening, you’ll arrive in the magnificent City of Lights—Paris. Upon reaching, head straight for a delicious Indian dinner before checking in at the hotel. After dinner and a smooth check-in, the rest of the evening is at leisure to relax. Paris greets you with its charming streets, elegant architecture, and promise of unforgettable memories in the days ahead. The next few days will reveal the city's most enchanting highlights—from the Eiffel Tower and Seine River Cruise to Disneyland magic. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 5,
        title:
          "Paris City Tour – Eiffel Tower 2nd Level & Seine River Cruise",
        detail:
          "After a delightful breakfast, embark on a panoramic guided city tour of Paris, exploring its most iconic and glamorous sights. Drive past the elegant Place Vendôme, Opéra Garnier, Musée d’Orsay, Place de la Concorde, and the world-renowned Champs-Élysées. Marvel at architectural wonders like the Arc de Triomphe, Alexander Bridge, and Les Invalides, each telling a story of the city’s rich history and grandeur. Next, ascend to the 2nd level of the Eiffel Tower, where breathtaking views of Paris await — an unforgettable photo opportunity! Later, set off on a romantic Seine River Cruise, drifting gently past stunning landmarks like Notre-Dame, Louvre Museum, and charming riverside façades. The illuminated bridges and skyline offer a dreamy Parisian evening experience. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 6,
        title:
          "A Magical Day at Disneyland Paris",
        detail:
          "Get ready for a day packed with fun, fantasy, and unforgettable experiences at Disneyland Paris, one of Europe’s most popular theme parks. Today, you can choose to explore either the enchanting Disneyland Park, where five immersive lands bring classic Disney tales to life, or the Walt Disney Studios Park, where movie magic takes center stage with thrilling shows, behind-the-scenes secrets, and jaw-dropping stunts. Feel the magic as you stroll through Sleeping Beauty’s Castle, join Captain Jack Sparrow on a pirate adventure, or zoom through space with Buzz Lightyear. Don’t miss the colourful street parades and character meet-and-greets that add charm to every corner of the park. At the studios, be amazed by professional stunt performances, discover how animation is created, and explore real-life film sets. Whether you're a thrill-seeker, a Disney fan, or just looking for a memorable day out, Disneyland Paris offers something for everyone — from adrenaline-pumping roller coasters to calm, whimsical rides for kids. Relish a day full of joy and wonder with your loved ones. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 7,
        title:
          "Three Cities in a Day – Paris, Brussels & Amsterdam Adventure",
        detail:
          "After enjoying a hearty breakfast, check out from your Paris hotel as we begin our journey to the Netherlands. En route, we stop in Brussels, the charming capital of Belgium and the de facto headquarters of the European Union. This cosmopolitan city beautifully blends historic charm with modern elegance. Our first stop is the Grand Place, a UNESCO World Heritage Site and one of Europe’s most stunning squares. Surrounded by elegant guildhalls and the 15th-century Brussels Town Hall, it’s the perfect spot to soak in the grandeur of Belgian architecture. From there, we take a short walk to the beloved Manneken Pis statue – a small but iconic figure that represents the city's playful spirit. Next, enjoy a photo stop at the Atomium, an architectural marvel and one of the most recognisable landmarks in Belgium. Originally constructed for the 1958 World Expo, the Atomium’s futuristic spheres make for a memorable backdrop. We then continue our journey toward Amsterdam, crossing scenic countryside and arriving in the Netherlands by evening. Upon arrival, check in to your hotel located near Schiphol Airport. The evening is free for you to explore Amsterdam at your own pace. Whether you choose to relax at the hotel or venture into the city to experience its vibrant nightlife, today offers the perfect mix of sightseeing and leisure. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 8,
        title:
          "Explore Amsterdam With Canal Cruise – Visit Keukenhof Gardens (Until 12th May) Or The Zaanse Schans (From 13th May) - Visit Cologne Cathedral",
        detail:
          "After a delicious breakfast and hotel check-out, get ready to experience the charm of the Netherlands. Depending on your travel date, today’s highlight will be either the iconic Keukenhof Gardens or the traditional village of Zaanse Schans. Until 12 May: Enjoy a visit to the vibrant Keukenhof Gardens, a floral paradise showcasing millions of tulips, daffodils, and hyacinths in full bloom—perfect for photos and a joyful springtime stroll. From 13 May: Explore the charming village of Zaanse Schans, famous for its wooden houses, working windmills, and artisan workshops. Watch a live clog-making demo, visit a traditional cheese farm, and get a glimpse of authentic Dutch life. Next, discover Amsterdam from a unique angle aboard a glass-topped canal cruise. Sail through the historic canals lined with picturesque buildings, arched bridges, and heritage-rich quarters that define the city’s charm. After lunch, begin your journey toward Germany. Your next stop is the stunning city of Cologne, where you'll enjoy an outside view of the magnificent Cologne Cathedral – a UNESCO World Heritage Site and one of the most impressive Gothic structures in Europe. With its twin 515-foot spires, the cathedral is a masterpiece of medieval architecture and an iconic symbol of the city. We then continue onward to Frankfurt. As today involves a long yet scenic drive, a packed dinner will be provided for your convenience. Upon arrival, check in to your hotel and unwind after a day full of cross-border discoveries. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 9,
        title:
          "Travel To The Heart Of The Black Forest And Visit Switzerland’s Largest Waterfall - The Rhine Falls",
        detail:
          "After enjoying a hearty breakfast, we check out and begin our scenic journey toward the Black Forest region of Germany, famed for its dense woodlands, charming villages, and timeless folklore. As we drive through winding forest roads surrounded by towering pines and firs, you’ll feel as if you’ve stepped into the pages of a fairy tale. En route, we visit a local cuckoo clock workshop, where you can witness skilled craftsmen creating intricate timepieces using traditional techniques passed down through generations. This is also the perfect place to pick up an authentic Black Forest souvenir. Relax with a warm beverage and soak in the serene beauty of this picturesque region, known for its tranquil atmosphere and postcard-perfect settings. From here, we continue our journey across the border into Switzerland, with a spectacular stop at Schaffhausen, home to one of Europe’s greatest natural wonders — the Rhine Falls. Cascading with immense force, the Rhine Falls is Switzerland’s largest and most powerful waterfall. Witness the thunderous roar and misty spray as water plunges over 150 metres in width — a moment you’ll want to capture with your camera and in your memory forever. After this refreshing encounter with nature, we drive to Zurich for check-in at your hotel. Enjoy the evening at leisure and prepare for more Swiss adventures ahead. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 10,
        title:
          "World’s First Rotating Cable Car Rotair Up Mt. Titlis Peak At 3,020m - Orientation Tour of Lucerne",
        detail:
          "After breakfast, get ready for a thrilling alpine experience as we head to the mountain village of Engelberg. From here, enjoy a series of cable car rides leading up to the spectacular Mt. Titlis, culminating in the breathtaking Rotair, the world’s first revolving cable car. At 3,020 meters above sea level, soak in stunning 360-degree views of snow-covered peaks, deep crevasses, and glistening glaciers. Test your nerves with a walk on the Cliff Walk, Europe’s highest suspension bridge, perched along the edge of Mt. Titlis — an unforgettable experience! Later, we descend and travel to the beautiful city of Lucerne. Enjoy an orientation tour of its highlights, including the Chapel Bridge (Kapellbrücke) and the moving Lion Monument. Enjoy some free time to shop for Swiss souvenirs like watches, chocolates, and knives before heading back to Zurich. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 11,
        title:
          "Magical Alpine Excursion To The Top Of Europe – The Amazing Jungfraujoch And Scenic Interlaken",
        detail:
          "After breakfast, get ready for a truly magical Alpine experience. Today, you have the opportunity to join an unforgettable excursion to Jungfraujoch – The Top of Europe (available at an additional cost). We begin by heading to Grindelwald Terminal, where the state-of-the-art Eiger Express gondola swiftly takes you to Eigergletscher Station in just 15 minutes. From there, board the legendary cogwheel train that ascends to the highest railway station in Europe at 11,333 feet. At the summit, immerse yourself in a world of eternal snow and ice. Wander through the Ice Palace, where artists sculpt masterpieces in frozen form, and take in jaw-dropping views of the Aletsch Glacier from the panoramic Sphinx Observatory — a true high point of your European adventure. Those who prefer a more relaxed day can spend time in Interlaken, a scenic town nestled between two lakes and surrounded by the majestic Swiss Alps. Whether shopping for Swiss souvenirs or enjoying a lakeside walk, Interlaken offers a peaceful escape. Later in the day, regroup and return to Zurich for the night. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 12,
        title:
          "Train Ride At The Capital Of Liechtenstein, Vaduz, Visit Swarovski Crystal Museum And The Tyrolean Capital Of Austria, Innsbruck",
        detail:
          "This morning, after breakfast and check-out, we continue our European journey toward Austria with exciting stops along the way. First, we arrive at Vaduz, the charming capital of Liechtenstein. Hop aboard a scenic toy train ride, a delightful 30-minute journey that takes you past the key landmarks and scenic corners of this small yet fascinating country. Next, head to Wattens, Austria, for a visit to the world-famous Swarovski Crystal Worlds. Marvel at the dazzling art installations and crystalline exhibits that showcase Swarovski’s legacy of brilliance. The museum and shop are a must-see for design lovers and shoppers alike. We then drive to Innsbruck, the capital of the Tyrol region, nestled in the Alps. On arrival, enjoy an orientation tour starting with the city’s most iconic symbol — the Golden Roof (Goldenes Dachl), built in the 1500s for Emperor Maximilian I. Stroll through Maria Theresien Strasse, lined with charming cafés, elegant boutiques, and striking Baroque architecture. After the tour, check in to your hotel in Innsbruck and relax after a culturally rich day. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 13,
        title:
          "Transfer To Venice – The Floating City Of Italy With Gondola Ride",
        detail:
          "After breakfast, check out and begin your journey to the romantic city of Venice — the floating jewel of Italy, built entirely on water and admired for centuries for its timeless beauty and charm. Arrive at the Venice pier, where a private boat will take you across the shimmering Giudecca Canal to St. Mark’s Square, the heart of the city. Admire the magnificent St. Mark’s Basilica, a masterpiece of Byzantine architecture, and gaze at the towering Bell Tower and Clock Tower, decorated with zodiac signs and a moon phase display. Next, see the historic Bridge of Sighs, built in white limestone, arching over the Rio di Palazzo and connecting the Doge’s Palace to the old prison cells — a place filled with history and legend. Later, treasure a romantic gondola ride through the charming canals of Venice. Glide past elegant bridges and baroque façades in a classic flat-bottomed Venetian boat, a truly magical way to experience this iconic city. After this memorable experience, return to the pier and continue to Padova, where you’ll check in for an overnight stay. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 14,
        title:
          "Pisa’s Leaning Wonder & Florence – The Cradle of Renaissance",
        detail:
          "Enjoy breakfast and check out as we head to the world-famous town of Pisa. Explore the Piazza dei Miracoli (Square of Miracles) and see the iconic Leaning Tower of Pisa, a marvel that continues to defy gravity. Also within the square are stunning monuments such as the Cathedral of St. Mary of the Assumption, the Baptistery, the Monumental Cemetery, and the Sinopie Museum — a site steeped in medieval history and architectural brilliance. We then travel to Florence, the artistic capital of Tuscany and the birthplace of the Renaissance. On arrival, take a guided city tour that begins with the majestic Duomo (Cathedral of Santa Maria del Fiore) — a symbol of the city, along with its impressive Campanile (Bell Tower) and the Baptistery with its famous “Gates of Paradise”. Continue to Piazza della Signoria, a living open-air museum filled with magnificent Renaissance sculptures and flanked by the grand Palazzo Vecchio. Walk across the Ponte Vecchio, Florence’s historic bridge lined with artisan shops, offering scenic views of the River Arno. Later, drive up to Piazzale Michelangelo for a panoramic viewpoint that showcases Florence’s iconic skyline in all its glory — a perfect photo opportunity. Before we depart, enjoy free time for shopping, where you can pick up leather goods, handmade souvenirs, or local delicacies. We end the day with a scenic drive into the Tuscany region, arriving at your hotel for a relaxing overnight stay. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 15,
        title:
          "Visit Rome - The Eternal City With The World’s Smallest Country - Vatican & St. Peter’s Basilica",
        detail:
          "After a delicious breakfast, check out from your hotel as we journey to Rome, the magnificent capital of Italy, often referred to as The Eternal City for its centuries-old legacy and timeless charm. Accompanied by an English-speaking guide, today’s exploration begins with a visit to a sovereign state within Rome itself — Vatican City, the smallest country in the world, covering just around 100 acres. Here, step into the grand St. Peter’s Basilica, a sacred site and architectural masterpiece, featuring the works of legends like Michelangelo and Bernini. Don’t miss the breathtaking Pietà and the soaring dome that defines the skyline of Vatican City. Please note: visitors must be modestly dressed (no shorts or sleeveless tops) to enter religious sites. Next, return to central Rome and visit the mighty Colosseum from the outside — the iconic amphitheater that once hosted gladiator battles and continues to symbolize the grandeur of ancient Rome. As we stroll through the city's historic core, admire the Victor Emmanuel Monument at Piazza Venezia, dedicated to the first king of unified Italy. Our final sightseeing stop is at the enchanting Trevi Fountain, where you can toss a coin and make a wish — a tradition that promises your return to Rome. This stunning Baroque masterpiece is a true symbol of Roman romance and artistry. Later, enjoy a delicious dinner before heading to your hotel in Rome for check-in. After a day of rich cultural experiences and architectural marvels, relax and prepare for your journey home the following day. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 16,
        title:
          "Adieu Europe – A Grand Journey Concludes",
        detail:
          "After breakfast, it’s time to bid farewell to your unforgettable journey across Europe. Check out from the hotel and transfer to the airport for your flight back home. If your return flight is from Milan, please note the drive from Rome or Arezzo may take up to 6 hours, so early departures may be arranged accordingly. As you leave, take with you memories of iconic cities, incredible landscapes, cultural wonders, and the warmth of shared experiences — a journey you’ll cherish forever.."
      },
    ],

    overview: "Embark on an unforgettable 16-day European escape that blends royal heritage, romantic cities, alpine adventures, and timeless history. Begin with the grandeur and vibrant energy of London, soaking in its iconic skyline and immersive cultural experiences before crossing to the elegance of Paris, where panoramic tower views, scenic river cruises, and magical theme park moments create lasting memories. Drift along charming canals in Amsterdam, witness Gothic architectural marvels in Cologne, and feel the mist of the mighty Rhine Falls. Embrace the breathtaking beauty of the Swiss Alps with thrilling mountain experiences at Mount Titlis and optional high-altitude adventures at Jungfraujoch. Continue through storybook Austrian landscapes before gliding through the romantic canals of Venice, discovering Renaissance charm in Florence, and concluding amid the ancient wonders and spiritual grandeur of Rome and Vatican City. This thoughtfully curated journey offers a seamless blend of culture, adventure, elegance, and unforgettable European moments."
  },
  {
    id: "europe-010",
    slug: "wonders-of-europe-2026",
    destination: "Europe",
    title: "Wonders of Europe 2026",
    duration: "12 Nights 13 Days",
    route: "3N Paris | 1N Amsterdam | 1N Frankfurt | 3N Zurich | 1N Innsbruck | 1N Padova | 1N Arezzo | 1N Rome",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Nov 2026"],
    stars: 4,
    price: 318999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [paris,amsterdam,frankfurt,zurich,innsburck,padova,arezzo,rome],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Into Paris", to: "Out of Rome", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "Paris", nights: "3 Nights", type: "The Jangle Hotel - Paris - Charles de Gaulle - Airport - 4 Star Hotel" },
      { location: "Amsterdam", nights: "1 Nights", type: "NH Amsterdam Schiphol Airport - 4 Star Hotel" },
      { location: "Frankfurt", nights: "1 Nights", type: "Elaya hotel frankfurt oberursel - 4 Star Hotel" },
      { location: "Zurich", nights: "3 Nights", type: "Radisson Hotel & Suites Zurich - 4 Star Hotel" },
      { location: "Innsbruck", nights: "1 Nights", type: "Hotel Alpenkonig Tirol - 4 Star Hotel" },
      { location: "Padova", nights: "1 Nights", type: "Crowne Plaza Padova by IHG - 4 Star Hotel" },
      { location: "Arezzo", nights: "1 Nights", type: "Hotel Park - 4 Star Hotel" },
      { location: "Rome", nights: "1 Nights", type: "Hampton By Hilton Rome North Fiano Romano - 4 Star Hotel" },

    ],

    sightseeing: [
      { title: "Paris Sightseeing" },
      { title: "Amsterdam Sightseeing" },
      { title: "Frankfurt Sightseeing" },
      { title: "Zurich Sightseeing" },
      { title: "Innsbruck Sightseeing" },
      { title: "Padova Sightseeing" },
      { title: "Arezzo Sightseeing" },
      { title: "Rome Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Guided city tour of Paris covering iconic sights like Champs-Élysées, Arc de Triomphe, Place de la Concorde and more",
      "Eiffel Tower – 2nd Level Entry",
      "Scenic Seine River Cruise",
      "Enjoy a fun-filled day at Disneyland Paris",
      "Services of an experienced Hindi & English-speaking Tour Manager throughout the tour",
      "All Driver and Tour Manager Tips Included",
      "Daily Indian Lunch & Dinners",
      "Orientation Tour of Brussels",
      "Photo opportunity at the famous Atomium",
      "The magnificent Grand Place and Manneken Pis Statue",
      "Visit Keukenhof Gardens (till 12th May) or Zaanse Schans (after 13th May)",
      "Glass-roof Canal Cruise through historic Amsterdam",
      "Visit the Gothic-Masterpiece Cologne Cathedral",
      "Scenic drive through Germany’s Black Forest",
      "Watch a live Cuckoo Clock demo",
      "View the magnification Rhine Falls at Schaffhausen",
      "Witness breath-taking mountain peaks and glaciers at Mt. Titlis",
      "Ride in the world’s first revolving cable car",
      "Orientation tour of Interlaken, with an optional excursion to Jungfraujoch – Top of Europe (extra cost)",
      "Explore the charming lakeside town of Lucerne",
      "Experience the toy train ride at Vaduz",
      "See the Maria Theresien Strasse and the Golden Roof",
      "Visit the Swarovski Crystal Worlds – Museum & Shopping Experience",
      "Arrive at St. Mark’s by private boat",
      "Enjoy a classic Venetian gondola ride",
      "Free time in Venice Island",
      "Photo-stop at the Leaning Tower of Pisa",
      "Visit Square of Miracles",
      "Guided city tour Florence",
      "Guided city tour of Rome covering iconic sights like the Colosseum & Roman Forum",
      "Visit the magnificent St. Peter’s Basilica",
      "Photo stop at the Iconic Trevi Fountai",

    ],

    exclusions: [
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fare difference arising due to change in travel dates, sector, or airline",
      "Additional costs due to flight rescheduling, cancellation, or no-show",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently.",
      "Guests departing independently from Zurich must arrange or pay for their transfers separately.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
      "Any services not explicitly mentioned in the inclusions",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Paris – The City of Romance, Lights & Glamour",
        detail:
          "Bienvenue à Paris! Welcome to the city of timeless romance and enchanting lights. Upon arrival and completion of immigration formalities, our friendly tour guide will be waiting to greet you and escort you to your hotel. After check-in, the rest of the day is yours to relax and soak in the Parisian vibe at your own pace. Stroll through the charming streets, sip a coffee at a sidewalk café, or simply unwind at the hotel. (Dinner)"
      },
      {
        day: 2,
        title:
          "Paris City Tour – Eiffel Tower 2nd Level & Seine River Cruise",
        detail:
          "After a delightful breakfast, embark on a panoramic guided city tour of Paris, exploring its most iconic and glamorous sights. Drive past the elegant Place Vendôme, Opéra Garnier, Musée d’Orsay, Place de la Concorde, and the world-renowned Champs-Élysées. Marvel at architectural wonders like the Arc de Triomphe, Alexander Bridge, and Les Invalides, each telling a story of the city’s rich history and grandeur. Next, ascend to the 2nd level of the Eiffel Tower, where breathtaking views of Paris await — an unforgettable photo opportunity! Later, set off on a romantic Seine River Cruise, drifting gently past stunning landmarks like Notre-Dame, Louvre Museum, and charming riverside façades. The illuminated bridges and skyline offer a dreamy Parisian evening experience. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 3,
        title:
          "A Magical Day at Disneyland Paris",
        detail:
          "Get ready for a day packed with fun, fantasy, and unforgettable experiences at Disneyland Paris, one of Europe’s most popular theme parks. Today, you can choose to explore either the enchanting Disneyland Park, where five immersive lands bring classic Disney tales to life, or the Walt Disney Studios Park, where movie magic takes center stage with thrilling shows, behind-the-scenes secrets, and jaw-dropping stunts. Feel the magic as you stroll through Sleeping Beauty’s Castle, join Captain Jack Sparrow on a pirate adventure, or zoom through space with Buzz Lightyear. Don’t miss the colourful street parades and character meet-and-greets that add charm to every corner of the park. At the studios, be amazed by professional stunt performances, discover how animation is created, and explore real-life film sets. Whether you're a thrill-seeker, a Disney fan, or just looking for a memorable day out, Disneyland Paris offers something for everyone — from adrenaline-pumping roller coasters to calm, whimsical rides for kids. Relish a day full of joy and wonder with your loved ones. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 4,
        title:
          "Three Cities in a Day – Paris, Brussels & Amsterdam Adventure",
        detail:
          "After enjoying a hearty breakfast, check out from your Paris hotel as we begin our journey to the Netherlands. En route, we stop in Brussels, the charming capital of Belgium and the de facto headquarters of the European Union. This cosmopolitan city beautifully blends historic charm with modern elegance. Our first stop is the Grand Place, a UNESCO World Heritage Site and one of Europe’s most stunning squares. Surrounded by elegant guildhalls and the 15th-century Brussels Town Hall, it’s the perfect spot to soak in the grandeur of Belgian architecture. From there, we take a short walk to the beloved Manneken Pis statue – a small but iconic figure that represents the city's playful spirit. Next, enjoy a photo stop at the Atomium, an architectural marvel and one of the most recognisable landmarks in Belgium. Originally constructed for the 1958 World Expo, the Atomium’s futuristic spheres make for a memorable backdrop. We then continue our journey toward Amsterdam, crossing scenic countryside and arriving in the Netherlands by evening. Upon arrival, check in to your hotel located near Schiphol Airport. The evening is free for you to explore Amsterdam at your own pace. Whether you choose to relax at the hotel or venture into the city to experience its vibrant nightlife, today offers the perfect mix of sightseeing and leisure. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 5,
        title:
          "Explore Amsterdam With Canal Cruise – Visit Keukenhof Gardens (Until 12th May) Or The Zaanse Schans (From 13th May) - Visit Cologne Cathedral",
        detail:
          "After a delicious breakfast and hotel check-out, get ready to experience the charm of the Netherlands. Depending on your travel date, today’s highlight will be either the iconic Keukenhof Gardens or the traditional village of Zaanse Schans. Until 12 May: Enjoy a visit to the vibrant Keukenhof Gardens, a floral paradise showcasing millions of tulips, daffodils, and hyacinths in full bloom—perfect for photos and a joyful springtime stroll. From 13 May: Explore the charming village of Zaanse Schans, famous for its wooden houses, working windmills, and artisan workshops. Watch a live clog-making demo, visit a traditional cheese farm, and get a glimpse of authentic Dutch life. Next, discover Amsterdam from a unique angle aboard a glass-topped canal cruise. Sail through the historic canals lined with picturesque buildings, arched bridges, and heritage-rich quarters that define the city’s charm. After lunch, begin your journey toward Germany. Your next stop is the stunning city of Cologne, where you'll enjoy an outside view of the magnificent Cologne Cathedral – a UNESCO World Heritage Site and one of the most impressive Gothic structures in Europe. With its twin 515-foot spires, the cathedral is a masterpiece of medieval architecture and an iconic symbol of the city. We then continue onward to Frankfurt. As today involves a long yet scenic drive, a packed dinner will be provided for your convenience. Upon arrival, check in to your hotel and unwind after a day full of cross-border discoveries. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 6,
        title:
          "Travel To The Heart Of The Black Forest And Visit Switzerland’s Largest Waterfall - The Rhine Falls",
        detail:
          "After enjoying a hearty breakfast, we check out and begin our scenic journey toward the Black Forest region of Germany, famed for its dense woodlands, charming villages, and timeless folklore. As we drive through winding forest roads surrounded by towering pines and firs, you’ll feel as if you’ve stepped into the pages of a fairy tale. En route, we visit a local cuckoo clock workshop, where you can witness skilled craftsmen creating intricate timepieces using traditional techniques passed down through generations. This is also the perfect place to pick up an authentic Black Forest souvenir. Relax with a warm beverage and soak in the serene beauty of this picturesque region, known for its tranquil atmosphere and postcard-perfect settings. From here, we continue our journey across the border into Switzerland, with a spectacular stop at Schaffhausen, home to one of Europe’s greatest natural wonders — the Rhine Falls. Cascading with immense force, the Rhine Falls is Switzerland’s largest and most powerful waterfall. Witness the thunderous roar and misty spray as water plunges over 150 metres in width — a moment you’ll want to capture with your camera and in your memory forever. After this refreshing encounter with nature, we drive to Zurich for check-in at your hotel. Enjoy the evening at leisure and prepare for more Swiss adventures ahead. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 7,
        title:
          "World’s First Rotating Cable Car Rotair Up Mt. Titlis Peak At 3,020m - Orientation Tour of Lucerne",
        detail:
          "After breakfast, get ready for a thrilling alpine experience as we head to the mountain village of Engelberg. From here, enjoy a series of cable car rides leading up to the spectacular Mt. Titlis, culminating in the breathtaking Rotair, the world’s first revolving cable car. At 3,020 meters above sea level, soak in stunning 360-degree views of snow-covered peaks, deep crevasses, and glistening glaciers. Test your nerves with a walk on the Cliff Walk, Europe’s highest suspension bridge, perched along the edge of Mt. Titlis — an unforgettable experience! Later, we descend and travel to the beautiful city of Lucerne. Enjoy an orientation tour of its highlights, including the Chapel Bridge (Kapellbrücke) and the moving Lion Monument. Enjoy some free time to shop for Swiss souvenirs like watches, chocolates, and knives before heading back to Zurich. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 8,
        title:
          "Magical Alpine Excursion To The Top Of Europe – The Amazing Jungfraujoch And Scenic Interlaken (Extra Cost)",
        detail:
          "After breakfast, get ready for a truly magical Alpine experience. Today, you have the opportunity to join an unforgettable excursion to Jungfraujoch – The Top of Europe (available at an additional cost). We begin by heading to Grindelwald Terminal, where the state-of-the-art Eiger Express gondola swiftly takes you to Eigergletscher Station in just 15 minutes. From there, board the legendary cogwheel train that ascends to the highest railway station in Europe at 11,333 feet. At the summit, immerse yourself in a world of eternal snow and ice. Wander through the Ice Palace, where artists sculpt masterpieces in frozen form, and take in jaw-dropping views of the Aletsch Glacier from the panoramic Sphinx Observatory — a true high point of your European adventure. Those who prefer a more relaxed day can spend time in Interlaken, a scenic town nestled between two lakes and surrounded by the majestic Swiss Alps. Whether shopping for Swiss souvenirs or enjoying a lakeside walk, Interlaken offers a peaceful escape. Later in the day, regroup and return to Zurich for the night. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 9,
        title:
          "Train Ride At The Capital Of Liechtenstein, Vaduz, Visit Swarovski Crystal Museum And The Tyrolean Capital Of Austria, Innsbruck",
        detail:
          "This morning, after breakfast and check-out, we continue our European journey toward Austria with exciting stops along the way. First, we arrive at Vaduz, the charming capital of Liechtenstein. Hop aboard a scenic toy train ride, a delightful 30-minute journey that takes you past the key landmarks and scenic corners of this small yet fascinating country. Next, head to Wattens, Austria, for a visit to the world-famous Swarovski Crystal Worlds. Marvel at the dazzling art installations and crystalline exhibits that showcase Swarovski’s legacy of brilliance. The museum and shop are a must-see for design lovers and shoppers alike. We then drive to Innsbruck, the capital of the Tyrol region, nestled in the Alps. On arrival, enjoy an orientation tour starting with the city’s most iconic symbol — the Golden Roof (Goldenes Dachl), built in the 1500s for Emperor Maximilian I. Stroll through Maria Theresien Strasse, lined with charming cafés, elegant boutiques, and striking Baroque architecture. After the tour, check in to your hotel in Innsbruck and relax after a culturally rich day. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 10,
        title:
          "Transfer To Venice – The Floating City Of Italy With Gondola Ride",
        detail:
          "After breakfast, check out and begin your journey to the romantic city of Venice — the floating jewel of Italy, built entirely on water and admired for centuries for its timeless beauty and charm. Arrive at the Venice pier, where a private boat will take you across the shimmering Giudecca Canal to St. Mark’s Square, the heart of the city. Admire the magnificent St. Mark’s Basilica, a masterpiece of Byzantine architecture, and gaze at the towering Bell Tower and Clock Tower, decorated with zodiac signs and a moon phase display. Next, see the historic Bridge of Sighs, built in white limestone, arching over the Rio di Palazzo and connecting the Doge’s Palace to the old prison cells — a place filled with history and legend. Later, treasure a romantic gondola ride through the charming canals of Venice. Glide past elegant bridges and baroque façades in a classic flat-bottomed Venetian boat, a truly magical way to experience this iconic city. After this memorable experience, return to the pier and continue to Padova, where you’ll check in for an overnight stay. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 11,
        title:
          "Pisa’s Leaning Wonder & Florence – The Cradle of Renaissance",
        detail:
          "Enjoy breakfast and check out as we head to the world-famous town of Pisa. Explore the Piazza dei Miracoli (Square of Miracles) and see the iconic Leaning Tower of Pisa, a marvel that continues to defy gravity. Also within the square are stunning monuments such as the Cathedral of St. Mary of the Assumption, the Baptistery, the Monumental Cemetery, and the Sinopie Museum — a site steeped in medieval history and architectural brilliance. We then travel to Florence, the artistic capital of Tuscany and the birthplace of the Renaissance. On arrival, take a guided city tour that begins with the majestic Duomo (Cathedral of Santa Maria del Fiore) — a symbol of the city, along with its impressive Campanile (Bell Tower) and the Baptistery with its famous “Gates of Paradise”. Continue to Piazza della Signoria, a living open-air museum filled with magnificent Renaissance sculptures and flanked by the grand Palazzo Vecchio. Walk across the Ponte Vecchio, Florence’s historic bridge lined with artisan shops, offering scenic views of the River Arno. Later, drive up to Piazzale Michelangelo for a panoramic viewpoint that showcases Florence’s iconic skyline in all its glory — a perfect photo opportunity. Before we depart, enjoy free time for shopping, where you can pick up leather goods, handmade souvenirs, or local delicacies. We end the day with a scenic drive into the Tuscany region, arriving at your hotel for a relaxing overnight stay. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 12,
        title:
          "Visit Rome - The Eternal City With The World’s Smallest Country - Vatican & St. Peter’s Basilica",
        detail:
          "After a delicious breakfast, check out from your hotel as we journey to Rome, the magnificent capital of Italy, often referred to as The Eternal City for its centuries-old legacy and timeless charm. Accompanied by an English-speaking guide, today’s exploration begins with a visit to a sovereign state within Rome itself — Vatican City, the smallest country in the world, covering just around 100 acres. Here, step into the grand St. Peter’s Basilica, a sacred site and architectural masterpiece, featuring the works of legends like Michelangelo and Bernini. Don’t miss the breathtaking Pietà and the soaring dome that defines the skyline of Vatican City. Please note: visitors must be modestly dressed (no shorts or sleeveless tops) to enter religious sites. Next, return to central Rome and visit the mighty Colosseum from the outside — the iconic amphitheater that once hosted gladiator battles and continues to symbolize the grandeur of ancient Rome. As we stroll through the city's historic core, admire the Victor Emmanuel Monument at Piazza Venezia, dedicated to the first king of unified Italy. Our final sightseeing stop is at the enchanting Trevi Fountain, where you can toss a coin and make a wish — a tradition that promises your return to Rome. This stunning Baroque masterpiece is a true symbol of Roman romance and artistry. Later, enjoy a delicious dinner before heading to your hotel in Rome for check-in. After a day of rich cultural experiences and architectural marvels, relax and prepare for your journey home the following day. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 13,
        title:
          "Adieu Europe – A Grand Journey Concludes",
        detail:
          "After breakfast, it’s time to bid farewell to your unforgettable journey across Europe. Check out from the hotel and transfer to the airport for your flight back home. If your return flight is from Milan, please note the drive from Rome or Arezzo may take up to 6 hours, so early departures may be arranged accordingly. As you leave, take with you memories of iconic cities, incredible landscapes, cultural wonders, and the warmth of shared experiences — a journey you’ll cherish forever.."
      },

    ],

    overview: "Embark on a magical 13-day European escape filled with breathtaking landscapes, fairytale cities, and unforgettable moments. From romantic evenings and charming old towns to snow-capped Alpine adventures and scenic countryside drives, this journey blends culture, comfort, and pure excitement in perfect harmony. Feel the thrill of mountain peaks, the serenity of lakes and canals, the elegance of grand boulevards, and the joy of immersive local experiences—from gondola rides and scenic cruises to vibrant town squares and storybook settings. Designed for effortless travel with quality stays and thoughtfully curated inclusions, this tour offers a seamless mix of relaxation, discovery, and once-in-a-lifetime memories across the heart of Europe."
  },
  {
    id: "europe-011",
    slug: "glimpses-of-europe-2026",
    destination: "Europe",
    title: "Glimpses of Europe - 2026",
    duration: "8 Nights 9 Days",
    route: "3N Paris | 1N Amsterdam | 1N Frankfurt | 3N Zurich",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 246999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [paris,amsterdam,frankfurt,zurich],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Into Paris", to: "Out of Zurich", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "Paris", nights: "3 Nights", type: "The Jangle Hotel - Paris - Charles de Gaulle - Airport - 4 Star Hotel" },
      { location: "Amsterdam", nights: "1 Nights", type: "NH Amsterdam Schiphol Airport - 4 Star Hotel" },
      { location: "Frankfurt", nights: "1 Nights", type: "Elaya hotel frankfurt oberursel - 4 Star Hotel" },
      { location: "Zurich", nights: "3 Nights", type: "Radisson Hotel & Suites Zurich - 4 Star Hotel" },

    ],

    sightseeing: [
      { title: "Paris Sightseeing" },
      { title: "Amsterdam Sightseeing" },
      { title: "Frankfurt Sightseeing" },
      { title: "Zurich Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Guided city tour of Paris covering iconic sights like Champs-Élysées, Arc de Triomphe, Place de la Concorde and more",
      "Eiffel Tower – 2nd Level Entry",
      "Scenic Seine River Cruise",
      "Enjoy a fun-filled day at Disneyland Paris",
      "Services of an experienced Hindi & English-speaking Tour Manager throughout the tour",
      "All Driver and Tour Manager Tips Included",
      "Daily Indian Lunch & Dinners",
      "Orientation Tour of Brussels",
      "Photo opportunity at the famous Atomium",
      "The magnificent Grand Place and Manneken Pis Statue",
      "Visit Keukenhof Gardens (till 12th May) or Zaanse Schans (after 13th May)",
      "Glass-roof Canal Cruise through historic Amsterdam",
      "Visit the Gothic-Masterpiece Cologne Cathedral",
      "Scenic drive through Germany’s Black Forest",
      "Watch a live Cuckoo Clock demo",
      "View the magnification Rhine Falls at Schaffhausen",
      "Witness breath-taking mountain peaks and glaciers at Mt. Titlis",
      "Ride in the world’s first revolving cable car",
      "Orientation tour of Interlaken, with an optional excursion to Jungfraujoch – Top of Europe (extra cost)",
      "Explore the charming lakeside town of Lucerne",

    ],

    exclusions: [
      "Departure may be arranged via Milan or Zurich, depending on flight availability. For direct joiners, return departures should be from Zurich. In case of departure from Milan, flights should be scheduled after 7:00 PM. An additional transfer from Zurich to Milan (approximately 5–7 hours by road)) will be required, and the associated transfer cost will be applicable.",
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fare difference arising due to change in travel dates, sector, or airline",
      "Additional costs due to flight rescheduling, cancellation, or no-show",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently.",
      "Guests departing independently from Zurich must arrange or pay for their transfers separately.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
      "Any services not explicitly mentioned in the inclusions",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival in Paris – The City of Romance, Lights & Glamour",
        detail:
          "Bienvenue à Paris! Welcome to the city of timeless romance and enchanting lights. Upon arrival and completion of immigration formalities, our friendly tour guide will be waiting to greet you and escort you to your hotel. After check-in, the rest of the day is yours to relax and soak in the Parisian vibe at your own pace. Stroll through the charming streets, sip a coffee at a sidewalk café, or simply unwind at the hotel. (Dinner)"
      },
      {
        day: 2,
        title:
          "Paris City Tour – Eiffel Tower 2nd Level & Seine River Cruise",
        detail:
          "After a delightful breakfast, embark on a panoramic guided city tour of Paris, exploring its most iconic and glamorous sights. Drive past the elegant Place Vendôme, Opéra Garnier, Musée d’Orsay, Place de la Concorde, and the world-renowned Champs-Élysées. Marvel at architectural wonders like the Arc de Triomphe, Alexander Bridge, and Les Invalides, each telling a story of the city’s rich history and grandeur. Next, ascend to the 2nd level of the Eiffel Tower, where breathtaking views of Paris await — an unforgettable photo opportunity! Later, set off on a romantic Seine River Cruise, drifting gently past stunning landmarks like Notre-Dame, Louvre Museum, and charming riverside façades. The illuminated bridges and skyline offer a dreamy Parisian evening experience. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 3,
        title:
          "A Magical Day at Disneyland Paris",
        detail:
          "Get ready for a day packed with fun, fantasy, and unforgettable experiences at Disneyland Paris, one of Europe’s most popular theme parks. Today, you can choose to explore either the enchanting Disneyland Park, where five immersive lands bring classic Disney tales to life, or the Walt Disney Studios Park, where movie magic takes center stage with thrilling shows, behind-the-scenes secrets, and jaw-dropping stunts. Feel the magic as you stroll through Sleeping Beauty’s Castle, join Captain Jack Sparrow on a pirate adventure, or zoom through space with Buzz Lightyear. Don’t miss the colourful street parades and character meet-and-greets that add charm to every corner of the park. At the studios, be amazed by professional stunt performances, discover how animation is created, and explore real-life film sets. Whether you're a thrill-seeker, a Disney fan, or just looking for a memorable day out, Disneyland Paris offers something for everyone — from adrenaline-pumping roller coasters to calm, whimsical rides for kids. Relish a day full of joy and wonder with your loved ones. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 4,
        title:
          "Three Cities in a Day – Paris, Brussels & Amsterdam Adventure",
        detail:
          "After enjoying a hearty breakfast, check out from your Paris hotel as we begin our journey to the Netherlands. En route, we stop in Brussels, the charming capital of Belgium and the de facto headquarters of the European Union. This cosmopolitan city beautifully blends historic charm with modern elegance. Our first stop is the Grand Place, a UNESCO World Heritage Site and one of Europe’s most stunning squares. Surrounded by elegant guildhalls and the 15th-century Brussels Town Hall, it’s the perfect spot to soak in the grandeur of Belgian architecture. From there, we take a short walk to the beloved Manneken Pis statue – a small but iconic figure that represents the city's playful spirit. Next, enjoy a photo stop at the Atomium, an architectural marvel and one of the most recognisable landmarks in Belgium. Originally constructed for the 1958 World Expo, the Atomium’s futuristic spheres make for a memorable backdrop. We then continue our journey toward Amsterdam, crossing scenic countryside and arriving in the Netherlands by evening. Upon arrival, check in to your hotel located near Schiphol Airport. The evening is free for you to explore Amsterdam at your own pace. Whether you choose to relax at the hotel or venture into the city to experience its vibrant nightlife, today offers the perfect mix of sightseeing and leisure. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 5,
        title:
          "Explore Amsterdam With Canal Cruise – Visit Keukenhof Gardens (Until 12th May) Or The Zaanse Schans (From 13th May) - Visit Cologne Cathedral",
        detail:
          "After a delicious breakfast and hotel check-out, get ready to experience the charm of the Netherlands. Depending on your travel date, today’s highlight will be either the iconic Keukenhof Gardens or the traditional village of Zaanse Schans. Until 12 May: Enjoy a visit to the vibrant Keukenhof Gardens, a floral paradise showcasing millions of tulips, daffodils, and hyacinths in full bloom—perfect for photos and a joyful springtime stroll. From 13 May: Explore the charming village of Zaanse Schans, famous for its wooden houses, working windmills, and artisan workshops. Watch a live clog-making demo, visit a traditional cheese farm, and get a glimpse of authentic Dutch life. Next, discover Amsterdam from a unique angle aboard a glass-topped canal cruise. Sail through the historic canals lined with picturesque buildings, arched bridges, and heritage-rich quarters that define the city’s charm. After lunch, begin your journey toward Germany. Your next stop is the stunning city of Cologne, where you'll enjoy an outside view of the magnificent Cologne Cathedral – a UNESCO World Heritage Site and one of the most impressive Gothic structures in Europe. With its twin 515-foot spires, the cathedral is a masterpiece of medieval architecture and an iconic symbol of the city. We then continue onward to Frankfurt. As today involves a long yet scenic drive, a packed dinner will be provided for your convenience. Upon arrival, check in to your hotel and unwind after a day full of cross-border discoveries. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 6,
        title:
          "Travel To The Heart Of The Black Forest And Visit Switzerland’s Largest Waterfall - The Rhine Falls",
        detail:
          "After enjoying a hearty breakfast, we check out and begin our scenic journey toward the Black Forest region of Germany, famed for its dense woodlands, charming villages, and timeless folklore. As we drive through winding forest roads surrounded by towering pines and firs, you’ll feel as if you’ve stepped into the pages of a fairy tale. En route, we visit a local cuckoo clock workshop, where you can witness skilled craftsmen creating intricate timepieces using traditional techniques passed down through generations. This is also the perfect place to pick up an authentic Black Forest souvenir. Relax with a warm beverage and soak in the serene beauty of this picturesque region, known for its tranquil atmosphere and postcard-perfect settings. From here, we continue our journey across the border into Switzerland, with a spectacular stop at Schaffhausen, home to one of Europe’s greatest natural wonders — the Rhine Falls. Cascading with immense force, the Rhine Falls is Switzerland’s largest and most powerful waterfall. Witness the thunderous roar and misty spray as water plunges over 150 metres in width — a moment you’ll want to capture with your camera and in your memory forever. After this refreshing encounter with nature, we drive to Zurich for check-in at your hotel. Enjoy the evening at leisure and prepare for more Swiss adventures ahead. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 7,
        title:
          "World’s First Rotating Cable Car Rotair Up Mt. Titlis Peak At 3,020m - Orientation Tour of Lucerne",
        detail:
          "After breakfast, get ready for a thrilling alpine experience as we head to the mountain village of Engelberg. From here, enjoy a series of cable car rides leading up to the spectacular Mt. Titlis, culminating in the breathtaking Rotair, the world’s first revolving cable car. At 3,020 meters above sea level, soak in stunning 360-degree views of snow-covered peaks, deep crevasses, and glistening glaciers. Test your nerves with a walk on the Cliff Walk, Europe’s highest suspension bridge, perched along the edge of Mt. Titlis — an unforgettable experience! Later, we descend and travel to the beautiful city of Lucerne. Enjoy an orientation tour of its highlights, including the Chapel Bridge (Kapellbrücke) and the moving Lion Monument. Enjoy some free time to shop for Swiss souvenirs like watches, chocolates, and knives before heading back to Zurich. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 8,
        title:
          "Magical Alpine Excursion To The Top Of Europe – The Amazing Jungfraujoch And Scenic Interlaken (Extra Cost)",
        detail:
          "After breakfast, get ready for a truly magical Alpine experience. Today, you have the opportunity to join an unforgettable excursion to Jungfraujoch – The Top of Europe (available at an additional cost). We begin by heading to Grindelwald Terminal, where the state-of-the-art Eiger Express gondola swiftly takes you to Eigergletscher Station in just 15 minutes. From there, board the legendary cogwheel train that ascends to the highest railway station in Europe at 11,333 feet. At the summit, immerse yourself in a world of eternal snow and ice. Wander through the Ice Palace, where artists sculpt masterpieces in frozen form, and take in jaw-dropping views of the Aletsch Glacier from the panoramic Sphinx Observatory — a true high point of your European adventure. Those who prefer a more relaxed day can spend time in Interlaken, a scenic town nestled between two lakes and surrounded by the majestic Swiss Alps. Whether shopping for Swiss souvenirs or enjoying a lakeside walk, Interlaken offers a peaceful escape. Later in the day, regroup and return to Zurich for the night. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 9,
        title:
          "Adieu Europe – A Grand Journey Concludes",
        detail:
          "After breakfast, it’s time to bid farewell to your unforgettable journey across Europe. Check out from the hotel and transfer to the airport for your flight back home. If your return flight is from Milan, please note the drive from Rome or Arezzo may take up to 6 hours, so early departures may be arranged accordingly. As you leave, take with you memories of iconic cities, incredible landscapes, cultural wonders, and the warmth of shared experiences — a journey you’ll cherish forever.."
      },

    ],

    overview: "Embark on an unforgettable 9-day journey through the heart of Europe, where romance, culture, and breathtaking landscapes come together in one seamless experience. From the timeless elegance and magical energy of Paris to the refined charm of Brussels and the storybook ambiance of Amsterdam, each city offers its own distinct rhythm and personality. As the journey unfolds, dramatic cathedral skylines, lush forests, cascading waterfalls, and pristine Alpine peaks create moments of awe and wonder. Snow-covered mountains, scenic panoramas, and charming European towns provide the perfect balance between vibrant city life and serene natural beauty. With thoughtfully planned travel, comforting Indian meals, and expert guidance throughout, this experience allows you to relax and truly immerse yourself. By the end of the journey, you return home not just with photographs but with a collection of emotions — joy, inspiration, connection, and the unforgettable magic of Europe."
  },
  // ================= France | Monaco | Italy | Switzerland =================
  {
    id: "franceswitzerlandparis-001",
    slug: "italy-swiss-paris-2026",
    destination: "Italy",
    title: "Italy Swiss Paris - 2026",
    duration: "10 Nights 11 Days",
    route: "2N Rome | 1N Ferrara | 1N Milan | 3N Zurich | 3N Paris ",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 268999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [rome,ferrara,zurich,paris],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Into Rome", to: "Out of Paris", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "Rome", nights: "2 Nights", type: "Hampton By Hilton Rome North Fiano Romano - 4 Star Hotel" },
      { location: "Ferrara", nights: "1 Nights", type: "Radisson Hotel Ferrara - 4 Star Hotel" },
      { location: "Milan", nights: "1 Nights", type: "Zeus Essence Dolce by Wyndham Milan Malpensa - 4 Star Hotel" },
      { location: "Zurich", nights: "3 Nights", type: "Radisson Hotel & Suites Zurich - 4 Star Hotel" },
      { location: "Paris", nights: "3 Nights", type: "The Jangle Hotel - Paris - Charles de Gaulle - Airport - 4 Star Hotel" },

    ],

    sightseeing: [
      { title: "Rome Sightseeing" },
      { title: "Ferrara Sightseeing" },
      { title: "Milan Sightseeing" },
      { title: "Zurich Sightseeing" },
      { title: "Paris Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Stay in good 4-star hotels in Europe",
      "Explore ancient Rome and the Vatican City with a guided tour of St. Peter’s Basilica.",
      "Capture the perfect photo at the iconic Leaning Tower of Pisa and admire Florence from Piazzale Michelangelo.",
      "Glide through Venice’s canals with a classic gondola ride and visit the majestic St. Mark’s Square.",
      "Ascend Mt. Titlis in the world’s first rotating cable car and walk the thrilling Cliff Walk.",
      "Marvel at the Rhine Falls and experience an optional excursion to Jungfraujoch – the Top of Europe.",
      "Relive childhood dreams at Disneyland Paris and admire the city from the Eiffel Tower’s 2nd level.",
      "3 Indian Jain/Vegetarian/Non-Vegetarian Dinners.",
      "10 Indian Jain/Vegetarian/Non-Vegetarian Dinners.",
      "Services of an English/Hindi Experienced Tour Manager",
      "All Driver and Tour Manager Tips Included",

    ],

    exclusions: [
      "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
      "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
      "Fare difference arising due to change in travel dates, sector, or airline",
      "Additional costs due to flight rescheduling, cancellation, or no-show",
      "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
      "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
      "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
      "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
      "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
      "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently.",
      "Guests departing independently from Zurich must arrange or pay for their transfers separately.",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
      "Any services not explicitly mentioned in the inclusions",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Rome Awaits – A Grand Beginning to Your European Journey",
        detail:
          "Welcome to Rome, a city where ancient history, timeless architecture, and vibrant culture come together. Upon your arrival at the airport, our friendly representative will greet you at the arrival hall and assist you with your transfer to the hotel. After check-in, take some time to relax and settle in. The rest of the day is at leisure for you to unwind or explore the surroundings at your own pace. Breathe in the Roman air, admire the classic streets, or simply prepare for the exciting journey that lies ahead. In the evening, join your fellow travelers for a delicious Indian dinner, setting the perfect tone for your European adventure. Get ready to explore historic wonders, cultural icons, and scenic beauty in the days to come. (Dinner)"
      },
      {
        day: 2,
        title:
          "Rome Guided City Tour with Vatican City and St. Peter’s Basilica",
        detail:
          "After a hearty breakfast at the hotel, the day begins with an immersive exploration of one of the world’s most iconic capitals—Rome, steeped in history, art, and imperial grandeur. Accompanied by a professional English-speaking guide, the first stop is Vatican City, the smallest independent state in the world. Here, you'll visit the majestic St. Peter’s Basilica, a masterpiece of Renaissance architecture adorned with incredible works by Michelangelo and Bernini. Marvel at the grandeur of its dome, sculptures, and the awe-inspiring Pietà, as your guide reveals the stories and significance behind each element. Next, return to the heart of Rome for a panoramic city tour. Capture postcard-perfect photos at the Colosseum (exterior), once a grand arena of gladiatorial combat. The drive continues past historical landmarks like Piazza Venezia, home to the grand Victor Emmanuel II Monument, and the legendary Trevi Fountain, where tossing a coin is said to ensure your return to Rome. Your guide will bring history to life, sharing tales of ancient emperors, Renaissance masters, and modern-day marvels. After soaking in the essence of Rome, regroup for a delicious Indian lunch. The rest of the afternoon allows time to explore or relax before returning to the hotel. In the evening, enjoy a traditional Indian dinner with your fellow travelers, recounting the highlights of your Roman adventure. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 3,
        title:
          "Visit Leaning Tower of Pisa – Florence City Tour & Piazzale Michelangelo",
        detail:
          "Start your day with a scenic drive through the Tuscan countryside as you journey from Rome toward the iconic city of Pisa. Upon arrival, you’ll visit the stunning Piazza dei Miracoli, or Square of Miracles—a UNESCO World Heritage Site. Here, marvel at the world-famous Leaning Tower of Pisa, a symbol of architectural wonder and human error turned tourist magnet. Surrounding this area are equally impressive sights like the Baptistery, Monumental Cemetery, and Cathedral of St. Mary of the Assumption, showcasing the Romanesque elegance of medieval Italy. After photo opportunities and time to appreciate Pisa's historical treasures, continue toward Florence, the cradle of the Renaissance. As you approach the city, your first stop is the famous Piazzale Michelangelo, offering a panoramic view over Florence’s red-tiled rooftops, bridges, and monuments—a breathtaking sight perfect for photos. During the orientation tour of Florence, stroll past the city’s key landmarks: the Florence Duomo, crowned by Brunelleschi’s massive dome, the Baptistery with its golden “Gates of Paradise”, Giotto’s Campanile, and the lively Piazza della Signoria, surrounded by Renaissance sculptures and the imposing Palazzo Vecchio. You’ll also see the charming Ponte Vecchio, a medieval stone bridge lined with artisan shops. The tour balances history with leisure, giving you a taste of Florence’s rich cultural heritage and its relaxed Tuscan charm. As the sun sets, proceed to your hotel in Bologna, where a hot Indian dinner awaits—perfect after a day immersed in art, architecture, and Italian legacy. (Breakfast and Dinner)"
      },
      {
        day: 4,
        title:
          "Transfer To Venice – The Floating City Of Italy With Gondola Ride",
        detail:
          "Today’s journey transports you to the magical world of Venice, a city built entirely on water, rich with romantic charm, artistic heritage, and timeless architecture. After breakfast, check out and drive to the Venetian pier, where a private boat awaits to take you across the shimmering waters of the Giudecca Canal. Feel the charm unfold as you arrive at the vibrant St. Mark’s Square, the heart of Venice. Here, admire the magnificent St. Mark’s Basilica, a masterpiece of Byzantine architecture adorned with intricate mosaics and golden domes. Nearby, witness the Clock Tower, the Bell Tower, and the famous Bridge of Sighs, connecting the Doge’s Palace to the historical prison complex. The view, the stories, and the atmosphere transport you to a different era. No trip to Venice is complete without a romantic Gondola ride. Glide through the city's narrow canals, flanked by grand palazzos and picturesque bridges. The peaceful sway of the boat and the reflections of centuries-old buildings in the water create a dreamlike experience unique to Venice. After this unforgettable experience, enjoy a delectable Indian lunch before continuing the journey towards Milan. Upon arrival, you’ll check into your hotel and unwind after a magical day. Venice’s elegance, serenity, and cinematic beauty are sure to remain one of the most cherished highlights of your European journey. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 5,
        title:
          "Discover Milan’s Elegance & Experience the Serenity of Lake Como – Drive to Zurich",
        detail:
          "Begin your morning with a delicious breakfast before checking out from your hotel in Milan. Your first experience today is a brief yet enriching orientation tour of Milan, Italy’s fashion and design capital. Visit the majestic Milan Cathedral (Duomo di Milano) from outside, one of the largest and most intricate Gothic cathedrals in the world. Just a few steps away is the historic Galleria Vittorio Emanuele II, a stunning 19th-century shopping arcade with beautiful glass domes, mosaics, and high-end boutiques. This elegant space is also a hotspot for enjoying Italian coffee and capturing some stunning photographs. After exploring Milan, you’ll travel north to the breathtakingly scenic region of Lake Como, a favorite getaway for celebrities and romantics alike. Nestled against the Alpine foothills, this lake is famed for its dramatic landscape, sparkling waters, and elegant lakeside villas. Visit the charming village of Bellagio (subject to road/weather conditions), often referred to as the “Pearl of Lake Como.” Here, you can stroll through narrow cobbled streets, admire pastel-colored buildings, and soak in views of the serene lakefront. Following this picturesque escape, continue your journey across the Swiss border into Zurich, Switzerland’s largest city. Relax in your comfortable coach and enjoy the changing landscapes as the terrain shifts from Italian elegance to Swiss precision and alpine charm. Upon arrival in Zurich by evening, settle into your hotel and enjoy a hearty Indian dinner. Today beautifully blends urban style, natural beauty, and cross-border adventure—offering a taste of Italy’s vibrant cities and the tranquil elegance of Switzerland’s countryside. (Breakfast and Dinner)"
      },
      {
        day: 6,
        title:
          "World’s First Rotating Cable Car Rotair Up Mt. Titlis Peak At 3,020m - Orientation Tour of Lucerne",
        detail:
          "After breakfast, get ready for a thrilling alpine experience as we head to the mountain village of Engelberg. From here, enjoy a series of cable car rides leading up to the spectacular Mt. Titlis, culminating in the breathtaking Rotair, the world’s first revolving cable car. At 3,020 meters above sea level, soak in stunning 360-degree views of snow-covered peaks, deep crevasses, and glistening glaciers. Test your nerves with a walk on the Cliff Walk, Europe’s highest suspension bridge, perched along the edge of Mt. Titlis — an unforgettable experience! Later, we descend and travel to the beautiful city of Lucerne. Enjoy an orientation tour of its highlights, including the Chapel Bridge (Kapellbrücke) and the moving Lion Monument. Enjoy some free time to shop for Swiss souvenirs like watches, chocolates, and knives before heading back to Zurich. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 7,
        title:
          "Magical Alpine Excursion To The Top Of Europe – The Amazing Jungfraujoch And Scenic Interlaken (Extra Cost)",
        detail:
          "After breakfast, get ready for a truly magical Alpine experience. Today, you have the opportunity to join an unforgettable excursion to Jungfraujoch – The Top of Europe (available at an additional cost). We begin by heading to Grindelwald Terminal, where the state-of-the-art Eiger Express gondola swiftly takes you to Eigergletscher Station in just 15 minutes. From there, board the legendary cogwheel train that ascends to the highest railway station in Europe at 11,333 feet. At the summit, immerse yourself in a world of eternal snow and ice. Wander through the Ice Palace, where artists sculpt masterpieces in frozen form, and take in jaw-dropping views of the Aletsch Glacier from the panoramic Sphinx Observatory — a true high point of your European adventure. Those who prefer a more relaxed day can spend time in Interlaken, a scenic town nestled between two lakes and surrounded by the majestic Swiss Alps. Whether shopping for Swiss souvenirs or enjoying a lakeside walk, Interlaken offers a peaceful escape. Later in the day, regroup and return to Zurich for the night. (Breakfast and Dinner)"
      },
      {
        day: 8,
        title:
          "From the Roar of Rhine Falls to the Romance of Paris",
        detail:
          "After breakfast, check out and begin your day with a stop at one of Switzerland’s most captivating natural wonders – the Rhine Falls in Schaffhausen. As Europe’s largest waterfall, the Rhine Falls offers a mesmerizing sight as water thunders down a 150-meter-wide drop. Take in panoramic views from the observation decks, capturing unforgettable moments against a backdrop of mist and power. It’s the perfect way to bid farewell to Switzerland’s natural beauty. From here, relax in the comfort of your luxury coach as you journey across the Swiss-French border toward Paris, the world-renowned City of Lights. The long but scenic drive offers changing vistas – from serene Alpine valleys to charming French countryside – providing a smooth transition from nature’s raw grandeur to urban elegance. Upon arrival in Paris by early evening, complete the hotel check-in and take some time to relax. The evening is yours to explore at leisure—stroll around the vicinity or simply unwind after a scenic travel day. For those interested in an enchanting Parisian night, optional experiences like the Moulin Rouge Cabaret or Paris by Night tour can be arranged (at extra cost). Later, enjoy a comforting Indian dinner with the group, discussing the journey so far and looking ahead to Paris’ iconic attractions awaiting you in the coming days—Eiffel Tower, Seine Cruise, and Disneyland adventures. (Breakfast and Dinner)"
      },
      {
        day: 9,
        title:
          "Paris City Tour – Eiffel Tower 2nd Level & Seine River Cruise",
        detail:
          "After a delightful breakfast, embark on a panoramic guided city tour of Paris, exploring its most iconic and glamorous sights. Drive past the elegant Place Vendôme, Opéra Garnier, Musée d’Orsay, Place de la Concorde, and the world-renowned Champs-Élysées. Marvel at architectural wonders like the Arc de Triomphe, Alexander Bridge, and Les Invalides, each telling a story of the city’s rich history and grandeur. Next, ascend to the 2nd level of the Eiffel Tower, where breathtaking views of Paris await — an unforgettable photo opportunity! Later, set off on a romantic Seine River Cruise, drifting gently past stunning landmarks like Notre-Dame, Louvre Museum, and charming riverside façades. The illuminated bridges and skyline offer a dreamy Parisian evening experience. (Breakfast and Dinner)"
      },
      {
        day: 10,
        title:
          "A Magical Day at Disneyland Paris",
        detail:
          "Get ready for a day packed with fun, fantasy, and unforgettable experiences at Disneyland Paris, one of Europe’s most popular theme parks. Today, you can choose to explore either the enchanting Disneyland Park, where five immersive lands bring classic Disney tales to life, or the Walt Disney Studios Park, where movie magic takes center stage with thrilling shows, behind-the-scenes secrets, and jaw-dropping stunts. Feel the magic as you stroll through Sleeping Beauty’s Castle, join Captain Jack Sparrow on a pirate adventure, or zoom through space with Buzz Lightyear. Don’t miss the colourful street parades and character meet-and-greets that add charm to every corner of the park. At the studios, be amazed by professional stunt performances, discover how animation is created, and explore real-life film sets. Whether you're a thrill-seeker, a Disney fan, or just looking for a memorable day out, Disneyland Paris offers something for everyone — from adrenaline-pumping roller coasters to calm, whimsical rides for kids. Relish a day full of joy and wonder with your loved ones. (Breakfast and Dinner)"
      },
      {
        day: 11,
        title:
          "From Paris with Memories – Fly Back Home",
        detail:
          "After a magical journey across Europe, today marks the end of your unforgettable adventure. Begin your morning with a relaxed breakfast at the hotel, reflecting on the incredible memories you've made—from riding a gondola in Venice and standing beneath the Eiffel Tower, to admiring snow-covered Swiss peaks and strolling through Renaissance Florence. It’s time to bid farewell to Paris, the City of Lights, with its timeless charm and captivating elegance. Our team will assist with your group transfer to the airport as you prepare to fly back home. Ensure your bags are packed and passports ready as you leave with a heart full of memories, cherished moments, and new friendships. Though your holiday ends today, the stories and experiences will remain with you forever. We thank you for traveling with us and look forward to welcoming you again on another exciting journey through the wonders of the world."
      },

    ],

    overview: "Embark on an unforgettable 11-day journey through Italy, Switzerland, and France, where every moment is designed to be felt, not just seen. Begin in Rome, soaking in the timeless atmosphere and effortless elegance of Italy before experiencing the artistic soul of Florence, the romantic charm of Venice, and the stylish vibrance of Milan, all connected by scenic drives and beautiful landscapes. As you enter Switzerland, breathe in the crisp alpine air, unwind amid snow-capped peaks and serene lakes, and embrace the peaceful rhythm of charming mountain towns. The journey concludes in Paris, where refined sophistication, glowing evenings, and café culture create the perfect romantic finale. With comfortable stays, Indian meals, smooth coach travel, and expert guidance throughout, this curated holiday lets you relax deeply, travel comfortably, and return home with cherished European memories."
  },
  // ================= Chaar Dham Yatra =================
  {
    id: "chardham-001",
    slug: "do-dham-yatra",
    destination: "Chardham",
    title: "Do Dham Yatra",
    duration: "3 Nights 4 Days",
    route: "1N Dehradun | 1N Phata | 1N Badrinath",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026"],
    stars: 3,
    price: 175999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [dehradun,kedarnath,badrinath],

    includes: ["helicopter", "hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Paris", to: "Out of Zurich", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Dehradun", nights: "1 Nights", type: "Lemon Tree Hotel, Dehradun or similar - 3 Star Hotel" },
      { location: "Phata", nights: "1 Nights", type: "Namah boutique resort or similar - 3 Star Hotel" },
      { location: "Badrinath", nights: "1 Nights", type: "Hotel Lord Palace or similar - 3 Star Hotel" },

    ],

    sightseeing: [
      { title: "Dehradun Sightseeing" },
      { title: "Phata Sightseeing" },
      { title: "Badrinath Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Comfortable stays in well-appointed hotels with scenic Himalayan surroundings",
      "Enjoy wholesome meals throughout the journey, including daily breakfast, lunch, and dinner as per the itinerary.",
      "Seamless travel with helicopter transfers between Do Dham destinations, along with comfortable ground transfers and assistance at every step.",
      "Visit the sacred shrines of Kedarnath and Badrinath with well-planned schedules for a spiritually fulfilling experience",
      "Hassle-free Kedarnath darshan via shuttle helicopter, ensuring comfort and ease",
      "Explore Mana Village, the “Last Village of India,” along with its mythological and cultural landmarks",
      "Dedicated ground support, welcome briefing, and seamless coordination throughout the yatra",

    ],

    // exclusions: [
    //   "Departure may be arranged via Milan or Zurich, depending on flight availability. For direct joiners, return departures should be from Zurich. In case of departure from Milan, flights should be scheduled after 7:00 PM. An additional transfer from Zurich to Milan (approximately 5–7 hours by road)) will be required, and the associated transfer cost will be applicable.",
    //   "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
    //   "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
    //   "Fare difference arising due to change in travel dates, sector, or airline",
    //   "Additional costs due to flight rescheduling, cancellation, or no-show",
    //   "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
    //   "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
    //   "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
    //   "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
    //   "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
    //   "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
    //   "For direct joiners, airport transfers are not included and must be arranged independently.",
    //   "Guests departing independently from Zurich must arrange or pay for their transfers separately.",
    //   "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    //   "Any services not explicitly mentioned in the inclusions",
    // ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrive in Dehradun",
        detail:
          "Upon arrival in Dehradun, our driver will greet you at the airport or railway station and transfer you to your hotel. In the evening, our representative will meet you for a welcome briefing, sharing complete details about the Do Dham Yatra and the journey ahead, along with conducting a body weight check for all passengers as per helicopter travel requirements. As a gesture of warm hospitality, each guest will receive a complimentary duffle bag, thoughtfully designed for the Do Dham Yatra, serving as both a token of appreciation and a practical travel companion. (Dinner)"
      },
      {
        day: 2,
        title:
          "Transfer from Dehradun to Kedarnath / Phata (by Helicopter) – Visit Kedarnath Temple via Shuttle Helicopter Service",
        detail:
          "After breakfast, guests will check out from the hotel and be transferred to Sahastradhara Helipad in Dehradun. From there, you will board a helicopter for a 30-minute flight to Phata/Guptkashi Helipad en route to Kedarnath. Upon arrival, our representative will escort you to your hotel for check-in. After some time to relax and freshen up, you will proceed for Kedarnath Temple darshan via a shuttle helicopter service. From the helipad, the temple is located approximately 500 meters away and can be comfortably reached on foot within 15–20 minutes. The shuttle service operates on pre-assigned time slots issued by UCADA (Uttarakhand Civil Aviation Development Authority), ensuring a smooth and well-organized pilgrimage. After darshan, you will return by shuttle helicopter to Phata/Guptkashi Helipad and proceed to your hotel, where you can enjoy your meal while admiring the stunning Himalayan views. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 3,
        title:
          "Transfer from Kedarnath / Phata to Badrinath (by Helicopter) – Visit Badrinath Temple",
        detail:
          "After breakfast, guests will complete check-out and proceed with a transfer to Guptkashi/Phata Helipad for their onward journey. From Guptkashi/Phata, you will board a helicopter for a 30-minute flight to Badrinath Helipad. Upon arrival, our representative will assist you with a smooth transfer to your hotel for check-in. After some time to relax and freshen up, you will proceed to Mana Village, known as the “Last Village of India” near the Indo-China border. Explore its iconic sites including Bheem Pul, a natural rock bridge steeped in mythology, the origin of the sacred Saraswati River, and the ancient caves of Ganesh Gufa and Vyas Gufa, associated with epic legends. After the sightseeing, return to the hotel to enjoy your lunch, followed by some leisure time to unwind. Later, you will proceed for Badrinath Temple darshan by cab. The temple is located approximately 1–1.5 km away, with a short drive of around 7–10 minutes, followed by a brief walk of 200–300 meters from the drop-off point to reach the entrance. After completing the darshan, you will return to the hotel for rest. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 4,
        title:
          "Departure from Dehradun",
        detail:
          "After breakfast, guests will complete check-out and proceed with a transfer to Badrinath Helipad for their onward journey. In the early morning, you will attend the Special Abhishek Puja at Badrinath Temple (at your own cost), beginning at 4:30 AM and lasting approximately two hours. This sacred ritual offers devotees a rare opportunity to sit inside the temple and witness the Shringar of the deity from close proximity. After breakfast, you will board the helicopter for your return journey to Dehradun. Upon arrival, our team will assist you with a smooth transfer to the airport or railway station for your onward travel. With this, your Do Dham Helicopter Yatra concludes, leaving you with divine blessings and cherished spiritual memories to treasure for a lifetime. (Breakfast)"
      },

    ],

    overview: "Experience a spiritually enriching journey to Kedarnath and Badrinath with seamless helicopter transfers and breathtaking Himalayan views. Experience smooth darshan at Kedarnath and explore the spiritual charm of Badrinath along with Mana Village’s mythological sites. Witness the sacred early morning Abhishek Puja for a truly soulful connection. Blending comfort, devotion, and scenic beauty, this pilgrimage offers a peaceful and memorable spiritual escape."
  },
  {
    id: "chardham-002",
    slug: "char-dham-yatra",
    destination: "Chardham",
    title: "Char Dham Yatra",
    duration: "5 Nights 6 Days",
    route: "1N Dehradun | 1N Yamunotri | 1N Gangotri | 1N Phata | 1N Badrinath ",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026", "Jun 2026"],
    stars: 4,
    price: 252999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [dehradun,yamunotri,gangotri,kedarnath,badrinath],

    includes: ["helicopter", "hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Paris", to: "Out of Zurich", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Dehradun", nights: "1 Nights", type: "Hyatt Centric Rajpur Road Dehradun or similar - 3 Star Hotel" },
      { location: "Yamunotri", nights: "1 Nights", type: "La Arkja Stay or similar - 3 Star Hotel" },
      { location: "Gangotri", nights: "1 Nights", type: "Namami Hotel or similar - 3 Star Hotel" },
      { location: "Phata", nights: "1 Nights", type: "The Turiya Heli Resort or similar - 3 Star Hotel" },
      { location: "Badrinath", nights: "1 Nights", type: "Hotel Lord Palace or similar - 3 Star Hotel" },

    ],

    sightseeing: [
      { title: "Dehradun Sightseeing" },
      { title: "Yamunotri Sightseeing" },
      { title: "Gangotri Sightseeing" },
      { title: "Phata Sightseeing" },
      { title: "Badrinath Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Comfortable stays in well-selected hotels at each destination, with clean and cozy arrangements.",
      "Enjoy wholesome meals throughout the journey, including daily breakfast, lunch, and dinner as per the itinerary.",
      "Seamless travel with helicopter transfers between all Char Dham destinations, along with comfortable ground transfers and assistance at every step.",
      "Visit all four sacred shrines - Yamunotri, Gangotri, Kedarnath, and Badrinath - with well-planned schedules for a smooth and fulfilling pilgrimage.",
      "Hassle-free access to Yamunotri via palki and Kedarnath via shuttle helicopter, ensuring comfort without compromising the spiritual experience.",
      "Witness breathtaking aerial views of the Himalayas, valleys, and rivers during helicopter journeys and stays.",
      "Opportunity to attend the early morning Abhishek Puja at Badrinath Temple and witness divine rituals up close.",
      "Dedicated ground support, welcome briefing, and guided coordination throughout the yatra for a smooth experience.",
      "Complimentary duffle bag and well-organized arrangements designed to enhance comfort and convenience during the pilgrimage.",

    ],

    // exclusions: [
    //   "Departure may be arranged via Milan or Zurich, depending on flight availability. For direct joiners, return departures should be from Zurich. In case of departure from Milan, flights should be scheduled after 7:00 PM. An additional transfer from Zurich to Milan (approximately 5–7 hours by road)) will be required, and the associated transfer cost will be applicable.",
    //   "Any increase in airfare, visa fees, airport taxes, fuel surcharges, government levies, or newly introduced taxes post-booking.",
    //   "Charges for airline seat upgrades, hotel room upgrades, or flight deviation requests.",
    //   "Fare difference arising due to change in travel dates, sector, or airline",
    //   "Additional costs due to flight rescheduling, cancellation, or no-show",
    //   "Fluctuations in the foreign exchange rate leading to a rise in land arrangement costs prior to departure.",
    //   "Pre- or post-tour hotel accommodation and services not included in the itinerary.",
    //   "Additional expenses due to route changes, airline amendments, date changes, or accommodation modifications arising from unforeseen or force majeure circumstances.",
    //   "Porterage, laundry, telephone calls, personal shopping, alcoholic beverages, and meals or snacks not specified in the group menu.",
    //   "Expenses arising from personal illness, medical emergencies, hospitalization, or accidents during the tour.",
    //   "Charges for optional activities, excursions, or services not mentioned in the itinerary.",
    //   "For direct joiners, airport transfers are not included and must be arranged independently.",
    //   "Guests departing independently from Zurich must arrange or pay for their transfers separately.",
    //   "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    //   "Any services not explicitly mentioned in the inclusions",
    // ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrive in Dehradun",
        detail:
          "Upon your arrival in Dehradun, our driver will greet you at the airport or railway station and accompany you to your hotel for a comfortable check-in. Later in the evening, our representative will meet you for a welcome session, where you’ll receive a detailed briefing about the Char Dham Yatra, including important guidelines for the journey ahead. As part of the helicopter travel requirements, a body weight check will also be conducted for all passengers during this session. As a token of our warm hospitality, each guest will be presented with a complimentary duffle bag, thoughtfully designed for the Char Dham Yatra. This specially curated travel bag is not only a gesture of gratitude but also a practical and convenient companion to support you throughout your spiritual journey. (Dinner)"
      },
      {
        day: 2,
        title:
          "Transfer from Dehradun to Yamunotri / Kharsali (by Helicopter) - Yamuna Mata Temple Visit",
        detail:
          "After breakfast, guests will check out from their hotel and proceed to Sahastradhara Helipad in Dehradun for their onward journey. From here, you will board a helicopter for a scenic 30-minute flight to Kharsali Helipad, the gateway to Yamunotri. On arrival, you will be transferred to your hotel. After some time to freshen up, a palki will be arranged from the hotel, which is the last motorable point. The journey to Yamunotri Temple involves a 5.5 km trek (one way), taking approximately 5 hours for the round trip. Carried by four trained porters, the palki ensures a comfortable and convenient experience. The key attractions at Yamunotri include the revered temple of Goddess Yamuna and the natural hot springs at Janki Chatti. NOTE: As Kharsali is the least developed among the Char Dhams, accommodation here will be basic, clean, and comfortable for a pleasant stay. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 3,
        title:
          "Transfer from Yamunotri / Kharsali to Gangotri / Harsil (by Helicopter) – Visit Gangotri Temple",
        detail:
          "Following breakfast, guests will complete the check-out formalities and be comfortably transferred to Kharsali Helipad to continue their onward journey. From Kharsali, you will board a helicopter for a scenic 30-minute flight to Harsil Helipad. Upon arrival, you will be assisted with your transfer to the hotel for check-in, before proceeding for the sacred Gangotri Ji Darshan. After taking some time to freshen up, you will proceed towards the Gangotri Temple, situated approximately 22 km from Harsil. The journey will be undertaken by a comfortable cab and takes around 50–55 minutes. After completing the darshan, you will return to the hotel. In the evening, enjoy local sightseeing of Bagori Village and Mukhba Village, both known for their rich cultural heritage, traditional handicrafts, and exquisite handmade woollen garments. Mukhba Village also holds great spiritual significance as the winter residence of Goddess Ganga. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 4,
        title:
          "Transfer from Gangotri / Harsil to Kedarnath / Phata (by Helicopter) – Visit Kedarnath Temple",
        detail:
          "After enjoying breakfast, guests will complete the check-out process and proceed with a comfortable transfer to Jhala Helipad to continue their onward journey. From Jhala, you will board a helicopter for a scenic 30-minute flight to Guptkashi/Phata Helipad. Upon arrival, our representative will receive you and assist with a smooth transfer to your hotel for check-in. After some time to relax and freshen up, you will proceed for the sacred Kedarnath Temple darshan via a shuttle helicopter service. From the Kedarnath helipad, the temple is located approximately 500 meters away, which can be comfortably covered on foot in about 15–20 minutes. The shuttle service operates on pre-assigned time slots issued by UCADA (Uttarakhand Civil Aviation Development Authority), ensuring a smooth, well-organized, and safe pilgrimage experience. After completing the darshan, you will return by shuttle helicopter to Phata/Guptkashi Helipad and then proceed to your hotel, where you can enjoy your meal while soaking in the majestic views of the Himalayan peaks. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 5,
        title:
          "Transfer from Kedarnath / Phata to Badrinath (by Helicopter) – Visit Badrinath Temple",
        detail:
          "After breakfast, guests will complete the check-out formalities and proceed with a transfer to Guptkashi/Phata Helipad to continue their onward journey. From Guptkashi/Phata, you will board a helicopter for a 30-minute flight to Badrinath Helipad. Upon arrival, our representative will receive you and assist with your transfer to the hotel for a smooth check-in. After some time to relax and freshen up, you will proceed to Mana Village, known as the “Last Village of India” near the Indo-China border. Explore its iconic sites including Bheem Pul, a natural rock bridge steeped in mythology, the origin of the sacred Saraswati River, and the ancient caves of Ganesh Gufa and Vyas Gufa, associated with epic legends. After the sightseeing, return to the hotel to enjoy your lunch, followed by some leisure time to unwind. Later, you will proceed for the sacred Badrinath Temple darshan by cab. The temple is situated approximately 1–1.5 km away, with a short drive of around 7–10 minutes. From the vehicle drop-off point, a brief walk of about 200–300 meters will lead you to the temple entrance. After completing the darshan, you will return to the hotel for rest and relaxation. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 6,
        title:
          "Departure from Dehradun",
        detail:
          "After breakfast, guests will complete the check-out process and proceed with a transfer to Badrinath Helipad for the onward journey. In the early morning, you will have the opportunity to attend the Special Abhishek Puja at Badrinath Temple (at your own cost). The ritual begins at 4:30 AM and continues for approximately two hours. During this sacred experience, devotees are granted the rare privilege of sitting inside the temple and witnessing the Shringar of the deity from close proximity. After breakfast, you will board the helicopter for your return journey to Dehradun. Upon arrival, our team will assist you with a smooth transfer to the airport or railway station for your onward travel. With this, your Char Dham Helicopter Yatra comes to a fulfilling end, leaving you with divine blessings and cherished spiritual memories to treasure for a lifetime. (Breakfast)"
      },

    ],

    overview: "Embark on a spiritually uplifting Char Dham journey with seamless helicopter travel, beginning in Dehradun and covering Yamunotri, Gangotri, Kedarnath, and Badrinath with ease and comfort. Experience sacred temple darshans, serene Himalayan landscapes, and visits to culturally rich villages, all thoughtfully arranged for a smooth and fulfilling pilgrimage. This divine journey offers a perfect blend of devotion, convenience, and tranquillity, leaving you with blessed moments and lasting spiritual memories."
  },
  // ================= New Zealand =================
  {
    id: "newZealand-001",
    slug: "explore-new-zealand",
    destination: "New Zealand",
    title: "Explore New Zealand",
    duration: "9 Nights 10 Days",
    route: "2N Auckland | 2N Rotorua | 3N Queenstown | 2N Christchurch ",
    departureCity: ["Delhi", "Chennai", "Bangalore", "Hyderabad", "Kolkata", "Ahmedabad", "Joining Direct"],
    availableDate: ["Apr 2026", "May 2026"],
    stars: 4,
    price: 208999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [auckland,rotorua,queenstown,christchurch],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Paris", to: "Out of Zurich", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Auckland", nights: "2 Nights", type: "Copthorne Hotel Auckland City or similar - 4 Star Hotel" },
      { location: "Rotorua", nights: "2 Nights", type: "VR Rotorua Lake Resort or similar - 4 Star Hotel" },
      { location: "Queenstown", nights: "3 Nights", type: "Holiday Inn Queenstown Frankton Road, an IHG Hotel or similar - 4 Star Hotel" },
      { location: "Christchurch", nights: "2 Nights", type: "Fable Christchurch or similar - 4 Star Hotel" },

    ],

    sightseeing: [
      { title: "Auckland Sightseeing" },
      { title: "Rotorua Sightseeing" },
      { title: "Queenstown Sightseeing" },
      { title: "Christchurch Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "09 Nights Accommodation in All 4 Places",
      "4 Star Hotel Category or Similar",
      "Daily Breakfast, Lunch and Dinner (HALAL & VEG TOURS CATERED)",
      "Auckland Highlights Luxury Tour with Sky Tower Entry",
      "Waitomo Cave Tour",
      "Hobbiton Tour",
      "Milford Sound Experience",
      "Shotover Jet, Mt Cook & Lake Tekapo",
      "Christchurch Attractions Combo Pass (Gondola and Tram)",
      "Experienced Tour Guide",

    ],

    exclusions: [
      "Passport fees, immunization costs, city taxes at the hotel and local departure taxes (wherever applicable)",
      "Optional enhancements like room or flight upgrades, or local camera or video fees Additional sightseeing, activities and experiences outside of the itinerary",
      "Early check-in or late check-out from hotels (unless otherwise specified)",
      "Breakfast, lunches, dinners and drinks (alcoholic and non-alcoholic), unless specified in the itinerary Any international and/or domestic flights, unless explicitly mentioned as an inclusion",
      "Excess baggage charges, and where applicable, baggage not included in your fare Tips for services and experiences",
      "Any Visa required, unless mentioned as an inclusion",
      "Read useful information and terms for more on what is included and excluded",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arrival at Auckland",
        detail:
          "Kia Ora! Welcome to New Zealand, the youngest country on Earth! Upon your arrival in Auckland, fondly known as 'The City of Sails,' our representative will extend a warm welcome and transfer you to your hotel. Auckland seamlessly combines islands, Polynesian culture, picturesque harbors, and a modern city environment. The remainder of the day is yours to enjoy at leisure, allowing you the opportunity to explore the city and uncover why Auckland is acclaimed as one of the finest destinations worldwide. Whether you choose to wander through its vibrant streets, visit cultural landmarks, or simply soak in the stunning waterfront views, Auckland promises a captivating introduction to the beauty of New Zealand. (Dinner)"
      },
      {
        day: 2,
        title:
          "Auckland Highlights Luxury Tour with Sky Tower Entry",
        detail:
          "Experience the best of Auckland City and the iconic Sky Tower in one fantastic half-day tour, combining highlights and entry to this famous landmark. Your knowledgeable guide will lead you to Auckland City's most iconic highlights. Marvel at beautiful beaches, panoramic views of several volcanoes, the Auckland Harbour Bridge, West haven Marina, and the Auckland Domain, all within a few hours. Explore Tamaki Drive with sweeping views across the Waitemata Harbour toward Bastion Point and Mission Bay, Auckland City’s renowned beach. Witness the majesty of Rangitoto Island, the youngest and largest volcano in the Auckland Volcanic Field. Drive over the iconic Auckland Harbour Bridge, offering sparkling views of the Waitemata Harbour dotted with white sails, and admire the iconic skyline of Auckland. Visit the Auckland Domain, with stunning views of the Auckland Museum, an architectural icon of New Zealand. Explore the suburb of Parnell, restored in the old colonial style, featuring many beautiful mansions. This small group tour provides insights into what makes Auckland uniquely beautiful, showcasing why it is known as one of the most stunning cities and regions globally. The tour concludes at Auckland’s iconic Sky Tower, standing at 328m, the tallest free-standing structure in the Southern Hemisphere, where you will also have entry to the Sky Tower included in the tour price. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 3,
        title:
          "Transfer from Auckland to Rotorua with Waitomo Caves",
        detail:
          "Embark on an enchanting one-day tour from Auckland to the mesmerizing Waitomo Glowworm Caves and the geothermal wonderland of Rotorua. This unforgettable journey begins with a convenient pick-up from your hotel in Auckland, ensuring a comfortable and seamless start to your adventure. Hop aboard our comfortable minibus, and get ready to explore the captivating natural wonders that await you. You will be driven through the breathtaking Waikato countryside on a fully guided journey to the Waitomo Caves. As we traverse this picturesque route, you'll have the opportunity to experience New Zealand's longest river, witness the beauty of majestic mountains, and encounter several different farm animals along the way. Upon reaching Waitomo, your journey continues with an exploration of the ancient and remarkable caves. Marvel at the intricate cave formations, including stalactites, stalagmites, and lime columns, as you venture deeper into the underground wonders. Board a glowworm boat and embark on a serene cruise along the grotto river, where thousands of glowworms, exclusive to New Zealand, illuminate the darkness above you. The glittering display creates a magical and otherworldly ambiance, making the Waitomo Glowworm Caves a must-see attraction for any traveler. Our adventure persists with another fully guided journey south to Rotorua, offering a captivating experience with numerous attractions along the way. Visit the Sets of Hobbiton movie. A state-of-the-art world famous experience. Followed by arrival into Rotorua The tour concludes with a drop-off at your accommodation or a central Rotorua location, allowing you to settle into this vibrant city. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 4,
        title:
          "Te Ra Guided tour with Agrodome Sheep Farm Tour",
        detail:
          "Start your day with a delicious breakfast at your hotel in Rotorua before embarking on a full-day guided tour of Te Ra. Your knowledgeable guide will take you on an immersive journey through the heart of Māori culture at Te Puia. Explore the geothermal wonders of the Whakarewarewa Valley, with its bubbling mud pools, steaming vents, and the famous Pohutu Geyser. Learn about traditional Māori crafts at the New Zealand Māori Arts and Crafts Institute, where you can see master carvers and weavers at work. In the afternoon, visit the Agrodome for a unique and entertaining sheep experience. The Agrodome Sheep Show is an interactive, fun, and educational demonstration featuring 19 breeds of sheep, a live shearing display, and an opportunity to hand-feed the friendly animals. You can also take a farm tour to see a variety of farm animals, including cows, alpacas, and ostriches. The day concludes with a return to your accommodation in Rotorua, leaving you with enriching memories of Māori culture and New Zealand's agricultural heritage. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 5,
        title:
          "Transfer from Rotorua to Queenstown",
        detail:
          "In the morning, complete your check-out from the hotel, and our team will facilitate your transfer to the airport for your flight to Queenstown. Upon arrival in Queenstown, you will be transferred to your hotel for check-in. The remainder of the day is yours to explore Queenstown at your leisure. Whether you choose to wander along the shores of Lake Wakatipu, explore the vibrant streets, or take in the breathtaking mountain scenery, Queenstown offers a variety of experiences for you to enjoy on your own. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 6,
        title:
          "Milford Sound Experience from Queenstown",
        detail:
          "Embark on a truly exceptional Milford Sound day tour with our established and top-rated small group Milford Experience, a tradition since 1994. Our aim is to provide an escape from the crowds, delivering a unique and unforgettable day that highlights the splendor of this world-renowned region. Experience the journey with guided commentary from our experienced guides, fostering a personalized and engaging atmosphere. Our small group tours enable guests to connect with the driver and fellow travelers, creating lasting and intimate memories. Travel in comfort with our custom-made, 16-seat glass roof Mercedes touring vehicles, offering business class amenities such as extended legroom, leather interior, panoramic windows for optimal views, and USB charging ports onboard. Upon reaching Milford Sound, embark on a breathtaking two-hour small boat nature cruise on the fjord. Witness cascading waterfalls, observe fur seals, penguins, and occasionally dolphins. The journey to Milford Sound is a full-day adventure from Queenstown, lasting 12-13 hours. Our smaller vehicles provide the flexibility to stay away from the crowds and allow more spontaneity in choosing stops along the way. The Milford Sound Day Tour departs daily from Queenstown at 7:30 am, promising an enriching experience that returns around 7:30 pm. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 7,
        title:
          "Shotover Jet 60 min ride and time at Leisure",
        detail:
          "Experience the unparalleled beauty and power of our canyons with the world's most exciting jet boat ride. Our journey promises a unique combination of natural splendor and thrilling canyon action, creating an experience like no other. From the moment you embark on this adventure, you'll be immersed in the pristine landscapes and the breathtaking canyons that define the essence of our journey. Proudly owned by Ngāi Tahu, the Māori people of this land, our connection to the Kimiākau (Shotover River) dates back centuries. The Shotover Canyons, the home of our tīpuna (ancestors), holds a special place in our hearts. As the custodians of this land, we take pride in offering exclusive access to the spectacular Shotover Canyons, ensuring an experience that is deeply rooted in our cultural heritage. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 8,
        title:
          "Transfer from Queenstown to Christchurch (via Mount Cook)",
        detail:
          "Embark on a breathtaking journey from Queenstown to Christchurch via Mt Cook on this small-group, fully-guided tour. This unique experience combines two of the most stunning locations in the South Island, providing ample time and options to indulge in activities that set it apart from other tours. Led by our famously passionate tour guides, known for bringing your journey to life with engaging stories and rich background knowledge, this tour is an immersive exploration of the South Island's natural beauty. Our modern and comfortable minibuses are equipped with extras to ensure your comfort and safety throughout the journey. (Breakfast, Lunch and Dinner)."
      },
      {
        day: 9,
        title:
          "Half Day Christchurch City tour with Antarctic centre",
        detail:
          "Start your day with a 3-hour guided tour of Christchurch, exploring the city's key landmarks and attractions. Discover the vibrant culture, historic sites, and beautiful parks as you navigate through the central business district and beyond. After your city tour, visit the International Antarctic Centre, where you can experience the thrill of Antarctica without leaving Christchurch. Enjoy interactive exhibits, see the Antarctic wildlife, and feel the chill of the Antarctic storm room. Overnight stay at Christchurch. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 10,
        title:
          "Departure from Christchurch",
        detail:
          "This morning, complete the check-out process from your hotel, and our team will arrange your transfer to the airport for your return flight home. As you board your flight, reflect on the happy memories and experiences gathered during your tour. Your journey concludes, and we hope you carry with you cherished moments and a sense of fulfillment from your travels. Wishing you a safe and pleasant journey back home. Until we meet again, farewell and thank you for choosing us to be a part of your memorable adventure."
      },

    ],

    overview: "Embark on a captivating 10-day journey through New Zealand's iconic destinations. Begin in Auckland, exploring the city's highlights and ascending the Sky Tower. Head to Rotorua, marveling at the Waitomo Glowworm Caves and discovering the geothermal wonders. Immerse yourself in the Hobbiton Morning/Afternoon Tour, a Middle-earth adventure. Fly to Queenstown for a self-guided exploration before a scenic Milford Sound Experience, offering a small-group boat cruise amidst stunning fjord landscapes. Experience the thrill of Shotover Jet, connecting with the cultural heritage of the Ngāi Tahu people. Travel to Christchurch via Mount Cook and Lake Tekapo, reveling in the South Island's natural beauty. In Christchurch, enjoy a Gondola ride and Tram tour with insightful commentary on the city's history and culture. Conclude your journey with a heartfelt farewell, leaving you with cherished memories and a sense of fulfillment. Safe travels and until we meet again!"
  },
  // ================= Japan =================
  {
    id: "japan-001",
    slug: "japan-for-first-timers-the-classic-route",
    destination: "Japan",
    title: "Japan for First Timers - The Classic Route",
    duration: "6 Nights 7 Days",
    route: "3N Tokyo | 1N Kanazawa | 2N Kyoto",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Ahmedabad", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Nov 2026"],
    stars: 4,
    price: 326999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [tokyo,kanazawa,kyoto],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Into Tokyo", to: "Out of Osaka", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "Tokyo", nights: "3 Nights", type: "Asakusa View Hotel or similar - 4 Star Hotel" },
      { location: "Kanazawa", nights: "1 Nights", type: "Kanazawa Tokyu Hotel or similar - 4 Star Hotel" },
      { location: "Kyoto", nights: "2 Nights", type: "Hotel Nikko Princess Kyoto or similar - 4 Star Hotel" },
    ],

    sightseeing: [
      { title: "Tokyo Sightseeing" },
      { title: "Kanazawa Sightseeing" },
      { title: "Kyoto Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      // { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "A perfectly planned 7-day Golden Route covering Tokyo, Mount Fuji, Kanazawa, Kyoto & Osaka in one smooth journey.",
      "Experience Mount Fuji in a full-day tour with Lake Kawaguchi, Chureito Pagoda, Oshino Hakkai & the 5th Station.",
      "Ride the iconic Bullet Train from Kanazawa to Kyoto — fast, scenic, and comfortable.",
      "Discover Kyoto’s traditions with torii gates, ancient temples & hilltop city views.",
      "Feel modern Japan in Tokyo & Osaka - from Shibuya Crossing & Harajuku streets to Dotonbori nights, Kuromon markets & Osaka Castle.",
      "Smartly paced itinerary blending cities, culture, nature & everyday Japanese life — without the rush.",

    ],

    exclusions: [
      "Mandatory Tips: Japanese Yen 800 per person per day, to be paid directly to the tour manager.",
      "Additional Expenses: Porterage, laundry, wines, mineral water, telephone charges, and any other items of a personal nature.",
      "Optional Tours: Any tours or activities not included in the itinerary.",
      "Food and Drinks: Meals and beverages that are not specifically mentioned in the “Tour Price Includes” section.",
      "Other Exclusions: Anything not explicitly listed under the “Tour Price Includes” column.",
      "Any extra cost incurred on behalf of an individual due to illness, accident, hospitalization, or any personal emergency.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arriving in Tokyo",
        detail:
          "The moment you land in Tokyo, you feel it — this place is different. Bright lights, quiet corners, polite smiles, and a sense of excitement in the air. After settling into your hotel, you have your first evening to soak it all in. Your Japan story begins. (Dinner)"
      },
      {
        day: 2,
        title:
          "Feeling Tokyo: From Peaceful Shrines to Shibuya Lights",
        detail:
          "Your day begins with the peaceful gardens of the Imperial Palace, the official residence of Japan’s Emperor. As you stroll along green pathways and admire the graceful Nijubashi Bridge from a distance — beautifully curved and uniquely shaped — you’ll feel a quiet calm in the heart of this busy city. Next, you head to the charming Asakusa area, walking past the lively Nakamise shopping street before reaching the beautiful Senso-ji Temple, Tokyo’s oldest Buddhist temple. The sound of prayers, glowing lanterns, and the gentle smell of incense make this moment truly special. Enjoy some free time for lunch before continuing your journey. Later, experience serenity at Meiji Jingu, a Shinto shrine hidden inside a peaceful forest. From here, step into the playful energy of Harajuku — known as a hub of youth culture, fashion experimentation, street style and pop culture. Your day ends at the iconic Shibuya Crossing, the world-famous pedestrian scramble where thousands cross from all directions at once under towering neon lights and digital billboards — a true symbol of Tokyo’s modern spirit. As the evening settles in, you return with quiet smiles, full hearts, and beautiful first memories of Japan. Overnight in Tokyo. (Breakfast and Dinner)"
      },
      {
        day: 3,
        title:
          "Mount Fuji & Lake Kawaguchi Experience",
        detail:
          "Today feels like stepping into a postcard. You leave the city behind and travel toward majestic Mount Fuji, Japan’s most loved natural icon. Your first stop is Oishi Park, where gentle breezes and flower-lined paths open up to stunning views of Lake Kawaguchi — part of the Fuji Five Lakes region, famous for its calm waters and mirror-like reflections of the mountain. Next, you visit Arakurayama Sengen Park, home to the iconic Chureito Pagoda and Arakura Fuji Sengen Shrine. From here, the views feel truly magical — one of Japan’s most photographed scenes. In Fujiyoshida, enjoy relaxed free time for lunch and browse traditional shops for local souvenirs. Later, discover the peaceful village of Oshino Hakkai, known for its crystal-clear ponds, thatched houses, and quiet countryside charm. Your journey continues up to Mount Fuji’s 5th Station (weather permitting), where fresh mountain air and panoramic views surround you. Standing here, you understand why Fuji is seen as sacred — its perfect shape and quiet presence leave a deep impression. It’s a day filled with scenery, silence, and simple joy — a beautiful contrast to the busy cities. You return to Tokyo carrying mountain memories and a calm heart. Overnight in Tokyo. (Breakfast and Dinner)"
      },
      {
        day: 4,
        title:
          "Tokyo to Kanazawa - From City Lights to Old Streets",
        detail:
          "Today is a travel day as you move from Tokyo to Kanazawa. After breakfast, you start your journey by Bullet Train. Roughly about 3.5 Hrs, but comfortable, and you’ll notice how the scenery slowly changes from the busy city to quieter towns and open landscapes. Once you reach Kanazawa, the vibe feels different — calmer and more traditional. You first visit the Higashi Chaya District. This area is known for its old wooden houses and traditional tea houses. The streets are narrow and charming, and it really feels like stepping into old Japan. It’s a nice place to walk around, click pictures, and just soak in the atmosphere. Next, you head to Kanazawa Castle. The castle grounds are wide and open, with strong stone walls and beautiful surroundings. It gives you a good sense of the city’s history and its samurai past. In the evening, enjoy dinner at an Indian restaurant and then transfer to your hotel. Overnight in Kanazawa."
      },
      {
        day: 5,
        title:
          "Finding Your Calm: Torii Gates, Temples & Quiet Kyoto Moments",
        detail:
          "After breakfast, you board the train toward Kyoto. Outside your window, the scenery slowly changes — quiet towns, green landscapes, and soft glimpses of Lake Biwa drifting past like a moving painting. By the time you arrive, Kyoto feels different. Slower. Softer. Older. This is where Japan’s soul quietly lives. Your afternoon begins at Fushimi Inari Taisha, walking through endless red torii gates that wind gently up the hillside. With every step, the world feels quieter — almost meditative — as if time itself has slowed down. Next, you visit Sanjusangen-do, A buddhist temple & home to 1,001 golden statues standing silently in perfect harmony. It’s a powerful, peaceful moment that stays with you long after you leave. Your day ends at Kiyomizu-dera - Pure Water Temple, where you stand on a wooden terrace overlooking Kyoto. As the city stretches out below and the light softens, you simply pause — taking it all in. Kyoto doesn’t rush you. It gently teaches you to slow down. You return to your hotel feeling lighter, calmer, and deeply connected to Japan’s timeless beauty. Overnight in Kyoto. (Breakfast and Dinner)"
      },
      {
        day: 6,
        title:
          "Osaka City Experience: Neon Streets & Everyday Life",
        detail:
          "Today, the mood changes. After breakfast, you travel from Kyoto into Osaka — and almost immediately, you feel the difference. This city is louder, brighter, warmer and full of life. You begin in Namba and Dotonbori, where neon lights glow even in daylight and the streets buzz with life. The smell of street food drifts through the air, laughter echoes from small cafés, and everywhere you look, something is happening. Osaka doesn’t try to impress — it simply invites you in. Tucked quietly between busy lanes, you step into Hozenji Temple, a small 17th-century temple where moss-covered statues and gentle prayers offer a peaceful calm before the city buzz pulls you back in. Then comes Kuromon Ichiba Market, where locals shop, eat, and laugh. This is where you truly see everyday Osaka — real, friendly, raw and real, and full of flavour and it’s impossible not to love it. Explore the retro neighbourhood of Shinsekai, that feels playful and nostalgic, then admire the grandeur of Osaka Castle, rising proudly above green gardens — a beautiful reminder of Japan’s powerful past. Before leaving, you stroll through the famous shopping streets Shinsaibashi and Nipponbashi, perfect for souvenirs, fashion, and last-minute finds. As evening settles in, you return to Kyoto — carrying Osaka’s colours, flavours, and energy with you. It’s a day that makes you feel alive. Overnight in Kyoto. (Breakfast and Dinner)"
      },
      {
        day: 7,
        title:
          "Departure: Taking Japan Home in Your Heart",
        detail:
          "After breakfast, it’s time to say goodbye. You complete your check-out and transfer to the airport, carrying more than just souvenirs — you carry memories of glowing streets, quiet temples, mountain breezes, and moments that touched your heart. You didn’t just travel through Japan — you felt it. From quiet temples to glowing streets, this journey becomes a beautiful memory you’ll carry long after you return home. (Breakfast)"
      },
    ],

    overview: "If this is your first time in Japan, this journey is designed to show you everything that matters — without feeling hurried. You start in Tokyo, with two full days to experience both sides of the city — peaceful temples and gardens, colorful shopping streets, Harajuku culture, and the iconic Shibuya Crossing. Next comes a full day around Mount Fuji, where you visit Lake Kawaguchi, Chureito Pagoda, Oshino Hakkai village and Fuji’s 5th Station (weather permitting). It’s a complete Fuji experience — nature, viewpoints, and postcard moments. You then travel by coach to Kanazawa, watching the scenery change as you move from city landscapes to quieter countryside. In Kanazawa, you explore the historic Kanazawa Castle and walk through the beautifully preserved Higashi Chaya District, known for its traditional wooden tea houses and old-world charm. From here, you continue to cultural Kyoto. Walk through thousands of red torii gates, visit historic temples, and enjoy stunning views from the hills. Your journey ends in energetic Osaka, where you explore lively markets, neon-lit streets, Osaka Castle, and vibrant local neighborhoods before returning to Kyoto. This itinerary gives you cities, mountains, temples, markets, and everyday Japanese life — all carefully arranged across seven meaningful days. You don’t just see Japan. You understand it. And when you leave, you carry home not just photos — but a complete first experience of Japan."
  },
  {
    id: "japan-002",
    slug: "japan-alpine-route-snow-wall-experience",
    destination: "Japan",
    title: "Japan Alpine Route - Snow Wall Experience",
    duration: "9 Nights 10 Days",
    route: "2N Tokyo | 1N Gotemba | 1N Nagano | 1N Toyama | 1N Nagoya | 3N Osaka",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Joining Direct"],
    availableDate: ["Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 374999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [tokyo,gotemba,nagano,toyama,osaka],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Into Tokyo", to: "Out of Osaka", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "Tokyo", nights: "2 Nights", type: "Asakusa View Hotel or similar - 4 Star Hotel" },
      { location: "Gotemba", nights: "1 Nights", type: "Mars Garden Wood Gotemba or similar - 4 Star Hotel" },
      { location: "Nagano", nights: "1 Nights", type: "Powdersuites by The Hakuba Collection or similar - 4 Star Hotel" },
      { location: "Toyama", nights: "1 Nights", type: "ANA Crowne Plaza Toyama, an IHG Hotel or similar - 4 Star Hotel" },
      { location: "Nagoya", nights: "1 Nights", type: "Nagoya Tokyu Hotel or similar - 4 Star Hotel" },
      { location: "Osaka", nights: "3 Nights", type: "LIBER HOTEL OSAKA or similar - 4 Star Hotel" },
    ],

    sightseeing: [
      { title: "Tokyo Sightseeing" },
      { title: "Gotemba Sightseeing" },
      { title: "Nagano Sightseeing" },
      { title: "Toyama Sightseeing" },
      { title: "Nagoya Sightseeing" },
      { title: "Osaka Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "A perfectly planned 9-night Japan journey covering Tokyo, Mt. Fuji region, Nagano, Toyama, Nagoya, Kyoto, Nara & Osaka - moving in one smooth direction without backtracking.",
      "2 proper nights in Tokyo to experience the city properly — from Senso-ji Temple and Tokyo Skytree views to TeamLab’s digital world and Shibuya Crossing.",
      "A full Mt. Fuji and Hakone day placed perfectly on the way to Nagano - so travel time becomes sightseeing time.",
      "The Tateyama Kurobe Alpine Route included smartly between Nagano and Toyama — reducing long travel stress and keeping the journey comfortable.",
      "Nagoya added as a strategic stop to break the long distance and add new experiences without tiring drives.",
      "Discover the cultural side in Nara & Kyoto — Deer Park, Todaiji Temple, Fushimi Inari gates, Golden Pavilion and the Arashiyama Bamboo Grove.",
      "End with 3 relaxed nights in Osaka featuring Osaka Castle, skyline views at Umeda Sky Building and lively Shinsaibashi streets, so the trip finishes easy, not hectic.",
      "Smartly routed, well-paced, and logically sequenced — blending cities, mountains, tradition and modern Japan in one seamless journey.",

    ],

    exclusions: [
      "Remittance charges, if any, are to be borne by the guest.",
      "Meals not specifically mentioned in the above itinerary.",
      "Single room supplement charges.",
      "Personal accident and travel insurance.",
      "Passport and visa application fees, along with any incidental charges, to be paid directly by the guest.",
      "International airfare and related airport taxes.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arriving in Tokyo",
        detail:
          "The moment your flight touches down in Japan, there’s a quiet sense of excitement in the air. The efficiency, the politeness, the calm — you feel it instantly. As you step out of the arrival gates, you’ll be warmly welcomed by your Tour Manager or local guide, ready with a smile to begin your Japan journey. From here, sit back and relax as you drive through your first glimpses of Japan — spotless roads, perfectly organized traffic, and a skyline that beautifully blends tradition with modern life. Soon, you arrive at your hotel, your home for the next few days. Check-in time is between 3:00 PM and 4:00 PM, giving you time to freshen up, settle in, and perhaps look out of your window to see your very first Japanese city view. And in case your flight arrives late, or immigration queues take longer than expected, don’t worry — a packed dinner will be arranged for you, ensuring you can unwind and relax after your long journey. Tonight, you rest in Japan. Tomorrow, your adventure truly begins."
      },
      {
        day: 2,
        title:
          "Full Day Tokyo Sight Seeing",
        detail:
          "After breakfast, you step out to see the real Tokyo. First, you visit Senso-ji (Asakusa Kannon Temple). The big red lantern at the entrance, the smell of incense in the air, and people quietly offering prayers — it instantly feels peaceful. For a few moments, everything slows down. Right outside, you walk through Nakamise Street, a lively old street filled with small shops, Japanese sweets, and cute souvenirs. It’s colourful, cheerful, and full of local charm. Then, sit back and experience a traditional Japanese Tea Ceremony. Watching the tea being prepared so carefully and tasting fresh matcha makes you truly feel Japan’s culture — simple, calm, and beautiful. Next, head up to the Tokyo Skytree (350m Observatory). From the top, the whole city spreads out below you — buildings, roads, rivers — Tokyo looks endless. Later, stop at the famous Shibuya Crossing. When the signal turns red, hundreds of people cross at once from every direction. Lights, energy, movement — this is the Tokyo you’ve seen in movies. By the end of the day, you’ve felt both sides of Japan — peaceful tradition and fast city life — all in one beautiful day."
      },
      {
        day: 3,
        title:
          "A Fun Day in Tokyo & Drive to Fuji",
        detail:
          "After breakfast, get ready for something completely different. You step into 3D TeamLab Planets, and suddenly you’re inside a world of lights, colours, and reflections. Flowers bloom around you, water ripples under your feet, and mirrors make the space feel endless. It doesn’t feel like a museum — it feels like you’ve walked into a dream. Every corner is fun, playful, and perfect for photos. Later, you head towards the bay for a quick stop at the Tokyo Statue of Liberty, with the beautiful Rainbow Bridge behind you. The sea breeze, the skyline, the bridge — it’s one of those moments where you just pause and smile for that perfect picture. By evening, you leave the busy city behind and drive towards the Mt. Fuji area. Slowly, tall buildings turn into open views and fresh air. The pace feels calmer. Tonight, you stay in Mishima / Gotemba, enjoy dinner, and relax — knowing that tomorrow, you’ll be closer to Japan’s most famous mountain. Overnight in Mishima/Gotemba."
      },
      {
        day: 4,
        title:
          "Mt. Fuji & Hakone Cruise and Transfer to Matsumoto/Nagano",
        detail:
          "After breakfast, drive up to Mount Fuji 5th Station. As you go higher, the air gets cooler, and the views get better. Standing there, halfway up Japan’s most famous mountain, feels special — this is the Mt. Fuji you’ve always seen in pictures. Later, enjoy lunch at an Indian restaurant before heading to Hakone. Take the Hakone Ropeway, gliding over valleys and volcanic landscapes — the views are simply beautiful. Then relax on a cruise across Lake Ashi, with calm waters and mountain views all around. By evening, travel onwards to Matsumoto / Nagano. After dinner at an Indian restaurant, check into your hotel and unwind for the night — surrounded by Japan’s peaceful countryside."
      },
      {
        day: 5,
        title:
          "Full Day Tateyama Kurobe Alpine Tour & Transfer to Toyama",
        detail:
          "Early this morning, with your packed breakfast and lunch ready, you set out for one of Japan’s most unforgettable experiences — the Tateyama Kurobe Alpine Route. As the journey begins, you realise this is not a normal sightseeing day. You move through the mountains using different modes of transport — Cable Cars pulling you up steep slopes, Ropeways floating over deep valleys, Mountain Buses winding through high roads. With every change, the views become more dramatic. Snow walls (in season), vast mountain ranges, clear skies, and crisp alpine air surround you. It feels fresh, quiet, and powerful - like you’re standing on top of Japan itself. No city noise, no rush. Just nature in its grandest form. Somewhere along the route, you pause to enjoy your packed lunch, sitting amidst breathtaking scenery that looks straight out of a postcard. By evening, you make your way back to Toyama, tired but amazed at what you’ve just experienced. After dinner at an Indian restaurant, you transfer to your hotel and check in. Tonight, as you rest in Toyama, you carry with you the feeling of having travelled across the very roof of Japan."
      },
      {
        day: 6,
        title:
          "Nagoya City Tour & Evening Light Festival",
        detail:
          "After breakfast, you travel by bus to Nagoya. The ride is comfortable, and as the scenery changes outside your window, you slowly enter another vibrant Japanese city. After lunch at an Indian restaurant, your first stop is the Toyota Commemorative Museum of Industry and Technology. Here, you see how Japan’s most famous car brand began its journey. From old machines to modern technology, it’s interesting to see how simple ideas turned into something the whole world knows today. Even if you’re not a car lover, it’s impressive. As evening approaches, you head to Nabana no Sato — and this is where the magic begins. When the sun sets, thousands and thousands of LED lights switch on together. Tunnels of lights, glowing landscapes, colourful displays — it feels like you’re walking inside a dream. It’s calm, beautiful, and perfect for photos. Later, enjoy dinner at an Indian restaurant before transferring to your hotel in Nagoya for check-in. Tonight, you rest with memories of bright city lights and a different side of Japan — modern, creative, and full of surprises."
      },
      {
        day: 7,
        title:
          "Nara Sighteeing & Onward to Osaka",
        detail:
          "After breakfast, you leave Nagoya and travel by coach towards Nara. The drive is smooth and comfortable, with neat towns, green fields, and peaceful views passing by your window. It’s one of those relaxed travel mornings where you just sit back and enjoy Japan as it moves around you. Soon, you arrive in Nara — a place that feels calm and old-world charming. At Nara Park, you’ll see something you won’t forget — friendly deer walking freely around you. They gently bow, come close for treats, and aren’t afraid of visitors. It feels simple, sweet, and very different from the busy cities. You’ll also visit Todai-ji, home to a massive Buddha statue inside one of the world’s largest wooden buildings. Standing inside, looking up at the giant statue, you feel small in the best way — quiet, peaceful, and amazed. Later, continue your journey towards Osaka, where the energy slowly builds again. By the time you reach the city, you’ll feel the contrast — from Nara’s calm nature to Osaka’s lively streets. Another beautiful day in Japan, filled with simple moments that stay with you."
      },
      {
        day: 8,
        title:
          "Kyoto Day Trip - Temples, Torii Gates & Arashiyama Bamboo",
        detail:
          "After breakfast, you travel from Osaka to Kyoto — a city that feels like stepping back in time. Your first stop is the famous Fushimi Inari Taisha. As you start walking through the thousands of bright red torii gates, one after another, it feels almost magical. The path keeps going, the gates create a tunnel around you, and for a moment, it’s just you and this beautiful red walkway. It’s one of those places you’ve seen in photos — and now you’re actually there. After lunch at an Indian restaurant, continue to Kinkaku-ji, also known as the Golden Pavilion. The temple shines beautifully beside the water, and when the sunlight hits it, the reflection is just stunning. It’s calm, picture-perfect, and peaceful. Next, walk through the famous Arashiyama Bamboo Grove. Tall green bamboo stalks rise all around you, swaying gently with the wind. The sound is soft, the path is quiet, and it feels completely different from anywhere else. By evening, you return to Osaka for dinner at an Indian restaurant, and then head back to your hotel. Today feels special — full of tradition, beauty, and simple moments that make you realise how unique Kyoto truly is."
      },
      {
        day: 9,
        title:
          "Osaka Sightseeing & Shopping Street",
        detail:
          "After breakfast, you head out to explore Osaka — a city that feels lively, friendly, and full of character. Your day begins at Osaka Castle. As you walk towards the grand castle, surrounded by huge stone walls and a wide moat, it feels like stepping into Japan’s samurai days. Inside, you learn about its history, and from the top floor, you get a lovely view of the city around you. Old Japan and modern Osaka — all in one frame. After lunch at an Indian restaurant, you visit the Umeda Sky Building. The elevator takes you up to the floating observatory, where the city stretches out below. Tall buildings, moving trains, busy roads — Osaka looks energetic and alive. Later, enjoy free time at Shinsaibashi. This is where you feel the real buzz of the city. Bright signboards, fashion stores, local snacks, and people everywhere. You can shop, explore, or simply walk around and take it all in. In the evening, after dinner at an Indian restaurant, you return to your hotel. Today, you’ve seen Osaka’s royal past, its modern skyline, and its fun shopping streets — all in one vibrant day."
      },
      {
        day: 10,
        title:
          "Departure from Osaka",
        detail:
          "After breakfast at an Indian restaurant, return to the hotel (if applicable) and complete the check-out formalities. At the scheduled time, transfer to the airport for your departure. Board your flight back home, carrying with you sweet and unforgettable memories of Japan’s culture, landscapes, and vibrant cities. Tour concludes with wonderful experiences. (Breakfast)"
      },
    ],

    overview: "This trip is for the traveller who doesn’t want to just “see” Japan — but truly feel it. If you’ve ever imagined walking under red torii gates in Kyoto, seeing Mount Fuji with your own eyes, touching snow walls in the Alps, feeding deer in Nara, and standing in the middle of Tokyo’s busy crossings — this journey is for you. What makes this trip special? You start in Tokyo — where old temples and neon lights exist side by side. One moment you’re at Senso-ji, the next you’re looking at the city from Tokyo Skytree. It’s fast, exciting, and full of life. Then you slow down near Mount Fuji 5th Station and cruise across Lake Ashi — fresh air, open views, and that postcard-perfect Fuji moment. After that comes the real highlight — the Tateyama Kurobe Alpine Route. Cable cars, ropeways, mountain buses, snow walls (in season) — this is not a normal sightseeing day. This is Japan at its most dramatic and beautiful. You then move into cultural Japan — the friendly deer at Nara Park, the red gates of Fushimi Inari Taisha, the golden shine of Kinkaku-ji, and the bamboo paths of Arashiyama Bamboo Grove. And you end in lively Osaka — castles, skyline views, and shopping streets full of energy. This is perfect for Families/Couples who want both fun and nature, First-time Japan travellers who want to cover it properly & anyone who wants mountains, cities, culture, and comfort — all in one trip. This is not rushed Japan. This is complete Japan — city lights, quiet temples, mountain air, and real experiences. When you return home, you won’t just say, “I visited Japan.” You’ll say, “I experienced it."
  },
  {
    id: "japan-003",
    slug: "japan-for-all-mt.Fuji-tokyo-osaka-city-highlights-hiroshimas-past",
    destination: "Japan",
    title: "Japan for all - Mt. Fuji, Tokyo & Osaka City Highlights & Hiroshima’s Past",
    duration: "6 Nights 7 Days",
    route: "3N Tokyo | 1N Hiroshima | 2N Osaka",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Joining Direct"],
    availableDate: ["Jun 2026"],
    stars: 4,
    price: 249999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [tokyo,hiroshima,osaka],

    includes: ["hotels", "sightseeing", "transfers", "meals"],

    // flights: [
    //   { from: "Into Tokyo", to: "Out of Osaka", type: "Direct or 1 Stop" },
    // ],

    hotels: [
      { location: "Tokyo", nights: "3 Nights", type: "Hotel JAL City Tokyo Toyosu or similar - 4 Star Hotel" },
      { location: "Hiroshima", nights: "1 Nights", type: "Grand Prince Hotel Hiroshima or similar - 4 Star Hotel" },
      { location: "Osaka", nights: "2 Nights", type: "Hotel Agora Regency Osaka Sakai or similar - 4 Star Hotel" },
    ],

    sightseeing: [
      { title: "Tokyo Sightseeing" },
      { title: "Hiroshima Sightseeing" },
      { title: "Osaka Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "6-Night Stay with 4-Star Hotel Accommodation",
      "Daily Breakfast, Indian Lunch, Indian Dinner",
      "SIC Transfers & Bullet Train Included",
      "Airport Pickup from Narita International Airport & Drop-off at Kansai International Airport",
      "Imperial Palace Tokyo (Outside View) ",
      "Sensō-ji & Nakamise Street",
      "Tokyo Skytree (350m Observatory)",
      "Shibuya Crossing & Hachikō Statue ",
      "Mount Fuji",
      "Hakone Ropeway ",
      "Lake Ashi Cruise",
      "Itsukushima Shrine Floating Torii",
      "Hiroshima Peace Memorial Park & Atomic Bomb Dome",
      "Umeda Sky Building",
      "Nara Park & Tōdai-ji",
      "Kinkaku-ji Arashiyama Bamboo Grove",
      "Shopping at Shinsaibashi",

    ],

    exclusions: [
      "Mandatory Tips: Japanese Yen 800 per person per day, to be paid directly to the tour manager.",
      "Additional Expenses: Porterage, laundry, wines, mineral water, telephone charges, and any other items of a personal nature.",
      "Optional Tours: Any tours or activities not included in the itinerary.",
      "Food and Drinks: Meals and beverages that are not specifically mentioned in the “Tour Price Includes” section.",
      "Other Exclusions: Anything not explicitly listed under the “Tour Price Includes” column.",
      "Any extra cost incurred on behalf of an individual due to illness, accident, hospitalization, or any personal emergency.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Welcome to Tokyo - A Country Like No Other",
        detail:
          "The moment you land in Tokyo, you feel the buzz of the city — a mix of deep traditions and modern wonders all around you. At the airport, you’re greeted with warmth that makes you feel right at home. A smooth drive takes you to your hotel in the heart of the city. After check-in (around 3:00 PM), you can relax and settle in. In the evening, enjoy a comforting Indian buffet dinner, either at the hotel or at a nearby restaurant. The familiar spices and flavors remind you of home, while outside the window Tokyo shines bright with neon lights, calling you to the adventures that wait ahead. Your journey in the Land of the Rising Sun has just begun."
      },
      {
        day: 2,
        title:
          "Full Day Tokyo Sightseeing – Imperial Palace, Asakusa, Sky Tree & Shibuya Crossing",
        detail:
          "Begin your day at the Imperial Palace, home to Japan’s royal family. The peaceful gardens and grand bridges offer a glimpse into the nation’s royal heritage. Next, visit Asakusa Temple, Tokyo’s oldest and most spiritual site. Outside, Nakamise Street buzzes with shops selling souvenirs and street snacks — a colorful taste of local culture. Head to the Tokyo Sky Tree, where breathtaking city views unfold from 350 meters above the ground — a true highlight of Tokyo. After a delicious Indian lunch, continue to Odaiba, the city’s modern waterfront area. Capture photos of the Statue of Liberty replica and the Rainbow Bridge before relaxing on a scenic Sumida River Cruise, watching Tokyo glide by from the water. As evening sets in, experience the energy of the Shibuya Crossing, the world’s busiest intersection, and visit the Hachiko Statue, a symbol of loyalty and love. End the day with a warm Indian dinner, reflecting on a perfect blend of tradition, culture, and modern charm."
      },
      {
        day: 3,
        title:
          "A Scenic Journey to Mt. Fuji and Lake Ashi",
        detail:
          "Your day begins with an exciting drive towards Mt. Fuji, Japan’s most iconic symbol. As the snow-capped peak appears in the distance, you’ll feel its quiet majesty. Weather permitting, you’ll visit the 5th Station, where stunning views of the mountain and its surroundings await. After a hearty Indian lunch, continue to the hot-spring resort town of Hakone. Ride the Hakone Ropeway, gliding over volcanic landscapes and steaming vents of the Owakudani Valley — a fascinating sight shaped by nature’s power. Next, enjoy a peaceful cruise on Lake Ashi, surrounded by green hills and with Mt. Fuji often reflected in its calm waters — a perfect moment for photos. As evening falls, return to Tokyo and savor a warm Indian dinner, ending the day filled with breathtaking views and unforgettable natural beauty."
      },
      {
        day: 4,
        title:
          "Transfer from Tokyo to Hiroshima - Bullet Train - Miyajima Island - Itsukushima Shrine - Floating Tori Gate",
        detail:
          "After breakfast, you leave behind the calm of Tokyo and board your train to Hiroshima. The journey itself feels special — as if you’re moving from one chapter of Japan’s story to another. On reaching Hiroshima, a warm Indian lunch welcomes you, giving you the comfort of home before stepping into a place rich with culture and beauty. Soon after, you take a ferry across the sparkling waters to Miyajima Island, a place often called one of Japan’s most beautiful spots. As the ferry glides over the waves, the sight that greets you is unforgettable — the Floating Torii Gate of Itsukushima Shrine, rising proudly from the sea. At high tide, it looks as if it is floating on water, a picture so magical you’ll want to pause and take it all in. Walking through the shrine, with its bright red pillars and quiet atmosphere, feels like stepping back in time. The island has a calmness that touches your heart — a place where the sea, the sky, and tradition come together. As the sun begins to set, you return to Hiroshima. Dinner at an Indian restaurant brings the day to a close, and you head to your hotel with memories of one of Japan’s most enchanting sights."
      },
      {
        day: 5,
        title:
          "Transfer from Hiroshima to Osaka - Hiroshima Sightseeing & Umeda Sky Tower",
        detail:
          "After breakfast, it’s time to say goodbye to your hotel and step into one of the most important chapters of Japan’s history. Today, you’ll visit Hiroshima’s Peace Memorial Park and Museum – a place that quietly speaks of both loss and hope. As you walk through the park, you’ll notice how peaceful and calm it feels, almost as if the city itself wants to remind the world of the value of peace. Inside the museum, you’ll see stories and exhibits that take you back to that fateful day in August 1945, and you’ll also see how the people of Hiroshima rebuilt their lives with courage and determination. Not far away stands the Atomic Bomb Dome, one of the very few buildings that survived the blast. It remains standing to this day, not as a ruin of despair, but as a powerful symbol of resilience and a promise that such a tragedy should never happen again. In the afternoon, head to Osaka and enjoy a hearty Indian lunch. Later, if time permits, ride up to the Umeda Sky Tower, a striking landmark with its floating observatory. From the top, take in sweeping views of Osaka – the modern skyline, bustling streets, and distant mountains, all spread out beneath you. As evening falls, enjoy a warm Indian dinner before checking in to your hotel for an overnight stay."
      },
      {
        day: 6,
        title:
          "Full Day Kyoto & Nara Experience",
        detail:
          "After breakfast, get ready for a beautiful day exploring the traditions of Japan. We begin in Nara, a peaceful city where nature and history live side by side. At Nara Deer Park, friendly deer walk freely all around you. Locals believe these deer are sacred messengers of the gods, and feeding them or simply watching them feels like stepping into a living storybook. Next, we visit the famous Todaiji Temple, home to the giant bronze Buddha. Standing over 15 meters tall, this breathtaking statue fills the hall with a sense of calm and respect. It’s not just a monument, but a reminder of Japan’s deep spiritual roots. From Nara, we continue to Kyoto, the country’s ancient capital. Our first stop is the stunning Golden Pavilion (Kinkaku-ji), a temple covered in gold leaf that shines beautifully over its pond. The reflection on the water makes it look almost unreal – a sight that stays in your heart. Finally, we stroll through the enchanting Arashiyama Bamboo Forest, where tall bamboo stalks sway gently above you. Walking here feels like entering another world, calm and magical, where time seems to slow down. The day ends with a heart full of peace and wonder, carrying the true spirit of Japan’s tradition and beauty."
      },
      {
        day: 7,
        title:
          "Departure From Osaka",
        detail:
          "Today marks the end of your unforgettable journey through Japan, but the memories you’ve created will stay with you forever. After breakfast at your hotel, check out and prepare for your transfer to the airport for your flight home. If time permits, enjoy some free time for shopping at Shinsaibashi, Osaka’s most famous shopping street. As you board your flight, take a moment to reflect on the experiences that have shaped your journey. May you carry with you the soul of Japan, a country where tradition, history, and modernity blend seamlessly."
      },
    ],

    overview: "The moment you land in Tokyo, you feel the mix of old and new all around you — quiet temples standing beside tall glass buildings, traditions living side by side with modern life. At Narita Airport, the warm welcome makes you feel like this is more than just a trip — it’s the start of something special. A smooth drive takes you to your hotel in the lively heart of the city (check-in at 3:00 PM). In the evening, you sit down to a comforting Indian buffet dinner, either at the hotel or a nearby restaurant. The food feels familiar, but your thoughts are already on the days ahead. Because this journey is not only about seeing Japan, it’s about experiencing it. Soon, you’ll leave behind Tokyo’s bright lights and step into Hiroshima — a city that touches your heart in silence. Here, at the Peace Memorial, history speaks without words. It’s a place that reminds you of strength, courage, and hope. Standing there, you don’t just learn about the past — you feel it deeply. And as you rest tonight, looking out at Tokyo’s shining skyline, you know this isn’t just a holiday. It’s a journey that will stay with you forever."
  },
  {
    id: "japan-005",
    slug: "classic-japan-journey-fuji-kyoto-bullet-train",
    destination: "Japan",
    title: "Classic Japan Journey: Fuji, Kyoto & Bullet Train",
    duration: "8 Nights 9 Days",
    route: "4N Tokyo | 2N Kyoto | 2N Osaka",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026", "Nov 2026"],
    stars: 4,
    price: 378999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [tokyo,kyoto,osaka],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Into Tokyo", to: "Out of Osaka", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "Tokyo", nights: "4 Nights", type: "Asakusa View Hotel or similar - 4 Star Hotel" },
      { location: "Kyoto", nights: "2 Nights", type: "RIHGA Royal Hotel Kyoto or similar - 4 Star Hotel" },
      { location: "Osaka", nights: "2 Nights", type: "RIHGA Royal Hotel Osaka, Vignette Collection by IHG or similar - 4 Star Hotel" },
    ],

    sightseeing: [
      { title: "Tokyo Sightseeing" },
      { title: "Kyoto Sightseeing" },
      { title: "Osaka Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "A smartly structured 9-day Japan journey covering Tokyo, Mount Fuji, Kyoto, Nara & Osaka in one seamless flow.",
      "4 nights in Tokyo to fully experience the city — heritage landmarks, skyline views, immersive TeamLab, vibrant Akihabara & the iconic Shibuya Crossing.",
      "A complete Mount Fuji & Lake Kawaguchi day with Oishi Park, Chureito Pagoda, Oshino Hakkai & the 5th Station — all covered properly.",
      "Ride the world-famous Shinkansen Bullet Train to Kyoto — fast, punctual and smooth.",
      "Explore Kyoto & Nara’s cultural treasures including Deer Park, Todaiji Temple, Golden Pavilion, Arashiyama Bamboo Forest, Fushimi Inari & Kiyomizu-dera.",
      "2 nights in Osaka with Osaka Castle, Umeda Sky Building views & lively Dotonbori evenings.",
      "Well-paced days, efficient travel time, and maximum coverage — giving you the complete Japan experience without feeling rushed.",

    ],

    exclusions: [
      "Mandatory Tips: Japanese Yen 800 per person per day, to be paid directly to the tour manager.",
      "Additional Expenses: Porterage, laundry, wines, mineral water, telephone charges, and any other items of a personal nature.",
      "Optional Tours: Any tours or activities not included in the itinerary.",
      "Food and Drinks: Meals and beverages that are not specifically mentioned in the “Tour Price Includes” section.",
      "Other Exclusions: Anything not explicitly listed under the “Tour Price Includes” column.",
      "Any extra cost incurred on behalf of an individual due to illness, accident, hospitalization, or any personal emergency.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Arriving in Tokyo",
        detail:
          "The moment you land in Tokyo, you feel it — this place is different. Bright lights, quiet corners, polite smiles, and a sense of excitement in the air. After settling into your hotel, you have your first evening to soak it all in. Your Japan story begins. (Dinner)"
      },
      {
        day: 2,
        title:
          "Full Day Tokyo Sight Seeing",
        detail:
          "Your day starts at the Tokyo Imperial Palace, where the city suddenly feels quiet. Wide gardens, old stone walls — it’s hard to believe you’re still in busy Tokyo. Then you head to Asakusa to visit Senso-ji Temple. The smell of incense fills the air, people fold their hands in prayer, and just outside, Nakamise-dori Street welcomes you with small traditional shops, local snacks, and colorful souvenirs. It’s lively, cheerful, and full of local charm. Next, you see Tokyo from above at Tokyo Skytree. The city just goes on and on — buildings, roads, rivers — all moving like one big rhythm. Later, explore modern Odaiba, enjoy a calm ride on the Sumida River, and then feel the real energy of the city at Shibuya Crossing. Stop for a photo at the Hachikō Memorial Statue — a small but touching story of loyalty. It’s a full day — old Tokyo, new Tokyo, calm moments and busy streets — all in one beautiful experience. (Breakfast, Lunch, and Dinner)"
      },
      {
        day: 3,
        title:
          "TeamLab Planet & Akihabara Shopping",
        detail:
          "Start your day at 3D TeamLab Planets Tokyo in Toyosu — a place where art isn’t just seen, it’s felt. You walk barefoot through shallow water that moves with you. Lights glow, flowers bloom and disappear, walls shift and change. It feels playful, dreamy, almost unreal — like stepping inside someone’s imagination. Then switch to full-on Tokyo energy in Akihabara. Bright signboards, anime stores, gaming arcades, endless gadgets — it’s colorful, loud, and full of personality. Whether you’re browsing for tech, collectibles, or just soaking in the vibe, Akihabara shows you a fun, modern side of Japan. From digital dreams to electric streets — today feels different, exciting, and completely Tokyo. (Breakfast, Lunch, and Dinner)"
      },
      {
        day: 4,
        title:
          "Mount Fuji & Lake Kawaguchi Experience",
        detail:
          "Today feels like stepping into a postcard. You leave the city behind and travel towards Mount Fuji, Japan’s most loved natural icon. At Oishi Park, gentle breezes and colorful flowers frame beautiful views of Lake Kawaguchi — calm waters reflecting the mountain like a mirror. Next, climb up to Arakurayama Sengen Park, home to the famous Chureito Pagoda and Arakura Fuji Sengen Shrine. The view from here feels almost unreal — the pagoda, the town below, and Mount Fuji rising in the background. In Fujiyoshida, enjoy some relaxed time for lunch on own and a little souvenir shopping before heading to the peaceful village of Oshino Hakkai, known for its clear ponds and quiet countryside charm. If weather allows, you continue up to Mount Fuji’s 5th Station. The air feels fresher, cooler. Standing there, surrounded by wide open views, you understand why Fuji is considered sacred — simple, powerful, and unforgettable. It’s a day of open skies, quiet moments, and natural beauty — a gentle break from the busy city. By evening, you return to Tokyo with mountain memories and a peaceful heart. (Breakfast, Lunch, and Dinner)"
      },
      {
        day: 5,
        title:
          "Transfer from Tokyo to Kyoto by Bullet Train (Shinkasen)",
        detail:
          "Travel in Japan’s world-famous Shinkansen — the iconic Bullet Train that truly reflects the spirit of the country: fast, precise, and beautifully efficient. The moment it glides into the station, there’s a quiet sense of perfection. It arrives exactly on time. It departs exactly on time. Step inside and you’ll find spacious, comfortable seats, spotless interiors, warm hospitality, and a system designed with complete attention to your safety and comfort. And then…it begins. In what feels like seconds, the city fades away and the landscape opens up. Rolling countryside, distant mountains, neat little towns — all passing by your window like scenes from a beautifully shot film. This is not just a transfer from one city to another. It’s a smooth, seamless experience that saves you time — while becoming one of the most memorable highlights of your Japan journey. (Breakfast, Lunch, and Dinner) "
      },
      {
        day: 6,
        title:
          "Kyoto & Nara Tour - Full Day Of Japan’s Heartfelt Tradition",
        detail:
          "After breakfast, we set out to experience the heartfelt traditions of Japan, starting with Nara, a city where history and nature coexist in perfect harmony. Wander through Nara Deer Park, where gentle deer roam freely, revered as messengers of the gods. Here, you’ll feel the peaceful connection between humans and nature, a unique aspect of Japan’s cultural heritage. Next, visit Todaiji Temple, home to the awe-inspiring Daibutsu, the world’s largest bronze Buddha statue, standing 15 meters tall and weighing over 500 tons. This UNESCO World Heritage Site radiates a sense of reverence and tranquility, offering a profound insight into Japan’s spiritual legacy. From Nara, we journey to Kyoto, Japan’s ancient capital, a city that embodies timeless beauty and tradition. Be mesmerized by the Golden Pavilion (Kinkaku-ji), gleaming like a jewel amidst tranquil ponds and lush gardens. Its serene surroundings invite quiet reflection, allowing you to connect deeply with Japan’s cultural elegance. We conclude our day with a visit to Arashiyama Bamboo Forest, where the towering bamboo stalks create a magical, otherworldly atmosphere. Walking through this natural cathedral, you’ll feel transported to a place where nature, spirituality, and tradition converge in perfect harmony. (Breakfast, Lunch, and Dinner)"
      },
      {
        day: 7,
        title:
          "Kyoto to Osaka by Road",
        detail:
          "Your day begins at Fushimi Inari Taisha, where endless red torii gates rise one after another, leading you gently up the hillside. As you walk through them, something shifts. The noise fades. Your pace slows. It feels peaceful, almost sacred - like the world has quietly paused around you. From there, you step into the timeless stillness of Sanjūsangen-dō. Inside, 1,001 golden statues stand in silent harmony. It’s not loud or dramatic — it’s calm, powerful, and deeply moving. A moment that stays in your heart long after you leave. Next, you arrive at Kiyomizu-dera. Standing on its grand wooden terrace, you look out over Kyoto — rooftops, distant hills, soft skies. The breeze is gentle, the light is warm, and for a few quiet seconds, you simply take it all in. Kyoto doesn’t try to impress you. It gently teaches you to slow down, breathe deeper, and feel more. By evening, you return to Osaka by road — lighter, calmer, and quietly connected to Japan’s timeless soul. (Breakfast, Lunch, and Dinner)"
      },
      {
        day: 8,
        title:
          "Osaka Sightseeing",
        detail:
          "Today, you explore Osaka - a city where history and modern life don’t compete, they coexist beautifully. Your morning begins at Osaka Castle, rising proudly above the skyline. Built in 1583 with dreams of becoming Japan’s capital, it stands not just as a monument, but as the spirit of Osaka itself — resilient, bold, and graceful. As you walk past its stone walls and quiet moats, you can almost sense the centuries that shaped this city. Next, step gently into the past at the Osaka Museum of Housing and Living. Old streets, wooden homes, lantern-lit corners — it feels less like a museum and more like wandering through memories of another time. Then, the perspective changes. At the Umeda Sky Building, you rise high above the city. The wind greets you as Osaka stretches endlessly below — rivers weaving through buildings, distant landscapes fading into the horizon. For a moment, everything feels vast and alive. As evening falls, you arrive at Dotonbori. Neon lights shimmer on the canal, street food sizzles, and laughter fills the air. This is Osaka at its most vibrant — energetic, expressive, and full of flavor. Today isn’t just about the places you visit. It’s about feeling Osaka — its strength, its warmth, its unstoppable spirit. (Breakfast, Lunch, and Dinner)"
      },
      {
        day: 9,
        title:
          "Departure",
        detail:
          "After breakfast, it’s time to say goodbye. You complete your check-out and transfer to the airport, carrying more than just souvenirs — you carry memories of glowing streets, quiet temples, mountain breezes, and moments that touched your heart. You didn’t just travel through Japan — you felt it. From quiet temples to glowing streets, this journey becomes a beautiful memory you’ll carry long after you return home. (Breakfast)"
      },
    ],

    overview: "If Japan has been on your mind for a while, this 9-day journey gives you the full picture — at the right pace. You spend four nights in Tokyo, discovering both its quiet traditions and electric energy — temples and street markets, skyline views and digital art, plus a complete Mount Fuji and Lake Kawaguchi experience. A scenic Bullet Train ride takes you to Kyoto, where deer parks, golden temples, bamboo forests, and red torii gates slow the pace and bring Japan’s traditions to life. Your journey ends in Osaka, with castle views, city skylines, and vibrant evening streets full of flavor and character. This itinerary is for travelers who want to see Japan properly — its energy, its beauty, and its quiet depth - all in one well-planned first experience."
  },
  {
    id: "japan-006",
    slug: "satvik-japan-premium-veg-departure",
    destination: "Japan",
    title: "Satvik Japan – Premium Veg Departure",
    duration: "9 Nights 10 Days",
    route: "3N Tokyo | 1N Hakone | 2N Kyoto | 3N Osaka",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 394999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [tokyo,hakone,kyoto,osaka],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Into Tokyo", to: "Out of Osaka", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "Tokyo", nights: "3 Nights", type: "Asakusa View Hotel or similar - 4 Star Hotel" },
      { location: "Hakone", nights: "1 Nights", type: "Oiso Prince Hotel or similar - 4 Star Hotel" },
      { location: "Kyoto", nights: "2 Nights", type: "Hotel Granvia Kyoto or similar - 4 Star Hotel" },
      { location: "Osaka", nights: "3 Nights", type: "RIHGA Royal Hotel Osaka, Vignette Collection by IHG or similar - 4 Star Hotel" },
    ],

    sightseeing: [
      { title: "Tokyo Sightseeing" },
      { title: "Hakone Sightseeing" },
      { title: "Kyoto Sightseeing" },
      { title: "Osaka Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "100% Pure Veg Food, No Compromise - Enjoy pre-arranged Indian vegetarian meals daily — no searching, no confusion. Jain meals available on request.",
      "Special Care for Dietary Preferences: Jain meals and specific dietary needs are handled with care — so you can travel stress-free.",
      "Smartly paced, minimal hotel changes, maximum experiences — designed for comfort, clarity & complete peace of mind.",
      "Bullet Train Experience — Travel on Japan’s iconic high-speed Shinkansen from Hakone to Kyoto and Osaka to Hiroshima.",
      "Tokyo: From Asakusa Temple and Imperial Palace to Shibuya Crossing, Skytree & TeamLab — experience the best of old and modern Japan.",
      "Kyoto & Nara – Cultural side of Japan: Fushimi Inari, Golden Pavilion, Arashiyama, Sagano Scenic Train & Nara Deer Park — timeless beauty and heritage in every step.",

    ],

    exclusions: [
      "Mandatory Tips: Japanese Yen 800 per person per day, to be paid directly to the tour manager.",
      "Additional Expenses: Porterage, laundry, wines, mineral water, telephone charges, and any other items of a personal nature.",
      "Optional Tours: Any tours or activities not included in the itinerary.",
      "Food and Drinks: Meals and beverages that are not specifically mentioned in the “Tour Price Includes” section.",
      "Other Exclusions: Anything not explicitly listed under the “Tour Price Includes” column.",
      "Any extra cost incurred on behalf of an individual due to illness, accident, hospitalization, or any personal emergency.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Welcome to Tokyo - The Land of the Rising Sun",
        detail:
          "As you step off the plane and breathe in the energy of Tokyo, you’ll immediately sense the perfect harmony between ancient traditions and futuristic wonders. At Narita Airport, you’re welcomed with the kind of warmth that feels like family, marking the beginning of an unforgettable journey in the Land of the Rising Sun. A smooth transfer will take you straight to your hotel, ideally nestled in the bustling heart of the city. After checking in (check-in time 4:00 PM), unwind with the comfort of a rich, Indian buffet dinner, carefully curated for your enjoyment either at the hotel or a nearby Indian restaurant. Relish the familiar spices and flavors that bring a touch of home, while Tokyo’s glowing skyline beckons you to explore the exciting fusion of cultures that await. With the city’s vibrant lights shining through your window, you can unwind and soak in the anticipation of the unforgettable adventures to come. (Dinner)"
      },
      {
        day: 2,
        title:
          "Full Day Tokyo Sightseeing – Imperial Palace, Asakusa, Sky Tree & Shibuya Crossing",
        detail:
          "Your first stop is the Imperial Palace, the residence of Japan's royal family. Its grand gates open to Japan’s royal past, surrounded by tranquil gardens that whisper stories of the Emperor’s reign. Next, you visit the Asakusa Temple, Tokyo’s oldest temple and one of the most significant Buddhist structures in Japan. The air is filled with the soothing scent of incense, and the Nakamise Street market invites you to explore vibrant stalls—its lively hustle reminiscent of India’s own bustling bazaars. A short ride takes you to the awe-inspiring Tokyo Sky Tree, standing tall at 350 meters as the tallest structure in Japan, offering panoramic views of this dynamic city, a symbol of Japan's engineering prowess. After a comforting Indian lunch, you head to Odaiba, home to the Statue of Liberty replica and the Rainbow Bridge, landmarks that are both symbols of Tokyo’s modernity and global connections. A peaceful Sumida River Cruise (Asakusa-Odaiba) offers a serene view of the city, before reaching the iconic Shibuya Crossing, one of the busiest pedestrian crossings in the world, a testament to the pulse of Tokyo. Pause at the Hachiko Statue, a symbol of loyalty and love that resonates deeply, much like the values held dear in India. End your day with a delicious pure veg Indian dinner, savoring familiar flavors while reflecting on your day of discovery. (Breakfast, Lunch, and Dinner)"
      },
      {
        day: 3,
        title:
          "Tokyo’s Best - Experience Tea Ceremony - 3D Team Labs - Shopping at Akihabara",
        detail:
          "Start your day by visiting the Meiji Shrine, dedicated to the deified spirits of Emperor Meiji and Empress Shoken. This sacred site offers a deep sense of peace and spirituality amid Tokyo’s vibrant city life. Then, sit back and experience a traditional Japanese Tea Ceremony. Watching the tea being prepared so carefully and tasting fresh matcha makes you truly feel Japan’s culture — simple, calm, and beautiful. After a comforting Indian meal for lunch, head to 3D TeamLab Planets in Toyosu, a mesmerizing 3D digital art museum. Here, you don’t just look at art — you become part of it. Walk barefoot through shallow pools of water that ripple with every step, wander through infinite digital landscapes that shift and glow around you, and marvel as light, sound, and motion transform the space into a living dream. Each installation invites exploration, reflection, and wonder, creating a sense of floating between reality and imagination. End you day with a shopping at Akihabara (If time permits), the electronics and tech haven of Tokyo. From anime collectibles to the latest gadgets, Akihabara is a vibrant showcase of Japan's modern culture. Conclude the day with a flavorful Indian dinner, savoring familiar tastes while reflecting on a Tokyo day that seamlessly blended nature, tradition, modernity, and futuristic artistry. (Breakfast, Lunch, and Dinner)"
      },
      {
        day: 4,
        title:
          "A Day of Majestic Beauty - Mt. Fuji, Hakone, and Lake Ashi",
        detail:
          "Today, we journey to the iconic Mt. Fuji, Japan’s highest and most sacred peak. Standing at 3,776 meters, Mt. Fuji is a UNESCO World Heritage Site and the symbol of Japan. As you ascend to the 5th station (weather permitting), the majesty of the mountain will take your breath away. The crisp mountain air and serene surroundings offer a moment of reflection. After a hearty Indian lunch, the adventure continues to Hakone, known for its hot springs and stunning vistas. Owakudani Valley offers volcanic views and the scent of sulfur, reminding you of the Earth’s raw power. From there, soar above the valley on the Hakone Ropeway (Owakudani - Togendai), offering panoramic views of Mt. Fuji and the surrounding mountains, leaving you speechless with the beauty of the landscape. The day concludes with a tranquil Lake Ashi cruise (Togendai - Hakone Machi) where you’ll be surrounded by serene waters and breathtaking scenery. This peaceful moment offers a chance to reflect on the day’s beauty before heading to an Indian restaurant for a warm dinner and overnight at Mishima/Gotemba/Kanagawa. (Breakfast, Lunch, and Dinner)"
      },
      {
        day: 5,
        title:
          "Hakone to Kyoto – A Walk Through Tradition",
        detail:
          "After breakfast, you say goodbye to Hakone and begin your journey towards Kyoto in Bullet Train. Kyoto — a city that feels like stepping into old Japan. As you arrive, the pace slows down, and there’s a certain charm in the air that immediately feels different. Your first stop is Nijo Castle, where you walk through beautifully preserved interiors and quiet gardens that reflect Japan’s rich history. It’s one of those places where you can really pause and take it all in. Later, you head to Maruyama Park — a lovely open space, perfect for a relaxed stroll and a bit of downtime. After lunch, you get some free time to explore the Gion area, one of Kyoto’s most iconic districts. Walking through its narrow streets, lined with traditional wooden houses, you might even spot a geisha passing by — it truly feels like a glimpse into another era. By evening, you settle in for a comforting dinner before heading to your hotel. Overnight stay in Kyoto, with the city’s old-world charm all around you. (Breakfast, Lunch, and Dinner)"
      },
      {
        day: 6,
        title:
          "Kyoto & Nara Tour",
        detail:
          "After breakfast, we set out to experience the heartfelt traditions of Japan, starting with Nara, a city where history and nature coexist in perfect harmony. Wander through Nara Deer Park, where gentle deer roam freely, revered as messengers of the gods. Here, you’ll feel the peaceful connection between humans and nature, a unique aspect of Japan’s cultural heritage. Next, visit Todaiji Temple, home to the awe-inspiring Daibutsu, the world’s largest bronze Buddha statue, standing 15 meters tall and weighing over 500 tons. This UNESCO World Heritage Site radiates a sense of reverence and tranquility, offering a profound insight into Japan’s spiritual legacy. From Nara, we journey to Kyoto, Japan’s ancient capital, a city that embodies timeless beauty and tradition. Be mesmerized by the Golden Pavilion (Kinkaku-ji), gleaming like a jewel amidst tranquil ponds and lush gardens. Its serene surroundings invite quiet reflection, allowing you to connect deeply with Japan’s cultural elegance. We continue to Arashiyama, where you’ll board the Sagano Scenic Railway, a charming train ride that winds through lush valleys and along the Hozugawa River, offering breathtaking seasonal views of Kyoto’s natural beauty. We conclude our day with a visit to Arashiyama Bamboo Forest, where the towering bamboo stalks create a magical, otherworldly atmosphere. Walking through this natural cathedral, you’ll feel transported to a place where nature, spirituality, and tradition converge in perfect harmony. (Breakfast, Lunch, and Dinner)"
      },
      {
        day: 7,
        title:
          "Kyoto Gates & Onward to Osaka",
        detail:
          "Your day begins at Fushimi Inari Taisha, where endless red torii gates rise one after another, leading you gently up the hillside. As you walk through them, something shifts. The noise fades. Your pace slows. It feels peaceful, almost sacred - like the world has quietly paused around you. From there, you step into the timeless stillness of Sanjūsangen-dō. Inside, 1,001 golden statues stand in silent harmony. It’s not loud or dramatic — it’s calm, powerful, and deeply moving. A moment that stays in your heart long after you leave. Next, you arrive at Kiyomizu-dera. Standing on its grand wooden terrace, you look out over Kyoto — rooftops, distant hills, soft skies. The breeze is gentle, the light is warm, and for a few quiet seconds, you simply take it all in. Kyoto doesn’t try to impress you. It gently teaches you to slow down, breathe deeper, and feel more. By evening, you return to Osaka by road — lighter, calmer, and quietly connected to Japan’s timeless soul."
      },
      {
        day: 8,
        title:
          "Osaka Sightseeing & Shopping Street",
        detail:
          "After breakfast, you head out to explore Osaka — a city that feels lively, friendly, and full of character. Your day begins at Osaka Castle. As you walk towards the grand castle, surrounded by huge stone walls and a wide moat, it feels like stepping into Japan’s samurai days. Inside, you learn about its history, and from the top floor, you get a lovely view of the city around you. Old Japan and modern Osaka — all in one frame. After lunch at an Indian restaurant, you visit the Umeda Sky Building. The elevator takes you up to the floating observatory, where the city stretches out below. Tall buildings, moving trains, busy roads — Osaka looks energetic and alive. Later, enjoy free time at Shinsaibashi. This is where you feel the real buzz of the city. Bright signboards, fashion stores, local snacks, and people everywhere. You can shop, explore, or simply walk around and take it all in. In the evening, after dinner at an Indian restaurant, you return to your hotel. Today, you’ve seen Osaka’s royal past, its modern skyline, and its fun shopping streets — all in one vibrant day."
      },
      {
        day: 9,
        title:
          "Hiroshima Day Tour by Bullet Train",
        detail:
          "After breakfast, you board Japan’s famous bullet train to Hiroshima. The journey itself is an experience — fast, smooth, and comfortable — as the scenery quietly changes outside your window. On arrival, enjoy lunch at a local Indian restaurant before heading to the pier. From here, you take a short ferry ride to Miyajima Island. As you approach, the iconic Torii Gate slowly comes into view, rising from the water — calm, beautiful, and almost dreamlike. You visit Itsukushima Shrine, where the sea, the shrine, and the mountains come together in perfect harmony. There’s a peaceful silence here that makes you slow down and just take it all in. Later, return to Hiroshima city and visit the Peace Memorial Park. The atmosphere changes — it becomes quiet, reflective. You see the Atomic Bomb Dome, still standing as it was, a powerful reminder of the past. Walking through the park, you feel a deep sense of respect and understanding — it’s a place that stays with you long after you leave. By evening, you board the bullet train back to Osaka, carrying with you a day filled with powerful stories, peaceful moments, and unforgettable memories. (Breakfast, Lunch, and Dinner)"
      },
      {
        day: 10,
        title:
          "Departure",
        detail:
          "After breakfast, it’s time to say goodbye. You complete your check-out and transfer to the airport, carrying more than just souvenirs — you carry memories of glowing streets, quiet temples, mountain breezes, and moments that touched your heart. You didn’t just travel through Japan — you felt it. From quiet temples to glowing streets, this journey becomes a beautiful memory you’ll carry long after you return home."
      },
    ],

    overview: "Your journey to Japan should be about experiences, not worries - and that’s exactly what we’ve designed for you. We understand that for vegetarian travellers, the biggest concern is always, “Khana kaise manage hoga?” With Satvik Japan, you can leave that worry behind completely. Throughout your trip, you will be served pure vegetarian Indian meals, carefully planned to give you both comfort and taste just like home. From wholesome breakfasts to satisfying dinners, every meal is thoughtfully arranged — so you never have to search, adjust, or compromise. We also provide Jain meal options, ensuring every traveller can enjoy the journey with complete peace of mind. This means you can truly focus on what matters — experiencing Japan. From the vibrant energy of Tokyo, to the serene beauty of Hakone and Mount Fuji, the timeless charm of Kyoto, and the lively streets of Osaka — every destination is enjoyed fully, without the stress of finding suitable food. This is not just a Japan tour. It’s a worry-free, comfortable, and deeply enjoyable travel experience, designed specially for vegetarian travellers."
  },
  // ================= UK and Scotland =================
  {
    id: "ukandscotland-001",
    slug: "Wonders of UK and Scotland",
    destination: "Scotland",
    title: "Wonders of UK and Scotland",
    duration: "7 Nights 8 Days",
    route: "2N London | 1N Manchester | 2N Glasgow | 1N Birmingham | 1N London",
    departureCity: ["Delhi", "Mumbai", "Bangalore", "Hyderabad", "Chennai", "Ahemdabad", "Kolkata", "Joining Direct"],
    availableDate: ["May 2026", "Jun 2026", "Jul 2026", "Aug 2026", "Sep 2026", "Oct 2026"],
    stars: 4,
    price: 264999,
    tags: ["💑 Honeymoon Special", "🌴 Vietnam Adventure Quest"],
    rating: 4.7,

    images: [london,manchester,glasgow,birmingham],

    includes: ["flights", "hotels", "sightseeing", "transfers", "meals"],

    flights: [
      { from: "Into London", to: "Out of London", type: "Direct or 1 Stop" },
    ],

    hotels: [
      { location: "London", nights: "2 Nights", type: "DoubleTree by Hilton London Heathrow Airport or similar - 4 Star Hotel" },
      { location: "Manchester", nights: "1 Nights", type: "Copthorne Hotel Manchester Salford Quays or similar - 4 Star Hotel" },
      { location: "Glasgow", nights: "2 Nights", type: "Sandman Signature Glasgow Hotel or similar - 4 Star Hotel" },
      { location: "Birmingham", nights: "1 Nights", type: "Holiday Inn Birmingham Airport - NEC by IHG or similar - 4 Star Hotel" },
      { location: "London", nights: "1 Nights", type: "DoubleTree by Hilton London Heathrow Airport or similar - 4 Star Hotel" },
    ],

    sightseeing: [
      { title: "London Sightseeing" },
      { title: "Manchester Sightseeing" },
      { title: "Glasgow Sightseeing" },
      { title: "Birmingham Sightseeing" },
      { title: "London Sightseeing" },
    ],

    transfers: [
      { from: "Airport", to: "Hotel", type: "Private" },
      { from: "Hotel", to: "Airport", type: "Private" },

    ],

    meals: [
      { title: "Breakfast Included" },
      { title: "Lunch Included" },
      { title: "Dinner Included" },
    ],


    inclusions: [
      "Stay in good 4 star hotels in UK",
      "Daily Continental Breakfast",
      "Covers the best of sightseeings in UK and Scotland (London Eye, Madame , Tussauds, Tower of London, Oxford, Edinburgh Tour, Glasgow Tour, Windermere Cruise, Scottish Highlands, Lords Cricket Stadium) ",
      "7 Indian Jain/Vegetarian/Non-Vegetarian (Halal) Lunches",
      "7 Indian Jain/Vegetarian/Non-Vegetarian (Halal) Dinners",
      "All Transfers and Tours by Luxury AC Coach",
      "Services of a English/Hindi Experienced Tour Manager",
      "Travel Insurance Included",
      "Tour Manager and Driver Tips Included",

    ],

    exclusions: [
      "Any increase in Airfare, Visa fees, Airport taxes, Govt Taxes, Fuel Surcharges and any applicability of new taxes from Govt.",
      "Any up gradation in Airline class or hotel room category Cost of Air ticket deviation charges.",
      "Fare difference arising due to change in travel dates, sector, or airline",
      "Additional costs due to flight rescheduling, cancellation, or no-show",
      "Any Increase in the rate of exchange leading to an increase in all land arrangements which may come in to effect prior to departure.",
      "Cost of pre or post tour hotel accommodation.",
      "Any extra expense such as route change, Airline change, Date change, Accommodation facilities, etc incurred due to the unforeseen, unavoidable forced majeuere circumstances during the tour.",
      "Porterage, laundry, telephone charges, shopping, wines & alcoholic beverages, items of personal nature and food or drink which is not part of a set group menu.",
      "Any extra cost incurred on behalf of an individual due to illness, accident, hospitalization, or any personal emergency.",
      "Any services or activity charges other than those included in the group tour itinerary.",
      "For direct joiners, airport transfers are not included and must be arranged independently for arrival and departure.",
      "Guests departing independently from London must arrange or pay for their transfers separately.",
      "Any services not explicitly mentioned in the inclusions",
      "No refund will be provided for unused services, missed sightseeing, or any activities not availed during the tour.",
    ],

    itinerary: [
      {
        day: 1,
        title:
          "Fly into London, the financial, political and cultural heart of Britain.",
        detail:
          "Welcome to London - capital of England and United Kingdom. On arrival, you will be met by your Tour Manager/Local Representative outside the customs area, who will welcome you and take you to your hotel (Check-in time is after 3.00 pm). Overnight in London. (Dinner)"
      },
      {
        day: 2,
        title:
          "Guided city tour of London along with Tower of London, Ride the London Eye. Later Visit the world famous Madame Tussauds wax museum.",
        detail:
          "In the morning after English Breakfast proceed for the City tour with our expert local guide covering important landmarks like Hyde Park, the Big Ben, Houses of Parliament, Westminster Abbey, Trafalgar Square, Piccadilly Circus, Buckingham Palace, Tower Bridge, Witness the changing of guards (subject to operational). We will also see Tower Bridge, one of London's most famous landmarks, is a bascule and suspension bridge on River Thames. We will board the London Eye, which is a cantilevered observation wheel on the South Bank of the River Thames in London. It is the most popular paid tourist attraction in the United Kingdom. Get splendid views of the city while you ride the London eye at a slow speed for 30 minutes. Entrance to Tower of London with Local Guide. The Tower's origins date back to the 11th century, and today it is an official UNESCO World Heritage Site. Inside you can see the Crown Jewels, which have been on display here since the 17th century, and the Highlight of the visit is the world-famous Kohinoor Diamond in the Jewel House. Visit the renowned Madame Tussauds wax museum. Be enthralled by the world’s largest wax collection of famous personalities and historical figures, as well as popular film, sports, and television characters. Overnight stay in London. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 3,
        title:
          "Visit to Lords Cricket Stadium, Oxford University, Panoramic tour of Manchester",
        detail:
          "Enjoy your breakfast in the morning today in London. We begin our day by visiting Lords cricket stadium. Experience more than 200 years of history and tradition and go behind the scenes in The Lord's Cricket Ground Tour and experience some of the most inspiring views in sport. See the players' dining room, experience the famous players' walk from the dressing room to the Lord's turf and more. In case Lords Cricket Stadium is closed for some reason we will be visiting the Tower of London instead. We leave London and proceed to Oxford. Oxford university is a world-leading centre of learning, teaching, research and the oldest university in the English-speaking world it can lay claim to nine centuries of continuous existence of teaching as early as 1096, making it the oldest university in the English-speaking world and the world's second-oldest university in continuous operation Followed by Lunch we drive towards Manchester! Manchester is a major city in the northwest of England with a rich industrial heritage, We start with Panoramic city tour of Manchester where we will see key sights such as Manchester Town Hall, the National Football Museum, the Museum of Science and Industry, Manchester United Football Club and Manchester Cathedral Overnight Stay in Manchester. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 4,
        title:
          "From Manchester on towards scenic drive north to the Lake District along with cruise on Lake Windermere & Glasgow Scottish Whiskey Experience",
        detail:
          "Devote the day to a scenic wonderland of mountains and tranquil waters - inspiration to a host of English poets. Appreciate the scenic beauty of the English Lake District on a relaxing cruise on Lake Windermere admiring the magnificent views of rugged mountains, secluded bays and wooded islands. After the cruise we head over to Glasgow! With a population of 600,000 people, Glasgow is Scotland’s largest city, and the fifth most-visited city in the United Kingdom. Proceed your journey through meadows of beautiful classic capital of Scotland, where we do a Panoramic city tour of Glasgow with Glasgow Cathedral, George Square, St Vincent Place. Our day ends by visiting a local Distillery in Glasgow where we enjoy the Scottish Whiskey Experience. Overnight Stay in Glasgow. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 5,
        title:
          "Lochness, Glen Coe and Highlands, Loch Lomond, Beautiful Luss Village",
        detail:
          "Toady after breakfast, head North out, of the hustle and bustle of the city to the famous hiking village of Tynndrum which sits in the shadow of Glencoe. On arrival, we could grab a coffee at the famous Green Welly Stop. From there we shall continue through Glencoe pass where we will be making many stops to take in the stunning scenery and some nice pictures! Glencoe was also featured in the James Bond film, Skyfall. We stop here for photos. We then make our way North again to Fort Augustus, which sits on the waters edge of Loch Ness. Finally, on our way back to Glasgow, we head along the banks of Loch Lomond making a final stop by Luss village, a perfect place to see the Loch in all its glory. Return back to Glasgow for overnight stay. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 6,
        title:
          "Explore Enchanting Edinburgh along with visit to Edinburgh Castle, Drive to Birmingham",
        detail:
          "From the cultural capital of Glasgow, we proceed towards Edinburgh for an intriguing sightseeing tour of the city. Ascend Castle Rock and visit Edinburgh Castle, which watches over the surrounding city from its elevated vantage point. Stroll through the Old Town along the Royal Mile and see the stunning Palace of Holyrood house before enjoying time at leisure to soak up the city's festive atmosphere. Later on we drive towards Birmingham Overnight in Birmingham (Breakfast, Lunch and Dinner)"
      },
      {
        day: 7,
        title:
          "Spend time shopping at the Bicester Village - Transfer to London",
        detail:
          "Today we check out and leave back for London. We visit Bicester Village outside London to do some shopping. Once you arrive, enjoy plenty of time to explore the high-end boutiques and designer stores, all offering incredible discounts on top brands. The shops are arranged in a quaint village-themed layout, away from the hustle and bustle of the city. When you need a break from shopping, there are plenty of cafes and restaurants where you can refuel with delicious food and drinks. Later we reach London for overnight stay. (Breakfast, Lunch and Dinner)"
      },
      {
        day: 8,
        title:
          "Fly Back Home",
        detail:
          "After breakfast check-out, the group will travel by private coach to one of London's airports for return flight back home. (Breakfast)"
      },
    ],

    overview: "Embark on an immersive journey through the United Kingdom where history, culture, and scenic beauty unfold seamlessly from one destination to the next. From the cosmopolitan energy of London to the academic elegance of Oxford and the industrial spirit of Manchester, each city reveals its own distinct character and charm. As you travel north, the landscapes transform into tranquil lakes, dramatic highlands, and storybook villages that feel both cinematic and deeply peaceful. Scotland adds a soulful layer to the experience — with rugged scenery, timeless traditions, and vibrant cultural pride creating moments that feel authentic and memorable. Balanced with comfortable stays, curated experiences, and thoughtfully planned travel throughout, this journey allows you to simply relax and absorb the essence of Britain. By the time you return home, you carry with you not just photographs, but a rich collection of emotions — heritage, warmth, grandeur, and the unforgettable spirit of the UK."
  },
];

